(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 22152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./cs/about-us.json": 86552,
	"./cs/authorship.json": 73431,
	"./cs/broadcast.json": 22582,
	"./cs/choose-plan.json": 1646,
	"./cs/christmas-contest.json": 1749,
	"./cs/common.json": 58891,
	"./cs/contact.json": 80801,
	"./cs/discount-may-2022.json": 1350,
	"./cs/discount.json": 54342,
	"./cs/easter-contest.json": 32535,
	"./cs/email-handle.json": 58588,
	"./cs/faq-home.json": 14103,
	"./cs/faq.json": 58700,
	"./cs/forgotten-password.json": 73675,
	"./cs/how-to-watch.json": 66993,
	"./cs/invite-friends.json": 18380,
	"./cs/login.json": 40692,
	"./cs/mobile-apps.json": 73108,
	"./cs/play-detail.json": 62214,
	"./cs/player.json": 93409,
	"./cs/popups.json": 8433,
	"./cs/profile.json": 50945,
	"./cs/register.json": 24778,
	"./cs/schools.json": 6320,
	"./cs/seo.json": 43328,
	"./cs/settings.json": 44622,
	"./cs/smart-tv.json": 59849,
	"./cs/theaters.json": 62647,
	"./cs/ua-support.json": 90519,
	"./cs/video-streaming.json": 22473,
	"./cs/vouchers.json": 29235,
	"./cs/welcome.json": 90258,
	"./en/about-us.json": 88700,
	"./en/authorship.json": 12249,
	"./en/broadcast.json": 2665,
	"./en/choose-plan.json": 92991,
	"./en/christmas-contest.json": 54903,
	"./en/common.json": 4807,
	"./en/contact.json": 26322,
	"./en/discount-may-2022.json": 85697,
	"./en/discount.json": 22075,
	"./en/easter-contest.json": 47440,
	"./en/email-handle.json": 88266,
	"./en/faq-home.json": 92495,
	"./en/faq.json": 60218,
	"./en/forgotten-password.json": 78762,
	"./en/how-to-watch.json": 57548,
	"./en/invite-friends.json": 7756,
	"./en/login.json": 9305,
	"./en/mobile-apps.json": 79609,
	"./en/play-detail.json": 19610,
	"./en/player.json": 8934,
	"./en/popups.json": 73398,
	"./en/profile.json": 51891,
	"./en/register.json": 83141,
	"./en/schools.json": 50128,
	"./en/seo.json": 52540,
	"./en/settings.json": 72604,
	"./en/smart-tv.json": 22207,
	"./en/theaters.json": 74608,
	"./en/ua-support.json": 16708,
	"./en/video-streaming.json": 50156,
	"./en/vouchers.json": 92484,
	"./en/welcome.json": 22799,
	"./pl/about-us.json": 48331,
	"./pl/authorship.json": 29554,
	"./pl/broadcast.json": 23006,
	"./pl/choose-plan.json": 73140,
	"./pl/christmas-contest.json": 17665,
	"./pl/common.json": 65978,
	"./pl/contact.json": 35753,
	"./pl/discount-may-2022.json": 56690,
	"./pl/discount.json": 26206,
	"./pl/easter-contest.json": 26409,
	"./pl/email-handle.json": 54623,
	"./pl/faq-home.json": 44011,
	"./pl/faq.json": 19354,
	"./pl/forgotten-password.json": 93154,
	"./pl/how-to-watch.json": 1515,
	"./pl/invite-friends.json": 57565,
	"./pl/login.json": 76254,
	"./pl/mobile-apps.json": 53813,
	"./pl/play-detail.json": 24699,
	"./pl/player.json": 35071,
	"./pl/popups.json": 84093,
	"./pl/profile.json": 81978,
	"./pl/register.json": 20043,
	"./pl/schools.json": 61283,
	"./pl/seo.json": 52729,
	"./pl/settings.json": 26543,
	"./pl/smart-tv.json": 27599,
	"./pl/theaters.json": 49562,
	"./pl/ua-support.json": 50537,
	"./pl/video-streaming.json": 84710,
	"./pl/vouchers.json": 11090,
	"./pl/welcome.json": 80931,
	"./sk/about-us.json": 43673,
	"./sk/authorship.json": 68199,
	"./sk/broadcast.json": 84742,
	"./sk/choose-plan.json": 4338,
	"./sk/christmas-contest.json": 75861,
	"./sk/common.json": 86939,
	"./sk/contact.json": 99929,
	"./sk/discount-may-2022.json": 45299,
	"./sk/discount.json": 8585,
	"./sk/easter-contest.json": 1348,
	"./sk/email-handle.json": 20585,
	"./sk/faq-home.json": 88996,
	"./sk/faq.json": 25889,
	"./sk/forgotten-password.json": 5111,
	"./sk/how-to-watch.json": 56845,
	"./sk/invite-friends.json": 88013,
	"./sk/login.json": 16520,
	"./sk/mobile-apps.json": 64996,
	"./sk/play-detail.json": 2779,
	"./sk/player.json": 830,
	"./sk/popups.json": 64260,
	"./sk/profile.json": 63363,
	"./sk/register.json": 50370,
	"./sk/schools.json": 27786,
	"./sk/seo.json": 96704,
	"./sk/settings.json": 50823,
	"./sk/smart-tv.json": 60015,
	"./sk/theaters.json": 34224,
	"./sk/ua-support.json": 10662,
	"./sk/video-streaming.json": 83215,
	"./sk/vouchers.json": 85267,
	"./sk/welcome.json": 54417,
	"./uk/about-us.json": 86212,
	"./uk/authorship.json": 38690,
	"./uk/broadcast.json": 16508,
	"./uk/choose-plan.json": 81695,
	"./uk/christmas-contest.json": 43007,
	"./uk/common.json": 95872,
	"./uk/contact.json": 72139,
	"./uk/discount-may-2022.json": 96422,
	"./uk/discount.json": 38947,
	"./uk/easter-contest.json": 11764,
	"./uk/email-handle.json": 23703,
	"./uk/faq-home.json": 42601,
	"./uk/faq.json": 17743,
	"./uk/forgotten-password.json": 74820,
	"./uk/how-to-watch.json": 37250,
	"./uk/invite-friends.json": 15065,
	"./uk/login.json": 92930,
	"./uk/mobile-apps.json": 60744,
	"./uk/play-detail.json": 86334,
	"./uk/player.json": 79461,
	"./uk/popups.json": 10051,
	"./uk/profile.json": 86309,
	"./uk/register.json": 26097,
	"./uk/schools.json": 22123,
	"./uk/seo.json": 80983,
	"./uk/settings.json": 69035,
	"./uk/smart-tv.json": 62421,
	"./uk/theaters.json": 37404,
	"./uk/ua-support.json": 93919,
	"./uk/video-streaming.json": 74761,
	"./uk/vouchers.json": 75557,
	"./uk/welcome.json": 38510
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22152;

/***/ }),

/***/ 48335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ is_prop_valid_browser_esm; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize_browser_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var is_prop_valid_browser_esm = (index);


/***/ }),

/***/ 13459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ index_esm; }
});

// UNUSED EXPORTS: firebase

;// CONCATENATED MODULE: ./node_modules/@firebase/app/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var tslib_es6_assign = function() {
    tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return tslib_es6_assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/@firebase/util/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var tslib_es6_extendStatics = function(d, b) {
    tslib_es6_extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return tslib_es6_extendStatics(d, b);
};

function tslib_es6_extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    tslib_es6_extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var tslib_tslib_es6_assign = function() {
    tslib_tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return tslib_tslib_es6_assign.apply(this, arguments);
}

function tslib_es6_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function tslib_es6_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function tslib_es6_param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function tslib_es6_metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function tslib_es6_awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function tslib_es6_generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var tslib_es6_createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function tslib_es6_exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) tslib_es6_createBinding(o, m, p);
}

function tslib_es6_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function tslib_es6_read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function tslib_es6_spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(tslib_es6_read(arguments[i]));
    return ar;
}

/** @deprecated */
function tslib_es6_spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function tslib_es6_spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function tslib_es6_await(v) {
    return this instanceof tslib_es6_await ? (this.v = v, this) : new tslib_es6_await(v);
}

function tslib_es6_asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof tslib_es6_await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function tslib_es6_asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: tslib_es6_await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function tslib_es6_asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof tslib_es6_values === "function" ? tslib_es6_values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function tslib_es6_makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var tslib_es6_setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function tslib_es6_importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) tslib_es6_createBinding(result, mod, k);
    tslib_es6_setModuleDefault(result, mod);
    return result;
}

function tslib_es6_importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function tslib_es6_classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function tslib_es6_classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function tslib_es6_classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/@firebase/util/dist/index.esm.js


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
var assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
var assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray$1 = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray: function (input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString: function (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString: function (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, webSafe) {
        this.init_();
        var charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */
var base64Encode = function (str) {
    var utf8Bytes = stringToByteArray$1(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */
var base64urlEncodeWithoutPadding = function (str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
var base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !isValidKey(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
function isValidKey(key) {
    return key !== '__proto__';
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.reject = function () { };
        this.resolve = function () { };
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createMockUserToken(token, projectId) {
    if (token.uid) {
        throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    }
    // Unsecured JWTs use "none" as the algorithm.
    var header = {
        alg: 'none',
        type: 'JWT'
    };
    var project = projectId || 'demo-project';
    var iat = token.iat || 0;
    var sub = token.sub || token.user_id;
    if (!sub) {
        throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    }
    var payload = __assign({ 
        // Set all required fields to decent defaults
        iss: "https://securetoken.google.com/" + project, aud: project, iat: iat, exp: iat + 3600, auth_time: iat, sub: sub, user_id: sub, firebase: {
            sign_in_provider: 'custom',
            identities: {}
        } }, token);
    // Unsecured JWTs use the empty string as a signature.
    var signature = '';
    return [
        base64urlEncodeWithoutPadding(JSON.stringify(header)),
        base64urlEncodeWithoutPadding(JSON.stringify(payload)),
        signature
    ].join('.');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return (typeof window !== 'undefined' &&
        // @ts-ignore Setting up an broadly applicable index signature for Window
        // just to deal with this case would probably be a bad idea.
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    try {
        return (Object.prototype.toString.call(__webpack_require__.g.process) === '[object process]');
    }
    catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */
function isBrowser() {
    return typeof self === 'object' && self.self === self;
}
function isBrowserExtension() {
    var runtime = typeof chrome === 'object'
        ? chrome.runtime
        : typeof browser === 'object'
            ? browser.runtime
            : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
}
/** Detects Electron apps. */
function isElectron() {
    return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */
function isIE() {
    var ua = getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */
function isUWP() {
    return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */
function isSafari() {
    return (!isNode() &&
        navigator.userAgent.includes('Safari') &&
        !navigator.userAgent.includes('Chrome'));
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */
function isIndexedDBAvailable() {
    return 'indexedDB' in self && indexedDB != null;
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */
function validateIndexedDBOpenable() {
    return new Promise(function (resolve, reject) {
        try {
            var preExist_1 = true;
            var DB_CHECK_NAME_1 = 'validate-browser-context-for-indexeddb-analytics-module';
            var request_1 = self.indexedDB.open(DB_CHECK_NAME_1);
            request_1.onsuccess = function () {
                request_1.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist_1) {
                    self.indexedDB.deleteDatabase(DB_CHECK_NAME_1);
                }
                resolve(true);
            };
            request_1.onupgradeneeded = function () {
                preExist_1 = false;
            };
            request_1.onerror = function () {
                var _a;
                reject(((_a = request_1.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        }
        catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */
function areCookiesEnabled() {
    if (!navigator || !navigator.cookieEnabled) {
        return false;
    }
    return true;
}
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 */
function getGlobal() {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof __webpack_require__.g !== 'undefined') {
        return __webpack_require__.g;
    }
    throw new Error('Unable to locate global object.');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var FirebaseError = /** @class */ (function (_super) {
    tslib_es6_extends(FirebaseError, _super);
    function FirebaseError(code, message, customData) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.customData = customData;
        _this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ErrorFactory.prototype.create);
        }
        return _this;
    }
    return FirebaseError;
}(Error));
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    ErrorFactory.prototype.create = function (code) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        var customData = data[0] || {};
        var fullCode = this.service + "/" + code;
        var template = this.errors[code];
        var message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
        var error = new FirebaseError(fullCode, fullMessage, customData);
        return error;
    };
    return ErrorFactory;
}());
function replaceTemplate(template, data) {
    return template.replace(PATTERN, function (_, key) {
        var value = data[key];
        return value != null ? String(value) : "<" + key + "?>";
    });
}
var PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidTimestamp = function (token) {
    var claims = decode(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (!!now &&
        !!validSince &&
        !!validUntil &&
        now >= validSince &&
        now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var issuedAtTime = function (token) {
    var claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidFormat = function (token) {
    var decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isAdmin = function (token) {
    var claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return obj[key];
    }
    else {
        return undefined;
    }
}
function isEmpty(obj) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function map(obj, fn, contextObj) {
    var res = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[key] = fn.call(contextObj, obj[key], key, obj);
        }
    }
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    for (var _i = 0, aKeys_1 = aKeys; _i < aKeys_1.length; _i++) {
        var k = aKeys_1[_i];
        if (!bKeys.includes(k)) {
            return false;
        }
        var aProp = a[k];
        var bProp = b[k];
        if (isObject(aProp) && isObject(bProp)) {
            if (!deepEqual(aProp, bProp)) {
                return false;
            }
        }
        else if (aProp !== bProp) {
            return false;
        }
    }
    for (var _a = 0, bKeys_1 = bKeys; _a < bKeys_1.length; _a++) {
        var k = bKeys_1[_a];
        if (!aKeys.includes(k)) {
            return false;
        }
    }
    return true;
}
function isObject(thing) {
    return thing !== null && typeof thing === 'object';
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function querystring(querystringParams) {
    var params = [];
    var _loop_1 = function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    };
    for (var _i = 0, _a = Object.entries(querystringParams); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */
function querystringDecode(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var _a = token.split('='), key = _a[0], value = _a[1];
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */
function extractQuerystring(url) {
    var queryStart = url.indexOf('?');
    if (!queryStart) {
        return '';
    }
    var fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function () {
    function Sha1() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (var i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, offset) {
        if (!offset) {
            offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(offset) << 24) |
                        (buf.charCodeAt(offset + 1) << 16) |
                        (buf.charCodeAt(offset + 2) << 8) |
                        buf.charCodeAt(offset + 3);
                offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[offset] << 24) |
                        (buf[offset + 1] << 16) |
                        (buf[offset + 2] << 8) |
                        buf[offset + 3];
                offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (length === undefined) {
            length = bytes.length;
        }
        var lengthMinusBlock = length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}());

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/** Turn synchronous function into one called asynchronously. */
// eslint-disable-next-line @typescript-eslint/ban-types
function index_esm_async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true)
            .then(function () {
            fn.apply(void 0, args);
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
var validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argName) {
    return fnName + " failed: " + argName + " argument ";
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, namespace, optional) {
    if (optional && !namespace) {
        return;
    }
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, 'namespace') + 'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentName, 
// eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentName, context, optional) {
    if (optional && !context) {
        return;
    }
    if (typeof context !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray = function (str) {
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The amount of milliseconds to exponentially increase.
 */
var DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */
var DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */
var MAX_VALUE_MILLIS = (/* unused pure expression or super */ null && (4 * 60 * 60 * 1000)); // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */
var RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */
function calculateBackoffMillis(backoffCount, intervalMillis, backoffFactor) {
    if (intervalMillis === void 0) { intervalMillis = DEFAULT_INTERVAL_MILLIS; }
    if (backoffFactor === void 0) { backoffFactor = DEFAULT_BACKOFF_FACTOR; }
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    var currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    var randomWait = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR *
        currBaseValue *
        // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
        // if we add or subtract.
        (Math.random() - 0.5) *
        2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provide English ordinal letters after a number
 */
function ordinal(i) {
    if (!Number.isFinite(i)) {
        return "" + i;
    }
    return i + indicator(i);
}
function indicator(i) {
    i = Math.abs(i);
    var cent = i % 100;
    if (cent >= 10 && cent <= 20) {
        return 'th';
    }
    var dec = i % 10;
    if (dec === 1) {
        return 'st';
    }
    if (dec === 2) {
        return 'nd';
    }
    if (dec === 3) {
        return 'rd';
    }
    return 'th';
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getModularInstance(service) {
    if (service && service._delegate) {
        return service._delegate;
    }
    else {
        return service;
    }
}


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@firebase/component/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var tslib_tslib_es6_extendStatics = function(d, b) {
    tslib_tslib_es6_extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return tslib_tslib_es6_extendStatics(d, b);
};

function tslib_tslib_es6_extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    tslib_tslib_es6_extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var node_modules_tslib_tslib_es6_assign = function() {
    node_modules_tslib_tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return node_modules_tslib_tslib_es6_assign.apply(this, arguments);
}

function tslib_tslib_es6_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function tslib_tslib_es6_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function tslib_tslib_es6_param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function tslib_tslib_es6_metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function tslib_tslib_es6_awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function tslib_tslib_es6_generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var tslib_tslib_es6_createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function tslib_tslib_es6_exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) tslib_tslib_es6_createBinding(o, m, p);
}

function tslib_tslib_es6_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function tslib_tslib_es6_read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function tslib_tslib_es6_spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(tslib_tslib_es6_read(arguments[i]));
    return ar;
}

/** @deprecated */
function tslib_tslib_es6_spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function tslib_tslib_es6_spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function tslib_tslib_es6_await(v) {
    return this instanceof tslib_tslib_es6_await ? (this.v = v, this) : new tslib_tslib_es6_await(v);
}

function tslib_tslib_es6_asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof tslib_tslib_es6_await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function tslib_tslib_es6_asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: tslib_tslib_es6_await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function tslib_tslib_es6_asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof tslib_tslib_es6_values === "function" ? tslib_tslib_es6_values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function tslib_tslib_es6_makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var tslib_tslib_es6_setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function tslib_tslib_es6_importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) tslib_tslib_es6_createBinding(result, mod, k);
    tslib_tslib_es6_setModuleDefault(result, mod);
    return result;
}

function tslib_tslib_es6_importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function tslib_tslib_es6_classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function tslib_tslib_es6_classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function tslib_tslib_es6_classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/@firebase/component/dist/index.esm.js



/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
var Component = /** @class */ (function () {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */
    function Component(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */
        this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */;
        this.onInstanceCreated = null;
    }
    Component.prototype.setInstantiationMode = function (mode) {
        this.instantiationMode = mode;
        return this;
    };
    Component.prototype.setMultipleInstances = function (multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    };
    Component.prototype.setServiceProps = function (props) {
        this.serviceProps = props;
        return this;
    };
    Component.prototype.setInstanceCreatedCallback = function (callback) {
        this.onInstanceCreated = callback;
        return this;
    };
    return Component;
}());

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */
var Provider = /** @class */ (function () {
    function Provider(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */
    Provider.prototype.get = function (identifier) {
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            var deferred = new Deferred();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) ||
                this.shouldAutoInitialize()) {
                // initialize the service if it can be auto-initialized
                try {
                    var instance = this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                    if (instance) {
                        deferred.resolve(instance);
                    }
                }
                catch (e) {
                    // when the instance factory throws an exception during get(), it should not cause
                    // a fatal error. We just return the unresolved promise in this case.
                }
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    };
    Provider.prototype.getImmediate = function (options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        var optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) ||
            this.shouldAutoInitialize()) {
            try {
                return this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
            }
            catch (e) {
                if (optional) {
                    return null;
                }
                else {
                    throw e;
                }
            }
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) {
                return null;
            }
            else {
                throw Error("Service " + this.name + " is not available");
            }
        }
    };
    Provider.prototype.getComponent = function () {
        return this.component;
    };
    Provider.prototype.setComponent = function (component) {
        var e_1, _a;
        if (component.name !== this.name) {
            throw Error("Mismatching Component " + component.name + " for Provider " + this.name + ".");
        }
        if (this.component) {
            throw Error("Component for " + this.name + " has already been provided");
        }
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) {
            return;
        }
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) {
            try {
                this.getOrInitializeService({ instanceIdentifier: DEFAULT_ENTRY_NAME });
            }
            catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
            }
        }
        try {
            // Create service instances for the pending promises and resolve them
            // NOTE: if this.multipleInstances is false, only the default instance will be created
            // and all promises with resolve with it regardless of the identifier.
            for (var _b = tslib_tslib_es6_values(this.instancesDeferred.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = tslib_tslib_es6_read(_c.value, 2), instanceIdentifier = _d[0], instanceDeferred = _d[1];
                var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                try {
                    // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                    var instance = this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                    instanceDeferred.resolve(instance);
                }
                catch (e) {
                    // when the instance factory throws an exception, it should not cause
                    // a fatal error. We just leave the promise unresolved.
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Provider.prototype.clearInstance = function (identifier) {
        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    };
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    Provider.prototype.delete = function () {
        return tslib_tslib_es6_awaiter(this, void 0, void 0, function () {
            var services;
            return tslib_tslib_es6_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        services = Array.from(this.instances.values());
                        return [4 /*yield*/, Promise.all(tslib_tslib_es6_spreadArray(tslib_tslib_es6_spreadArray([], tslib_tslib_es6_read(services
                                .filter(function (service) { return 'INTERNAL' in service; }) // legacy services
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .map(function (service) { return service.INTERNAL.delete(); }))), tslib_tslib_es6_read(services
                                .filter(function (service) { return '_delete' in service; }) // modularized services
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .map(function (service) { return service._delete(); }))))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Provider.prototype.isComponentSet = function () {
        return this.component != null;
    };
    Provider.prototype.isInitialized = function (identifier) {
        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
        return this.instances.has(identifier);
    };
    Provider.prototype.getOptions = function (identifier) {
        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
        return this.instancesOptions.get(identifier) || {};
    };
    Provider.prototype.initialize = function (opts) {
        var e_2, _a;
        if (opts === void 0) { opts = {}; }
        var _b = opts.options, options = _b === void 0 ? {} : _b;
        var normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) {
            throw Error(this.name + "(" + normalizedIdentifier + ") has already been initialized");
        }
        if (!this.isComponentSet()) {
            throw Error("Component " + this.name + " has not been registered yet");
        }
        var instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        try {
            // resolve any pending promise waiting for the service instance
            for (var _c = tslib_tslib_es6_values(this.instancesDeferred.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = tslib_tslib_es6_read(_d.value, 2), instanceIdentifier = _e[0], instanceDeferred = _e[1];
                var normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                if (normalizedIdentifier === normalizedDeferredIdentifier) {
                    instanceDeferred.resolve(instance);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return instance;
    };
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */
    Provider.prototype.onInit = function (callback, identifier) {
        var _a;
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        var existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        var existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) {
            callback(existingInstance, normalizedIdentifier);
        }
        return function () {
            existingCallbacks.delete(callback);
        };
    };
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */
    Provider.prototype.invokeOnInitCallbacks = function (instance, identifier) {
        var e_3, _a;
        var callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) {
            return;
        }
        try {
            for (var callbacks_1 = tslib_tslib_es6_values(callbacks), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()) {
                var callback = callbacks_1_1.value;
                try {
                    callback(instance, identifier);
                }
                catch (_b) {
                    // ignore errors in the onInit callback
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    Provider.prototype.getOrInitializeService = function (_a) {
        var instanceIdentifier = _a.instanceIdentifier, _b = _a.options, options = _b === void 0 ? {} : _b;
        var instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */
            this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */
            if (this.component.onInstanceCreated) {
                try {
                    this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                }
                catch (_c) {
                    // ignore errors in the onInstanceCreatedCallback
                }
            }
        }
        return instance || null;
    };
    Provider.prototype.normalizeInstanceIdentifier = function (identifier) {
        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
        if (this.component) {
            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        }
        else {
            return identifier; // assume multiple instances are supported before the component is provided.
        }
    };
    Provider.prototype.shouldAutoInitialize = function () {
        return (!!this.component &&
            this.component.instantiationMode !== "EXPLICIT" /* EXPLICIT */);
    };
    return Provider;
}());
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */
var ComponentContainer = /** @class */ (function () {
    function ComponentContainer(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */
    ComponentContainer.prototype.addComponent = function (component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            throw new Error("Component " + component.name + " has already been registered with " + this.name);
        }
        provider.setComponent(component);
    };
    ComponentContainer.prototype.addOrOverwriteComponent = function (component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            // delete the existing provider from the container, so we can register the new component
            this.providers.delete(component.name);
        }
        this.addComponent(component);
    };
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */
    ComponentContainer.prototype.getProvider = function (name) {
        if (this.providers.has(name)) {
            return this.providers.get(name);
        }
        // create a Provider for a service that hasn't registered with Firebase
        var provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    };
    ComponentContainer.prototype.getProviders = function () {
        return Array.from(this.providers.values());
    };
    return ComponentContainer;
}());


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@firebase/logger/dist/index.esm.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function index_esm_spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
/**
 * A container for all of the Logger instances
 */
var instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
var levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */
var defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
var ConsoleMethod = (_a = {},
    _a[LogLevel.DEBUG] = 'log',
    _a[LogLevel.VERBOSE] = 'log',
    _a[LogLevel.INFO] = 'info',
    _a[LogLevel.WARN] = 'warn',
    _a[LogLevel.ERROR] = 'error',
    _a);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
var defaultLogHandler = function (instance, logType) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (logType < instance.logLevel) {
        return;
    }
    var now = new Date().toISOString();
    var method = ConsoleMethod[logType];
    if (method) {
        console[method].apply(console, index_esm_spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
    }
    else {
        throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
    }
};
var Logger = /** @class */ (function () {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */
        this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */
        this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function () {
            return this._logLevel;
        },
        set: function (val) {
            if (!(val in LogLevel)) {
                throw new TypeError("Invalid value \"" + val + "\" assigned to `logLevel`");
            }
            this._logLevel = val;
        },
        enumerable: false,
        configurable: true
    });
    // Workaround for setter/getter having to be the same type.
    Logger.prototype.setLogLevel = function (val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    };
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function () {
            return this._logHandler;
        },
        set: function (val) {
            if (typeof val !== 'function') {
                throw new TypeError('Value assigned to `logHandler` must be a function');
            }
            this._logHandler = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "userLogHandler", {
        get: function () {
            return this._userLogHandler;
        },
        set: function (val) {
            this._userLogHandler = val;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, index_esm_spreadArrays([this, LogLevel.DEBUG], args));
        this._logHandler.apply(this, index_esm_spreadArrays([this, LogLevel.DEBUG], args));
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, index_esm_spreadArrays([this, LogLevel.VERBOSE], args));
        this._logHandler.apply(this, index_esm_spreadArrays([this, LogLevel.VERBOSE], args));
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, index_esm_spreadArrays([this, LogLevel.INFO], args));
        this._logHandler.apply(this, index_esm_spreadArrays([this, LogLevel.INFO], args));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, index_esm_spreadArrays([this, LogLevel.WARN], args));
        this._logHandler.apply(this, index_esm_spreadArrays([this, LogLevel.WARN], args));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._userLogHandler && this._userLogHandler.apply(this, index_esm_spreadArrays([this, LogLevel.ERROR], args));
        this._logHandler.apply(this, index_esm_spreadArrays([this, LogLevel.ERROR], args));
    };
    return Logger;
}());
function setLogLevel(level) {
    instances.forEach(function (inst) {
        inst.setLogLevel(level);
    });
}
function setUserLogHandler(logCallback, options) {
    var _loop_1 = function (instance) {
        var customLogLevel = null;
        if (options && options.level) {
            customLogLevel = levelStringToEnum[options.level];
        }
        if (logCallback === null) {
            instance.userLogHandler = null;
        }
        else {
            instance.userLogHandler = function (instance, level) {
                var args = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    args[_i - 2] = arguments[_i];
                }
                var message = args
                    .map(function (arg) {
                    if (arg == null) {
                        return null;
                    }
                    else if (typeof arg === 'string') {
                        return arg;
                    }
                    else if (typeof arg === 'number' || typeof arg === 'boolean') {
                        return arg.toString();
                    }
                    else if (arg instanceof Error) {
                        return arg.message;
                    }
                    else {
                        try {
                            return JSON.stringify(arg);
                        }
                        catch (ignored) {
                            return null;
                        }
                    }
                })
                    .filter(function (arg) { return arg; })
                    .join(' ');
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
                    logCallback({
                        level: LogLevel[level].toLowerCase(),
                        message: message,
                        args: args,
                        type: instance.name
                    });
                }
            };
        }
    };
    for (var _i = 0, instances_1 = instances; _i < instances_1.length; _i++) {
        var instance = instances_1[_i];
        _loop_1(instance);
    }
}


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@firebase/app/dist/index.esm.js





/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a$1;
var ERRORS = (_a$1 = {},
    _a$1["no-app" /* NO_APP */] = "No Firebase App '{$appName}' has been created - " +
        'call Firebase App.initializeApp()',
    _a$1["bad-app-name" /* BAD_APP_NAME */] = "Illegal App name: '{$appName}",
    _a$1["duplicate-app" /* DUPLICATE_APP */] = "Firebase App named '{$appName}' already exists",
    _a$1["app-deleted" /* APP_DELETED */] = "Firebase App named '{$appName}' already deleted",
    _a$1["invalid-app-argument" /* INVALID_APP_ARGUMENT */] = 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.',
    _a$1["invalid-log-argument" /* INVALID_LOG_ARGUMENT */] = 'First argument to `onLog` must be null or a function.',
    _a$1);
var ERROR_FACTORY = new ErrorFactory('app', 'Firebase', ERRORS);

var name$c = "@firebase/app";
var version$1 = "0.6.30";

var name$b = "@firebase/analytics";

var name$a = "@firebase/app-check";

var name$9 = "@firebase/auth";

var name$8 = "@firebase/database";

var name$7 = "@firebase/functions";

var name$6 = "@firebase/installations";

var name$5 = "@firebase/messaging";

var name$4 = "@firebase/performance";

var name$3 = "@firebase/remote-config";

var name$2 = "@firebase/storage";

var name$1 = "@firebase/firestore";

var index_esm_name = "firebase-wrapper";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var index_esm_a;
var index_esm_DEFAULT_ENTRY_NAME = '[DEFAULT]';
var PLATFORM_LOG_STRING = (index_esm_a = {},
    index_esm_a[name$c] = 'fire-core',
    index_esm_a[name$b] = 'fire-analytics',
    index_esm_a[name$a] = 'fire-app-check',
    index_esm_a[name$9] = 'fire-auth',
    index_esm_a[name$8] = 'fire-rtdb',
    index_esm_a[name$7] = 'fire-fn',
    index_esm_a[name$6] = 'fire-iid',
    index_esm_a[name$5] = 'fire-fcm',
    index_esm_a[name$4] = 'fire-perf',
    index_esm_a[name$3] = 'fire-rc',
    index_esm_a[name$2] = 'fire-gcs',
    index_esm_a[name$1] = 'fire-fst',
    index_esm_a['fire-js'] = 'fire-js',
    index_esm_a[index_esm_name] = 'fire-js-all',
    index_esm_a);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger = new Logger('@firebase/app');

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */ (function () {
    function FirebaseAppImpl(options, config, firebase_) {
        var _this = this;
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.name_ = config.name;
        this.automaticDataCollectionEnabled_ =
            config.automaticDataCollectionEnabled || false;
        this.options_ = deepCopy(options);
        this.container = new ComponentContainer(config.name);
        // add itself to container
        this._addComponent(new Component('app', function () { return _this; }, "PUBLIC" /* PUBLIC */));
        // populate ComponentContainer with existing components
        this.firebase_.INTERNAL.components.forEach(function (component) {
            return _this._addComponent(component);
        });
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function () {
            this.checkDestroyed_();
            return this.automaticDataCollectionEnabled_;
        },
        set: function (val) {
            this.checkDestroyed_();
            this.automaticDataCollectionEnabled_ = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function () {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function () {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: false,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        })
            .then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            return Promise.all(_this.container.getProviders().map(function (provider) { return provider.delete(); }));
        })
            .then(function () {
            _this.isDeleted_ = true;
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage and functions are the only ones that are leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        var _a;
        if (instanceIdentifier === void 0) { instanceIdentifier = index_esm_DEFAULT_ENTRY_NAME; }
        this.checkDestroyed_();
        // Initialize instance if InstatiationMode is `EXPLICIT`.
        var provider = this.container.getProvider(name);
        if (!provider.isInitialized() &&
            ((_a = provider.getComponent()) === null || _a === void 0 ? void 0 : _a.instantiationMode) === "EXPLICIT" /* EXPLICIT */) {
            provider.initialize();
        }
        // getImmediate will always succeed because _getService is only called for registered components.
        return provider.getImmediate({
            identifier: instanceIdentifier
        });
    };
    /**
     * Remove a service instance from the cache, so we will create a new instance for this service
     * when people try to get this service again.
     *
     * NOTE: currently only firestore is using this functionality to support firestore shutdown.
     *
     * @param name The service name
     * @param instanceIdentifier instance identifier in case multiple instances are allowed
     * @internal
     */
    FirebaseAppImpl.prototype._removeServiceInstance = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = index_esm_DEFAULT_ENTRY_NAME; }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.container.getProvider(name).clearInstance(instanceIdentifier);
    };
    /**
     * @param component the component being added to this app's container
     */
    FirebaseAppImpl.prototype._addComponent = function (component) {
        try {
            this.container.addComponent(component);
        }
        catch (e) {
            logger.debug("Component " + component.name + " failed to register with FirebaseApp " + this.name, e);
        }
    };
    FirebaseAppImpl.prototype._addOrOverwriteComponent = function (component) {
        this.container.addOrOverwriteComponent(component);
    };
    FirebaseAppImpl.prototype.toJSON = function () {
        return {
            name: this.name,
            automaticDataCollectionEnabled: this.automaticDataCollectionEnabled,
            options: this.options
        };
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            throw ERROR_FACTORY.create("app-deleted" /* APP_DELETED */, { appName: this.name_ });
        }
    };
    return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
    FirebaseAppImpl.prototype.delete ||
    console.log('dc');

var version = "8.10.0";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */
function createFirebaseNamespaceCore(firebaseAppImpl) {
    var apps = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var components = new Map();
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeApp,
        // @ts-ignore
        app: app,
        registerVersion: registerVersion,
        setLogLevel: setLogLevel,
        onLog: onLog,
        // @ts-ignore
        apps: null,
        SDK_VERSION: version,
        INTERNAL: {
            registerComponent: registerComponent,
            removeApp: removeApp,
            components: components,
            useAsService: useAsService
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace['default'] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        delete apps[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || index_esm_DEFAULT_ENTRY_NAME;
        if (!contains(apps, name)) {
            throw ERROR_FACTORY.create("no-app" /* NO_APP */, { appName: name });
        }
        return apps[name];
    }
    // @ts-ignore
    app['App'] = firebaseAppImpl;
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) { rawConfig = {}; }
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = { name: name_1 };
        }
        var config = rawConfig;
        if (config.name === undefined) {
            config.name = index_esm_DEFAULT_ENTRY_NAME;
        }
        var name = config.name;
        if (typeof name !== 'string' || !name) {
            throw ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */, {
                appName: String(name)
            });
        }
        if (contains(apps, name)) {
            throw ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */, { appName: name });
        }
        var app = new firebaseAppImpl(options, config, namespace);
        apps[name] = app;
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map(function (name) { return apps[name]; });
    }
    function registerComponent(component) {
        var componentName = component.name;
        if (components.has(componentName)) {
            logger.debug("There were multiple attempts to register component " + componentName + ".");
            return component.type === "PUBLIC" /* PUBLIC */
                ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    namespace[componentName]
                : null;
        }
        components.set(componentName, component);
        // create service namespace for public components
        if (component.type === "PUBLIC" /* PUBLIC */) {
            // The Service namespace is an accessor function ...
            var serviceNamespace = function (appArg) {
                if (appArg === void 0) { appArg = app(); }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (typeof appArg[componentName] !== 'function') {
                    // Invalid argument.
                    // This happens in the following case: firebase.storage('gs:/')
                    throw ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */, {
                        appName: componentName
                    });
                }
                // Forward service instance lookup to the FirebaseApp.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return appArg[componentName]();
            };
            // ... and a container for service-level properties.
            if (component.serviceProps !== undefined) {
                deepExtend(serviceNamespace, component.serviceProps);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace[componentName] = serviceNamespace;
            // Patch the FirebaseAppImpl prototype
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            firebaseAppImpl.prototype[componentName] =
                // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
                // option added to the no-explicit-any rule when ESlint releases it.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var serviceFxn = this._getService.bind(this, componentName);
                    return serviceFxn.apply(this, component.multipleInstances ? args : []);
                };
        }
        // add the component to existing app instances
        for (var _i = 0, _a = Object.keys(apps); _i < _a.length; _i++) {
            var appName = _a[_i];
            apps[appName]._addComponent(component);
        }
        return component.type === "PUBLIC" /* PUBLIC */
            ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                namespace[componentName]
            : null;
    }
    function registerVersion(libraryKeyOrName, version, variant) {
        var _a;
        // TODO: We can use this check to whitelist strings when/if we set up
        // a good whitelist system.
        var library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
        if (variant) {
            library += "-" + variant;
        }
        var libraryMismatch = library.match(/\s|\//);
        var versionMismatch = version.match(/\s|\//);
        if (libraryMismatch || versionMismatch) {
            var warning = [
                "Unable to register library \"" + library + "\" with version \"" + version + "\":"
            ];
            if (libraryMismatch) {
                warning.push("library name \"" + library + "\" contains illegal characters (whitespace or \"/\")");
            }
            if (libraryMismatch && versionMismatch) {
                warning.push('and');
            }
            if (versionMismatch) {
                warning.push("version name \"" + version + "\" contains illegal characters (whitespace or \"/\")");
            }
            logger.warn(warning.join(' '));
            return;
        }
        registerComponent(new Component(library + "-version", function () { return ({ library: library, version: version }); }, "VERSION" /* VERSION */));
    }
    function onLog(logCallback, options) {
        if (logCallback !== null && typeof logCallback !== 'function') {
            throw ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */);
        }
        setUserLogHandler(logCallback, options);
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        return useService;
    }
    return namespace;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var namespace = createFirebaseNamespaceCore(FirebaseAppImpl);
    namespace.INTERNAL = tslib_es6_assign(tslib_es6_assign({}, namespace.INTERNAL), { createFirebaseNamespace: createFirebaseNamespace,
        extendNamespace: extendNamespace,
        createSubscribe: createSubscribe,
        ErrorFactory: ErrorFactory,
        deepExtend: deepExtend });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        deepExtend(namespace, props);
    }
    return namespace;
}
var firebase$1 = createFirebaseNamespace();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PlatformLoggerService = /** @class */ (function () {
    function PlatformLoggerService(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    PlatformLoggerService.prototype.getPlatformInfoString = function () {
        var providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers
            .map(function (provider) {
            if (isVersionServiceProvider(provider)) {
                var service = provider.getImmediate();
                return service.library + "/" + service.version;
            }
            else {
                return null;
            }
        })
            .filter(function (logString) { return logString; })
            .join(' ');
    };
    return PlatformLoggerService;
}());
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */
function isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(firebase, variant) {
    firebase.INTERNAL.registerComponent(new Component('platform-logger', function (container) { return new PlatformLoggerService(container); }, "PRIVATE" /* PRIVATE */));
    // Register `app` package.
    firebase.registerVersion(name$c, version$1, variant);
    // Register platform SDK identifier (no version).
    firebase.registerVersion('fire-js', '');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Firebase Lite detection test
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (isBrowser() && self.firebase !== undefined) {
    logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
    // eslint-disable-next-line
    var sdkVersion = self.firebase.SDK_VERSION;
    if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) {
        logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
    }
}
var initializeApp = firebase$1.initializeApp;
// TODO: This disable can be removed and the 'ignoreRestArgs' option added to
// the no-explicit-any rule when ESlint releases it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
firebase$1.initializeApp = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // Environment check before initializing app
    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
    // in @firebase/logger
    if (isNode()) {
        logger.warn("\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the \"main\" field in package.json.\n      \n      If you are using Webpack, you can specify \"main\" as the first item in\n      \"resolve.mainFields\":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the @rollup/plugin-node-resolve plugin and specify \"main\"\n      as the first item in \"mainFields\", e.g. ['main', 'module'].\n      https://github.com/rollup/@rollup/plugin-node-resolve\n      ");
    }
    return initializeApp.apply(undefined, args);
};
var firebase = firebase$1;
registerCoreComponents(firebase);

/* harmony default export */ var index_esm = (firebase);

//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 1756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xb": function() { return /* binding */ Hub; },
  "Gd": function() { return /* binding */ getCurrentHub; },
  "cu": function() { return /* binding */ getMainCarrier; }
});

// UNUSED EXPORTS: API_VERSION, getActiveDomain, getHubFromCarrier, makeMain, setHubOnCarrier

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(61557);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(45855);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(26757);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(7663);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/global.js
var esm_global = __webpack_require__(5177);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(88090);
;// CONCATENATED MODULE: ./node_modules/@sentry/hub/esm/flags.js
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var flags_IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/scope.js
var esm_scope = __webpack_require__(94421);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(50416);
;// CONCATENATED MODULE: ./node_modules/@sentry/hub/esm/session.js

/**
 * @inheritdoc
 */
var Session = /** @class */ (function () {
    function Session(context) {
        this.errors = 0;
        this.sid = (0,misc/* uuid4 */.DM)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0,time/* timestampInSeconds */.ph)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) {
            this.update(context);
        }
    }
    /** JSDoc */
    // eslint-disable-next-line complexity
    Session.prototype.update = function (context) {
        if (context === void 0) { context = {}; }
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) {
                this.ipAddress = context.user.ip_address;
            }
            if (!this.did && !context.did) {
                this.did = context.user.id || context.user.email || context.user.username;
            }
        }
        this.timestamp = context.timestamp || (0,time/* timestampInSeconds */.ph)();
        if (context.ignoreDuration) {
            this.ignoreDuration = context.ignoreDuration;
        }
        if (context.sid) {
            // Good enough uuid validation. — Kamil
            this.sid = context.sid.length === 32 ? context.sid : (0,misc/* uuid4 */.DM)();
        }
        if (context.init !== undefined) {
            this.init = context.init;
        }
        if (!this.did && context.did) {
            this.did = "" + context.did;
        }
        if (typeof context.started === 'number') {
            this.started = context.started;
        }
        if (this.ignoreDuration) {
            this.duration = undefined;
        }
        else if (typeof context.duration === 'number') {
            this.duration = context.duration;
        }
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) {
            this.release = context.release;
        }
        if (context.environment) {
            this.environment = context.environment;
        }
        if (!this.ipAddress && context.ipAddress) {
            this.ipAddress = context.ipAddress;
        }
        if (!this.userAgent && context.userAgent) {
            this.userAgent = context.userAgent;
        }
        if (typeof context.errors === 'number') {
            this.errors = context.errors;
        }
        if (context.status) {
            this.status = context.status;
        }
    };
    /** JSDoc */
    Session.prototype.close = function (status) {
        if (status) {
            this.update({ status: status });
        }
        else if (this.status === 'ok') {
            this.update({ status: 'exited' });
        }
        else {
            this.update();
        }
    };
    /** JSDoc */
    Session.prototype.toJSON = function () {
        return (0,object/* dropUndefinedKeys */.Jr)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent,
            },
        });
    };
    return Session;
}());

//# sourceMappingURL=session.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/hub/esm/hub.js





/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new esm_scope/* Scope */.s(); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [{}];
        this.getStackTop().scope = scope;
        if (client) {
            this.bindClient(client);
        }
    }
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) {
            client.setupIntegrations();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var scope = esm_scope/* Scope.clone */.s.clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        if (this.getStack().length <= 1)
            return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)();
        if (event.type !== 'transaction') {
            this._lastEventId = eventId;
        }
        this._invokeClient('captureEvent', event, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, hint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client)
            return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0)
            return;
        var timestamp = (0,time/* dateTimestampInSeconds */.yW)();
        var mergedBreadcrumb = (0,tslib_es6/* __assign */.pi)({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? (0,esm_logger/* consoleSandbox */.Cf)(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null)
            return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var scope = this.getScope();
        if (scope)
            scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var scope = this.getScope();
        if (scope)
            scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var scope = this.getScope();
        if (scope)
            scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var scope = this.getScope();
        if (scope)
            scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var scope = this.getScope();
        if (scope)
            scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function (name, context) {
        var scope = this.getScope();
        if (scope)
            scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) {
            callback(scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client)
            return null;
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            flags_IS_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startTransaction = function (context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureSession = function (endSession) {
        if (endSession === void 0) { endSession = false; }
        // both send the update and pull the session from the scope
        if (endSession) {
            return this.endSession();
        }
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.endSession = function () {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) {
            session.close();
        }
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) {
            scope.setSession();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSession = function (context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0,esm_global/* getGlobalObject */.R)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new Session((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ release: release,
            environment: environment }, (scope && { user: scope.getUser() })), (userAgent && { userAgent: userAgent })), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') {
                currentSession.update({ status: 'exited' });
            }
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */
    Hub.prototype._sendSessionUpdate = function () {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope)
            return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) {
                client.captureSession(session);
            }
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (_a = client)[method].apply(_a, (0,tslib_es6/* __spread */.fl)(args, [scope]));
        }
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        flags_IS_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
    var carrier = (0,esm_global/* getGlobalObject */.R)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0,node/* isNodeEnv */.KV)()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Returns the active domain, if one exists
 * @deprecated No longer used; remove in v7
 * @returns The domain, or undefined if there is no active domain
 */
// eslint-disable-next-line deprecation/deprecation
function getActiveDomain() {
    IS_DEBUG_BUILD && logger.warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = getMainCarrier().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    try {
        var sentry = getMainCarrier().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, esm_scope/* Scope.clone */.s.clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    return (0,esm_global/* getGlobalSingleton */.Y)('hub', function () { return new Hub(); }, carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier)
        return false;
    var __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
    __SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map

/***/ }),

/***/ 94421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61557);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2389);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26757);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14464);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5177);


/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */
        this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(scope._breadcrumbs);
            newScope._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, scope._tags);
            newScope._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, scope._extra);
            newScope._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = user || {};
        if (this._session) {
            this._session.update({ user: user });
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getUser = function () {
        return this._user;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getRequestSession = function () {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setRequestSession = function (requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extras) {
        this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransactionName = function (name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */
    Scope.prototype.setTransaction = function (name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (key, context) {
        var _a;
        if (context === null) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._contexts[key];
        }
        else {
            this._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getTransaction = function () {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSession = function (session) {
        if (!session) {
            delete this._session;
        }
        else {
            this._session = session;
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSession = function () {
        return this._session;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.update = function (captureContext) {
        if (!captureContext) {
            return this;
        }
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), captureContext._tags);
            this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), captureContext._extra);
            this._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) {
                this._user = captureContext._user;
            }
            if (captureContext._level) {
                this._level = captureContext._level;
            }
            if (captureContext._fingerprint) {
                this._fingerprint = captureContext._fingerprint;
            }
            if (captureContext._requestSession) {
                this._requestSession = captureContext._requestSession;
            }
        }
        else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext = captureContext;
            this._tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), captureContext.tags);
            this._extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), captureContext.extra);
            this._contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) {
                this._user = captureContext.user;
            }
            if (captureContext.level) {
                this._level = captureContext.level;
            }
            if (captureContext.fingerprint) {
                this._fingerprint = captureContext.fingerprint;
            }
            if (captureContext.requestSession) {
                this._requestSession = captureContext.requestSession;
            }
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) {
            return this;
        }
        var mergedBreadcrumb = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)() }, breadcrumb);
        this._breadcrumbs = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._extra), event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._tags), event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._user), event.user);
        }
        if (this._contexts && Object.keys(this._contexts).length) {
            event.contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._contexts), event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transactionName) {
            event.transaction = this._transactionName;
        }
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ trace: this._span.getTraceContext() }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) {
                event.tags = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({ transaction: transactionName }, event.tags);
            }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spread */ .fl)(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */
    Scope.prototype.setSDKProcessingMetadata = function (newData) {
        this._sdkProcessingMetadata = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW(function (resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, event), hint);
                if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
                    void result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    void _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function (callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    return Scope;
}());

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getGlobalSingleton */ .Y)('globalEventProcessors', function () { return []; });
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map

/***/ }),

/***/ 75300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "e": function() { return /* binding */ configureScope; }
/* harmony export */ });
/* unused harmony exports captureMessage, captureEvent, addBreadcrumb, setContext, setExtras, setTags, setExtra, setTag, setUser, _callOnClient, startTransaction */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61557);
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1756);


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
    if (hub && hub[method]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return hub[method].apply(hub, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spread */ .fl)(args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
    return callOnHub('captureMessage', message, level, __assign({ originalException: message, syntheticException: syntheticException }, context));
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, __spread(['_invokeClient', method], args));
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(context, customSamplingContext) {
    return callOnHub('startTransaction', __assign({}, context), customSamplingContext);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 16416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ FINISH_REASON_TAG; },
/* harmony export */   "x": function() { return /* binding */ IDLE_TRANSACTION_FINISH_REASONS; }
/* harmony export */ });
// Store finish reasons in tuple to save on bundle size
// Readonly type should enforce that this is not mutated.
var FINISH_REASON_TAG = 'finishReason';
var IDLE_TRANSACTION_FINISH_REASONS = ['heartbeatFailed', 'idleTimeout', 'documentHidden'];
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ 72354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IS_DEBUG_BUILD; }
/* harmony export */ });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map

/***/ }),

/***/ 86208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ro": function() { return /* binding */ addExtensionMethods; },
  "lb": function() { return /* binding */ startIdleTransaction; }
});

// UNUSED EXPORTS: _addTracingExtensions

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(61557);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/hub.js + 2 modules
var hub = __webpack_require__(1756);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(7663);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(2389);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(88090);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(44290);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/flags.js
var flags = __webpack_require__(72354);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(10351);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/errors.js



/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
    (0,instrument/* addInstrumentationHandler */.o)('error', errorCallback);
    (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
    var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
    if (activeTransaction) {
        var status_1 = 'internal_error';
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log("[Tracing] Transaction: " + status_1 + " -> Global error occured");
        activeTransaction.setStatus(status_1);
    }
}
//# sourceMappingURL=errors.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(85253);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/transaction.js
var esm_transaction = __webpack_require__(23664);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js
/* module decorator */ module = __webpack_require__.hmd(module);








/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
    var scope = this.getScope();
    if (scope) {
        var span = scope.getSpan();
        if (span) {
            return {
                'sentry-trace': span.toTraceparent(),
            };
        }
    }
    return {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0,utils/* hasTracingEnabled */.zu)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            transactionSampling: { method: 'explicitly_set' },
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            transactionSampling: {
                method: 'client_sampler',
                // cast to number in case it's a boolean
                rate: Number(sampleRate),
            },
        });
    }
    else if (samplingContext.parentSampled !== undefined) {
        sampleRate = samplingContext.parentSampled;
        transaction.setMetadata({
            transactionSampling: { method: 'inheritance' },
        });
    }
    else {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            transactionSampling: {
                method: 'client_rate',
                // cast to number in case it's a boolean
                rate: Number(sampleRate),
            },
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        flags/* IS_DEBUG_BUILD */.h && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        flags/* IS_DEBUG_BUILD */.h &&
            logger/* logger.log */.kg.log("[Tracing] Discarding transaction because " + (typeof options.tracesSampler === 'function'
                ? 'tracesSampler returned 0 or false'
                : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        flags/* IS_DEBUG_BUILD */.h &&
            logger/* logger.log */.kg.log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = " + Number(sampleRate) + ")");
        return transaction;
    }
    flags/* IS_DEBUG_BUILD */.h && logger/* logger.log */.kg.log("[Tracing] starting " + transaction.op + " transaction - " + transaction.name);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        flags/* IS_DEBUG_BUILD */.h &&
            logger/* logger.warn */.kg.warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got " + JSON.stringify(rate) + " of type " + JSON.stringify(typeof rate) + ".");
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        flags/* IS_DEBUG_BUILD */.h &&
            logger/* logger.warn */.kg.warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got " + rate + ".");
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(transactionContext, customSamplingContext) {
    var client = this.getClient();
    var options = (client && client.getOptions()) || {};
    var transaction = new esm_transaction/* Transaction */.Y(transactionContext, this);
    transaction = sample(transaction, options, (0,tslib_es6/* __assign */.pi)({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
    if (transaction.sampled) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    return transaction;
}
/**
 * Create new idle transaction.
 */
function startIdleTransaction(hub, transactionContext, idleTimeout, onScope, customSamplingContext) {
    var client = hub.getClient();
    var options = (client && client.getOptions()) || {};
    var transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, onScope);
    transaction = sample(transaction, options, (0,tslib_es6/* __assign */.pi)({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
    if (transaction.sampled) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    return transaction;
}
/**
 * @private
 */
function _addTracingExtensions() {
    var carrier = (0,hub/* getMainCarrier */.cu)();
    if (!carrier.__SENTRY__) {
        return;
    }
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) {
        carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
    }
    if (!carrier.__SENTRY__.extensions.traceHeaders) {
        carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
    }
}
/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
    var carrier = (0,hub/* getMainCarrier */.cu)();
    if (!carrier.__SENTRY__) {
        return;
    }
    var packageToIntegrationMapping = {
        mongodb: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo');
            return new integration.Mongo();
        },
        mongoose: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo');
            return new integration.Mongo({ mongoose: true });
        },
        mysql: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mysql');
            return new integration.Mysql();
        },
        pg: function () {
            var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/postgres');
            return new integration.Postgres();
        },
    };
    var mappedPackages = Object.keys(packageToIntegrationMapping)
        .filter(function (moduleName) { return !!(0,node/* loadModule */.$y)(moduleName); })
        .map(function (pkg) {
        try {
            return packageToIntegrationMapping[pkg]();
        }
        catch (e) {
            return undefined;
        }
    })
        .filter(function (p) { return p; });
    if (mappedPackages.length > 0) {
        carrier.__SENTRY__.integrations = (0,tslib_es6/* __spread */.fl)((carrier.__SENTRY__.integrations || []), mappedPackages);
    }
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
    _addTracingExtensions();
    // Detect and automatically load specified integrations.
    if ((0,node/* isNodeEnv */.KV)()) {
        _autoloadDatabaseIntegrations();
    }
    // If an error happens globally, we should make sure transaction status is set to error.
    registerErrorInstrumentation();
}
//# sourceMappingURL=hubextensions.js.map

/***/ }),

/***/ 85253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; },
/* harmony export */   "nT": function() { return /* binding */ DEFAULT_IDLE_TIMEOUT; }
/* harmony export */ });
/* unused harmony exports HEARTBEAT_INTERVAL, IdleTransactionSpanRecorder */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61557);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26757);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7663);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16416);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72354);
/* harmony import */ var _span__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8111);
/* harmony import */ var _transaction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23664);






var DEFAULT_IDLE_TIMEOUT = 1000;
var HEARTBEAT_INTERVAL = 5000;
/**
 * @inheritDoc
 */
var IdleTransactionSpanRecorder = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IdleTransactionSpanRecorder, _super);
    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
        if (transactionSpanId === void 0) { transactionSpanId = ''; }
        var _this = _super.call(this, maxlen) || this;
        _this._pushActivity = _pushActivity;
        _this._popActivity = _popActivity;
        _this.transactionSpanId = transactionSpanId;
        return _this;
    }
    /**
     * @inheritDoc
     */
    IdleTransactionSpanRecorder.prototype.add = function (span) {
        var _this = this;
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = function (endTimestamp) {
                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
                _this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) {
                this._pushActivity(span.spanId);
            }
        }
        _super.prototype.add.call(this, span);
    };
    return IdleTransactionSpanRecorder;
}(_span__WEBPACK_IMPORTED_MODULE_2__/* .SpanRecorder */ .gB));

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
var IdleTransaction = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IdleTransaction, _super);
    function IdleTransaction(transactionContext, _idleHub, 
    /**
     * The time to wait in ms until the idle transaction will be finished.
     * @default 1000
     */
    _idleTimeout, 
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope) {
        if (_idleTimeout === void 0) { _idleTimeout = DEFAULT_IDLE_TIMEOUT; }
        if (_onScope === void 0) { _onScope = false; }
        var _this = _super.call(this, transactionContext, _idleHub) || this;
        _this._idleHub = _idleHub;
        _this._idleTimeout = _idleTimeout;
        _this._onScope = _onScope;
        // Activities store a list of active spans
        _this.activities = {};
        // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
        _this._heartbeatCounter = 0;
        // We should not use heartbeat if we finished a transaction
        _this._finished = false;
        _this._beforeFinishCallbacks = [];
        if (_idleHub && _onScope) {
            // There should only be one active transaction on the scope
            clearActiveTransaction(_idleHub);
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("Setting idle transaction on scope. Span ID: " + _this.spanId);
            _idleHub.configureScope(function (scope) { return scope.setSpan(_this); });
        }
        _this._initTimeout = setTimeout(function () {
            if (!_this._finished) {
                _this.finish();
            }
        }, _this._idleTimeout);
        return _this;
    }
    /** {@inheritDoc} */
    IdleTransaction.prototype.finish = function (endTimestamp) {
        var e_1, _a;
        var _this = this;
        if (endTimestamp === void 0) { endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)(); }
        this._finished = true;
        this.activities = {};
        if (this.spanRecorder) {
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h &&
                _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
            try {
                for (var _b = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(this._beforeFinishCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var callback = _c.value;
                    callback(this, endTimestamp);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.spanRecorder.spans = this.spanRecorder.spans.filter(function (span) {
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === _this.spanId) {
                    return true;
                }
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus('cancelled');
                    _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h &&
                        _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                var keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) {
                    _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h &&
                        _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
                }
                return keepSpan;
            });
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] flushing IdleTransaction');
        }
        else {
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] No active IdleTransaction');
        }
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            clearActiveTransaction(this._idleHub);
        }
        return _super.prototype.finish.call(this, endTimestamp);
    };
    /**
     * Register a callback function that gets excecuted before the transaction finishes.
     * Useful for cleanup or if you want to add any additional spans based on current context.
     *
     * This is exposed because users have no other way of running something before an idle transaction
     * finishes.
     */
    IdleTransaction.prototype.registerBeforeFinishCallback = function (callback) {
        this._beforeFinishCallbacks.push(callback);
    };
    /**
     * @inheritDoc
     */
    IdleTransaction.prototype.initSpanRecorder = function (maxlen) {
        var _this = this;
        if (!this.spanRecorder) {
            var pushActivity = function (id) {
                if (_this._finished) {
                    return;
                }
                _this._pushActivity(id);
            };
            var popActivity = function (id) {
                if (_this._finished) {
                    return;
                }
                _this._popActivity(id);
            };
            this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('Starting heartbeat');
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    };
    /**
     * Start tracking a specific activity.
     * @param spanId The span id that represents the activity
     */
    IdleTransaction.prototype._pushActivity = function (spanId) {
        if (this._initTimeout) {
            clearTimeout(this._initTimeout);
            this._initTimeout = undefined;
        }
        _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("[Tracing] pushActivity: " + spanId);
        this.activities[spanId] = true;
        _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    };
    /**
     * Remove an activity from usage
     * @param spanId The span id that represents the activity
     */
    IdleTransaction.prototype._popActivity = function (spanId) {
        var _this = this;
        if (this.activities[spanId]) {
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("[Tracing] popActivity " + spanId);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            var timeout = this._idleTimeout;
            // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampWithMs is in seconds, timeout is in ms
            var end_1 = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)() + timeout / 1000;
            setTimeout(function () {
                if (!_this._finished) {
                    _this.setTag(_constants__WEBPACK_IMPORTED_MODULE_5__/* .FINISH_REASON_TAG */ .d, _constants__WEBPACK_IMPORTED_MODULE_5__/* .IDLE_TRANSACTION_FINISH_REASONS[1] */ .x[1]);
                    _this.finish(end_1);
                }
            }, timeout);
        }
    };
    /**
     * Checks when entries of this.activities are not changing for 3 beats.
     * If this occurs we finish the transaction.
     */
    IdleTransaction.prototype._beat = function () {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) {
            return;
        }
        var heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) {
            this._heartbeatCounter += 1;
        }
        else {
            this._heartbeatCounter = 1;
        }
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
            this.setStatus('deadline_exceeded');
            this.setTag(_constants__WEBPACK_IMPORTED_MODULE_5__/* .FINISH_REASON_TAG */ .d, _constants__WEBPACK_IMPORTED_MODULE_5__/* .IDLE_TRANSACTION_FINISH_REASONS[0] */ .x[0]);
            this.finish();
        }
        else {
            this._pingHeartbeat();
        }
    };
    /**
     * Pings the heartbeat
     */
    IdleTransaction.prototype._pingHeartbeat = function () {
        var _this = this;
        _flags__WEBPACK_IMPORTED_MODULE_3__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("pinging Heartbeat -> current counter: " + this._heartbeatCounter);
        setTimeout(function () {
            _this._beat();
        }, HEARTBEAT_INTERVAL);
    };
    return IdleTransaction;
}(_transaction__WEBPACK_IMPORTED_MODULE_6__/* .Transaction */ .Y));

/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
    if (hub) {
        var scope = hub.getScope();
        if (scope) {
            var transaction = scope.getTransaction();
            if (transaction) {
                scope.setSpan(undefined);
            }
        }
    }
}
//# sourceMappingURL=idletransaction.js.map

/***/ }),

/***/ 8111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dr": function() { return /* binding */ Span; },
/* harmony export */   "gB": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* unused harmony export spanStatusfromHttpCode */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61557);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45855);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26757);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50416);


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
var SpanRecorder = /** @class */ (function () {
    function SpanRecorder(maxlen) {
        if (maxlen === void 0) { maxlen = 1000; }
        this.spans = [];
        this._maxlen = maxlen;
    }
    /**
     * This is just so that we don't run out of memory while recording a lot
     * of spans. At some point we just stop and flush out the start of the
     * trace tree (i.e.the first n spans with the smallest
     * start_timestamp).
     */
    SpanRecorder.prototype.add = function (span) {
        if (this.spans.length > this._maxlen) {
            span.spanRecorder = undefined;
        }
        else {
            this.spans.push(span);
        }
    };
    return SpanRecorder;
}());

/**
 * Span contains all data about a span
 */
var Span = /** @class */ (function () {
    /**
     * You should never call the constructor manually, always use `Sentry.startTransaction()`
     * or call `startChild()` on an existing span.
     * @internal
     * @hideconstructor
     * @hidden
     */
    function Span(spanContext) {
        /**
         * @inheritDoc
         */
        this.traceId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();
        /**
         * @inheritDoc
         */
        this.spanId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);
        /**
         * Timestamp in seconds when the span was created.
         */
        this.startTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
        /**
         * @inheritDoc
         */
        this.tags = {};
        /**
         * @inheritDoc
         */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.data = {};
        if (!spanContext) {
            return this;
        }
        if (spanContext.traceId) {
            this.traceId = spanContext.traceId;
        }
        if (spanContext.spanId) {
            this.spanId = spanContext.spanId;
        }
        if (spanContext.parentSpanId) {
            this.parentSpanId = spanContext.parentSpanId;
        }
        // We want to include booleans as well here
        if ('sampled' in spanContext) {
            this.sampled = spanContext.sampled;
        }
        if (spanContext.op) {
            this.op = spanContext.op;
        }
        if (spanContext.description) {
            this.description = spanContext.description;
        }
        if (spanContext.data) {
            this.data = spanContext.data;
        }
        if (spanContext.tags) {
            this.tags = spanContext.tags;
        }
        if (spanContext.status) {
            this.status = spanContext.status;
        }
        if (spanContext.startTimestamp) {
            this.startTimestamp = spanContext.startTimestamp;
        }
        if (spanContext.endTimestamp) {
            this.endTimestamp = spanContext.endTimestamp;
        }
    }
    /**
     * @inheritDoc
     * @deprecated
     */
    Span.prototype.child = function (spanContext) {
        return this.startChild(spanContext);
    };
    /**
     * @inheritDoc
     */
    Span.prototype.startChild = function (spanContext) {
        var childSpan = new Span((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, spanContext), { parentSpanId: this.spanId, sampled: this.sampled, traceId: this.traceId }));
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) {
            childSpan.spanRecorder.add(childSpan);
        }
        childSpan.transaction = this.transaction;
        return childSpan;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setTag = function (key, value) {
        var _a;
        this.tags = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, this.tags), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Span.prototype.setData = function (key, value) {
        var _a;
        this.data = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, this.data), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setStatus = function (value) {
        this.status = value;
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setHttpStatus = function (httpStatus) {
        this.setTag('http.status_code', String(httpStatus));
        var spanStatus = spanStatusfromHttpCode(httpStatus);
        if (spanStatus !== 'unknown_error') {
            this.setStatus(spanStatus);
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.isSuccess = function () {
        return this.status === 'ok';
    };
    /**
     * @inheritDoc
     */
    Span.prototype.finish = function (endTimestamp) {
        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toTraceparent = function () {
        var sampledString = '';
        if (this.sampled !== undefined) {
            sampledString = this.sampled ? '-1' : '-0';
        }
        return this.traceId + "-" + this.spanId + sampledString;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toContext = function () {
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId,
        });
    };
    /**
     * @inheritDoc
     */
    Span.prototype.updateWithContext = function (spanContext) {
        var _a, _b, _c, _d, _e;
        this.data = (_a = spanContext.data, (_a !== null && _a !== void 0 ? _a : {}));
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = (_b = spanContext.spanId, (_b !== null && _b !== void 0 ? _b : this.spanId));
        this.startTimestamp = (_c = spanContext.startTimestamp, (_c !== null && _c !== void 0 ? _c : this.startTimestamp));
        this.status = spanContext.status;
        this.tags = (_d = spanContext.tags, (_d !== null && _d !== void 0 ? _d : {}));
        this.traceId = (_e = spanContext.traceId, (_e !== null && _e !== void 0 ? _e : this.traceId));
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.getTraceContext = function () {
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId,
        });
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toJSON = function () {
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId,
        });
    };
    return Span;
}());

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) {
        return 'ok';
    }
    if (httpStatus >= 400 && httpStatus < 500) {
        switch (httpStatus) {
            case 401:
                return 'unauthenticated';
            case 403:
                return 'permission_denied';
            case 404:
                return 'not_found';
            case 409:
                return 'already_exists';
            case 413:
                return 'failed_precondition';
            case 429:
                return 'resource_exhausted';
            default:
                return 'invalid_argument';
        }
    }
    if (httpStatus >= 500 && httpStatus < 600) {
        switch (httpStatus) {
            case 501:
                return 'unimplemented';
            case 503:
                return 'unavailable';
            case 504:
                return 'deadline_exceeded';
            default:
                return 'internal_error';
        }
    }
    return 'unknown_error';
}
//# sourceMappingURL=span.js.map

/***/ }),

/***/ 23664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61557);
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1756);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2389);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7663);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50416);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72354);
/* harmony import */ var _span__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8111);





/** JSDoc */
var Transaction = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(Transaction, _super);
    /**
     * This constructor should never be called manually. Those instrumenting tracing should use
     * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
     * @internal
     * @hideconstructor
     * @hidden
     */
    function Transaction(transactionContext, hub) {
        var _this = _super.call(this, transactionContext) || this;
        _this._measurements = {};
        /**
         * The reference to the current hub.
         */
        _this._hub = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();
        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(hub, _sentry_hub__WEBPACK_IMPORTED_MODULE_1__/* .Hub */ .Xb)) {
            _this._hub = hub;
        }
        _this.name = transactionContext.name || '';
        _this.metadata = transactionContext.metadata || {};
        _this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        _this.transaction = _this;
        return _this;
    }
    /**
     * JSDoc
     */
    Transaction.prototype.setName = function (name) {
        this.name = name;
    };
    /**
     * Attaches SpanRecorder to the span itself
     * @param maxlen maximum number of spans that can be recorded
     */
    Transaction.prototype.initSpanRecorder = function (maxlen) {
        if (maxlen === void 0) { maxlen = 1000; }
        if (!this.spanRecorder) {
            this.spanRecorder = new _span__WEBPACK_IMPORTED_MODULE_3__/* .SpanRecorder */ .gB(maxlen);
        }
        this.spanRecorder.add(this);
    };
    /**
     * Set observed measurements for this transaction.
     * @hidden
     */
    Transaction.prototype.setMeasurements = function (measurements) {
        this._measurements = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, measurements);
    };
    /**
     * Set metadata for this transaction.
     * @hidden
     */
    Transaction.prototype.setMetadata = function (newMetadata) {
        this.metadata = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, this.metadata), newMetadata);
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.finish = function (endTimestamp) {
        var _this = this;
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) {
            return undefined;
        }
        if (!this.name) {
            _flags__WEBPACK_IMPORTED_MODULE_4__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this.name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        _super.prototype.finish.call(this, endTimestamp);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            _flags__WEBPACK_IMPORTED_MODULE_4__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.log */ .kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            var client = this._hub.getClient();
            var transport = client && client.getTransport && client.getTransport();
            if (transport && transport.recordLostEvent) {
                transport.recordLostEvent('sample_rate', 'transaction');
            }
            return undefined;
        }
        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) { return s !== _this && s.endTimestamp; }) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            this.endTimestamp = finishedSpans.reduce(function (prev, current) {
                if (prev.endTimestamp && current.endTimestamp) {
                    return prev.endTimestamp > current.endTimestamp ? prev : current;
                }
                return prev;
            }).endTimestamp;
        }
        var transaction = {
            contexts: {
                trace: this.getTraceContext(),
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: 'transaction',
            sdkProcessingMetadata: this.metadata,
        };
        var hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            _flags__WEBPACK_IMPORTED_MODULE_4__/* .IS_DEBUG_BUILD */ .h &&
                _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.log */ .kg.log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        _flags__WEBPACK_IMPORTED_MODULE_4__/* .IS_DEBUG_BUILD */ .h && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.log */ .kg.log("[Tracing] Finishing " + this.op + " transaction: " + this.name + ".");
        return this._hub.captureEvent(transaction);
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.toContext = function () {
        var spanContext = _super.prototype.toContext.call(this);
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .dropUndefinedKeys */ .Jr)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, spanContext), { name: this.name, trimEnd: this._trimEnd }));
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.updateWithContext = function (transactionContext) {
        var _a;
        _super.prototype.updateWithContext.call(this, transactionContext);
        this.name = (_a = transactionContext.name, (_a !== null && _a !== void 0 ? _a : ''));
        this._trimEnd = transactionContext.trimEnd;
        return this;
    };
    return Transaction;
}(_span__WEBPACK_IMPORTED_MODULE_3__/* .Span */ .Dr));

//# sourceMappingURL=transaction.js.map

/***/ }),

/***/ 10351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WB": function() { return /* binding */ secToMs; },
/* harmony export */   "XL": function() { return /* binding */ msToSec; },
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; },
/* harmony export */   "zu": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1756);

/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * TODO(v7): Reorganize these exports
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 */

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(maybeOptions) {
    var client = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
    var options = maybeOptions || (client && client.getOptions());
    return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
}
/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
    var hub = maybeHub || (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
    var scope = hub.getScope();
    return scope && scope.getTransaction();
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
    return time / 1000;
}
/**
 * Converts from seconds to milliseconds
 * @param time time in seconds
 */
function secToMs(time) {
    return time * 1000;
}
// so it can be used in manual instrumentation without necessitating a hard dependency on @sentry/utils

//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 80963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l": function() { return /* binding */ getLocationHref; }
/* harmony export */ });
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5177);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2389);


/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length
        ? keyAttrs.filter(function (keyAttr) { return elem.getAttribute(keyAttr); }).map(function (keyAttr) { return [keyAttr, elem.getAttribute(keyAttr)]; })
        : null;
    if (keyAttrPairs && keyAttrPairs.length) {
        keyAttrPairs.forEach(function (keyAttrPair) {
            out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
        });
    }
    else {
        if (elem.id) {
            out.push("#" + elem.id);
        }
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(className)) {
            classes = className.split(/\s+/);
            for (i = 0; i < classes.length; i++) {
                out.push("." + classes[i]);
            }
        }
    }
    var allowedAttrs = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < allowedAttrs.length; i++) {
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)();
    try {
        return global.document.location.href;
    }
    catch (oO) {
        return '';
    }
}
//# sourceMappingURL=browser.js.map

/***/ }),

/***/ 86834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IS_DEBUG_BUILD; }
/* harmony export */ });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map

/***/ }),

/***/ 5177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "Y": function() { return /* binding */ getGlobalSingleton; }
/* harmony export */ });
/* harmony import */ var _node__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88090);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return ((0,_node__WEBPACK_IMPORTED_MODULE_0__/* .isNodeEnv */ .KV)()
        ? __webpack_require__.g
        : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
            ? window // eslint-disable-line no-restricted-globals
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `getGlobalObject`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
    var global = (obj || getGlobalObject());
    var __SENTRY__ = (global.__SENTRY__ = global.__SENTRY__ || {});
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}
//# sourceMappingURL=global.js.map

/***/ }),

/***/ 44290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ addInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61557);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86834);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5177);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2389);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7663);
/* harmony import */ var _object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50416);
/* harmony import */ var _stacktrace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28791);
/* harmony import */ var _supports__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66946);








var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h && _logger__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn('unknown instrumentation type:', type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(callback);
    instrument(type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__values */ .XA)(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h &&
                    _logger__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .kg.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0,_stacktrace__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(handler) + "\nError:", e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in global)) {
        return;
    }
    _logger__WEBPACK_IMPORTED_MODULE_2__/* .CONSOLE_LEVELS.forEach */ .RU.forEach(function (level) {
        if (!(level in global.console)) {
            return;
        }
        (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global.console, level, function (originalConsoleMethod) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleMethod) {
                    originalConsoleMethod.apply(global.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!(0,_supports__WEBPACK_IMPORTED_MODULE_6__/* .supportsNativeFetch */ .t$)()) {
        return;
    }
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var handlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(global, args).then(function (response) {
                triggerHandlers('fetch', (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, handlerData), { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({}, handlerData), { endTimestamp: Date.now(), error: error }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in global && (0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isInstanceOf */ .V9)(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in global && (0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isInstanceOf */ .V9)(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in global)) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = (xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isString */ .HD)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            });
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0,_is__WEBPACK_IMPORTED_MODULE_7__/* .isString */ .HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
                xhr.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function () {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr,
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(xhr, args);
        };
    });
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.__sentry_xhr__ && args[0] !== undefined) {
                this.__sentry_xhr__.body = args[0];
            }
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this,
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!(0,_supports__WEBPACK_IMPORTED_MODULE_6__/* .supportsHistory */ .Bf)()) {
        return;
    }
    var oldOnPopState = global.onpopstate;
    global.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
            // https://github.com/getsentry/sentry-javascript/issues/3344
            // https://github.com/bugsnag/bugsnag-js/issues/469
            try {
                return oldOnPopState.apply(this, args);
            }
            catch (_oO) {
                // no-empty
            }
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global.history, 'pushState', historyReplacementFunction);
    (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(global.history, 'replaceState', historyReplacementFunction);
}
var debounceDuration = 1000;
var debounceTimerID;
var lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) {
        return true;
    }
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) {
        return true;
    }
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) {
            return true;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') {
        return false;
    }
    try {
        var target = event.target;
        if (!target || !target.tagName) {
            return true;
        }
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
            return false;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) { globalListener = false; }
    return function (event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event)) {
            return;
        }
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if (debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = global.setTimeout(function () {
            debounceTimerID = undefined;
        }, debounceDuration);
    };
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in global)) {
        return;
    }
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    global.document.addEventListener('click', globalDOMEventHandler, false);
    global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    ['EventTarget', 'Node'].forEach(function (target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(proto, 'addEventListener', function (originalAddEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_1 = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
                        var handlerForType = (handlers_1[type] = handlers_1[type] || { refCount: 0 });
                        if (!handlerForType.handler) {
                            var handler = makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount += 1;
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0,_object__WEBPACK_IMPORTED_MODULE_5__/* .fill */ .hl)(proto, 'removeEventListener', function (originalRemoveEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers_2[type];
                        if (handlerForType) {
                            handlerForType.refCount -= 1;
                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = undefined;
                                delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                            }
                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
                            if (Object.keys(handlers_2).length === 0) {
                                delete el.__sentry_instrumentation_handlers__;
                            }
                        }
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
    _oldOnErrorHandler = global.onerror;
    global.onerror = function (msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url,
        });
        if (_oldOnErrorHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
    global.onunhandledrejection = function (e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
}
//# sourceMappingURL=instrument.js.map

/***/ }),

/***/ 2389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; }
/* harmony export */ });
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line @typescript-eslint/unbound-method
var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (objectToString.call(wat)) {
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
function isBuiltin(wat, ty) {
    return objectToString.call(wat) === "[object " + ty + "]";
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return isBuiltin(wat, 'String');
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
//# sourceMappingURL=is.js.map

/***/ }),

/***/ 7663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61557);
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86834);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5177);



// TODO: Implement different loggers for different environments
var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
var CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    if (!('console' in global)) {
        return callback();
    }
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    CONSOLE_LEVELS.forEach(function (level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    }
    finally {
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function (level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function makeLogger() {
    var enabled = false;
    var logger = {
        enable: function () {
            enabled = true;
        },
        disable: function () {
            enabled = false;
        },
    };
    if (_flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h) {
        CONSOLE_LEVELS.forEach(function (name) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            logger[name] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (enabled) {
                    consoleSandbox(function () {
                        var _a;
                        (_a = global.console)[name].apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spread */ .fl)([PREFIX + "[" + name + "]:"], args));
                    });
                }
            };
        });
    }
    else {
        CONSOLE_LEVELS.forEach(function (name) {
            logger[name] = function () { return undefined; };
        });
    }
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var logger;
if (_flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h) {
    logger = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .Y)('logger', makeLogger);
}
else {
    logger = makeLogger();
}

//# sourceMappingURL=logger.js.map

/***/ }),

/***/ 45855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "en": function() { return /* binding */ parseUrl; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "rt": function() { return /* binding */ stripUrlQueryAndFragment; }
/* harmony export */ });
/* unused harmony exports parseSemver, addContextToFrame */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61557);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5177);
/* harmony import */ var _object__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50416);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) {
        return message;
    }
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) {
            return firstException.type + ": " + firstException.value;
        }
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    var exception = (event.exception = event.exception || {});
    var values = (exception.values = exception.values || []);
    var firstException = (values[0] = values[0] || {});
    if (!firstException.value) {
        firstException.value = value || '';
    }
    if (!firstException.type) {
        firstException.type = type || 'Error';
    }
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) {
        return;
    }
    var defaultMechanism = { type: 'generic', handled: true };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, (currentMechanism && currentMechanism.data)), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4],
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) { linesOfContext = 5; }
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines
        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
        .map(function (line) { return snipLine(line, 0); });
    frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines
        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
        .map(function (line) { return snipLine(line, 0); });
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) {
        return true;
    }
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0,_object__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .xp)(exception, '__sentry_captured__', true);
    }
    catch (err) {
        // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
//# sourceMappingURL=misc.js.map

/***/ }),

/***/ 88090:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; },
  "$y": function() { return /* binding */ loadModule; }
});

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */
/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
//# sourceMappingURL=env.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(89885);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return (!isBrowserBundle() &&
        Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]');
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    }
    catch (e) {
        // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    }
    catch (e) {
        // no-empty
    }
    return mod;
}
//# sourceMappingURL=node.js.map

/***/ }),

/***/ 50416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61557);
/* harmony import */ var _browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80963);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2389);
/* harmony import */ var _string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81197);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') {
        try {
            markFunctionWrapped(wrapped, original);
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true,
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */
function convertToPlainObject(value) {
    var newObj = value;
    if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isError */ .VZ)(value)) {
        newObj = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ message: value.message, name: value.name, stack: value.stack }, getOwnProperties(value));
    }
    else if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isEvent */ .cO)(value)) {
        var event_1 = value;
        newObj = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ type: event_1.type, target: serializeEventTarget(event_1.target), currentTarget: serializeEventTarget(event_1.currentTarget) }, getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
            newObj.detail = event_1.detail;
        }
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
    try {
        return (0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(target) ? (0,_browser__WEBPACK_IMPORTED_MODULE_2__/* .htmlTreeAsString */ .R)(target) : Object.prototype.toString.call(target);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
    var extractedProps = {};
    for (var property in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, property)) {
            extractedProps[property] = obj[property];
        }
    }
    return extractedProps;
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return (0,_string__WEBPACK_IMPORTED_MODULE_3__/* .truncate */ .$G)(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return (0,_string__WEBPACK_IMPORTED_MODULE_3__/* .truncate */ .$G)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */
function dropUndefinedKeys(val) {
    var e_1, _a;
    if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(val)) {
        var rv = {};
        try {
            for (var _b = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__values */ .XA)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (typeof val[key] !== 'undefined') {
                    rv[key] = dropUndefinedKeys(val[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return rv;
    }
    if (Array.isArray(val)) {
        return val.map(dropUndefinedKeys);
    }
    return val;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
    var objectified;
    switch (true) {
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case isPrimitive(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
//# sourceMappingURL=object.js.map

/***/ }),

/***/ 28791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony export stripSentryFramesAndReverse */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61557);

var STACKTRACE_LIMIT = 50;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser() {
    var parsers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parsers[_i] = arguments[_i];
    }
    var sortedParsers = parsers.sort(function (a, b) { return a[0] - b[0]; }).map(function (p) { return p[1]; });
    return function (stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) { skipFirst = 0; }
        var frames = [];
        try {
            for (var _c = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var line = _d.value;
                try {
                    for (var sortedParsers_1 = (e_2 = void 0, (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__values */ .XA)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()) {
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return stripSentryFramesAndReverse(frames);
    };
}
/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
    if (!stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .slice(0, STACKTRACE_LIMIT)
        .map(function (frame) { return ((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, frame), { filename: frame.filename || localStack[0].filename, function: frame.function || '?' })); })
        .reverse();
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
//# sourceMappingURL=stacktrace.js.map

/***/ }),

/***/ 81197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; },
/* harmony export */   "zC": function() { return /* binding */ isMatchingPattern; }
/* harmony export */ });
/* unused harmony exports snipLine, escapeStringForRegex */
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2389);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) {
        return newLine;
    }
    if (colno > lineLength) {
        // eslint-disable-next-line no-param-reassign
        colno = lineLength;
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) {
        end = lineLength;
    }
    if (end === lineLength) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < lineLength) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (!(0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
        return false;
    }
    if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
//# sourceMappingURL=string.js.map

/***/ }),

/***/ 66946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Bf": function() { return /* binding */ supportsHistory; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "hv": function() { return /* binding */ supportsReferrerPolicy; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsErrorEvent, supportsDOMError, supportsDOMException, supportsReportingObserver */
/* harmony import */ var _flags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86834);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5177);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7663);



/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)())) {
        return false;
    }
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') {
        try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            _flags__WEBPACK_IMPORTED_MODULE_1__/* .IS_DEBUG_BUILD */ .h &&
                _logger__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    return 'ReportingObserver' in getGlobalObject();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map

/***/ }),

/***/ 14464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2389);
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
    return new SyncPromise(function (resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
    return new SyncPromise(function (_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(1 /* RESOLVED */, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(2 /* REJECTED */, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== 0 /* PENDING */) {
                return;
            }
            if ((0,_is__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
                void value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === 0 /* PENDING */) {
                return;
            }
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function (handler) {
                if (handler[0]) {
                    return;
                }
                if (_this._state === 1 /* RESOLVED */) {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    handler[1](_this._value);
                }
                if (_this._state === 2 /* REJECTED */) {
                    handler[2](_this._value);
                }
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._handlers.push([
                false,
                function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                    }
                    else {
                        try {
                            resolve(onfulfilled(result));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
                function (reason) {
                    if (!onrejected) {
                        reject(reason);
                    }
                    else {
                        try {
                            resolve(onrejected(reason));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map

/***/ }),

/***/ 26757:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "_I": function() { return /* binding */ timestampWithMs; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports usingPerformanceAPI, _browserPerformanceTimeOriginMode */
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5177);
/* harmony import */ var _node__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88090);
/* module decorator */ module = __webpack_require__.hmd(module);


/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
    nowSeconds: function () { return Date.now() / 1000; },
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
    var performance = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function () { return performance.now(); },
        timeOrigin: timeOrigin,
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
    try {
        var perfHooks = (0,_node__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks');
        return perfHooks.performance;
    }
    catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = (0,_node__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
    };
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
var usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
var _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
var browserPerformanceTimeOrigin = (function () {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600 * 1000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin
        ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
        : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        }
        else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
})();
//# sourceMappingURL=time.js.map

/***/ }),

/***/ 50292:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var _global = (typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9.0.2-178a20c-production"};

/***/ }),

/***/ 50744:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 68295:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 63288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTimezoneOffsetInMilliseconds; }
/* harmony export */ });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),

/***/ 1780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 55686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1780);

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),

/***/ 61836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ AnimatePresence; }
});

// EXTERNAL MODULE: ./node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(55845);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-unmount-effect.js
var use_unmount_effect = __webpack_require__(17249);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-force-update.js




function useForceUpdate() {
    var unloadingRef = (0,react.useRef)(false);
    var _a = (0,tslib_es6/* __read */.CR)((0,react.useState)(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    (0,use_unmount_effect/* useUnmountEffect */.z)(function () { return (unloadingRef.current = true); });
    return (0,react.useCallback)(function () {
        !unloadingRef.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [forcedRenderCount]);
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/PresenceContext.js
var PresenceContext = __webpack_require__(4796);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.js
var use_constant = __webpack_require__(71435);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/PresenceChild.js





var presenceId = 0;
function getPresenceId() {
    var id = presenceId;
    presenceId++;
    return id;
}
var PresenceChild = function (_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = (0,use_constant/* useConstant */.h)(newChildrenMap);
    var id = (0,use_constant/* useConstant */.h)(getPresenceId);
    var context = (0,react.useMemo)(function () { return ({
        id: id,
        initial: initial,
        isPresent: isPresent,
        custom: custom,
        onExitComplete: function (childId) {
            presenceChildren.set(childId, true);
            var allComplete = true;
            presenceChildren.forEach(function (isComplete) {
                if (!isComplete)
                    allComplete = false;
            });
            allComplete && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
        },
        register: function (childId) {
            presenceChildren.set(childId, false);
            return function () { return presenceChildren.delete(childId); };
        },
    }); }, 
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    presenceAffectsLayout ? undefined : [isPresent]);
    (0,react.useMemo)(function () {
        presenceChildren.forEach(function (_, key) { return presenceChildren.set(key, false); });
    }, [isPresent]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */
    react.useEffect(function () {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
    }, [isPresent]);
    return (react.createElement(PresenceContext/* PresenceContext.Provider */.O.Provider, { value: context }, children));
};
function newChildrenMap() {
    return new Map();
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/SharedLayoutContext.js + 1 modules
var SharedLayoutContext = __webpack_require__(92513);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.js







function getChildKey(child) {
    return child.key || "";
}
function updateChildLookup(children, allChildren) {
    var seenChildren =  false ? 0 : null;
    children.forEach(function (child) {
        var key = getChildKey(child);
        if (false) {}
        allChildren.set(key, child);
    });
}
function onlyElements(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    react.Children.forEach(children, function (child) {
        if ((0,react.isValidElement)(child))
            filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * @library
 *
 * Any `Frame` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { Frame, AnimatePresence } from 'framer'
 *
 * // As items are added and removed from `items`
 * export function Items({ items }) {
 *   return (
 *     <AnimatePresence>
 *       {items.map(item => (
 *         <Frame
 *           key={item.id}
 *           initial={{ opacity: 0 }}
 *           animate={{ opacity: 1 }}
 *           exit={{ opacity: 0 }}
 *         />
 *       ))}
 *     </AnimatePresence>
 *   )
 * }
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * @motion
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */
var AnimatePresence = function (_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    var forceRender = useForceUpdate();
    var layoutContext = (0,react.useContext)(SharedLayoutContext/* SharedLayoutContext */.WH);
    if ((0,SharedLayoutContext/* isSharedLayout */.Md)(layoutContext)) {
        forceRender = layoutContext.forceUpdate;
    }
    var isInitialRender = (0,react.useRef)(true);
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    var filteredChildren = onlyElements(children);
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    var presentChildren = (0,react.useRef)(filteredChildren);
    // A lookup table to quickly reference components by key
    var allChildren = (0,react.useRef)(new Map())
        .current;
    // A living record of all currently exiting components.
    var exiting = (0,react.useRef)(new Set()).current;
    updateChildLookup(filteredChildren, allChildren);
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    if (isInitialRender.current) {
        isInitialRender.current = false;
        return (react.createElement(react.Fragment, null, filteredChildren.map(function (child) { return (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? undefined : false, presenceAffectsLayout: presenceAffectsLayout }, child)); })));
    }
    // If this is a subsequent render, deal with entering and exiting children
    var childrenToRender = (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(filteredChildren));
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    var presentKeys = presentChildren.current.map(getChildKey);
    var targetKeys = filteredChildren.map(getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    var numPresent = presentKeys.length;
    for (var i = 0; i < numPresent; i++) {
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) {
            exiting.add(key);
        }
        else {
            // In case this key has re-entered, remove from the exiting list
            exiting.delete(key);
        }
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (exitBeforeEnter && exiting.size) {
        childrenToRender = [];
    }
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach(function (key) {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1)
            return;
        var child = allChildren.get(key);
        if (!child)
            return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function () {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            var removeIndex = presentChildren.current.findIndex(function (presentChild) { return presentChild.key === key; });
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, react.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom: custom, presenceAffectsLayout: presenceAffectsLayout }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map(function (child) {
        var key = child.key;
        return exiting.has(key) ? (child) : (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout: presenceAffectsLayout }, child));
    });
    presentChildren.current = childrenToRender;
    if (false) {}
    return (react.createElement(react.Fragment, null, exiting.size
        ? childrenToRender
        : childrenToRender.map(function (child) { return (0,react.cloneElement)(child); })));
};




/***/ }),

/***/ 44038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ VisibilityAction; },
/* harmony export */   "z": function() { return /* binding */ Presence; }
/* harmony export */ });
/**
 * @public
 */
var Presence;
(function (Presence) {
    Presence[Presence["Entering"] = 0] = "Entering";
    Presence[Presence["Present"] = 1] = "Present";
    Presence[Presence["Exiting"] = 2] = "Exiting";
})(Presence || (Presence = {}));
/**
 * @public
 */
var VisibilityAction;
(function (VisibilityAction) {
    VisibilityAction[VisibilityAction["Hide"] = 0] = "Hide";
    VisibilityAction[VisibilityAction["Show"] = 1] = "Show";
})(VisibilityAction || (VisibilityAction = {}));




/***/ }),

/***/ 4796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ PresenceContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);


/**
 * @public
 */
var PresenceContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);




/***/ }),

/***/ 92513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bg": function() { return /* binding */ FramerTreeLayoutContext; },
  "WH": function() { return /* binding */ SharedLayoutContext; },
  "Md": function() { return /* binding */ isSharedLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(55845);
// EXTERNAL MODULE: ./node_modules/framesync/dist/es/index.js + 2 modules
var es = __webpack_require__(26765);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/projection/utils.js
var utils = __webpack_require__(56962);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/batch-layout.js
var batch_layout = __webpack_require__(78091);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/compare-by-depth.js
var compare_by_depth = __webpack_require__(81708);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimateSharedLayout/types.js
var types = __webpack_require__(44038);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimateSharedLayout/utils/batcher.js







/**
 * Default handlers for batching VisualElements
 */
var defaultHandler = {
    layoutReady: function (child) { return child.notifyLayoutReady(); },
};
/**
 * Create a batcher to process VisualElements
 */
function createBatcher() {
    var queue = new Set();
    return {
        add: function (child) { return queue.add(child); },
        flush: function (_a) {
            var _b = _a === void 0 ? defaultHandler : _a, layoutReady = _b.layoutReady, parent = _b.parent;
            (0,batch_layout/* batchLayout */.U)(function (read, write) {
                var order = Array.from(queue).sort(compare_by_depth/* compareByDepth */._);
                var ancestors = parent
                    ? (0,utils/* collectProjectingAncestors */.kv)(parent)
                    : [];
                write(function () {
                    var allElements = (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(ancestors)), (0,tslib_es6/* __read */.CR)(order));
                    allElements.forEach(function (element) { return element.resetTransform(); });
                });
                read(function () {
                    order.forEach(utils/* updateLayoutMeasurement */.de);
                });
                write(function () {
                    ancestors.forEach(function (element) { return element.restoreTransform(); });
                    order.forEach(layoutReady);
                });
                read(function () {
                    /**
                     * After all children have started animating, ensure any Entering components are set to Present.
                     * If we add deferred animations (set up all animations and then start them in two loops) this
                     * could be moved to the start loop. But it needs to happen after all the animations configs
                     * are generated in AnimateSharedLayout as this relies on presence data
                     */
                    order.forEach(function (child) {
                        if (child.isPresent)
                            child.presence = types/* Presence.Present */.z.Present;
                    });
                });
                write(function () {
                    /**
                     * Starting these animations will have queued jobs on the frame loop. In some situations,
                     * like when removing an element, these will be processed too late after the DOM is manipulated,
                     * leaving a flash of incorrectly-projected content. By manually flushing these jobs
                     * we ensure there's no flash.
                     */
                    es/* flushSync.preRender */.iW.preRender();
                    es/* flushSync.render */.iW.render();
                });
                read(function () {
                    /**
                     * Schedule a callback at the end of the following frame to assign the latest projection
                     * box to the prevViewportBox snapshot. Once global batching is in place this could be run
                     * synchronously. But for now it ensures that if any nested `AnimateSharedLayout` top-level
                     * child attempts to calculate its previous relative position against a prevViewportBox
                     * it will be against its latest projection box instead, as the snapshot is useless beyond this
                     * render.
                     */
                    es/* default.postRender */.ZP.postRender(function () {
                        return order.forEach(assignProjectionToSnapshot);
                    });
                    queue.clear();
                });
            });
            // TODO: Need to find a layout-synchronous way of flushing this
            (0,batch_layout/* flushLayout */.R)();
        },
    };
}
function assignProjectionToSnapshot(child) {
    child.prevViewportBox = child.projection.target;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/SharedLayoutContext.js



var SharedLayoutContext = (0,react.createContext)(createBatcher());
/**
 * @internal
 */
var FramerTreeLayoutContext = (0,react.createContext)(createBatcher());
function isSharedLayout(context) {
    return !!context.forceUpdate;
}




/***/ }),

/***/ 50922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ motion; }
});

// UNUSED EXPORTS: createDomMotionComponent

// EXTERNAL MODULE: ./node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(55845);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/definitions.js
var createDefinition = function (propNames) { return ({
    isEnabled: function (props) { return propNames.some(function (name) { return !!props[name]; }); },
}); };
var featureDefinitions = {
    measureLayout: createDefinition([
        "layout",
        "layoutId",
        "drag",
        "_layoutResetTransform",
    ]),
    animation: createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
    ]),
    exit: createDefinition(["exit"]),
    drag: createDefinition(["drag", "dragControls"]),
    focus: createDefinition(["whileFocus"]),
    hover: createDefinition(["whileHover", "onHoverStart", "onHoverEnd"]),
    tap: createDefinition(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
    pan: createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd",
    ]),
    layoutAnimation: createDefinition(["layout", "layoutId"]),
};
function loadFeatures(features) {
    for (var key in features) {
        var Component = features[key];
        if (Component !== null)
            featureDefinitions[key].Component = Component;
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/LazyContext.js


var LazyContext = (0,react.createContext)({ strict: false });



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/use-features.js







var featureNames = Object.keys(featureDefinitions);
var numFeatures = featureNames.length;
/**
 * Load features via renderless components based on the provided MotionProps.
 */
function useFeatures(props, visualElement, preloadedFeatures) {
    var features = [];
    var lazyContext = (0,react.useContext)(LazyContext);
    if (!visualElement)
        return null;
    /**
     * If we're in development mode, check to make sure we're not rendering a motion component
     * as a child of LazyMotion, as this will break the file-size benefits of using it.
     */
    if (false) {}
    for (var i = 0; i < numFeatures; i++) {
        var name_1 = featureNames[i];
        var _a = featureDefinitions[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
        /**
         * It might be possible in the future to use this moment to
         * dynamically request functionality. In initial tests this
         * was producing a lot of duplication amongst bundles.
         */
        if (isEnabled(props) && Component) {
            features.push(react.createElement(Component, (0,tslib_es6/* __assign */.pi)({ key: name_1 }, props, { visualElement: visualElement })));
        }
    }
    return features;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/MotionConfigContext.js


/**
 * @public
 */
var MotionConfigContext = (0,react.createContext)({
    transformPagePoint: function (p) { return p; },
    isStatic: false,
});



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/MotionContext/index.js


var MotionContext = (0,react.createContext)({});
function useVisualElementContext() {
    return (0,react.useContext)(MotionContext).visualElement;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/PresenceContext.js
var context_PresenceContext = __webpack_require__(4796);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.js
var use_constant = __webpack_require__(71435);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.js




/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */
function usePresence() {
    var context = (0,react.useContext)(context_PresenceContext/* PresenceContext */.O);
    if (context === null)
        return [true, null];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useOpaqueId when released in React
    var id = useUniqueId();
    (0,react.useEffect)(function () { return register(id); }, []);
    var safeToRemove = function () { return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id); };
    return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */
function useIsPresent() {
    return isPresent(useContext(PresenceContext));
}
function isPresent(context) {
    return context === null ? true : context.isPresent;
}
var counter = 0;
var incrementId = function () { return counter++; };
var useUniqueId = function () { return (0,use_constant/* useConstant */.h)(incrementId); };



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/LayoutGroupContext.js


/**
 * @internal
 */
var LayoutGroupContext = (0,react.createContext)(null);



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/is-browser.js
var isBrowser = typeof window !== "undefined";



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.js



var useIsomorphicLayoutEffect = isBrowser ? react.useLayoutEffect : react.useEffect;



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/utils/use-visual-element.js










function useLayoutId(_a) {
    var layoutId = _a.layoutId;
    var layoutGroupId = (0,react.useContext)(LayoutGroupContext);
    return layoutGroupId && layoutId !== undefined
        ? layoutGroupId + "-" + layoutId
        : layoutId;
}
function useVisualElement(Component, visualState, props, createVisualElement) {
    var config = (0,react.useContext)(MotionConfigContext);
    var lazyContext = (0,react.useContext)(LazyContext);
    var parent = useVisualElementContext();
    var presenceContext = (0,react.useContext)(context_PresenceContext/* PresenceContext */.O);
    var layoutId = useLayoutId(props);
    var visualElementRef = (0,react.useRef)(undefined);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */
    if (!createVisualElement)
        createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState: visualState,
            parent: parent,
            props: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, props), { layoutId: layoutId }),
            presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
            blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false,
        });
    }
    var visualElement = visualElementRef.current;
    useIsomorphicLayoutEffect(function () {
        if (!visualElement)
            return;
        visualElement.setProps((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, config), props), { layoutId: layoutId }));
        visualElement.isPresent = isPresent(presenceContext);
        visualElement.isPresenceRoot =
            !parent || parent.presenceId !== (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id);
        /**
         * Fire a render to ensure the latest state is reflected on-screen.
         */
        visualElement.syncRender();
    });
    (0,react.useEffect)(function () {
        var _a;
        if (!visualElement)
            return;
        /**
         * In a future refactor we can replace the features-as-components and
         * have this loop through them all firing "effect" listeners
         */
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.animateChanges();
    });
    useIsomorphicLayoutEffect(function () { return function () { return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount(); }; }, []);
    return visualElement;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/is-ref-object.js
function isRefObject(ref) {
    return (typeof ref === "object" &&
        Object.prototype.hasOwnProperty.call(ref, "current"));
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/utils/use-motion-ref.js



/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */
function useMotionRef(visualState, visualElement, externalRef) {
    return (0,react.useCallback)(function (instance) {
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 ? void 0 : _a.call(visualState, instance));
        if (visualElement) {
            instance
                ? visualElement.mount(instance)
                : visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") {
                externalRef(instance);
            }
            else if (isRefObject(externalRef)) {
                externalRef.current = instance;
            }
        }
    }, 
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement]);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/variants.js
/**
 * Decides if the supplied variable is an array of variant labels
 */
function isVariantLabels(v) {
    return Array.isArray(v);
}
/**
 * Decides if the supplied variable is variant label
 */
function isVariantLabel(v) {
    return typeof v === "string" || isVariantLabels(v);
}
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */
function getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function (value, key) { return (current[key] = value.get()); });
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */
function getVelocity(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function (value, key) { return (velocity[key] = value.getVelocity()); });
    return velocity;
}
function resolveVariantFromProps(props, definition, custom, currentValues, currentVelocity) {
    var _a;
    if (currentValues === void 0) { currentValues = {}; }
    if (currentVelocity === void 0) { currentVelocity = {}; }
    if (typeof definition === "string") {
        definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    }
    return typeof definition === "function"
        ? definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity)
        : definition;
}
function resolveVariant(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return resolveVariantFromProps(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, getCurrent(visualElement), getVelocity(visualElement));
}
function checkIfControllingVariants(props) {
    var _a;
    return (typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" ||
        isVariantLabel(props.initial) ||
        isVariantLabel(props.animate) ||
        isVariantLabel(props.whileHover) ||
        isVariantLabel(props.whileDrag) ||
        isVariantLabel(props.whileTap) ||
        isVariantLabel(props.whileFocus) ||
        isVariantLabel(props.exit));
}
function checkIfVariantNode(props) {
    return Boolean(checkIfControllingVariants(props) || props.variants);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/MotionContext/utils.js


function getCurrentTreeVariants(props, context) {
    if (checkIfControllingVariants(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || isVariantLabel(initial)
                ? initial
                : undefined,
            animate: isVariantLabel(animate) ? animate : undefined,
        };
    }
    return props.inherit !== false ? context : {};
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/MotionContext/create.js




function useCreateMotionContext(props, isStatic) {
    var _a = getCurrentTreeVariants(props, (0,react.useContext)(MotionContext)), initial = _a.initial, animate = _a.animate;
    return (0,react.useMemo)(function () { return ({ initial: initial, animate: animate }); }, 
    /**
     * Only break memoisation in static mode
     */
    isStatic
        ? [
            variantLabelsAsDependency(initial),
            variantLabelsAsDependency(animate),
        ]
        : []);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/index.js











/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 *
 * @internal
 */
function motion_createMotionComponent(_a) {
    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
    preloadedFeatures && loadFeatures(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we're rendering in a static environment, we only visually update the component
         * as a result of a React-rerender rather than interactions or animations. This
         * means we don't need to load additional memory structures like VisualElement,
         * or any gesture/animation features.
         */
        var isStatic = (0,react.useContext)(MotionConfigContext).isStatic;
        var features = null;
        /**
         * Create the tree context. This is memoized and will only trigger renders
         * when the current tree variant changes in static mode.
         */
        var context = useCreateMotionContext(props, isStatic);
        /**
         *
         */
        var visualState = useVisualState(props, isStatic);
        if (!isStatic && isBrowser) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */
            context.visualElement = useVisualElement(Component, visualState, props, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             *
             * TODO: The intention is to move these away from a React-centric to a
             * VisualElement-centric lifecycle scheme.
             */
            features = useFeatures(props, context.visualElement, preloadedFeatures);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */
        return (react.createElement(react.Fragment, null,
            react.createElement(MotionContext.Provider, { value: context }, useRender(Component, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic)),
            features));
    }
    return (0,react.forwardRef)(MotionComponent);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-proxy.js


/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */
function createMotionProxy(createConfig) {
    function custom(Component, customMotionComponentConfig) {
        if (customMotionComponentConfig === void 0) { customMotionComponentConfig = {}; }
        return motion_createMotionComponent(createConfig(Component, customMotionComponentConfig));
    }
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */
    var componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */
        get: function (_target, key) {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */
            if (!componentCache.has(key)) {
                componentCache.set(key, custom(key));
            }
            return componentCache.get(key);
        },
    });
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/lowercase-elements.js
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */
var lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view",
];



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/is-svg-component.js


function isSVGComponent(Component) {
    if (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component !== "string" ||
        /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */
        Component.includes("-")) {
        return false;
    }
    else if (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    lowercaseSVGElements.indexOf(Component) > -1 ||
        /**
         * If it contains a capital letter, it's an SVG component
         */
        /[A-Z]/.test(Component)) {
        return true;
    }
    return false;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/projection/scale-correction.js
var valueScaleCorrection = {};
/**
 * @internal
 */
function addScaleCorrection(correctors) {
    for (var key in correctors) {
        valueScaleCorrection[key] = correctors[key];
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/utils/transform.js
/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */
var transformAxes = ["", "X", "Y", "Z"];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */
var order = ["translate", "scale", "rotate", "skew"];
/**
 * Generate a list of every possible transform key.
 */
var transformProps = ["transformPerspective", "x", "y", "z"];
order.forEach(function (operationKey) {
    return transformAxes.forEach(function (axesKey) {
        return transformProps.push(operationKey + axesKey);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */
function sortTransformProps(a, b) {
    return transformProps.indexOf(a) - transformProps.indexOf(b);
}
/**
 * A quick lookup for transform props.
 */
var transformPropSet = new Set(transformProps);
function isTransformProp(key) {
    return transformPropSet.has(key);
}
/**
 * A quick lookup for transform origin props
 */
var transformOriginProps = new Set(["originX", "originY", "originZ"]);
function isTransformOriginProp(key) {
    return transformOriginProps.has(key);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/utils/is-forced-motion-value.js



function isForcedMotionValue(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (isTransformProp(key) ||
        isTransformOriginProp(key) ||
        ((layout || layoutId !== undefined) &&
            (!!valueScaleCorrection[key] || key === "opacity")));
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/utils/is-motion-value.js
var isMotionValue = function (value) {
    return value !== null && typeof value === "object" && value.getVelocity;
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/utils/build-transform.js


var translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
};
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */
function buildTransform(_a, _b, transformIsDefault, transformTemplate) {
    var transform = _a.transform, transformKeys = _a.transformKeys;
    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
    // The transform string we're going to build into.
    var transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort(sortTransformProps);
    // Track whether the defined transform has a defined z so we don't add a
    // second to enable hardware acceleration
    var transformHasZ = false;
    // Loop over each transform and build them into transformString
    var numTransformKeys = transformKeys.length;
    for (var i = 0; i < numTransformKeys; i++) {
        var key = transformKeys[i];
        transformString += (translateAlias[key] || key) + "(" + transform[key] + ") ";
        if (key === "z")
            transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) {
        transformString += "translateZ(0)";
    }
    else {
        transformString = transformString.trim();
    }
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) {
        transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    }
    else if (allowTransformNone && transformIsDefault) {
        transformString = "none";
    }
    return transformString;
}
/**
 * Build a transformOrigin style. Uses the same defaults as the browser for
 * undefined origins.
 */
function buildTransformOrigin(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return originX + " " + originY + " " + originZ;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/is-css-variable.js
/**
 * Returns true if the provided key is a CSS variable
 */
function isCSSVariable(key) {
    return key.startsWith("--");
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/get-as-type.js
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */
var getValueAsType = function (value, type) {
    return type && typeof value === "number"
        ? type.transform(value)
        : value;
};



;// CONCATENATED MODULE: ./node_modules/style-value-types/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function tslib_es6_read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(tslib_es6_read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function tslib_es6_spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/style-value-types/dist/es/utils.js
var clamp = function (min, max) { return function (v) {
    return Math.max(Math.min(v, max), min);
}; };
var sanitize = function (v) { return (v % 1 ? Number(v.toFixed(5)) : v); };
var floatRegex = /(-)?([\d]*\.?[\d])+/g;
var colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
var singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function isString(v) {
    return typeof v === 'string';
}



;// CONCATENATED MODULE: ./node_modules/style-value-types/dist/es/numbers/units.js



var createUnitType = function (unit) { return ({
    test: function (v) {
        return isString(v) && v.endsWith(unit) && v.split(' ').length === 1;
    },
    parse: parseFloat,
    transform: function (v) { return "" + v + unit; },
}); };
var degrees = createUnitType('deg');
var percent = createUnitType('%');
var px = createUnitType('px');
var vh = createUnitType('vh');
var vw = createUnitType('vw');
var progressPercentage = __assign(__assign({}, percent), { parse: function (v) { return percent.parse(v) / 100; }, transform: function (v) { return percent.transform(v * 100); } });



;// CONCATENATED MODULE: ./node_modules/style-value-types/dist/es/numbers/index.js



var number = {
    test: function (v) { return typeof v === 'number'; },
    parse: parseFloat,
    transform: function (v) { return v; },
};
var alpha = __assign(__assign({}, number), { transform: clamp(0, 1) });
var scale = __assign(__assign({}, number), { default: 1 });



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/type-int.js



var type_int_int = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, number), { transform: Math.round });



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/number.js



var numberValueTypes = {
    // Border props
    borderWidth: px,
    borderTopWidth: px,
    borderRightWidth: px,
    borderBottomWidth: px,
    borderLeftWidth: px,
    borderRadius: px,
    radius: px,
    borderTopLeftRadius: px,
    borderTopRightRadius: px,
    borderBottomRightRadius: px,
    borderBottomLeftRadius: px,
    // Positioning props
    width: px,
    maxWidth: px,
    height: px,
    maxHeight: px,
    size: px,
    top: px,
    right: px,
    bottom: px,
    left: px,
    // Spacing props
    padding: px,
    paddingTop: px,
    paddingRight: px,
    paddingBottom: px,
    paddingLeft: px,
    margin: px,
    marginTop: px,
    marginRight: px,
    marginBottom: px,
    marginLeft: px,
    // Transform props
    rotate: degrees,
    rotateX: degrees,
    rotateY: degrees,
    rotateZ: degrees,
    scale: scale,
    scaleX: scale,
    scaleY: scale,
    scaleZ: scale,
    skew: degrees,
    skewX: degrees,
    skewY: degrees,
    distance: px,
    translateX: px,
    translateY: px,
    translateZ: px,
    x: px,
    y: px,
    z: px,
    perspective: px,
    transformPerspective: px,
    opacity: alpha,
    originX: progressPercentage,
    originY: progressPercentage,
    originZ: px,
    // Misc
    zIndex: type_int_int,
    // SVG
    fillOpacity: alpha,
    strokeOpacity: alpha,
    numOctaves: type_int_int,
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/utils/build-styles.js







function buildHTMLStyles(state, latestValues, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
    var _a;
    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
    // Empty the transformKeys array. As we're throwing out refs to its items
    // this might not be as cheap as suspected. Maybe using the array as a buffer
    // with a manual incrementation would be better.
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    var transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */
    for (var key in latestValues) {
        var value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */
        if (isCSSVariable(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        var valueType = numberValueTypes[key];
        var valueAsType = getValueAsType(value, valueType);
        if (isTransformProp(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone)
                continue;
            // Otherwise check to see if this is a default transform
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0))
                transformIsNone = false;
        }
        else if (isTransformOriginProp(key)) {
            transformOrigin[key] = valueAsType;
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
        }
        else {
            /**
             * If layout projection is on, and we need to perform scale correction for this
             * value type, perform it.
             */
            if ((projection === null || projection === void 0 ? void 0 : projection.isHydrated) &&
                (layoutState === null || layoutState === void 0 ? void 0 : layoutState.isHydrated) &&
                valueScaleCorrection[key]) {
                var correctedValue = valueScaleCorrection[key].process(value, layoutState, projection);
                /**
                 * Scale-correctable values can define a number of other values to break
                 * down into. For instance borderRadius needs applying to borderBottomLeftRadius etc
                 */
                var applyTo = valueScaleCorrection[key].applyTo;
                if (applyTo) {
                    var num = applyTo.length;
                    for (var i = 0; i < num; i++) {
                        style[applyTo[i]] = correctedValue;
                    }
                }
                else {
                    style[key] = correctedValue;
                }
            }
            else {
                style[key] = valueAsType;
            }
        }
    }
    if (layoutState &&
        projection &&
        buildProjectionTransform &&
        buildProjectionTransformOrigin) {
        style.transform = buildProjectionTransform(layoutState.deltaFinal, layoutState.treeScale, hasTransform ? transform : undefined);
        if (transformTemplate) {
            style.transform = transformTemplate(transform, style.transform);
        }
        style.transformOrigin = buildProjectionTransformOrigin(layoutState);
    }
    else {
        if (hasTransform) {
            style.transform = buildTransform(state, options, transformIsNone, transformTemplate);
        }
        if (hasTransformOrigin) {
            style.transformOrigin = buildTransformOrigin(transformOrigin);
        }
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/utils/create-render-state.js
var createHtmlRenderState = function () { return ({
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {},
}); };



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/use-props.js







function copyRawValuesOnly(target, source, props) {
    for (var key in source) {
        if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
            target[key] = source[key];
        }
    }
}
function useInitialMotionValues(_a, visualState, isStatic) {
    var transformTemplate = _a.transformTemplate;
    return (0,react.useMemo)(function () {
        var state = createHtmlRenderState();
        buildHTMLStyles(state, visualState, undefined, undefined, { enableHardwareAcceleration: !isStatic }, transformTemplate);
        var vars = state.vars, style = state.style;
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, vars), style);
    }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */
    copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) {
        style = props.transformValues(style);
    }
    return style;
}
function useHTMLProps(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = useStyle(props, visualState, isStatic);
    if (Boolean(props.drag)) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout =
            "none";
        // Disable scrolling on the draggable direction
        style.touchAction =
            props.drag === true
                ? "none"
                : "pan-" + (props.drag === "x" ? "y" : "x");
    }
    htmlProps.style = style;
    return htmlProps;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/utils/valid-prop.js
/**
 * A list of all valid MotionProps.
 *
 * @internalremarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */
var validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "_layoutResetTransform",
    "onLayoutAnimationComplete",
    "onViewportBoxUpdate",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover",
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */
function isValidMotionProp(key) {
    return validMotionProps.has(key);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/filter-props.js


var shouldForward = function (key) { return !isValidMotionProp(key); };
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */
try {
    var emotionIsPropValid_1 = (__webpack_require__(48335)/* ["default"] */ .Z);
    shouldForward = function (key) {
        // Handle events explicitly as Emotion validates them all as true
        if (key.startsWith("on")) {
            return !isValidMotionProp(key);
        }
        else {
            return emotionIsPropValid_1(key);
        }
    };
}
catch (_a) {
    // We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for (var key in props) {
        if (shouldForward(key) ||
            (forwardMotionProps === true && isValidMotionProp(key)) ||
            (!isDom && !isValidMotionProp(key))) {
            filteredProps[key] = props[key];
        }
    }
    return filteredProps;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/utils/transform-origin.js


function calcOrigin(origin, offset, size) {
    return typeof origin === "string"
        ? origin
        : px.transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */
function calcSVGTransformOrigin(dimensions, originX, originY) {
    var pxOriginX = calcOrigin(originX, dimensions.x, dimensions.width);
    var pxOriginY = calcOrigin(originY, dimensions.y, dimensions.height);
    return pxOriginX + " " + pxOriginY;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/utils/path.js


// Convert a progress 0-1 to a pixels value based on the provided length
var progressToPixels = function (progress, length) {
    return px.transform(progress * length);
};
var dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray",
};
var camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray",
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */
function buildSVGPath(attrs, totalLength, length, spacing, offset, useDashCase) {
    if (spacing === void 0) { spacing = 1; }
    if (offset === void 0) { offset = 0; }
    if (useDashCase === void 0) { useDashCase = true; }
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? dashKeys : camelKeys;
    // Build the dash offset
    attrs[keys.offset] = progressToPixels(-offset, totalLength);
    // Build the dash array
    var pathLength = progressToPixels(length, totalLength);
    var pathSpacing = progressToPixels(spacing, totalLength);
    attrs[keys.array] = pathLength + " " + pathSpacing;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/utils/build-attrs.js





/**
 * Build SVG visual attrbutes, like cx and style.transform
 */
function buildSVGAttrs(state, _a, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, 
    // This is object creation, which we try to avoid per-frame.
    latest = (0,tslib_es6/* __rest */._T)(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
    buildHTMLStyles(state, latest, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin);
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions, totalPathLength = state.totalPathLength;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */
    if (attrs.transform) {
        if (dimensions)
            style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions &&
        (originX !== undefined || originY !== undefined || style.transform)) {
        style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    }
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined)
        attrs.x = attrX;
    if (attrY !== undefined)
        attrs.y = attrY;
    // Build SVG path if one has been measured
    if (totalPathLength !== undefined && pathLength !== undefined) {
        buildSVGPath(attrs, totalPathLength, pathLength, pathSpacing, pathOffset, false);
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/utils/create-render-state.js



var createSvgRenderState = function () { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, createHtmlRenderState()), { attrs: {} })); };



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/use-props.js






function useSVGProps(props, visualState) {
    var visualProps = (0,react.useMemo)(function () {
        var state = createSvgRenderState();
        buildSVGAttrs(state, visualState, undefined, undefined, { enableHardwareAcceleration: false }, props.transformTemplate);
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, state.attrs), { style: (0,tslib_es6/* __assign */.pi)({}, state.style) });
    }, [visualState]);
    if (props.style) {
        var rawStyles = {};
        copyRawValuesOnly(rawStyles, props.style, props);
        visualProps.style = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, rawStyles), visualProps.style);
    }
    return visualProps;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/use-render.js







function createUseRender(forwardMotionProps) {
    if (forwardMotionProps === void 0) { forwardMotionProps = false; }
    var useRender = function (Component, props, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = isSVGComponent(Component)
            ? useSVGProps
            : useHTMLProps;
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
        var elementProps = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, filteredProps), visualProps), { ref: ref });
        return (0,react.createElement)(Component, elementProps);
    };
    return useRender;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/camel-to-dash.js
var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var REPLACE_TEMPLATE = "$1-$2";
/**
 * Convert camelCase to dash-case properties.
 */
var camelToDash = function (str) {
    return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/utils/render.js
function renderHTML(element, _a) {
    var style = _a.style, vars = _a.vars;
    // Directly assign style into the Element's style prop. In tests Object.assign is the
    // fastest way to assign styles.
    Object.assign(element.style, style);
    // Loop over any CSS variables and assign those.
    for (var key in vars) {
        element.style.setProperty(key, vars[key]);
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/utils/camel-case-attrs.js
/**
 * A set of attribute names that are always read/written as camel case.
 */
var camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
]);



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/utils/render.js




function renderSVG(element, renderState) {
    renderHTML(element, renderState);
    for (var key in renderState.attrs) {
        element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/utils/scrape-motion-values.js



function scrapeMotionValuesFromProps(props) {
    var style = props.style;
    var newValues = {};
    for (var key in style) {
        if (isMotionValue(style[key]) || isForcedMotionValue(key, props)) {
            newValues[key] = style[key];
        }
    }
    return newValues;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/utils/scrape-motion-values.js



function scrape_motion_values_scrapeMotionValuesFromProps(props) {
    var newValues = scrapeMotionValuesFromProps(props);
    for (var key in props) {
        if (isMotionValue(props[key])) {
            var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
            newValues[targetKey] = props[key];
        }
    }
    return newValues;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/utils/is-animation-controls.js
function isAnimationControls(v) {
    return typeof v === "object" && typeof v.start === "function";
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/utils/is-keyframes-target.js
var isKeyframesTarget = function (v) {
    return Array.isArray(v);
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/resolve-value.js


var isCustomValue = function (v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var resolveFinalValueInKeyframes = function (v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/utils/resolve-motion-value.js



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 *
 * @internal
 */
function resolveMotionValue(value) {
    var unwrappedValue = isMotionValue(value) ? value.get() : value;
    return isCustomValue(unwrappedValue)
        ? unwrappedValue.toValue()
        : unwrappedValue;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/utils/use-visual-state.js









function makeState(_a, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
    var state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState(),
    };
    if (onMount) {
        state.mount = function (instance) { return onMount(props, instance, state); };
    }
    return state;
}
var makeUseVisualState = function (config) { return function (props, isStatic) {
    var context = (0,react.useContext)(MotionContext);
    var presenceContext = (0,react.useContext)(context_PresenceContext/* PresenceContext */.O);
    return isStatic
        ? makeState(config, props, context, presenceContext)
        : (0,use_constant/* useConstant */.h)(function () { return makeState(config, props, context, presenceContext); });
}; };
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    var motionValues = scrapeMotionValues(props);
    for (var key in motionValues) {
        values[key] = resolveMotionValue(motionValues[key]);
    }
    var initial = props.initial, animate = props.animate;
    var isControllingVariants = checkIfControllingVariants(props);
    var isVariantNode = checkIfVariantNode(props);
    if (context &&
        isVariantNode &&
        !isControllingVariants &&
        props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : (initial = context.initial);
        animate !== null && animate !== void 0 ? animate : (animate = context.animate);
    }
    var variantToSet = blockInitialAnimation || initial === false ? animate : initial;
    if (variantToSet &&
        typeof variantToSet !== "boolean" &&
        !isAnimationControls(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
        list.forEach(function (definition) {
            var resolved = resolveVariantFromProps(props, definition);
            if (!resolved)
                return;
            var transitionEnd = resolved.transitionEnd; resolved.transition; var target = (0,tslib_es6/* __rest */._T)(resolved, ["transitionEnd", "transition"]);
            for (var key in target)
                values[key] = target[key];
            for (var key in transitionEnd)
                values[key] = transitionEnd[key];
        });
    }
    return values;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/config-motion.js






var svgMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrape_motion_values_scrapeMotionValuesFromProps,
        createRenderState: createSvgRenderState,
        onMount: function (props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions =
                    typeof instance.getBBox ===
                        "function"
                        ? instance.getBBox()
                        : instance.getBoundingClientRect();
            }
            catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                };
            }
            if (isPath(instance)) {
                renderState.totalPathLength = instance.getTotalLength();
            }
            buildSVGAttrs(renderState, latestValues, undefined, undefined, { enableHardwareAcceleration: false }, props.transformTemplate);
            // TODO: Replace with direct assignment
            renderSVG(instance, renderState);
        },
    }),
};
function isPath(element) {
    return element.tagName === "path";
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/config-motion.js




var htmlMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
        createRenderState: createHtmlRenderState,
    }),
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/create-config.js






function create_config_createDomMotionConfig(Component, _a, preloadedFeatures, createVisualElement) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = isSVGComponent(Component)
        ? svgMotionConfig
        : htmlMotionConfig;
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, baseConfig), { preloadedFeatures: preloadedFeatures, useRender: createUseRender(forwardMotionProps), createVisualElement: createVisualElement,
        Component: Component });
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/types.js
var AnimationType;
(function (AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["Exit"] = "exit";
})(AnimationType || (AnimationType = {}));



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/events/use-dom-event.js


function addDomEvent(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function () { return target.removeEventListener(eventName, handler, options); };
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */
function useDomEvent(ref, eventName, handler, options) {
    (0,react.useEffect)(function () {
        var element = ref.current;
        if (handler && element) {
            return addDomEvent(element, eventName, handler, options);
        }
    }, [ref, eventName, handler, options]);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/use-focus-gesture.js



/**
 *
 * @param props
 * @param ref
 * @internal
 */
function useFocusGesture(_a) {
    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
    var onFocus = function () {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Focus, true);
    };
    var onBlur = function () {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Focus, false);
    };
    useDomEvent(visualElement, "focus", whileFocus ? onFocus : undefined);
    useDomEvent(visualElement, "blur", whileFocus ? onBlur : undefined);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/utils/event-type.js
function isMouseEvent(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
        return !!(event.pointerType === "mouse");
    }
    return event instanceof MouseEvent;
}
function isTouchEvent(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/events/event-info.js


/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */
function filterPrimaryPointer(eventHandler) {
    return function (event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent ||
            (isMouseEvent && event.button === 0);
        if (isPrimaryPointer) {
            eventHandler(event);
        }
    };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(e, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function pointFromMouse(point, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function extractEventInfo(event, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    return {
        point: isTouchEvent(event)
            ? pointFromTouch(event, pointType)
            : pointFromMouse(event, pointType),
    };
}
function getViewportPointFromEvent(event) {
    return extractEventInfo(event, "client");
}
var wrapHandler = function (handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) { shouldFilterPrimaryPointer = false; }
    var listener = function (event) {
        return handler(event, extractEventInfo(event));
    };
    return shouldFilterPrimaryPointer
        ? filterPrimaryPointer(listener)
        : listener;
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/events/utils.js


// We check for event support via functions in case they've been mocked by a testing suite.
var supportsPointerEvents = function () {
    return isBrowser && window.onpointerdown === null;
};
var supportsTouchEvents = function () {
    return isBrowser && window.ontouchstart === null;
};
var supportsMouseEvents = function () {
    return isBrowser && window.onmousedown === null;
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/events/use-pointer-event.js




var mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave",
};
var touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel",
};
function getPointerEventName(name) {
    if (supportsPointerEvents()) {
        return name;
    }
    else if (supportsTouchEvents()) {
        return touchEventNames[name];
    }
    else if (supportsMouseEvents()) {
        return mouseEventNames[name];
    }
    return name;
}
function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
}
function usePointerEvent(ref, eventName, handler, options) {
    return useDomEvent(ref, getPointerEventName(eventName), handler && wrapHandler(handler, eventName === "pointerdown"), options);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/drag/utils/lock.js
function createLock(name) {
    var lock = null;
    return function () {
        var openLock = function () {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var globalHorizontalLock = createLock("dragHorizontal");
var globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag) {
    var lock = false;
    if (drag === "y") {
        lock = globalVerticalLock();
    }
    else if (drag === "x") {
        lock = globalHorizontalLock();
    }
    else {
        var openHorizontal_1 = globalHorizontalLock();
        var openVertical_1 = globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) {
            lock = function () {
                openHorizontal_1();
                openVertical_1();
            };
        }
        else {
            // Release the locks because we don't use them
            if (openHorizontal_1)
                openHorizontal_1();
            if (openVertical_1)
                openVertical_1();
        }
    }
    return lock;
}
function isDragActive() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    var openGestureLock = getGlobalLock(true);
    if (!openGestureLock)
        return true;
    openGestureLock();
    return false;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/use-hover-gesture.js





function createHoverEvent(visualElement, isActive, callback) {
    return function (event, info) {
        var _a;
        if (!isMouseEvent(event) || isDragActive())
            return;
        callback === null || callback === void 0 ? void 0 : callback(event, info);
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Hover, isActive);
    };
}
function useHoverGesture(_a) {
    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
    usePointerEvent(visualElement, "pointerenter", onHoverStart || whileHover
        ? createHoverEvent(visualElement, true, onHoverStart)
        : undefined);
    usePointerEvent(visualElement, "pointerleave", onHoverEnd || whileHover
        ? createHoverEvent(visualElement, false, onHoverEnd)
        : undefined);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/utils/is-node-or-child.js
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */
var isNodeOrChild = function (parent, child) {
    if (!child) {
        return false;
    }
    else if (parent === child) {
        return true;
    }
    else {
        return isNodeOrChild(parent, child.parentElement);
    }
};



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-unmount-effect.js
var use_unmount_effect = __webpack_require__(17249);
;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/pipe.js
var combineFunctions = function (a, b) { return function (v) { return b(a(v)); }; };
var pipe = function () {
    var transformers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        transformers[_i] = arguments[_i];
    }
    return transformers.reduce(combineFunctions);
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/use-tap-gesture.js








/**
 * @param handlers -
 * @internal
 */
function useTapGesture(_a) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isPressing = (0,react.useRef)(false);
    var cancelPointerEndListeners = (0,react.useRef)(null);
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 ? void 0 : _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Tap, false);
        return !isDragActive();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd())
            return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */
        !isNodeOrChild(visualElement.getInstance(), event.target)
            ? onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info)
            : onTap === null || onTap === void 0 ? void 0 : onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd())
            return;
        onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current)
            return;
        isPressing.current = true;
        cancelPointerEndListeners.current = pipe(addPointerEvent(window, "pointerup", onPointerUp), addPointerEvent(window, "pointercancel", onPointerCancel));
        onTapStart === null || onTapStart === void 0 ? void 0 : onTapStart(event, info);
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Tap, true);
    }
    usePointerEvent(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined);
    (0,use_unmount_effect/* useUnmountEffect */.z)(removePointerEndListener);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/utils/make-renderless-component.js
var makeRenderlessComponent = function (hook) { return function (props) {
    hook(props);
    return null;
}; };



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/gestures.js





var gestureAnimations = {
    tap: makeRenderlessComponent(useTapGesture),
    focus: makeRenderlessComponent(useFocusGesture),
    hover: makeRenderlessComponent(useHoverGesture),
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/shallow-compare.js
function shallowCompare(next, prev) {
    if (!Array.isArray(prev))
        return false;
    var prevLength = prev.length;
    if (prevLength !== next.length)
        return false;
    for (var i = 0; i < prevLength; i++) {
        if (prev[i] !== next[i])
            return false;
    }
    return true;
}



;// CONCATENATED MODULE: ./node_modules/popmotion/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var tslib_es6_extendStatics = function(d, b) {
    tslib_es6_extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return tslib_es6_extendStatics(d, b);
};

function tslib_es6_extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    tslib_es6_extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var tslib_es6_assign = function() {
    tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return tslib_es6_assign.apply(this, arguments);
}

function tslib_es6_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function tslib_es6_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function tslib_es6_param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function tslib_es6_metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function tslib_es6_awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function tslib_es6_generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var tslib_es6_createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function tslib_es6_exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) tslib_es6_createBinding(o, m, p);
}

function tslib_es6_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function tslib_tslib_es6_read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function tslib_es6_spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(tslib_tslib_es6_read(arguments[i]));
    return ar;
}

/** @deprecated */
function tslib_es6_spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function tslib_tslib_es6_spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function tslib_es6_await(v) {
    return this instanceof tslib_es6_await ? (this.v = v, this) : new tslib_es6_await(v);
}

function tslib_es6_asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof tslib_es6_await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function tslib_es6_asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: tslib_es6_await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function tslib_es6_asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof tslib_es6_values === "function" ? tslib_es6_values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function tslib_es6_makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var tslib_es6_setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function tslib_es6_importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) tslib_es6_createBinding(result, mod, k);
    tslib_es6_setModuleDefault(result, mod);
    return result;
}

function tslib_es6_importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function tslib_es6_classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function tslib_es6_classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function tslib_es6_classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/hey-listen/dist/hey-listen.es.js
var warning = function () { };
var invariant = function () { };
if (false) {}



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/clamp.js
var clamp_clamp = function (min, max, v) {
    return Math.min(Math.max(v, min), max);
};



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/utils/find-spring.js



var safeMin = 0.001;
var minDuration = 0.01;
var maxDuration = 10.0;
var minDamping = 0.05;
var maxDamping = 1;
function findSpring(_a) {
    var _b = _a.duration, duration = _b === void 0 ? 800 : _b, _c = _a.bounce, bounce = _c === void 0 ? 0.25 : _c, _d = _a.velocity, velocity = _d === void 0 ? 0 : _d, _e = _a.mass, mass = _e === void 0 ? 1 : _e;
    var envelope;
    var derivative;
    warning(duration <= maxDuration * 1000, "Spring duration must be 10 seconds or less");
    var dampingRatio = 1 - bounce;
    dampingRatio = clamp_clamp(minDamping, maxDamping, dampingRatio);
    duration = clamp_clamp(minDuration, maxDuration, duration / 1000);
    if (dampingRatio < 1) {
        envelope = function (undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var a = exponentialDecay - velocity;
            var b = calcAngularFreq(undampedFreq, dampingRatio);
            var c = Math.exp(-delta);
            return safeMin - (a / b) * c;
        };
        derivative = function (undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var d = delta * velocity + velocity;
            var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            var f = Math.exp(-delta);
            var g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            var factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return (factor * ((d - e) * f)) / g;
        };
    }
    else {
        envelope = function (undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = function (undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    var initialGuess = 5 / duration;
    var undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) {
        return {
            stiffness: 100,
            damping: 10,
            duration: duration,
        };
    }
    else {
        var stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration,
        };
    }
}
var rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    var result = initialGuess;
    for (var i = 1; i < rootIterations; i++) {
        result = result - envelope(result) / derivative(result);
    }
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/generators/spring.js



var durationKeys = ["duration", "bounce"];
var physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
    return keys.some(function (key) { return options[key] !== undefined; });
}
function getSpringOptions(options) {
    var springOptions = tslib_es6_assign({ velocity: 0.0, stiffness: 100, damping: 10, mass: 1.0, isResolvedFromDuration: false }, options);
    if (!isSpringType(options, physicsKeys) &&
        isSpringType(options, durationKeys)) {
        var derived = findSpring(options);
        springOptions = tslib_es6_assign(tslib_es6_assign(tslib_es6_assign({}, springOptions), derived), { velocity: 0.0, mass: 1.0 });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function spring(_a) {
    var _b = _a.from, from = _b === void 0 ? 0.0 : _b, _c = _a.to, to = _c === void 0 ? 1.0 : _c, _d = _a.restSpeed, restSpeed = _d === void 0 ? 2 : _d, restDelta = _a.restDelta, options = tslib_es6_rest(_a, ["from", "to", "restSpeed", "restDelta"]);
    var state = { done: false, value: from };
    var _e = getSpringOptions(options), stiffness = _e.stiffness, damping = _e.damping, mass = _e.mass, velocity = _e.velocity, duration = _e.duration, isResolvedFromDuration = _e.isResolvedFromDuration;
    var resolveSpring = zero;
    var resolveVelocity = zero;
    function createSpring() {
        var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        var initialDelta = to - from;
        var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        var undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        restDelta !== null && restDelta !== void 0 ? restDelta : (restDelta = Math.abs(to - from) <= 1 ? 0.01 : 0.4);
        if (dampingRatio < 1) {
            var angularFreq_1 = calcAngularFreq(undampedAngularFreq, dampingRatio);
            resolveSpring = function (t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return (to -
                    envelope *
                        (((initialVelocity +
                            dampingRatio * undampedAngularFreq * initialDelta) /
                            angularFreq_1) *
                            Math.sin(angularFreq_1 * t) +
                            initialDelta * Math.cos(angularFreq_1 * t)));
            };
            resolveVelocity = function (t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return (dampingRatio *
                    undampedAngularFreq *
                    envelope *
                    ((Math.sin(angularFreq_1 * t) *
                        (initialVelocity +
                            dampingRatio *
                                undampedAngularFreq *
                                initialDelta)) /
                        angularFreq_1 +
                        initialDelta * Math.cos(angularFreq_1 * t)) -
                    envelope *
                        (Math.cos(angularFreq_1 * t) *
                            (initialVelocity +
                                dampingRatio *
                                    undampedAngularFreq *
                                    initialDelta) -
                            angularFreq_1 *
                                initialDelta *
                                Math.sin(angularFreq_1 * t)));
            };
        }
        else if (dampingRatio === 1) {
            resolveSpring = function (t) {
                return to -
                    Math.exp(-undampedAngularFreq * t) *
                        (initialDelta +
                            (initialVelocity + undampedAngularFreq * initialDelta) *
                                t);
            };
        }
        else {
            var dampedAngularFreq_1 = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = function (t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                var freqForT = Math.min(dampedAngularFreq_1 * t, 300);
                return (to -
                    (envelope *
                        ((initialVelocity +
                            dampingRatio * undampedAngularFreq * initialDelta) *
                            Math.sinh(freqForT) +
                            dampedAngularFreq_1 *
                                initialDelta *
                                Math.cosh(freqForT))) /
                        dampedAngularFreq_1);
            };
        }
    }
    createSpring();
    return {
        next: function (t) {
            var current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                var currentVelocity = resolveVelocity(t) * 1000;
                var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                var isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done =
                    isBelowVelocityThreshold && isBelowDisplacementThreshold;
            }
            else {
                state.done = t >= duration;
            }
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: function () {
            var _a;
            velocity = -velocity;
            _a = [to, from], from = _a[0], to = _a[1];
            createSpring();
        },
    };
}
spring.needsInterpolation = function (a, b) {
    return typeof a === "string" || typeof b === "string";
};
var zero = function (_t) { return 0; };



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/progress.js
var progress = function (from, to, value) {
    var toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/mix.js
var mix = function (from, to, progress) {
    return -progress * from + progress * to + from;
};



;// CONCATENATED MODULE: ./node_modules/style-value-types/dist/es/color/utils.js


var isColorString = function (type, testProp) { return function (v) {
    return Boolean((isString(v) && singleColorRegex.test(v) && v.startsWith(type)) ||
        (testProp && Object.prototype.hasOwnProperty.call(v, testProp)));
}; };
var splitColor = function (aName, bName, cName) { return function (v) {
    var _a;
    if (!isString(v))
        return v;
    var _b = v.match(floatRegex), a = _b[0], b = _b[1], c = _b[2], alpha = _b[3];
    return _a = {},
        _a[aName] = parseFloat(a),
        _a[bName] = parseFloat(b),
        _a[cName] = parseFloat(c),
        _a.alpha = alpha !== undefined ? parseFloat(alpha) : 1,
        _a;
}; };



;// CONCATENATED MODULE: ./node_modules/style-value-types/dist/es/color/rgba.js





var clampRgbUnit = clamp(0, 255);
var rgbUnit = __assign(__assign({}, number), { transform: function (v) { return Math.round(clampRgbUnit(v)); } });
var rgba = {
    test: isColorString('rgb', 'red'),
    parse: splitColor('red', 'green', 'blue'),
    transform: function (_a) {
        var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return 'rgba(' +
            rgbUnit.transform(red) +
            ', ' +
            rgbUnit.transform(green) +
            ', ' +
            rgbUnit.transform(blue) +
            ', ' +
            sanitize(alpha.transform(alpha$1)) +
            ')';
    },
};



;// CONCATENATED MODULE: ./node_modules/style-value-types/dist/es/color/hex.js



function parseHex(v) {
    var r = '';
    var g = '';
    var b = '';
    var a = '';
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    }
    else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1,
    };
}
var hex = {
    test: isColorString('#'),
    parse: parseHex,
    transform: rgba.transform,
};



;// CONCATENATED MODULE: ./node_modules/style-value-types/dist/es/color/hsla.js





var hsla = {
    test: isColorString('hsl', 'hue'),
    parse: splitColor('hue', 'saturation', 'lightness'),
    transform: function (_a) {
        var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return ('hsla(' +
            Math.round(hue) +
            ', ' +
            percent.transform(sanitize(saturation)) +
            ', ' +
            percent.transform(sanitize(lightness)) +
            ', ' +
            sanitize(alpha.transform(alpha$1)) +
            ')');
    },
};



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/mix-color.js





var mixLinearColor = function (from, to, v) {
    var fromExpo = from * from;
    var toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
var colorTypes = [hex, rgba, hsla];
var getColorType = function (v) {
    return colorTypes.find(function (type) { return type.test(v); });
};
var notAnimatable = function (color) {
    return "'" + color + "' is not an animatable color. Use the equivalent color code instead.";
};
var mixColor = function (from, to) {
    var fromColorType = getColorType(from);
    var toColorType = getColorType(to);
    invariant(!!fromColorType, notAnimatable(from));
    invariant(!!toColorType, notAnimatable(to));
    invariant(fromColorType.transform === toColorType.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");
    var fromColor = fromColorType.parse(from);
    var toColor = toColorType.parse(to);
    var blended = tslib_es6_assign({}, fromColor);
    var mixFunc = fromColorType === hsla ? mix : mixLinearColor;
    return function (v) {
        for (var key in blended) {
            if (key !== "alpha") {
                blended[key] = mixFunc(fromColor[key], toColor[key], v);
            }
        }
        blended.alpha = mix(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};



;// CONCATENATED MODULE: ./node_modules/style-value-types/dist/es/color/index.js





var color = {
    test: function (v) { return rgba.test(v) || hex.test(v) || hsla.test(v); },
    parse: function (v) {
        if (rgba.test(v)) {
            return rgba.parse(v);
        }
        else if (hsla.test(v)) {
            return hsla.parse(v);
        }
        else {
            return hex.parse(v);
        }
    },
    transform: function (v) {
        return isString(v)
            ? v
            : v.hasOwnProperty('red')
                ? rgba.transform(v)
                : hsla.transform(v);
    },
};



;// CONCATENATED MODULE: ./node_modules/style-value-types/dist/es/complex/index.js




var colorToken = '${c}';
var numberToken = '${n}';
function test(v) {
    var _a, _b, _c, _d;
    return (isNaN(v) &&
        isString(v) &&
        ((_b = (_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match(colorRegex)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0);
}
function analyse(v) {
    var values = [];
    var numColors = 0;
    var colors = v.match(colorRegex);
    if (colors) {
        numColors = colors.length;
        v = v.replace(colorRegex, colorToken);
        values.push.apply(values, colors.map(color.parse));
    }
    var numbers = v.match(floatRegex);
    if (numbers) {
        v = v.replace(floatRegex, numberToken);
        values.push.apply(values, numbers.map(number.parse));
    }
    return { values: values, numColors: numColors, tokenised: v };
}
function parse(v) {
    return analyse(v).values;
}
function createTransformer(v) {
    var _a = analyse(v), values = _a.values, numColors = _a.numColors, tokenised = _a.tokenised;
    var numValues = values.length;
    return function (v) {
        var output = tokenised;
        for (var i = 0; i < numValues; i++) {
            output = output.replace(i < numColors ? colorToken : numberToken, i < numColors ? color.transform(v[i]) : sanitize(v[i]));
        }
        return output;
    };
}
var convertNumbersToZero = function (v) {
    return typeof v === 'number' ? 0 : v;
};
function getAnimatableNone(v) {
    var parsed = parse(v);
    var transformer = createTransformer(v);
    return transformer(parsed.map(convertNumbersToZero));
}
var complex = { test: test, parse: parse, createTransformer: createTransformer, getAnimatableNone: getAnimatableNone };



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/inc.js
var zeroPoint = {
    x: 0,
    y: 0,
    z: 0
};
var isNum = function (v) { return typeof v === 'number'; };



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/mix-complex.js








function getMixer(origin, target) {
    if (isNum(origin)) {
        return function (v) { return mix(origin, target, v); };
    }
    else if (color.test(origin)) {
        return mixColor(origin, target);
    }
    else {
        return mixComplex(origin, target);
    }
}
var mixArray = function (from, to) {
    var output = tslib_tslib_es6_spreadArray([], from);
    var numValues = output.length;
    var blendValue = from.map(function (fromThis, i) { return getMixer(fromThis, to[i]); });
    return function (v) {
        for (var i = 0; i < numValues; i++) {
            output[i] = blendValue[i](v);
        }
        return output;
    };
};
var mixObject = function (origin, target) {
    var output = tslib_es6_assign(tslib_es6_assign({}, origin), target);
    var blendValue = {};
    for (var key in output) {
        if (origin[key] !== undefined && target[key] !== undefined) {
            blendValue[key] = getMixer(origin[key], target[key]);
        }
    }
    return function (v) {
        for (var key in blendValue) {
            output[key] = blendValue[key](v);
        }
        return output;
    };
};
function mix_complex_analyse(value) {
    var parsed = complex.parse(value);
    var numValues = parsed.length;
    var numNumbers = 0;
    var numRGB = 0;
    var numHSL = 0;
    for (var i = 0; i < numValues; i++) {
        if (numNumbers || typeof parsed[i] === "number") {
            numNumbers++;
        }
        else {
            if (parsed[i].hue !== undefined) {
                numHSL++;
            }
            else {
                numRGB++;
            }
        }
    }
    return { parsed: parsed, numNumbers: numNumbers, numRGB: numRGB, numHSL: numHSL };
}
var mixComplex = function (origin, target) {
    var template = complex.createTransformer(target);
    var originStats = mix_complex_analyse(origin);
    var targetStats = mix_complex_analyse(target);
    invariant(originStats.numHSL === targetStats.numHSL &&
        originStats.numRGB === targetStats.numRGB &&
        originStats.numNumbers >= targetStats.numNumbers, "Complex values '" + origin + "' and '" + target + "' too different to mix. Ensure all colors are of the same type.");
    return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
};



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/interpolate.js









var mixNumber = function (from, to) { return function (p) { return mix(from, to, p); }; };
function detectMixerFactory(v) {
    if (typeof v === 'number') {
        return mixNumber;
    }
    else if (typeof v === 'string') {
        if (color.test(v)) {
            return mixColor;
        }
        else {
            return mixComplex;
        }
    }
    else if (Array.isArray(v)) {
        return mixArray;
    }
    else if (typeof v === 'object') {
        return mixObject;
    }
}
function createMixers(output, ease, customMixer) {
    var mixers = [];
    var mixerFactory = customMixer || detectMixerFactory(output[0]);
    var numMixers = output.length - 1;
    for (var i = 0; i < numMixers; i++) {
        var mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = pipe(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function fastInterpolate(_a, _b) {
    var from = _a[0], to = _a[1];
    var mixer = _b[0];
    return function (v) { return mixer(progress(from, to, v)); };
}
function slowInterpolate(input, mixers) {
    var inputLength = input.length;
    var lastInputIndex = inputLength - 1;
    return function (v) {
        var mixerIndex = 0;
        var foundMixerIndex = false;
        if (v <= input[0]) {
            foundMixerIndex = true;
        }
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            var i = 1;
            for (; i < inputLength; i++) {
                if (input[i] > v || i === lastInputIndex) {
                    break;
                }
            }
            mixerIndex = i - 1;
        }
        var progressInRange = progress(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function interpolate(input, output, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.clamp, isClamp = _c === void 0 ? true : _c, ease = _b.ease, mixer = _b.mixer;
    var inputLength = input.length;
    invariant(inputLength === output.length, 'Both input and output ranges must be the same length');
    invariant(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, 'Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.');
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    var mixers = createMixers(output, ease, mixer);
    var interpolator = inputLength === 2
        ? fastInterpolate(input, mixers)
        : slowInterpolate(input, mixers);
    return isClamp
        ? function (v) { return interpolator(clamp_clamp(input[0], input[inputLength - 1], v)); }
        : interpolator;
}



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/easing/utils.js
var reverseEasing = function (easing) { return function (p) { return 1 - easing(1 - p); }; };
var mirrorEasing = function (easing) { return function (p) {
    return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
}; };
var createExpoIn = function (power) { return function (p) { return Math.pow(p, power); }; };
var createBackIn = function (power) { return function (p) {
    return p * p * ((power + 1) * p - power);
}; };
var createAnticipate = function (power) {
    var backEasing = createBackIn(power);
    return function (p) {
        return (p *= 2) < 1
            ? 0.5 * backEasing(p)
            : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
    };
};



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/easing/index.js


var DEFAULT_OVERSHOOT_STRENGTH = 1.525;
var BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
var BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
var BOUNCE_THIRD_THRESHOLD = 9.0 / 10.0;
var linear = function (p) { return p; };
var easeIn = createExpoIn(2);
var easeOut = reverseEasing(easeIn);
var easeInOut = mirrorEasing(easeIn);
var circIn = function (p) { return 1 - Math.sin(Math.acos(p)); };
var circOut = reverseEasing(circIn);
var circInOut = mirrorEasing(circOut);
var backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
var backOut = reverseEasing(backIn);
var backInOut = mirrorEasing(backIn);
var anticipate = createAnticipate(DEFAULT_OVERSHOOT_STRENGTH);
var ca = 4356.0 / 361.0;
var cb = 35442.0 / 1805.0;
var cc = 16061.0 / 1805.0;
var bounceOut = function (p) {
    if (p === 1 || p === 0)
        return p;
    var p2 = p * p;
    return p < BOUNCE_FIRST_THRESHOLD
        ? 7.5625 * p2
        : p < BOUNCE_SECOND_THRESHOLD
            ? 9.075 * p2 - 9.9 * p + 3.4
            : p < BOUNCE_THIRD_THRESHOLD
                ? ca * p2 - cb * p + cc
                : 10.8 * p * p - 20.52 * p + 10.72;
};
var bounceIn = reverseEasing(bounceOut);
var bounceInOut = function (p) {
    return p < 0.5
        ? 0.5 * (1.0 - bounceOut(1.0 - p * 2.0))
        : 0.5 * bounceOut(p * 2.0 - 1.0) + 0.5;
};



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/generators/keyframes.js



function defaultEasing(values, easing) {
    return values.map(function () { return easing || easeInOut; }).splice(0, values.length - 1);
}
function defaultOffset(values) {
    var numValues = values.length;
    return values.map(function (_value, i) {
        return i !== 0 ? i / (numValues - 1) : 0;
    });
}
function convertOffsetToTimes(offset, duration) {
    return offset.map(function (o) { return o * duration; });
}
function keyframes(_a) {
    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.to, to = _c === void 0 ? 1 : _c, ease = _a.ease, offset = _a.offset, _d = _a.duration, duration = _d === void 0 ? 300 : _d;
    var state = { done: false, value: from };
    var values = Array.isArray(to) ? to : [from, to];
    var times = convertOffsetToTimes(offset && offset.length === values.length
        ? offset
        : defaultOffset(values), duration);
    function createInterpolator() {
        return interpolate(times, values, {
            ease: Array.isArray(ease) ? ease : defaultEasing(values, ease),
        });
    }
    var interpolator = createInterpolator();
    return {
        next: function (t) {
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: function () {
            values.reverse();
            interpolator = createInterpolator();
        },
    };
}



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/generators/decay.js
function decay(_a) {
    var _b = _a.velocity, velocity = _b === void 0 ? 0 : _b, _c = _a.from, from = _c === void 0 ? 0 : _c, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 350 : _e, _f = _a.restDelta, restDelta = _f === void 0 ? 0.5 : _f, modifyTarget = _a.modifyTarget;
    var state = { done: false, value: from };
    var amplitude = power * velocity;
    var ideal = from + amplitude;
    var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal)
        amplitude = target - from;
    return {
        next: function (t) {
            var delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: function () { },
    };
}



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/utils/detect-animation-from-options.js




var types = { keyframes: keyframes, spring: spring, decay: decay };
function detectAnimationFromOptions(config) {
    if (Array.isArray(config.to)) {
        return keyframes;
    }
    else if (types[config.type]) {
        return types[config.type];
    }
    var keys = new Set(Object.keys(config));
    if (keys.has("ease") ||
        (keys.has("duration") && !keys.has("dampingRatio"))) {
        return keyframes;
    }
    else if (keys.has("dampingRatio") ||
        keys.has("stiffness") ||
        keys.has("mass") ||
        keys.has("damping") ||
        keys.has("restSpeed") ||
        keys.has("restDelta")) {
        return spring;
    }
    return keyframes;
}



// EXTERNAL MODULE: ./node_modules/framesync/dist/es/index.js + 2 modules
var es = __webpack_require__(26765);
;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/utils/elapsed.js
function loopElapsed(elapsed, duration, delay) {
    if (delay === void 0) { delay = 0; }
    return elapsed - duration - delay;
}
function reverseElapsed(elapsed, duration, delay, isForwardPlayback) {
    if (delay === void 0) { delay = 0; }
    if (isForwardPlayback === void 0) { isForwardPlayback = true; }
    return isForwardPlayback
        ? loopElapsed(duration + -elapsed, duration, delay)
        : duration - (elapsed - duration) + delay;
}
function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/index.js






var framesync = function (update) {
    var passTimestamp = function (_a) {
        var delta = _a.delta;
        return update(delta);
    };
    return {
        start: function () { return es/* default.update */.ZP.update(passTimestamp, true); },
        stop: function () { return es/* cancelSync.update */.qY.update(passTimestamp); },
    };
};
function animate(_a) {
    var _b, _c;
    var from = _a.from, _d = _a.autoplay, autoplay = _d === void 0 ? true : _d, _e = _a.driver, driver = _e === void 0 ? framesync : _e, _f = _a.elapsed, elapsed = _f === void 0 ? 0 : _f, _g = _a.repeat, repeatMax = _g === void 0 ? 0 : _g, _h = _a.repeatType, repeatType = _h === void 0 ? "loop" : _h, _j = _a.repeatDelay, repeatDelay = _j === void 0 ? 0 : _j, onPlay = _a.onPlay, onStop = _a.onStop, onComplete = _a.onComplete, onRepeat = _a.onRepeat, onUpdate = _a.onUpdate, options = tslib_es6_rest(_a, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
    var to = options.to;
    var driverControls;
    var repeatCount = 0;
    var computedDuration = options.duration;
    var latest;
    var isComplete = false;
    var isForwardPlayback = true;
    var interpolateFromNumber;
    var animator = detectAnimationFromOptions(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = interpolate([0, 100], [from, to], {
            clamp: false,
        });
        from = 0;
        to = 100;
    }
    var animation = animator(tslib_es6_assign(tslib_es6_assign({}, options), { from: from, to: to }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        }
        else {
            elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror")
                animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback)
            delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            var state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber)
                latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0)
                computedDuration !== null && computedDuration !== void 0 ? computedDuration : (computedDuration = elapsed);
            if (repeatCount < repeatMax) {
                hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            }
            else {
                complete();
            }
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 ? void 0 : onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: function () {
            onStop === null || onStop === void 0 ? void 0 : onStop();
            driverControls.stop();
        },
    };
}



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/velocity-per-second.js
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/inertia.js





function inertia(_a) {
    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.velocity, velocity = _c === void 0 ? 0 : _c, min = _a.min, max = _a.max, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 750 : _e, _f = _a.bounceStiffness, bounceStiffness = _f === void 0 ? 500 : _f, _g = _a.bounceDamping, bounceDamping = _g === void 0 ? 10 : _g, _h = _a.restDelta, restDelta = _h === void 0 ? 1 : _h, modifyTarget = _a.modifyTarget, driver = _a.driver, onUpdate = _a.onUpdate, onComplete = _a.onComplete;
    var currentAnimation;
    function isOutOfBounds(v) {
        return (min !== undefined && v < min) || (max !== undefined && v > max);
    }
    function boundaryNearest(v) {
        if (min === undefined)
            return max;
        if (max === undefined)
            return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
        currentAnimation = animate(tslib_es6_assign(tslib_es6_assign({}, options), { driver: driver, onUpdate: function (v) {
                var _a;
                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, v);
            }, onComplete: onComplete }));
    }
    function startSpring(options) {
        startAnimation(tslib_es6_assign({ type: "spring", stiffness: bounceStiffness, damping: bounceDamping, restDelta: restDelta }, options));
    }
    if (isOutOfBounds(from)) {
        startSpring({ from: from, velocity: velocity, to: boundaryNearest(from) });
    }
    else {
        var target = power * velocity + from;
        if (typeof modifyTarget !== "undefined")
            target = modifyTarget(target);
        var boundary_1 = boundaryNearest(target);
        var heading_1 = boundary_1 === min ? -1 : 1;
        var prev_1;
        var current_1;
        var checkBoundary = function (v) {
            prev_1 = current_1;
            current_1 = v;
            velocity = velocityPerSecond(v - prev_1, (0,es/* getFrameData */.$B)().delta);
            if ((heading_1 === 1 && v > boundary_1) ||
                (heading_1 === -1 && v < boundary_1)) {
                startSpring({ from: v, to: boundary_1, velocity: velocity });
            }
        };
        startAnimation({
            type: "decay",
            from: from,
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined,
        });
    }
    return {
        stop: function () { return currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop(); },
    };
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/time-conversion.js
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
var secondsToMilliseconds = function (seconds) { return seconds * 1000; };



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/easing/cubic-bezier.js


var a = function (a1, a2) { return 1.0 - 3.0 * a2 + 3.0 * a1; };
var b = function (a1, a2) { return 3.0 * a2 - 6.0 * a1; };
var c = function (a1) { return 3.0 * a1; };
var calcBezier = function (t, a1, a2) {
    return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
};
var getSlope = function (t, a1, a2) {
    return 3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1);
};
var subdivisionPrecision = 0.0000001;
var subdivisionMaxIterations = 10;
function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX;
    var currentT;
    var i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) {
            aB = currentT;
        }
        else {
            aA = currentT;
        }
    } while (Math.abs(currentX) > subdivisionPrecision &&
        ++i < subdivisionMaxIterations);
    return currentT;
}
var newtonIterations = 8;
var newtonMinSlope = 0.001;
function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < newtonIterations; ++i) {
        var currentSlope = getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) {
            return aGuessT;
        }
        var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
function cubicBezier(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2)
        return linear;
    var sampleValues = new Float32Array(kSplineTableSize);
    for (var i = 0; i < kSplineTableSize; ++i) {
        sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
    function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = kSplineTableSize - 1;
        for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
            intervalStart += kSampleStepSize;
        }
        --currentSample;
        var dist = (aX - sampleValues[currentSample]) /
            (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * kSampleStepSize;
        var initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= newtonMinSlope) {
            return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        }
        else if (initialSlope === 0.0) {
            return guessForT;
        }
        else {
            return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
        }
    }
    return function (t) {
        return t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
    };
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/utils/easing.js




var easingLookup = {
    linear: linear,
    easeIn: easeIn,
    easeInOut: easeInOut,
    easeOut: easeOut,
    circIn: circIn,
    circInOut: circInOut,
    circOut: circOut,
    backIn: backIn,
    backInOut: backInOut,
    backOut: backOut,
    anticipate: anticipate,
    bounceIn: bounceIn,
    bounceInOut: bounceInOut,
    bounceOut: bounceOut,
};
var easingDefinitionToFunction = function (definition) {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        invariant(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = (0,tslib_es6/* __read */.CR)(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return cubicBezier(x1, y1, x2, y2);
    }
    else if (typeof definition === "string") {
        // Else lookup from table
        invariant(easingLookup[definition] !== undefined, "Invalid easing type '" + definition + "'");
        return easingLookup[definition];
    }
    return definition;
};
var isEasingArray = function (ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/utils/is-animatable.js


/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */
var isAnimatable = function (key, value) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex")
        return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value))
        return true;
    if (typeof value === "string" && // It's animatable if we have a string
        complex.test(value) && // And it contains numbers and/or colors
        !value.startsWith("url(") // Unless it starts with "url("
    ) {
        return true;
    }
    return false;
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/utils/default-transitions.js



var underDampedSpring = function () { return ({
    type: "spring",
    stiffness: 500,
    damping: 25,
    restDelta: 0.5,
    restSpeed: 10,
}); };
var criticallyDampedSpring = function (to) { return ({
    type: "spring",
    stiffness: 550,
    damping: to === 0 ? 2 * Math.sqrt(550) : 30,
    restDelta: 0.01,
    restSpeed: 10,
}); };
var linearTween = function () { return ({
    type: "keyframes",
    ease: "linear",
    duration: 0.3,
}); };
var default_transitions_keyframes = function (values) { return ({
    type: "keyframes",
    duration: 0.8,
    values: values,
}); };
var defaultTransitions = {
    x: underDampedSpring,
    y: underDampedSpring,
    z: underDampedSpring,
    rotate: underDampedSpring,
    rotateX: underDampedSpring,
    rotateY: underDampedSpring,
    rotateZ: underDampedSpring,
    scaleX: criticallyDampedSpring,
    scaleY: criticallyDampedSpring,
    scale: criticallyDampedSpring,
    opacity: linearTween,
    backgroundColor: linearTween,
    color: linearTween,
    default: criticallyDampedSpring,
};
var getDefaultTransition = function (valueKey, to) {
    var transitionFactory;
    if (isKeyframesTarget(to)) {
        transitionFactory = default_transitions_keyframes;
    }
    else {
        transitionFactory =
            defaultTransitions[valueKey] || defaultTransitions.default;
    }
    return (0,tslib_es6/* __assign */.pi)({ to: to }, transitionFactory(to));
};



;// CONCATENATED MODULE: ./node_modules/style-value-types/dist/es/complex/filter.js




var maxDefaults = new Set(['brightness', 'contrast', 'saturate', 'opacity']);
function applyDefaultFilter(v) {
    var _a = v.slice(0, -1).split('('), name = _a[0], value = _a[1];
    if (name === 'drop-shadow')
        return v;
    var number = (value.match(floatRegex) || [])[0];
    if (!number)
        return v;
    var unit = value.replace(number, '');
    var defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value)
        defaultValue *= 100;
    return name + '(' + defaultValue + unit + ')';
}
var functionRegex = /([a-z-]*)\(.*?\)/g;
var filter = __assign(__assign({}, complex), { getAnimatableNone: function (v) {
        var functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(' ') : v;
    } });



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/defaults.js




/**
 * A map of default value types for common values
 */
var defaultValueTypes = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, numberValueTypes), { 
    // Color props
    color: color, backgroundColor: color, outlineColor: color, fill: color, stroke: color, 
    // Border props
    borderColor: color, borderTopColor: color, borderRightColor: color, borderBottomColor: color, borderLeftColor: color, filter: filter, WebkitFilter: filter });
/**
 * Gets the default ValueType for the provided value key
 */
var getDefaultValueType = function (key) { return defaultValueTypes[key]; };



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/animatable-none.js



function animatable_none_getAnimatableNone(key, value) {
    var _a;
    var defaultValueType = getDefaultValueType(key);
    if (defaultValueType !== filter)
        defaultValueType = complex;
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/utils/transitions.js









/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */
function isTransitionDefined(_a) {
    _a.when; _a.delay; _a.delayChildren; _a.staggerChildren; _a.staggerDirection; _a.repeat; _a.repeatType; _a.repeatDelay; _a.from; var transition = (0,tslib_es6/* __rest */._T)(_a, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
    return !!Object.keys(transition).length;
}
var legacyRepeatWarning = false;
/**
 * Convert Framer Motion's Transition type into Popmotion-compatible options.
 */
function convertTransitionToAnimationOptions(_a) {
    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = (0,tslib_es6/* __rest */._T)(_a, ["ease", "times", "yoyo", "flip", "loop"]);
    var options = (0,tslib_es6/* __assign */.pi)({}, transition);
    if (times)
        options["offset"] = times;
    /**
     * Convert any existing durations from seconds to milliseconds
     */
    if (transition.duration)
        options["duration"] = secondsToMilliseconds(transition.duration);
    if (transition.repeatDelay)
        options.repeatDelay = secondsToMilliseconds(transition.repeatDelay);
    /**
     * Map easing names to Popmotion's easing functions
     */
    if (ease) {
        options["ease"] = isEasingArray(ease)
            ? ease.map(easingDefinitionToFunction)
            : easingDefinitionToFunction(ease);
    }
    /**
     * Support legacy transition API
     */
    if (transition.type === "tween")
        options.type = "keyframes";
    /**
     * TODO: These options are officially removed from the API.
     */
    if (yoyo || loop || flip) {
        warning(!legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        legacyRepeatWarning = true;
        if (yoyo) {
            options.repeatType = "reverse";
        }
        else if (loop) {
            options.repeatType = "loop";
        }
        else if (flip) {
            options.repeatType = "mirror";
        }
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    /**
     * TODO: Popmotion 9 has the ability to automatically detect whether to use
     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
     * It'd be good to introduce a similar thing here.
     */
    if (transition.type !== "spring")
        options.type = "keyframes";
    return options;
}
/**
 * Get the delay for a value by checking Transition with decreasing specificity.
 */
function getDelayFromTransition(transition, key) {
    var _a;
    var valueTransition = getValueTransition(transition, key) || {};
    return (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : 0;
}
function hydrateKeyframes(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(options.to));
        options.to[0] = options.from;
    }
    return options;
}
function getPopmotionAnimationOptions(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) {
        (_a = transition.duration) !== null && _a !== void 0 ? _a : (transition.duration = 0.8);
    }
    hydrateKeyframes(options);
    /**
     * Get a default transition if none is determined to be defined.
     */
    if (!isTransitionDefined(transition)) {
        transition = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, transition), getDefaultTransition(key, options.to));
    }
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), convertTransitionToAnimationOptions(transition));
}
/**
 *
 */
function getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = getValueTransition(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = isAnimatable(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") {
        /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */
        origin = animatable_none_getAnimatableNone(key, target);
    }
    else if (isZero(origin) && typeof target === "string") {
        origin = getZeroUnit(target);
    }
    else if (!Array.isArray(target) &&
        isZero(target) &&
        typeof origin === "string") {
        target = getZeroUnit(origin);
    }
    var isOriginAnimatable = isAnimatable(key, origin);
    warning(isOriginAnimatable === isTargetAnimatable, "You are trying to animate " + key + " from \"" + origin + "\" to \"" + target + "\". " + origin + " is not an animatable value - to enable this animation set " + origin + " to a value animatable to " + target + " via the `style` property.");
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function (v) { return value.set(v); },
        };
        return valueTransition.type === "inertia" ||
            valueTransition.type === "decay"
            ? inertia((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), valueTransition))
            : animate((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, getPopmotionAnimationOptions(valueTransition, options, key)), { onUpdate: function (v) {
                    var _a;
                    options.onUpdate(v);
                    (_a = valueTransition.onUpdate) === null || _a === void 0 ? void 0 : _a.call(valueTransition, v);
                }, onComplete: function () {
                    var _a;
                    options.onComplete();
                    (_a = valueTransition.onComplete) === null || _a === void 0 ? void 0 : _a.call(valueTransition);
                } }));
    }
    function set() {
        var _a;
        value.set(target);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _a === void 0 ? void 0 : _a.call(valueTransition);
        return { stop: function () { } };
    }
    return !isOriginAnimatable ||
        !isTargetAnimatable ||
        valueTransition.type === false
        ? set
        : start;
}
function isZero(value) {
    return (value === 0 ||
        (typeof value === "string" &&
            parseFloat(value) === 0 &&
            value.indexOf(" ") === -1));
}
function getZeroUnit(potentialUnitType) {
    return typeof potentialUnitType === "number"
        ? 0
        : animatable_none_getAnimatableNone("", potentialUnitType);
}
function getValueTransition(transition, key) {
    return transition[key] || transition["default"] || transition;
}
/**
 * Start animation on a MotionValue. This function is an interface between
 * Framer Motion and Popmotion
 *
 * @internal
 */
function startAnimation(key, value, target, transition) {
    if (transition === void 0) { transition = {}; }
    return value.start(function (onComplete) {
        var delayTimer;
        var controls;
        var animation = getAnimation(key, value, target, transition, onComplete);
        var delay = getDelayFromTransition(transition, key);
        var start = function () { return (controls = animation()); };
        if (delay) {
            delayTimer = setTimeout(start, secondsToMilliseconds(delay));
        }
        else {
            start();
        }
        return function () {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 ? void 0 : controls.stop();
        };
    });
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/is-numerical-string.js
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
var isNumericalString = function (v) { return /^\-?\d*\.?\d+$/.test(v); };



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/array.js
function addUniqueItem(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function removeItem(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/subscription-manager.js


var SubscriptionManager = /** @class */ (function () {
    function SubscriptionManager() {
        this.subscriptions = [];
    }
    SubscriptionManager.prototype.add = function (handler) {
        var _this = this;
        addUniqueItem(this.subscriptions, handler);
        return function () { return removeItem(_this.subscriptions, handler); };
    };
    SubscriptionManager.prototype.notify = function (a, b, c) {
        var numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions)
            return;
        if (numSubscriptions === 1) {
            /**
             * If there's only a single handler we can just call it without invoking a loop.
             */
            this.subscriptions[0](a, b, c);
        }
        else {
            for (var i = 0; i < numSubscriptions; i++) {
                /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */
                var handler = this.subscriptions[i];
                handler && handler(a, b, c);
            }
        }
    };
    SubscriptionManager.prototype.getSize = function () {
        return this.subscriptions.length;
    };
    SubscriptionManager.prototype.clear = function () {
        this.subscriptions.length = 0;
    };
    return SubscriptionManager;
}());



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/index.js




var isFloat = function (value) {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */
var MotionValue = /** @class */ (function () {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */
    function MotionValue(init) {
        var _this = this;
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */
        this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */
        this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */
        this.updateSubscribers = new SubscriptionManager();
        /**
         * Functions to notify when the velocity updates.
         *
         * @internal
         */
        this.velocityUpdateSubscribers = new SubscriptionManager();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */
        this.renderSubscribers = new SubscriptionManager();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */
        this.canTrackVelocity = false;
        this.updateAndNotify = function (v, render) {
            if (render === void 0) { render = true; }
            _this.prev = _this.current;
            _this.current = v;
            // Update timestamp
            var _a = (0,es/* getFrameData */.$B)(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                es/* default.postRender */.ZP.postRender(_this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (_this.prev !== _this.current) {
                _this.updateSubscribers.notify(_this.current);
            }
            // Update velocity subscribers
            if (_this.velocityUpdateSubscribers.getSize()) {
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
            // Update render subscribers
            if (render) {
                _this.renderSubscribers.notify(_this.current);
            }
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.scheduleVelocityCheck = function () { return es/* default.postRender */.ZP.postRender(_this.velocityCheck); };
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.velocityCheck = function (_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * @library
     *
     * ```jsx
     * function MyComponent() {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <Frame x={x} />
     * }
     * ```
     *
     * @motion
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @internalremarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */
    MotionValue.prototype.onChange = function (subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function () {
        this.updateSubscribers.clear();
    };
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */
    MotionValue.prototype.onRenderRequest = function (subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */
    MotionValue.prototype.attach = function (passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */
    MotionValue.prototype.set = function (v, render) {
        if (render === void 0) { render = true; }
        if (!render || !this.passiveEffect) {
            this.updateAndNotify(v, render);
        }
        else {
            this.passiveEffect(v, this.updateAndNotify);
        }
    };
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */
    MotionValue.prototype.get = function () {
        return this.current;
    };
    /**
     * @public
     */
    MotionValue.prototype.getPrevious = function () {
        return this.prev;
    };
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */
    MotionValue.prototype.getVelocity = function () {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity
            ? // These casts could be avoided if parseFloat would be typed better
                velocityPerSecond(parseFloat(this.current) -
                    parseFloat(this.prev), this.timeDelta)
            : 0;
    };
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */
    MotionValue.prototype.start = function (animation) {
        var _this = this;
        this.stop();
        return new Promise(function (resolve) {
            _this.hasAnimated = true;
            _this.stopAnimation = animation(resolve);
        }).then(function () { return _this.clearAnimation(); });
    };
    /**
     * Stop the currently active animation.
     *
     * @public
     */
    MotionValue.prototype.stop = function () {
        if (this.stopAnimation)
            this.stopAnimation();
        this.clearAnimation();
    };
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */
    MotionValue.prototype.isAnimating = function () {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function () {
        this.stopAnimation = null;
    };
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */
    MotionValue.prototype.destroy = function () {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}());
/**
 * @internal
 */
function motionValue(init) {
    return new MotionValue(init);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/test.js
/**
 * Tests a provided value against a ValueType
 */
var testValueType = function (v) { return function (type) { return type.test(v); }; };



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/type-auto.js
/**
 * ValueType for "auto"
 */
var auto = {
    test: function (v) { return v === "auto"; },
    parse: function (v) { return v; },
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/dimensions.js




/**
 * A list of value types commonly used for dimensions
 */
var dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
var findDimensionValueType = function (v) {
    return dimensionValueTypes.find(testValueType(v));
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/find.js





/**
 * A list of all ValueTypes
 */
var valueTypes = (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(dimensionValueTypes)), [color, complex]);
/**
 * Tests a value against the list of ValueTypes
 */
var findValueType = function (v) { return valueTypes.find(testValueType(v)); };



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/setters.js









/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */
function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) {
        visualElement.getValue(key).set(value);
    }
    else {
        visualElement.addValue(key, motionValue(value));
    }
}
function setTarget(visualElement, definition) {
    var resolved = resolveVariant(visualElement, definition);
    var _a = resolved
        ? visualElement.makeTargetAnimatable(resolved, false)
        : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b; _a.transition; var target = (0,tslib_es6/* __rest */._T)(_a, ["transitionEnd", "transition"]);
    target = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, target), transitionEnd);
    for (var key in target) {
        var value = resolveFinalValueInKeyframes(target[key]);
        setMotionValue(visualElement, key, value);
    }
}
function setVariants(visualElement, variantLabels) {
    var reversedLabels = __spreadArray([], __read(variantLabels)).reverse();
    reversedLabels.forEach(function (key) {
        var _a;
        var variant = visualElement.getVariant(key);
        variant && setTarget(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
            setVariants(child, variantLabels);
        });
    });
}
function setValues(visualElement, definition) {
    if (Array.isArray(definition)) {
        return setVariants(visualElement, definition);
    }
    else if (typeof definition === "string") {
        return setVariants(visualElement, [definition]);
    }
    else {
        setTarget(visualElement, definition);
    }
}
function checkTargetForNewValues(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    var newValueKeys = Object.keys(target).filter(function (key) { return !visualElement.hasValue(key); });
    var numNewValues = newValueKeys.length;
    if (!numNewValues)
        return;
    for (var i = 0; i < numNewValues; i++) {
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */
        if (Array.isArray(targetValue)) {
            value = targetValue[0];
        }
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */
        if (value === null) {
            value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        }
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */
        if (value === undefined || value === null)
            continue;
        if (typeof value === "string" && isNumericalString(value)) {
            // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
        }
        else if (!findValueType(value) && complex.test(targetValue)) {
            value = animatable_none_getAnimatableNone(key, targetValue);
        }
        visualElement.addValue(key, motionValue(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : (_d[key] = value);
        visualElement.setBaseTarget(key, value);
    }
}
function getOriginFromTransition(key, transition) {
    if (!transition)
        return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for (var key in target) {
        origin[key] =
            (_a = getOriginFromTransition(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    }
    return origin;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/animation.js





/**
 * @internal
 */
function animateVisualElement(visualElement, definition, options) {
    if (options === void 0) { options = {}; }
    visualElement.notifyAnimationStart();
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function (variant) {
            return animateVariant(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    }
    else if (typeof definition === "string") {
        animation = animateVariant(visualElement, definition, options);
    }
    else {
        var resolvedDefinition = typeof definition === "function"
            ? resolveVariant(visualElement, definition, options.custom)
            : definition;
        animation = animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(function () {
        return visualElement.notifyAnimationComplete(definition);
    });
}
function animateVariant(visualElement, variant, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var resolved = resolveVariant(visualElement, variant, options.custom);
    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
    if (options.transitionOverride) {
        transition = options.transitionOverride;
    }
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    var getAnimation = resolved
        ? function () { return animateTarget(visualElement, resolved, options); }
        : function () { return Promise.resolve(); };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size)
        ? function (forwardDelay) {
            if (forwardDelay === void 0) { forwardDelay = 0; }
            var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
            return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
        }
        : function () { return Promise.resolve(); };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */
    var when = transition.when;
    if (when) {
        var _c = (0,tslib_es6/* __read */.CR)(when === "beforeChildren"
            ? [getAnimation, getChildAnimations]
            : [getChildAnimations, getAnimation], 2), first = _c[0], last = _c[1];
        return first().then(last);
    }
    else {
        return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
    }
}
/**
 * @internal
 */
function animateTarget(visualElement, definition, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = (0,tslib_es6/* __rest */._T)(_e, ["transition", "transitionEnd"]);
    if (transitionOverride)
        transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
    for (var key in target) {
        var value = visualElement.getValue(key);
        var valueTarget = target[key];
        if (!value ||
            valueTarget === undefined ||
            (animationTypeState &&
                shouldBlockAnimation(animationTypeState, key))) {
            continue;
        }
        var animation = startAnimation(key, value, valueTarget, (0,tslib_es6/* __assign */.pi)({ delay: delay }, transition));
        animations.push(animation);
    }
    return Promise.all(animations).then(function () {
        transitionEnd && setTarget(visualElement, transitionEnd);
    });
}
function animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
    if (delayChildren === void 0) { delayChildren = 0; }
    if (staggerChildren === void 0) { staggerChildren = 0; }
    if (staggerDirection === void 0) { staggerDirection = 1; }
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1
        ? function (i) {
            if (i === void 0) { i = 0; }
            return i * staggerChildren;
        }
        : function (i) {
            if (i === void 0) { i = 0; }
            return maxStaggerDuration - i * staggerChildren;
        };
    Array.from(visualElement.variantChildren)
        .sort(sortByTreeOrder)
        .forEach(function (child, i) {
        animations.push(animateVariant(child, variant, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { delay: delayChildren + generateStaggerDuration(i) })).then(function () { return child.notifyAnimationComplete(variant); }));
    });
    return Promise.all(animations);
}
function stopAnimation(visualElement) {
    visualElement.forEachValue(function (value) { return value.stop(); });
}
function sortByTreeOrder(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */
function shouldBlockAnimation(_a, key) {
    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/animation-state.js








var variantPriorityOrder = [
    AnimationType.Animate,
    AnimationType.Hover,
    AnimationType.Tap,
    AnimationType.Drag,
    AnimationType.Focus,
    AnimationType.Exit,
];
var reversePriorityOrder = (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(variantPriorityOrder)).reverse();
var numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
    return function (animations) {
        return Promise.all(animations.map(function (_a) {
            var animation = _a.animation, options = _a.options;
            return animateVisualElement(visualElement, animation, options);
        }));
    };
}
function createAnimationState(visualElement) {
    var animate = animateList(visualElement);
    var state = createState();
    var allAnimatedKeys = {};
    var isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */
    var buildResolvedTypeValues = function (acc, definition) {
        var resolved = resolveVariant(visualElement, definition);
        if (resolved) {
            resolved.transition; var transitionEnd = resolved.transitionEnd, target = (0,tslib_es6/* __rest */._T)(resolved, ["transition", "transitionEnd"]);
            acc = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, acc), target), transitionEnd);
        }
        return acc;
    };
    function isAnimated(key) {
        return allAnimatedKeys[key] !== undefined;
    }
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */
    function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */
    function animateChanges(options, changedActiveType) {
        var _a;
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */
        var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */
        var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */
        var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */
        var removedVariantIndex = Infinity;
        var _loop_1 = function (i) {
            var type = reversePriorityOrder[i];
            var typeState = state[type];
            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            var propIsVariant = isVariantLabel(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */
            var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false)
                removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */
            var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */
            if (isInherited &&
                isInitialRender &&
                visualElement.manuallyAnimateOnMount) {
                isInherited = false;
            }
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */
            typeState.protectedKeys = (0,tslib_es6/* __assign */.pi)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (
            // If it isn't active and hasn't *just* been set as inactive
            (!typeState.isActive && activeDelta === null) ||
                // If we didn't and don't have any defined prop for this animation type
                (!prop && !typeState.prevProp) ||
                // Or if the prop doesn't define an animation
                isAnimationControls(prop) ||
                typeof prop === "boolean") {
                return "continue";
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */
            var shouldAnimateType = variantsHaveChanged(typeState.prevProp, prop) ||
                // If we're making this variant active, we want to always make it active
                (type === changedActiveType &&
                    typeState.isActive &&
                    !isInherited &&
                    propIsVariant) ||
                // If we removed a higher-priority variant (i is in reverse order)
                (i > removedVariantIndex && propIsVariant);
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */
            var definitionList = Array.isArray(prop) ? prop : [prop];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */
            var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false)
                resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */
            var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
            var allKeys = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, prevResolvedValues), resolvedValues);
            var markToAnimate = function (key) {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for (var key in allKeys) {
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key))
                    continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */
                if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */
                    if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
                        if (!shallowCompare(next, prev)) {
                            markToAnimate(key);
                        }
                        else {
                            /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */
                            typeState.protectedKeys[key] = true;
                        }
                    }
                    else if (next !== undefined) {
                        // If next is defined and doesn't equal prev, it needs animating
                        markToAnimate(key);
                    }
                    else {
                        // If it's undefined, it's been removed.
                        removedKeys.add(key);
                    }
                }
                else if (next !== undefined && removedKeys.has(key)) {
                    /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */
                    markToAnimate(key);
                }
                else {
                    /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */
                    typeState.protectedKeys[key] = true;
                }
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */
            typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */
            if (typeState.isActive) {
                encounteredKeys = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, encounteredKeys), resolvedValues);
            }
            if (isInitialRender && visualElement.blockInitialAnimation) {
                shouldAnimateType = false;
            }
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */
            if (shouldAnimateType && !isInherited) {
                animations.push.apply(animations, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(definitionList.map(function (animation) { return ({
                    animation: animation,
                    options: (0,tslib_es6/* __assign */.pi)({ type: type }, options),
                }); }))));
            }
        };
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */
        for (var i = 0; i < numAnimationTypes; i++) {
            _loop_1(i);
        }
        allAnimatedKeys = (0,tslib_es6/* __assign */.pi)({}, encounteredKeys);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */
        if (removedKeys.size) {
            var fallbackAnimation_1 = {};
            removedKeys.forEach(function (key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) {
                    fallbackAnimation_1[key] = fallbackTarget;
                }
            });
            animations.push({ animation: fallbackAnimation_1 });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender &&
            props.initial === false &&
            !visualElement.manuallyAnimateOnMount) {
            shouldAnimate = false;
        }
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */
    function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive)
            return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function (child) { var _a; return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive); });
        state[type].isActive = isActive;
        return animateChanges(options, type);
    }
    return {
        isAnimated: isAnimated,
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function () { return state; },
    };
}
function variantsHaveChanged(prev, next) {
    if (typeof next === "string") {
        return next !== prev;
    }
    else if (isVariantLabels(next)) {
        return !shallowCompare(next, prev);
    }
    return false;
}
function createTypeState(isActive) {
    if (isActive === void 0) { isActive = false; }
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {},
    };
}
function createState() {
    var _a;
    return _a = {},
        _a[AnimationType.Animate] = createTypeState(true),
        _a[AnimationType.Hover] = createTypeState(),
        _a[AnimationType.Tap] = createTypeState(),
        _a[AnimationType.Drag] = createTypeState(),
        _a[AnimationType.Focus] = createTypeState(),
        _a[AnimationType.Exit] = createTypeState(),
        _a;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/animations.js









var animations = {
    animation: makeRenderlessComponent(function (_a) {
        var visualElement = _a.visualElement, animate = _a.animate;
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */
        visualElement.animationState || (visualElement.animationState = createAnimationState(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */
        if (isAnimationControls(animate)) {
            (0,react.useEffect)(function () { return animate.subscribe(visualElement); }, [animate]);
        }
    }),
    exit: makeRenderlessComponent(function (props) {
        var custom = props.custom, visualElement = props.visualElement;
        var _a = (0,tslib_es6/* __read */.CR)(usePresence(), 2), isPresent = _a[0], onExitComplete = _a[1];
        var presenceContext = (0,react.useContext)(context_PresenceContext/* PresenceContext */.O);
        (0,react.useEffect)(function () {
            var _a, _b;
            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Exit, !isPresent, { custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom });
            !isPresent && (animation === null || animation === void 0 ? void 0 : animation.then(onExitComplete));
        }, [isPresent]);
    }),
};



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/is-point.js
var isPoint = function (point) {
    return point.hasOwnProperty('x') && point.hasOwnProperty('y');
};



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/is-point-3d.js


var isPoint3D = function (point) {
    return isPoint(point) && point.hasOwnProperty('z');
};



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/distance.js




var distance1D = function (a, b) { return Math.abs(a - b); };
function distance(a, b) {
    if (isNum(a) && isNum(b)) {
        return distance1D(a, b);
    }
    else if (isPoint(a) && isPoint(b)) {
        var xDelta = distance1D(a.x, b.x);
        var yDelta = distance1D(a.y, b.y);
        var zDelta = isPoint3D(a) && isPoint3D(b) ? distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/PanSession.js








/**
 * @internal
 */
var PanSession = /** @class */ (function () {
    function PanSession(event, handlers, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
        /**
         * @internal
         */
        this.startEvent = null;
        /**
         * @internal
         */
        this.lastMoveEvent = null;
        /**
         * @internal
         */
        this.lastMoveEventInfo = null;
        /**
         * @internal
         */
        this.handlers = {};
        this.updatePoint = function () {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo))
                return;
            var info = getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            var isDistancePastThreshold = distance(info.offset, { x: 0, y: 0 }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold)
                return;
            var point = info.point;
            var timestamp = (0,es/* getFrameData */.$B)().timestamp;
            _this.history.push((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, point), { timestamp: timestamp }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function (event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = transformPoint(info, _this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if (isMouseEvent(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            es/* default.update */.ZP.update(_this.updatePoint, true);
        };
        this.handlePointerUp = function (event, info) {
            _this.end();
            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
            var panInfo = getPanInfo(transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) {
                onEnd(event, panInfo);
            }
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (isTouchEvent(event) && event.touches.length > 1)
            return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = extractEventInfo(event);
        var initialInfo = transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0,es/* getFrameData */.$B)().timestamp;
        this.history = [(0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, point), { timestamp: timestamp })];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart &&
            onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function (handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function () {
        this.removeListeners && this.removeListeners();
        es/* cancelSync.update */.qY.update(this.updatePoint);
    };
    return PanSession;
}());
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a, b) {
    return { x: a.x - b.x, y: a.y - b.y };
}
function getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: PanSession_getVelocity(history, 0.1),
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function PanSession_getVelocity(history, timeDelta) {
    if (history.length < 2) {
        return { x: 0, y: 0 };
    }
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = lastDevicePoint(history);
    while (i >= 0) {
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp >
            secondsToMilliseconds(timeDelta)) {
            break;
        }
        i--;
    }
    if (!timestampedPoint) {
        return { x: 0, y: 0 };
    }
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) {
        return { x: 0, y: 0 };
    }
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time,
    };
    if (currentVelocity.x === Infinity) {
        currentVelocity.x = 0;
    }
    if (currentVelocity.y === Infinity) {
        currentVelocity.y = 0;
    }
    return currentVelocity;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/geometry/index.js + 1 modules
var geometry = __webpack_require__(19125);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/each-axis.js
// Call a handler once for each axis
function eachAxis(handler) {
    return [handler("x"), handler("y")];
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/drag/utils/constraints.js



/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */
function applyConstraints(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) {
        // If we have a min point defined, and this is outside of that, constrain
        point = elastic ? mix(min, point, elastic.min) : Math.max(point, min);
    }
    else if (max !== undefined && point > max) {
        // If we have a max point defined, and this is outside of that, constrain
        point = elastic ? mix(max, point, elastic.max) : Math.min(point, max);
    }
    return point;
}
/**
 * Calculates a min projection point based on a pointer, pointer progress
 * within the drag target, and constraints.
 *
 * For instance if an element was 100px width, we were dragging from 0.25
 * along this axis, the pointer is at 200px, and there were no constraints,
 * we would calculate a min projection point of 175px.
 */
function calcConstrainedMinPoint(point, length, progress, constraints, elastic) {
    // Calculate a min point for this axis and apply it to the current pointer
    var min = point - length * progress;
    return constraints ? applyConstraints(min, constraints, elastic) : min;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */
function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined
            ? axis.max + max - (axis.max - axis.min)
            : undefined,
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */
function calcRelativeConstraints(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom),
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min <
        layoutAxis.max - layoutAxis.min) {
        _a = (0,tslib_es6/* __read */.CR)([max, min], 2), min = _a[0], max = _a[1];
    }
    return {
        min: layoutAxis.min + min,
        max: layoutAxis.min + max,
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */
function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y),
    };
}
/**
 * Calculate the an axis position based on two axes and a progress value.
 */
function calcPositionFromProgress(axis, constraints, progress) {
    var axisLength = axis.max - axis.min;
    var min = mix(constraints.min, constraints.max - axisLength, progress);
    return { min: min, max: min + axisLength };
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */
function rebaseAxisConstraints(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) {
        relativeConstraints.min = constraints.min - layout.min;
    }
    if (constraints.max !== undefined) {
        relativeConstraints.max = constraints.max - layout.min;
    }
    return relativeConstraints;
}
var defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */
function resolveDragElastic(dragElastic) {
    if (dragElastic === false) {
        dragElastic = 0;
    }
    else if (dragElastic === true) {
        dragElastic = defaultElastic;
    }
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom"),
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel),
    };
}
function resolvePointElastic(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number"
        ? dragElastic
        : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/projection/measure.js


/**
 * Measure and return the element bounding box.
 *
 * We convert the box into an AxisBox2D to make it easier to work with each axis
 * individually and programmatically.
 *
 * This function optionally accepts a transformPagePoint function which allows us to compensate
 * for, for instance, measuring the element within a scaled plane like a Framer devivce preview component.
 */
function getBoundingBox(element, transformPagePoint) {
    var box = element.getBoundingClientRect();
    return (0,geometry/* convertBoundingBoxToAxisBox */.RX)((0,geometry/* transformBoundingBox */.dV)(box, transformPagePoint));
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/geometry/delta-calc.js


var clampProgress = function (v) { return clamp_clamp(0, 1, v); };
/**
 * Returns true if the provided value is within maxDistance of the provided target
 */
function isNear(value, target, maxDistance) {
    if (target === void 0) { target = 0; }
    if (maxDistance === void 0) { maxDistance = 0.01; }
    return distance(value, target) < maxDistance;
}
function calcLength(axis) {
    return axis.max - axis.min;
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */
function delta_calc_calcOrigin(source, target) {
    var origin = 0.5;
    var sourceLength = calcLength(source);
    var targetLength = calcLength(target);
    if (targetLength > sourceLength) {
        origin = progress(target.min, target.max - sourceLength, source.min);
    }
    else if (sourceLength > targetLength) {
        origin = progress(source.min, source.max - targetLength, target.min);
    }
    return clampProgress(origin);
}
/**
 * Update the AxisDelta with a transform that projects source into target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */
function updateAxisDelta(delta, source, target, origin) {
    if (origin === void 0) { origin = 0.5; }
    delta.origin = origin;
    delta.originPoint = mix(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    if (isNear(delta.scale, 1, 0.0001))
        delta.scale = 1;
    delta.translate =
        mix(target.min, target.max, delta.origin) - delta.originPoint;
    if (isNear(delta.translate))
        delta.translate = 0;
}
/**
 * Update the BoxDelta with a transform that projects the source into the target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */
function updateBoxDelta(delta, source, target, origin) {
    updateAxisDelta(delta.x, source.x, target.x, defaultOrigin(origin.originX));
    updateAxisDelta(delta.y, source.y, target.y, defaultOrigin(origin.originY));
}
/**
 * Currently this only accepts numerical origins, measured as 0-1, but could
 * accept pixel values by comparing to the target axis.
 */
function defaultOrigin(origin) {
    return typeof origin === "number" ? origin : 0.5;
}
function calcRelativeAxis(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(projection, parentProjection) {
    calcRelativeAxis(projection.target.x, projection.relativeTarget.x, parentProjection.target.x);
    calcRelativeAxis(projection.target.y, projection.relativeTarget.y, parentProjection.target.y);
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/projection/utils.js
var utils = __webpack_require__(56962);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/layout/utils.js


function tweenAxis(target, prev, next, p) {
    target.min = mix(prev.min, next.min, p);
    target.max = mix(prev.max, next.max, p);
}
function calcRelativeOffsetAxis(parent, child) {
    return {
        min: child.min - parent.min,
        max: child.max - parent.min,
    };
}
function calcRelativeOffset(parent, child) {
    return {
        x: calcRelativeOffsetAxis(parent.x, child.x),
        y: calcRelativeOffsetAxis(parent.y, child.y),
    };
}
function checkIfParentHasChanged(prev, next) {
    var prevId = prev.getLayoutId();
    var nextId = next.getLayoutId();
    return prevId !== nextId || (nextId === undefined && prev !== next);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/is-draggable.js
function isDraggable(visualElement) {
    var _a = visualElement.getProps(), drag = _a.drag, _dragX = _a._dragX;
    return drag && !_dragX;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/geometry/delta-apply.js




/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */
function resetAxis(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */
function resetBox(box, originBox) {
    resetAxis(box.x, originBox.x);
    resetAxis(box.y, originBox.y);
}
/**
 * Scales a point based on a factor and an originPoint
 */
function scalePoint(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */
function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) {
        point = scalePoint(point, boxScale, originPoint);
    }
    return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */
function applyAxisDelta(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) { translate = 0; }
    if (scale === void 0) { scale = 1; }
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */
function applyBoxDelta(box, _a) {
    var x = _a.x, y = _a.y;
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */
function applyAxisTransforms(final, axis, transforms, _a) {
    var _b = (0,tslib_es6/* __read */.CR)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    // Copy the current axis to the final axis before mutation
    final.min = axis.min;
    final.max = axis.max;
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = mix(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    applyAxisDelta(final, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
var xKeys = ["x", "scaleX", "originX"];
var yKeys = ["y", "scaleY", "originY"];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */
function applyBoxTransforms(finalBox, box, transforms) {
    applyAxisTransforms(finalBox.x, box.x, transforms, xKeys);
    applyAxisTransforms(finalBox.y, box.y, transforms, yKeys);
}
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */
function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = scalePoint(point, 1 / scale, originPoint);
    if (boxScale !== undefined) {
        point = scalePoint(point, 1 / boxScale, originPoint);
    }
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */
function removeAxisDelta(axis, translate, scale, origin, boxScale) {
    if (translate === void 0) { translate = 0; }
    if (scale === void 0) { scale = 1; }
    if (origin === void 0) { origin = 0.5; }
    var originPoint = mix(axis.min, axis.max, origin) - translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeAxisTransforms(axis, transforms, _a) {
    var _b = (0,tslib_es6/* __read */.CR)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale);
}
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeBoxTransforms(box, transforms) {
    removeAxisTransforms(box.x, transforms, xKeys);
    removeAxisTransforms(box.y, transforms, yKeys);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */
function applyTreeDeltas(box, treeScale, treePath) {
    var treeLength = treePath.length;
    if (!treeLength)
        return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for (var i = 0; i < treeLength; i++) {
        node = treePath[i];
        delta = node.getLayoutState().delta;
        // Incoporate each ancestor's scale into a culmulative treeScale for this component
        treeScale.x *= delta.x.scale;
        treeScale.y *= delta.y.scale;
        // Apply each ancestor's calculated delta into this component's recorded layout box
        applyBoxDelta(box, delta);
        // If this is a draggable ancestor, also incorporate the node's transform to the layout box
        if (isDraggable(node)) {
            applyBoxTransforms(box, box, node.getLatestValues());
        }
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/projection/convert-to-relative.js




/**
 * Returns a boolean stating whether or not we converted the projection
 * to relative projection.
 */
function convertToRelativeProjection(visualElement, isLayoutDrag) {
    if (isLayoutDrag === void 0) { isLayoutDrag = true; }
    var projectionParent = visualElement.getProjectionParent();
    if (!projectionParent)
        return false;
    var offset;
    if (isLayoutDrag) {
        offset = calcRelativeOffset(projectionParent.projection.target, visualElement.projection.target);
        removeBoxTransforms(offset, projectionParent.getLatestValues());
    }
    else {
        offset = calcRelativeOffset(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
    }
    eachAxis(function (axis) {
        return visualElement.setProjectionTargetAxis(axis, offset[axis].min, offset[axis].max, true);
    });
    return true;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/batch-layout.js
var batch_layout = __webpack_require__(78091);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/drag/VisualElementDragControls.js






















var elementDragControls = new WeakMap();
/**
 *
 */
var lastPointerEvent;
var VisualElementDragControls = /** @class */ (function () {
    function VisualElementDragControls(_a) {
        var visualElement = _a.visualElement;
        /**
         * Track whether we're currently dragging.
         *
         * @internal
         */
        this.isDragging = false;
        /**
         * The current direction of drag, or `null` if both.
         *
         * @internal
         */
        this.currentDirection = null;
        /**
         * The permitted boundaries of travel, in pixels.
         *
         * @internal
         */
        this.constraints = false;
        /**
         * The per-axis resolved elastic values.
         *
         * @internal
         */
        this.elastic = (0,geometry/* axisBox */.VZ)();
        /**
         * A reference to the host component's latest props.
         *
         * @internal
         */
        this.props = {};
        /**
         * @internal
         */
        this.hasMutatedConstraints = false;
        /**
         * Track the initial position of the cursor relative to the dragging element
         * when dragging starts as a value of 0-1 on each axis. We then use this to calculate
         * an ideal bounding box for the VisualElement renderer to project into every frame.
         *
         * @internal
         */
        this.cursorProgress = {
            x: 0.5,
            y: 0.5,
        };
        // When updating _dragX, or _dragY instead of the VisualElement,
        // persist their values between drag gestures.
        this.originPoint = {};
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        /**
         * @internal
         */
        this.panSession = null;
        this.visualElement = visualElement;
        this.visualElement.enableLayoutProjection();
        elementDragControls.set(visualElement, this);
    }
    /**
     * Instantiate a PanSession for the drag gesture
     *
     * @public
     */
    VisualElementDragControls.prototype.start = function (originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c, cursorProgress = _b.cursorProgress;
        var onSessionStart = function (event) {
            var _a;
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            _this.stopMotion();
            /**
             * Save the initial point. We'll use this to calculate the pointer's position rather
             * than the one we receive when the gesture actually starts. By then, the pointer will
             * have already moved, and the perception will be of the pointer "slipping" across the element
             */
            var initialPoint = getViewportPointFromEvent(event).point;
            (_a = _this.cancelLayout) === null || _a === void 0 ? void 0 : _a.call(_this);
            _this.cancelLayout = (0,batch_layout/* batchLayout */.U)(function (read, write) {
                var ancestors = (0,utils/* collectProjectingAncestors */.kv)(_this.visualElement);
                var children = (0,utils/* collectProjectingChildren */.e3)(_this.visualElement);
                var tree = (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(ancestors)), (0,tslib_es6/* __read */.CR)(children));
                var hasManuallySetCursorOrigin = false;
                /**
                 * Apply a simple lock to the projection target. This ensures no animations
                 * can run on the projection box while this lock is active.
                 */
                _this.isLayoutDrag() && _this.visualElement.lockProjectionTarget();
                write(function () {
                    tree.forEach(function (element) { return element.resetTransform(); });
                });
                read(function () {
                    (0,utils/* updateLayoutMeasurement */.de)(_this.visualElement);
                    children.forEach(utils/* updateLayoutMeasurement */.de);
                });
                write(function () {
                    tree.forEach(function (element) { return element.restoreTransform(); });
                    if (snapToCursor) {
                        hasManuallySetCursorOrigin = _this.snapToCursor(initialPoint);
                    }
                });
                read(function () {
                    var isRelativeDrag = Boolean(_this.getAxisMotionValue("x") && !_this.isExternalDrag());
                    if (!isRelativeDrag) {
                        _this.visualElement.rebaseProjectionTarget(true, _this.visualElement.measureViewportBox(false));
                    }
                    _this.visualElement.scheduleUpdateLayoutProjection();
                    /**
                     * When dragging starts, we want to find where the cursor is relative to the bounding box
                     * of the element. Every frame, we calculate a new bounding box using this relative position
                     * and let the visualElement renderer figure out how to reproject the element into this bounding
                     * box.
                     *
                     * By doing it this way, rather than applying an x/y transform directly to the element,
                     * we can ensure the component always visually sticks to the cursor as we'd expect, even
                     * if the DOM element itself changes layout as a result of React updates the user might
                     * make based on the drag position.
                     */
                    var projection = _this.visualElement.projection;
                    eachAxis(function (axis) {
                        if (!hasManuallySetCursorOrigin) {
                            var _a = projection.target[axis], min = _a.min, max = _a.max;
                            _this.cursorProgress[axis] = cursorProgress
                                ? cursorProgress[axis]
                                : progress(min, max, initialPoint[axis]);
                        }
                        /**
                         * If we have external drag MotionValues, record their origin point. On pointermove
                         * we'll apply the pan gesture offset directly to this value.
                         */
                        var axisValue = _this.getAxisMotionValue(axis);
                        if (axisValue) {
                            _this.originPoint[axis] = axisValue.get();
                        }
                    });
                });
                write(function () {
                    es/* flushSync.update */.iW.update();
                    es/* flushSync.preRender */.iW.preRender();
                    es/* flushSync.render */.iW.render();
                    es/* flushSync.postRender */.iW.postRender();
                });
                read(function () { return _this.resolveDragConstraints(); });
            });
        };
        var onStart = function (event, info) {
            var _a, _b, _c;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            var _d = _this.props, drag = _d.drag, dragPropagation = _d.dragPropagation;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock)
                    _this.openGlobalLock();
                _this.openGlobalLock = getGlobalLock(drag);
                // If we don 't have the lock, don't start dragging
                if (!_this.openGlobalLock)
                    return;
            }
            (0,batch_layout/* flushLayout */.R)();
            // Set current drag status
            _this.isDragging = true;
            _this.currentDirection = null;
            // Fire onDragStart event
            (_b = (_a = _this.props).onDragStart) === null || _b === void 0 ? void 0 : _b.call(_a, event, info);
            (_c = _this.visualElement.animationState) === null || _c === void 0 ? void 0 : _c.setActive(AnimationType.Drag, true);
        };
        var onMove = function (event, info) {
            var _a, _b, _c, _d;
            var _e = _this.props, dragPropagation = _e.dragPropagation, dragDirectionLock = _e.dragDirectionLock;
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !_this.openGlobalLock)
                return;
            var offset = info.offset;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (_this.currentDirection !== null) {
                    (_b = (_a = _this.props).onDirectionLock) === null || _b === void 0 ? void 0 : _b.call(_a, _this.currentDirection);
                }
                return;
            }
            // Update each point with the latest position
            _this.updateAxis("x", info.point, offset);
            _this.updateAxis("y", info.point, offset);
            // Fire onDrag event
            (_d = (_c = _this.props).onDrag) === null || _d === void 0 ? void 0 : _d.call(_c, event, info);
            // Update the last pointer event
            lastPointerEvent = event;
        };
        var onSessionEnd = function (event, info) {
            return _this.stop(event, info);
        };
        var transformPagePoint = this.props.transformPagePoint;
        this.panSession = new PanSession(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
        }, { transformPagePoint: transformPagePoint });
    };
    VisualElementDragControls.prototype.resolveDragConstraints = function () {
        var _this = this;
        var _a = this.props, dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
        var layout = this.visualElement.getLayoutState().layoutCorrected;
        if (dragConstraints) {
            this.constraints = isRefObject(dragConstraints)
                ? this.resolveRefConstraints(layout, dragConstraints)
                : calcRelativeConstraints(layout, dragConstraints);
        }
        else {
            this.constraints = false;
        }
        this.elastic = resolveDragElastic(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */
        if (this.constraints && !this.hasMutatedConstraints) {
            eachAxis(function (axis) {
                if (_this.getAxisMotionValue(axis)) {
                    _this.constraints[axis] = rebaseAxisConstraints(layout[axis], _this.constraints[axis]);
                }
            });
        }
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function (layoutBox, constraints) {
        var _a = this.props, onMeasureDragConstraints = _a.onMeasureDragConstraints, transformPagePoint = _a.transformPagePoint;
        var constraintsElement = constraints.current;
        invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        this.constraintsBox = getBoundingBox(constraintsElement, transformPagePoint);
        var measuredConstraints = calcViewportConstraints(layoutBox, this.constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */
        if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints((0,geometry/* convertAxisBoxToBoundingBox */._6)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) {
                measuredConstraints = (0,geometry/* convertBoundingBoxToAxisBox */.RX)(userConstraints);
            }
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.cancelDrag = function () {
        var _a, _b;
        this.visualElement.unlockProjectionTarget();
        (_a = this.cancelLayout) === null || _a === void 0 ? void 0 : _a.call(this);
        this.isDragging = false;
        this.panSession && this.panSession.end();
        this.panSession = null;
        if (!this.props.dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 ? void 0 : _b.setActive(AnimationType.Drag, false);
    };
    VisualElementDragControls.prototype.stop = function (event, info) {
        var _a, _b, _c;
        (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
        this.panSession = null;
        var isDragging = this.isDragging;
        this.cancelDrag();
        if (!isDragging)
            return;
        var velocity = info.velocity;
        this.animateDragEnd(velocity);
        (_c = (_b = this.props).onDragEnd) === null || _c === void 0 ? void 0 : _c.call(_b, event, info);
    };
    VisualElementDragControls.prototype.snapToCursor = function (point) {
        var _this = this;
        return eachAxis(function (axis) {
            var drag = _this.props.drag;
            // If we're not dragging this axis, do an early return.
            if (!shouldDrag(axis, drag, _this.currentDirection))
                return;
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
                var box = _this.visualElement.getLayoutState().layout;
                var length_1 = box[axis].max - box[axis].min;
                var center = box[axis].min + length_1 / 2;
                var offset = point[axis] - center;
                _this.originPoint[axis] = point[axis];
                axisValue.set(offset);
            }
            else {
                _this.cursorProgress[axis] = 0.5;
                return true;
            }
        }).includes(true);
    };
    /**
     * Update the specified axis with the latest pointer information.
     */
    VisualElementDragControls.prototype.updateAxis = function (axis, point, offset) {
        var drag = this.props.drag;
        // If we're not dragging this axis, do an early return.
        if (!shouldDrag(axis, drag, this.currentDirection))
            return;
        return this.getAxisMotionValue(axis)
            ? this.updateAxisMotionValue(axis, offset)
            : this.updateVisualElementAxis(axis, point);
    };
    VisualElementDragControls.prototype.updateAxisMotionValue = function (axis, offset) {
        var axisValue = this.getAxisMotionValue(axis);
        if (!offset || !axisValue)
            return;
        var nextValue = this.originPoint[axis] + offset[axis];
        var update = this.constraints
            ? applyConstraints(nextValue, this.constraints[axis], this.elastic[axis])
            : nextValue;
        axisValue.set(update);
    };
    VisualElementDragControls.prototype.updateVisualElementAxis = function (axis, point) {
        var _a;
        // Get the actual layout bounding box of the element
        var axisLayout = this.visualElement.getLayoutState().layout[axis];
        // Calculate its current length. In the future we might want to lerp this to animate
        // between lengths if the layout changes as we change the DOM
        var axisLength = axisLayout.max - axisLayout.min;
        // Get the initial progress that the pointer sat on this axis on gesture start.
        var axisProgress = this.cursorProgress[axis];
        // Calculate a new min point based on the latest pointer position, constraints and elastic
        var min = calcConstrainedMinPoint(point[axis], axisLength, axisProgress, (_a = this.constraints) === null || _a === void 0 ? void 0 : _a[axis], this.elastic[axis]);
        // Update the axis viewport target with this new min and the length
        this.visualElement.setProjectionTargetAxis(axis, min, min + axisLength);
    };
    VisualElementDragControls.prototype.setProps = function (_a) {
        var _b = _a.drag, drag = _b === void 0 ? false : _b, _c = _a.dragDirectionLock, dragDirectionLock = _c === void 0 ? false : _c, _d = _a.dragPropagation, dragPropagation = _d === void 0 ? false : _d, _e = _a.dragConstraints, dragConstraints = _e === void 0 ? false : _e, _f = _a.dragElastic, dragElastic = _f === void 0 ? defaultElastic : _f, _g = _a.dragMomentum, dragMomentum = _g === void 0 ? true : _g, remainingProps = (0,tslib_es6/* __rest */._T)(_a, ["drag", "dragDirectionLock", "dragPropagation", "dragConstraints", "dragElastic", "dragMomentum"]);
        this.props = (0,tslib_es6/* __assign */.pi)({ drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum }, remainingProps);
    };
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - If the component will perform layout animations, we output the gesture to the component's
     *      visual bounding box
     * - Otherwise, we apply the delta to the x/y motion values.
     */
    VisualElementDragControls.prototype.getAxisMotionValue = function (axis) {
        var _a = this.props, layout = _a.layout, layoutId = _a.layoutId;
        var dragKey = "_drag" + axis.toUpperCase();
        if (this.props[dragKey]) {
            return this.props[dragKey];
        }
        else if (!layout && layoutId === undefined) {
            return this.visualElement.getValue(axis, 0);
        }
    };
    VisualElementDragControls.prototype.isLayoutDrag = function () {
        return !this.getAxisMotionValue("x");
    };
    VisualElementDragControls.prototype.isExternalDrag = function () {
        var _a = this.props, _dragX = _a._dragX, _dragY = _a._dragY;
        return _dragX || _dragY;
    };
    VisualElementDragControls.prototype.animateDragEnd = function (velocity) {
        var _this = this;
        var _a = this.props, drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition;
        /**
         * Everything beyond the drag gesture should be performed with
         * relative projection so children stay in sync with their parent element.
         */
        var isRelative = convertToRelativeProjection(this.visualElement, this.isLayoutDrag() && !this.isExternalDrag());
        /**
         * If we had previously resolved constraints relative to the viewport,
         * we need to also convert those to a relative coordinate space for the animation
         */
        var constraints = this.constraints || {};
        if (isRelative &&
            Object.keys(constraints).length &&
            this.isLayoutDrag()) {
            var projectionParent = this.visualElement.getProjectionParent();
            if (projectionParent) {
                var relativeConstraints_1 = calcRelativeOffset(projectionParent.projection.targetFinal, constraints);
                eachAxis(function (axis) {
                    var _a = relativeConstraints_1[axis], min = _a.min, max = _a.max;
                    constraints[axis] = {
                        min: isNaN(min) ? undefined : min,
                        max: isNaN(max) ? undefined : max,
                    };
                });
            }
        }
        var momentumAnimations = eachAxis(function (axis) {
            var _a;
            if (!shouldDrag(axis, drag, _this.currentDirection)) {
                return;
            }
            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */
            var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ type: "inertia", velocity: dragMomentum ? velocity[axis] : 0, bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping, timeConstant: 750, restDelta: 1, restSpeed: 10 }, dragTransition), transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return _this.getAxisMotionValue(axis)
                ? _this.startAxisValueAnimation(axis, inertia)
                : _this.visualElement.startLayoutAnimation(axis, inertia, isRelative);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(function () {
            var _a, _b;
            (_b = (_a = _this.props).onDragTransitionEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
    };
    VisualElementDragControls.prototype.stopMotion = function () {
        var _this = this;
        eachAxis(function (axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            axisValue
                ? axisValue.stop()
                : _this.visualElement.stopLayoutAnimation();
        });
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function (axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        if (!axisValue)
            return;
        var currentValue = axisValue.get();
        axisValue.set(currentValue);
        axisValue.set(currentValue); // Set twice to hard-reset velocity
        return startAnimation(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.scalePoint = function () {
        var _this = this;
        var _a = this.props, drag = _a.drag, dragConstraints = _a.dragConstraints;
        if (!isRefObject(dragConstraints) || !this.constraintsBox)
            return;
        // Stop any current animations as there can be some visual glitching if we resize mid animation
        this.stopMotion();
        // Record the relative progress of the targetBox relative to the constraintsBox
        var boxProgress = { x: 0, y: 0 };
        eachAxis(function (axis) {
            boxProgress[axis] = delta_calc_calcOrigin(_this.visualElement.projection.target[axis], _this.constraintsBox[axis]);
        });
        /**
         * For each axis, calculate the current progress of the layout axis within the constraints.
         * Then, using the latest layout and constraints measurements, reposition the new layout axis
         * proportionally within the constraints.
         */
        this.updateConstraints(function () {
            eachAxis(function (axis) {
                if (!shouldDrag(axis, drag, null))
                    return;
                // Calculate the position of the targetBox relative to the constraintsBox using the
                // previously calculated progress
                var _a = calcPositionFromProgress(_this.visualElement.projection.target[axis], _this.constraintsBox[axis], boxProgress[axis]), min = _a.min, max = _a.max;
                _this.visualElement.setProjectionTargetAxis(axis, min, max);
            });
        });
        /**
         * If any other draggable components are queuing the same tasks synchronously
         * this will wait until they've all been scheduled before flushing.
         */
        setTimeout(batch_layout/* flushLayout */.R, 1);
    };
    VisualElementDragControls.prototype.updateConstraints = function (onReady) {
        var _this = this;
        this.cancelLayout = (0,batch_layout/* batchLayout */.U)(function (read, write) {
            var ancestors = (0,utils/* collectProjectingAncestors */.kv)(_this.visualElement);
            write(function () {
                return ancestors.forEach(function (element) { return element.resetTransform(); });
            });
            read(function () { return (0,utils/* updateLayoutMeasurement */.de)(_this.visualElement); });
            write(function () {
                return ancestors.forEach(function (element) { return element.restoreTransform(); });
            });
            read(function () {
                _this.resolveDragConstraints();
            });
            if (onReady)
                write(onReady);
        });
    };
    VisualElementDragControls.prototype.mount = function (visualElement) {
        var _this = this;
        var element = visualElement.getInstance();
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */
        var stopPointerListener = addPointerEvent(element, "pointerdown", function (event) {
            var _a = _this.props, drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */
        var stopResizeListener = addDomEvent(window, "resize", function () {
            _this.scalePoint();
        });
        /**
         * Ensure drag constraints are resolved correctly relative to the dragging element
         * whenever its layout changes.
         */
        var stopLayoutUpdateListener = visualElement.onLayoutUpdate(function () {
            if (_this.isDragging) {
                _this.resolveDragConstraints();
            }
        });
        /**
         * If the previous component with this same layoutId was dragging at the time
         * it was unmounted, we want to continue the same gesture on this component.
         */
        var prevDragCursor = visualElement.prevDragCursor;
        if (prevDragCursor) {
            this.start(lastPointerEvent, { cursorProgress: prevDragCursor });
        }
        /**
         * Return a function that will teardown the drag gesture
         */
        return function () {
            stopPointerListener === null || stopPointerListener === void 0 ? void 0 : stopPointerListener();
            stopResizeListener === null || stopResizeListener === void 0 ? void 0 : stopResizeListener();
            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 ? void 0 : stopLayoutUpdateListener();
            _this.cancelDrag();
        };
    };
    return VisualElementDragControls;
}());
function shouldDrag(direction, drag, currentDirection) {
    return ((drag === true || drag === direction) &&
        (currentDirection === null || currentDirection === direction));
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */
function getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) { lockThreshold = 10; }
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) {
        direction = "y";
    }
    else if (Math.abs(offset.x) > lockThreshold) {
        direction = "x";
    }
    return direction;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/drag/use-drag.js






/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */
function useDrag(props) {
    var groupDragControls = props.dragControls, visualElement = props.visualElement;
    var transformPagePoint = (0,react.useContext)(MotionConfigContext).transformPagePoint;
    var dragControls = (0,use_constant/* useConstant */.h)(function () {
        return new VisualElementDragControls({
            visualElement: visualElement,
        });
    });
    dragControls.setProps((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, props), { transformPagePoint: transformPagePoint }));
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0,react.useEffect)(function () { return groupDragControls && groupDragControls.subscribe(dragControls); }, [dragControls]);
    // Mount the drag controls with the visualElement
    (0,react.useEffect)(function () { return dragControls.mount(visualElement); }, []);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/use-pan-gesture.js






/**
 *
 * @param handlers -
 * @param ref -
 *
 * @internalremarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */
function usePanGesture(_a) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = (0,react.useRef)(null);
    var transformPagePoint = (0,react.useContext)(MotionConfigContext).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function (event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        },
    };
    (0,react.useEffect)(function () {
        if (panSession.current !== null) {
            panSession.current.updateHandlers(handlers);
        }
    });
    function onPointerDown(event) {
        panSession.current = new PanSession(event, handlers, {
            transformPagePoint: transformPagePoint,
        });
    }
    usePointerEvent(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0,use_unmount_effect/* useUnmountEffect */.z)(function () { return panSession.current && panSession.current.end(); });
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/drag.js




var drag = {
    pan: makeRenderlessComponent(usePanGesture),
    drag: makeRenderlessComponent(useDrag),
};



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimateSharedLayout/types.js
var AnimateSharedLayout_types = __webpack_require__(44038);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/css-variables-conversion.js



function css_variables_conversion_isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
    var match = cssVariableRegex.exec(current);
    if (!match)
        return [,];
    var _a = (0,tslib_es6/* __read */.CR)(match, 3), token = _a[1], fallback = _a[2];
    return [token, fallback];
}
var maxDepth = 4;
function getVariableValue(current, element, depth) {
    if (depth === void 0) { depth = 1; }
    invariant(depth <= maxDepth, "Max CSS variable fallback depth detected in property \"" + current + "\". This may indicate a circular fallback dependency.");
    var _a = (0,tslib_es6/* __read */.CR)(parseCSSVariable(current), 2), token = _a[0], fallback = _a[1];
    // No CSS variable detected
    if (!token)
        return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        return resolved.trim();
    }
    else if (css_variables_conversion_isCSSVariable(fallback)) {
        // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
        return getVariableValue(fallback, element, depth + 1);
    }
    else {
        return fallback;
    }
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */
function resolveCSSVariables(visualElement, _a, transitionEnd) {
    var _b;
    var target = (0,tslib_es6/* __rest */._T)(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof HTMLElement))
        return { target: target, transitionEnd: transitionEnd };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) {
        transitionEnd = (0,tslib_es6/* __assign */.pi)({}, transitionEnd);
    }
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.forEachValue(function (value) {
        var current = value.get();
        if (!css_variables_conversion_isCSSVariable(current))
            return;
        var resolved = getVariableValue(current, element);
        if (resolved)
            value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for (var key in target) {
        var current = target[key];
        if (!css_variables_conversion_isCSSVariable(current))
            continue;
        var resolved = getVariableValue(current, element);
        if (!resolved)
            continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd)
            (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : (transitionEnd[key] = current);
    }
    return { target: target, transitionEnd: transitionEnd };
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/projection/default-scale-correctors.js





function pixelsToPercent(pixels, axis) {
    return (pixels / (axis.max - axis.min)) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */
function correctBorderRadius(latest, _layoutState, _a) {
    var target = _a.target;
    /**
     * If latest is a string, if it's a percentage we can return immediately as it's
     * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
     */
    if (typeof latest === "string") {
        if (px.test(latest)) {
            latest = parseFloat(latest);
        }
        else {
            return latest;
        }
    }
    /**
     * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
     * pixel value as a percentage of each axis
     */
    var x = pixelsToPercent(latest, target.x);
    var y = pixelsToPercent(latest, target.y);
    return x + "% " + y + "%";
}
var varToken = "_$css";
function correctBoxShadow(latest, _a) {
    var delta = _a.delta, treeScale = _a.treeScale;
    var original = latest;
    /**
     * We need to first strip and store CSS variables from the string.
     */
    var containsCSSVariables = latest.includes("var(");
    var cssVariables = [];
    if (containsCSSVariables) {
        latest = latest.replace(cssVariableRegex, function (match) {
            cssVariables.push(match);
            return varToken;
        });
    }
    var shadow = complex.parse(latest);
    // TODO: Doesn't support multiple shadows
    if (shadow.length > 5)
        return original;
    var template = complex.createTransformer(latest);
    var offset = typeof shadow[0] !== "number" ? 1 : 0;
    // Calculate the overall context scale
    var xScale = delta.x.scale * treeScale.x;
    var yScale = delta.y.scale * treeScale.y;
    shadow[0 + offset] /= xScale;
    shadow[1 + offset] /= yScale;
    /**
     * Ideally we'd correct x and y scales individually, but because blur and
     * spread apply to both we have to take a scale average and apply that instead.
     * We could potentially improve the outcome of this by incorporating the ratio between
     * the two scales.
     */
    var averageScale = mix(xScale, yScale, 0.5);
    // Blur
    if (typeof shadow[2 + offset] === "number")
        shadow[2 + offset] /= averageScale;
    // Spread
    if (typeof shadow[3 + offset] === "number")
        shadow[3 + offset] /= averageScale;
    var output = template(shadow);
    if (containsCSSVariables) {
        var i_1 = 0;
        output = output.replace(varToken, function () {
            var cssVariable = cssVariables[i_1];
            i_1++;
            return cssVariable;
        });
    }
    return output;
}
var borderCorrectionDefinition = {
    process: correctBorderRadius,
};
var defaultScaleCorrectors = {
    borderRadius: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, borderCorrectionDefinition), { applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
        ] }),
    borderTopLeftRadius: borderCorrectionDefinition,
    borderTopRightRadius: borderCorrectionDefinition,
    borderBottomLeftRadius: borderCorrectionDefinition,
    borderBottomRightRadius: borderCorrectionDefinition,
    boxShadow: {
        process: correctBoxShadow,
    },
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/layout/Animate.js











var progressTarget = 1000;
var Animate = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Animate, _super);
    function Animate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * A mutable object that tracks the target viewport box
         * for the current animation frame.
         */
        _this.frameTarget = (0,geometry/* axisBox */.VZ)();
        /**
         * The current animation target, we use this to check whether to start
         * a new animation or continue the existing one.
         */
        _this.currentAnimationTarget = (0,geometry/* axisBox */.VZ)();
        /**
         * Track whether we're animating this axis.
         */
        _this.isAnimating = {
            x: false,
            y: false,
        };
        _this.stopAxisAnimation = {
            x: undefined,
            y: undefined,
        };
        _this.isAnimatingTree = false;
        _this.animate = function (target, origin, _a) {
            if (_a === void 0) { _a = {}; }
            var originBox = _a.originBox, targetBox = _a.targetBox, visibilityAction = _a.visibilityAction, shouldStackAnimate = _a.shouldStackAnimate, onComplete = _a.onComplete, prevParent = _a.prevParent, config = (0,tslib_es6/* __rest */._T)(_a, ["originBox", "targetBox", "visibilityAction", "shouldStackAnimate", "onComplete", "prevParent"]);
            var _b = _this.props, visualElement = _b.visualElement, layout = _b.layout;
            /**
             * Early return if we've been instructed not to animate this render.
             */
            if (shouldStackAnimate === false) {
                _this.isAnimatingTree = false;
                return _this.safeToRemove();
            }
            /**
             * Prioritise tree animations
             */
            if (_this.isAnimatingTree && shouldStackAnimate !== true) {
                return;
            }
            else if (shouldStackAnimate) {
                _this.isAnimatingTree = true;
            }
            /**
             * Allow the measured origin (prev bounding box) and target (actual layout) to be
             * overridden by the provided config.
             */
            origin = originBox || origin;
            target = targetBox || target;
            /**
             * If this element has a projecting parent, there's an opportunity to animate
             * it relatively to that parent rather than relatively to the viewport. This
             * allows us to add orchestrated animations.
             */
            var isRelative = false;
            var projectionParent = visualElement.getProjectionParent();
            if (projectionParent) {
                var prevParentViewportBox = projectionParent.prevViewportBox;
                var parentLayout = projectionParent.getLayoutState().layout;
                /**
                 * If we're being provided a previous parent VisualElement by AnimateSharedLayout
                 */
                if (prevParent) {
                    /**
                     * If we've been provided an explicit target box it means we're animating back
                     * to this previous parent. So we can make a relative box by comparing to the previous
                     * parent's layout
                     */
                    if (targetBox) {
                        parentLayout = prevParent.getLayoutState().layout;
                    }
                    /**
                     * Likewise if we've been provided an explicit origin box it means we're
                     * animating out from a different element. So we should figure out where that was
                     * on screen relative to the new parent element.
                     */
                    if (originBox &&
                        !checkIfParentHasChanged(prevParent, projectionParent) &&
                        prevParent.prevViewportBox) {
                        prevParentViewportBox = prevParent.prevViewportBox;
                    }
                }
                if (prevParentViewportBox &&
                    isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox)) {
                    isRelative = true;
                    origin = calcRelativeOffset(prevParentViewportBox, origin);
                    target = calcRelativeOffset(parentLayout, target);
                }
            }
            var boxHasMoved = hasMoved(origin, target);
            var animations = eachAxis(function (axis) {
                var _a, _b;
                /**
                 * If layout is set to "position", we can resize the origin box based on the target
                 * box and only animate its position.
                 */
                if (layout === "position") {
                    var targetLength = target[axis].max - target[axis].min;
                    origin[axis].max = origin[axis].min + targetLength;
                }
                if (visualElement.projection.isTargetLocked) {
                    return;
                }
                else if (visibilityAction !== undefined) {
                    visualElement.setVisibility(visibilityAction === AnimateSharedLayout_types/* VisibilityAction.Show */.c.Show);
                }
                else if (boxHasMoved) {
                    // If the box has moved, animate between it's current visual state and its
                    // final state
                    return _this.animateAxis(axis, target[axis], origin[axis], (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, config), { isRelative: isRelative }));
                }
                else {
                    (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 ? void 0 : _b.call(_a);
                    // If the box has remained in the same place, immediately set the axis target
                    // to the final desired state
                    return visualElement.setProjectionTargetAxis(axis, target[axis].min, target[axis].max, isRelative);
                }
            });
            // Force a render to ensure there's no flash of uncorrected bounding box.
            visualElement.syncRender();
            /**
             * If this visualElement isn't present (ie it's been removed from the tree by the user but
             * kept in by the tree by AnimatePresence) then call safeToRemove when all axis animations
             * have successfully finished.
             */
            return Promise.all(animations).then(function () {
                _this.isAnimatingTree = false;
                onComplete && onComplete();
                visualElement.notifyLayoutAnimationComplete();
            });
        };
        return _this;
    }
    Animate.prototype.componentDidMount = function () {
        var _this = this;
        var visualElement = this.props.visualElement;
        visualElement.animateMotionValue = startAnimation;
        visualElement.enableLayoutProjection();
        this.unsubLayoutReady = visualElement.onLayoutUpdate(this.animate);
        visualElement.layoutSafeToRemove = function () { return _this.safeToRemove(); };
        addScaleCorrection(defaultScaleCorrectors);
    };
    Animate.prototype.componentWillUnmount = function () {
        var _this = this;
        this.unsubLayoutReady();
        eachAxis(function (axis) { var _a, _b; return (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 ? void 0 : _b.call(_a); });
    };
    /**
     * TODO: This manually performs animations on the visualElement's layout progress
     * values. It'd be preferable to amend the startLayoutAxisAnimation
     * API to accept more custom animations like this.
     */
    Animate.prototype.animateAxis = function (axis, target, origin, _a) {
        var _this = this;
        var _b, _c;
        var _d = _a === void 0 ? {} : _a, transition = _d.transition, isRelative = _d.isRelative;
        /**
         * If we're not animating to a new target, don't run this animation
         */
        if (this.isAnimating[axis] &&
            axisIsEqual(target, this.currentAnimationTarget[axis])) {
            return;
        }
        (_c = (_b = this.stopAxisAnimation)[axis]) === null || _c === void 0 ? void 0 : _c.call(_b);
        this.isAnimating[axis] = true;
        var visualElement = this.props.visualElement;
        var frameTarget = this.frameTarget[axis];
        var layoutProgress = visualElement.getProjectionAnimationProgress()[axis];
        /**
         * Set layout progress back to 0. We set it twice to hard-reset any velocity that might
         * be re-incoporated into a subsequent spring animation.
         */
        layoutProgress.clearListeners();
        layoutProgress.set(0);
        layoutProgress.set(0);
        /**
         * Create an animation function to run once per frame. This will tween the visual bounding box from
         * origin to target using the latest progress value.
         */
        var frame = function () {
            // Convert the latest layoutProgress, which is a value from 0-1000, into a 0-1 progress
            var p = layoutProgress.get() / progressTarget;
            // Tween the axis and update the visualElement with the latest values
            tweenAxis(frameTarget, origin, target, p);
            visualElement.setProjectionTargetAxis(axis, frameTarget.min, frameTarget.max, isRelative);
        };
        // Synchronously run a frame to ensure there's no flash of the uncorrected bounding box.
        frame();
        // Create a function to stop animation on this specific axis
        var unsubscribeProgress = layoutProgress.onChange(frame);
        this.stopAxisAnimation[axis] = function () {
            _this.isAnimating[axis] = false;
            layoutProgress.stop();
            unsubscribeProgress();
        };
        this.currentAnimationTarget[axis] = target;
        var layoutTransition = transition ||
            visualElement.getDefaultTransition() ||
            defaultLayoutTransition;
        // Start the animation on this axis
        var animation = startAnimation(axis === "x" ? "layoutX" : "layoutY", layoutProgress, progressTarget, layoutTransition && getValueTransition(layoutTransition, "layout")).then(this.stopAxisAnimation[axis]);
        return animation;
    };
    Animate.prototype.safeToRemove = function () {
        var _a, _b;
        (_b = (_a = this.props).safeToRemove) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    Animate.prototype.render = function () {
        return null;
    };
    return Animate;
}(react.Component));
function AnimateLayoutContextProvider(props) {
    var _a = (0,tslib_es6/* __read */.CR)(usePresence(), 2), safeToRemove = _a[1];
    return react.createElement(Animate, (0,tslib_es6/* __assign */.pi)({}, props, { safeToRemove: safeToRemove }));
}
function hasMoved(a, b) {
    return (!isZeroBox(a) &&
        !isZeroBox(b) &&
        (!axisIsEqual(a.x, b.x) || !axisIsEqual(a.y, b.y)));
}
var zeroAxis = { min: 0, max: 0 };
function isZeroBox(a) {
    return axisIsEqual(a.x, zeroAxis) && axisIsEqual(a.y, zeroAxis);
}
function axisIsEqual(a, b) {
    return a.min === b.min && a.max === b.max;
}
var defaultLayoutTransition = {
    duration: 0.45,
    ease: [0.4, 0, 0.1, 1],
};
function isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox) {
    return prevParent || (!prevParent && !(originBox || targetBox));
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/SharedLayoutContext.js + 1 modules
var SharedLayoutContext = __webpack_require__(92513);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/layout/Measure.js





/**
 * This component is responsible for scheduling the measuring of the motion component
 */
var Measure = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Measure, _super);
    function Measure() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * If this is a child of a SyncContext, register the VisualElement with it on mount.
     */
    Measure.prototype.componentDidMount = function () {
        var _a = this.props, syncLayout = _a.syncLayout, framerSyncLayout = _a.framerSyncLayout, visualElement = _a.visualElement;
        (0,SharedLayoutContext/* isSharedLayout */.Md)(syncLayout) && syncLayout.register(visualElement);
        (0,SharedLayoutContext/* isSharedLayout */.Md)(framerSyncLayout) &&
            framerSyncLayout.register(visualElement);
        visualElement.onUnmount(function () {
            if ((0,SharedLayoutContext/* isSharedLayout */.Md)(syncLayout)) {
                syncLayout.remove(visualElement);
            }
            if ((0,SharedLayoutContext/* isSharedLayout */.Md)(framerSyncLayout)) {
                framerSyncLayout.remove(visualElement);
            }
        });
    };
    /**
     * If this is a child of a SyncContext, notify it that it needs to re-render. It will then
     * handle the snapshotting.
     *
     * If it is stand-alone component, add it to the batcher.
     */
    Measure.prototype.getSnapshotBeforeUpdate = function () {
        var _a = this.props, syncLayout = _a.syncLayout, visualElement = _a.visualElement;
        if ((0,SharedLayoutContext/* isSharedLayout */.Md)(syncLayout)) {
            syncLayout.syncUpdate();
        }
        else {
            (0,utils/* snapshotViewportBox */.x7)(visualElement);
            syncLayout.add(visualElement);
        }
        return null;
    };
    Measure.prototype.componentDidUpdate = function () {
        var syncLayout = this.props.syncLayout;
        if (!(0,SharedLayoutContext/* isSharedLayout */.Md)(syncLayout))
            syncLayout.flush();
    };
    Measure.prototype.render = function () {
        return null;
    };
    return Measure;
}(react.Component));
function MeasureContextProvider(props) {
    var syncLayout = (0,react.useContext)(SharedLayoutContext/* SharedLayoutContext */.WH);
    var framerSyncLayout = (0,react.useContext)(SharedLayoutContext/* FramerTreeLayoutContext */.bg);
    return (react.createElement(Measure, (0,tslib_es6/* __assign */.pi)({}, props, { syncLayout: syncLayout, framerSyncLayout: framerSyncLayout })));
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/layout/index.js



var layoutAnimations = {
    measureLayout: MeasureContextProvider,
    layoutAnimation: AnimateLayoutContextProvider,
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/state.js


var createProjectionState = function () { return ({
    isEnabled: false,
    isHydrated: false,
    isTargetLocked: false,
    target: (0,geometry/* axisBox */.VZ)(),
    targetFinal: (0,geometry/* axisBox */.VZ)(),
}); };
function createLayoutState() {
    return {
        isHydrated: false,
        layout: (0,geometry/* axisBox */.VZ)(),
        layoutCorrected: (0,geometry/* axisBox */.VZ)(),
        treeScale: { x: 1, y: 1 },
        delta: (0,geometry/* delta */.pY)(),
        deltaFinal: (0,geometry/* delta */.pY)(),
        deltaTransform: "",
    };
}
var zeroLayout = createLayoutState();



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/utils/build-projection-transform.js


/**
 * Build a transform style that takes a calculated delta between the element's current
 * space on screen and projects it into the desired space.
 */
function buildLayoutProjectionTransform(_a, treeScale, latestTransform) {
    var x = _a.x, y = _a.y;
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */
    var xTranslate = x.translate / treeScale.x;
    var yTranslate = y.translate / treeScale.y;
    var transform = "translate3d(" + xTranslate + "px, " + yTranslate + "px, 0) ";
    if (latestTransform) {
        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
        if (rotate)
            transform += "rotate(" + rotate + ") ";
        if (rotateX)
            transform += "rotateX(" + rotateX + ") ";
        if (rotateY)
            transform += "rotateY(" + rotateY + ") ";
    }
    transform += "scale(" + x.scale + ", " + y.scale + ")";
    return !latestTransform && transform === identityProjection ? "" : transform;
}
/**
 * Take the calculated delta origin and apply it as a transform string.
 */
function buildLayoutProjectionTransformOrigin(_a) {
    var deltaFinal = _a.deltaFinal;
    return deltaFinal.x.origin * 100 + "% " + deltaFinal.y.origin * 100 + "% 0";
}
var identityProjection = buildLayoutProjectionTransform(zeroLayout.delta, zeroLayout.treeScale, { x: 1, y: 1 });



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/lifecycles.js



var names = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "SetAxisTarget",
    "Unmount",
];
function createLifecycles() {
    var managers = names.map(function () { return new SubscriptionManager(); });
    var propSubscriptions = {};
    var lifecycles = {
        clearAllListeners: function () { return managers.forEach(function (manager) { return manager.clear(); }); },
        updatePropListeners: function (props) {
            return names.forEach(function (name) {
                var _a;
                (_a = propSubscriptions[name]) === null || _a === void 0 ? void 0 : _a.call(propSubscriptions);
                var on = "on" + name;
                var propListener = props[on];
                if (propListener) {
                    propSubscriptions[name] = lifecycles[on](propListener);
                }
            });
        },
    };
    managers.forEach(function (manager, i) {
        lifecycles["on" + names[i]] = function (handler) { return manager.add(handler); };
        lifecycles["notify" + names[i]] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return manager.notify.apply(manager, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(args)));
        };
    });
    return lifecycles;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/motion-values.js



function updateMotionValuesFromProps(element, next, prev) {
    var _a;
    for (var key in next) {
        var nextValue = next[key];
        var prevValue = prev[key];
        if (isMotionValue(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */
            element.addValue(key, nextValue);
        }
        else if (isMotionValue(prevValue)) {
            /**
             * If we're swapping to a new motion value, create a new motion value
             * from that
             */
            element.addValue(key, motionValue(nextValue));
        }
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */
            if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            }
            else {
                element.addValue(key, motionValue((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
            }
        }
    }
    // Handle removed values
    for (var key in prev) {
        if (next[key] === undefined)
            element.removeValue(key);
    }
    return next;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/projection.js



function updateLayoutDeltas(_a, _b, treePath, transformOrigin) {
    var delta = _a.delta, layout = _a.layout, layoutCorrected = _a.layoutCorrected, treeScale = _a.treeScale;
    var target = _b.target;
    /**
     * Reset the corrected box with the latest values from box, as we're then going
     * to perform mutative operations on it.
     */
    resetBox(layoutCorrected, layout);
    /**
     * Apply all the parent deltas to this box to produce the corrected box. This
     * is the layout box, as it will appear on screen as a result of the transforms of its parents.
     */
    applyTreeDeltas(layoutCorrected, treeScale, treePath);
    /**
     * Update the delta between the corrected box and the target box before user-set transforms were applied.
     * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
     * for our layout reprojection, but still allow them to be scaled correctly by the user.
     * It might be that to simplify this we may want to accept that user-set scale is also corrected
     * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
     * to allow people to choose whether these styles are corrected based on just the
     * layout reprojection or the final bounding box.
     */
    updateBoxDelta(delta, layoutCorrected, target, transformOrigin);
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/compare-by-depth.js
var compare_by_depth = __webpack_require__(81708);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/flat-tree.js



var FlatTree = /** @class */ (function () {
    function FlatTree() {
        this.children = [];
        this.isDirty = false;
    }
    FlatTree.prototype.add = function (child) {
        addUniqueItem(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.remove = function (child) {
        removeItem(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.forEach = function (callback) {
        this.isDirty && this.children.sort(compare_by_depth/* compareByDepth */._);
        this.isDirty = false;
        this.children.forEach(callback);
    };
    return FlatTree;
}());



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/projection/relative-set.js



function setCurrentViewportBox(visualElement) {
    var projectionParent = visualElement.getProjectionParent();
    if (!projectionParent) {
        visualElement.rebaseProjectionTarget();
        return;
    }
    var relativeOffset = calcRelativeOffset(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
    eachAxis(function (axis) {
        visualElement.setProjectionTargetAxis(axis, relativeOffset[axis].min, relativeOffset[axis].max, true);
    });
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/index.js





















var visualElement = function (_a) {
    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, resetTransform = _a.resetTransform, restoreTransform = _a.restoreTransform, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
    return function (_a, options) {
        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState;
        if (options === void 0) { options = {}; }
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        /**
         * The instance of the render-specific node that will be hydrated by the
         * exposed React ref. So for example, this visual element can host a
         * HTMLElement, plain object, or Three.js object. The functions provided
         * in VisualElementConfig allow us to interface with this instance.
         */
        var instance;
        /**
         * Manages the subscriptions for a visual element's lifecycle, for instance
         * onRender and onViewportBoxUpdate.
         */
        var lifecycles = createLifecycles();
        /**
         *
         */
        var projection = createProjectionState();
        /**
         * A reference to the nearest projecting parent. This is either
         * undefined if we haven't looked for the nearest projecting parent,
         * false if there is no parent performing layout projection, or a reference
         * to the projecting parent.
         */
        var projectionParent;
        /**
         * This is a reference to the visual state of the "lead" visual element.
         * Usually, this will be this visual element. But if it shares a layoutId
         * with other visual elements, only one of them will be designated lead by
         * AnimateSharedLayout. All the other visual elements will take on the visual
         * appearance of the lead while they crossfade to it.
         */
        var leadProjection = projection;
        var leadLatestValues = latestValues;
        var unsubscribeFromLeadVisualElement;
        /**
         * The latest layout measurements and calculated projections. This
         * is seperate from the target projection data in visualState as
         * many visual elements might point to the same piece of visualState as
         * a target, whereas they might each have different layouts and thus
         * projection calculations needed to project into the same viewport box.
         */
        var layoutState = createLayoutState();
        /**
         *
         */
        var crossfader;
        /**
         * Keep track of whether the viewport box has been updated since the
         * last time the layout projection was re-calculated.
         */
        var hasViewportBoxUpdated = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */
        var values = new Map();
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */
        var valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */
        var prevMotionValues = {};
        /**
         * x/y motion values that track the progress of initiated layout
         * animations.
         *
         * TODO: Target for removal
         */
        var projectionTargetProgress;
        /**
         * When values are removed from all animation props we need to search
         * for a fallback value to animate to. These values are tracked in baseTarget.
         */
        var baseTarget = (0,tslib_es6/* __assign */.pi)({}, latestValues);
        // Internal methods ========================
        /**
         * On mount, this will be hydrated with a callback to disconnect
         * this visual element from its parent on unmount.
         */
        var removeFromVariantTree;
        /**
         *
         */
        function render() {
            if (!instance)
                return;
            if (element.isProjectionReady()) {
                /**
                 * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
                 * This is the final box that we will then project into by calculating a transform delta and
                 * applying it to the corrected box.
                 */
                applyBoxTransforms(leadProjection.targetFinal, leadProjection.target, leadLatestValues);
                /**
                 * Update the delta between the corrected box and the final target box, after
                 * user-set transforms are applied to it. This will be used by the renderer to
                 * create a transform style that will reproject the element from its actual layout
                 * into the desired bounding box.
                 */
                updateBoxDelta(layoutState.deltaFinal, layoutState.layoutCorrected, leadProjection.targetFinal, latestValues);
            }
            triggerBuild();
            renderInstance(instance, renderState);
        }
        function triggerBuild() {
            var valuesToRender = latestValues;
            if (crossfader && crossfader.isActive()) {
                var crossfadedValues = crossfader.getCrossfadeState(element);
                if (crossfadedValues)
                    valuesToRender = crossfadedValues;
            }
            build(element, renderState, valuesToRender, leadProjection, layoutState, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        function updateLayoutProjection() {
            if (!element.isProjectionReady())
                return;
            var delta = layoutState.delta, treeScale = layoutState.treeScale;
            var prevTreeScaleX = treeScale.x;
            var prevTreeScaleY = treeScale.y;
            var prevDeltaTransform = layoutState.deltaTransform;
            updateLayoutDeltas(layoutState, leadProjection, element.path, latestValues);
            hasViewportBoxUpdated &&
                element.notifyViewportBoxUpdate(leadProjection.target, delta);
            hasViewportBoxUpdated = false;
            var deltaTransform = buildLayoutProjectionTransform(delta, treeScale);
            if (deltaTransform !== prevDeltaTransform ||
                // Also compare calculated treeScale, for values that rely on this only for scale correction
                prevTreeScaleX !== treeScale.x ||
                prevTreeScaleY !== treeScale.y) {
                element.scheduleRender();
            }
            layoutState.deltaTransform = deltaTransform;
        }
        function updateTreeLayoutProjection() {
            element.layoutTree.forEach(fireUpdateLayoutProjection);
        }
        /**
         *
         */
        function bindToMotionValue(key, value) {
            var removeOnChange = value.onChange(function (latestValue) {
                latestValues[key] = latestValue;
                props.onUpdate && es/* default.update */.ZP.update(update, false, true);
            });
            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, function () {
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */
        var initialMotionValues = scrapeMotionValuesFromProps(props);
        for (var key in initialMotionValues) {
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && isMotionValue(value)) {
                value.set(latestValues[key], false);
            }
        }
        /**
         * Determine what role this visual element should take in the variant tree.
         */
        var isControllingVariants = checkIfControllingVariants(props);
        var isVariantNode = checkIfVariantNode(props);
        var element = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ treeType: treeType, 
            /**
             * This is a mirror of the internal instance prop, which keeps
             * VisualElement type-compatible with React's RefObject.
             */
            current: null, 
            /**
             * The depth of this visual element within the visual element tree.
             */
            depth: parent ? parent.depth + 1 : 0, parent: parent, children: new Set(), 
            /**
             * An ancestor path back to the root visual element. This is used
             * by layout projection to quickly recurse back up the tree.
             */
            path: parent ? (0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(parent.path)), [parent]) : [], layoutTree: parent ? parent.layoutTree : new FlatTree(), 
            /**
             *
             */
            presenceId: presenceId,
            projection: projection, 
            /**
             * If this component is part of the variant tree, it should track
             * any children that are also part of the tree. This is essentially
             * a shadow tree to simplify logic around how to stagger over children.
             */
            variantChildren: isVariantNode ? new Set() : undefined, 
            /**
             * Whether this instance is visible. This can be changed imperatively
             * by AnimateSharedLayout, is analogous to CSS's visibility in that
             * hidden elements should take up layout, and needs enacting by the configured
             * render function.
             */
            isVisible: undefined, 
            /**
             * Normally, if a component is controlled by a parent's variants, it can
             * rely on that ancestor to trigger animations further down the tree.
             * However, if a component is created after its parent is mounted, the parent
             * won't trigger that mount animation so the child needs to.
             *
             * TODO: This might be better replaced with a method isParentMounted
             */
            manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()), 
            /**
             * This can be set by AnimatePresence to force components that mount
             * at the same time as it to mount as if they have initial={false} set.
             */
            blockInitialAnimation: blockInitialAnimation, 
            /**
             * Determine whether this component has mounted yet. This is mostly used
             * by variant children to determine whether they need to trigger their
             * own animations on mount.
             */
            isMounted: function () { return Boolean(instance); }, mount: function (newInstance) {
                instance = element.current = newInstance;
                element.pointTo(element);
                if (isVariantNode && parent && !isControllingVariants) {
                    removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                }
                parent === null || parent === void 0 ? void 0 : parent.children.add(element);
            },
            /**
             *
             */
            unmount: function () {
                es/* cancelSync.update */.qY.update(update);
                es/* cancelSync.render */.qY.render(render);
                es/* cancelSync.preRender */.qY.preRender(element.updateLayoutProjection);
                valueSubscriptions.forEach(function (remove) { return remove(); });
                element.stopLayoutAnimation();
                element.layoutTree.remove(element);
                removeFromVariantTree === null || removeFromVariantTree === void 0 ? void 0 : removeFromVariantTree();
                parent === null || parent === void 0 ? void 0 : parent.children.delete(element);
                unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 ? void 0 : unsubscribeFromLeadVisualElement();
                lifecycles.clearAllListeners();
            },
            /**
             * Add a child visual element to our set of children.
             */
            addVariantChild: function (child) {
                var _a;
                var closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 ? void 0 : _a.add(child);
                    return function () { return closestVariantNode.variantChildren.delete(child); };
                }
            },
            sortNodePosition: function (other) {
                /**
                 * If these nodes aren't even of the same type we can't compare their depth.
                 */
                if (!sortNodePosition || treeType !== other.treeType)
                    return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            }, 
            /**
             * Returns the closest variant node in the tree starting from
             * this visual element.
             */
            getClosestVariantNode: function () {
                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
            }, 
            /**
             * A method that schedules an update to layout projections throughout
             * the tree. We inherit from the parent so there's only ever one
             * job scheduled on the next frame - that of the root visual element.
             */
            scheduleUpdateLayoutProjection: parent
                ? parent.scheduleUpdateLayoutProjection
                : function () {
                    return es/* default.preRender */.ZP.preRender(element.updateTreeLayoutProjection, false, true);
                }, 
            /**
             * Expose the latest layoutId prop.
             */
            getLayoutId: function () { return props.layoutId; }, 
            /**
             * Returns the current instance.
             */
            getInstance: function () { return instance; }, 
            /**
             * Get/set the latest static values.
             */
            getStaticValue: function (key) { return latestValues[key]; }, setStaticValue: function (key, value) { return (latestValues[key] = value); }, 
            /**
             * Returns the latest motion value state. Currently only used to take
             * a snapshot of the visual element - perhaps this can return the whole
             * visual state
             */
            getLatestValues: function () { return latestValues; }, 
            /**
             * Set the visiblity of the visual element. If it's changed, schedule
             * a render to reflect these changes.
             */
            setVisibility: function (visibility) {
                if (element.isVisible === visibility)
                    return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            /**
             * Make a target animatable by Popmotion. For instance, if we're
             * trying to animate width from 100px to 100vw we need to measure 100vw
             * in pixels to determine what we really need to animate to. This is also
             * pluggable to support Framer's custom value types like Color,
             * and CSS variables.
             */
            makeTargetAnimatable: function (target, canMutate) {
                if (canMutate === void 0) { canMutate = true; }
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            // Motion values ========================
            /**
             * Add a motion value and bind it to this visual element.
             */
            addValue: function (key, value) {
                // Remove existing value if it exists
                if (element.hasValue(key))
                    element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            /**
             * Remove a motion value and unbind any active subscriptions.
             */
            removeValue: function (key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 ? void 0 : _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            }, 
            /**
             * Check whether we have a motion value for this key
             */
            hasValue: function (key) { return values.has(key); }, 
            /**
             * Get a motion value for this key. If called with a default
             * value, we'll create one if none exists.
             */
            getValue: function (key, defaultValue) {
                var value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = motionValue(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            }, 
            /**
             * Iterate over our motion values.
             */
            forEachValue: function (callback) { return values.forEach(callback); }, 
            /**
             * If we're trying to animate to a previously unencountered value,
             * we need to check for it in our state and as a last resort read it
             * directly from the instance (which might have performance implications).
             */
            readValue: function (key) { var _a; return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options); }, 
            /**
             * Set the base target to later animate back to. This is currently
             * only hydrated on creation and when we first read a value.
             */
            setBaseTarget: function (key, value) {
                baseTarget[key] = value;
            },
            /**
             * Find the base target for a value thats been removed from all animation
             * props.
             */
            getBaseTarget: function (key) {
                if (getBaseTarget) {
                    var target = getBaseTarget(props, key);
                    if (target !== undefined && !isMotionValue(target))
                        return target;
                }
                return baseTarget[key];
            } }, lifecycles), { 
            /**
             * Build the renderer state based on the latest visual state.
             */
            build: function () {
                triggerBuild();
                return renderState;
            },
            /**
             * Schedule a render on the next animation frame.
             */
            scheduleRender: function () {
                es/* default.render */.ZP.render(render, false, true);
            }, 
            /**
             * Synchronously fire render. It's prefered that we batch renders but
             * in many circumstances, like layout measurement, we need to run this
             * synchronously. However in those instances other measures should be taken
             * to batch reads/writes.
             */
            syncRender: render, 
            /**
             * Update the provided props. Ensure any newly-added motion values are
             * added to our map, old ones removed, and listeners updated.
             */
            setProps: function (newProps) {
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = updateMotionValuesFromProps(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            }, getProps: function () { return props; }, 
            // Variants ==============================
            /**
             * Returns the variant definition with a given name.
             */
            getVariant: function (name) { var _a; return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name]; }, 
            /**
             * Returns the defined default transition on this component.
             */
            getDefaultTransition: function () { return props.transition; }, 
            /**
             * Used by child variant nodes to get the closest ancestor variant props.
             */
            getVariantContext: function (startAtParent) {
                if (startAtParent === void 0) { startAtParent = false; }
                if (startAtParent)
                    return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) {
                        context_1.initial = props.initial;
                    }
                    return context_1;
                }
                var context = {};
                for (var i = 0; i < numVariantProps; i++) {
                    var name_1 = variantProps[i];
                    var prop = props[name_1];
                    if (isVariantLabel(prop) || prop === false) {
                        context[name_1] = prop;
                    }
                }
                return context;
            },
            // Layout projection ==============================
            /**
             * Enable layout projection for this visual element. Won't actually
             * occur until we also have hydrated layout measurements.
             */
            enableLayoutProjection: function () {
                projection.isEnabled = true;
                element.layoutTree.add(element);
            },
            /**
             * Lock the projection target, for instance when dragging, so
             * nothing else can try and animate it.
             */
            lockProjectionTarget: function () {
                projection.isTargetLocked = true;
            },
            unlockProjectionTarget: function () {
                element.stopLayoutAnimation();
                projection.isTargetLocked = false;
            }, getLayoutState: function () { return layoutState; }, setCrossfader: function (newCrossfader) {
                crossfader = newCrossfader;
            }, isProjectionReady: function () {
                return projection.isEnabled &&
                    projection.isHydrated &&
                    layoutState.isHydrated;
            }, 
            /**
             * Start a layout animation on a given axis.
             */
            startLayoutAnimation: function (axis, transition, isRelative) {
                if (isRelative === void 0) { isRelative = false; }
                var progress = element.getProjectionAnimationProgress()[axis];
                var _a = isRelative
                    ? projection.relativeTarget[axis]
                    : projection.target[axis], min = _a.min, max = _a.max;
                var length = max - min;
                progress.clearListeners();
                progress.set(min);
                progress.set(min); // Set twice to hard-reset velocity
                progress.onChange(function (v) {
                    element.setProjectionTargetAxis(axis, v, v + length, isRelative);
                });
                return element.animateMotionValue(axis, progress, 0, transition);
            },
            /**
             * Stop layout animations.
             */
            stopLayoutAnimation: function () {
                eachAxis(function (axis) {
                    return element.getProjectionAnimationProgress()[axis].stop();
                });
            },
            /**
             * Measure the current viewport box with or without transforms.
             * Only measures axis-aligned boxes, rotate and skew must be manually
             * removed with a re-render to work.
             */
            measureViewportBox: function (withTransform) {
                if (withTransform === void 0) { withTransform = true; }
                var viewportBox = measureViewportBox(instance, options);
                if (!withTransform)
                    removeBoxTransforms(viewportBox, latestValues);
                return viewportBox;
            },
            /**
             * Get the motion values tracking the layout animations on each
             * axis. Lazy init if not already created.
             */
            getProjectionAnimationProgress: function () {
                projectionTargetProgress || (projectionTargetProgress = {
                    x: motionValue(0),
                    y: motionValue(0),
                });
                return projectionTargetProgress;
            },
            /**
             * Update the projection of a single axis. Schedule an update to
             * the tree layout projection.
             */
            setProjectionTargetAxis: function (axis, min, max, isRelative) {
                if (isRelative === void 0) { isRelative = false; }
                var target;
                if (isRelative) {
                    if (!projection.relativeTarget) {
                        projection.relativeTarget = (0,geometry/* axisBox */.VZ)();
                    }
                    target = projection.relativeTarget[axis];
                }
                else {
                    projection.relativeTarget = undefined;
                    target = projection.target[axis];
                }
                projection.isHydrated = true;
                target.min = min;
                target.max = max;
                // Flag that we want to fire the onViewportBoxUpdate event handler
                hasViewportBoxUpdated = true;
                lifecycles.notifySetAxisTarget();
            },
            /**
             * Rebase the projection target on top of the provided viewport box
             * or the measured layout. This ensures that non-animating elements
             * don't fall out of sync differences in measurements vs projections
             * after a page scroll or other relayout.
             */
            rebaseProjectionTarget: function (force, box) {
                if (box === void 0) { box = layoutState.layout; }
                var _a = element.getProjectionAnimationProgress(), x = _a.x, y = _a.y;
                var shouldRebase = !projection.relativeTarget &&
                    !projection.isTargetLocked &&
                    !x.isAnimating() &&
                    !y.isAnimating();
                if (force || shouldRebase) {
                    eachAxis(function (axis) {
                        var _a = box[axis], min = _a.min, max = _a.max;
                        element.setProjectionTargetAxis(axis, min, max);
                    });
                }
            },
            /**
             * Notify the visual element that its layout is up-to-date.
             * Currently Animate.tsx uses this to check whether a layout animation
             * needs to be performed.
             */
            notifyLayoutReady: function (config) {
                setCurrentViewportBox(element);
                element.notifyLayoutUpdate(layoutState.layout, element.prevViewportBox || layoutState.layout, config);
            }, 
            /**
             * Temporarily reset the transform of the instance.
             */
            resetTransform: function () { return resetTransform(element, instance, props); }, restoreTransform: function () { return restoreTransform(instance, renderState); }, updateLayoutProjection: updateLayoutProjection,
            updateTreeLayoutProjection: function () {
                element.layoutTree.forEach(fireResolveRelativeTargetBox);
                /**
                 * Schedule the projection updates at the end of the current preRender
                 * step. This will ensure that all layout trees will first resolve
                 * relative projection boxes into viewport boxes, and *then*
                 * update projections.
                 */
                es/* default.preRender */.ZP.preRender(updateTreeLayoutProjection, false, true);
                // sync.postRender(() => element.scheduleUpdateLayoutProjection())
            },
            getProjectionParent: function () {
                if (projectionParent === undefined) {
                    var foundParent = false;
                    // Search backwards through the tree path
                    for (var i = element.path.length - 1; i >= 0; i--) {
                        var ancestor = element.path[i];
                        if (ancestor.projection.isEnabled) {
                            foundParent = ancestor;
                            break;
                        }
                    }
                    projectionParent = foundParent;
                }
                return projectionParent;
            },
            resolveRelativeTargetBox: function () {
                var relativeParent = element.getProjectionParent();
                if (!projection.relativeTarget || !relativeParent)
                    return;
                calcRelativeBox(projection, relativeParent.projection);
                if (isDraggable(relativeParent)) {
                    var target = projection.target;
                    applyBoxTransforms(target, target, relativeParent.getLatestValues());
                }
            },
            shouldResetTransform: function () {
                return Boolean(props._layoutResetTransform);
            },
            /**
             *
             */
            pointTo: function (newLead) {
                leadProjection = newLead.projection;
                leadLatestValues = newLead.getLatestValues();
                /**
                 * Subscribe to lead component's layout animations
                 */
                unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 ? void 0 : unsubscribeFromLeadVisualElement();
                unsubscribeFromLeadVisualElement = pipe(newLead.onSetAxisTarget(element.scheduleUpdateLayoutProjection), newLead.onLayoutAnimationComplete(function () {
                    var _a;
                    if (element.isPresent) {
                        element.presence = AnimateSharedLayout_types/* Presence.Present */.z.Present;
                    }
                    else {
                        (_a = element.layoutSafeToRemove) === null || _a === void 0 ? void 0 : _a.call(element);
                    }
                }));
            }, 
            // TODO: Clean this up
            isPresent: true, presence: AnimateSharedLayout_types/* Presence.Entering */.z.Entering });
        return element;
    };
};
function fireResolveRelativeTargetBox(child) {
    child.resolveRelativeTargetBox();
}
function fireUpdateLayoutProjection(child) {
    child.updateLayoutProjection();
}
var variantProps = (0,tslib_es6/* __spreadArray */.ev)(["initial"], (0,tslib_es6/* __read */.CR)(variantPriorityOrder));
var numVariantProps = variantProps.length;



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/unit-conversion.js







var positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
]);
var isPositionalKey = function (key) { return positionalKeys.has(key); };
var hasPositionalKey = function (target) {
    return Object.keys(target).some(isPositionalKey);
};
var setAndResetVelocity = function (value, to) {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
var isNumOrPxType = function (v) {
    return v === number || v === px;
};
var BoundingBoxDimension;
(function (BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
var getPosFromMatrix = function (matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var getTranslateFromMatrix = function (pos2, pos3) { return function (_bbox, _a) {
    var transform = _a.transform;
    if (transform === "none" || !transform)
        return 0;
    var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
        return getPosFromMatrix(matrix3d[1], pos3);
    }
    else {
        var matrix = transform.match(/^matrix\((.+)\)$/);
        if (matrix) {
            return getPosFromMatrix(matrix[1], pos2);
        }
        else {
            return 0;
        }
    }
}; };
var transformKeys = new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformProps.filter(function (key) { return !transformKeys.has(key); });
function removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    nonTranslationalTransformKeys.forEach(function (key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([key, value.get()]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length)
        visualElement.syncRender();
    return removedTransforms;
}
var positionalValues = {
    // Dimensions
    width: function (_a) {
        var x = _a.x;
        return x.max - x.min;
    },
    height: function (_a) {
        var y = _a.y;
        return y.max - y.min;
    },
    top: function (_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function (_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function (_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function (_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: getTranslateFromMatrix(4, 13),
    y: getTranslateFromMatrix(5, 14),
};
var convertChangedValueTypes = function (target, visualElement, changedKeys) {
    var originBbox = visualElement.measureViewportBox();
    var element = visualElement.getInstance();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display, top = elementComputedStyle.top, left = elementComputedStyle.left, bottom = elementComputedStyle.bottom, right = elementComputedStyle.right, transform = elementComputedStyle.transform;
    var originComputedStyle = { top: top, left: left, bottom: bottom, right: right, transform: transform };
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") {
        visualElement.setStaticValue("display", target.display || "block");
    }
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.syncRender();
    var targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach(function (key) {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        var value = visualElement.getValue(key);
        setAndResetVelocity(value, positionalValues[key](originBbox, originComputedStyle));
        target[key] = positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var checkAndConvertChangedValueTypes = function (visualElement, target, origin, transitionEnd) {
    if (origin === void 0) { origin = {}; }
    if (transitionEnd === void 0) { transitionEnd = {}; }
    target = (0,tslib_es6/* __assign */.pi)({}, target);
    transitionEnd = (0,tslib_es6/* __assign */.pi)({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function (key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key))
            return;
        var from = origin[key];
        var to = target[key];
        var fromType = findDimensionValueType(from);
        var toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if (isKeyframesTarget(to)) {
            var numKeyframes = to.length;
            for (var i = to[0] === null ? 1 : 0; i < numKeyframes; i++) {
                if (!toType) {
                    toType = findDimensionValueType(to[i]);
                    invariant(toType === fromType ||
                        (isNumOrPxType(fromType) && isNumOrPxType(toType)), "Keyframes must be of the same dimension as the current value");
                }
                else {
                    invariant(findDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
                }
            }
        }
        else {
            toType = findDimensionValueType(to);
        }
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") {
                    value.set(parseFloat(current));
                }
                if (typeof to === "string") {
                    target[key] = parseFloat(to);
                }
                else if (Array.isArray(to) && toType === px) {
                    target[key] = to.map(parseFloat);
                }
            }
            else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) &&
                (toType === null || toType === void 0 ? void 0 : toType.transform) &&
                (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) {
                    value.set(toType.transform(from));
                }
                else {
                    target[key] = fromType.transform(to);
                }
            }
            else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] =
                    transitionEnd[key] !== undefined
                        ? transitionEnd[key]
                        : target[key];
                setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) {
            removedTransformValues.forEach(function (_a) {
                var _b = (0,tslib_es6/* __read */.CR)(_a, 2), key = _b[0], value = _b[1];
                visualElement.getValue(key).set(value);
            });
        }
        // Reapply original values
        visualElement.syncRender();
        return { target: convertedTarget, transitionEnd: transitionEnd };
    }
    else {
        return { target: target, transitionEnd: transitionEnd };
    }
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */
function unitConversion(visualElement, target, origin, transitionEnd) {
    return hasPositionalKey(target)
        ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd)
        : { target: target, transitionEnd: transitionEnd };
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/parse-dom-variant.js



/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */
var parseDomVariant = function (visualElement, target, origin, transitionEnd) {
    var resolved = resolveCSSVariables(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return unitConversion(visualElement, target, origin, transitionEnd);
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/visual-element.js













function visual_element_getComputedStyle(element) {
    return window.getComputedStyle(element);
}
var htmlConfig = {
    treeType: "dom",
    readValueFromInstance: function (domElement, key) {
        if (isTransformProp(key)) {
            var defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        else {
            var computedStyle = visual_element_getComputedStyle(domElement);
            return ((isCSSVariable(key)
                ? computedStyle.getPropertyValue(key)
                : computedStyle[key]) || 0);
        }
    },
    sortNodePosition: function (a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */
        return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget: function (props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox: function (element, _a) {
        var transformPagePoint = _a.transformPagePoint;
        return getBoundingBox(element, transformPagePoint);
    },
    /**
     * Reset the transform on the current Element. This is called as part
     * of a batched process across the entire layout tree. To remove this write
     * cycle it'd be interesting to see if it's possible to "undo" all the current
     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
     * works
     */
    resetTransform: function (element, domElement, props) {
        var transformTemplate = props.transformTemplate;
        domElement.style.transform = transformTemplate
            ? transformTemplate({}, "")
            : "none";
        // Ensure that whatever happens next, we restore our transform on the next frame
        element.scheduleRender();
    },
    restoreTransform: function (instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState: function (key, _a) {
        var vars = _a.vars, style = _a.style;
        delete vars[key];
        delete style[key];
    },
    /**
     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
     * can be animated by Motion.
     */
    makeTargetAnimatable: function (element, _a, _b, isMounted) {
        var transformValues = _b.transformValues;
        if (isMounted === void 0) { isMounted = true; }
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = (0,tslib_es6/* __rest */._T)(_a, ["transition", "transitionEnd"]);
        var origin = getOrigin(target, transition || {}, element);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */
        if (transformValues) {
            if (transitionEnd)
                transitionEnd = transformValues(transitionEnd);
            if (target)
                target = transformValues(target);
            if (origin)
                origin = transformValues(origin);
        }
        if (isMounted) {
            checkTargetForNewValues(element, target, origin);
            var parsed = parseDomVariant(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return (0,tslib_es6/* __assign */.pi)({ transition: transition,
            transitionEnd: transitionEnd }, target);
    },
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
    build: function (element, renderState, latestValues, projection, layoutState, options, props) {
        if (element.isVisible !== undefined) {
            renderState.style.visibility = element.isVisible
                ? "visible"
                : "hidden";
        }
        var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
        buildHTMLStyles(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? buildLayoutProjectionTransform : undefined, isProjectionTranform
            ? buildLayoutProjectionTransformOrigin
            : undefined);
    },
    render: renderHTML,
};
var htmlVisualElement = visualElement(htmlConfig);



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/visual-element.js












var svgVisualElement = visualElement((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, htmlConfig), { getBaseTarget: function (props, key) {
        return props[key];
    },
    readValueFromInstance: function (domElement, key) {
        var _a;
        if (isTransformProp(key)) {
            return ((_a = getDefaultValueType(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        }
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        return domElement.getAttribute(key);
    },
    scrapeMotionValuesFromProps: scrape_motion_values_scrapeMotionValuesFromProps,
    build: function (_element, renderState, latestValues, projection, layoutState, options, props) {
        var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
        buildSVGAttrs(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? buildLayoutProjectionTransform : undefined, isProjectionTranform
            ? buildLayoutProjectionTransformOrigin
            : undefined);
    }, render: renderSVG }));



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/create-visual-element.js




var create_visual_element_createDomVisualElement = function (Component, options) {
    return isSVGComponent(Component)
        ? svgVisualElement(options, { enableHardwareAcceleration: false })
        : htmlVisualElement(options, { enableHardwareAcceleration: true });
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js










var featureBundle = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, animations), gestureAnimations), drag), layoutAnimations);
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */
var motion = /*@__PURE__*/ createMotionProxy(function (Component, config) {
    return create_config_createDomMotionConfig(Component, config, featureBundle, create_visual_element_createDomVisualElement);
});
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */
function createDomMotionComponent(key) {
    return createMotionComponent(createDomMotionConfig(key, { forwardMotionProps: false }, featureBundle, createDomVisualElement));
}




/***/ }),

/***/ 56962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "de": function() { return /* binding */ updateLayoutMeasurement; },
/* harmony export */   "e3": function() { return /* binding */ collectProjectingChildren; },
/* harmony export */   "kv": function() { return /* binding */ collectProjectingAncestors; },
/* harmony export */   "x7": function() { return /* binding */ snapshotViewportBox; }
/* harmony export */ });
/* harmony import */ var framesync__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26765);
/* harmony import */ var _utils_geometry_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19125);
/* harmony import */ var _utils_compare_by_depth_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81708);




function isProjecting(visualElement) {
    var isEnabled = visualElement.projection.isEnabled;
    return isEnabled || visualElement.shouldResetTransform();
}
function collectProjectingAncestors(visualElement, ancestors) {
    if (ancestors === void 0) { ancestors = []; }
    var parent = visualElement.parent;
    if (parent)
        collectProjectingAncestors(parent, ancestors);
    if (isProjecting(visualElement))
        ancestors.push(visualElement);
    return ancestors;
}
function collectProjectingChildren(visualElement) {
    var children = [];
    var addChild = function (child) {
        if (isProjecting(child))
            children.push(child);
        child.children.forEach(addChild);
    };
    visualElement.children.forEach(addChild);
    return children.sort(_utils_compare_by_depth_js__WEBPACK_IMPORTED_MODULE_1__/* .compareByDepth */ ._);
}
/**
 * Update the layoutState by measuring the DOM layout. This
 * should be called after resetting any layout-affecting transforms.
 */
function updateLayoutMeasurement(visualElement) {
    if (visualElement.shouldResetTransform())
        return;
    var layoutState = visualElement.getLayoutState();
    visualElement.notifyBeforeLayoutMeasure(layoutState.layout);
    layoutState.isHydrated = true;
    layoutState.layout = visualElement.measureViewportBox();
    layoutState.layoutCorrected = (0,_utils_geometry_index_js__WEBPACK_IMPORTED_MODULE_2__/* .copyAxisBox */ .nP)(layoutState.layout);
    visualElement.notifyLayoutMeasure(layoutState.layout, visualElement.prevViewportBox || layoutState.layout);
    framesync__WEBPACK_IMPORTED_MODULE_0__/* ["default"].update */ .ZP.update(function () { return visualElement.rebaseProjectionTarget(); });
}
/**
 * Record the viewport box as it was before an expected mutation/re-render
 */
function snapshotViewportBox(visualElement) {
    if (visualElement.shouldResetTransform())
        return;
    visualElement.prevViewportBox = visualElement.measureViewportBox(false);
    /**
     * Update targetBox to match the prevViewportBox. This is just to ensure
     * that targetBox is affected by scroll in the same way as the measured box
     */
    visualElement.rebaseProjectionTarget(false, visualElement.prevViewportBox);
}




/***/ }),

/***/ 78091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ flushLayout; },
/* harmony export */   "U": function() { return /* binding */ batchLayout; }
/* harmony export */ });
var unresolvedJobs = new Set();
function pushJob(stack, job, pointer) {
    if (!stack[pointer])
        stack[pointer] = [];
    stack[pointer].push(job);
}
function batchLayout(callback) {
    unresolvedJobs.add(callback);
    return function () { return unresolvedJobs.delete(callback); };
}
function flushLayout() {
    if (!unresolvedJobs.size)
        return;
    var pointer = 0;
    var reads = [[]];
    var writes = [];
    var setRead = function (job) { return pushJob(reads, job, pointer); };
    var setWrite = function (job) {
        pushJob(writes, job, pointer);
        pointer++;
    };
    /**
     * Resolve jobs into their array stacks
     */
    unresolvedJobs.forEach(function (callback) {
        callback(setRead, setWrite);
        pointer = 0;
    });
    unresolvedJobs.clear();
    /**
     * Execute jobs
     */
    var numStacks = writes.length;
    for (var i = 0; i <= numStacks; i++) {
        reads[i] && reads[i].forEach(executeJob);
        writes[i] && writes[i].forEach(executeJob);
    }
}
var executeJob = function (job) { return job(); };




/***/ }),

/***/ 81708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ compareByDepth; }
/* harmony export */ });
var compareByDepth = function (a, b) {
    return a.depth - b.depth;
};




/***/ }),

/***/ 19125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VZ": function() { return /* binding */ axisBox; },
  "_6": function() { return /* binding */ convertAxisBoxToBoundingBox; },
  "RX": function() { return /* binding */ convertBoundingBoxToAxisBox; },
  "nP": function() { return /* binding */ copyAxisBox; },
  "pY": function() { return /* binding */ delta; },
  "dV": function() { return /* binding */ transformBoundingBox; }
});

// EXTERNAL MODULE: ./node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(55845);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/noop.js
function noop(any) {
    return any;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/geometry/index.js



/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */
function convertBoundingBoxToAxisBox(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: { min: left, max: right },
        y: { min: top, max: bottom },
    };
}
function convertAxisBoxToBoundingBox(_a) {
    var x = _a.x, y = _a.y;
    return {
        top: y.min,
        bottom: y.max,
        left: x.min,
        right: x.max,
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */
function transformBoundingBox(_a, transformPoint) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    if (transformPoint === void 0) { transformPoint = noop; }
    var topLeft = transformPoint({ x: left, y: top });
    var bottomRight = transformPoint({ x: right, y: bottom });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x,
    };
}
/**
 * Create an empty axis box of zero size
 */
function axisBox() {
    return { x: { min: 0, max: 1 }, y: { min: 0, max: 1 } };
}
function copyAxisBox(box) {
    return {
        x: (0,tslib_es6/* __assign */.pi)({}, box.x),
        y: (0,tslib_es6/* __assign */.pi)({}, box.y),
    };
}
/**
 * Create an empty box delta
 */
var zeroDelta = {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0,
};
function delta() {
    return {
        x: (0,tslib_es6/* __assign */.pi)({}, zeroDelta),
        y: (0,tslib_es6/* __assign */.pi)({}, zeroDelta),
    };
}




/***/ }),

/***/ 71435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useConstant; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);


/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */
function useConstant(init) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    if (ref.current === null) {
        ref.current = init();
    }
    return ref.current;
}




/***/ }),

/***/ 17249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useUnmountEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);


function useUnmountEffect(callback) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () { return function () { return callback(); }; }, []);
}




/***/ }),

/***/ 55845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CR": function() { return /* binding */ __read; },
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "ev": function() { return /* binding */ __spreadArray; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 26765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qY": function() { return /* binding */ cancelSync; },
  "ZP": function() { return /* binding */ es; },
  "iW": function() { return /* binding */ flushSync; },
  "$B": function() { return /* binding */ getFrameData; }
});

;// CONCATENATED MODULE: ./node_modules/framesync/dist/es/on-next-frame.js
var defaultTimestep = (1 / 60) * 1000;
var getCurrentTime = typeof performance !== "undefined"
    ? function () { return performance.now(); }
    : function () { return Date.now(); };
var onNextFrame = typeof window !== "undefined"
    ? function (callback) {
        return window.requestAnimationFrame(callback);
    }
    : function (callback) {
        return setTimeout(function () { return callback(getCurrentTime()); }, defaultTimestep);
    };



;// CONCATENATED MODULE: ./node_modules/framesync/dist/es/create-render-step.js
function createRenderStep(runNextFrame) {
    var toRun = [];
    var toRunNextFrame = [];
    var numToRun = 0;
    var isProcessing = false;
    var toKeepAlive = new WeakSet();
    var step = {
        schedule: function (callback, keepAlive, immediate) {
            if (keepAlive === void 0) { keepAlive = false; }
            if (immediate === void 0) { immediate = false; }
            var addToCurrentFrame = immediate && isProcessing;
            var buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive)
                toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing)
                    numToRun = toRun.length;
            }
            return callback;
        },
        cancel: function (callback) {
            var index = toRunNextFrame.indexOf(callback);
            if (index !== -1)
                toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: function (frameData) {
            var _a;
            isProcessing = true;
            _a = [toRunNextFrame, toRun], toRun = _a[0], toRunNextFrame = _a[1];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) {
                for (var i = 0; i < numToRun; i++) {
                    var callback = toRun[i];
                    callback(frameData);
                    if (toKeepAlive.has(callback)) {
                        step.schedule(callback);
                        runNextFrame();
                    }
                }
            }
            isProcessing = false;
        },
    };
    return step;
}



;// CONCATENATED MODULE: ./node_modules/framesync/dist/es/index.js



var maxElapsed = 40;
var useDefaultElapsed = true;
var runNextFrame = false;
var isProcessing = false;
var es_frame = {
    delta: 0,
    timestamp: 0
};
var stepsOrder = ["read", "update", "preRender", "render", "postRender"];
var steps = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    acc[key] = createRenderStep(function () {
        return runNextFrame = true;
    });
    return acc;
}, {});
var sync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    var step = steps[key];
    acc[key] = function (process, keepAlive, immediate) {
        if (keepAlive === void 0) {
            keepAlive = false;
        }
        if (immediate === void 0) {
            immediate = false;
        }
        if (!runNextFrame) startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
var cancelSync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    acc[key] = steps[key].cancel;
    return acc;
}, {});
var flushSync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    acc[key] = function () {
        return steps[key].process(es_frame);
    };
    return acc;
}, {});
var processStep = function (stepId) {
    return steps[stepId].process(es_frame);
};
var processFrame = function (timestamp) {
    runNextFrame = false;
    es_frame.delta = useDefaultElapsed ? defaultTimestep : Math.max(Math.min(timestamp - es_frame.timestamp, maxElapsed), 1);
    es_frame.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (runNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
var startLoop = function () {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing) onNextFrame(processFrame);
};
var getFrameData = function () {
    return es_frame;
};

/* harmony default export */ var es = (sync);



/***/ }),

/***/ 86153:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(1530),
    root = __webpack_require__(11217);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 55706:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(66695),
    hashDelete = __webpack_require__(79326),
    hashGet = __webpack_require__(39010),
    hashHas = __webpack_require__(73098),
    hashSet = __webpack_require__(5223);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 18999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(55289),
    listCacheDelete = __webpack_require__(33913),
    listCacheGet = __webpack_require__(4870),
    listCacheHas = __webpack_require__(68121),
    listCacheSet = __webpack_require__(17211);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 9279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(1530),
    root = __webpack_require__(11217);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 5437:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(68861),
    mapCacheDelete = __webpack_require__(34785),
    mapCacheGet = __webpack_require__(72753),
    mapCacheHas = __webpack_require__(61757),
    mapCacheSet = __webpack_require__(65659);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 8776:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(1530),
    root = __webpack_require__(11217);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 86197:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(1530),
    root = __webpack_require__(11217);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 63378:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(5437),
    setCacheAdd = __webpack_require__(42231),
    setCacheHas = __webpack_require__(27464);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 33919:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(18999),
    stackClear = __webpack_require__(71880),
    stackDelete = __webpack_require__(12550),
    stackGet = __webpack_require__(67420),
    stackHas = __webpack_require__(90870),
    stackSet = __webpack_require__(93438);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 27665:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(11217);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 8625:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(11217);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 55728:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(1530),
    root = __webpack_require__(11217);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 60178:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 15738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(27652),
    isArguments = __webpack_require__(74223),
    isArray = __webpack_require__(73370),
    isBuffer = __webpack_require__(17973),
    isIndex = __webpack_require__(4063),
    isTypedArray = __webpack_require__(29717);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 47860:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 298:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 59147:
/***/ (function(module) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),

/***/ 52664:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 24036:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ 10510:
/***/ (function(module) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),

/***/ 49726:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(25473);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 23163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(69710);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 25235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(20724);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 58780:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(25235),
    keys = __webpack_require__(80412);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 98366:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(10190),
    toKey = __webpack_require__(57304);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 49534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(298),
    isArray = __webpack_require__(73370);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 33854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(27665),
    getRawTag = __webpack_require__(50293),
    objectToString = __webpack_require__(66594);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 36928:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),

/***/ 54966:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 25190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33854),
    isObjectLike = __webpack_require__(63646);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 5196:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(22809),
    isObjectLike = __webpack_require__(63646);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 22809:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(33919),
    equalArrays = __webpack_require__(12696),
    equalByTag = __webpack_require__(57241),
    equalObjects = __webpack_require__(74655),
    getTag = __webpack_require__(26659),
    isArray = __webpack_require__(73370),
    isBuffer = __webpack_require__(17973),
    isTypedArray = __webpack_require__(29717);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 45843:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(33919),
    baseIsEqual = __webpack_require__(5196);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 51178:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(64922),
    isMasked = __webpack_require__(25717),
    isObject = __webpack_require__(4278),
    toSource = __webpack_require__(19275);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 83932:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33854),
    isLength = __webpack_require__(78568),
    isObjectLike = __webpack_require__(63646);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 65109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(57720),
    baseMatchesProperty = __webpack_require__(16404),
    identity = __webpack_require__(60100),
    isArray = __webpack_require__(73370),
    property = __webpack_require__(45681);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 70017:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(84707),
    nativeKeys = __webpack_require__(31371);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 57720:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(45843),
    getMatchData = __webpack_require__(5942),
    matchesStrictComparable = __webpack_require__(58589);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 16404:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(5196),
    get = __webpack_require__(89914),
    hasIn = __webpack_require__(83159),
    isKey = __webpack_require__(61713),
    isStrictComparable = __webpack_require__(4409),
    matchesStrictComparable = __webpack_require__(58589),
    toKey = __webpack_require__(57304);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 16548:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 33325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(98366);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 929:
/***/ (function(module) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),

/***/ 10232:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 27652:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 65211:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(27665),
    arrayMap = __webpack_require__(47860),
    isArray = __webpack_require__(73370),
    isSymbol = __webpack_require__(44872);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 69661:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 10248:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 10190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(73370),
    isKey = __webpack_require__(61713),
    stringToPath = __webpack_require__(89726),
    toString = __webpack_require__(72509);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 25463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(10232);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ 63177:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(11217);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 20724:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 99361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castSlice = __webpack_require__(25463),
    hasUnicode = __webpack_require__(26381),
    stringToArray = __webpack_require__(14002),
    toString = __webpack_require__(72509);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),

/***/ 38127:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayReduce = __webpack_require__(59147),
    deburr = __webpack_require__(95200),
    words = __webpack_require__(71335);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),

/***/ 7350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(929);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),

/***/ 69710:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(1530);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 12696:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(63378),
    arraySome = __webpack_require__(52664),
    cacheHas = __webpack_require__(10248);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 57241:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(27665),
    Uint8Array = __webpack_require__(8625),
    eq = __webpack_require__(25473),
    equalArrays = __webpack_require__(12696),
    mapToArray = __webpack_require__(74940),
    setToArray = __webpack_require__(33200);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 74655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(38263);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 42759:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 38263:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(49534),
    getSymbols = __webpack_require__(3669),
    keys = __webpack_require__(80412);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 23716:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(32592);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 5942:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(4409),
    keys = __webpack_require__(80412);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 1530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(51178),
    getValue = __webpack_require__(41849);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 50293:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(27665);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 3669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(60178),
    stubArray = __webpack_require__(41897);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 26659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(86153),
    Map = __webpack_require__(9279),
    Promise = __webpack_require__(8776),
    Set = __webpack_require__(86197),
    WeakMap = __webpack_require__(55728),
    baseGetTag = __webpack_require__(33854),
    toSource = __webpack_require__(19275);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 41849:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 92434:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(10190),
    isArguments = __webpack_require__(74223),
    isArray = __webpack_require__(73370),
    isIndex = __webpack_require__(4063),
    isLength = __webpack_require__(78568),
    toKey = __webpack_require__(57304);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 26381:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 25901:
/***/ (function(module) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),

/***/ 66695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(64333);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 79326:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 39010:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(64333);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 73098:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(64333);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 5223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(64333);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 4063:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 61713:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(73370),
    isSymbol = __webpack_require__(44872);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 32592:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 25717:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(63177);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 84707:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 4409:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(4278);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 55289:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 33913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(49726);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 4870:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(49726);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 68121:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(49726);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 17211:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(49726);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 68861:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(55706),
    ListCache = __webpack_require__(18999),
    Map = __webpack_require__(9279);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 34785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(23716);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 72753:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(23716);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 61757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(23716);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 65659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(23716);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 74940:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 58589:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 96345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(22871);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 64333:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(1530);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 31371:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(29632);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 99232:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(42759);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 66594:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 29632:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 11217:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(42759);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 42231:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 27464:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 33200:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 71880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(18999);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 12550:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67420:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 90870:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 93438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(18999),
    Map = __webpack_require__(9279),
    MapCache = __webpack_require__(5437);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 14002:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(24036),
    hasUnicode = __webpack_require__(26381),
    unicodeToArray = __webpack_require__(25144);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 89726:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(96345);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 57304:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(44872);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 19275:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 25144:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ 53528:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),

/***/ 29131:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var capitalize = __webpack_require__(54596),
    createCompounder = __webpack_require__(38127);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),

/***/ 54596:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(72509),
    upperFirst = __webpack_require__(27715);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),

/***/ 95200:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var deburrLetter = __webpack_require__(7350),
    toString = __webpack_require__(72509);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),

/***/ 25473:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 89914:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(98366);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 77981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHas = __webpack_require__(36928),
    hasPath = __webpack_require__(92434);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),

/***/ 83159:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(54966),
    hasPath = __webpack_require__(92434);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 60100:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 74223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(25190),
    isObjectLike = __webpack_require__(63646);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 73370:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 1691:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(64922),
    isLength = __webpack_require__(78568);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 17973:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(11217),
    stubFalse = __webpack_require__(56068);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 64922:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33854),
    isObject = __webpack_require__(4278);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 78568:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 4278:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 63646:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 44872:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(33854),
    isObjectLike = __webpack_require__(63646);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 29717:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(83932),
    baseUnary = __webpack_require__(69661),
    nodeUtil = __webpack_require__(99232);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 80412:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(15738),
    baseKeys = __webpack_require__(70017),
    isArrayLike = __webpack_require__(1691);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 17581:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(23163),
    baseForOwn = __webpack_require__(58780),
    baseIteratee = __webpack_require__(65109);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),

/***/ 56540:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(23163),
    baseForOwn = __webpack_require__(58780),
    baseIteratee = __webpack_require__(65109);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ 22871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(5437);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 45681:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(16548),
    basePropertyDeep = __webpack_require__(33325),
    isKey = __webpack_require__(61713),
    toKey = __webpack_require__(57304);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 41825:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCompounder = __webpack_require__(38127);

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

module.exports = snakeCase;


/***/ }),

/***/ 41897:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 56068:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 72509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(65211);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 27715:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(99361);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),

/***/ 71335:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiWords = __webpack_require__(10510),
    hasUnicodeWord = __webpack_require__(25901),
    toString = __webpack_require__(72509),
    unicodeWords = __webpack_require__(53528);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),

/***/ 67014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ I18nProvider; }
});

// UNUSED EXPORTS: InternalContext

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(75332);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/_context.js
var _context = __webpack_require__(86632);
;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/transCore.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function splitNsKey(key, nsSeparator) {
    if (!nsSeparator)
        return { i18nKey: key };
    var i = key.indexOf(nsSeparator);
    if (i < 0)
        return { i18nKey: key };
    return {
        namespace: key.slice(0, i),
        i18nKey: key.slice(i + nsSeparator.length),
    };
}
function transCore(_a) {
    var config = _a.config, allNamespaces = _a.allNamespaces, pluralRules = _a.pluralRules, lang = _a.lang;
    var _b = config.logger, logger = _b === void 0 ? missingKeyLogger : _b;
    var t = function (key, query, options) {
        var _a;
        if (key === void 0) { key = ''; }
        var k = Array.isArray(key) ? key[0] : key;
        var _b = config.nsSeparator, nsSeparator = _b === void 0 ? ':' : _b, _c = config.loggerEnvironment, loggerEnvironment = _c === void 0 ? 'browser' : _c;
        var _d = splitNsKey(k, nsSeparator), i18nKey = _d.i18nKey, _e = _d.namespace, namespace = _e === void 0 ? (_a = options === null || options === void 0 ? void 0 : options.ns) !== null && _a !== void 0 ? _a : config.defaultNS : _e;
        var dic = (namespace && allNamespaces[namespace]) || {};
        var keyWithPlural = plural(pluralRules, dic, i18nKey, config, query);
        var value = getDicValue(dic, keyWithPlural, config, options);
        var empty = typeof value === 'undefined' ||
            (typeof value === 'object' && !Object.keys(value).length);
        var fallbacks = typeof (options === null || options === void 0 ? void 0 : options.fallback) === 'string'
            ? [options.fallback]
            : (options === null || options === void 0 ? void 0 : options.fallback) || [];
        if (empty &&
            (loggerEnvironment === 'both' ||
                loggerEnvironment ===
                    (typeof window === 'undefined' ? 'node' : 'browser'))) {
            logger({ namespace: namespace, i18nKey: i18nKey });
        }
        if (empty && Array.isArray(fallbacks) && fallbacks.length) {
            var firstFallback = fallbacks[0], restFallbacks = fallbacks.slice(1);
            if (typeof firstFallback === 'string') {
                return t(firstFallback, query, __assign(__assign({}, options), { fallback: restFallbacks }));
            }
        }
        if (empty && (options === null || options === void 0 ? void 0 : options.default) && (fallbacks === null || fallbacks === void 0 ? void 0 : fallbacks.length) == 0) {
            return interpolation({ text: options === null || options === void 0 ? void 0 : options.default, query: query, config: config, lang: lang });
        }
        if (empty) {
            return k;
        }
        if (value instanceof Object) {
            return objectInterpolation({
                obj: value,
                query: query,
                config: config,
                lang: lang,
            });
        }
        return interpolation({ text: value, query: query, config: config, lang: lang });
    };
    return t;
}
function getDicValue(dic, key, config, options) {
    if (key === void 0) { key = ''; }
    if (options === void 0) { options = {
        returnObjects: false,
    }; }
    var _a = (config || {}).keySeparator, keySeparator = _a === void 0 ? '.' : _a;
    var keyParts = keySeparator ? key.split(keySeparator) : [key];
    var value = keyParts.reduce(function (val, key) {
        if (typeof val === 'string') {
            return {};
        }
        var res = val[key];
        return res || (typeof res === 'string' ? res : {});
    }, dic);
    if (typeof value === 'string' ||
        (value instanceof Object && options.returnObjects)) {
        return value;
    }
    return undefined;
}
function plural(pluralRules, dic, key, config, query) {
    if (!query || typeof query.count !== 'number')
        return key;
    var numKey = "".concat(key, "_").concat(query.count);
    if (getDicValue(dic, numKey, config) !== undefined)
        return numKey;
    var pluralKey = "".concat(key, "_").concat(pluralRules.select(query.count));
    if (getDicValue(dic, pluralKey, config) !== undefined) {
        return pluralKey;
    }
    var nestedNumKey = "".concat(key, ".").concat(query.count);
    if (getDicValue(dic, nestedNumKey, config) !== undefined)
        return nestedNumKey;
    var nestedKey = "".concat(key, ".").concat(pluralRules.select(query.count));
    if (getDicValue(dic, nestedKey, config) !== undefined)
        return nestedKey;
    return key;
}
function interpolation(_a) {
    var text = _a.text, query = _a.query, config = _a.config, lang = _a.lang;
    if (!text || !query)
        return text || '';
    var escapeRegex = function (str) {
        return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    };
    var _b = config.interpolation || {}, _c = _b.format, format = _c === void 0 ? null : _c, _d = _b.prefix, prefix = _d === void 0 ? '{{' : _d, _e = _b.suffix, suffix = _e === void 0 ? '}}' : _e;
    var regexEnd = suffix === '' ? '' : "(?:[\\s,]+([\\w-]*))?\\s*".concat(escapeRegex(suffix));
    return Object.keys(query).reduce(function (all, varKey) {
        var regex = new RegExp("".concat(escapeRegex(prefix), "\\s*").concat(varKey).concat(regexEnd), 'gm');
        return all.replace(regex, function (_match, $1) {
            return $1 && format
                ? format(query[varKey], $1, lang)
                : query[varKey];
        });
    }, text);
}
function objectInterpolation(_a) {
    var obj = _a.obj, query = _a.query, config = _a.config, lang = _a.lang;
    if (!query || Object.keys(query).length === 0)
        return obj;
    Object.keys(obj).forEach(function (key) {
        if (obj[key] instanceof Object)
            objectInterpolation({
                obj: obj[key],
                query: query,
                config: config,
                lang: lang,
            });
        if (typeof obj[key] === 'string')
            obj[key] = interpolation({
                text: obj[key],
                query: query,
                config: config,
                lang: lang,
            });
    });
    return obj;
}
function missingKeyLogger(_a) {
    var namespace = _a.namespace, i18nKey = _a.i18nKey;
    if (true)
        return;
    if (!namespace) {
        console.warn("[next-translate] The text \"".concat(i18nKey, "\" has no namespace in front of it."));
        return;
    }
    console.warn("[next-translate] \"".concat(namespace, ":").concat(i18nKey, "\" is missing in current namespace configuration. Try adding \"").concat(i18nKey, "\" to the namespace \"").concat(namespace, "\"."));
}

// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/I18nProvider.js
var I18nProvider_assign = (undefined && undefined.__assign) || function () {
    I18nProvider_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return I18nProvider_assign.apply(this, arguments);
};





var InternalContext = (0,react.createContext)({ ns: {}, config: {} });
function I18nProvider(_a) {
    var lng = _a.lang, _b = _a.namespaces, namespaces = _b === void 0 ? {} : _b, children = _a.children, _c = _a.config, newConfig = _c === void 0 ? {} : _c;
    var parentLang = (0,useTranslation/* default */.Z)().lang;
    var _d = (0,router.useRouter)() || {}, locale = _d.locale, defaultLocale = _d.defaultLocale;
    var internal = (0,react.useContext)(InternalContext);
    var allNamespaces = I18nProvider_assign(I18nProvider_assign({}, internal.ns), namespaces);
    var lang = lng || parentLang || locale || defaultLocale || '';
    var config = I18nProvider_assign(I18nProvider_assign({}, internal.config), newConfig);
    var localesToIgnore = config.localesToIgnore || ['default'];
    var ignoreLang = localesToIgnore.includes(lang);
    var pluralRules = new Intl.PluralRules(ignoreLang ? undefined : lang);
    var t = transCore({ config: config, allNamespaces: allNamespaces, pluralRules: pluralRules, lang: lang });
    return (react.createElement(_context/* default.Provider */.Z.Provider, { value: { lang: lang, t: t } },
        react.createElement(InternalContext.Provider, { value: { ns: allNamespaces, config: config } }, children)));
}


/***/ }),

/***/ 46834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Trans; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/formatElements.js

var tagRe = /<(\w+)>(.*?)<\/\1>|<(\w+)\/>/;
var nlRe = /(?:\r\n|\r|\n)/g;
function getElements(parts) {
    if (!parts.length)
        return [];
    var _a = parts.slice(0, 4), paired = _a[0], children = _a[1], unpaired = _a[2], after = _a[3];
    return [
        [(paired || unpaired), children || '', after],
    ].concat(getElements(parts.slice(4, parts.length)));
}
function formatElements(value, elements) {
    if (elements === void 0) { elements = []; }
    var parts = value.replace(nlRe, '').split(tagRe);
    if (parts.length === 1)
        return value;
    var tree = [];
    var before = parts.shift();
    if (before)
        tree.push(before);
    getElements(parts).forEach(function (_a, realIndex) {
        var key = _a[0], children = _a[1], after = _a[2];
        var element = elements[key] || react.createElement(react.Fragment, null);
        tree.push((0,react.cloneElement)(element, { key: realIndex }, children ? formatElements(children, elements) : element.props.children));
        if (after)
            tree.push(after);
    });
    return tree;
}

;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/Trans.js



function Trans(_a) {
    var i18nKey = _a.i18nKey, values = _a.values, components = _a.components, fallback = _a.fallback, defaultTrans = _a.defaultTrans, ns = _a.ns;
    var _b = (0,useTranslation/* default */.Z)(ns), t = _b.t, lang = _b.lang;
    var result = (0,react.useMemo)(function () {
        var text = t(i18nKey, values, { fallback: fallback, default: defaultTrans });
        if (!components || components.length === 0)
            return text;
        return formatElements(text, components);
    }, [i18nKey, values, components, lang]);
    return result;
}


/***/ }),

/***/ 86632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);

/* harmony default export */ __webpack_exports__["Z"] = ((0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    t: function (k) { return (Array.isArray(k) ? k[0] : k); },
    lang: '',
}));


/***/ }),

/***/ 62044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useTranslation; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/wrapTWithDefaultNs.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function wrapTWithDefaultNs(oldT, ns) {
    if (typeof ns !== 'string')
        return oldT;
    var t = function (key, query, options) {
        return oldT(key, query, __assign({ ns: ns }, options));
    };
    return t;
}

// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/_context.js
var _context = __webpack_require__(86632);
;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js
var useTranslation_assign = (undefined && undefined.__assign) || function () {
    useTranslation_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return useTranslation_assign.apply(this, arguments);
};



function useTranslation(defaultNS) {
    var ctx = (0,react.useContext)(_context/* default */.Z);
    return (0,react.useMemo)(function () { return (useTranslation_assign(useTranslation_assign({}, ctx), { t: wrapTWithDefaultNs(ctx.t, defaultNS) })); }, [ctx.lang, defaultNS]);
}


/***/ }),

/***/ 83244:
/***/ (function(module) {

"use strict";

/* globals self */ var fetch = self.fetch.bind(self);
module.exports = fetch;
module.exports["default"] = module.exports;

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 89885:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(48410);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 48410:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={308:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(308);module.exports=r})();

/***/ }),

/***/ 65117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(30117)


/***/ }),

/***/ 1984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(78590)


/***/ }),

/***/ 75657:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(31895)


/***/ }),

/***/ 75332:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(25948)


/***/ }),

/***/ 12774:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.destroyCookie = exports.setCookie = exports.parseCookies = void 0;
var cookie = __webpack_require__(68295);
var setCookieParser = __webpack_require__(13238);
var utils_1 = __webpack_require__(53138);
/**
 * Parses cookies.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param options Options that we pass down to `cookie` library.
 */
function parseCookies(ctx, options) {
    var _a, _b;
    if ((_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.cookie) {
        return cookie.parse(ctx.req.headers.cookie, options);
    }
    if (utils_1.isBrowser()) {
        return cookie.parse(document.cookie, options);
    }
    return {};
}
exports.parseCookies = parseCookies;
/**
 * Sets a cookie.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name The name of your cookie.
 * @param value The value of your cookie.
 * @param options Options that we pass down to `cookie` library.
 */
function setCookie(ctx, name, value, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    // SSR
    if (((_a = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _a === void 0 ? void 0 : _a.getHeader) && ctx.res.setHeader) {
        // Check if response has finished and warn about it.
        if ((_b = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _b === void 0 ? void 0 : _b.finished) {
            console.warn("Not setting \"" + name + "\" cookie. Response has finished.");
            console.warn("You should set cookie before res.send()");
            return {};
        }
        /**
         * Load existing cookies from the header and parse them.
         */
        var cookies = ctx.res.getHeader('Set-Cookie') || [];
        if (typeof cookies === 'string')
            cookies = [cookies];
        if (typeof cookies === 'number')
            cookies = [];
        /**
         * Parse cookies but ignore values - we've already encoded
         * them in the previous call.
         */
        var parsedCookies = setCookieParser.parse(cookies, {
            decodeValues: false,
        });
        /**
         * We create the new cookie and make sure that none of
         * the existing cookies match it.
         */
        var newCookie_1 = utils_1.createCookie(name, value, options);
        var cookiesToSet_1 = [];
        parsedCookies.forEach(function (parsedCookie) {
            if (!utils_1.areCookiesEqual(parsedCookie, newCookie_1)) {
                /**
                 * We serialize the cookie back to the original format
                 * if it isn't the same as the new one.
                 */
                var serializedCookie = cookie.serialize(parsedCookie.name, parsedCookie.value, __assign({ 
                    // we prevent reencoding by default, but you might override it
                    encode: function (val) { return val; } }, parsedCookie));
                cookiesToSet_1.push(serializedCookie);
            }
        });
        cookiesToSet_1.push(cookie.serialize(name, value, options));
        // Update the header.
        ctx.res.setHeader('Set-Cookie', cookiesToSet_1);
    }
    // Browser
    if (utils_1.isBrowser()) {
        if (options && options.httpOnly) {
            throw new Error('Can not set a httpOnly cookie in the browser.');
        }
        document.cookie = cookie.serialize(name, value, options);
    }
    return {};
}
exports.setCookie = setCookie;
/**
 * Destroys a cookie with a particular name.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name Cookie name.
 * @param options Options that we pass down to `cookie` library.
 */
function destroyCookie(ctx, name, options) {
    /**
     * We forward the request destroy to setCookie function
     * as it is the same function with modified maxAge value.
     */
    return setCookie(ctx, name, '', __assign(__assign({}, (options || {})), { maxAge: -1 }));
}
exports.destroyCookie = destroyCookie;
/* Utility Exports */
exports["default"] = {
    set: setCookie,
    get: parseCookies,
    destroy: destroyCookie,
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 53138:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.areCookiesEqual = exports.hasSameProperties = exports.createCookie = exports.isBrowser = void 0;
/**
 * Tells whether we are in a browser or server.
 */
function isBrowser() {
    return typeof window !== 'undefined';
}
exports.isBrowser = isBrowser;
/**
 * Create an instance of the Cookie interface
 */
function createCookie(name, value, options) {
    var sameSite = options.sameSite;
    if (sameSite === true) {
        sameSite = 'strict';
    }
    if (sameSite === undefined || sameSite === false) {
        sameSite = 'lax';
    }
    var cookieToSet = __assign(__assign({}, options), { sameSite: sameSite });
    delete cookieToSet.encode;
    return __assign({ name: name, value: value }, cookieToSet);
}
exports.createCookie = createCookie;
/**
 * Tells whether given objects have the same properties.
 */
function hasSameProperties(a, b) {
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length !== bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
}
exports.hasSameProperties = hasSameProperties;
/**
 * Compare the cookie and return true if the cookies have equivalent
 * options and the cookies would be overwritten in the browser storage.
 *
 * @param a first Cookie for comparison
 * @param b second Cookie for comparison
 */
function areCookiesEqual(a, b) {
    var sameSiteSame = a.sameSite === b.sameSite;
    if (typeof a.sameSite === 'string' && typeof b.sameSite === 'string') {
        sameSiteSame = a.sameSite.toLowerCase() === b.sameSite.toLowerCase();
    }
    return (hasSameProperties(__assign(__assign({}, a), { sameSite: undefined }), __assign(__assign({}, b), { sameSite: undefined })) && sameSiteSame);
}
exports.areCookiesEqual = areCookiesEqual;
/* Functions */
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 69256:
/***/ (function(module) {

"use strict";
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */


function Cache(maxSize) {
  this._maxSize = maxSize
  this.clear()
}
Cache.prototype.clear = function () {
  this._size = 0
  this._values = Object.create(null)
}
Cache.prototype.get = function (key) {
  return this._values[key]
}
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear()
  if (!(key in this._values)) this._size++

  return (this._values[key] = value)
}

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512

var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE)

var config

module.exports = {
  Cache: Cache,

  split: split,

  normalizePath: normalizePath,

  setter: function (path) {
    var parts = normalizePath(path)

    return (
      setCache.get(path) ||
      setCache.set(path, function setter(obj, value) {
        var index = 0
        var len = parts.length
        var data = obj

        while (index < len - 1) {
          var part = parts[index]
          if (
            part === '__proto__' ||
            part === 'constructor' ||
            part === 'prototype'
          ) {
            return obj
          }

          data = data[parts[index++]]
        }
        data[parts[index]] = value
      })
    )
  },

  getter: function (path, safe) {
    var parts = normalizePath(path)
    return (
      getCache.get(path) ||
      getCache.set(path, function getter(data) {
        var index = 0,
          len = parts.length
        while (index < len) {
          if (data != null || !safe) data = data[parts[index++]]
          else return
        }
        return data
      })
    )
  },

  join: function (segments) {
    return segments.reduce(function (path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg)
  },
}

function normalizePath(path) {
  return (
    pathCache.get(path) ||
    pathCache.set(
      path,
      split(path).map(function (part) {
        return part.replace(CLEAN_QUOTES_REGEX, '$2')
      })
    )
  )
}

function split(path) {
  return path.match(SPLIT_REGEX) || ['']
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket

  for (idx = 0; idx < len; idx++) {
    part = parts[idx]

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"'
      }

      isBracket = isQuoted(part)
      isArray = !isBracket && /^\d+$/.test(part)

      iter.call(thisArg, part, isBracket, isArray, idx, parts)
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}


/***/ }),

/***/ 13238:
/***/ (function(module) {

"use strict";


var defaultParseOptions = {
  decodeValues: true,
  map: false,
  silent: false,
};

function isNonEmptyString(str) {
  return typeof str === "string" && !!str.trim();
}

function parseString(setCookieValue, options) {
  var parts = setCookieValue.split(";").filter(isNonEmptyString);
  var nameValue = parts.shift().split("=");
  var name = nameValue.shift();
  var value = nameValue.join("="); // everything after the first =, joined by a "=" if there was more than one part

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  try {
    value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
  } catch (e) {
    console.error(
      "set-cookie-parser encountered an error while decoding a cookie with value '" +
        value +
        "'. Set options.decodeValues to false to disable this feature.",
      e
    );
  }

  var cookie = {
    name: name, // grab everything before the first =
    value: value,
  };

  parts.forEach(function (part) {
    var sides = part.split("=");
    var key = sides.shift().trimLeft().toLowerCase();
    var value = sides.join("=");
    if (key === "expires") {
      cookie.expires = new Date(value);
    } else if (key === "max-age") {
      cookie.maxAge = parseInt(value, 10);
    } else if (key === "secure") {
      cookie.secure = true;
    } else if (key === "httponly") {
      cookie.httpOnly = true;
    } else if (key === "samesite") {
      cookie.sameSite = value;
    } else {
      cookie[key] = value;
    }
  });

  return cookie;
}

function parse(input, options) {
  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!input) {
    if (!options.map) {
      return [];
    } else {
      return {};
    }
  }

  if (input.headers && input.headers["set-cookie"]) {
    // fast-path for node.js (which automatically normalizes header names to lower-case
    input = input.headers["set-cookie"];
  } else if (input.headers) {
    // slow-path for other environments - see #25
    var sch =
      input.headers[
        Object.keys(input.headers).find(function (key) {
          return key.toLowerCase() === "set-cookie";
        })
      ];
    // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
    if (!sch && input.headers.cookie && !options.silent) {
      console.warn(
        "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
      );
    }
    input = sch;
  }
  if (!Array.isArray(input)) {
    input = [input];
  }

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!options.map) {
    return input.filter(isNonEmptyString).map(function (str) {
      return parseString(str, options);
    });
  } else {
    var cookies = {};
    return input.filter(isNonEmptyString).reduce(function (cookies, str) {
      var cookie = parseString(str, options);
      cookies[cookie.name] = cookie;
      return cookies;
    }, cookies);
  }
}

/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/
function splitCookiesString(cookiesString) {
  if (Array.isArray(cookiesString)) {
    return cookiesString;
  }
  if (typeof cookiesString !== "string") {
    return [];
  }

  var cookiesStrings = [];
  var pos = 0;
  var start;
  var ch;
  var lastComma;
  var nextStart;
  var cookiesSeparatorFound;

  function skipWhitespace() {
    while (pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos))) {
      pos += 1;
    }
    return pos < cookiesString.length;
  }

  function notSpecialChar() {
    ch = cookiesString.charAt(pos);

    return ch !== "=" && ch !== ";" && ch !== ",";
  }

  while (pos < cookiesString.length) {
    start = pos;
    cookiesSeparatorFound = false;

    while (skipWhitespace()) {
      ch = cookiesString.charAt(pos);
      if (ch === ",") {
        // ',' is a cookie separator if we have later first '=', not ';' or ','
        lastComma = pos;
        pos += 1;

        skipWhitespace();
        nextStart = pos;

        while (pos < cookiesString.length && notSpecialChar()) {
          pos += 1;
        }

        // currently special character
        if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
          // we found cookies separator
          cookiesSeparatorFound = true;
          // pos is inside the next cookie, so back up and return it.
          pos = nextStart;
          cookiesStrings.push(cookiesString.substring(start, lastComma));
          start = pos;
        } else {
          // in param ',' or param separator ';',
          // we continue from that comma
          pos = lastComma + 1;
        }
      } else {
        pos += 1;
      }
    }

    if (!cookiesSeparatorFound || pos >= cookiesString.length) {
      cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
  }

  return cookiesStrings;
}

module.exports = parse;
module.exports.parse = parse;
module.exports.parseString = parseString;
module.exports.splitCookiesString = splitCookiesString;


/***/ }),

/***/ 42250:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch] || charMap[ch] || ch;
        if (appendChar === replacement) {
          appendChar = ' ';
        }
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ }),

/***/ 64174:
/***/ (function(module) {


/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

module.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
}

module.exports.array = toposort

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes)

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  })

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set())
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep
      try {
        nodeRep = ", node was:" + JSON.stringify(node)
      } catch(e) {
        nodeRep = ""
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true

    var outgoing = outgoingEdges.get(node) || new Set()
    outgoing = Array.from(outgoing)

    if (i = outgoing.length) {
      predecessors.add(node)
      do {
        var child = outgoing[--i]
        visit(child, nodesHash.get(child), predecessors)
      } while (i)
      predecessors.delete(node)
    }

    sorted[--cursor] = node
  }
}

function uniqueNodes(arr){
  var res = new Set()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    res.add(edge[0])
    res.add(edge[1])
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    if (!edges.has(edge[0])) edges.set(edge[0], new Set())
    if (!edges.has(edge[1])) edges.set(edge[1], new Set())
    edges.get(edge[0]).add(edge[1])
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i)
  }
  return res
}


/***/ }),

/***/ 61557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CR": function() { return /* binding */ __read; },
/* harmony export */   "XA": function() { return /* binding */ __values; },
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "fl": function() { return /* binding */ __spread; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ 7827:
/***/ (function(__unused_webpack_module, exports) {

/*! https://mths.be/utf8js v3.0.0 by @mathias */
;(function(root) {

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	function checkScalarValue(codePoint) {
		if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
			throw Error(
				'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
				' is not a scalar value'
			);
		}
	}
	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			checkScalarValue(codePoint);
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function utf8encode(string) {
		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol() {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read first byte
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				checkScalarValue(codePoint);
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid UTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function utf8decode(byteString) {
		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol()) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	/*--------------------------------------------------------------------------*/

	root.version = '3.0.0';
	root.encode = utf8encode;
	root.decode = utf8decode;

}( false ? 0 : exports));


/***/ }),

/***/ 46513:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var v1 = __webpack_require__(82287);
var v4 = __webpack_require__(49768);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),

/***/ 12063:
/***/ (function(module) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),

/***/ 42022:
/***/ (function(module) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),

/***/ 82287:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var rng = __webpack_require__(42022);
var bytesToUuid = __webpack_require__(12063);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),

/***/ 49768:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var rng = __webpack_require__(42022);
var bytesToUuid = __webpack_require__(12063);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),

/***/ 94644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Rx": function() { return /* reexport */ number_create; },
  "Ry": function() { return /* reexport */ object_create; },
  "iH": function() { return /* reexport */ create; },
  "Z_": function() { return /* reexport */ string_create; }
});

// UNUSED EXPORTS: ArraySchema, BaseSchema, BooleanSchema, DateSchema, MixedSchema, NumberSchema, ObjectSchema, StringSchema, ValidationError, addMethod, array, bool, boolean, date, isSchema, lazy, mixed, reach, setLocale

;// CONCATENATED MODULE: ./node_modules/nanoclone/src/index.js
// ES6 Map
var map
try {
  map = Map
} catch (_) { }
var set

// ES6 Set
try {
  set = Set
} catch (_) { }

function baseClone (src, circulars, clones) {
  // Null/undefined/functions/etc
  if (!src || typeof src !== 'object' || typeof src === 'function') {
    return src
  }

  // DOM Node
  if (src.nodeType && 'cloneNode' in src) {
    return src.cloneNode(true)
  }

  // Date
  if (src instanceof Date) {
    return new Date(src.getTime())
  }

  // RegExp
  if (src instanceof RegExp) {
    return new RegExp(src)
  }

  // Arrays
  if (Array.isArray(src)) {
    return src.map(clone)
  }

  // ES6 Maps
  if (map && src instanceof map) {
    return new Map(Array.from(src.entries()))
  }

  // ES6 Sets
  if (set && src instanceof set) {
    return new Set(Array.from(src.values()))
  }

  // Object
  if (src instanceof Object) {
    circulars.push(src)
    var obj = Object.create(src)
    clones.push(obj)
    for (var key in src) {
      var idx = circulars.findIndex(function (i) {
        return i === src[key]
      })
      obj[key] = idx > -1 ? clones[idx] : baseClone(src[key], circulars, clones)
    }
    return obj
  }

  // ???
  return src
}

function clone (src) {
  return baseClone(src, [], [])
}

;// CONCATENATED MODULE: ./node_modules/yup/es/util/printValue.js
const printValue_toString = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = printValue_toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}
;// CONCATENATED MODULE: ./node_modules/yup/es/locale.js

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.');

    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }

    return msg;
  },
  defined: '${path} must be defined'
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let locale_boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
/* harmony default export */ var es_locale = (Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean: locale_boolean
}));
// EXTERNAL MODULE: ./node_modules/lodash/has.js
var has = __webpack_require__(77981);
var has_default = /*#__PURE__*/__webpack_require__.n(has);
;// CONCATENATED MODULE: ./node_modules/yup/es/util/isSchema.js
const isSchema_isSchema = obj => obj && obj.__isYupSchema__;

/* harmony default export */ var util_isSchema = (isSchema_isSchema);
;// CONCATENATED MODULE: ./node_modules/yup/es/Condition.js



class Condition {
  constructor(refs, options) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!has_default()(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = options;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);

    this.fn = function (...args) {
      let options = args.pop();
      let schema = args.pop();
      let branch = check(...args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  resolve(base, options) {
    let values = this.refs.map(ref => ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!util_isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }

}

/* harmony default export */ var es_Condition = (Condition);
;// CONCATENATED MODULE: ./node_modules/yup/es/util/toArray.js
function toArray(value) {
  return value == null ? [] : [].concat(value);
}
;// CONCATENATED MODULE: ./node_modules/yup/es/ValidationError.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || 'this';
    if (path !== params.path) params = _extends({}, params, {
      path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }

  static isError(err) {
    return err && err.name === 'ValidationError';
  }

  constructor(errorOrErrors, value, field, type) {
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.errors = void 0;
    this.params = void 0;
    this.inner = void 0;
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
  }

}
;// CONCATENATED MODULE: ./node_modules/yup/es/util/runTests.js


const once = cb => {
  let fired = false;
  return (...args) => {
    if (fired) return;
    fired = true;
    cb(...args);
  };
};

function runTests(options, cb) {
  let {
    endEarly,
    tests,
    args,
    value,
    errors,
    sort,
    path
  } = options;
  let callback = once(cb);
  let count = tests.length;
  const nestedErrors = [];
  errors = errors ? errors : [];
  if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);

  for (let i = 0; i < tests.length; i++) {
    const test = tests[i];
    test(args, function finishTestRun(err) {
      if (err) {
        // always return early for non validation errors
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }

        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }

        nestedErrors.push(err);
      }

      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

          if (errors.length) nestedErrors.push(...errors);
          errors = nestedErrors;
        }

        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }

        callback(null, value);
      }
    });
  }
}
// EXTERNAL MODULE: ./node_modules/lodash/mapValues.js
var mapValues = __webpack_require__(56540);
var mapValues_default = /*#__PURE__*/__webpack_require__.n(mapValues);
// EXTERNAL MODULE: ./node_modules/property-expr/index.js
var property_expr = __webpack_require__(69256);
;// CONCATENATED MODULE: ./node_modules/yup/es/Reference.js

const prefixes = {
  context: '$',
  value: '.'
};
function create(key, options) {
  return new Reference(key, options);
}
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && (0,property_expr.getter)(this.path, true);
    this.map = options.map;
  }

  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */


  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }

  resolve() {
    return this;
  }

  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }

  toString() {
    return `Ref(${this.key})`;
  }

  static isRef(value) {
    return value && value.__isYupRef;
  }

} // @ts-ignore

Reference.prototype.__isYupRef = true;
;// CONCATENATED MODULE: ./node_modules/yup/es/util/createValidation.js
function createValidation_extends() { createValidation_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return createValidation_extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function createValidation(config) {
  function validate(_ref, cb) {
    let {
      value,
      path = '',
      label,
      options,
      originalValue,
      sync
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);

    const {
      name,
      test,
      params,
      message
    } = config;
    let {
      parent,
      context
    } = options;

    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }

    function createError(overrides = {}) {
      const nextParams = mapValues_default()(createValidation_extends({
        value,
        originalValue,
        label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }

    let ctx = createValidation_extends({
      path,
      parent,
      type: name,
      createError,
      resolve,
      options,
      originalValue
    }, rest);

    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then(validOrError => {
          if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
        }).catch(cb);
      } catch (err) {
        cb(err);
      }

      return;
    }

    let result;

    try {
      var _ref2;

      result = test.call(ctx, value, ctx);

      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
      }
    } catch (err) {
      cb(err);
      return;
    }

    if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
  }

  validate.OPTIONS = config;
  return validate;
}
;// CONCATENATED MODULE: ./node_modules/yup/es/util/reach.js


let trim = part => part.substr(0, part.length - 1).substr(1);

function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug; // root path: ''

  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  (0,property_expr.forEach)(path, (_part, isBracket, isArray) => {
    let part = isBracket ? trim(_part) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });

    if (schema.innerType) {
      let idx = isArray ? parseInt(part, 10) : 0;

      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }

      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal


    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }

    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

const reach = (obj, path, value, context) => getIn(obj, path, value, context).schema;

/* harmony default export */ var util_reach = ((/* unused pure expression or super */ null && (reach)));
;// CONCATENATED MODULE: ./node_modules/yup/es/util/ReferenceSet.js

class ReferenceSet {
  constructor() {
    this.list = void 0;
    this.refs = void 0;
    this.list = new Set();
    this.refs = new Map();
  }

  get size() {
    return this.list.size + this.refs.size;
  }

  describe() {
    const description = [];

    for (const item of this.list) description.push(item);

    for (const [, ref] of this.refs) description.push(ref.describe());

    return description;
  }

  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }

  resolveAll(resolve) {
    return this.toArray().reduce((acc, e) => acc.concat(Reference.isRef(e) ? resolve(e) : e), []);
  }

  add(value) {
    Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  }

  delete(value) {
    Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  }

  clone() {
    const next = new ReferenceSet();
    next.list = new Set(this.list);
    next.refs = new Map(this.refs);
    return next;
  }

  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.list.forEach(value => next.add(value));
    newItems.refs.forEach(value => next.add(value));
    removeItems.list.forEach(value => next.delete(value));
    removeItems.refs.forEach(value => next.delete(value));
    return next;
  }

}
;// CONCATENATED MODULE: ./node_modules/yup/es/schema.js
function schema_extends() { schema_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return schema_extends.apply(this, arguments); }

// @ts-ignore










 // const UNSET = 'unset' as const;

class BaseSchema {
  constructor(options) {
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this._typeError = void 0;
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || 'mixed';
    this.spec = schema_extends({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      presence: 'optional'
    }, options == null ? void 0 : options.spec);
  } // TODO: remove


  get _type() {
    return this.type;
  }

  _typeCheck(_value) {
    return true;
  }

  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    } // if the nested value is a schema we can skip cloning, since
    // they are already immutable


    const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly

    next.type = this.type;
    next._typeError = this._typeError;
    next._whitelistError = this._whitelistError;
    next._blacklistError = this._blacklistError;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.exclusiveTests = schema_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly

    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(schema_extends({}, this.spec, spec));
    return next;
  }

  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }

  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  } // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }


  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }

  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();

    const mergedSpec = schema_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
    //   mergedSpec.nullable = base.spec.nullable;
    // if (combined.spec.presence === UNSET)
    //   mergedSpec.presence = base.spec.presence;


    combined.spec = mergedSpec;
    combined._typeError || (combined._typeError = base._typeError);
    combined._whitelistError || (combined._whitelistError = base._whitelistError);
    combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)

    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests

    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
    // the deduping logic is consistent

    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }

  isType(v) {
    if (this.spec.nullable && v === null) return true;
    return this._typeCheck(v);
  }

  resolve(options) {
    let schema = this;

    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((schema, condition) => condition.resolve(schema, options), schema);
      schema = schema.resolve(options);
    }

    return schema;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */


  cast(value, options = {}) {
    let resolvedSchema = this.resolve(schema_extends({
      value
    }, options));

    let result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }

    return result;
  }

  _cast(rawValue, _options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn) => fn.call(this, value, rawValue, this), rawValue);

    if (value === undefined) {
      value = this.getDefault();
    }

    return value;
  }

  _validate(_value, options = {}, cb) {
    let {
      sync,
      path,
      from = [],
      originalValue = _value,
      strict = this.spec.strict,
      abortEarly = this.spec.abortEarly
    } = options;
    let value = _value;

    if (!strict) {
      // this._validating = true;
      value = this._cast(value, schema_extends({
        assert: false
      }, options)); // this._validating = false;
    } // value is cast, we can check if it meets type requirements


    let args = {
      value,
      path,
      options,
      originalValue,
      schema: this,
      label: this.spec.label,
      sync,
      from
    };
    let initialTests = [];
    if (this._typeError) initialTests.push(this._typeError);
    let finalTests = [];
    if (this._whitelistError) finalTests.push(this._whitelistError);
    if (this._blacklistError) finalTests.push(this._blacklistError);
    runTests({
      args,
      value,
      path,
      sync,
      tests: initialTests,
      endEarly: abortEarly
    }, err => {
      if (err) return void cb(err, value);
      runTests({
        tests: this.tests.concat(finalTests),
        args,
        path,
        sync,
        value,
        endEarly: abortEarly
      }, cb);
    });
  }

  validate(value, options, maybeCb) {
    let schema = this.resolve(schema_extends({}, options, {
      value
    })); // callback case is for nested validations

    return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject) => schema._validate(value, options, (err, value) => {
      if (err) reject(err);else resolve(value);
    }));
  }

  validateSync(value, options) {
    let schema = this.resolve(schema_extends({}, options, {
      value
    }));
    let result;

    schema._validate(value, schema_extends({}, options, {
      sync: true
    }), (err, value) => {
      if (err) throw err;
      result = value;
    });

    return result;
  }

  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }

  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }

  _getDefault() {
    let defaultValue = this.spec.default;

    if (defaultValue == null) {
      return defaultValue;
    }

    return typeof defaultValue === 'function' ? defaultValue.call(this) : clone(defaultValue);
  }

  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault();
  }

  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }

    let next = this.clone({
      default: def
    });
    return next;
  }

  strict(isStrict = true) {
    let next = this.clone();
    next.spec.strict = isStrict;
    return next;
  }

  _isPresent(value) {
    return value != null;
  }

  defined(message = mixed.defined) {
    return this.test({
      message,
      name: 'defined',
      exclusive: true,

      test(value) {
        return value !== undefined;
      }

    });
  }

  required(message = mixed.required) {
    return this.clone({
      presence: 'required'
    }).withMutation(s => s.test({
      message,
      name: 'required',
      exclusive: true,

      test(value) {
        return this.schema._isPresent(value);
      }

    }));
  }

  notRequired() {
    let next = this.clone({
      presence: 'optional'
    });
    next.tests = next.tests.filter(test => test.OPTIONS.name !== 'required');
    return next;
  }

  nullable(isNullable = true) {
    let next = this.clone({
      nullable: isNullable !== false
    });
    return next;
  }

  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */


  test(...args) {
    let opts;

    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }

    if (opts.message === undefined) opts.message = mixed["default"];
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;

    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  }

  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }

    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(new es_Condition(deps, options));
    return next;
  }

  typeError(message) {
    let next = this.clone();
    next._typeError = createValidation({
      message,
      name: 'typeError',

      test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }

    });
    return next;
  }

  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = createValidation({
      message,
      name: 'oneOf',

      test(value) {
        if (value === undefined) return true;
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: valids.toArray().join(', '),
            resolved
          }
        });
      }

    });
    return next;
  }

  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = createValidation({
      message,
      name: 'notOneOf',

      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: invalids.toArray().join(', '),
            resolved
          }
        });
        return true;
      }

    });
    return next;
  }

  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  describe() {
    const next = this.clone();
    const {
      label,
      meta
    } = next.spec;
    const description = {
      meta,
      label,
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }

} // eslint-disable-next-line @typescript-eslint/no-unused-vars

// @ts-expect-error
BaseSchema.prototype.__isYupSchema__ = true;

for (const method of ['validate', 'validateSync']) BaseSchema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], schema_extends({}, options, {
    parent,
    path
  }));
};

for (const alias of ['equals', 'is']) BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;

for (const alias of ['not', 'nope']) BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;

BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;
;// CONCATENATED MODULE: ./node_modules/yup/es/mixed.js

const Mixed = BaseSchema;
/* harmony default export */ var es_mixed = ((/* unused pure expression or super */ null && (Mixed)));
function mixed_create() {
  return new Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class

mixed_create.prototype = Mixed.prototype;
;// CONCATENATED MODULE: ./node_modules/yup/es/util/isAbsent.js
const isAbsent = value => value == null;

/* harmony default export */ var util_isAbsent = (isAbsent);
;// CONCATENATED MODULE: ./node_modules/yup/es/boolean.js



function boolean_create() {
  return new BooleanSchema();
}
class BooleanSchema extends BaseSchema {
  constructor() {
    super({
      type: 'boolean'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (!this.isType(value)) {
          if (/^(true|1)$/i.test(String(value))) return true;
          if (/^(false|0)$/i.test(String(value))) return false;
        }

        return value;
      });
    });
  }

  _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();
    return typeof v === 'boolean';
  }

  isTrue(message = locale_boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'true'
      },

      test(value) {
        return util_isAbsent(value) || value === true;
      }

    });
  }

  isFalse(message = locale_boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'false'
      },

      test(value) {
        return util_isAbsent(value) || value === false;
      }

    });
  }

}
boolean_create.prototype = BooleanSchema.prototype;
;// CONCATENATED MODULE: ./node_modules/yup/es/string.js


 // eslint-disable-next-line

let rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

let isTrimmed = value => util_isAbsent(value) || value === value.trim();

let objStringTag = {}.toString();
function string_create() {
  return new StringSchema();
}
class StringSchema extends BaseSchema {
  constructor() {
    super({
      type: 'string'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  }

  _isPresent(value) {
    return super._isPresent(value) && !!value.length;
  }

  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return util_isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return util_isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;

    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }

    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      test: value => util_isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }

  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }

  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }

  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  } //-- transforms --


  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }

  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }

  lowercase(message = string.lowercase) {
    return this.transform(value => !util_isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => util_isAbsent(value) || value === value.toLowerCase()
    });
  }

  uppercase(message = string.uppercase) {
    return this.transform(value => !util_isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => util_isAbsent(value) || value === value.toUpperCase()
    });
  }

}
string_create.prototype = StringSchema.prototype; //
// String Interfaces
//
;// CONCATENATED MODULE: ./node_modules/yup/es/number.js




let number_isNaN = value => value != +value;

function number_create() {
  return new NumberSchema();
}
class NumberSchema extends BaseSchema {
  constructor() {
    super({
      type: 'number'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        let parsed = value;

        if (typeof parsed === 'string') {
          parsed = parsed.replace(/\s/g, '');
          if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings

          parsed = +parsed;
        }

        if (this.isType(parsed)) return parsed;
        return parseFloat(parsed);
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof Number) value = value.valueOf();
    return typeof value === 'number' && !number_isNaN(value);
  }

  min(min, message = number.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return util_isAbsent(value) || value >= this.resolve(min);
      }

    });
  }

  max(max, message = number.max) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value <= this.resolve(max);
      }

    });
  }

  lessThan(less, message = number.lessThan) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        less
      },

      test(value) {
        return util_isAbsent(value) || value < this.resolve(less);
      }

    });
  }

  moreThan(more, message = number.moreThan) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        more
      },

      test(value) {
        return util_isAbsent(value) || value > this.resolve(more);
      }

    });
  }

  positive(msg = number.positive) {
    return this.moreThan(0, msg);
  }

  negative(msg = number.negative) {
    return this.lessThan(0, msg);
  }

  integer(message = number.integer) {
    return this.test({
      name: 'integer',
      message,
      test: val => util_isAbsent(val) || Number.isInteger(val)
    });
  }

  truncate() {
    return this.transform(value => !util_isAbsent(value) ? value | 0 : value);
  }

  round(method) {
    var _method;

    let avail = ['ceil', 'floor', 'round', 'trunc'];
    method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc

    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(value => !util_isAbsent(value) ? Math[method](value) : value);
  }

}
number_create.prototype = NumberSchema.prototype; //
// Number Interfaces
//
;// CONCATENATED MODULE: ./node_modules/yup/es/util/isodate.js
/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) struct[k] = +struct[k] || 0; // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}
;// CONCATENATED MODULE: ./node_modules/yup/es/date.js
// @ts-ignore





let invalidDate = new Date('');

let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';

function date_create() {
  return new DateSchema();
}
class DateSchema extends BaseSchema {
  constructor() {
    super({
      type: 'date'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        value = parseIsoDate(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.

        return !isNaN(value) ? new Date(value) : invalidDate;
      });
    });
  }

  _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  }

  prepareParam(ref, name) {
    let param;

    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }

    return param;
  }

  min(min, message = date.min) {
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return util_isAbsent(value) || value >= this.resolve(limit);
      }

    });
  }

  max(max, message = date.max) {
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value <= this.resolve(limit);
      }

    });
  }

}
DateSchema.INVALID_DATE = invalidDate;
date_create.prototype = DateSchema.prototype;
date_create.INVALID_DATE = invalidDate;
// EXTERNAL MODULE: ./node_modules/lodash/snakeCase.js
var snakeCase = __webpack_require__(41825);
var snakeCase_default = /*#__PURE__*/__webpack_require__.n(snakeCase);
// EXTERNAL MODULE: ./node_modules/lodash/camelCase.js
var camelCase = __webpack_require__(29131);
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);
// EXTERNAL MODULE: ./node_modules/lodash/mapKeys.js
var mapKeys = __webpack_require__(17581);
var mapKeys_default = /*#__PURE__*/__webpack_require__.n(mapKeys);
// EXTERNAL MODULE: ./node_modules/toposort/index.js
var toposort = __webpack_require__(64174);
var toposort_default = /*#__PURE__*/__webpack_require__.n(toposort);
;// CONCATENATED MODULE: ./node_modules/yup/es/util/sortFields.js
 // @ts-expect-error





function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));

  function addNode(depPath, key) {
    let node = (0,property_expr.split)(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`)) edges.push([key, node]);
  }

  for (const key in fields) if (has_default()(fields, key)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (util_isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }

  return toposort_default().array(Array.from(nodes), edges).reverse();
}
;// CONCATENATED MODULE: ./node_modules/yup/es/util/sortByKeyOrder.js
function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;

    if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}
;// CONCATENATED MODULE: ./node_modules/yup/es/object.js
function object_extends() { object_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return object_extends.apply(this, arguments); }














let isObject = obj => Object.prototype.toString.call(obj) === '[object Object]';

function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}

const defaultSort = sortByKeyOrder([]);
class ObjectSchema extends BaseSchema {
  constructor(spec) {
    super({
      type: 'object'
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      this.transform(function coerce(value) {
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }

        if (this.isType(value)) return value;
        return null;
      });

      if (spec) {
        this.shape(spec);
      }
    });
  }

  _typeCheck(value) {
    return isObject(value) || typeof value === 'function';
  }

  _cast(_value, options = {}) {
    var _options$stripUnknown;

    let value = super._cast(_value, options); //should ignore nulls here


    if (value === undefined) return this.getDefault();
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;

    let props = this._nodes.concat(Object.keys(value).filter(v => this._nodes.indexOf(v) === -1));

    let intermediateValue = {}; // is filled during the transform below

    let innerOptions = object_extends({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });

    let isChanged = false;

    for (const prop of props) {
      let field = fields[prop];
      let exists = has_default()(value, prop);

      if (field) {
        let fieldValue;
        let inputValue = value[prop]; // safe to mutate since this is fired in sequence

        innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];

        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = 'spec' in field ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;

        if (fieldSpec == null ? void 0 : fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }

        fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
        field.cast(value[prop], innerOptions) : value[prop];

        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }

      if (intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }

    return isChanged ? intermediateValue : value;
  }

  _validate(_value, opts = {}, callback) {
    let errors = [];
    let {
      sync,
      from = [],
      originalValue = _value,
      abortEarly = this.spec.abortEarly,
      recursive = this.spec.recursive
    } = opts;
    from = [{
      schema: this,
      value: originalValue
    }, ...from]; // this flag is needed for handling `strict` correctly in the context of
    // validation vs just casting. e.g strict() on a field is only used when validating

    opts.__validating = true;
    opts.originalValue = originalValue;
    opts.from = from;

    super._validate(_value, opts, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || abortEarly) {
          return void callback(err, value);
        }

        errors.push(err);
      }

      if (!recursive || !isObject(value)) {
        callback(errors[0] || null, value);
        return;
      }

      originalValue = originalValue || value;

      let tests = this._nodes.map(key => (_, cb) => {
        let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
        let field = this.fields[key];

        if (field && 'validate' in field) {
          field.validate(value[key], object_extends({}, opts, {
            // @ts-ignore
            path,
            from,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: true,
            parent: value,
            originalValue: originalValue[key]
          }), cb);
          return;
        }

        cb(null);
      });

      runTests({
        sync,
        tests,
        value,
        errors,
        endEarly: abortEarly,
        sort: this._sortErrors,
        path: opts.path
      }, callback);
    });
  }

  clone(spec) {
    const next = super.clone(spec);
    next.fields = object_extends({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }

  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;

    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];

      if (target === undefined) {
        nextFields[field] = schemaOrRef;
      } else if (target instanceof BaseSchema && schemaOrRef instanceof BaseSchema) {
        nextFields[field] = schemaOrRef.concat(target);
      }
    }

    return next.withMutation(() => next.shape(nextFields, this._excludedEdges));
  }

  getDefaultFromShape() {
    let dft = {};

    this._nodes.forEach(key => {
      const field = this.fields[key];
      dft[key] = 'default' in field ? field.getDefault() : undefined;
    });

    return dft;
  }

  _getDefault() {
    if ('default' in this.spec) {
      return super._getDefault();
    } // if there is no default set invent one


    if (!this._nodes.length) {
      return undefined;
    }

    return this.getDefaultFromShape();
  }

  shape(additions, excludes = []) {
    let next = this.clone();
    let fields = Object.assign(next.fields, additions);
    next.fields = fields;
    next._sortErrors = sortByKeyOrder(Object.keys(fields));

    if (excludes.length) {
      // this is a convenience for when users only supply a single pair
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      next._excludedEdges = [...next._excludedEdges, ...excludes];
    }

    next._nodes = sortFields(fields, next._excludedEdges);
    return next;
  }

  pick(keys) {
    const picked = {};

    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }

    return this.clone().withMutation(next => {
      next.fields = {};
      return next.shape(picked);
    });
  }

  omit(keys) {
    const next = this.clone();
    const fields = next.fields;
    next.fields = {};

    for (const key of keys) {
      delete fields[key];
    }

    return next.withMutation(() => next.shape(fields));
  }

  from(from, to, alias) {
    let fromGetter = (0,property_expr.getter)(from, true);
    return this.transform(obj => {
      if (obj == null) return obj;
      let newObj = obj;

      if (has_default()(obj, from)) {
        newObj = object_extends({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  }

  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,

      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }

    });
    next.spec.noUnknown = noAllow;
    return next;
  }

  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }

  transformKeys(fn) {
    return this.transform(obj => obj && mapKeys_default()(obj, (_, key) => fn(key)));
  }

  camelCase() {
    return this.transformKeys((camelCase_default()));
  }

  snakeCase() {
    return this.transformKeys((snakeCase_default()));
  }

  constantCase() {
    return this.transformKeys(key => snakeCase_default()(key).toUpperCase());
  }

  describe() {
    let base = super.describe();
    base.fields = mapValues_default()(this.fields, value => value.describe());
    return base;
  }

}
function object_create(spec) {
  return new ObjectSchema(spec);
}
object_create.prototype = ObjectSchema.prototype;
;// CONCATENATED MODULE: ./node_modules/yup/es/array.js
function array_extends() { array_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return array_extends.apply(this, arguments); }








function array_create(type) {
  return new ArraySchema(type);
}
class ArraySchema extends BaseSchema {
  constructor(type) {
    super({
      type: 'array'
    }); // `undefined` specifically means uninitialized, as opposed to
    // "no subtype"

    this.innerType = void 0;
    this.innerType = type;
    this.withMutation(() => {
      this.transform(function (values) {
        if (typeof values === 'string') try {
          values = JSON.parse(values);
        } catch (err) {
          values = null;
        }
        return this.isType(values) ? values : null;
      });
    });
  }

  _typeCheck(v) {
    return Array.isArray(v);
  }

  get _subType() {
    return this.innerType;
  }

  _cast(_value, _opts) {
    const value = super._cast(_value, _opts); //should ignore nulls here


    if (!this._typeCheck(value) || !this.innerType) return value;
    let isChanged = false;
    const castArray = value.map((v, idx) => {
      const castElement = this.innerType.cast(v, array_extends({}, _opts, {
        path: `${_opts.path || ''}[${idx}]`
      }));

      if (castElement !== v) {
        isChanged = true;
      }

      return castElement;
    });
    return isChanged ? castArray : value;
  }

  _validate(_value, options = {}, callback) {
    var _options$abortEarly, _options$recursive;

    let errors = [];
    let sync = options.sync;
    let path = options.path;
    let innerType = this.innerType;
    let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
    let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
    let originalValue = options.originalValue != null ? options.originalValue : _value;

    super._validate(_value, options, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || endEarly) {
          return void callback(err, value);
        }

        errors.push(err);
      }

      if (!recursive || !innerType || !this._typeCheck(value)) {
        callback(errors[0] || null, value);
        return;
      }

      originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated

      let tests = new Array(value.length);

      for (let idx = 0; idx < value.length; idx++) {
        let item = value[idx];
        let path = `${options.path || ''}[${idx}]`; // object._validate note for isStrict explanation

        let innerOptions = array_extends({}, options, {
          path,
          strict: true,
          parent: value,
          index: idx,
          originalValue: originalValue[idx]
        });

        tests[idx] = (_, cb) => innerType.validate(item, innerOptions, cb);
      }

      runTests({
        sync,
        path,
        value,
        errors,
        endEarly,
        tests
      }, callback);
    });
  }

  clone(spec) {
    const next = super.clone(spec);
    next.innerType = this.innerType;
    return next;
  }

  concat(schema) {
    let next = super.concat(schema);
    next.innerType = this.innerType;
    if (schema.innerType) next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat()
    next.innerType.concat(schema.innerType) : schema.innerType;
    return next;
  }

  of(schema) {
    // FIXME: this should return a new instance of array without the default to be
    let next = this.clone();
    if (!util_isSchema(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + printValue(schema)); // FIXME(ts):

    next.innerType = schema;
    return next;
  }

  length(length, message = array.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return util_isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message) {
    message = message || array.min;
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      // FIXME(ts): Array<typeof T>
      test(value) {
        return util_isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message) {
    message = message || array.max;
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  ensure() {
    return this.default(() => []).transform((val, original) => {
      // We don't want to return `null` for nullable schema
      if (this._typeCheck(val)) return val;
      return original == null ? [] : [].concat(original);
    });
  }

  compact(rejector) {
    let reject = !rejector ? v => !!v : (v, i, a) => !rejector(v, i, a);
    return this.transform(values => values != null ? values.filter(reject) : values);
  }

  describe() {
    let base = super.describe();
    if (this.innerType) base.innerType = this.innerType.describe();
    return base;
  }

  nullable(isNullable = true) {
    return super.nullable(isNullable);
  }

  defined() {
    return super.defined();
  }

  required(msg) {
    return super.required(msg);
  }

}
array_create.prototype = ArraySchema.prototype; //
// Interfaces
//
;// CONCATENATED MODULE: ./node_modules/yup/es/setLocale.js

function setLocale(custom) {
  Object.keys(custom).forEach(type => {
    // @ts-ignore
    Object.keys(custom[type]).forEach(method => {
      // @ts-ignore
      locale[type][method] = custom[type][method];
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/yup/es/index.js















function addMethod(schemaType, name, fn) {
  if (!schemaType || !isSchema(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}




/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(89143);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V7": function() { return /* binding */ transformTranslationsIntoNames; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "dD": function() { return /* binding */ parseQueryString; },
/* harmony export */   "jR": function() { return /* binding */ queryStringFromObject; },
/* harmony export */   "td": function() { return /* binding */ baseApiUrl; }
/* harmony export */ });
/* unused harmony export isServerError */
/* provided dependency */ var process = __webpack_require__(89885);
function queryStringFromObject(params) {
    var paramString = Object.keys(params !== null && params !== void 0 ? params : []).map(function(key) {
        return "".concat(key, "=").concat(params[key]);
    }).join("&");
    return paramString.length > 0 ? "?".concat(paramString) : "";
}
function parseQueryString(str) {
    if (!str) {
        return {};
    }
    return JSON.parse('{"' + decodeURI(str).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}
function baseApiUrl() {
    // for the browser always use the public API url
    if (true) {
        return "https://dramoxapi.cz/";
    }
    // for production try to use API within internal network, fallback to public API url/ todo: @petr
    return process.env.API_INTERNAL_URL || "https://dramoxapi.cz/";
}
var sleep = function(m) {
    return new Promise(function(r) {
        return setTimeout(r, m);
    });
};
function isServerError(response) {
    var ref;
    return ((ref = response) === null || ref === void 0 ? void 0 : ref.error) !== undefined;
}
function transformTranslationsIntoNames(translations) {
    return translations.map(function(t) {
        return {
            id: t.id,
            names: t.translations
        };
    });
}


/***/ }),

/***/ 66564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getSharedApiClient; }
/* harmony export */ });
/* unused harmony export ApiClient */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43692);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62139);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5447);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44453);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83244);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _apiHelpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65639);
/* harmony import */ var _enums_errors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10367);
/* harmony import */ var enums__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39933);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12774);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17651);










var ApiClient = /*#__PURE__*/ function() {
    "use strict";
    function ApiClient(locale, token, ip, forcedDomain, forceCountryForDev) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, ApiClient);
        this.locale = locale;
        this.token = token;
        this.ip = ip;
        this.forcedDomain = forcedDomain;
        this.forceCountryForDev = forceCountryForDev;
    }
    var _proto = ApiClient.prototype;
    _proto.getDonateOptions = function getDonateOptions() {
        return this.get("payments/donation/options");
    };
    _proto.getCountryInfo = function getCountryInfo() {
        return this.get("countries/info");
    };
    _proto.getHomepageSection = function getHomepageSection(id) {
        return this.get("homepage/section/".concat(id));
    };
    _proto.getHomepageContent = function getHomepageContent() {
        return this.get("homepage/promoted");
    };
    _proto.getPlayDetail = function getPlayDetail(slugOrId) {
        var url = "plays/".concat(slugOrId);
        if (typeof slugOrId === "string") {
            url = "plays/slug/".concat(slugOrId);
        }
        return this.get(url);
    };
    _proto.getSimilarPlays = function getSimilarPlays(id, body) {
        return this.post("plays/".concat(id, "/similar"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            order: "desc",
            order_by: "date_published_from"
        }, body));
    };
    _proto.getPlays = function getPlays(body) {
        // order: "desc", order_by: "views",
        return this.post("plays", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, body));
    };
    _proto.getCurrentlyWatchingPlays = function getCurrentlyWatchingPlays() {
        return this.get("plays/current");
    };
    _proto.getDramoxOriginalsPlays = function getDramoxOriginalsPlays() {
        return this.get("plays/originals");
    };
    _proto.getTheatreDetail = function getTheatreDetail(slugOrId) {
        if (typeof slugOrId === "string") {
            return this.getTheatreDetailSlug(slugOrId);
        }
        return this.get("theatres/".concat(slugOrId));
    };
    _proto.getTheatreDetailSlug = function getTheatreDetailSlug(slug) {
        return this.get("theatres/slug/".concat(slug));
    };
    _proto.getTheatres = function getTheatres(query) {
        return this.get("theatres", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, query));
    };
    _proto.getHomepageSections = function getHomepageSections(user, limit, landing_page) {
        var payload = JSON.parse(JSON.stringify({
            limit: limit,
            landing_page: landing_page
        })); // remove undefined DTM-1603
        return this.get("homepage", payload);
    };
    _proto.getGenres = function getGenres() {
        return this.get("genres");
    };
    _proto.getGenre = function getGenre(id) {
        return this.get("genres/".concat(id));
    };
    _proto.getTheatresWithNames = function getTheatresWithNames() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.get("translations/theatres/names", null, {
                            Authorization: "ApiKey ".concat("UEzvDwcKH61z4vVh8zZi3feJwLDddK")
                        });
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", (0,_apiHelpers__WEBPACK_IMPORTED_MODULE_2__/* .transformTranslationsIntoNames */ .V7)(res.items));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getCelebritiesWithNames = function getCelebritiesWithNames() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.get("translations/celebrities/names", null, {
                            Authorization: "ApiKey ".concat("UEzvDwcKH61z4vVh8zZi3feJwLDddK")
                        });
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", (0,_apiHelpers__WEBPACK_IMPORTED_MODULE_2__/* .transformTranslationsIntoNames */ .V7)(res.items));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getPlaysWithNames = function getPlaysWithNames() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.get("translations/plays/names", null, {
                            Authorization: "ApiKey ".concat("UEzvDwcKH61z4vVh8zZi3feJwLDddK")
                        });
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", (0,_apiHelpers__WEBPACK_IMPORTED_MODULE_2__/* .transformTranslationsIntoNames */ .V7)(res.items));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getCelebrityDetail = function getCelebrityDetail(slugOrId) {
        var url = "celebrities/".concat(slugOrId);
        if (typeof slugOrId === "string") {
            url = "celebrities/slug/".concat(slugOrId);
        }
        return this.get(url);
    };
    _proto.getVideo = function getVideo(id) {
        return this.get("video/".concat(id));
    };
    _proto.updateVideoProgress = function updateVideoProgress(id, progress, timeWatched, sessionId) {
        return this.post("video/".concat(id, "/tick"), {
            user_progress: progress,
            time_watched: timeWatched,
            session_id: sessionId
        });
    };
    _proto.search = function search(query) {
        return this.post("search", {
            query: query
        });
    };
    _proto.paymentDonation = function paymentDonation(body) {
        try {
            return this.post("payments/donation", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, body));
        } catch (e) {
            if (e.status === 400) {
                throw _enums_errors__WEBPACK_IMPORTED_MODULE_3__/* .AppApiError.DonationError */ .u.DonationError;
            }
        }
    };
    _proto.getUser = function getUser() {
        try {
            return this.get("user");
        } catch (e) {
            throw _enums_errors__WEBPACK_IMPORTED_MODULE_3__/* .AppApiError.UserError */ .u.UserError;
        }
    };
    _proto.checkUserExists = function checkUserExists(email) {
        return this.post("user/exists", {
            email: email
        });
    };
    _proto.createUser = function createUser(body) {
        return this.post("user/register", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, body));
    };
    _proto.getPlans = function getPlans() {
        return this.get("plans");
    };
    _proto.getUserCards = function getUserCards() {
        return this.get("user/cards");
    };
    _proto.getCountries = function getCountries() {
        return this.get("countries");
    };
    _proto.getPurchaseHistory = function getPurchaseHistory() {
        return this.get("user/history");
    };
    _proto.deleteUser = function deleteUser() {
        return this.delete("user");
    };
    _proto.changeDefaultCard = function changeDefaultCard(cardId) {
        return this.post("user/cards", {
            id: cardId
        });
    };
    _proto.removeUserCard = function removeUserCard(cardId) {
        return this.delete("user/cards/".concat(cardId));
    };
    _proto.cancelSubscription = function cancelSubscription() {
        return this.delete("subscription/change");
    };
    _proto.changeSubscription = function changeSubscription(planId) {
        return this.post("subscription/change", {
            plan_id: planId
        });
    };
    _proto.resetPassword = function resetPassword(email) {
        return this.post("user/resetPassword", {
            email: email
        });
    };
    _proto.sendEmail = function sendEmail(sendEmail1) {
        return this.post("email", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, sendEmail1));
    };
    _proto.updateUserData = function updateUserData(body) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.patch("user", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, body));
                    case 3:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        throw _enums_errors__WEBPACK_IMPORTED_MODULE_3__/* .AppApiError.PatchUserError */ .u.PatchUserError;
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }))();
    };
    _proto.redeeemVoucher = function redeeemVoucher(code) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.post("payments/codes", {
                            code: code,
                            type: "VOUCHER"
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        throw _ctx.t0.cause;
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }))();
    };
    _proto.redeemCode = function redeemCode(code, type) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.post("payments/codes", {
                            code: code,
                            type: type
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        throw _ctx.t0.cause;
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }))();
    };
    _proto.previewPromoCode = function previewPromoCode(code) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.get("payments/codes", {
                            code: code
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        throw _ctx.t0.cause;
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }))();
    };
    _proto.buySubscription = function buySubscription(body) {
        try {
            return this.post("payments/subscription", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, body));
        } catch (e) {
            if (e.status === 400) {
                throw _enums_errors__WEBPACK_IMPORTED_MODULE_3__/* .AppApiError.SubscriptionPaymentError */ .u.SubscriptionPaymentError;
            }
        }
    };
    _proto.paymentVoucher = function paymentVoucher(body) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.post("payments/voucher", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, body));
                    case 3:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        if (!(_ctx.t0.status === 400)) {
                            _ctx.next = 11;
                            break;
                        }
                        throw _enums_errors__WEBPACK_IMPORTED_MODULE_3__/* .AppApiError.VoucherPaymentError */ .u.VoucherPaymentError;
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }))();
    };
    _proto.addCard = function addCard() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.post("user/cards/add");
                    case 3:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        if (!(_ctx.t0.status === 400)) {
                            _ctx.next = 11;
                            break;
                        }
                        throw _enums_errors__WEBPACK_IMPORTED_MODULE_3__/* .AppApiError.AddCard */ .u.AddCard;
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }))();
    };
    _proto.changePassword = function changePassword() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.post("user/changePassword");
                    case 3:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        throw _ctx.t0;
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }))();
    };
    _proto.getPromoCode = function getPromoCode() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.get("user/promo");
                    case 3:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        if (!(_ctx.t0.cause === _enums_errors__WEBPACK_IMPORTED_MODULE_3__/* .AppApiError.PromoNotAllowed */ .u.PromoNotAllowed)) {
                            _ctx.next = 11;
                            break;
                        }
                        throw _enums_errors__WEBPACK_IMPORTED_MODULE_3__/* .AppApiError.PromoNotAllowed */ .u.PromoNotAllowed;
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }))();
    };
    _proto.addToWatchlist = function addToWatchlist(playId) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.post("user/watchlist", {}, {
                            play: playId
                        });
                    case 3:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        if (!(_ctx.t0.status === 400)) {
                            _ctx.next = 13;
                            break;
                        }
                        throw _enums_errors__WEBPACK_IMPORTED_MODULE_3__/* .AppApiError.QueryParamsMissing */ .u.QueryParamsMissing;
                    case 13:
                        if (!(_ctx.t0.status === 401)) {
                            _ctx.next = 15;
                            break;
                        }
                        throw _enums_errors__WEBPACK_IMPORTED_MODULE_3__/* .AppApiError.AuthInvalid */ .u.AuthInvalid;
                    case 15:
                        throw _ctx.t0;
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }))();
    };
    _proto.getWatchList = function getWatchList() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.get("user/watchlist");
                    case 3:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        if (!(_ctx.t0.status === 401)) {
                            _ctx.next = 11;
                            break;
                        }
                        throw _enums_errors__WEBPACK_IMPORTED_MODULE_3__/* .AppApiError.AuthInvalid */ .u.AuthInvalid;
                    case 11:
                        throw _ctx.t0;
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }))();
    };
    _proto.getPaymentCodes = function getPaymentCodes(code) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.get("payments/codes", {
                            code: code
                        });
                    case 3:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        throw _ctx.t0.cause;
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }))();
    };
    _proto.removeFromWatchlist = function removeFromWatchlist(playId) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.delete("user/watchlist", {
                            play: playId
                        });
                    case 3:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        if (!(_ctx.t0.status === 400)) {
                            _ctx.next = 13;
                            break;
                        }
                        throw _enums_errors__WEBPACK_IMPORTED_MODULE_3__/* .AppApiError.QueryParamsMissing */ .u.QueryParamsMissing;
                    case 13:
                        if (!(_ctx.t0.status === 401)) {
                            _ctx.next = 15;
                            break;
                        }
                        throw _enums_errors__WEBPACK_IMPORTED_MODULE_3__/* .AppApiError.AuthInvalid */ .u.AuthInvalid;
                    case 15:
                        throw _ctx.t0;
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }))();
    };
    _proto.popularTheatres = function popularTheatres() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.get("theatres/popular");
                    case 3:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        throw _ctx.t0;
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }))();
    };
    _proto.theatresFilters = function theatresFilters() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.get("theatres/filters");
                    case 3:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        throw _ctx.t0;
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }))();
    };
    _proto.cookieAnalytics = function cookieAnalytics(payload) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.post("analytics/cookies", payload);
                    case 3:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        throw _ctx.t0;
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }))();
    };
    _proto.getBroadcastSchedule = function getBroadcastSchedule() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this.get("/videos/live/schedule");
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        throw _ctx.t0;
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }))();
    };
    _proto.getSocials = function getSocials() {
        return this.get("socials");
    };
    _proto._getHeaders = function _getHeaders() {
        var headers = {
            "Content-Type": "application/json",
            "Accept-Language": this.locale
        };
        if (this.token) {
            headers["Authorization"] = "Bearer " + this.token;
        }
        if (this.ip) {
            headers["X-Forwarded-For"] = this.ip;
        }
        if (this.forcedDomain) {
            headers["Domain"] = this.forcedDomain;
        }
        if (this.forceCountryForDev) {
            headers["Debug-Country-Override"] = this.forceCountryForDev;
        }
        return headers;
    };
    _proto.get = function get(url) {
        var queryParams = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, headers = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var _this = this;
        return new Promise(function(resolve, reject) {
            return isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default()("".concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_2__/* .baseApiUrl */ .td)()).concat(url).concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_2__/* .queryStringFromObject */ .jR)(queryParams)), {
                method: "GET",
                headers: Object.assign({}, _this._getHeaders(), headers)
            }).then(function(res) {
                if (res.status === 204) {
                    resolve({});
                } else if (res.status > 204) {
                    res.json().then(reject).catch(reject);
                } else {
                    res.json().then(resolve).catch(reject);
                }
            }).catch(reject);
        });
    };
    _proto.post = function post(url) {
        var body = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, queryParams = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        var _this = this;
        return new Promise(function(resolve, reject) {
            isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default()("".concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_2__/* .baseApiUrl */ .td)()).concat(url).concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_2__/* .queryStringFromObject */ .jR)(queryParams)), {
                method: "POST",
                body: JSON.stringify(body),
                headers: _this._getHeaders()
            }).then(function(res) {
                if (res.status === 204) {
                    resolve({});
                } else if (res.status > 204) {
                    res.json().then(reject).catch(reject);
                } else {
                    res.json().then(resolve).catch(reject);
                }
            }).catch(reject);
        });
    };
    _proto.delete = function _delete(url) {
        var queryParams = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var _this = this;
        return new Promise(function(resolve, reject) {
            isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default()("".concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_2__/* .baseApiUrl */ .td)()).concat(url).concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_2__/* .queryStringFromObject */ .jR)(queryParams)), {
                method: "DELETE",
                headers: _this._getHeaders()
            }).then(function() {
                return resolve(Promise.resolve());
            }).catch(reject);
        });
    };
    _proto.patch = function patch(url, body) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default()("".concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_2__/* .baseApiUrl */ .td)()).concat(url), {
                method: "PATCH",
                headers: _this._getHeaders(),
                body: JSON.stringify(body)
            }).then(function(res) {
                if (res.status > 204) {
                    return reject(reject);
                }
                return resolve(res.json());
            }).catch(reject);
        });
    };
    return ApiClient;
}();
var _sharedApiClient;
var _token;
var _locale;
function getSharedApiClient() {
    if (!_sharedApiClient) {
        var cookies = (0,nookies__WEBPACK_IMPORTED_MODULE_5__.parseCookies)();
        rebuildApiClient(_locale !== null && _locale !== void 0 ? _locale : cookies.NEXT_LOCALE, _token);
    }
    return _sharedApiClient;
}
if (true) {
    window.addEventListener(enums__WEBPACK_IMPORTED_MODULE_4__/* .Events.AuthToken */ .zW.AuthToken, function(e) {
        var token = e.detail;
        _token = token;
        var cookies = (0,nookies__WEBPACK_IMPORTED_MODULE_5__.parseCookies)();
        rebuildApiClient(_locale !== null && _locale !== void 0 ? _locale : cookies.NEXT_LOCALE, _token);
    });
    window.addEventListener(enums__WEBPACK_IMPORTED_MODULE_4__/* .Events.Language */ .zW.Language, function(e) {
        var locale = e.detail;
        _locale = locale;
        rebuildApiClient(locale, _token);
    });
}
function rebuildApiClient(locale, token) {
    var domain = null;
    if (!token) {
        domain = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .domainFromHost */ .Pn)(window.location.host);
    }
    _sharedApiClient = new ApiClient(locale, token, null, domain);
}


/***/ }),

/***/ 54087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ firebaseApp; }
});

// EXTERNAL MODULE: ./node_modules/@firebase/app/dist/index.esm.js + 6 modules
var index_esm = __webpack_require__(13459);
;// CONCATENATED MODULE: ./node_modules/firebase/app/dist/index.esm.js



var index_esm_name = "firebase";
var version = "8.10.1";

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
index_esm/* default.registerVersion */.Z.registerVersion(index_esm_name, version, 'app');
index_esm/* default.SDK_VERSION */.Z.SDK_VERSION = version;
//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./api/firebase.ts
/* provided dependency */ var process = __webpack_require__(89885);

var config = {
    apiKey: "AIzaSyAixAhl9bfbPg1gOwo_Rql2ReERbr7F1tA",
    authDomain: "dramox-78c86.firebaseapp.com",
    databaseURL: "",
    projectId: "dramox-78c86",
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGE_SENDER_ID,
    appId: "1:389978603406:web:e2f0aadea88cb2411aaedf"
};
var firebaseApp = !index_esm/* default.apps.length */.Z.apps.length ? index_esm/* default.initializeApp */.Z.initializeApp(config) : index_esm/* default.app */.Z.app(); // /**
 //  * Given a refresh token, get a new Firebase ID token. Call this when
 //  * the Firebase ID token has expired.
 //  * @return {String} The new ID token
 //  */
 // export const refreshExpiredIdToken = async (refreshToken: string) => {
 //   if (!refreshToken) {
 //     throw new Error('The "refreshToken" argument is required.');
 //   }
 //   const apiKey = process.env.NEXT_PUBLIC_FIREBASE_API_KEY;
 //   // https://firebase.google.com/docs/reference/rest/auth/#section-refresh-token
 //   const endpoint = `https://securetoken.googleapis.com/v1/token?key=${apiKey}`;
 //   console.log("refreshing from here");
 //   const response = await fetch(endpoint, {
 //     method: "POST",
 //     headers: {
 //       "Content-Type": "application/x-www-form-urlencoded",
 //     },
 //     body: `grant_type=refresh_token&refresh_token=${refreshToken}`,
 //   });
 //   const responseJSON = await response.json();
 //   if (!response.ok) {
 //     throw new Error(`Problem refreshing token: ${JSON.stringify(responseJSON)}`);
 //   }
 //   const idToken = responseJSON.id_token;
 //   return idToken;
 // };


/***/ }),

/***/ 22826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Accordion": function() { return /* binding */ Accordion; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2746);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56168);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50922);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61836);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58772);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50744);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);






var Accordion = function(props) {
    var title = props.title, content = props.content, expandedHeaderClassName = props.expandedHeaderClassName, onToggle = props.onToggle;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), expanded = ref[0], setExpanded = ref[1];
    var handleToggle = function() {
        setExpanded(!expanded);
        if (onToggle) {
            onToggle();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.h5 */ .E.h5, {
                initial: false,
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accordionHeader), expanded ? expandedHeaderClassName : null),
                onClick: handleToggle,
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .AnimatePresence */ .M, {
                initial: false,
                children: expanded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.section */ .E.section, {
                    initial: "collapsed",
                    animate: "open",
                    exit: "collapsed",
                    variants: {
                        open: {
                            opacity: 1,
                            height: "auto"
                        },
                        collapsed: {
                            opacity: 0,
                            height: 0
                        }
                    },
                    transition: {
                        duration: 0.48,
                        ease: [
                            0.04,
                            0.62,
                            0.23,
                            0.98
                        ]
                    },
                    children: content
                }, "content")
            })
        ]
    });
};


/***/ }),

/***/ 3245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5447);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99728);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27427);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70082);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17651);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75657);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56168);




// import { useLang } from 'context/langContext';




var AppLink = function(_param) {
    var children = _param.children, href = _param.href, onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "href",
        "onClick"
    ]);
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_1__/* .useLang */ .J)().locale;
    var localisedHref = href;
    if (typeof href === "string") {
        localisedHref = (0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .localiseUrl */ ._Q)(href, locale);
    }
    if (onClick) {
        // wrap in additional function in case we need to do something in the future (i.e. preventDefault etc.)
        var _onClick = function() {
            // e.preventDefault();
            onClick();
        };
        children = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.cloneElement)(children, {
            onClick: _onClick
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        href: localisedHref
    }, props), {
        locale: false,
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AppLink);


/***/ }),

/***/ 20010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17651);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56168);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79206);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var DramoxImage = function(param) {
    var src = param.src, _width = param.width, width = _width === void 0 ? 0 : _width, _height = param.height, height = _height === void 0 ? 0 : _height, quality = param.quality, alt = param.alt, className = param.className, placeholderClass = param.placeholderClass, _loadImmediately = param.loadImmediately, loadImmediately = _loadImmediately === void 0 ? true : _loadImmediately, _usePlaceholder = param.usePlaceholder, usePlaceholder = _usePlaceholder === void 0 ? false : _usePlaceholder;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loaded = ref2[0], setLoaded = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref;
        if (ref1 === null || ref1 === void 0 ? void 0 : (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.clientWidth) {
            // image loaded in dom, hide placeholder
            setLoaded(true);
        }
    }, [
        ref1 === null || ref1 === void 0 ? void 0 : (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.clientWidth
    ]);
    var image = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (!src) {
            return null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            ref: ref1,
            className: [
                className,
                loaded ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().loaded) : ""
            ].join(" "),
            srcSet: "".concat((0,helpers__WEBPACK_IMPORTED_MODULE_1__/* .imageUrl */ .sQ)(src, width, height, quality), " 1x, ").concat((0,helpers__WEBPACK_IMPORTED_MODULE_1__/* .imageUrl */ .sQ)(src, width * 2, height * 2, quality), " 2x"),
            src: (0,helpers__WEBPACK_IMPORTED_MODULE_1__/* .imageUrl */ .sQ)(src, width * 2, height * 2, quality),
            width: width,
            height: height,
            alt: alt
        });
    }, [
        src
    ]);
    if (loadImmediately && !usePlaceholder) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: image
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: [
            placeholderClass,
            (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imgPlaceholder)
        ].join(" "),
        children: loadImmediately && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: image
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DramoxImage);


/***/ }),

/***/ 46323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(43692);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(2746);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(44453);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(50744);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(67902);
// EXTERNAL MODULE: ./helpers/index.ts + 50 modules
var helpers = __webpack_require__(17651);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(84911);
// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(66564);
// EXTERNAL MODULE: ./components/AppLink/AppLink.tsx
var AppLink = __webpack_require__(3245);
// EXTERNAL MODULE: ./context/langContext.ts
var langContext = __webpack_require__(70082);
// EXTERNAL MODULE: ./enums/namespaces.ts
var namespaces = __webpack_require__(99731);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(75332);
;// CONCATENATED MODULE: ./components/Search/Search.tsx













var MIN_SEARCH_INPUT = 3;
var debounceTimer = null;
var searchingCls = "searching";
var SearchInput = function() {
    var ref;
    var t = (0,useTranslation/* default */.Z)(namespaces/* Namespace.Common */.l.Common).t;
    var ref1 = (0,react.useState)(null), results = ref1[0], setResults = ref1[1];
    var ref2 = (0,react.useState)([]), flattenedResults = ref2[0], setFlattenedResults = ref2[1];
    var ref3 = (0,react.useState)(-1), activeResultIndex = ref3[0], setActiveResultIndex = ref3[1];
    var ref4 = (0,react.useState)(false), displaySearch = ref4[0], setDisplaySearch = ref4[1];
    var ref5 = (0,react.useState)(false), enterPressed = ref5[0], setEnterPressed = ref5[1];
    var router = (0,next_router.useRouter)();
    var locale = (0,langContext/* useLang */.J)().locale;
    var refInput = (0,react.useRef)(null);
    var refResultList = (0,react.useRef)(null);
    var ref6 = results !== null && results !== void 0 ? results : {
        plays: [],
        theatres: [],
        celebrities: []
    }, plays = ref6.plays, theatres = ref6.theatres, celebrities = ref6.celebrities;
    var close = function() {
        var docHtml = document.documentElement;
        var htmlClsList = docHtml.classList;
        htmlClsList.remove(searchingCls);
        setDisplaySearch(false);
        setResults(null);
        setFlattenedResults([]);
        setTimeout(function() {
            if (refInput.current) {
                refInput.current.value = "";
                refInput.current.blur();
            }
        }, 251); // close animation lasts for 250ms, set value to blank after it's finished
    };
    var open = function() {
        var docHtml = document.documentElement;
        var htmlClsList = docHtml.classList;
        htmlClsList.add(searchingCls);
        htmlClsList.remove(constants/* mobileMenuCls */.LT);
        setDisplaySearch(true);
    };
    (0,react.useEffect)(function() {
        if (results) {
            setFlattenedResults((0,_to_consumable_array/* default */.Z)(results.plays).concat((0,_to_consumable_array/* default */.Z)(results.theatres), (0,_to_consumable_array/* default */.Z)(results.celebrities)));
        } else {
            setFlattenedResults([]);
        }
    }, [
        results
    ]);
    (0,react.useEffect)(function() {
        refInput.current.addEventListener("focus", function() {
            open();
        });
        refInput.current.addEventListener("keydown", function(e) {
            if (e.code === "Escape") {
                close();
            } else if (e.code === "ArrowDown") {
                e.preventDefault();
                setActiveResultIndex(function(prev) {
                    return prev + 1;
                });
            } else if (e.code === "ArrowUp") {
                e.preventDefault();
                setActiveResultIndex(function(prev) {
                    return Math.max(0, prev - 1);
                });
            } else if (e.code === "Enter") {
                setEnterPressed(true);
            }
        });
        refInput.current.addEventListener("input", (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var searchString;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setActiveResultIndex(-1);
                        window.clearTimeout(debounceTimer);
                        searchString = refInput.current.value;
                        if (searchString.length >= MIN_SEARCH_INPUT) {
                            // resolve after 200ms (or clear within next key stroke)
                            debounceTimer = window.setTimeout((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                var results;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.prev = 0;
                                            _ctx.next = 3;
                                            return (0,client/* getSharedApiClient */.L)().search(searchString);
                                        case 3:
                                            results = _ctx.sent;
                                            setResults(results);
                                            _ctx.next = 9;
                                            break;
                                        case 7:
                                            _ctx.prev = 7;
                                            _ctx.t0 = _ctx["catch"](0);
                                        case 9:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee, null, [
                                    [
                                        0,
                                        7
                                    ]
                                ]);
                            })), 200);
                        } else {
                            setResults(null);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })));
        // blur search on close button click
        var elSearchClose = document.getElementById("search-close");
        elSearchClose === null || elSearchClose === void 0 ? void 0 : elSearchClose.addEventListener("click", function(e) {
            var ref;
            e.stopImmediatePropagation();
            e.preventDefault();
            (ref = document.activeElement) === null || ref === void 0 ? void 0 : ref.blur();
        });
        var elCloseSearch = document.getElementById("search-cancel");
        var elOverlay = document.getElementById("search-overlay");
        [
            "touchstart",
            "click"
        ].forEach(function(event) {
            [
                elCloseSearch,
                elOverlay
            ].forEach(function(el) {
                el === null || el === void 0 ? void 0 : el.addEventListener(event, function(e) {
                    e.preventDefault();
                    close();
                });
            });
        });
    }, [
        refInput
    ]);
    (0,react.useEffect)(function() {
        if (refResultList && refResultList.current && document.documentElement.classList.contains("mobile")) {
            if (window.visualViewport) {
                refResultList.current.style.maxHeight = "".concat(window.visualViewport.height - 15 - 60, "px");
            }
        }
    }, [
        refResultList.current
    ]);
    (0,react.useEffect)(function() {
        if (activeResultIndex > flattenedResults.length - 1) {
            setActiveResultIndex(flattenedResults.length - 1);
        }
    }, [
        flattenedResults,
        activeResultIndex
    ]);
    (0,react.useEffect)(function() {
        if (enterPressed && flattenedResults.length && flattenedResults[activeResultIndex]) {
            var url = refResultList.current.querySelectorAll("a")[activeResultIndex].href;
            router.push(url).then(close);
        }
    }, [
        enterPressed,
        activeResultIndex,
        flattenedResults,
        refResultList
    ]);
    var emptySearch = displaySearch && !(flattenedResults === null || flattenedResults === void 0 ? void 0 : flattenedResults.length) && ((ref = refInput.current) === null || ref === void 0 ? void 0 : ref.value.length) >= MIN_SEARCH_INPUT;
    var displayResultList = !emptySearch && displaySearch && results;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "text",
                placeholder: t("search_placeholder"),
                id: "input-search",
                ref: refInput,
                autoComplete: "off"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "input-search",
                className: "search",
                children: t("search_placeholder")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "cancel",
                id: "search-cancel",
                children: "X"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "overlay",
                id: "search-overlay"
            }),
            displayResultList ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "result-list",
                ref: refResultList,
                children: [
                    (plays === null || plays === void 0 ? void 0 : plays.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: t("performances")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: plays.map(function(play) {
                                    var ref, ref1;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                            href: helpers/* Permalink.playFromSearchResponse */.xm.playFromSearchResponse(play, locale),
                                            onClick: function() {
                                                close();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: ((ref = flattenedResults[activeResultIndex]) === null || ref === void 0 ? void 0 : ref.name) === play.name && ((ref1 = flattenedResults[activeResultIndex]) === null || ref1 === void 0 ? void 0 : ref1.id) === play.id ? "active" : null,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: play.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                        children: play.theatre_name
                                                    })
                                                ]
                                            })
                                        })
                                    }, play.id);
                                })
                            })
                        ]
                    }),
                    (theatres === null || theatres === void 0 ? void 0 : theatres.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: t("theatres")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: theatres.map(function(theatre) {
                                    var ref, ref1;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                            href: helpers/* Permalink.theatre */.xm.theatre(theatre, locale),
                                            onClick: function() {
                                                close();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: ((ref = flattenedResults[activeResultIndex]) === null || ref === void 0 ? void 0 : ref.name) === theatre.name && ((ref1 = flattenedResults[activeResultIndex]) === null || ref1 === void 0 ? void 0 : ref1.id) === theatre.id ? "active" : null,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: theatre.name
                                                })
                                            })
                                        })
                                    }, theatre.name);
                                })
                            })
                        ]
                    }),
                    (celebrities === null || celebrities === void 0 ? void 0 : celebrities.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: t("actors")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: celebrities.map(function(celebrity) {
                                    var ref, ref1;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                            href: helpers/* Permalink.celebrity */.xm.celebrity(celebrity, locale),
                                            onClick: close,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: ((ref = flattenedResults[activeResultIndex]) === null || ref === void 0 ? void 0 : ref.id) === celebrity.id && ((ref1 = flattenedResults[activeResultIndex]) === null || ref1 === void 0 ? void 0 : ref1.name) === celebrity.name ? "active" : null,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: celebrity.name
                                                })
                                            })
                                        })
                                    }, celebrity.name);
                                })
                            })
                        ]
                    })
                ]
            }) : emptySearch ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "result-list empty",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: t("no_search_results")
                        })
                    })
                })
            }) : null
        ]
    });
};
/* harmony default export */ var Search = (SearchInput);

// EXTERNAL MODULE: ./enums/index.ts + 3 modules
var enums = __webpack_require__(39933);
// EXTERNAL MODULE: ./enums/routeType.js
var routeType = __webpack_require__(33973);
// EXTERNAL MODULE: ./constants/ui.ts
var ui = __webpack_require__(73684);
// EXTERNAL MODULE: ./context/index.ts + 2 modules
var context = __webpack_require__(52662);
;// CONCATENATED MODULE: ./components/Header/headerHelpers.tsx









var closeMenu = function() {
    var htmlClsList = (0,helpers/* getDOMCls */.Cd)();
    htmlClsList.remove(ui/* mobileMenuCls */.LT);
    var collapseCls = [
        "collapse-menu-opened",
        "all-genres-opened"
    ];
    var openElements = document.querySelectorAll(collapseCls.map(function(c) {
        return ".".concat(c);
    }).join(", "));
    openElements.forEach(function(el) {
        return collapseCls.forEach(function(cls) {
            return el.classList.remove(cls);
        });
    });
};
var getAuthorizedItems = function(t) {
    var showPaidSubscriptionRelatedItems = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, countryCode = arguments.length > 2 ? arguments[2] : void 0;
    var handleLogout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        e.stopPropagation();
                        _ctx.next = 4;
                        return signout();
                    case 4:
                        window.location.href = "/";
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLogout(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var locale = (0,langContext/* useLang */.J)().locale;
    var ref = (0,context/* useAuth */.aC)(), signout = ref.signout, user = ref.user, isAnonymous = ref.isAnonymous;
    if (!user && isAnonymous) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "unlogged login ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                        href: helpers/* Permalink.login */.xm.login(locale),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "personal",
                            children: t("menu.login")
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "unlogged try-free ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                            href: helpers/* Permalink.registerStep1 */.xm.registerStep1(locale),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "register",
                                children: t((0,helpers/* getNoTrialTranslationKeyIfNeeded */.jU)("menu.try_free", countryCode))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "login-prompt",
                            children: [
                                t("register:already_account"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                    href: helpers/* Permalink.login */.xm.login(locale),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: t("register:login_prompt")
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    } else if (user && !isAnonymous) {
        var ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: "user-menu",
                id: "user-menu-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "image-logo",
                        id: "image_logo_text",
                        children: [
                            (0,helpers/* userLogo */.sN)((ref1 = user === null || user === void 0 ? void 0 : user.full_name) !== null && ref1 !== void 0 ? ref1 : user === null || user === void 0 ? void 0 : user.email),
                            (user === null || user === void 0 ? void 0 : user.showProfileWarning) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "warning"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: user === null || user === void 0 ? void 0 : user.full_name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                href: "/".concat(routeType/* RouteType.Profile */.Y.Profile),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: t("menu.my_profile")
                                })
                            }),
                            showPaidSubscriptionRelatedItems && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                        href: helpers/* Permalink.inviteFriends */.xm.inviteFriends(locale),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: t("menu.invite_friends")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                        href: helpers/* Permalink.contentSettings */.xm.contentSettings(locale),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: t("menu.content_settings")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/#/logout",
                                className: "logout",
                                onClick: handleLogout,
                                children: t("menu.logout")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "logo-arrow"
                    })
                ]
            })
        });
    }
};

// EXTERNAL MODULE: ./context/authContext.tsx + 3 modules
var authContext = __webpack_require__(13102);
// EXTERNAL MODULE: ./helpers/PlatformHelper.ts
var PlatformHelper = __webpack_require__(61400);
// EXTERNAL MODULE: ./components/Select/Select.tsx
var Select = __webpack_require__(53173);
// EXTERNAL MODULE: ./helpers/storageHelper.ts
var storageHelper = __webpack_require__(38869);
;// CONCATENATED MODULE: ./components/Header/Header.tsx



















var Header = function(param) {
    var countryCode = param.countryCode;
    var headerRef = react.useRef(null);
    var navigationRef = react.useRef(null);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), mainGenres = ref[0], setMainGenres = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), didScroll = ref1[0], setDidScroll = ref1[1];
    var t = (0,useTranslation/* default */.Z)(enums/* Namespace.Common */.lS.Common).t;
    var ref2 = (0,authContext/* useAuth */.aC)(), user = ref2.user, isUserLoaded = ref2.isUserLoaded;
    var locale = (0,langContext/* useLang */.J)().locale;
    var ref3 = (0,react.useState)(), genres = ref3[0], setGenres = ref3[1];
    var ref4 = (0,react.useState)(false), mobileMenuOpen = ref4[0], setMobileMenuOpen = ref4[1];
    var getLangFlag = (0,react.useCallback)(function() {
        return constants/* LANGUAGES_OPTIONS.find */.hb.find(function(item) {
            return item.value === locale;
        }).flag;
    }, [
        locale
    ]);
    var onLanguageChange = (0,react.useMemo)(function() {
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(language) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (user) {
                                _ctx.next = 4;
                                break;
                            }
                            {
                                (0,helpers/* forceLanguage */.MI)(language);
                            }
                            _ctx.next = 6;
                            break;
                        case 4:
                            _ctx.next = 6;
                            return (0,client/* getSharedApiClient */.L)().updateUserData({
                                language: language
                            });
                        case 6:
                            window.location.reload();
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(language) {
                return _ref.apply(this, arguments);
            };
        }();
    }, [
        user,
        isUserLoaded
    ]);
    (0,react.useEffect)(function() {
        if (locale) {
            var cacheKey = "genres_".concat(locale);
            var _cachedGenres = storageHelper/* default.getJSON */.Z.getJSON(cacheKey);
            if (_cachedGenres) {
                setGenres(_cachedGenres);
            } else {
                (0,client/* getSharedApiClient */.L)().getGenres().then(function(genres) {
                    setGenres(genres);
                    storageHelper/* default.saveJSON */.Z.saveJSON(cacheKey, genres, 60 * 60 * 1000);
                });
            }
        }
    }, [
        locale
    ]);
    (0,react.useEffect)(function() {
        var ref;
        setMainGenres((ref = genres === null || genres === void 0 ? void 0 : genres.filter(function(g) {
            return [
                "drama",
                "comedy",
                "tragedy"
            ].indexOf(g.slug) > -1;
        })) !== null && ref !== void 0 ? ref : []);
    }, [
        genres
    ]);
    var toggleMobileMenu = function(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setMobileMenuOpen(function(state) {
            return !state;
        });
    };
    (0,react.useEffect)(function() {
        var htmlClsList = (0,helpers/* getDOMCls */.Cd)();
        if (!htmlClsList.contains(constants/* mobileMenuCls */.LT)) {
            if (PlatformHelper/* default.isMobileSafari */.Z.isMobileSafari) {
                window.scroll(0, 1);
            }
            htmlClsList.add(constants/* mobileMenuCls */.LT);
        } else {
            htmlClsList.remove(constants/* mobileMenuCls */.LT);
        }
    }, [
        mobileMenuOpen
    ]);
    var onCollapseMenuClick = function(e) {
        if (mobileMenuOpen) {
            e.stopPropagation();
            e.preventDefault();
            var parent = e.target.parentElement;
            var collapseCls = "collapse-menu-opened";
            if (parent.classList.contains(collapseCls)) {
                parent.classList.remove(collapseCls);
            } else {
                parent.classList.add(collapseCls);
            }
            var allGenres = (0,helpers/* getDOM */.bn)().querySelector(".all-genres-opened");
            if (allGenres && parent.classList.contains("genres")) {
                allGenres.classList.remove("all-genres-opened");
            }
        }
    };
    var handleScroll = function() {
        var header = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current;
        if (header) {
            var navElementHeight = (header === null || header === void 0 ? void 0 : header.clientHeight) || null;
            window.scrollY > navElementHeight ? setDidScroll(true) : setDidScroll(false);
        } else {
            setDidScroll(window.scrollY > 64);
        }
    };
    react.useEffect(function() {
        var listenerCallback = (0,helpers/* debounce */.Ds)(handleScroll);
        if (window) {
            window.addEventListener("scroll", listenerCallback, false);
            return function() {
                window.removeEventListener("scroll", listenerCallback, false);
            };
        }
    }, [
        helpers/* debounce */.Ds,
        handleScroll
    ]);
    react.useEffect(function() {
        var htmlClsList = (0,helpers/* getDOMCls */.Cd)();
        if (htmlClsList.contains(constants/* mobileMenuCls */.LT)) {
            htmlClsList.remove(constants/* mobileMenuCls */.LT);
        }
        return function() {
            htmlClsList.remove(constants/* mobileMenuCls */.LT);
        };
    }, []);
    var sortedGenres = (0,helpers/* sortAlphabetically */.a)(genres, "name");
    /*
    Hide core menu items when user is registered but still hasn't activated subscription within the first week (typically /choose-plan after first login).
    Show core menu items in all other cases.
  */ var showCoreMenuEntries = (0,react.useMemo)(function() {
        return !user || !user.isWeekOldWithoutSub;
    }, [
        user
    ]);
    var ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: classnames_default()("fixed-top", {
            fixed: didScroll,
            blendLogo: countryCode !== "pl"
        }),
        ref: headerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "header-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/#/toggle-nav",
                            className: "nav-toggle",
                            id: "nav-toggle",
                            onClick: toggleMobileMenu,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "toggle-lang",
                                children: getLangFlag()
                            })
                        }),
                        showCoreMenuEntries && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "input-search",
                            className: "search"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: helpers/* Permalink.registerStep1 */.xm.registerStep1(locale),
                            className: "btn-register-header",
                            children: t("common:menu.try_now")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            className: classnames_default()("menu", user && "logged-in"),
                            role: "main",
                            ref: navigationRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    showCoreMenuEntries && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "menu-home",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: helpers/* Permalink.root */.xm.root(user, locale),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: t("menu.home")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "menu-search",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "input-search",
                                                    children: t("common:menu.search")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "menu-item collapse-menu genres",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#",
                                                        onClick: onCollapseMenuClick,
                                                        children: t("menu.genres")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        className: "primary-list",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "primary-item",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                                    href: helpers/* Permalink.mostPopular */.xm.mostPopular(locale),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: t("popular")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "border-bottom-1px primary-item",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                                    href: helpers/* Permalink.recentlyAdded */.xm.recentlyAdded(locale),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: t("recently_added")
                                                                    })
                                                                })
                                                            }),
                                                            mainGenres.map(function(g, i) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    className: classnames_default()("primary-item", i === 2 ? "border-bottom-1px" : null),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: helpers/* Permalink.genre */.xm.genre(g, locale),
                                                                        onClick: closeMenu,
                                                                        children: g.name
                                                                    })
                                                                }, i);
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                className: "all-genres with-icon collapsible-button",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        onClick: onCollapseMenuClick,
                                                                        children: t("all_genres")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                        className: classnames_default()("sub-menu", (sortedGenres === null || sortedGenres === void 0 ? void 0 : sortedGenres.length) <= 5 ? "shifted" : null),
                                                                        children: sortedGenres === null || sortedGenres === void 0 ? void 0 : sortedGenres.map(function(genre) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                className: "genre-link",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    href: helpers/* Permalink.genre */.xm.genre(genre, locale),
                                                                                    onClick: closeMenu,
                                                                                    children: genre.name
                                                                                })
                                                                            }, genre.id);
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "menu-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: helpers/* Permalink.theatres */.xm.theatres(locale),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: t("menu.theatres")
                                                    })
                                                })
                                            }),
                                            isUserLoaded && user ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "menu-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: helpers/* Permalink.watchList */.xm.watchList(locale),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: t("menu.watch_list")
                                                    })
                                                })
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "menu-item collapse-menu",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "/#/about",
                                                        onClick: onCollapseMenuClick,
                                                        children: t("menu.about")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        className: "primary-list about-dramox",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "border-bottom-1px primary-item",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                                    href: helpers/* Permalink.about */.xm.about(locale),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: t("menu.about_project")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "with-icon support-theater primary-item",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                                    href: helpers/* Permalink.donate */.xm.donate(locale),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: t("menu.theatre")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "with-icon gift-vouchers primary-item",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                                    href: helpers/* Permalink.voucher */.xm.voucher(locale),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: t("menu.voucher")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "for-schools with-icon border-bottom-1px primary-item",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                                    href: helpers/* Permalink.forSchools */.xm.forSchools(locale),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: t("menu.for_schools")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "primary-item",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                                    href: helpers/* Permalink.howToWatchMobile */.xm.howToWatchMobile(locale),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: t("menu.mobile_apps")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "primary-item",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                                    href: helpers/* Permalink.howToWatchSmartTV */.xm.howToWatchSmartTV(locale),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: t("menu.smart_tv")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "primary-item",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                                    href: helpers/* Permalink.contact */.xm.contact(locale),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: t("menu.contact")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "primary-item",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                                    href: helpers/* Permalink.faq */.xm.faq(locale),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: t("menu.faq")
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    isUserLoaded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "menu-item with-icon gift-vouchers",
                                                title: t("menu.voucher"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: helpers/* Permalink.voucher */.xm.voucher(locale),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: t("menu.voucher")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "menu-item with-icon set-language",
                                                style: {
                                                    marginRight: isUserLoaded ? "initial" : "auto"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "lang-flag",
                                                        children: getLangFlag()
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "language-list",
                                                        children: constants/* LANGUAGES_OPTIONS.map */.hb.map(function(val, i) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                onClick: function() {
                                                                    onLanguageChange(val.value);
                                                                },
                                                                dangerouslySetInnerHTML: {
                                                                    __html: val.label
                                                                }
                                                            }, i);
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    showCoreMenuEntries && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "search-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {})
                                    }),
                                    getAuthorizedItems(t, /* showPaidSubscriptionRelatedItems */ showCoreMenuEntries, (ref5 = user === null || user === void 0 ? void 0 : user.home_country) !== null && ref5 !== void 0 ? ref5 : countryCode),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "languages",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "language"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("profile:ui_language")
                                                }),
                                                isUserLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                    name: "language",
                                                    options: constants/* LANGUAGES_OPTIONS */.hb,
                                                    defaultValue: locale,
                                                    className: "tiny",
                                                    onChange: function(lang) {
                                                        return onLanguageChange(lang);
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                    href: !mobileMenuOpen ? helpers/* Permalink.root */.xm.root(user, locale) : "#",
                    onClick: mobileMenuOpen ? toggleMobileMenu : null,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: [
                            "logo",
                            locale === "uk" ? "small-logo" : ""
                        ].join(" "),
                        title: "Dramox",
                        "mobile-text": t("common:menu.logo_mobile"),
                        children: "Dramox"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Header_Header = (Header);

// EXTERNAL MODULE: ./components/Layout/Layout.module.scss
var Layout_module = __webpack_require__(88115);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
// EXTERNAL MODULE: ./hooks/index.ts + 3 modules
var hooks = __webpack_require__(22135);
// EXTERNAL MODULE: ./enums/country.ts
var country = __webpack_require__(72473);
;// CONCATENATED MODULE: ./components/Footer/Footer.tsx











var Footer = function(param) {
    var countryCode = param.countryCode;
    var ref = (0,authContext/* useAuth */.aC)(), user = ref.user, isUserLoaded = ref.isUserLoaded;
    var locale = (0,langContext/* useLang */.J)().locale;
    var t = (0,useTranslation/* default */.Z)(namespaces/* Namespace.Profile */.l.Profile).t;
    var ref1 = (0,react.useState)(), socials = ref1[0], setSocials = ref1[1];
    (0,react.useEffect)(function() {
        if (isUserLoaded) {
            var cacheKey = "socials_".concat(locale);
            var _cachedSocials = storageHelper/* default.getJSON */.Z.getJSON(cacheKey);
            if (_cachedSocials) {
                setSocials(_cachedSocials);
            } else {
                (0,client/* getSharedApiClient */.L)().getSocials().then(function(socials) {
                    setSocials(socials);
                    storageHelper/* default.saveJSON */.Z.saveJSON(cacheKey, socials, 60 * 60 * 1000);
                });
            }
        }
    }, [
        isUserLoaded
    ]);
    var FOOTER_PAGES = function() {
        return [
            {
                href: helpers/* Permalink.about */.xm.about(locale),
                label: t("common:menu.about_project")
            },
            {
                href: helpers/* Permalink.donate */.xm.donate(locale),
                label: t("common:menu.theatre")
            },
            {
                href: helpers/* Permalink.forSchools */.xm.forSchools(locale),
                label: t("common:menu.for_schools")
            },
            {
                href: helpers/* Permalink.howToWatch */.xm.howToWatch(locale),
                label: t("common:menu.how_to_watch")
            },
            {
                href: helpers/* Permalink.contact */.xm.contact(locale),
                label: t("common:menu.contact")
            },
            {
                href: helpers/* Permalink.faq */.xm.faq(locale),
                label: t("common:menu.faq")
            }, 
        ];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                href: helpers/* Permalink.root */.xm.root(user, locale),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "logo",
                    title: "Dramox",
                    children: "Dramox"
                })
            }),
            !(user === null || user === void 0 ? void 0 : user.isWeekOldWithoutSub) && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: FOOTER_PAGES().map(function(link, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                            href: link.href,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: link.label
                            })
                        })
                    }, i);
                })
            }),
            socials && socials.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "socials",
                children: socials.map(function(social) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: social.type.toLowerCase(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            target: "_blank",
                            href: social.url
                        })
                    }, social.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                        href: helpers/* Permalink.termsAndConditions */.xm.termsAndConditions(locale),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: t("common:menu.terms_conditions")
                        })
                    }),
                    " ",
                    "\u2022",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                        href: helpers/* Permalink.privacyPolicy */.xm.privacyPolicy(locale),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: t("common:menu.privacy_policy")
                        })
                    }),
                    " ",
                    "\u2022",
                    " ",
                    countryCode !== country/* Country.Ukraine */.c.Ukraine && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                href: helpers/* Permalink.cookie */.xm.cookie(),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: t("common:menu.cookies")
                                })
                            }),
                            " \u2022"
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                        href: helpers/* Permalink.authorship */.xm.authorship(locale),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: t("common:menu.authorship")
                        })
                    }),
                    countryCode === country/* Country.Czechia */.c.Czechia && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            " \u2022 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                href: helpers/* Permalink.broadcast */.xm.broadcast(locale),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: t("common:menu.broadcast")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t("common:ownership")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Copyright \xa9 2020-",
                    new Date().getFullYear(),
                    " Dramox"
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer_Footer = (Footer);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(1984);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./config/routeTable.ts
var routeTable = __webpack_require__(82278);
;// CONCATENATED MODULE: ./components/Meta/trackingScripts.tsx

var trackingScripts = function(country) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: '\n          !function(e,t,n,o,a){var c=e.Startquestion=e.Startquestion||{};c.invoked?e.console&&console.warn&&console.warn("Startquestion snippet included twice."):(c.invoked=!0,c.queue=[],c.call=function(){c.queue.push(Array.prototype.slice.call(arguments))},(e=t.createElement("script")).type="text/javascript",e.async=!0,e.src=n,(t=t.getElementsByTagName("script")[0]).parentNode.insertBefore(e,t),c.call({type:"load",config:{key:o,lang:a}}))}(window,document,\'https://library.startquestion.com/current/startquestion.js\',\'f166e34e-40ec-11ec-8d09-00505685cca8\',\'en\');\n          '
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                dangerouslySetInnerHTML: {
                    __html: "\n          (function (w, d, s, l, i) {\n            w[l] = w[l] || [];\n            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });\n            var f = d.getElementsByTagName(s)[0],\n              j = d.createElement(s),\n              dl = l != 'dataLayer' ? '&l=' + l : '';\n            j.async = true;\n            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;\n            f.parentNode.insertBefore(j, f);\n          })(window, document, 'script', 'dataLayer', 'GTM-M27M94C');\n          "
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n          window.dataLayer = window.dataLayer || [];\n          function gtag() {\n            dataLayer.push(arguments);\n          }\n          gtag('js', new Date());\n\n          gtag('config', '".concat(function() {
                        switch(country){
                            case "cz":
                            case "sk":
                                return "AW-604203976";
                            case "ua":
                                return "AW-10850542638";
                            case "pl":
                                return "AW-11017503479";
                            default:
                                return "";
                        }
                    }(), "');\n          ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                dangerouslySetInnerHTML: {
                    __html: "\n          (function (h, o, t, j, a, r) {\n            h.hj =\n              h.hj ||\n              function () {\n                (h.hj.q = h.hj.q || []).push(arguments);\n              };\n            h._hjSettings = { hjid: 2038079, hjsv: 6 };\n            a = o.getElementsByTagName('head')[0];\n            r = o.createElement('script');\n            r.async = 1;\n            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;\n            a.appendChild(r);\n          })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');\n          "
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                dangerouslySetInnerHTML: {
                    __html: "\n            var fbId = '".concat(function() {
                        switch(country){
                            case "cz":
                            case "sk":
                                return "820541082084038";
                            case "ua":
                                return "927360487980003";
                            case "pl":
                                return "467812515221802";
                            default:
                                return "567317627801812";
                        }
                    }(), "';\n            !(function (f, b, e, v, n, t, s) {\n            if (f.fbq) return;\n            n = f.fbq = function () {\n              n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);\n            };\n            if (!f._fbq) f._fbq = n;\n            n.push = n;\n            n.loaded = !0;\n            n.version = '2.0';\n            n.queue = [];\n            t = b.createElement(e);\n            t.async = !0;\n            t.src = v;\n            s = b.getElementsByTagName(e)[0];\n            s.parentNode.insertBefore(t, s);\n          })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');\n          fbq('init', fbId);\n          fbq('track', 'PageView');\n          ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                    __html: "\n          var seznam_cId = null;\n          var query = (window.location.search || '').replace('?', '').split('=');\n          if (query[0] == 'seznam_cId') {\n            seznam_cId = query[1];\n          }\n          var seznam_value = null;\n          "
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                    __html: "\n          /* <![CDATA[ */\n          var seznam_retargeting_id = 108677;\n          /* ]]> */\n          "
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                src: "//c.imedia.cz/js/retargeting.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                    __html: "\n          window.smartlook||(function(d) { var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0]; var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript'; c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c); })(document); smartlook('init', 'b41e656f8f6b07d018b3c20f0323194cc0f54919', { region: 'eu' });\n          "
                }
            })
        ]
    });
};
/* harmony default export */ var Meta_trackingScripts = (trackingScripts);

;// CONCATENATED MODULE: ./components/Meta/index.tsx







var Meta = function(param) {
    var countryCode = param.countryCode, analyticsAllowed = param.analyticsAllowed;
    var ref = (0,next_router.useRouter)(), locales = ref.locales, asPath = ref.asPath, currentLocale = ref.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "var a = document.documentElement; a.className = a.className.replace('no-js', 'js'); var e =\n        window.navigator.userAgent, m = !!e.match(/iPad/i) || !!e.match(/iPhone/i), c = e.match(/android/i); (m || c) &&\n        (a.className += ' mobile');"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: "Dramox"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, user-scalable=no, initial-scale=1, maximum-scale=1, minimum-scale=1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "author",
                content: "https://elevup.com"
            }),
            locales.map(function(locale) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "alternate",
                    href: "".concat((0,routeTable/* baseUrl */.F)(locale)).concat((0,helpers/* localiseUrl */._Q)(asPath, locale, currentLocale)),
                    hrefLang: locale
                }, locale);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "alternate",
                href: "".concat((0,routeTable/* baseUrl */.F)("en")).concat((0,helpers/* localiseUrl */._Q)(asPath, "en", currentLocale)),
                hrefLang: "x-default"
            }, "lang-default"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/favicon-16x16.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/site.webmanifest"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "mask-icon",
                href: "/safari-pinned-tab.svg",
                color: "#d73231"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-config",
                content: "/browserconfig.xml"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-TileColor",
                content: "#010117"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "theme-color",
                content: "#010117"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: helpers/* isLiveProduction */.Ur ? "index,follow" : "noindex,nofollow"
            }),
            (0,helpers/* host */.ho)() === routeTable/* default.sk */.Z.sk && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "facebook-domain-verification",
                content: "fv5fwhmfbvqi4smhyxmhtz2fb0soz7"
            }),
            (0,helpers/* host */.ho)() === routeTable/* default.default */.Z["default"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "facebook-domain-verification",
                content: "nqr715jnpkk9g3oftlo5rwikti6web"
            }),
            countryCode === country/* Country.Ukraine */.c.Ukraine && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "facebook-domain-verification",
                content: "fv5fwhmfbvqi4smhyxmhtz2fb0soz7"
            }),
            analyticsAllowed && helpers/* isLiveProduction */.Ur && Meta_trackingScripts(countryCode),
            helpers/* isLiveProduction */.Ur && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                id: "clarity-tracking-code",
                dangerouslySetInnerHTML: {
                    __html: '\n              (function(c,l,a,r,i,t,y){\n                  c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};\n                  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;\n                  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);\n              })(window, document, "clarity", "script", "nbtk5ed8xf");\n              '
                }
            })
        ]
    });
};
/* harmony default export */ var components_Meta = (Meta);

// EXTERNAL MODULE: ./context/popupContext.tsx
var popupContext = __webpack_require__(30785);
// EXTERNAL MODULE: ./enums/popupType.ts
var enums_popupType = __webpack_require__(91360);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(65117);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.js + 2 modules
var AnimatePresence = __webpack_require__(61836);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 153 modules
var motion = __webpack_require__(50922);
// EXTERNAL MODULE: ./containers/notificationList.module.scss
var notificationList_module = __webpack_require__(22202);
var notificationList_module_default = /*#__PURE__*/__webpack_require__.n(notificationList_module);
;// CONCATENATED MODULE: ./containers/notificationList.tsx






var Notification = function(props) {
    var id = props.id, _duration = props.duration, duration = _duration === void 0 ? 2500 : _duration, title = props.title, message = props.message, _variant = props.variant, variant = _variant === void 0 ? "success" : _variant;
    var notification = (0,context/* useNotificationQueue */.eL)();
    react.useEffect(function() {
        var delayDebounceFn = setTimeout(function() {
            notification.remove(id);
        }, duration);
        return function() {
            return clearTimeout(delayDebounceFn);
        };
    }, []);
    var getVariantClassName = function() {
        switch(variant){
            case "success":
                return (notificationList_module_default()).notificationSuccess;
            case "info":
                return (notificationList_module_default()).notificationInfo;
            case "danger":
                return (notificationList_module_default()).notificationDanger;
            default:
                throw new Error("Undefined case '".concat(variant, "' of variant type in Notification.getVariantClassName()."));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        role: "alert",
        className: classnames_default()((notificationList_module_default()).notification, getVariantClassName()),
        onClick: function() {
            notification.remove(id);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                className: "d-block",
                children: title
            }),
            message && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-0",
                children: message
            })
        ]
    }, id);
};
var NotificationList = function() {
    var queue = (0,context/* useNotificationQueue */.eL)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (notificationList_module_default()).notificationList,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            initial: false,
            children: queue.entries.map(function(param) {
                var id = param.id, data = param.data;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    initial: {
                        opacity: 0,
                        y: 50,
                        scale: 0.3
                    },
                    animate: {
                        opacity: 1,
                        y: 0,
                        scale: 1
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification, {
                        id: id,
                        variant: data.level,
                        title: data.title,
                        message: data.message,
                        duration: data.duration
                    })
                }, id);
            })
        })
    });
};

;// CONCATENATED MODULE: ./containers/index.ts


// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(60950);
// EXTERNAL MODULE: ./components/Popups/BasePopup.tsx
var BasePopup = __webpack_require__(73495);
// EXTERNAL MODULE: ./components/Popups/NewsletterSubscriptionDialog/index.module.scss
var index_module = __webpack_require__(49228);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/Popups/NewsletterSubscriptionDialog/index.tsx





var NewsletterSubscriptionDialog = function(param) {
    var iframe = param.iframe, onClose = param.onClose;
    var refContent = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), iframeSent = ref[0], setIframeSent = ref[1];
    var ref1 = (0,react.useState)(false), loaded = ref1[0], setLoaded = ref1[1];
    var refIframe = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BasePopup/* default */.Z, {
        showCloseIcon: true,
        classes: [
            (index_module_default()).newsletterDialog,
            loaded ? (index_module_default()).loaded : null
        ],
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: refContent,
            className: (index_module_default()).content,
            children: [
                !loaded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            duration: 2,
                            style: {
                                height: 50,
                                width: "75%",
                                borderRadius: "3px",
                                marginBottom: 12,
                                marginTop: 50
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            duration: 2,
                            style: {
                                height: 50,
                                width: "75%",
                                borderRadius: "3px",
                                marginBottom: 12
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            duration: 2,
                            style: {
                                height: 50,
                                width: "75%",
                                borderRadius: "3px",
                                marginBottom: 12
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react.cloneElement)(iframe, {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    onLoad: function(e) {
                        var iframe = e.currentTarget;
                        if (!iframeSent) {
                            var form = iframe.contentDocument.querySelector("form");
                            form.submit();
                            setIframeSent(true);
                        } else {
                            setLoaded(true);
                        }
                    },
                    ref: refIframe
                })
            ]
        })
    });
};
/* harmony default export */ var Popups_NewsletterSubscriptionDialog = (NewsletterSubscriptionDialog);

// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(46834);
;// CONCATENATED MODULE: ./components/Popups/Login.tsx









var LoginPopup = function(param) {
    var onClose = param.onClose;
    var t = (0,useTranslation/* default */.Z)(namespaces/* Namespace.Popups */.l.Popups).t;
    var locale = (0,langContext/* useLang */.J)().locale;
    var setPopup = (0,context/* usePopup */.BF)().setPopup;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BasePopup/* default */.Z, {
        showCloseIcon: false,
        classes: [],
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: t("popups:login_title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t("popups:login_content")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "buttons",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                    href: helpers/* Permalink.login */.xm.login(locale),
                    onClick: function() {
                        return setPopup(null);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "btn btn-primary",
                        children: t("popups:login_action")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                    i18nKey: "popups:login_footer",
                    components: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: helpers/* Permalink.registerStep1 */.xm.registerStep1(locale)
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Login = (LoginPopup);

;// CONCATENATED MODULE: ./components/Popups/LowQualityPopup.tsx




var LowQualityPopup = function(param) {
    var onClose = param.onClose;
    var t = (0,useTranslation/* default */.Z)(namespaces/* Namespace.Popups */.l.Popups).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BasePopup/* default */.Z, {
        showCloseIcon: false,
        classes: [],
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: t("popups:low_quality_title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t("popups:low_quality_text")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "buttons",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: onClose,
                    className: "btn btn-primary",
                    children: t("popups:low_quality_btn")
                })
            })
        ]
    });
};
/* harmony default export */ var Popups_LowQualityPopup = (LowQualityPopup);

// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var nookies_dist = __webpack_require__(12774);
;// CONCATENATED MODULE: ./components/Header/BareHeader.tsx

















var BareHeader = function(param) {
    var countryCode = param.countryCode;
    var headerRef = react.useRef(null);
    var navigationRef = react.useRef(null);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), mainGenres = ref[0], setMainGenres = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), didScroll = ref1[0], setDidScroll = ref1[1];
    var t = (0,useTranslation/* default */.Z)(enums/* Namespace.Common */.lS.Common).t;
    var ref2 = (0,authContext/* useAuth */.aC)(), user = ref2.user, isUserLoaded = ref2.isUserLoaded;
    var locale = (0,langContext/* useLang */.J)().locale;
    var ref3 = (0,react.useState)(), genres = ref3[0], setGenres = ref3[1];
    var ref4 = (0,react.useState)(false), mobileMenuOpen = ref4[0], setMobileMenuOpen = ref4[1];
    var getLangFlag = (0,react.useCallback)(function() {
        return constants/* LANGUAGES_OPTIONS.find */.hb.find(function(item) {
            return item.value === locale;
        }).flag;
    }, [
        locale
    ]);
    (0,react.useEffect)(function() {
        if (locale) {
            var cacheKey = "genres_".concat(locale);
            var _cachedGenres = storageHelper/* default.getJSON */.Z.getJSON(cacheKey);
            if (_cachedGenres) {
                setGenres(_cachedGenres);
            } else {
                (0,client/* getSharedApiClient */.L)().getGenres().then(function(genres) {
                    setGenres(genres);
                    storageHelper/* default.saveJSON */.Z.saveJSON(cacheKey, genres, 60 * 60 * 1000);
                });
            }
        }
    }, [
        locale
    ]);
    var onLanguageChange = (0,react.useMemo)(function() {
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(language) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (user) {
                                _ctx.next = 4;
                                break;
                            }
                            {
                                (0,helpers/* forceLanguage */.MI)(language);
                            }
                            _ctx.next = 6;
                            break;
                        case 4:
                            _ctx.next = 6;
                            return (0,client/* getSharedApiClient */.L)().updateUserData({
                                language: language
                            });
                        case 6:
                            window.location.reload();
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(language) {
                return _ref.apply(this, arguments);
            };
        }();
    }, [
        user,
        isUserLoaded
    ]);
    (0,react.useEffect)(function() {
        var ref;
        setMainGenres((ref = genres === null || genres === void 0 ? void 0 : genres.filter(function(g) {
            return [
                "drama",
                "comedy",
                "tragedy"
            ].indexOf(g.slug) > -1;
        })) !== null && ref !== void 0 ? ref : []);
    }, [
        genres
    ]);
    var toggleMobileMenu = function(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setMobileMenuOpen(function(state) {
            return !state;
        });
    };
    (0,react.useEffect)(function() {
        var htmlClsList = (0,helpers/* getDOMCls */.Cd)();
        if (!htmlClsList.contains(constants/* mobileMenuCls */.LT)) {
            if (PlatformHelper/* default.isMobileSafari */.Z.isMobileSafari) {
                window.scroll(0, 1);
            }
            htmlClsList.add(constants/* mobileMenuCls */.LT);
        } else {
            htmlClsList.remove(constants/* mobileMenuCls */.LT);
        }
    }, [
        mobileMenuOpen
    ]);
    var onCollapseMenuClick = function(e) {
        if (mobileMenuOpen) {
            e.stopPropagation();
            e.preventDefault();
            var parent = e.target.parentElement;
            var collapseCls = "collapse-menu-opened";
            if (parent.classList.contains(collapseCls)) {
                parent.classList.remove(collapseCls);
            } else {
                parent.classList.add(collapseCls);
            }
            var allGenres = (0,helpers/* getDOM */.bn)().querySelector(".all-genres-opened");
            if (allGenres && parent.classList.contains("genres")) {
                allGenres.classList.remove("all-genres-opened");
            }
        }
    };
    var handleScroll = function() {
        var header = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current;
        if (header) {
            var navElementHeight = (header === null || header === void 0 ? void 0 : header.clientHeight) || null;
            window.scrollY > navElementHeight ? setDidScroll(true) : setDidScroll(false);
        } else {
            setDidScroll(window.scrollY > 64);
        }
    };
    react.useEffect(function() {
        var listenerCallback = (0,helpers/* debounce */.Ds)(handleScroll);
        if (window) {
            window.addEventListener("scroll", listenerCallback, false);
            return function() {
                window.removeEventListener("scroll", listenerCallback, false);
            };
        }
    }, [
        helpers/* debounce */.Ds,
        handleScroll
    ]);
    react.useEffect(function() {
        var htmlClsList = (0,helpers/* getDOMCls */.Cd)();
        if (htmlClsList.contains(constants/* mobileMenuCls */.LT)) {
            htmlClsList.remove(constants/* mobileMenuCls */.LT);
        }
        return function() {
            htmlClsList.remove(constants/* mobileMenuCls */.LT);
        };
    }, []);
    var sortedGenres = (0,helpers/* sortAlphabetically */.a)(genres, "name");
    /*
    Hide core menu items when user is registered but still hasn't activated subscription within the first week (typically /choose-plan after first login).
    Show core menu items in all other cases.
  */ var showCoreMenuEntries = (0,react.useMemo)(function() {
        return !user || !user.isWeekOldWithoutSub;
    }, [
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: classnames_default()("fixed-top", {
            fixed: didScroll,
            blendLogo: countryCode !== "pl"
        }),
        ref: headerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "header-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/#/toggle-nav",
                            className: "nav-toggle",
                            id: "nav-toggle",
                            onClick: toggleMobileMenu,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "toggle-lang",
                                children: getLangFlag()
                            })
                        }),
                        showCoreMenuEntries && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "input-search",
                            className: "search"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: helpers/* Permalink.registerStep1 */.xm.registerStep1(locale),
                            className: "btn-register-header",
                            children: t("common:menu.try_now")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            className: classnames_default()("menu", user && "logged-in"),
                            role: "main",
                            ref: navigationRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "menu-item with-icon gift-vouchers",
                                        title: t("menu.voucher"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                            href: helpers/* Permalink.voucher */.xm.voucher(locale),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: t("menu.voucher")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "menu-item with-icon set-language",
                                        style: {
                                            marginRight: 30
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "lang-flag",
                                                children: getLangFlag()
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "language-list",
                                                children: constants/* LANGUAGES_OPTIONS.map */.hb.map(function(val, i) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        onClick: function() {
                                                            onLanguageChange(val.value);
                                                        },
                                                        dangerouslySetInnerHTML: {
                                                            __html: val.label
                                                        }
                                                    }, i);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "unlogged try-free ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                href: helpers/* Permalink.registerStep1 */.xm.registerStep1(locale),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "register",
                                                    children: t((0,helpers/* getNoTrialTranslationKeyIfNeeded */.jU)("welcome:welcome_button_long_".concat(countryCode), countryCode))
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "login-prompt",
                                                children: [
                                                    t("register:already_account"),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                        href: helpers/* Permalink.login */.xm.login(locale),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: t("register:login_prompt")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "languages",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "language"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("profile:ui_language")
                                                }),
                                                isUserLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                    name: "language",
                                                    options: constants/* LANGUAGES_OPTIONS */.hb,
                                                    defaultValue: locale,
                                                    className: "tiny",
                                                    onChange: function(lang) {
                                                        return onLanguageChange(lang);
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: [
                        "logo",
                        locale === "uk" ? "small-logo" : ""
                    ].join(" "),
                    title: "Dramox",
                    "mobile-text": t("common:menu.logo_mobile"),
                    children: "Dramox"
                })
            ]
        })
    });
};
/* harmony default export */ var Header_BareHeader = (BareHeader);

;// CONCATENATED MODULE: ./components/Layout/index.tsx

















var BuySubscriptionPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3029).then(__webpack_require__.bind(__webpack_require__, 83029));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83029)
            ];
        }
    },
    ssr: false
});
var ChangePrimaryCard = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2086).then(__webpack_require__.bind(__webpack_require__, 22086));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22086)
            ];
        }
    },
    ssr: false
});
var DeleteDialog = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1185).then(__webpack_require__.bind(__webpack_require__, 1185));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1185)
            ];
        }
    },
    ssr: false
});
var RemoveCard = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4841).then(__webpack_require__.bind(__webpack_require__, 4841));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4841)
            ];
        }
    },
    ssr: false
});
var RemoveSubsciptionDialog = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1189).then(__webpack_require__.bind(__webpack_require__, 71189));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71189)
            ];
        }
    },
    ssr: false
});
var PromoDiscountDialog = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7875).then(__webpack_require__.bind(__webpack_require__, 27875));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27875)
            ];
        }
    },
    ssr: false
});
var CookiesPopup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1816), __webpack_require__.e(748)]).then(__webpack_require__.bind(__webpack_require__, 80748));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80748)
            ];
        }
    },
    ssr: false
});
var CookiesBar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3952).then(__webpack_require__.bind(__webpack_require__, 33952));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33952)
            ];
        }
    },
    ssr: false
});
var Layout = function(param) {
    var children = param.children, _hiddenWrappers = param.hiddenWrappers, hiddenWrappers = _hiddenWrappers === void 0 ? false : _hiddenWrappers, showBareHeader = param.showBareHeader, countryCode = param.countryCode, _allowPopups = param.allowPopups, allowPopups = _allowPopups === void 0 ? true : _allowPopups;
    var ref = (0,useTranslation/* default */.Z)(), _t = ref.t;
    var setPopup = (0,popupContext/* usePopup */.BF)().setPopup;
    var ref1 = (0,react.useState)(false), allowAnalytics = ref1[0], setAllowAnalytics = ref1[1];
    var ref2 = (0,react.useState)(false), showCookieBar = ref2[0], setShowCookieBar = ref2[1];
    // ui hooks
    (0,hooks/* useCloseMobileMenu */.$1)();
    var updateTrackingAllowanceBasedOnCookies = (0,react.useCallback)(function() {
        var cookies = (0,nookies_dist.parseCookies)();
        var shouldShowCookieBar = cookies.ALLOW_GDPR === undefined;
        setAllowAnalytics(cookies.ALLOW_GDPR === "true" || shouldShowCookieBar);
        setShowCookieBar(shouldShowCookieBar);
    }, []);
    (0,react.useEffect)(updateTrackingAllowanceBasedOnCookies, []);
    (0,react.useEffect)(function() {
        if (showCookieBar) {
            // delay cookies bar for a bit so the animation doesn't repeat on redirects
            setTimeout(function() {
                setPopup(enums_popupType/* PopupType.CookiesBar */.k.CookiesBar);
            }, 1000);
        }
    }, [
        showCookieBar
    ]);
    (0,react.useEffect)(function() {
        if (!allowPopups) {
            setPopup(null);
        }
    }, [
        allowPopups
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popupContext/* popupContext.Consumer */.cy.Consumer, {
        children: function(param) {
            var popupType = param.popupType, onClose = param.onClose, data = param.data, t = param.t;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    children && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Meta, {
                                analyticsAllowed: allowAnalytics,
                                countryCode: countryCode
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Layout_module_default()).containerFluid,
                                children: [
                                    !hiddenWrappers && (showBareHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_BareHeader, {
                                        countryCode: countryCode
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {
                                        countryCode: countryCode
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationList, {}),
                                    children,
                                    !hiddenWrappers && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {
                                        countryCode: countryCode
                                    })
                                ]
                            })
                        ]
                    }),
                    allowPopups && popupType === enums_popupType/* PopupType.Login */.k.Login && /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {
                        onClose: onClose
                    }),
                    allowPopups && popupType === enums_popupType/* PopupType.BuySubscription */.k.BuySubscription && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuySubscriptionPopup, {
                        onClose: onClose
                    }),
                    allowPopups && popupType === enums_popupType/* PopupType.LowQuality */.k.LowQuality && /*#__PURE__*/ (0,jsx_runtime.jsx)(Popups_LowQualityPopup, {
                        onClose: onClose
                    }),
                    allowPopups && popupType === enums_popupType/* PopupType.DeleteUser */.k.DeleteUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteDialog, {
                        onClose: onClose,
                        t: t !== null && t !== void 0 ? t : _t
                    }),
                    allowPopups && popupType === enums_popupType/* PopupType.RemoveSubscription */.k.RemoveSubscription && /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveSubsciptionDialog, {
                        hasPromo: data.hasPromo,
                        isGracePeriodPopup: data.isGracePeriod,
                        plan: data.plan,
                        onClose: onClose,
                        t: t !== null && t !== void 0 ? t : _t
                    }),
                    allowPopups && popupType === enums_popupType/* PopupType.DeleteCard */.k.DeleteCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveCard, {
                        t: t,
                        cardId: data,
                        onClose: onClose
                    }),
                    allowPopups && popupType === enums_popupType/* PopupType.NewsletterSubscription */.k.NewsletterSubscription && /*#__PURE__*/ (0,jsx_runtime.jsx)(Popups_NewsletterSubscriptionDialog, {
                        onClose: onClose,
                        iframe: data,
                        t: t !== null && t !== void 0 ? t : _t
                    }),
                    allowPopups && popupType === enums_popupType/* PopupType.SetPrimaryCard */.k.SetPrimaryCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePrimaryCard, {
                        t: t,
                        cardId: data,
                        onClose: onClose
                    }),
                    allowPopups && popupType === enums_popupType/* PopupType.PromoDiscount */.k.PromoDiscount && function() {
                        var _data = data;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoDiscountDialog, {
                            discountPercent: _data.discountPercent,
                            discountPeriod: _data.discountPeriod,
                            discountPeriodCount: _data.discountPeriodCount,
                            code: _data.code,
                            type: _data.type,
                            onClose: onClose
                        });
                    }(),
                    allowPopups && popupType === enums_popupType/* PopupType.Cookies */.k.Cookies && /*#__PURE__*/ (0,jsx_runtime.jsx)(CookiesPopup, {
                        onClose: onClose,
                        onAccept: updateTrackingAllowanceBasedOnCookies
                    }),
                    allowPopups && popupType === enums_popupType/* PopupType.CookiesBar */.k.CookiesBar && /*#__PURE__*/ (0,jsx_runtime.jsx)(CookiesBar, {
                        onAccept: updateTrackingAllowanceBasedOnCookies
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 63104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70040);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var LoadingComponent = function(param) {
    var _spinnerSize = param.spinnerSize, spinnerSize = _spinnerSize === void 0 ? "small" : _spinnerSize;
    var classes = [
        (_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loading)
    ];
    if (spinnerSize === "medium") {
        classes.push((_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default().medium));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classes.join(" ")
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingComponent);


/***/ }),

/***/ 73495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var context_popupContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30785);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56168);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17651);




var BasePopup = function(param) {
    var children = param.children, onClose = param.onClose, classes = param.classes, showCloseIcon = param.showCloseIcon, _closeOnEscape = param.closeOnEscape, closeOnEscape = _closeOnEscape === void 0 ? true : _closeOnEscape, _allowBackgroundScrolling = param.allowBackgroundScrolling, allowBackgroundScrolling = _allowBackgroundScrolling === void 0 ? false : _allowBackgroundScrolling, _allowCloseOnOverlayClick = param.allowCloseOnOverlayClick, allowCloseOnOverlayClick = _allowCloseOnOverlayClick === void 0 ? true : _allowCloseOnOverlayClick, _showOverlay = param.showOverlay, showOverlay = _showOverlay === void 0 ? true : _showOverlay;
    var setPopup = (0,context_popupContext__WEBPACK_IMPORTED_MODULE_1__/* .usePopup */ .BF)().setPopup;
    var openDialogCls = "dialog-open";
    var allowScrollingCls = "allow-scrolling";
    var elClose = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var refOverlay = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var close = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .closeDialog */ .gk)(allowScrollingCls);
        setPopup(null);
        onClose && onClose();
    }, [
        onClose
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (showCloseIcon) {
            elClose.current.addEventListener("click", function(e) {
                e.preventDefault();
                close();
            });
        }
        window.addEventListener("resize", function() {
            if (window.innerWidth < 992) {
                closeOnEscape && close();
            }
        });
        var cls = [
            openDialogCls
        ];
        if (allowBackgroundScrolling) {
            cls.push(allowScrollingCls);
        }
        (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .toggleDialogWithCls */ .Q$)(cls, closeOnEscape, close);
        return function() {
            (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .closeDialog */ .gk)(allowScrollingCls);
        };
    }, [
        elClose,
        closeOnEscape
    ]);
    var onOverlayClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (allowCloseOnOverlayClick) {
            close();
        }
    }, [
        allowCloseOnOverlayClick
    ]);
    var content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                ref: ref,
                className: "dialog ".concat(classes.join(" ")),
                children: [
                    showCloseIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "#",
                        className: "close",
                        ref: elClose,
                        children: "close"
                    }),
                    children
                ]
            }),
            showOverlay && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "overlay",
                ref: refOverlay,
                onClick: onOverlayClick
            })
        ]
    });
    return content;
};
/* harmony default export */ __webpack_exports__["Z"] = (BasePopup);


/***/ }),

/***/ 53173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56168);


var Select = function(param) {
    var options = param.options, defaultLabel = param.defaultLabel, name = param.name, onChange = param.onChange, defaultValue = param.defaultValue, className = param.className, value = param.value, style = param.style;
    var _onChange = function(e) {
        onChange && onChange(e.target.value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                value: value,
                name: name,
                id: name,
                defaultValue: defaultValue,
                onChange: _onChange,
                className: className,
                style: style,
                children: [
                    defaultLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                        value: "",
                        disabled: true,
                        children: defaultLabel
                    }, -1),
                    options === null || options === void 0 ? void 0 : options.map(function(opt, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                            value: opt.value,
                            dangerouslySetInnerHTML: {
                                __html: opt.label
                            }
                        }, i);
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 66893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C_": function() { return /* reexport */ BrowseSkeleton; },
  "Vv": function() { return /* reexport */ FAQList; },
  "h2": function() { return /* reexport */ LoadingPage; }
});

// UNUSED EXPORTS: Accordion, InfoToolbar

// EXTERNAL MODULE: ./components/Accordion/index.tsx
var Accordion = __webpack_require__(22826);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(50744);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var esm_useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(60950);
// EXTERNAL MODULE: ./i18n.js
var i18n = __webpack_require__(57919);
// EXTERNAL MODULE: ./components/Layout/index.tsx + 12 modules
var Layout = __webpack_require__(46323);
// EXTERNAL MODULE: ./components/BrowseSkeleton/BrowseSkeleton.module.scss
var BrowseSkeleton_module = __webpack_require__(51257);
var BrowseSkeleton_module_default = /*#__PURE__*/__webpack_require__.n(BrowseSkeleton_module);
;// CONCATENATED MODULE: ./components/BrowseSkeleton/index.tsx








var BrowseSkeleton = function(param) {
    var _countryCode = param.countryCode, countryCode = _countryCode === void 0 ? i18n.defaultLocale : _countryCode;
    var t = (0,esm_useTranslation/* default */.Z)().t;
    var renderSkeletonSection = function() {
        var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "scroll-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "play-list",
                children: Array.from(Array(count).keys()).map(function(_, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                duration: 2,
                                style: {
                                    height: 144,
                                    width: "100%",
                                    borderRadius: "3px",
                                    marginBottom: 12
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    duration: 2,
                                    style: {
                                        height: 22,
                                        width: 120
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    duration: 2,
                                    style: {
                                        height: 19,
                                        width: 95
                                    }
                                })
                            })
                        ]
                    }, i);
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        countryCode: countryCode,
        allowPopups: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* SkeletonTheme */.y, {
                baseColor: "#22222E",
                highlightColor: "#2D2D3A",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "carousel-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "dramox-carousel swiper-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "swiper-slide",
                                style: {
                                    marginBottom: 45
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "links-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                duration: 2,
                                                style: {
                                                    width: 240
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                duration: 2,
                                                style: {
                                                    width: 340,
                                                    marginBottom: 20,
                                                    marginLeft: 8
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                duration: 2,
                                                style: {
                                                    width: 540,
                                                    height: 80,
                                                    marginBottom: 0
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()("buttons", (BrowseSkeleton_module_default()).buttons),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                    duration: 2,
                                                    style: {
                                                        height: 50
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                    duration: 2,
                                                    style: {
                                                        height: 50
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "category-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("common:recently_added")
                            }),
                            renderSkeletonSection()
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "category-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("common:most_popular")
                            }),
                            renderSkeletonSection(4)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "category-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("common:comedy")
                            }),
                            renderSkeletonSection(2)
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./enums/namespaces.ts
var namespaces = __webpack_require__(99731);
// EXTERNAL MODULE: ./components/FAQList/index.module.scss
var index_module = __webpack_require__(86901);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(46834);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(75332);
// EXTERNAL MODULE: ./helpers/index.ts + 50 modules
var helpers = __webpack_require__(17651);
// EXTERNAL MODULE: ./constants/links.ts
var links = __webpack_require__(60041);
// EXTERNAL MODULE: ./context/index.ts + 2 modules
var context = __webpack_require__(52662);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(65117);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/FAQList/index.tsx











var FAQList_Accordion = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 22826)).then(function(component) {
        return component.Accordion;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22826)
            ];
        }
    },
    ssr: false
});
var FAQList = function(param) {
    var _type = param.type, type = _type === void 0 ? "long" : _type, priceMonthly = param.priceMonthly, priceYearly = param.priceYearly, priceYearlyDiscount = param.priceYearlyDiscount, countryCode = param.countryCode;
    var ns = namespaces/* Namespace */.l[type === "long" ? "FAQ" : "FAQHome"];
    var t = (0,esm_useTranslation/* default */.Z)(ns).t;
    var locale = (0,router.useRouter)().locale;
    var user = (0,context/* useAuth */.aC)().user;
    var faqs = Object.values(t("items", null, {
        returnObjects: true
    }));
    var assembleTranslationKey = (0,react.useCallback)(function(index) {
        var completeKey = "".concat(ns, ":items.").concat(index, ".a");
        if (index === 14 || index === 19) {
            var ref;
            return (0,helpers/* getNoTrialTranslationKeyIfNeeded */.jU)(completeKey, (ref = user === null || user === void 0 ? void 0 : user.home_country) !== null && ref !== void 0 ? ref : countryCode);
        }
        return completeKey;
    }, [
        user,
        countryCode,
        ns
    ]);
    var getQuestion = (0,react.useCallback)(function(index) {
        var ref;
        if (index === 13 && (0,helpers/* countryHasNoTrial */.yx)((ref = user === null || user === void 0 ? void 0 : user.home_country) !== null && ref !== void 0 ? ref : countryCode)) {
            return faqs[index].no_trial_q;
        }
        return faqs[index].q;
    }, [
        faqs,
        countryCode,
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (index_module_default()).faqList,
        children: faqs.map(function(_, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQList_Accordion, {
                    title: getQuestion(i),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                            // `${ns}:items.${i + 1}.a_${country}`
                            i18nKey: assembleTranslationKey(i + 1),
                            // fallback={`${ns}:items.${i + 1}.a`}
                            values: {
                                monthly: priceMonthly,
                                yearly: priceYearly,
                                yearlyDiscount: priceYearlyDiscount
                            },
                            components: {
                                linkMobileAppsGuide: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: helpers/* Permalink.howToWatchMobile */.xm.howToWatchMobile(locale)
                                }),
                                linkSmartTvGuide: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: helpers/* Permalink.smartTV */.xm.smartTV(locale)
                                }),
                                linkAboutUs: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: helpers/* Permalink.about */.xm.about(locale)
                                }),
                                linkDonate: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: helpers/* Permalink.donate */.xm.donate(locale)
                                }),
                                linkVouchers: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: helpers/* Permalink.voucher */.xm.voucher(locale)
                                }),
                                linkAppStore: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: links/* LINK_APP_STORE */.c,
                                    target: "_blank"
                                }),
                                linkGooglePlay: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: links/* LINK_GOOGLE_PLAY */.a,
                                    target: "_blank"
                                }),
                                linkRegister: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: helpers/* Permalink.registerStep1 */.xm.registerStep1(locale)
                                }),
                                p: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {}),
                                linkDramox: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: helpers/* Permalink.root */.xm.root(user, locale)
                                })
                            }
                        })
                    }),
                    expandedHeaderClassName: (index_module_default()).expanded
                })
            }, i);
        })
    });
};

// EXTERNAL MODULE: ./context/langContext.ts
var langContext = __webpack_require__(70082);
// EXTERNAL MODULE: ./components/LoadingComponent/index.tsx
var LoadingComponent = __webpack_require__(63104);
// EXTERNAL MODULE: ./components/LoadingPage/index.module.scss
var LoadingPage_index_module = __webpack_require__(36249);
var LoadingPage_index_module_default = /*#__PURE__*/__webpack_require__.n(LoadingPage_index_module);
;// CONCATENATED MODULE: ./components/LoadingPage/index.tsx





var LoadingPage = function() {
    var locale = (0,langContext/* useLang */.J)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        countryCode: locale,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
            className: (LoadingPage_index_module_default()).loading,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingComponent/* default */.Z, {
                spinnerSize: "medium"
            })
        })
    });
};

// EXTERNAL MODULE: ./components/AppLink/AppLink.tsx
var AppLink_AppLink = __webpack_require__(3245);
// EXTERNAL MODULE: ./helpers/storageHelper.ts
var helpers_storageHelper = __webpack_require__(38869);
;// CONCATENATED MODULE: ./components/InfoToolbar/index.tsx






var InfoToolbar = function(param) {
    var translationKey = param.translationKey, link = param.link;
    var t = useTranslation().t;
    var ref = useState(false), visible = ref[0], setVisible = ref[1];
    var containerRef = useRef(null);
    useEffect(function() {
        setVisible(!storageHelper.get(translationKey));
        return function() {
            document.body.style.paddingTop = "0";
        };
    }, []);
    useEffect(function() {
        var ref;
        var elHeight = containerRef === null || containerRef === void 0 ? void 0 : (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight;
        document.body.style.paddingTop = visible ? "".concat(elHeight, "px") : "0";
    }, [
        containerRef,
        visible
    ]);
    var onClose = function() {
        storageHelper.add(translationKey, "set");
        setVisible(false);
    };
    if (!visible) {
        return null;
    }
    var text = t(translationKey);
    return /*#__PURE__*/ _jsxs("aside", {
        className: styles.container,
        ref: containerRef,
        children: [
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    !link && text,
                    !!link && /*#__PURE__*/ _jsx(AppLink, {
                        href: link,
                        children: /*#__PURE__*/ _jsx("a", {
                            children: text
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: styles.close,
                title: "Zav\u0159\xedt",
                onClick: onClose
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/index.ts







/***/ }),

/***/ 82278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ baseUrl; }
/* harmony export */ });
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17651);

// local dev
var routeTable = {
    cz: "czdramox:3300",
    sk: "skdramox:3300",
    ua: "uadramox:3300",
    pl: "pldramox:3300",
    default: "tvdramox:3300"
};
// live PROD
if (helpers__WEBPACK_IMPORTED_MODULE_0__/* .isLiveProduction */ .Ur) {
    routeTable = {
        cz: "www.dramox.cz",
        sk: "www.dramox.sk",
        ua: "www.dramox.com.ua",
        pl: "www.dramox.pl",
        default: "www.dramox.tv"
    };
// live DEV
} else if (helpers__WEBPACK_IMPORTED_MODULE_0__/* .isProduction */ .yv) {
    routeTable = {
        cz: "www.dev.dramox.cz",
        sk: "www.dev.dramox.sk",
        ua: "www.dev.dramox.com.ua",
        pl: "www.dev.dramox.pl",
        default: "www.dev.dramox.tv"
    };
}
function baseUrl(locale) {
    var ref;
    return "https://".concat((ref = routeTable[(0,helpers__WEBPACK_IMPORTED_MODULE_0__/* .localeToCountry */ .vb)(locale)]) !== null && ref !== void 0 ? ref : routeTable.default);
}
/* harmony default export */ __webpack_exports__["Z"] = (routeTable);


/***/ }),

/***/ 67902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LT": function() { return /* reexport safe */ _ui__WEBPACK_IMPORTED_MODULE_0__.LT; },
/* harmony export */   "Xx": function() { return /* reexport safe */ _ui__WEBPACK_IMPORTED_MODULE_0__.Xx; },
/* harmony export */   "hb": function() { return /* reexport safe */ _lang__WEBPACK_IMPORTED_MODULE_1__.hb; }
/* harmony export */ });
/* harmony import */ var _ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73684);
/* harmony import */ var _lang__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74782);





/***/ }),

/***/ 74782:
/***/ (function(__unused_webpack_module, exports) {

var LANGUAGES = {
    en: {
        label: "English"
    },
    cs: {
        label: "\u010Ce\u0161tina"
    },
    sk: {
        label: "Sloven\u010Dina"
    },
    uk: {
        label: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430"
    },
    pl: {
        label: "Polski"
    }
};
var LANGUAGES_OPTIONS = [
    {
        flag: "\uD83C\uDDE8\uD83C\uDDFF",
        label: "\uD83C\uDDE8\uD83C\uDDFF&nbsp;&nbsp;".concat(LANGUAGES["cs"].label),
        value: "cs"
    },
    {
        flag: "\uD83C\uDDEC\uD83C\uDDE7",
        label: "\uD83C\uDDEC\uD83C\uDDE7&nbsp;&nbsp;".concat(LANGUAGES["en"].label),
        value: "en"
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDF0",
        label: "\uD83C\uDDF8\uD83C\uDDF0&nbsp;&nbsp;".concat(LANGUAGES["sk"].label),
        value: "sk"
    },
    {
        flag: "\uD83C\uDDFA\uD83C\uDDE6",
        label: "\uD83C\uDDFA\uD83C\uDDE6&nbsp;&nbsp;".concat(LANGUAGES["uk"].label),
        value: "uk"
    },
    {
        flag: "\uD83C\uDDF5\uD83C\uDDF1",
        label: "\uD83C\uDDF5\uD83C\uDDF1&nbsp;&nbsp;".concat(LANGUAGES["pl"].label),
        value: "pl"
    }, 
];
var locales = [
    "cs",
    "en",
    "sk",
    "uk",
    "pl"
];
exports.a2 = LANGUAGES;
exports.hb = LANGUAGES_OPTIONS;
exports.k1 = locales;


/***/ }),

/***/ 60041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ LINK_GOOGLE_PLAY; },
/* harmony export */   "c": function() { return /* binding */ LINK_APP_STORE; }
/* harmony export */ });
var LINK_GOOGLE_PLAY = "https://play.google.com/store/apps/details?id=cz.dramox.dramox";
var LINK_APP_STORE = "https://apps.apple.com/cz/app/dramox-divadlo-online/id1563430137?l=cs";


/***/ }),

/***/ 73684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LT": function() { return /* binding */ mobileMenuCls; },
/* harmony export */   "Xx": function() { return /* binding */ MOBILE_VIEW_PX; },
/* harmony export */   "fk": function() { return /* binding */ homeContentCls; },
/* harmony export */   "lC": function() { return /* binding */ homeCls; }
/* harmony export */ });
var mobileMenuCls = "mobile-menu-open";
var homeCls = "home";
var homeContentCls = "home-content";
var MOBILE_VIEW_PX = 992;


/***/ }),

/***/ 13102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Yo": function() { return /* binding */ ProvideAuth; },
  "oZ": function() { return /* binding */ redirectWhenAuth; },
  "aC": function() { return /* binding */ useAuth; },
  "QO": function() { return /* binding */ withAuth; },
  "DE": function() { return /* binding */ withForcePlanToLoggedInUnsubs; },
  "JH": function() { return /* binding */ withNoSubscription; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(43692);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5447);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(44453);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(75332);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/@firebase/app/dist/index.esm.js + 6 modules
var index_esm = __webpack_require__(13459);
;// CONCATENATED MODULE: ./node_modules/@firebase/auth/dist/auth.esm.js
(function() {/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/
var k,aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)};function ba(a){a=["object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof __webpack_require__.g&&__webpack_require__.g,a];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}return globalThis}var ca=ba(this);
function da(a,b){if(b){var c=ca;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];e in c||(c[e]={});c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&aa(c,a,{configurable:!0,writable:!0,value:b})}}function ea(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}function fa(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):{next:ea(a)}}
da("Promise",function(a){function b(g){this.b=0;this.c=void 0;this.a=[];var h=this.f();try{g(h.resolve,h.reject)}catch(m){h.reject(m)}}function c(){this.a=null}function d(g){return g instanceof b?g:new b(function(h){h(g)})}if(a)return a;c.prototype.b=function(g){if(null==this.a){this.a=[];var h=this;this.c(function(){h.g()})}this.a.push(g)};var e=ca.setTimeout;c.prototype.c=function(g){e(g,0)};c.prototype.g=function(){for(;this.a&&this.a.length;){var g=this.a;this.a=[];for(var h=0;h<g.length;++h){var m=
g[h];g[h]=null;try{m()}catch(p){this.f(p)}}}this.a=null};c.prototype.f=function(g){this.c(function(){throw g;})};b.prototype.f=function(){function g(p){return function(v){m||(m=!0,p.call(h,v))}}var h=this,m=!1;return{resolve:g(this.m),reject:g(this.g)}};b.prototype.m=function(g){if(g===this)this.g(new TypeError("A Promise cannot resolve to itself"));else if(g instanceof b)this.s(g);else{a:switch(typeof g){case "object":var h=null!=g;break a;case "function":h=!0;break a;default:h=!1}h?this.v(g):this.h(g)}};
b.prototype.v=function(g){var h=void 0;try{h=g.then}catch(m){this.g(m);return}"function"==typeof h?this.u(h,g):this.h(g)};b.prototype.g=function(g){this.i(2,g)};b.prototype.h=function(g){this.i(1,g)};b.prototype.i=function(g,h){if(0!=this.b)throw Error("Cannot settle("+g+", "+h+"): Promise already settled in state"+this.b);this.b=g;this.c=h;this.l()};b.prototype.l=function(){if(null!=this.a){for(var g=0;g<this.a.length;++g)f.b(this.a[g]);this.a=null}};var f=new c;b.prototype.s=function(g){var h=this.f();
g.Ra(h.resolve,h.reject)};b.prototype.u=function(g,h){var m=this.f();try{g.call(h,m.resolve,m.reject)}catch(p){m.reject(p)}};b.prototype.then=function(g,h){function m(A,Q){return"function"==typeof A?function(ya){try{p(A(ya))}catch(Ad){v(Ad)}}:Q}var p,v,B=new b(function(A,Q){p=A;v=Q});this.Ra(m(g,p),m(h,v));return B};b.prototype.catch=function(g){return this.then(void 0,g)};b.prototype.Ra=function(g,h){function m(){switch(p.b){case 1:g(p.c);break;case 2:h(p.c);break;default:throw Error("Unexpected state: "+
p.b);}}var p=this;null==this.a?f.b(m):this.a.push(m)};b.resolve=d;b.reject=function(g){return new b(function(h,m){m(g)})};b.race=function(g){return new b(function(h,m){for(var p=fa(g),v=p.next();!v.done;v=p.next())d(v.value).Ra(h,m)})};b.all=function(g){var h=fa(g),m=h.next();return m.done?d([]):new b(function(p,v){function B(ya){return function(Ad){A[ya]=Ad;Q--;0==Q&&p(A)}}var A=[],Q=0;do A.push(void 0),Q++,d(m.value).Ra(B(A.length-1),v),m=h.next();while(!m.done)})};return b});
var ha=ha||{},l=this||self,ia=/^[\w+/_-]+[=]{0,2}$/,ja=null;function ka(a){return(a=a.querySelector&&a.querySelector("script[nonce]"))&&(a=a.nonce||a.getAttribute("nonce"))&&ia.test(a)?a:""}function la(){}function ma(a){var b=typeof a;return"object"!=b?b:a?Array.isArray(a)?"array":b:"null"}function na(a){var b=ma(a);return"array"==b||"object"==b&&"number"==typeof a.length}function oa(a){return"function"==ma(a)}function n(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}
function pa(a){return Object.prototype.hasOwnProperty.call(a,qa)&&a[qa]||(a[qa]=++ra)}var qa="closure_uid_"+(1E9*Math.random()>>>0),ra=0;function sa(a,b,c){return a.call.apply(a.bind,arguments)}function ta(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}}
function q(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?q=sa:q=ta;return q.apply(null,arguments)}function ua(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}}var va=Date.now;function r(a,b){function c(){}c.prototype=b.prototype;a.bb=b.prototype;a.prototype=new c;a.prototype.constructor=a}function wa(a){return a};/*

 Copyright 2017 Google LLC

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function t(a,b,c){this.code=xa+a;this.message=b||za[a]||"";this.a=c||null}r(t,Error);t.prototype.w=function(){var a={code:this.code,message:this.message};this.a&&(a.serverResponse=this.a);return a};t.prototype.toJSON=function(){return this.w()};function Aa(a){var b=a&&a.code;return b?new t(b.substring(xa.length),a.message,a.serverResponse):null}
var xa="auth/",za={"admin-restricted-operation":"This operation is restricted to administrators only.","argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
"captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.","code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.",
"requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.","dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-change-needs-verification":"Multi-factor users must always have a verified email.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.",
"internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.","invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.","invalid-auth-event":"An internal error has occurred.",
"invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.","invalid-continue-uri":"The continue URL provided in the request is invalid.","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
"invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-dynamic-link-domain":"The provided dynamic link domain is not configured or authorized for the current project.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.","invalid-credential":"The supplied auth credential is malformed or has expired.",
"invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-multi-factor-session":"The request does not contain a valid proof of first factor successful sign-in.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.",
"unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.","invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
"invalid-provider-id":"The specified provider ID is invalid.","invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","invalid-tenant-id":"The Auth instance's tenant ID is invalid.",
"multi-factor-info-not-found":"The user does not have a second factor matching the identifier provided.","multi-factor-auth-required":"Proof of ownership of a second factor is required to complete sign-in.","missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.","auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
"missing-verification-code":"The phone auth credential was created with an empty SMS verification code.","missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.","missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-multi-factor-info":"No second factor identifier is provided.","missing-multi-factor-session":"The request is missing proof of first factor successful sign-in.","missing-or-invalid-nonce":"The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
"missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.","network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
"no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","null-user":"A null user object was provided as the argument for an operation which requires a non-null user object.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",
"rejected-credential":"The request contains malformed or mismatching credentials.","second-factor-already-in-use":"The second factor is already enrolled on this account.","maximum-second-factor-count-exceeded":"The maximum allowed number of second factors on a user has been exceeded.","tenant-id-mismatch":"The provided tenant ID does not match the Auth instance's tenant ID",timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.",
"too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.","unsupported-first-factor":"Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.","unsupported-persistence-type":"The current environment does not support the specified persistence type.","unsupported-tenant-operation":"This operation is not supported in a multi-tenant context.",
"unverified-email":"The operation requires a verified email.","user-cancelled":"The user did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.",
"web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};var Ba={ld:{Ua:"https://staging-identitytoolkit.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",$a:"https://staging-securetoken.sandbox.googleapis.com/v1/token",Xa:"https://staging-identitytoolkit.sandbox.googleapis.com/v2/",id:"b"},sd:{Ua:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",$a:"https://securetoken.googleapis.com/v1/token",Xa:"https://identitytoolkit.googleapis.com/v2/",id:"p"},ud:{Ua:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",
$a:"https://staging-securetoken.sandbox.googleapis.com/v1/token",Xa:"https://staging-identitytoolkit.sandbox.googleapis.com/v2/",id:"s"},vd:{Ua:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",$a:"https://test-securetoken.sandbox.googleapis.com/v1/token",Xa:"https://test-identitytoolkit.sandbox.googleapis.com/v2/",id:"t"}};
function Ca(a){for(var b in Ba)if(Ba[b].id===a)return a=Ba[b],{firebaseEndpoint:a.Ua,secureTokenEndpoint:a.$a,identityPlatformEndpoint:a.Xa};return null}var Da;Da=Ca("__EID__")?"__EID__":void 0;function Ea(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function u(a){if(Error.captureStackTrace)Error.captureStackTrace(this,u);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}r(u,Error);u.prototype.name="CustomError";function Fa(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");u.call(this,c+a[d])}r(Fa,u);Fa.prototype.name="AssertionError";function Ga(a,b){throw new Fa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function Ha(a,b){this.c=a;this.f=b;this.b=0;this.a=null}Ha.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function Ia(a,b){a.f(b);100>a.b&&(a.b++,b.next=a.a,a.a=b)};function Ja(){this.b=this.a=null}var La=new Ha(function(){return new Ka},function(a){a.reset()});Ja.prototype.add=function(a,b){var c=La.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function Ma(){var a=Na,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function Ka(){this.next=this.b=this.a=null}Ka.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};Ka.prototype.reset=function(){this.next=this.b=this.a=null};var Oa=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if("string"===typeof a)return"string"!==typeof b||1!=b.length?-1:a.indexOf(b,0);for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},w=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};
function Pa(a,b){for(var c="string"===typeof a?a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)}
var Qa=Array.prototype.filter?function(a,b){return Array.prototype.filter.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=[],e=0,f="string"===typeof a?a.split(""):a,g=0;g<c;g++)if(g in f){var h=f[g];b.call(void 0,h,g,a)&&(d[e++]=h)}return d},Ra=Array.prototype.map?function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e="string"===typeof a?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},Sa=Array.prototype.some?function(a,
b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d="string"===typeof a?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};function Ta(a){a:{var b=Ua;for(var c=a.length,d="string"===typeof a?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:"string"===typeof a?a.charAt(b):a[b]}function Va(a,b){return 0<=Oa(a,b)}
function Wa(a,b){b=Oa(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function Xa(a,b){var c=0;Pa(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Ya(a){return Array.prototype.concat.apply([],arguments)}function Za(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var $a=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]},ab=/&/g,bb=/</g,cb=/>/g,db=/"/g,eb=/'/g,fb=/\x00/g,gb=/[\x00&<>"']/;function x(a,b){return-1!=a.indexOf(b)}function hb(a,b){return a<b?-1:a>b?1:0};var ib;a:{var jb=l.navigator;if(jb){var kb=jb.userAgent;if(kb){ib=kb;break a}}ib=""}function y(a){return x(ib,a)};function lb(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function mb(a){for(var b in a)return!1;return!0}function nb(a){var b={},c;for(c in a)b[c]=a[c];return b}var ob="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function z(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<ob.length;f++)c=ob[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function pb(a,b){a:{try{var c=a&&a.ownerDocument,d=c&&(c.defaultView||c.parentWindow);d=d||l;if(d.Element&&d.Location){var e=d;break a}}catch(g){}e=null}if(e&&"undefined"!=typeof e[b]&&(!a||!(a instanceof e[b])&&(a instanceof e.Location||a instanceof e.Element))){if(n(a))try{var f=a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a)}catch(g){f="<object could not be stringified>"}else f=void 0===a?"undefined":null===a?"null":typeof a;Ga("Argument is not a %s (or a non-Element, non-Location mock); got: %s",
b,f)}};function qb(a,b){this.a=a===rb&&b||"";this.b=sb}qb.prototype.ta=!0;qb.prototype.sa=function(){return this.a};qb.prototype.toString=function(){return"Const{"+this.a+"}"};function tb(a){if(a instanceof qb&&a.constructor===qb&&a.b===sb)return a.a;Ga("expected object of type Const, got '"+a+"'");return"type_error:Const"}var sb={},rb={};var ub;function vb(){if(void 0===ub){var a=null,b=l.trustedTypes;if(b&&b.createPolicy){try{a=b.createPolicy("goog#html",{createHTML:wa,createScript:wa,createScriptURL:wa})}catch(c){l.console&&l.console.error(c.message)}ub=a}else ub=a}return ub};function wb(a,b){this.a=b===xb?a:""}wb.prototype.ta=!0;wb.prototype.sa=function(){return this.a.toString()};wb.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function yb(a){if(a instanceof wb&&a.constructor===wb)return a.a;Ga("expected object of type TrustedResourceUrl, got '"+a+"' of type "+ma(a));return"type_error:TrustedResourceUrl"}
function zb(a,b){var c=tb(a);if(!Ab.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(Bb,function(d,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));d=b[e];return d instanceof qb?tb(d):encodeURIComponent(String(d))});return Cb(a)}var Bb=/%{(\w+)}/g,Ab=/^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i,xb={};
function Cb(a){var b=vb();a=b?b.createScriptURL(a):a;return new wb(a,xb)};function C(a,b){this.a=b===Db?a:""}C.prototype.ta=!0;C.prototype.sa=function(){return this.a.toString()};C.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function Eb(a){if(a instanceof C&&a.constructor===C)return a.a;Ga("expected object of type SafeUrl, got '"+a+"' of type "+ma(a));return"type_error:SafeUrl"}
var Fb=/^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|font\/\w+|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i,Gb=/^data:(.*);base64,[a-z0-9+\/]+=*$/i,Hb=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
function Ib(a){if(a instanceof C)return a;a="object"==typeof a&&a.ta?a.sa():String(a);if(Hb.test(a))a=new C(a,Db);else{a=String(a);a=a.replace(/(%0A|%0D)/g,"");var b=a.match(Gb);a=b&&Fb.test(b[1])?new C(a,Db):null}return a}function Jb(a){if(a instanceof C)return a;a="object"==typeof a&&a.ta?a.sa():String(a);Hb.test(a)||(a="about:invalid#zClosurez");return new C(a,Db)}var Db={},Kb=new C("about:invalid#zClosurez",Db);function Lb(a,b,c){this.a=c===Mb?a:""}Lb.prototype.ta=!0;Lb.prototype.sa=function(){return this.a.toString()};Lb.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Nb(a){if(a instanceof Lb&&a.constructor===Lb)return a.a;Ga("expected object of type SafeHtml, got '"+a+"' of type "+ma(a));return"type_error:SafeHtml"}var Mb={};function Ob(a,b){pb(a,"HTMLScriptElement");a.src=yb(b);(b=a.ownerDocument&&a.ownerDocument.defaultView)&&b!=l?b=ka(b.document):(null===ja&&(ja=ka(l.document)),b=ja);b&&a.setAttribute("nonce",b)}function Pb(a,b,c,d){a=a instanceof C?a:Jb(a);b=b||l;c=c instanceof qb?tb(c):c||"";return b.open(Eb(a),c,d,void 0)};function Qb(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}function Rb(a){gb.test(a)&&(-1!=a.indexOf("&")&&(a=a.replace(ab,"&amp;")),-1!=a.indexOf("<")&&(a=a.replace(bb,"&lt;")),-1!=a.indexOf(">")&&(a=a.replace(cb,"&gt;")),-1!=a.indexOf('"')&&(a=a.replace(db,"&quot;")),-1!=a.indexOf("'")&&(a=a.replace(eb,"&#39;")),-1!=a.indexOf("\x00")&&(a=a.replace(fb,"&#0;")));return a};function Sb(a){Sb[" "](a);return a}Sb[" "]=la;function Tb(a,b){var c=Ub;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var Vb=y("Opera"),Wb=y("Trident")||y("MSIE"),Xb=y("Edge"),Yb=Xb||Wb,Zb=y("Gecko")&&!(x(ib.toLowerCase(),"webkit")&&!y("Edge"))&&!(y("Trident")||y("MSIE"))&&!y("Edge"),$b=x(ib.toLowerCase(),"webkit")&&!y("Edge");function ac(){var a=l.document;return a?a.documentMode:void 0}var bc;
a:{var cc="",dc=function(){var a=ib;if(Zb)return/rv:([^\);]+)(\)|;)/.exec(a);if(Xb)return/Edge\/([\d\.]+)/.exec(a);if(Wb)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if($b)return/WebKit\/(\S+)/.exec(a);if(Vb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();dc&&(cc=dc?dc[1]:"");if(Wb){var ec=ac();if(null!=ec&&ec>parseFloat(cc)){bc=String(ec);break a}}bc=cc}var Ub={};
function fc(a){return Tb(a,function(){for(var b=0,c=$a(String(bc)).split("."),d=$a(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",h=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];if(0==g[0].length&&0==h[0].length)break;b=hb(0==g[1].length?0:parseInt(g[1],10),0==h[1].length?0:parseInt(h[1],10))||hb(0==g[2].length,0==h[2].length)||hb(g[2],h[2]);g=g[3];h=h[3]}while(0==b)}return 0<=b})}var gc;
if(l.document&&Wb){var hc=ac();gc=hc?hc:parseInt(bc,10)||void 0}else gc=void 0;var ic=gc;try{(new self.OffscreenCanvas(0,0)).getContext("2d")}catch(a){}var jc=!Wb||9<=Number(ic);function kc(a){var b=document;return"string"===typeof a?b.getElementById(a):a}function lc(a,b){lb(b,function(c,d){c&&"object"==typeof c&&c.ta&&(c=c.sa());"style"==d?a.style.cssText=c:"class"==d?a.className=c:"for"==d?a.htmlFor=c:mc.hasOwnProperty(d)?a.setAttribute(mc[d],c):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,c):a[d]=c})}
var mc={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
function nc(a,b,c){var d=arguments,e=document,f=String(d[0]),g=d[1];if(!jc&&g&&(g.name||g.type)){f=["<",f];g.name&&f.push(' name="',Rb(g.name),'"');if(g.type){f.push(' type="',Rb(g.type),'"');var h={};z(h,g);delete h.type;g=h}f.push(">");f=f.join("")}f=oc(e,f);g&&("string"===typeof g?f.className=g:Array.isArray(g)?f.className=g.join(" "):lc(f,g));2<d.length&&pc(e,f,d);return f}
function pc(a,b,c){function d(h){h&&b.appendChild("string"===typeof h?a.createTextNode(h):h)}for(var e=2;e<c.length;e++){var f=c[e];if(!na(f)||n(f)&&0<f.nodeType)d(f);else{a:{if(f&&"number"==typeof f.length){if(n(f)){var g="function"==typeof f.item||"string"==typeof f.item;break a}if(oa(f)){g="function"==typeof f.item;break a}}g=!1}w(g?Za(f):f,d)}}}function oc(a,b){b=String(b);"application/xhtml+xml"===a.contentType&&(b=b.toLowerCase());return a.createElement(b)};function qc(a){l.setTimeout(function(){throw a;},0)}var rc;
function sc(){var a=l.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!y("Presto")&&(a=function(){var e=oc(document,"IFRAME");e.style.display="none";document.documentElement.appendChild(e);var f=e.contentWindow;e=f.document;e.open();e.close();var g="callImmediate"+Math.random(),h="file:"==f.location.protocol?"*":f.location.protocol+"//"+f.location.host;e=q(function(m){if(("*"==h||m.origin==h)&&m.data==g)this.port1.onmessage()},this);
f.addEventListener("message",e,!1);this.port1={};this.port2={postMessage:function(){f.postMessage(g,h)}}});if("undefined"!==typeof a&&!y("Trident")&&!y("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var e=c.Hb;c.Hb=null;e()}};return function(e){d.next={Hb:e};d=d.next;b.port2.postMessage(0)}}return function(e){l.setTimeout(e,0)}};function tc(a,b){uc||vc();wc||(uc(),wc=!0);Na.add(a,b)}var uc;function vc(){if(l.Promise&&l.Promise.resolve){var a=l.Promise.resolve(void 0);uc=function(){a.then(xc)}}else uc=function(){var b=xc;!oa(l.setImmediate)||l.Window&&l.Window.prototype&&!y("Edge")&&l.Window.prototype.setImmediate==l.setImmediate?(rc||(rc=sc()),rc(b)):l.setImmediate(b)}}var wc=!1,Na=new Ja;function xc(){for(var a;a=Ma();){try{a.a.call(a.b)}catch(b){qc(b)}Ia(La,a)}wc=!1};function D(a,b){this.a=yc;this.i=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=la)try{var c=this;a.call(b,function(d){zc(c,Ac,d)},function(d){if(!(d instanceof Bc))try{if(d instanceof Error)throw d;throw Error("Promise rejected.");}catch(e){}zc(c,Cc,d)})}catch(d){zc(this,Cc,d)}}var yc=0,Ac=2,Cc=3;function Dc(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}Dc.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};var Ec=new Ha(function(){return new Dc},function(a){a.reset()});
function Fc(a,b,c){var d=Ec.get();d.g=a;d.b=b;d.f=c;return d}function E(a){if(a instanceof D)return a;var b=new D(la);zc(b,Ac,a);return b}function F(a){return new D(function(b,c){c(a)})}function Gc(a,b,c){Hc(a,b,c,null)||tc(ua(b,a))}function Ic(a){return new D(function(b,c){var d=a.length,e=[];if(d)for(var f=function(p,v){d--;e[p]=v;0==d&&b(e)},g=function(p){c(p)},h=0,m;h<a.length;h++)m=a[h],Gc(m,ua(f,h),g);else b(e)})}
function Jc(a){return new D(function(b){var c=a.length,d=[];if(c)for(var e=function(h,m,p){c--;d[h]=m?{Qb:!0,value:p}:{Qb:!1,reason:p};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],Gc(g,ua(e,f,!0),ua(e,f,!1));else b(d)})}D.prototype.then=function(a,b,c){return Kc(this,oa(a)?a:null,oa(b)?b:null,c)};D.prototype.$goog_Thenable=!0;k=D.prototype;k.oa=function(a,b){a=Fc(a,a,b);a.c=!0;Lc(this,a);return this};k.o=function(a,b){return Kc(this,null,a,b)};
k.cancel=function(a){if(this.a==yc){var b=new Bc(a);tc(function(){Mc(this,b)},this)}};function Mc(a,b){if(a.a==yc)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,g=c.b;g&&(g.c||(d++,g.a==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(c.a==yc&&1==d?Mc(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):Nc(c),Oc(c,e,Cc,b)))}a.c=null}else zc(a,Cc,b)}function Lc(a,b){a.b||a.a!=Ac&&a.a!=Cc||Pc(a);a.f?a.f.next=b:a.b=b;a.f=b}
function Kc(a,b,c,d){var e=Fc(null,null,null);e.a=new D(function(f,g){e.g=b?function(h){try{var m=b.call(d,h);f(m)}catch(p){g(p)}}:f;e.b=c?function(h){try{var m=c.call(d,h);void 0===m&&h instanceof Bc?g(h):f(m)}catch(p){g(p)}}:g});e.a.c=a;Lc(a,e);return e.a}k.$c=function(a){this.a=yc;zc(this,Ac,a)};k.ad=function(a){this.a=yc;zc(this,Cc,a)};
function zc(a,b,c){a.a==yc&&(a===c&&(b=Cc,c=new TypeError("Promise cannot resolve to itself")),a.a=1,Hc(c,a.$c,a.ad,a)||(a.i=c,a.a=b,a.c=null,Pc(a),b!=Cc||c instanceof Bc||Qc(a,c)))}function Hc(a,b,c,d){if(a instanceof D)return Lc(a,Fc(b||la,c||null,d)),!0;if(Ea(a))return a.then(b,c,d),!0;if(n(a))try{var e=a.then;if(oa(e))return Rc(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
function Rc(a,b,c,d,e){function f(m){h||(h=!0,d.call(e,m))}function g(m){h||(h=!0,c.call(e,m))}var h=!1;try{b.call(a,g,f)}catch(m){f(m)}}function Pc(a){a.h||(a.h=!0,tc(a.gc,a))}function Nc(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}k.gc=function(){for(var a;a=Nc(this);)Oc(this,a,this.a,this.i);this.h=!1};
function Oc(a,b,c,d){if(c==Cc&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,Sc(b,c,d);else try{b.c?b.g.call(b.f):Sc(b,c,d)}catch(e){Tc.call(null,e)}Ia(Ec,b)}function Sc(a,b,c){b==Ac?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function Qc(a,b){a.g=!0;tc(function(){a.g&&Tc.call(null,b)})}var Tc=qc;function Bc(a){u.call(this,a)}r(Bc,u);Bc.prototype.name="cancel";function Uc(){0!=Vc&&(Wc[pa(this)]=this);this.ya=this.ya;this.pa=this.pa}var Vc=0,Wc={};Uc.prototype.ya=!1;function Xc(a){if(!a.ya&&(a.ya=!0,a.Da(),0!=Vc)){var b=pa(a);if(0!=Vc&&a.pa&&0<a.pa.length)throw Error(a+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete Wc[b]}}Uc.prototype.Da=function(){if(this.pa)for(;this.pa.length;)this.pa.shift()()};var Yc=Object.freeze||function(a){return a};var Zc=!Wb||9<=Number(ic),$c=Wb&&!fc("9"),ad=function(){if(!l.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});try{l.addEventListener("test",la,b),l.removeEventListener("test",la,b)}catch(c){}return a}();function G(a,b){this.type=a;this.b=this.target=b;this.defaultPrevented=!1}G.prototype.preventDefault=function(){this.defaultPrevented=!0};function bd(a,b){G.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(Zb){a:{try{Sb(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==
c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;d?(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0):(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
a.metaKey;this.pointerId=a.pointerId||0;this.pointerType="string"===typeof a.pointerType?a.pointerType:cd[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}r(bd,G);var cd=Yc({2:"touch",3:"pen",4:"mouse"});bd.prototype.preventDefault=function(){bd.bb.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,$c)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};bd.prototype.g=function(){return this.a};var dd="closure_listenable_"+(1E6*Math.random()|0),ed=0;function fd(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.Wa=e;this.key=++ed;this.wa=this.Qa=!1}function gd(a){a.wa=!0;a.listener=null;a.proxy=null;a.src=null;a.Wa=null};function hd(a){this.src=a;this.a={};this.b=0}hd.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var g=id(a,b,d,e);-1<g?(b=a[g],c||(b.Qa=!1)):(b=new fd(b,this.src,f,!!d,e),b.Qa=c,a.push(b));return b};function jd(a,b){var c=b.type;c in a.a&&Wa(a.a[c],b)&&(gd(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function id(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.wa&&f.listener==b&&f.capture==!!c&&f.Wa==d)return e}return-1};var kd="closure_lm_"+(1E6*Math.random()|0),ld={},md=0;function nd(a,b,c,d,e){if(d&&d.once)od(a,b,c,d,e);else if(Array.isArray(b))for(var f=0;f<b.length;f++)nd(a,b[f],c,d,e);else c=pd(c),a&&a[dd]?qd(a,b,c,n(d)?!!d.capture:!!d,e):rd(a,b,c,!1,d,e)}
function rd(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=n(e)?!!e.capture:!!e,h=sd(a);h||(a[kd]=h=new hd(a));c=h.add(b,c,d,g,f);if(!c.proxy){d=td();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)ad||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(ud(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");md++}}
function td(){var a=vd,b=Zc?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function od(a,b,c,d,e){if(Array.isArray(b))for(var f=0;f<b.length;f++)od(a,b[f],c,d,e);else c=pd(c),a&&a[dd]?wd(a,b,c,n(d)?!!d.capture:!!d,e):rd(a,b,c,!0,d,e)}
function xd(a,b,c,d,e){if(Array.isArray(b))for(var f=0;f<b.length;f++)xd(a,b[f],c,d,e);else(d=n(d)?!!d.capture:!!d,c=pd(c),a&&a[dd])?(a=a.v,b=String(b).toString(),b in a.a&&(f=a.a[b],c=id(f,c,d,e),-1<c&&(gd(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=sd(a))&&(b=a.a[b.toString()],a=-1,b&&(a=id(b,c,d,e)),(c=-1<a?b[a]:null)&&yd(c))}
function yd(a){if("number"!==typeof a&&a&&!a.wa){var b=a.src;if(b&&b[dd])jd(b.v,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(ud(c),d):b.addListener&&b.removeListener&&b.removeListener(d);md--;(c=sd(b))?(jd(c,a),0==c.b&&(c.src=null,b[kd]=null)):gd(a)}}}function ud(a){return a in ld?ld[a]:ld[a]="on"+a}
function zd(a,b,c,d){var e=!0;if(a=sd(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.wa&&(f=Bd(f,d),e=e&&!1!==f)}return e}function Bd(a,b){var c=a.listener,d=a.Wa||a.src;a.Qa&&yd(a);return c.call(d,b)}
function vd(a,b){if(a.wa)return!0;if(!Zc){if(!b)a:{b=["window","event"];for(var c=l,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new bd(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=zd(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=zd(d[e],a,!1,b),c=c&&f}return c}return Bd(a,
new bd(b,this))}function sd(a){a=a[kd];return a instanceof hd?a:null}var Cd="__closure_events_fn_"+(1E9*Math.random()>>>0);function pd(a){if(oa(a))return a;a[Cd]||(a[Cd]=function(b){return a.handleEvent(b)});return a[Cd]};function H(){Uc.call(this);this.v=new hd(this);this.bc=this;this.hb=null}r(H,Uc);H.prototype[dd]=!0;H.prototype.addEventListener=function(a,b,c,d){nd(this,a,b,c,d)};H.prototype.removeEventListener=function(a,b,c,d){xd(this,a,b,c,d)};
H.prototype.dispatchEvent=function(a){var b,c=this.hb;if(c)for(b=[];c;c=c.hb)b.push(c);c=this.bc;var d=a.type||a;if("string"===typeof a)a=new G(a,c);else if(a instanceof G)a.target=a.target||c;else{var e=a;a=new G(d,c);z(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var g=a.b=b[f];e=Dd(g,d,!0,a)&&e}g=a.b=c;e=Dd(g,d,!0,a)&&e;e=Dd(g,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)g=a.b=b[f],e=Dd(g,d,!1,a)&&e;return e};
H.prototype.Da=function(){H.bb.Da.call(this);if(this.v){var a=this.v,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,gd(d[e]);delete a.a[c];a.b--}}this.hb=null};function qd(a,b,c,d,e){a.v.add(String(b),c,!1,d,e)}function wd(a,b,c,d,e){a.v.add(String(b),c,!0,d,e)}
function Dd(a,b,c,d){b=a.v.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.wa&&g.capture==c){var h=g.listener,m=g.Wa||g.src;g.Qa&&jd(a.v,g);e=!1!==h.call(m,d)&&e}}return e&&!d.defaultPrevented};function Ed(a,b,c){if(oa(a))c&&(a=q(a,c));else if(a&&"function"==typeof a.handleEvent)a=q(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:l.setTimeout(a,b||0)}function Fd(a){var b=null;return(new D(function(c,d){b=Ed(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).o(function(c){l.clearTimeout(b);throw c;})};function Gd(a){if(a.X&&"function"==typeof a.X)return a.X();if("string"===typeof a)return a.split("");if(na(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}function Hd(a){if(a.Y&&"function"==typeof a.Y)return a.Y();if(!a.X||"function"!=typeof a.X){if(na(a)||"string"===typeof a){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}b=[];c=0;for(var d in a)b[c++]=d;return b}}
function Id(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(na(a)||"string"===typeof a)w(a,b,void 0);else for(var c=Hd(a),d=Gd(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};function Jd(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof Jd)for(c=a.Y(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d])}k=Jd.prototype;k.X=function(){Kd(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};k.Y=function(){Kd(this);return this.a.concat()};
k.clear=function(){this.b={};this.c=this.a.length=0};function Kd(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];Ld(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],Ld(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}k.get=function(a,b){return Ld(this.b,a)?this.b[a]:b};k.set=function(a,b){Ld(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
k.forEach=function(a,b){for(var c=this.Y(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function Ld(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var Md=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function Nd(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function Od(a,b){this.a=this.l=this.c="";this.g=null;this.h=this.f="";this.i=!1;var c;a instanceof Od?(this.i=void 0!==b?b:a.i,Pd(this,a.c),this.l=a.l,this.a=a.a,Qd(this,a.g),this.f=a.f,Rd(this,Sd(a.b)),this.h=a.h):a&&(c=String(a).match(Md))?(this.i=!!b,Pd(this,c[1]||"",!0),this.l=Td(c[2]||""),this.a=Td(c[3]||"",!0),Qd(this,c[4]),this.f=Td(c[5]||"",!0),Rd(this,c[6]||"",!0),this.h=Td(c[7]||"")):(this.i=!!b,this.b=new Ud(null,this.i))}
Od.prototype.toString=function(){var a=[],b=this.c;b&&a.push(Vd(b,Wd,!0),":");var c=this.a;if(c||"file"==b)a.push("//"),(b=this.l)&&a.push(Vd(b,Wd,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.g,null!=c&&a.push(":",String(c));if(c=this.f)this.a&&"/"!=c.charAt(0)&&a.push("/"),a.push(Vd(c,"/"==c.charAt(0)?Xd:Yd,!0));(c=this.b.toString())&&a.push("?",c);(c=this.h)&&a.push("#",Vd(c,Zd));return a.join("")};
Od.prototype.resolve=function(a){var b=new Od(this),c=!!a.c;c?Pd(b,a.c):c=!!a.l;c?b.l=a.l:c=!!a.a;c?b.a=a.a:c=null!=a.g;var d=a.f;if(c)Qd(b,a.g);else if(c=!!a.f){if("/"!=d.charAt(0))if(this.a&&!this.f)d="/"+d;else{var e=b.f.lastIndexOf("/");-1!=e&&(d=b.f.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(x(e,"./")||x(e,"/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");for(var f=[],g=0;g<e.length;){var h=e[g++];"."==h?d&&g==e.length&&f.push(""):".."==h?((1<f.length||1==f.length&&""!=f[0])&&f.pop(),
d&&g==e.length&&f.push("")):(f.push(h),d=!0)}d=f.join("/")}else d=e}c?b.f=d:c=""!==a.b.toString();c?Rd(b,Sd(a.b)):c=!!a.h;c&&(b.h=a.h);return b};function Pd(a,b,c){a.c=c?Td(b,!0):b;a.c&&(a.c=a.c.replace(/:$/,""))}function Qd(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.g=b}else a.g=null}function Rd(a,b,c){b instanceof Ud?(a.b=b,$d(a.b,a.i)):(c||(b=Vd(b,ae)),a.b=new Ud(b,a.i))}function I(a,b,c){a.b.set(b,c)}function be(a,b){return a.b.get(b)}
function J(a){return a instanceof Od?new Od(a):new Od(a,void 0)}function ce(a,b,c,d){var e=new Od(null,void 0);a&&Pd(e,a);b&&(e.a=b);c&&Qd(e,c);d&&(e.f=d);return e}function Td(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Vd(a,b,c){return"string"===typeof a?(a=encodeURI(a).replace(b,de),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function de(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}
var Wd=/[#\/\?@]/g,Yd=/[#\?:]/g,Xd=/[#\?]/g,ae=/[#\?@]/g,Zd=/#/g;function Ud(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}function ee(a){a.a||(a.a=new Jd,a.b=0,a.c&&Nd(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}function fe(a){var b=Hd(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new Ud(null,void 0);a=Gd(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];Array.isArray(f)?ge(c,e,f):c.add(e,f)}return c}k=Ud.prototype;
k.add=function(a,b){ee(this);this.c=null;a=he(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};function ie(a,b){ee(a);b=he(a,b);Ld(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,Ld(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&Kd(a)))}k.clear=function(){this.a=this.c=null;this.b=0};function je(a,b){ee(a);b=he(a,b);return Ld(a.a.b,b)}k.forEach=function(a,b){ee(this);this.a.forEach(function(c,d){w(c,function(e){a.call(b,e,d,this)},this)},this)};
k.Y=function(){ee(this);for(var a=this.a.X(),b=this.a.Y(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};k.X=function(a){ee(this);var b=[];if("string"===typeof a)je(this,a)&&(b=Ya(b,this.a.get(he(this,a))));else{a=this.a.X();for(var c=0;c<a.length;c++)b=Ya(b,a[c])}return b};k.set=function(a,b){ee(this);this.c=null;a=he(this,a);je(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};
k.get=function(a,b){if(!a)return b;a=this.X(a);return 0<a.length?String(a[0]):b};function ge(a,b,c){ie(a,b);0<c.length&&(a.c=null,a.a.set(he(a,b),Za(c)),a.b+=c.length)}k.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.Y(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.X(d);for(var f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}}return this.c=a.join("&")};
function Sd(a){var b=new Ud;b.c=a.c;a.a&&(b.a=new Jd(a.a),b.b=a.b);return b}function he(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function $d(a,b){b&&!a.f&&(ee(a),a.c=null,a.a.forEach(function(c,d){var e=d.toLowerCase();d!=e&&(ie(this,d),ge(this,e,c))},a));a.f=b};function ke(a){var b=[];le(new me,a,b);return b.join("")}function me(){}
function le(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(Array.isArray(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),le(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),ne(d,c),c.push(":"),le(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":ne(b,c);break;case "number":c.push(isFinite(b)&&
!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var oe={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},pe=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
function ne(a,b){b.push('"',a.replace(pe,function(c){var d=oe[c];d||(d="\\u"+(c.charCodeAt(0)|65536).toString(16).substr(1),oe[c]=d);return d}),'"')};function qe(){var a=K();return Wb&&!!ic&&11==ic||/Edge\/\d+/.test(a)}function re(){return l.window&&l.window.location.href||self&&self.location&&self.location.href||""}function se(a,b){b=b||l.window;var c="about:blank";a&&(c=Eb(Ib(a)||Kb));b.location.href=c}function te(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<te(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c}
function ue(){var a=K();a=ve(a)!=we?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!Wb||!ic||9<ic}function xe(a){a=(a||K()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function ye(a){a=a||l.window;try{a.close()}catch(b){}}
function ze(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=K().toLowerCase();d&&(b.target=d,x(c,"crios/")&&(b.target="_blank"));ve(K())==Ae&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(a=b)||(a={});d=window;b=c instanceof C?c:Ib("undefined"!=typeof c.href?c.href:String(c))||Kb;c=a.target||c.target;e=
[];for(g in a)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+a[g]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(g+"="+(a[g]?1:0))}var g=e.join(",");if((y("iPhone")&&!y("iPod")&&!y("iPad")||y("iPad")||y("iPod"))&&d.navigator&&d.navigator.standalone&&c&&"_self"!=c)g=oc(document,"A"),pb(g,"HTMLAnchorElement"),b=b instanceof C?b:Jb(b),g.href=Eb(b),g.setAttribute("target",c),a.noreferrer&&g.setAttribute("rel","noreferrer"),a=document.createEvent("MouseEvent"),
a.initMouseEvent("click",!0,!0,d,1),g.dispatchEvent(a),g={};else if(a.noreferrer){if(g=Pb("",d,c,g),a=Eb(b),g&&(Yb&&x(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),g.opener=null,a='<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url='+Rb(a)+'">',a=(d=vb())?d.createHTML(a):a,a=new Lb(a,null,Mb),d=g.document))d.write(Nb(a)),d.close()}else(g=Pb(b,d,c,g))&&a.noopener&&(g.opener=null);if(g)try{g.focus()}catch(h){}return g}
function Be(a){return new D(function(b){function c(){Fd(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var Ce=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,De=/^[^@]+@[^@]+$/;function Ee(){var a=null;return(new D(function(b){"complete"==l.document.readyState?b():(a=function(){b()},od(window,"load",a))})).o(function(b){xd(window,"load",a);throw b;})}
function Fe(){return Ge(void 0)?Ee().then(function(){return new D(function(a,b){var c=l.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):F(Error("Cordova must run in an Android or iOS file scheme."))}function Ge(a){a=a||K();return!("file:"!==He()&&"ionic:"!==He()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function Ie(){var a=l.window;try{return!(!a||a==a.top)}catch(b){return!1}}
function Je(){return"undefined"!==typeof l.WorkerGlobalScope&&"function"===typeof l.importScripts}function Ke(){return index_esm/* default.INTERNAL.hasOwnProperty */.Z.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":index_esm/* default.INTERNAL.hasOwnProperty */.Z.INTERNAL.hasOwnProperty("node")?"Node":Je()?"Worker":"Browser"}function Le(){var a=Ke();return"ReactNative"===a||"Node"===a}function Me(){for(var a=50,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}
var Ae="Firefox",we="Chrome";
function ve(a){var b=a.toLowerCase();if(x(b,"opera/")||x(b,"opr/")||x(b,"opios/"))return"Opera";if(x(b,"iemobile"))return"IEMobile";if(x(b,"msie")||x(b,"trident/"))return"IE";if(x(b,"edge/"))return"Edge";if(x(b,"firefox/"))return Ae;if(x(b,"silk/"))return"Silk";if(x(b,"blackberry"))return"Blackberry";if(x(b,"webos"))return"Webos";if(!x(b,"safari/")||x(b,"chrome/")||x(b,"crios/")||x(b,"android"))if(!x(b,"chrome/")&&!x(b,"crios/")||x(b,"edge/")){if(x(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
2==a.length)return a[1]}else return we;else return"Safari";return"Other"}var Ne={md:"FirebaseCore-web",od:"FirebaseUI-web"};function Oe(a,b){b=b||[];var c=[],d={},e;for(e in Ne)d[Ne[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=Ke();"Browser"===c?(d=K(),c=ve(d)):"Worker"===c&&(d=K(),c=ve(d)+"-"+c);return c+"/JsCore/"+a+"/"+b.join(",")}function K(){return l.navigator&&l.navigator.userAgent||""}
function L(a,b){a=a.split(".");b=b||l;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function Pe(){try{var a=l.localStorage,b=Qe();if(a)return a.setItem(b,"1"),a.removeItem(b),qe()?!!l.indexedDB:!0}catch(c){return Je()&&!!l.indexedDB}return!1}function Re(){return(Se()||"chrome-extension:"===He()||Ge())&&!Le()&&Pe()&&!Je()}function Se(){return"http:"===He()||"https:"===He()}function He(){return l.location&&l.location.protocol||null}
function Te(a){a=a||K();return xe(a)||ve(a)==Ae?!1:!0}function Ue(a){return"undefined"===typeof a?null:ke(a)}function Ve(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function We(a){if(null!==a)return JSON.parse(a)}function Qe(a){return a?a:Math.floor(1E9*Math.random()).toString()}function Xe(a){a=a||K();return"Safari"==ve(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
function Ye(){var a=l.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function Ze(a,b){if(a>b)throw Error("Short delay should be less than long delay!");this.a=a;this.c=b;a=K();b=Ke();this.b=xe(a)||"ReactNative"===b}
Ze.prototype.get=function(){var a=l.navigator;return(a&&"boolean"===typeof a.onLine&&(Se()||"chrome-extension:"===He()||"undefined"!==typeof a.connection)?a.onLine:1)?this.b?this.c:this.a:Math.min(5E3,this.a)};function $e(){var a=l.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}
function af(){var a=l.document,b=null;return $e()||!a?E():(new D(function(c){b=function(){$e()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).o(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}function bf(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null}function cf(){return!(!L("fireauth.oauthhelper",l)&&!L("fireauth.iframe",l))}
function df(){var a=l.navigator;return a&&a.serviceWorker&&a.serviceWorker.controller||null}function ef(){var a=l.navigator;return a&&a.serviceWorker?E().then(function(){return a.serviceWorker.ready}).then(function(b){return b.active||null}).o(function(){return null}):E(null)};/*

 Copyright 2017 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
var ff={};function gf(a){ff[a]||(ff[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var hf;try{var jf={};Object.defineProperty(jf,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(jf,"abcd",{configurable:!0,enumerable:!0,value:2});hf=2==jf.abcd}catch(a){hf=!1}function M(a,b,c){hf?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function N(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&M(a,c,b[c])}function kf(a){var b={};N(b,a);return b}function lf(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
function mf(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function nf(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)M(b,c,nf(a[c]))}return b};/*

 Copyright 2019 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function of(a){var b=a&&(a[pf]?"phone":null);if(b&&a&&a[qf]){M(this,"uid",a[qf]);M(this,"displayName",a[rf]||null);var c=null;a[sf]&&(c=(new Date(a[sf])).toUTCString());M(this,"enrollmentTime",c);M(this,"factorId",b)}else throw new t("internal-error","Internal assert: invalid MultiFactorInfo object");}of.prototype.w=function(){return{uid:this.uid,displayName:this.displayName,factorId:this.factorId,enrollmentTime:this.enrollmentTime}};function tf(a){try{var b=new uf(a)}catch(c){b=null}return b}
var rf="displayName",sf="enrolledAt",qf="mfaEnrollmentId",pf="phoneInfo";function uf(a){of.call(this,a);M(this,"phoneNumber",a[pf])}r(uf,of);uf.prototype.w=function(){var a=uf.bb.w.call(this);a.phoneNumber=this.phoneNumber;return a};function vf(a){var b={},c=a[wf],d=a[xf],e=a[yf];a=tf(a[zf]);if(!e||e!=Af&&e!=Bf&&!c||e==Bf&&!d||e==Cf&&!a)throw Error("Invalid checkActionCode response!");e==Bf?(b[Df]=c||null,b[Ef]=c||null,b[Ff]=d):(b[Df]=d||null,b[Ef]=d||null,b[Ff]=c||null);b[Gf]=a||null;M(this,Hf,e);M(this,If,nf(b))}
var Cf="REVERT_SECOND_FACTOR_ADDITION",Af="EMAIL_SIGNIN",Bf="VERIFY_AND_CHANGE_EMAIL",wf="email",zf="mfaInfo",xf="newEmail",yf="requestType",Ff="email",Df="fromEmail",Gf="multiFactorInfo",Ef="previousEmail",If="data",Hf="operation";function Jf(a){a=J(a);var b=be(a,Kf)||null,c=be(a,Lf)||null,d=be(a,Mf)||null;d=d?Nf[d]||null:null;if(!b||!c||!d)throw new t("argument-error",Kf+", "+Lf+"and "+Mf+" are required in a valid action code URL.");N(this,{apiKey:b,operation:d,code:c,continueUrl:be(a,Of)||null,languageCode:be(a,Pf)||null,tenantId:be(a,Qf)||null})}
var Kf="apiKey",Lf="oobCode",Of="continueUrl",Pf="languageCode",Mf="mode",Qf="tenantId",Nf={recoverEmail:"RECOVER_EMAIL",resetPassword:"PASSWORD_RESET",revertSecondFactorAddition:Cf,signIn:Af,verifyAndChangeEmail:Bf,verifyEmail:"VERIFY_EMAIL"};function Rf(a){try{return new Jf(a)}catch(b){return null}};function Sf(a){var b=a[Tf];if("undefined"===typeof b)throw new t("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new t("invalid-continue-uri");this.h=b;this.b=this.a=null;this.g=!1;var c=a[Uf];if(c&&"object"===typeof c){b=c[Vf];var d=c[Wf];c=c[Xf];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new t("argument-error",Wf+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
typeof c||"string"===typeof c&&!c.length))throw new t("argument-error",Xf+" property must be a non empty string when specified.");this.b=c||null}else{if("undefined"!==typeof b)throw new t("argument-error",Vf+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new t("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new t("argument-error",Uf+" property must be a non null object when specified.");this.f=null;if((b=a[Yf])&&"object"===
typeof b)if(b=b[Zf],"string"===typeof b&&b.length)this.f=b;else{if("undefined"!==typeof b)throw new t("argument-error",Zf+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new t("argument-error",Yf+" property must be a non null object when specified.");b=a[$f];if("undefined"!==typeof b&&"boolean"!==typeof b)throw new t("argument-error",$f+" property must be a boolean when specified.");this.c=!!b;a=a[ag];if("undefined"!==typeof a&&("string"!==typeof a||"string"===
typeof a&&!a.length))throw new t("argument-error",ag+" property must be a non empty string when specified.");this.i=a||null}var Uf="android",ag="dynamicLinkDomain",$f="handleCodeInApp",Yf="iOS",Tf="url",Wf="installApp",Xf="minimumVersion",Vf="packageName",Zf="bundleId";
function bg(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.c;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.b,b.androidInstallApp=a.g;b.iOSBundleId=a.f;b.dynamicLinkDomain=a.i;for(var c in b)null===b[c]&&delete b[c];return b};function cg(a){return Ra(a,function(b){b=b.toString(16);return 1<b.length?b:"0"+b}).join("")};var dg=null;function eg(a){var b=[];fg(a,function(c){b.push(c)});return b}function fg(a,b){function c(m){for(;d<a.length;){var p=a.charAt(d++),v=dg[p];if(null!=v)return v;if(!/^[\s\xa0]*$/.test(p))throw Error("Unknown base64 encoding at char: "+p);}return m}gg();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),h=c(64);if(64===h&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=h&&b(g<<6&192|h))}}
function gg(){if(!dg){dg={};for(var a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""),b=["+/=","+/","-_=","-_.","-_"],c=0;5>c;c++)for(var d=a.concat(b[c].split("")),e=0;e<d.length;e++){var f=d[e];void 0===dg[f]&&(dg[f]=e)}}};function hg(a){var b=ig(a);if(!(b&&b.sub&&b.iss&&b.aud&&b.exp))throw Error("Invalid JWT");this.h=a;this.a=b.exp;this.i=b.sub;a=Date.now()/1E3;this.g=b.iat||(a>this.a?this.a:a);this.b=b.provider_id||b.firebase&&b.firebase.sign_in_provider||null;this.f=b.firebase&&b.firebase.tenant||null;this.c=!!b.is_anonymous||"anonymous"==this.b}hg.prototype.T=function(){return this.f};hg.prototype.l=function(){return this.c};hg.prototype.toString=function(){return this.h};
function jg(a){try{return new hg(a)}catch(b){return null}}
function ig(a){if(!a)return null;a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{var d=eg(a);a=[];for(c=b=0;b<d.length;){var e=d[b++];if(128>e)a[c++]=String.fromCharCode(e);else if(191<e&&224>e){var f=d[b++];a[c++]=String.fromCharCode((e&31)<<6|f&63)}else if(239<e&&365>e){f=d[b++];var g=d[b++],h=d[b++],m=((e&7)<<18|(f&63)<<12|(g&63)<<6|h&63)-65536;a[c++]=String.fromCharCode(55296+(m>>10));a[c++]=String.fromCharCode(56320+(m&1023))}else f=d[b++],g=
d[b++],a[c++]=String.fromCharCode((e&15)<<12|(f&63)<<6|g&63)}return JSON.parse(a.join(""))}catch(p){}return null};var kg="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),lg=["client_id","response_type","scope","redirect_uri","state"],mg={nd:{Ja:"locale",va:700,ua:600,fa:"facebook.com",Ya:lg},pd:{Ja:null,va:500,ua:750,fa:"github.com",Ya:lg},qd:{Ja:"hl",va:515,ua:680,fa:"google.com",Ya:lg},wd:{Ja:"lang",va:485,ua:705,fa:"twitter.com",Ya:kg},kd:{Ja:"locale",va:640,ua:600,fa:"apple.com",Ya:[]}};
function ng(a){for(var b in mg)if(mg[b].fa==a)return mg[b];return null};function og(a){var b={};b["facebook.com"]=pg;b["google.com"]=qg;b["github.com"]=rg;b["twitter.com"]=sg;var c=a&&a[tg];try{if(c)return b[c]?new b[c](a):new ug(a);if("undefined"!==typeof a[vg])return new wg(a)}catch(d){}return null}var vg="idToken",tg="providerId";
function wg(a){var b=a[tg];if(!b&&a[vg]){var c=jg(a[vg]);c&&c.b&&(b=c.b)}if(!b)throw Error("Invalid additional user info!");if("anonymous"==b||"custom"==b)b=null;c=!1;"undefined"!==typeof a.isNewUser?c=!!a.isNewUser:"identitytoolkit#SignupNewUserResponse"===a.kind&&(c=!0);M(this,"providerId",b);M(this,"isNewUser",c)}function ug(a){wg.call(this,a);a=We(a.rawUserInfo||"{}");M(this,"profile",nf(a||{}))}r(ug,wg);
function pg(a){ug.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}r(pg,ug);function rg(a){ug.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");M(this,"username",this.profile&&this.profile.login||null)}r(rg,ug);function qg(a){ug.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}r(qg,ug);
function sg(a){ug.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");M(this,"username",a.screenName||null)}r(sg,ug);function xg(a){var b=J(a),c=be(b,"link"),d=be(J(c),"link");b=be(b,"deep_link_id");return be(J(b),"link")||b||d||c||a};function yg(a,b){if(!a&&!b)throw new t("internal-error","Internal assert: no raw session string available");if(a&&b)throw new t("internal-error","Internal assert: unable to determine the session type");this.a=a||null;this.b=b||null;this.type=this.a?zg:Ag}var zg="enroll",Ag="signin";yg.prototype.Ha=function(){return this.a?E(this.a):E(this.b)};yg.prototype.w=function(){return this.type==zg?{multiFactorSession:{idToken:this.a}}:{multiFactorSession:{pendingCredential:this.b}}};function Bg(){}Bg.prototype.ka=function(){};Bg.prototype.b=function(){};Bg.prototype.c=function(){};Bg.prototype.w=function(){};function Cg(a,b){return a.then(function(c){if(c[Dg]){var d=jg(c[Dg]);if(!d||b!=d.i)throw new t("user-mismatch");return c}throw new t("user-mismatch");}).o(function(c){throw c&&c.code&&c.code==xa+"user-not-found"?new t("user-mismatch"):c;})}
function Eg(a,b){if(b)this.a=b;else throw new t("internal-error","failed to construct a credential");M(this,"providerId",a);M(this,"signInMethod",a)}Eg.prototype.ka=function(a){return Fg(a,Gg(this))};Eg.prototype.b=function(a,b){var c=Gg(this);c.idToken=b;return Hg(a,c)};Eg.prototype.c=function(a,b){return Cg(Ig(a,Gg(this)),b)};function Gg(a){return{pendingToken:a.a,requestUri:"http://localhost"}}Eg.prototype.w=function(){return{providerId:this.providerId,signInMethod:this.signInMethod,pendingToken:this.a}};
function Jg(a){if(a&&a.providerId&&a.signInMethod&&0==a.providerId.indexOf("saml.")&&a.pendingToken)try{return new Eg(a.providerId,a.pendingToken)}catch(b){}return null}
function Kg(a,b,c){this.a=null;if(b.idToken||b.accessToken)b.idToken&&M(this,"idToken",b.idToken),b.accessToken&&M(this,"accessToken",b.accessToken),b.nonce&&!b.pendingToken&&M(this,"nonce",b.nonce),b.pendingToken&&(this.a=b.pendingToken);else if(b.oauthToken&&b.oauthTokenSecret)M(this,"accessToken",b.oauthToken),M(this,"secret",b.oauthTokenSecret);else throw new t("internal-error","failed to construct a credential");M(this,"providerId",a);M(this,"signInMethod",c)}
Kg.prototype.ka=function(a){return Fg(a,Lg(this))};Kg.prototype.b=function(a,b){var c=Lg(this);c.idToken=b;return Hg(a,c)};Kg.prototype.c=function(a,b){var c=Lg(this);return Cg(Ig(a,c),b)};
function Lg(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;a.nonce&&!a.a&&(b.nonce=a.nonce);b={postBody:fe(b).toString(),requestUri:"http://localhost"};a.a&&(delete b.postBody,b.pendingToken=a.a);return b}
Kg.prototype.w=function(){var a={providerId:this.providerId,signInMethod:this.signInMethod};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);this.nonce&&(a.nonce=this.nonce);this.a&&(a.pendingToken=this.a);return a};
function Mg(a){if(a&&a.providerId&&a.signInMethod){var b={idToken:a.oauthIdToken,accessToken:a.oauthTokenSecret?null:a.oauthAccessToken,oauthTokenSecret:a.oauthTokenSecret,oauthToken:a.oauthTokenSecret&&a.oauthAccessToken,nonce:a.nonce,pendingToken:a.pendingToken};try{return new Kg(a.providerId,b,a.signInMethod)}catch(c){}}return null}function Ng(a,b){this.Qc=b||[];N(this,{providerId:a,isOAuthProvider:!0});this.Jb={};this.qb=(ng(a)||{}).Ja||null;this.pb=null}
Ng.prototype.Ka=function(a){this.Jb=nb(a);return this};function Og(a){if("string"!==typeof a||0!=a.indexOf("saml."))throw new t("argument-error",'SAML provider IDs must be prefixed with "saml."');Ng.call(this,a,[])}r(Og,Ng);function Pg(a){Ng.call(this,a,lg);this.a=[]}r(Pg,Ng);Pg.prototype.Ca=function(a){Va(this.a,a)||this.a.push(a);return this};Pg.prototype.Rb=function(){return Za(this.a)};
Pg.prototype.credential=function(a,b){var c;n(a)?c={idToken:a.idToken||null,accessToken:a.accessToken||null,nonce:a.rawNonce||null}:c={idToken:a||null,accessToken:b||null};if(!c.idToken&&!c.accessToken)throw new t("argument-error","credential failed: must provide the ID token and/or the access token.");return new Kg(this.providerId,c,this.providerId)};function Qg(){Pg.call(this,"facebook.com")}r(Qg,Pg);M(Qg,"PROVIDER_ID","facebook.com");M(Qg,"FACEBOOK_SIGN_IN_METHOD","facebook.com");
function Rg(a){if(!a)throw new t("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;n(a)&&(b=a.accessToken);return(new Qg).credential({accessToken:b})}function Sg(){Pg.call(this,"github.com")}r(Sg,Pg);M(Sg,"PROVIDER_ID","github.com");M(Sg,"GITHUB_SIGN_IN_METHOD","github.com");
function Tg(a){if(!a)throw new t("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;n(a)&&(b=a.accessToken);return(new Sg).credential({accessToken:b})}function Ug(){Pg.call(this,"google.com");this.Ca("profile")}r(Ug,Pg);M(Ug,"PROVIDER_ID","google.com");M(Ug,"GOOGLE_SIGN_IN_METHOD","google.com");function Vg(a,b){var c=a;n(a)&&(c=a.idToken,b=a.accessToken);return(new Ug).credential({idToken:c,accessToken:b})}function Wg(){Ng.call(this,"twitter.com",kg)}
r(Wg,Ng);M(Wg,"PROVIDER_ID","twitter.com");M(Wg,"TWITTER_SIGN_IN_METHOD","twitter.com");function Xg(a,b){var c=a;n(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new t("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Kg("twitter.com",c,"twitter.com")}
function Yg(a,b,c){this.a=a;this.f=b;M(this,"providerId","password");M(this,"signInMethod",c===Zg.EMAIL_LINK_SIGN_IN_METHOD?Zg.EMAIL_LINK_SIGN_IN_METHOD:Zg.EMAIL_PASSWORD_SIGN_IN_METHOD)}Yg.prototype.ka=function(a){return this.signInMethod==Zg.EMAIL_LINK_SIGN_IN_METHOD?O(a,$g,{email:this.a,oobCode:this.f}):O(a,ah,{email:this.a,password:this.f})};
Yg.prototype.b=function(a,b){return this.signInMethod==Zg.EMAIL_LINK_SIGN_IN_METHOD?O(a,bh,{idToken:b,email:this.a,oobCode:this.f}):O(a,ch,{idToken:b,email:this.a,password:this.f})};Yg.prototype.c=function(a,b){return Cg(this.ka(a),b)};Yg.prototype.w=function(){return{email:this.a,password:this.f,signInMethod:this.signInMethod}};function dh(a){return a&&a.email&&a.password?new Yg(a.email,a.password,a.signInMethod):null}function Zg(){N(this,{providerId:"password",isOAuthProvider:!1})}
function eh(a,b){b=fh(b);if(!b)throw new t("argument-error","Invalid email link!");return new Yg(a,b.code,Zg.EMAIL_LINK_SIGN_IN_METHOD)}function fh(a){a=xg(a);return(a=Rf(a))&&a.operation===Af?a:null}N(Zg,{PROVIDER_ID:"password"});N(Zg,{EMAIL_LINK_SIGN_IN_METHOD:"emailLink"});N(Zg,{EMAIL_PASSWORD_SIGN_IN_METHOD:"password"});function gh(a){if(!(a.fb&&a.eb||a.La&&a.ea))throw new t("internal-error");this.a=a;M(this,"providerId","phone");this.fa="phone";M(this,"signInMethod","phone")}
gh.prototype.ka=function(a){return a.gb(hh(this))};gh.prototype.b=function(a,b){var c=hh(this);c.idToken=b;return O(a,ih,c)};gh.prototype.c=function(a,b){var c=hh(this);c.operation="REAUTH";a=O(a,jh,c);return Cg(a,b)};gh.prototype.w=function(){var a={providerId:"phone"};this.a.fb&&(a.verificationId=this.a.fb);this.a.eb&&(a.verificationCode=this.a.eb);this.a.La&&(a.temporaryProof=this.a.La);this.a.ea&&(a.phoneNumber=this.a.ea);return a};
function kh(a){if(a&&"phone"===a.providerId&&(a.verificationId&&a.verificationCode||a.temporaryProof&&a.phoneNumber)){var b={};w(["verificationId","verificationCode","temporaryProof","phoneNumber"],function(c){a[c]&&(b[c]=a[c])});return new gh(b)}return null}function hh(a){return a.a.La&&a.a.ea?{temporaryProof:a.a.La,phoneNumber:a.a.ea}:{sessionInfo:a.a.fb,code:a.a.eb}}
function lh(a){try{this.a=a||index_esm/* default.auth */.Z.auth()}catch(b){throw new t("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}N(this,{providerId:"phone",isOAuthProvider:!1})}
lh.prototype.gb=function(a,b){var c=this.a.a;return E(b.verify()).then(function(d){if("string"!==typeof d)throw new t("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":var e=n(a)?a.session:null,f=n(a)?a.phoneNumber:a,g;e&&e.type==zg?g=e.Ha().then(function(h){return mh(c,{idToken:h,phoneEnrollmentInfo:{phoneNumber:f,recaptchaToken:d}})}):e&&e.type==Ag?g=e.Ha().then(function(h){return nh(c,
{mfaPendingCredential:h,mfaEnrollmentId:a.multiFactorHint&&a.multiFactorHint.uid||a.multiFactorUid,phoneSignInInfo:{recaptchaToken:d}})}):g=oh(c,{phoneNumber:f,recaptchaToken:d});return g.then(function(h){"function"===typeof b.reset&&b.reset();return h},function(h){"function"===typeof b.reset&&b.reset();throw h;});default:throw new t("argument-error",'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};
function ph(a,b){if(!a)throw new t("missing-verification-id");if(!b)throw new t("missing-verification-code");return new gh({fb:a,eb:b})}N(lh,{PROVIDER_ID:"phone"});N(lh,{PHONE_SIGN_IN_METHOD:"phone"});
function qh(a){if(a.temporaryProof&&a.phoneNumber)return new gh({La:a.temporaryProof,ea:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret,e=a&&a.nonce,f=a&&a.oauthIdToken,g=a&&a.pendingToken;try{switch(b){case "google.com":return Vg(f,c);case "facebook.com":return Rg(c);case "github.com":return Tg(c);case "twitter.com":return Xg(c,d);default:return c||d||f||g?g?0==b.indexOf("saml.")?new Eg(b,g):new Kg(b,{pendingToken:g,idToken:a.oauthIdToken,
accessToken:a.oauthAccessToken},b):(new Pg(b)).credential({idToken:f,accessToken:c,rawNonce:e}):null}}catch(h){return null}}function rh(a){if(!a.isOAuthProvider)throw new t("invalid-oauth-provider");};function sh(a,b,c,d,e,f,g){this.c=a;this.b=b||null;this.g=c||null;this.f=d||null;this.i=f||null;this.h=g||null;this.a=e||null;if(this.g||this.a){if(this.g&&this.a)throw new t("invalid-auth-event");if(this.g&&!this.f)throw new t("invalid-auth-event");}else throw new t("invalid-auth-event");}sh.prototype.getUid=function(){var a=[];a.push(this.c);this.b&&a.push(this.b);this.f&&a.push(this.f);this.h&&a.push(this.h);return a.join("-")};sh.prototype.T=function(){return this.h};
sh.prototype.w=function(){return{type:this.c,eventId:this.b,urlResponse:this.g,sessionId:this.f,postBody:this.i,tenantId:this.h,error:this.a&&this.a.w()}};function th(a){a=a||{};return a.type?new sh(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&Aa(a.error),a.postBody,a.tenantId):null};/*

 Copyright 2018 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function uh(){this.b=null;this.a=[]}var vh=null;function wh(a){var b=vh;b.a.push(a);b.b||(b.b=function(c){for(var d=0;d<b.a.length;d++)b.a[d](c)},a=L("universalLinks.subscribe",l),"function"===typeof a&&a(null,b.b))};function xh(a){var b="unauthorized-domain",c=void 0,d=J(a);a=d.a;d=d.c;"chrome-extension"==d?c=Qb("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=Qb("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
t.call(this,b,c)}r(xh,t);function yh(a,b,c){t.call(this,a,c);a=b||{};a.Kb&&M(this,"email",a.Kb);a.ea&&M(this,"phoneNumber",a.ea);a.credential&&M(this,"credential",a.credential);a.$b&&M(this,"tenantId",a.$b)}r(yh,t);yh.prototype.w=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);this.tenantId&&(a.tenantId=this.tenantId);var b=this.credential&&this.credential.w();b&&z(a,b);return a};yh.prototype.toJSON=function(){return this.w()};
function zh(a){if(a.code){var b=a.code||"";0==b.indexOf(xa)&&(b=b.substring(xa.length));var c={credential:qh(a),$b:a.tenantId};if(a.email)c.Kb=a.email;else if(a.phoneNumber)c.ea=a.phoneNumber;else if(!c.credential)return new t(b,a.message||void 0);return new yh(b,c,a.message)}return null};function Ah(){}Ah.prototype.c=null;function Bh(a){return a.c||(a.c=a.b())};var Ch;function Dh(){}r(Dh,Ah);Dh.prototype.a=function(){var a=Eh(this);return a?new ActiveXObject(a):new XMLHttpRequest};Dh.prototype.b=function(){var a={};Eh(this)&&(a[0]=!0,a[1]=!0);return a};
function Eh(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}Ch=new Dh;function Fh(){}r(Fh,Ah);Fh.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new Gh;throw Error("Unsupported browser");};Fh.prototype.b=function(){return{}};
function Gh(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseType=this.responseText=this.response="";this.status=-1;this.statusText="";this.a.onload=q(this.qc,this);this.a.onerror=q(this.Tb,this);this.a.onprogress=q(this.rc,this);this.a.ontimeout=q(this.vc,this)}k=Gh.prototype;k.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
k.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};k.abort=function(){this.a.abort()};k.setRequestHeader=function(){};k.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};k.qc=function(){this.status=200;this.response=this.responseText=this.a.responseText;Hh(this,4)};k.Tb=function(){this.status=500;this.response=this.responseText="";Hh(this,4)};k.vc=function(){this.Tb()};
k.rc=function(){this.status=200;Hh(this,1)};function Hh(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}k.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function Ih(a,b,c){this.reset(a,b,c,void 0,void 0)}Ih.prototype.a=null;var Jh=0;Ih.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Jh++;d||va();delete this.a};function Kh(a){this.f=a;this.b=this.c=this.a=null}function Lh(a,b){this.name=a;this.value=b}Lh.prototype.toString=function(){return this.name};var Mh=new Lh("SEVERE",1E3),Nh=new Lh("WARNING",900),Oh=new Lh("CONFIG",700),Ph=new Lh("FINE",500);function Qh(a){if(a.c)return a.c;if(a.a)return Qh(a.a);Ga("Root logger has no level set.");return null}Kh.prototype.log=function(a,b,c){if(a.value>=Qh(this).value)for(oa(b)&&(b=b()),a=new Ih(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};var Rh={},Sh=null;
function Th(a){Sh||(Sh=new Kh(""),Rh[""]=Sh,Sh.c=Oh);var b;if(!(b=Rh[a])){b=new Kh(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=Th(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;Rh[a]=b}return b};function Uh(a,b){a&&a.log(Ph,b,void 0)};function Vh(a){this.f=a}r(Vh,Ah);Vh.prototype.a=function(){return new Wh(this.f)};Vh.prototype.b=function(a){return function(){return a}}({});function Wh(a){H.call(this);this.u=a;this.h=void 0;this.readyState=Xh;this.status=0;this.responseType=this.responseText=this.response=this.statusText="";this.onreadystatechange=null;this.l=new Headers;this.b=null;this.s="GET";this.f="";this.a=!1;this.i=Th("goog.net.FetchXmlHttp");this.m=this.c=this.g=null}r(Wh,H);var Xh=0;k=Wh.prototype;
k.open=function(a,b){if(this.readyState!=Xh)throw this.abort(),Error("Error reopening a connection");this.s=a;this.f=b;this.readyState=1;Yh(this)};k.send=function(a){if(1!=this.readyState)throw this.abort(),Error("need to call open() first. ");this.a=!0;var b={headers:this.l,method:this.s,credentials:this.h,cache:void 0};a&&(b.body=a);this.u.fetch(new Request(this.f,b)).then(this.uc.bind(this),this.Va.bind(this))};
k.abort=function(){this.response=this.responseText="";this.l=new Headers;this.status=0;this.c&&this.c.cancel("Request was aborted.");1<=this.readyState&&this.a&&4!=this.readyState&&(this.a=!1,Zh(this));this.readyState=Xh};
k.uc=function(a){this.a&&(this.g=a,this.b||(this.status=this.g.status,this.statusText=this.g.statusText,this.b=a.headers,this.readyState=2,Yh(this)),this.a&&(this.readyState=3,Yh(this),this.a&&("arraybuffer"===this.responseType?a.arrayBuffer().then(this.sc.bind(this),this.Va.bind(this)):"undefined"!==typeof l.ReadableStream&&"body"in a?(this.response=this.responseText="",this.c=a.body.getReader(),this.m=new TextDecoder,$h(this)):a.text().then(this.tc.bind(this),this.Va.bind(this)))))};
function $h(a){a.c.read().then(a.pc.bind(a)).catch(a.Va.bind(a))}k.pc=function(a){if(this.a){var b=this.m.decode(a.value?a.value:new Uint8Array(0),{stream:!a.done});b&&(this.response=this.responseText+=b);a.done?Zh(this):Yh(this);3==this.readyState&&$h(this)}};k.tc=function(a){this.a&&(this.response=this.responseText=a,Zh(this))};k.sc=function(a){this.a&&(this.response=a,Zh(this))};k.Va=function(a){var b=this.i;b&&b.log(Nh,"Failed to fetch url "+this.f,a instanceof Error?a:Error(a));this.a&&Zh(this)};
function Zh(a){a.readyState=4;a.g=null;a.c=null;a.m=null;Yh(a)}k.setRequestHeader=function(a,b){this.l.append(a,b)};k.getResponseHeader=function(a){return this.b?this.b.get(a.toLowerCase())||"":((a=this.i)&&a.log(Nh,"Attempting to get response header but no headers have been received for url: "+this.f,void 0),"")};
k.getAllResponseHeaders=function(){if(!this.b){var a=this.i;a&&a.log(Nh,"Attempting to get all response headers but no headers have been received for url: "+this.f,void 0);return""}a=[];for(var b=this.b.entries(),c=b.next();!c.done;)c=c.value,a.push(c[0]+": "+c[1]),c=b.next();return a.join("\r\n")};function Yh(a){a.onreadystatechange&&a.onreadystatechange.call(a)}Object.defineProperty(Wh.prototype,"withCredentials",{get:function(){return"include"===this.h},set:function(a){this.h=a?"include":"same-origin"}});function ai(a){H.call(this);this.headers=new Jd;this.D=a||null;this.c=!1;this.C=this.a=null;this.h=this.P=this.l="";this.f=this.N=this.i=this.J=!1;this.g=0;this.s=null;this.m=bi;this.u=this.S=!1}r(ai,H);var bi="";ai.prototype.b=Th("goog.net.XhrIo");var ci=/^https?$/i,di=["POST","PUT"];
function ei(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.l+"; newUri="+b);c=c?c.toUpperCase():"GET";a.l=b;a.h="";a.P=c;a.J=!1;a.c=!0;a.a=a.D?a.D.a():Ch.a();a.C=a.D?Bh(a.D):Bh(Ch);a.a.onreadystatechange=q(a.Wb,a);try{Uh(a.b,fi(a,"Opening Xhr")),a.N=!0,a.a.open(c,String(b),!0),a.N=!1}catch(g){Uh(a.b,fi(a,"Error opening Xhr: "+g.message));gi(a,g);return}b=d||"";var f=new Jd(a.headers);e&&Id(e,function(g,h){f.set(h,g)});e=Ta(f.Y());d=l.FormData&&b instanceof
l.FormData;!Va(di,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(g,h){this.a.setRequestHeader(h,g)},a);a.m&&(a.a.responseType=a.m);"withCredentials"in a.a&&a.a.withCredentials!==a.S&&(a.a.withCredentials=a.S);try{hi(a),0<a.g&&(a.u=ii(a.a),Uh(a.b,fi(a,"Will abort after "+a.g+"ms if incomplete, xhr2 "+a.u)),a.u?(a.a.timeout=a.g,a.a.ontimeout=q(a.Ma,a)):a.s=Ed(a.Ma,a.g,a)),Uh(a.b,fi(a,"Sending request")),a.i=!0,a.a.send(b),a.i=!1}catch(g){Uh(a.b,
fi(a,"Send error: "+g.message)),gi(a,g)}}function ii(a){return Wb&&fc(9)&&"number"===typeof a.timeout&&void 0!==a.ontimeout}function Ua(a){return"content-type"==a.toLowerCase()}k=ai.prototype;k.Ma=function(){"undefined"!=typeof ha&&this.a&&(this.h="Timed out after "+this.g+"ms, aborting",Uh(this.b,fi(this,this.h)),this.dispatchEvent("timeout"),this.abort(8))};function gi(a,b){a.c=!1;a.a&&(a.f=!0,a.a.abort(),a.f=!1);a.h=b;ji(a);ki(a)}
function ji(a){a.J||(a.J=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}k.abort=function(){this.a&&this.c&&(Uh(this.b,fi(this,"Aborting")),this.c=!1,this.f=!0,this.a.abort(),this.f=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),ki(this))};k.Da=function(){this.a&&(this.c&&(this.c=!1,this.f=!0,this.a.abort(),this.f=!1),ki(this,!0));ai.bb.Da.call(this)};k.Wb=function(){this.ya||(this.N||this.i||this.f?li(this):this.Jc())};k.Jc=function(){li(this)};
function li(a){if(a.c&&"undefined"!=typeof ha)if(a.C[1]&&4==mi(a)&&2==ni(a))Uh(a.b,fi(a,"Local request error detected and ignored"));else if(a.i&&4==mi(a))Ed(a.Wb,0,a);else if(a.dispatchEvent("readystatechange"),4==mi(a)){Uh(a.b,fi(a,"Request complete"));a.c=!1;try{var b=ni(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.l).match(Md)[1]||null;if(!f&&l.self&&l.self.location){var g=l.self.location.protocol;
f=g.substr(0,g.length-1)}e=!ci.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{try{var h=2<mi(a)?a.a.statusText:""}catch(m){Uh(a.b,"Can not get status: "+m.message),h=""}a.h=h+" ["+ni(a)+"]";ji(a)}}finally{ki(a)}}}function ki(a,b){if(a.a){hi(a);var c=a.a,d=a.C[0]?la:null;a.a=null;a.C=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(Mh,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
function hi(a){a.a&&a.u&&(a.a.ontimeout=null);a.s&&(l.clearTimeout(a.s),a.s=null)}function mi(a){return a.a?a.a.readyState:0}function ni(a){try{return 2<mi(a)?a.a.status:-1}catch(b){return-1}}function oi(a){try{return a.a?a.a.responseText:""}catch(b){return Uh(a.b,"Can not get responseText: "+b.message),""}}
k.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.m){case bi:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.b;a&&a.log(Mh,"Response type "+this.m+" is not supported on this browser",void 0);return null}catch(b){return Uh(this.b,"Can not get response: "+b.message),null}};function fi(a,b){return b+" ["+a.P+" "+a.l+" "+ni(a)+"]"};/*
 Portions of this code are from MochiKit, received by
 The Closure Authors under the MIT license. All other code is Copyright
 2005-2009 The Closure Authors. All Rights Reserved.
*/
function pi(a){var b=qi;this.g=[];this.u=b;this.s=a||null;this.f=this.a=!1;this.c=void 0;this.v=this.C=this.i=!1;this.h=0;this.b=null;this.l=0}pi.prototype.cancel=function(a){if(this.a)this.c instanceof pi&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.l--,0>=b.l&&b.cancel())}this.u?this.u.call(this.s,this):this.v=!0;this.a||(a=new ri(this),si(this),ti(this,!1,a))}};pi.prototype.m=function(a,b){this.i=!1;ti(this,a,b)};function ti(a,b,c){a.a=!0;a.c=c;a.f=!b;ui(a)}
function si(a){if(a.a){if(!a.v)throw new vi(a);a.v=!1}}function wi(a,b){xi(a,null,b,void 0)}function xi(a,b,c,d){a.g.push([b,c,d]);a.a&&ui(a)}pi.prototype.then=function(a,b,c){var d,e,f=new D(function(g,h){d=g;e=h});xi(this,d,function(g){g instanceof ri?f.cancel():e(g)});return f.then(a,b,c)};pi.prototype.$goog_Thenable=!0;function yi(a){return Sa(a.g,function(b){return oa(b[1])})}
function ui(a){if(a.h&&a.a&&yi(a)){var b=a.h,c=zi[b];c&&(l.clearTimeout(c.a),delete zi[b]);a.h=0}a.b&&(a.b.l--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.i;){var e=a.g.shift(),f=e[0],g=e[1];e=e[2];if(f=a.f?g:f)try{var h=f.call(e||a.s,b);void 0!==h&&(a.f=a.f&&(h==b||h instanceof Error),a.c=b=h);if(Ea(b)||"function"===typeof l.Promise&&b instanceof l.Promise)d=!0,a.i=!0}catch(m){b=m,a.f=!0,yi(a)||(c=!0)}}a.c=b;d&&(h=q(a.m,a,!0),d=q(a.m,a,!1),b instanceof pi?(xi(b,h,d),b.C=!0):b.then(h,d));c&&(b=
new Ai(b),zi[b.a]=b,a.h=b.a)}function vi(){u.call(this)}r(vi,u);vi.prototype.message="Deferred has already fired";vi.prototype.name="AlreadyCalledError";function ri(){u.call(this)}r(ri,u);ri.prototype.message="Deferred was canceled";ri.prototype.name="CanceledError";function Ai(a){this.a=l.setTimeout(q(this.c,this),0);this.b=a}Ai.prototype.c=function(){delete zi[this.a];throw this.b;};var zi={};function Bi(a){var b={},c=b.document||document,d=yb(a).toString(),e=oc(document,"SCRIPT"),f={Xb:e,Ma:void 0},g=new pi(f),h=null,m=null!=b.timeout?b.timeout:5E3;0<m&&(h=window.setTimeout(function(){Ci(e,!0);var p=new Di(Ei,"Timeout reached for loading script "+d);si(g);ti(g,!1,p)},m),f.Ma=h);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(Ci(e,b.xd||!1,h),si(g),ti(g,!0,null))};e.onerror=function(){Ci(e,!0,h);var p=new Di(Fi,"Error while loading script "+
d);si(g);ti(g,!1,p)};f=b.attributes||{};z(f,{type:"text/javascript",charset:"UTF-8"});lc(e,f);Ob(e,a);Gi(c).appendChild(e);return g}function Gi(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function qi(){if(this&&this.Xb){var a=this.Xb;a&&"SCRIPT"==a.tagName&&Ci(a,!0,this.Ma)}}
function Ci(a,b,c){null!=c&&l.clearTimeout(c);a.onload=la;a.onerror=la;a.onreadystatechange=la;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var Fi=0,Ei=1;function Di(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);u.call(this,c);this.code=a}r(Di,u);function Hi(a){this.f=a}r(Hi,Ah);Hi.prototype.a=function(){return new this.f};Hi.prototype.b=function(){return{}};
function Ii(a,b,c){this.c=a;a=b||{};this.l=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.m=a.secureTokenTimeout||Ji;this.g=nb(a.secureTokenHeaders||Ki);this.h=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.i=a.identityPlatformEndpoint||"https://identitytoolkit.googleapis.com/v2/";this.v=a.firebaseTimeout||Li;this.a=nb(a.firebaseHeaders||Mi);c&&(this.a["X-Client-Version"]=c,this.g["X-Client-Version"]=c);c="Node"==Ke();c=l.XMLHttpRequest||
c&&index_esm/* default.INTERNAL.node */.Z.INTERNAL.node&&index_esm/* default.INTERNAL.node.XMLHttpRequest */.Z.INTERNAL.node.XMLHttpRequest;if(!c&&!Je())throw new t("internal-error","The XMLHttpRequest compatibility library was not found.");this.f=void 0;Je()?this.f=new Vh(self):Le()?this.f=new Hi(c):this.f=new Fh;this.b=null}var Ni,Dg="idToken",Ji=new Ze(3E4,6E4),Ki={"Content-Type":"application/x-www-form-urlencoded"},Li=new Ze(3E4,6E4),Mi={"Content-Type":"application/json"};function Oi(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}
function Pi(a,b){b&&(a.l=Qi("https://securetoken.googleapis.com/v1/token",b),a.h=Qi("https://www.googleapis.com/identitytoolkit/v3/relyingparty/",b),a.i=Qi("https://identitytoolkit.googleapis.com/v2/",b))}function Qi(a,b){a=J(a);b=J(b.url);a.f=a.a+a.f;Pd(a,b.c);a.a=b.a;Qd(a,b.g);return a.toString()}function Ri(a,b){b?(a.a["X-Client-Version"]=b,a.g["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.g["X-Client-Version"])}Ii.prototype.T=function(){return this.b};
function Si(a,b,c,d,e,f,g){ue()||Je()?a=q(a.u,a):(Ni||(Ni=new D(function(h,m){Ti(h,m)})),a=q(a.s,a));a(b,c,d,e,f,g)}
Ii.prototype.u=function(a,b,c,d,e,f){if(Je()&&("undefined"===typeof l.fetch||"undefined"===typeof l.Headers||"undefined"===typeof l.Request))throw new t("operation-not-supported-in-this-environment","fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");var g=new ai(this.f);if(f){g.g=Math.max(0,f);var h=setTimeout(function(){g.dispatchEvent("timeout")},f)}qd(g,"complete",function(){h&&clearTimeout(h);var m=null;try{m=
JSON.parse(oi(this))||null}catch(p){m=null}b&&b(m)});wd(g,"ready",function(){h&&clearTimeout(h);Xc(this)});wd(g,"timeout",function(){h&&clearTimeout(h);Xc(this);b&&b(null)});ei(g,a,c,d,e)};var Ui=new qb(rb,"https://apis.google.com/js/client.js?onload=%{onload}"),Vi="__fcb"+Math.floor(1E6*Math.random()).toString();
function Ti(a,b){if(((window.gapi||{}).client||{}).request)a();else{l[Vi]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=zb(Ui,{onload:Vi});wi(Bi(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
Ii.prototype.s=function(a,b,c,d,e){var f=this;Ni.then(function(){window.gapi.client.setApiKey(f.c);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(h){window.gapi.auth.setToken(g);b&&b(h)}})}).o(function(g){b&&b({error:{message:g&&g.message||"CORS_UNSUPPORTED"}})})};
function Wi(a,b){return new D(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Si(a,a.l+"?key="+encodeURIComponent(a.c),function(e){e?e.error?d(Xi(e)):e.access_token&&e.refresh_token?c(e):d(new t("internal-error")):d(new t("network-request-failed"))},"POST",fe(b).toString(),a.g,a.m.get()):d(new t("internal-error"))})}
function Yi(a,b,c,d,e,f,g){var h=J(b+c);I(h,"key",a.c);g&&I(h,"cb",Date.now().toString());var m="GET"==d;if(m)for(var p in e)e.hasOwnProperty(p)&&I(h,p,e[p]);return new D(function(v,B){Si(a,h.toString(),function(A){A?A.error?B(Xi(A,f||{})):v(A):B(new t("network-request-failed"))},d,m?void 0:ke(Ve(e)),a.a,a.v.get())})}function Zi(a){a=a.email;if("string"!==typeof a||!De.test(a))throw new t("invalid-email");}function $i(a){"email"in a&&Zi(a)}
function aj(a,b){return O(a,bj,{identifier:b,continueUri:Se()?re():"http://localhost"}).then(function(c){return c.signinMethods||[]})}function cj(a){return O(a,dj,{}).then(function(b){return b.authorizedDomains||[]})}function P(a){if(!a[Dg]){if(a.mfaPendingCredential)throw new t("multi-factor-auth-required",null,nb(a));throw new t("internal-error");}}
function ej(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new t("internal-error");}else{if(!a.sessionInfo)throw new t("missing-verification-id");if(!a.code)throw new t("missing-verification-code");}}Ii.prototype.Ab=function(){return O(this,fj,{})};Ii.prototype.Cb=function(a,b){return O(this,gj,{idToken:a,email:b})};Ii.prototype.Db=function(a,b){return O(this,ch,{idToken:a,password:b})};var hj={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};k=Ii.prototype;
k.Eb=function(a,b){var c={idToken:a},d=[];lb(hj,function(e,f){var g=b[f];null===g?d.push(e):f in b&&(c[f]=g)});d.length&&(c.deleteAttribute=d);return O(this,gj,c)};k.wb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};z(a,b);return O(this,ij,a)};k.xb=function(a,b){a={requestType:"EMAIL_SIGNIN",email:a};z(a,b);return O(this,jj,a)};k.vb=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};z(a,b);return O(this,kj,a)};
k.Fb=function(a,b,c){a={requestType:"VERIFY_AND_CHANGE_EMAIL",idToken:a,newEmail:b};z(a,c);return O(this,lj,a)};function oh(a,b){return O(a,mj,b)}k.gb=function(a){return O(this,nj,a)};function mh(a,b){return O(a,oj,b).then(function(c){return c.phoneSessionInfo.sessionInfo})}
function pj(a){if(!a.phoneVerificationInfo)throw new t("internal-error");if(!a.phoneVerificationInfo.sessionInfo)throw new t("missing-verification-id");if(!a.phoneVerificationInfo.code)throw new t("missing-verification-code");}function nh(a,b){return O(a,qj,b).then(function(c){return c.phoneResponseInfo.sessionInfo})}function rj(a,b,c){return O(a,sj,{idToken:b,deleteProvider:c})}function tj(a){if(!a.requestUri||!a.sessionId&&!a.postBody&&!a.pendingToken)throw new t("internal-error");}
function uj(a,b){b.oauthIdToken&&b.providerId&&0==b.providerId.indexOf("oidc.")&&!b.pendingToken&&(a.sessionId?b.nonce=a.sessionId:a.postBody&&(a=new Ud(a.postBody),je(a,"nonce")&&(b.nonce=a.get("nonce"))));return b}
function vj(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=zh(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=zh(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=zh(a)):a.errorMessage&&(b=wj(a.errorMessage));if(b)throw b;P(a)}function Fg(a,b){b.returnIdpCredential=!0;return O(a,xj,b)}function Hg(a,b){b.returnIdpCredential=!0;return O(a,yj,b)}
function Ig(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return O(a,zj,b)}function Aj(a){if(!a.oobCode)throw new t("invalid-action-code");}k.ob=function(a,b){return O(this,Bj,{oobCode:a,newPassword:b})};k.Sa=function(a){return O(this,Cj,{oobCode:a})};k.kb=function(a){return O(this,Dj,{oobCode:a})};
var Dj={endpoint:"setAccountInfo",A:Aj,Z:"email",B:!0},Cj={endpoint:"resetPassword",A:Aj,G:function(a){var b=a.requestType;if(!b||!a.email&&"EMAIL_SIGNIN"!=b&&"VERIFY_AND_CHANGE_EMAIL"!=b)throw new t("internal-error");},B:!0},Ej={endpoint:"signupNewUser",A:function(a){Zi(a);if(!a.password)throw new t("weak-password");},G:P,V:!0,B:!0},bj={endpoint:"createAuthUri",B:!0},Fj={endpoint:"deleteAccount",O:["idToken"]},sj={endpoint:"setAccountInfo",O:["idToken","deleteProvider"],A:function(a){if(!Array.isArray(a.deleteProvider))throw new t("internal-error");
}},$g={endpoint:"emailLinkSignin",O:["email","oobCode"],A:Zi,G:P,V:!0,B:!0},bh={endpoint:"emailLinkSignin",O:["idToken","email","oobCode"],A:Zi,G:P,V:!0},Gj={endpoint:"accounts/mfaEnrollment:finalize",O:["idToken","phoneVerificationInfo"],A:pj,G:P,B:!0,Na:!0},Hj={endpoint:"accounts/mfaSignIn:finalize",O:["mfaPendingCredential","phoneVerificationInfo"],A:pj,G:P,B:!0,Na:!0},Ij={endpoint:"getAccountInfo"},jj={endpoint:"getOobConfirmationCode",O:["requestType"],A:function(a){if("EMAIL_SIGNIN"!=a.requestType)throw new t("internal-error");
Zi(a)},Z:"email",B:!0},kj={endpoint:"getOobConfirmationCode",O:["idToken","requestType"],A:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new t("internal-error");},Z:"email",B:!0},lj={endpoint:"getOobConfirmationCode",O:["idToken","newEmail","requestType"],A:function(a){if("VERIFY_AND_CHANGE_EMAIL"!=a.requestType)throw new t("internal-error");},Z:"email",B:!0},ij={endpoint:"getOobConfirmationCode",O:["requestType"],A:function(a){if("PASSWORD_RESET"!=a.requestType)throw new t("internal-error");
Zi(a)},Z:"email",B:!0},dj={mb:!0,endpoint:"getProjectConfig",Vb:"GET"},Jj={mb:!0,endpoint:"getRecaptchaParam",Vb:"GET",G:function(a){if(!a.recaptchaSiteKey)throw new t("internal-error");}},Bj={endpoint:"resetPassword",A:Aj,Z:"email",B:!0},mj={endpoint:"sendVerificationCode",O:["phoneNumber","recaptchaToken"],Z:"sessionInfo",B:!0},gj={endpoint:"setAccountInfo",O:["idToken"],A:$i,V:!0},ch={endpoint:"setAccountInfo",O:["idToken"],A:function(a){$i(a);if(!a.password)throw new t("weak-password");},G:P,
V:!0},fj={endpoint:"signupNewUser",G:P,V:!0,B:!0},oj={endpoint:"accounts/mfaEnrollment:start",O:["idToken","phoneEnrollmentInfo"],A:function(a){if(!a.phoneEnrollmentInfo)throw new t("internal-error");if(!a.phoneEnrollmentInfo.phoneNumber)throw new t("missing-phone-number");if(!a.phoneEnrollmentInfo.recaptchaToken)throw new t("missing-app-credential");},G:function(a){if(!a.phoneSessionInfo||!a.phoneSessionInfo.sessionInfo)throw new t("internal-error");},B:!0,Na:!0},qj={endpoint:"accounts/mfaSignIn:start",
O:["mfaPendingCredential","mfaEnrollmentId","phoneSignInInfo"],A:function(a){if(!a.phoneSignInInfo||!a.phoneSignInInfo.recaptchaToken)throw new t("missing-app-credential");},G:function(a){if(!a.phoneResponseInfo||!a.phoneResponseInfo.sessionInfo)throw new t("internal-error");},B:!0,Na:!0},xj={endpoint:"verifyAssertion",A:tj,Za:uj,G:vj,V:!0,B:!0},zj={endpoint:"verifyAssertion",A:tj,Za:uj,G:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new t("user-not-found");if(a.errorMessage)throw wj(a.errorMessage);
P(a)},V:!0,B:!0},yj={endpoint:"verifyAssertion",A:function(a){tj(a);if(!a.idToken)throw new t("internal-error");},Za:uj,G:vj,V:!0},Kj={endpoint:"verifyCustomToken",A:function(a){if(!a.token)throw new t("invalid-custom-token");},G:P,V:!0,B:!0},ah={endpoint:"verifyPassword",A:function(a){Zi(a);if(!a.password)throw new t("wrong-password");},G:P,V:!0,B:!0},nj={endpoint:"verifyPhoneNumber",A:ej,G:P,B:!0},ih={endpoint:"verifyPhoneNumber",A:function(a){if(!a.idToken)throw new t("internal-error");ej(a)},
G:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",zh(a);P(a)}},jh={Ib:{USER_NOT_FOUND:"user-not-found"},endpoint:"verifyPhoneNumber",A:ej,G:P,B:!0},Lj={endpoint:"accounts/mfaEnrollment:withdraw",O:["idToken","mfaEnrollmentId"],G:function(a){if(!!a[Dg]^!!a.refreshToken)throw new t("internal-error");},B:!0,Na:!0};
function O(a,b,c){if(!mf(c,b.O))return F(new t("internal-error"));var d=!!b.Na,e=b.Vb||"POST",f;return E(c).then(b.A).then(function(){b.V&&(c.returnSecureToken=!0);b.B&&a.b&&"undefined"===typeof c.tenantId&&(c.tenantId=a.b);return d?Yi(a,a.i,b.endpoint,e,c,b.Ib,b.mb||!1):Yi(a,a.h,b.endpoint,e,c,b.Ib,b.mb||!1)}).then(function(g){f=g;return b.Za?b.Za(c,f):f}).then(b.G).then(function(){if(!b.Z)return f;if(!(b.Z in f))throw new t("internal-error");return f[b.Z]})}
function wj(a){return Xi({error:{errors:[{message:a}],code:400,message:a}})}
function Xi(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new t(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",INVALID_PENDING_TOKEN:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",MISSING_OR_INVALID_NONCE:"missing-or-invalid-nonce",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",RESET_PASSWORD_EXCEED_LIMIT:"too-many-requests",
EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",INVALID_PROVIDER_ID:"invalid-provider-id",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",
OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",
QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",REJECTED_CREDENTIAL:"rejected-credential",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_DYNAMIC_LINK_DOMAIN:"invalid-dynamic-link-domain",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash",UNSUPPORTED_TENANT_OPERATION:"unsupported-tenant-operation",
INVALID_TENANT_ID:"invalid-tenant-id",TENANT_ID_MISMATCH:"tenant-id-mismatch",ADMIN_ONLY_OPERATION:"admin-restricted-operation",INVALID_MFA_PENDING_CREDENTIAL:"invalid-multi-factor-session",MFA_ENROLLMENT_NOT_FOUND:"multi-factor-info-not-found",MISSING_MFA_PENDING_CREDENTIAL:"missing-multi-factor-session",MISSING_MFA_ENROLLMENT_ID:"missing-multi-factor-info",EMAIL_CHANGE_NEEDS_VERIFICATION:"email-change-needs-verification",SECOND_FACTOR_EXISTS:"second-factor-already-in-use",SECOND_FACTOR_LIMIT_EXCEEDED:"maximum-second-factor-count-exceeded",
UNSUPPORTED_FIRST_FACTOR:"unsupported-first-factor",UNVERIFIED_EMAIL:"unverified-email"};z(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*([\s\S]*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new t(d[e],b);!b&&a&&(b=Ue(a));return new t("internal-error",b)};function Mj(a){this.b=a;this.a=null;this.sb=Nj(this)}
function Nj(a){return Oj().then(function(){return new D(function(b,c){L("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},Pj.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
function Qj(a,b){return a.sb.then(function(){return new D(function(c){a.a.send(b.type,b,c,L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function Rj(a,b){a.sb.then(function(){a.a.register("authEvent",b,L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var Sj=new qb(rb,"https://apis.google.com/js/api.js?onload=%{onload}"),Tj=new Ze(3E4,6E4),Pj=new Ze(5E3,15E3),Uj=null;
function Oj(){return Uj?Uj:Uj=(new D(function(a,b){function c(){Ye();L("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Ye();b(Error("Network Error"))},timeout:Tj.get()})}if(L("gapi.iframes.Iframe"))a();else if(L("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();l[d]=function(){L("gapi.load")?c():b(Error("Network Error"))};d=zb(Sj,{onload:d});E(Bi(d)).o(function(){b(Error("Network Error"))})}})).o(function(a){Uj=null;throw a;})};function Vj(a,b,c,d){this.l=a;this.h=b;this.i=c;this.g=d;this.f=null;this.g?(a=J(this.g.url),a=ce(a.c,a.a,a.g,"/emulator/auth/iframe")):a=ce("https",this.l,null,"/__/auth/iframe");this.a=a;I(this.a,"apiKey",this.h);I(this.a,"appName",this.i);this.b=null;this.c=[]}Vj.prototype.toString=function(){this.f?I(this.a,"v",this.f):ie(this.a.b,"v");this.b?I(this.a,"eid",this.b):ie(this.a.b,"eid");this.c.length?I(this.a,"fw",this.c.join(",")):ie(this.a.b,"fw");return this.a.toString()};
function Wj(a,b,c,d,e,f){this.u=a;this.s=b;this.c=c;this.m=d;this.v=f;this.i=this.g=this.l=null;this.a=e;this.h=this.f=null}Wj.prototype.zb=function(a){this.h=a;return this};
Wj.prototype.toString=function(){if(this.v){var a=J(this.v.url);a=ce(a.c,a.a,a.g,"/emulator/auth/handler")}else a=ce("https",this.u,null,"/__/auth/handler");I(a,"apiKey",this.s);I(a,"appName",this.c);I(a,"authType",this.m);if(this.a.isOAuthProvider){var b=this.a;try{var c=index_esm/* default.app */.Z.app(this.c).auth().la()}catch(h){c=null}b.pb=c;I(a,"providerId",this.a.providerId);c=this.a;b=Ve(c.Jb);for(var d in b)b[d]=b[d].toString();d=c.Qc;b=nb(b);for(var e=0;e<d.length;e++){var f=d[e];f in b&&delete b[f]}c.qb&&
c.pb&&!b[c.qb]&&(b[c.qb]=c.pb);mb(b)||I(a,"customParameters",Ue(b))}"function"===typeof this.a.Rb&&(c=this.a.Rb(),c.length&&I(a,"scopes",c.join(",")));this.l?I(a,"redirectUrl",this.l):ie(a.b,"redirectUrl");this.g?I(a,"eventId",this.g):ie(a.b,"eventId");this.i?I(a,"v",this.i):ie(a.b,"v");if(this.b)for(var g in this.b)this.b.hasOwnProperty(g)&&!be(a,g)&&I(a,g,this.b[g]);this.h?I(a,"tid",this.h):ie(a.b,"tid");this.f?I(a,"eid",this.f):ie(a.b,"eid");g=Xj(this.c);g.length&&I(a,"fw",g.join(","));return a.toString()};
function Xj(a){try{return index_esm/* default.app */.Z.app(a).auth().Ga()}catch(b){return[]}}function Yj(a,b,c,d,e,f){this.s=a;this.g=b;this.b=c;this.f=f;this.c=d||null;this.i=e||null;this.l=this.u=this.C=null;this.h=[];this.m=this.a=null}
function Zj(a){var b=re();return cj(a).then(function(c){a:{var d=J(b),e=d.c;d=d.a;for(var f=0;f<c.length;f++){var g=c[f];var h=d;var m=e;0==g.indexOf("chrome-extension://")?h=J(g).a==h&&"chrome-extension"==m:"http"!=m&&"https"!=m?h=!1:Ce.test(g)?h=h==g:(g=g.split(".").join("\\."),h=(new RegExp("^(.+\\."+g+"|"+g+")$","i")).test(h));if(h){c=!0;break a}}c=!1}if(!c)throw new xh(re());})}
function ak(a){if(a.m)return a.m;a.m=Ee().then(function(){if(!a.u){var b=a.c,c=a.i,d=Xj(a.b),e=new Vj(a.s,a.g,a.b,a.f);e.f=b;e.b=c;e.c=Za(d||[]);a.u=e.toString()}a.v=new Mj(a.u);bk(a)});return a.m}k=Yj.prototype;k.Pb=function(a,b,c){var d=new t("popup-closed-by-user"),e=new t("web-storage-unsupported"),f=this,g=!1;return this.ma().then(function(){ck(f).then(function(h){h||(a&&ye(a),b(e),g=!0)})}).o(function(){}).then(function(){if(!g)return Be(a)}).then(function(){if(!g)return Fd(c).then(function(){b(d)})})};
k.Yb=function(){var a=K();return!Te(a)&&!Xe(a)};k.Ub=function(){return!1};
k.Nb=function(a,b,c,d,e,f,g,h){if(!a)return F(new t("popup-blocked"));if(g&&!Te())return this.ma().o(function(p){ye(a);e(p)}),d(),E();this.a||(this.a=Zj(dk(this)));var m=this;return this.a.then(function(){var p=m.ma().o(function(v){ye(a);e(v);throw v;});d();return p}).then(function(){rh(c);if(!g){var p=ek(m.s,m.g,m.b,b,c,null,f,m.c,void 0,m.i,h,m.f);se(p,a)}}).o(function(p){"auth/network-request-failed"==p.code&&(m.a=null);throw p;})};
function dk(a){a.l||(a.C=a.c?Oe(a.c,Xj(a.b)):null,a.l=new Ii(a.g,Ca(a.i),a.C),a.f&&Pi(a.l,a.f));return a.l}k.Ob=function(a,b,c,d){this.a||(this.a=Zj(dk(this)));var e=this;return this.a.then(function(){rh(b);var f=ek(e.s,e.g,e.b,a,b,re(),c,e.c,void 0,e.i,d,e.f);se(f)}).o(function(f){"auth/network-request-failed"==f.code&&(e.a=null);throw f;})};k.ma=function(){var a=this;return ak(this).then(function(){return a.v.sb}).o(function(){a.a=null;throw new t("network-request-failed");})};k.ac=function(){return!0};
function ek(a,b,c,d,e,f,g,h,m,p,v,B){a=new Wj(a,b,c,d,e,B);a.l=f;a.g=g;a.i=h;a.b=nb(m||null);a.f=p;return a.zb(v).toString()}function bk(a){if(!a.v)throw Error("IfcHandler must be initialized!");Rj(a.v,function(b){var c={};if(b&&b.authEvent){var d=!1;b=th(b.authEvent);for(c=0;c<a.h.length;c++)d=a.h[c](b)||d;c={};c.status=d?"ACK":"ERROR";return E(c)}c.status="ERROR";return E(c)})}
function ck(a){var b={type:"webStorageSupport"};return ak(a).then(function(){return Qj(a.v,b)}).then(function(c){if(c&&c.length&&"undefined"!==typeof c[0].webStorageSupport)return c[0].webStorageSupport;throw Error();})}k.Ea=function(a){this.h.push(a)};k.Ta=function(a){Xa(this.h,function(b){return b==a})};function fk(a){this.a=a||index_esm/* default.INTERNAL.reactNative */.Z.INTERNAL.reactNative&&index_esm/* default.INTERNAL.reactNative.AsyncStorage */.Z.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new t("internal-error","The React Native compatibility library was not found.");this.type="asyncStorage"}k=fk.prototype;k.get=function(a){return E(this.a.getItem(a)).then(function(b){return b&&We(b)})};k.set=function(a,b){return E(this.a.setItem(a,Ue(b)))};k.U=function(a){return E(this.a.removeItem(a))};k.ca=function(){};k.ia=function(){};function gk(a){this.b=a;this.a={};this.f=q(this.c,this)}var hk=[];function ik(){var a=Je()?self:null;w(hk,function(c){c.b==a&&(b=c)});if(!b){var b=new gk(a);hk.push(b)}return b}
gk.prototype.c=function(a){var b=a.data.eventType,c=a.data.eventId,d=this.a[b];if(d&&0<d.length){a.ports[0].postMessage({status:"ack",eventId:c,eventType:b,response:null});var e=[];w(d,function(f){e.push(E().then(function(){return f(a.origin,a.data.data)}))});Jc(e).then(function(f){var g=[];w(f,function(h){g.push({fulfilled:h.Qb,value:h.value,reason:h.reason?h.reason.message:void 0})});w(g,function(h){for(var m in h)"undefined"===typeof h[m]&&delete h[m]});a.ports[0].postMessage({status:"done",eventId:c,
eventType:b,response:g})})}};function jk(a,b,c){mb(a.a)&&a.b.addEventListener("message",a.f);"undefined"===typeof a.a[b]&&(a.a[b]=[]);a.a[b].push(c)};function kk(a){this.a=a}kk.prototype.postMessage=function(a,b){this.a.postMessage(a,b)};function lk(a){this.c=a;this.b=!1;this.a=[]}
function mk(a,b,c,d){var e,f=c||{},g,h,m,p=null;if(a.b)return F(Error("connection_unavailable"));var v=d?800:50,B="undefined"!==typeof MessageChannel?new MessageChannel:null;return(new D(function(A,Q){B?(e=Math.floor(Math.random()*Math.pow(10,20)).toString(),B.port1.start(),h=setTimeout(function(){Q(Error("unsupported_event"))},v),g=function(ya){ya.data.eventId===e&&("ack"===ya.data.status?(clearTimeout(h),m=setTimeout(function(){Q(Error("timeout"))},3E3)):"done"===ya.data.status?(clearTimeout(m),
"undefined"!==typeof ya.data.response?A(ya.data.response):Q(Error("unknown_error"))):(clearTimeout(h),clearTimeout(m),Q(Error("invalid_response"))))},p={messageChannel:B,onMessage:g},a.a.push(p),B.port1.addEventListener("message",g),a.c.postMessage({eventType:b,eventId:e,data:f},[B.port2])):Q(Error("connection_unavailable"))})).then(function(A){nk(a,p);return A}).o(function(A){nk(a,p);throw A;})}
function nk(a,b){if(b){var c=b.messageChannel,d=b.onMessage;c&&(c.port1.removeEventListener("message",d),c.port1.close());Xa(a.a,function(e){return e==b})}}lk.prototype.close=function(){for(;0<this.a.length;)nk(this,this.a[0]);this.b=!0};function ok(){if(!pk())throw new t("web-storage-unsupported");this.c={};this.a=[];this.b=0;this.m=l.indexedDB;this.type="indexedDB";this.g=this.v=this.f=this.l=null;this.s=!1;this.h=null;var a=this;Je()&&self?(this.v=ik(),jk(this.v,"keyChanged",function(b,c){return qk(a).then(function(d){0<d.length&&w(a.a,function(e){e(d)});return{keyProcessed:Va(d,c.key)}})}),jk(this.v,"ping",function(){return E(["keyChanged"])})):ef().then(function(b){if(a.h=b)a.g=new lk(new kk(b)),mk(a.g,"ping",null,!0).then(function(c){c[0].fulfilled&&
Va(c[0].value,"keyChanged")&&(a.s=!0)}).o(function(){})})}var rk;function sk(a){return new D(function(b,c){var d=a.m.deleteDatabase("firebaseLocalStorageDb");d.onsuccess=function(){b()};d.onerror=function(e){c(Error(e.target.error))}})}
function tk(a){return new D(function(b,c){var d=a.m.open("firebaseLocalStorageDb",1);d.onerror=function(e){try{e.preventDefault()}catch(f){}c(Error(e.target.error))};d.onupgradeneeded=function(e){e=e.target.result;try{e.createObjectStore("firebaseLocalStorage",{keyPath:"fbase_key"})}catch(f){c(f)}};d.onsuccess=function(e){e=e.target.result;e.objectStoreNames.contains("firebaseLocalStorage")?b(e):sk(a).then(function(){return tk(a)}).then(function(f){b(f)}).o(function(f){c(f)})}})}
function uk(a){a.i||(a.i=tk(a));return a.i}function vk(a,b){function c(e,f){uk(a).then(b).then(e).o(function(g){if(3<++d)f(g);else return uk(a).then(function(h){h.close();a.i=void 0;return c(e,f)}).o(function(h){f(h)})})}var d=0;return new D(c)}function pk(){try{return!!l.indexedDB}catch(a){return!1}}function wk(a){return a.objectStore("firebaseLocalStorage")}function xk(a,b){return a.transaction(["firebaseLocalStorage"],b?"readwrite":"readonly")}
function yk(a){return new D(function(b,c){a.onsuccess=function(d){d&&d.target?b(d.target.result):b()};a.onerror=function(d){c(d.target.error)}})}k=ok.prototype;k.set=function(a,b){var c=this,d=!1;return vk(this,function(e){e=wk(xk(e,!0));return yk(e.get(a))}).then(function(e){return vk(c,function(f){f=wk(xk(f,!0));if(e)return e.value=b,yk(f.put(e));c.b++;d=!0;var g={};g.fbase_key=a;g.value=b;return yk(f.add(g))})}).then(function(){c.c[a]=b;return zk(c,a)}).oa(function(){d&&c.b--})};
function zk(a,b){return a.g&&a.h&&df()===a.h?mk(a.g,"keyChanged",{key:b},a.s).then(function(){}).o(function(){}):E()}k.get=function(a){return vk(this,function(b){return yk(wk(xk(b,!1)).get(a))}).then(function(b){return b&&b.value})};k.U=function(a){var b=this,c=!1;return vk(this,function(d){c=!0;b.b++;return yk(wk(xk(d,!0))["delete"](a))}).then(function(){delete b.c[a];return zk(b,a)}).oa(function(){c&&b.b--})};
function qk(a){return uk(a).then(function(b){var c=wk(xk(b,!1));return c.getAll?yk(c.getAll()):new D(function(d,e){var f=[],g=c.openCursor();g.onsuccess=function(h){(h=h.target.result)?(f.push(h.value),h["continue"]()):d(f)};g.onerror=function(h){e(h.target.error)}})}).then(function(b){var c={},d=[];if(0==a.b){for(d=0;d<b.length;d++)c[b[d].fbase_key]=b[d].value;d=te(a.c,c);a.c=c}return d})}k.ca=function(a){0==this.a.length&&Ak(this);this.a.push(a)};
k.ia=function(a){Xa(this.a,function(b){return b==a});0==this.a.length&&Bk(this)};function Ak(a){function b(){a.f=setTimeout(function(){a.l=qk(a).then(function(c){0<c.length&&w(a.a,function(d){d(c)})}).then(function(){b()}).o(function(c){"STOP_EVENT"!=c.message&&b()})},800)}Bk(a);b()}function Bk(a){a.l&&a.l.cancel("STOP_EVENT");a.f&&(clearTimeout(a.f),a.f=null)};function Ck(a){var b=this,c=null;this.a=[];this.type="indexedDB";this.c=a;this.b=E().then(function(){if(pk()){var d=Qe(),e="__sak"+d;rk||(rk=new ok);c=rk;return c.set(e,d).then(function(){return c.get(e)}).then(function(f){if(f!==d)throw Error("indexedDB not supported!");return c.U(e)}).then(function(){return c}).o(function(){return b.c})}return b.c}).then(function(d){b.type=d.type;d.ca(function(e){w(b.a,function(f){f(e)})});return d})}k=Ck.prototype;k.get=function(a){return this.b.then(function(b){return b.get(a)})};
k.set=function(a,b){return this.b.then(function(c){return c.set(a,b)})};k.U=function(a){return this.b.then(function(b){return b.U(a)})};k.ca=function(a){this.a.push(a)};k.ia=function(a){Xa(this.a,function(b){return b==a})};function Dk(){this.a={};this.type="inMemory"}k=Dk.prototype;k.get=function(a){return E(this.a[a])};k.set=function(a,b){this.a[a]=b;return E()};k.U=function(a){delete this.a[a];return E()};k.ca=function(){};k.ia=function(){};function Ek(){if(!Fk()){if("Node"==Ke())throw new t("internal-error","The LocalStorage compatibility library was not found.");throw new t("web-storage-unsupported");}this.a=Gk()||index_esm/* default.INTERNAL.node.localStorage */.Z.INTERNAL.node.localStorage;this.type="localStorage"}function Gk(){try{var a=l.localStorage,b=Qe();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function Fk(){var a="Node"==Ke();a=Gk()||a&&index_esm/* default.INTERNAL.node */.Z.INTERNAL.node&&index_esm/* default.INTERNAL.node.localStorage */.Z.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}k=Ek.prototype;k.get=function(a){var b=this;return E().then(function(){var c=b.a.getItem(a);return We(c)})};k.set=function(a,b){var c=this;return E().then(function(){var d=Ue(b);null===d?c.U(a):c.a.setItem(a,d)})};k.U=function(a){var b=this;return E().then(function(){b.a.removeItem(a)})};
k.ca=function(a){l.window&&nd(l.window,"storage",a)};k.ia=function(a){l.window&&xd(l.window,"storage",a)};function Hk(){this.type="nullStorage"}k=Hk.prototype;k.get=function(){return E(null)};k.set=function(){return E()};k.U=function(){return E()};k.ca=function(){};k.ia=function(){};function Ik(){if(!Jk()){if("Node"==Ke())throw new t("internal-error","The SessionStorage compatibility library was not found.");throw new t("web-storage-unsupported");}this.a=Kk()||index_esm/* default.INTERNAL.node.sessionStorage */.Z.INTERNAL.node.sessionStorage;this.type="sessionStorage"}function Kk(){try{var a=l.sessionStorage,b=Qe();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function Jk(){var a="Node"==Ke();a=Kk()||a&&index_esm/* default.INTERNAL.node */.Z.INTERNAL.node&&index_esm/* default.INTERNAL.node.sessionStorage */.Z.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}k=Ik.prototype;k.get=function(a){var b=this;return E().then(function(){var c=b.a.getItem(a);return We(c)})};k.set=function(a,b){var c=this;return E().then(function(){var d=Ue(b);null===d?c.U(a):c.a.setItem(a,d)})};k.U=function(a){var b=this;return E().then(function(){b.a.removeItem(a)})};k.ca=function(){};
k.ia=function(){};function Lk(){var a={};a.Browser=Mk;a.Node=Nk;a.ReactNative=Ok;a.Worker=Pk;this.a=a[Ke()]}var Qk,Mk={F:Ek,cb:Ik},Nk={F:Ek,cb:Ik},Ok={F:fk,cb:Hk},Pk={F:Ek,cb:Hk};var Rk={rd:"local",NONE:"none",td:"session"};function Sk(a){var b=new t("invalid-persistence-type"),c=new t("unsupported-persistence-type");a:{for(d in Rk)if(Rk[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(Ke()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;case "Worker":if("session"===a||!pk()&&"none"!==a)throw c;break;default:if(!Pe()&&"none"!==a)throw c;}}
function Tk(){var a=!Xe(K())&&Ie()?!0:!1,b=Te(),c=Pe();this.m=a;this.h=b;this.l=c;this.a={};Qk||(Qk=new Lk);a=Qk;try{this.g=!qe()&&cf()||!l.indexedDB?new a.a.F:new Ck(Je()?new Dk:new a.a.F)}catch(d){this.g=new Dk,this.h=!0}try{this.i=new a.a.cb}catch(d){this.i=new Dk}this.v=new Dk;this.f=q(this.Zb,this);this.b={}}var Uk;function Vk(){Uk||(Uk=new Tk);return Uk}function Wk(a,b){switch(b){case "session":return a.i;case "none":return a.v;default:return a.g}}
function Xk(a,b){return"firebase:"+a.name+(b?":"+b:"")}function Yk(a,b,c){var d=Xk(b,c),e=Wk(a,b.F);return a.get(b,c).then(function(f){var g=null;try{g=We(l.localStorage.getItem(d))}catch(h){}if(g&&!f)return l.localStorage.removeItem(d),a.set(b,g,c);g&&f&&"localStorage"!=e.type&&l.localStorage.removeItem(d)})}k=Tk.prototype;k.get=function(a,b){return Wk(this,a.F).get(Xk(a,b))};function Zk(a,b,c){c=Xk(b,c);"local"==b.F&&(a.b[c]=null);return Wk(a,b.F).U(c)}
k.set=function(a,b,c){var d=Xk(a,c),e=this,f=Wk(this,a.F);return f.set(d,b).then(function(){return f.get(d)}).then(function(g){"local"==a.F&&(e.b[d]=g)})};k.addListener=function(a,b,c){a=Xk(a,b);this.l&&(this.b[a]=l.localStorage.getItem(a));mb(this.a)&&(Wk(this,"local").ca(this.f),this.h||(qe()||!cf())&&l.indexedDB||!this.l||$k(this));this.a[a]||(this.a[a]=[]);this.a[a].push(c)};
k.removeListener=function(a,b,c){a=Xk(a,b);this.a[a]&&(Xa(this.a[a],function(d){return d==c}),0==this.a[a].length&&delete this.a[a]);mb(this.a)&&(Wk(this,"local").ia(this.f),al(this))};function $k(a){al(a);a.c=setInterval(function(){for(var b in a.a){var c=l.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new bd({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.Zb(c))}},1E3)}function al(a){a.c&&(clearInterval(a.c),a.c=null)}
k.Zb=function(a){if(a&&a.g){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=l.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.nb(c))}else if(0==b.indexOf("firebase:")&&this.a[b]){"undefined"!==typeof a.a.a?Wk(this,"local").ia(this.f):al(this);if(this.m)if(c=l.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?l.localStorage.setItem(b,d):l.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;c=function(){if("undefined"!==
typeof a.a.a||f.b[b]!==l.localStorage.getItem(b))f.b[b]=l.localStorage.getItem(b),f.nb(b)};Wb&&ic&&10==ic&&l.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else w(a,q(this.nb,this))};k.nb=function(a){this.a[a]&&w(this.a[a],function(b){b()})};function bl(a){this.a=a;this.b=Vk()}var cl={name:"authEvent",F:"local"};function dl(a){return a.b.get(cl,a.a).then(function(b){return th(b)})};function el(){this.a=Vk()};function fl(){this.b=-1};function gl(a,b){this.b=hl;this.f=l.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.i=a;this.h=b;this.l=l.Int32Array?new Int32Array(64):Array(64);void 0===il&&(l.Int32Array?il=new Int32Array(jl):il=jl);this.reset()}var il;r(gl,fl);for(var hl=64,kl=hl-1,ll=[],ml=0;ml<kl;ml++)ll[ml]=0;var nl=Ya(128,ll);gl.prototype.reset=function(){this.g=this.c=0;this.a=l.Int32Array?new Int32Array(this.h):Za(this.h)};
function ol(a){for(var b=a.f,c=a.l,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}d=a.a[0]|0;e=a.a[1]|0;var h=a.a[2]|0,m=a.a[3]|0,p=a.a[4]|0,v=a.a[5]|0,B=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var A=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&h^e&h)|0;g=p&v^~p&B;f=f+((p>>>6|p<<26)^(p>>>11|p<<21)^(p>>>25|p<<
7))|0;g=g+(il[b]|0)|0;g=f+(g+(c[b]|0)|0)|0;f=B;B=v;v=p;p=m+g|0;m=h;h=e;e=d;d=g+A|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+h|0;a.a[3]=a.a[3]+m|0;a.a[4]=a.a[4]+p|0;a.a[5]=a.a[5]+v|0;a.a[6]=a.a[6]+B|0;a.a[7]=a.a[7]+f|0}
function pl(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if("string"===typeof b)for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(ol(a),e=0);else if(na(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(ol(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
var jl=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function ql(){gl.call(this,8,rl)}r(ql,gl);var rl=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function sl(a,b,c,d,e,f){this.v=a;this.i=b;this.l=c;this.m=d||null;this.u=e||null;this.s=f;this.h=b+":"+c;this.C=new el;this.g=new bl(this.h);this.f=null;this.b=[];this.a=this.c=null}function tl(a){return new t("invalid-cordova-configuration",a)}k=sl.prototype;
k.ma=function(){return this.Ia?this.Ia:this.Ia=Fe().then(function(){if("function"!==typeof L("universalLinks.subscribe",l))throw tl("cordova-universal-links-plugin-fix is not installed");if("undefined"===typeof L("BuildInfo.packageName",l))throw tl("cordova-plugin-buildinfo is not installed");if("function"!==typeof L("cordova.plugins.browsertab.openUrl",l))throw tl("cordova-plugin-browsertab is not installed");if("function"!==typeof L("cordova.InAppBrowser.open",l))throw tl("cordova-plugin-inappbrowser is not installed");
},function(){throw new t("cordova-not-ready");})};function ul(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function vl(a){var b=new ql;pl(b,a);a=[];var c=8*b.g;56>b.c?pl(b,nl,56-b.c):pl(b,nl,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;ol(b);for(d=c=0;d<b.i;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return cg(a)}
k.Pb=function(a,b){b(new t("operation-not-supported-in-this-environment"));return E()};k.Nb=function(){return F(new t("operation-not-supported-in-this-environment"))};k.ac=function(){return!1};k.Yb=function(){return!0};k.Ub=function(){return!0};
k.Ob=function(a,b,c,d){if(this.c)return F(new t("redirect-operation-pending"));var e=this,f=l.document,g=null,h=null,m=null,p=null;return this.c=E().then(function(){rh(b);return wl(e)}).then(function(){return xl(e,a,b,c,d)}).then(function(){return(new D(function(v,B){h=function(){var A=L("cordova.plugins.browsertab.close",l);v();"function"===typeof A&&A();e.a&&"function"===typeof e.a.close&&(e.a.close(),e.a=null);return!1};e.Ea(h);m=function(){g||(g=Fd(2E3).then(function(){B(new t("redirect-cancelled-by-user"))}))};
p=function(){$e()&&m()};f.addEventListener("resume",m,!1);K().toLowerCase().match(/android/)||f.addEventListener("visibilitychange",p,!1)})).o(function(v){return yl(e).then(function(){throw v;})})}).oa(function(){m&&f.removeEventListener("resume",m,!1);p&&f.removeEventListener("visibilitychange",p,!1);g&&g.cancel();h&&e.Ta(h);e.c=null})};
function xl(a,b,c,d,e){var f=ul(),g=new sh(b,d,null,f,new t("no-auth-event"),null,e),h=L("BuildInfo.packageName",l);if("string"!==typeof h)throw new t("invalid-cordova-configuration");var m=L("BuildInfo.displayName",l),p={};if(K().toLowerCase().match(/iphone|ipad|ipod/))p.ibi=h;else if(K().toLowerCase().match(/android/))p.apn=h;else return F(new t("operation-not-supported-in-this-environment"));m&&(p.appDisplayName=m);f=vl(f);p.sessionId=f;var v=ek(a.v,a.i,a.l,b,c,null,d,a.m,p,a.u,e,a.s);return a.ma().then(function(){var B=
a.h;return a.C.a.set(cl,g.w(),B)}).then(function(){var B=L("cordova.plugins.browsertab.isAvailable",l);if("function"!==typeof B)throw new t("invalid-cordova-configuration");var A=null;B(function(Q){if(Q){A=L("cordova.plugins.browsertab.openUrl",l);if("function"!==typeof A)throw new t("invalid-cordova-configuration");A(v)}else{A=L("cordova.InAppBrowser.open",l);if("function"!==typeof A)throw new t("invalid-cordova-configuration");Q=K();a.a=A(v,Q.match(/(iPad|iPhone|iPod).*OS 7_\d/i)||Q.match(/(iPad|iPhone|iPod).*OS 8_\d/i)?
"_blank":"_system","location=yes")}})})}function zl(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function wl(a){a.f||(a.f=a.ma().then(function(){return new D(function(b){function c(d){b(d);a.Ta(c);return!1}a.Ea(c);Al(a)})}));return a.f}function yl(a){var b=null;return dl(a.g).then(function(c){b=c;c=a.g;return Zk(c.b,cl,c.a)}).then(function(){return b})}
function Al(a){function b(g){d=!0;e&&e.cancel();yl(a).then(function(h){var m=c;if(h&&g&&g.url){var p=null;m=xg(g.url);-1!=m.indexOf("/__/auth/callback")&&(p=J(m),p=We(be(p,"firebaseError")||null),p=(p="object"===typeof p?Aa(p):null)?new sh(h.c,h.b,null,null,p,null,h.T()):new sh(h.c,h.b,m,h.f,null,null,h.T()));m=p||c}zl(a,m)})}var c=new sh("unknown",null,null,null,new t("no-auth-event")),d=!1,e=Fd(500).then(function(){return yl(a).then(function(){d||zl(a,c)})}),f=l.handleOpenURL;l.handleOpenURL=function(g){0==
g.toLowerCase().indexOf(L("BuildInfo.packageName",l).toLowerCase()+"://")&&b({url:g});if("function"===typeof f)try{f(g)}catch(h){console.error(h)}};vh||(vh=new uh);wh(b)}k.Ea=function(a){this.b.push(a);wl(this).o(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new sh("unknown",null,null,null,new t("no-auth-event")),a(b))})};k.Ta=function(a){Xa(this.b,function(b){return b==a})};function Bl(a){this.a=a;this.b=Vk()}var Cl={name:"pendingRedirect",F:"session"};function Dl(a){return a.b.set(Cl,"pending",a.a)}function El(a){return Zk(a.b,Cl,a.a)}function Fl(a){return a.b.get(Cl,a.a).then(function(b){return"pending"==b})};function Gl(a,b,c,d){this.i={};this.u=0;this.D=a;this.v=b;this.m=c;this.J=d;this.h=[];this.f=!1;this.l=q(this.s,this);this.b=new Hl;this.C=new Il;this.g=new Bl(Jl(this.v,this.m));this.c={};this.c.unknown=this.b;this.c.signInViaRedirect=this.b;this.c.linkViaRedirect=this.b;this.c.reauthViaRedirect=this.b;this.c.signInViaPopup=this.C;this.c.linkViaPopup=this.C;this.c.reauthViaPopup=this.C;this.a=Kl(this.D,this.v,this.m,Da,this.J)}
function Kl(a,b,c,d,e){var f=index_esm/* default.SDK_VERSION */.Z.SDK_VERSION||null;return Ge()?new sl(a,b,c,f,d,e):new Yj(a,b,c,f,d,e)}Gl.prototype.reset=function(){this.f=!1;this.a.Ta(this.l);this.a=Kl(this.D,this.v,this.m,null,this.J);this.i={}};function Ll(a){a.f||(a.f=!0,a.a.Ea(a.l));var b=a.a;return a.a.ma().o(function(c){a.a==b&&a.reset();throw c;})}
function Ml(a){a.a.Yb()&&Ll(a).o(function(b){var c=new sh("unknown",null,null,null,new t("operation-not-supported-in-this-environment"));Nl(b)&&a.s(c)});a.a.Ub()||Ol(a.b)}function Pl(a,b){Va(a.h,b)||a.h.push(b);a.f||Fl(a.g).then(function(c){c?El(a.g).then(function(){Ll(a).o(function(d){var e=new sh("unknown",null,null,null,new t("operation-not-supported-in-this-environment"));Nl(d)&&a.s(e)})}):Ml(a)}).o(function(){Ml(a)})}function Ql(a,b){Xa(a.h,function(c){return c==b})}
Gl.prototype.s=function(a){if(!a)throw new t("invalid-auth-event");6E5<=Date.now()-this.u&&(this.i={},this.u=0);if(a&&a.getUid()&&this.i.hasOwnProperty(a.getUid()))return!1;for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.Gb(a.c,a.b)){if(b=this.c[a.c])b.h(a,d),a&&(a.f||a.b)&&(this.i[a.getUid()]=!0,this.u=Date.now());b=!0;break}}Ol(this.b);return b};var Rl=new Ze(2E3,1E4),Sl=new Ze(3E4,6E4);Gl.prototype.ra=function(){return this.b.ra()};
function Tl(a,b,c,d,e,f,g){return a.a.Nb(b,c,d,function(){a.f||(a.f=!0,a.a.Ea(a.l))},function(){a.reset()},e,f,g)}function Nl(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}
function Ul(a,b,c,d,e){var f;return Dl(a.g).then(function(){return a.a.Ob(b,c,d,e).o(function(g){if(Nl(g))throw new t("operation-not-supported-in-this-environment");f=g;return El(a.g).then(function(){throw f;})}).then(function(){return a.a.ac()?new D(function(){}):El(a.g).then(function(){return a.ra()}).then(function(){}).o(function(){})})})}function Vl(a,b,c,d,e){return a.a.Pb(d,function(f){b.na(c,null,f,e)},Rl.get())}var Wl={};function Jl(a,b,c){a=a+":"+b;c&&(a=a+":"+c.url);return a}
function Xl(a,b,c,d){var e=Jl(b,c,d);Wl[e]||(Wl[e]=new Gl(a,b,c,d));return Wl[e]}function Hl(){this.b=null;this.f=[];this.c=[];this.a=null;this.i=this.g=!1}Hl.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
Hl.prototype.h=function(a,b){if(a){this.reset();this.g=!0;var c=a.c,d=a.b,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;this.i=!(!e&&!f);"unknown"!=c||e||f?a.a?(Yl(this,!0,null,a.a),E()):b.Fa(c,d)?Zl(this,a,b):F(new t("invalid-auth-event")):(Yl(this,!1,null,null),E())}else F(new t("invalid-auth-event"))};function Ol(a){a.g||(a.g=!0,Yl(a,!1,null,null))}function $l(a){a.g&&!a.i&&Yl(a,!1,null,null)}
function Zl(a,b,c){c=c.Fa(b.c,b.b);var d=b.g,e=b.f,f=b.i,g=b.T(),h=!!b.c.match(/Redirect$/);c(d,e,g,f).then(function(m){Yl(a,h,m,null)}).o(function(m){Yl(a,h,null,m)})}function am(a,b){a.b=function(){return F(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function bm(a,b){a.b=function(){return E(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function Yl(a,b,c,d){b?d?am(a,d):bm(a,c):bm(a,{user:null});a.f=[];a.c=[]}
Hl.prototype.ra=function(){var a=this;return new D(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),cm(a))})};function cm(a){var b=new t("timeout");a.a&&a.a.cancel();a.a=Fd(Sl.get()).then(function(){a.b||(a.g=!0,Yl(a,!0,null,b))})}function Il(){}Il.prototype.h=function(a,b){if(a){var c=a.c,d=a.b;a.a?(b.na(a.c,null,a.a,a.b),E()):b.Fa(c,d)?dm(a,b):F(new t("invalid-auth-event"))}else F(new t("invalid-auth-event"))};
function dm(a,b){var c=a.b,d=a.c;b.Fa(d,c)(a.g,a.f,a.T(),a.i).then(function(e){b.na(d,e,null,c)}).o(function(e){b.na(d,null,e,c)})};function em(){this.jb=!1;Object.defineProperty(this,"appVerificationDisabled",{get:function(){return this.jb},set:function(a){this.jb=a},enumerable:!1})};function fm(a,b){this.a=b;M(this,"verificationId",a)}fm.prototype.confirm=function(a){a=ph(this.verificationId,a);return this.a(a)};function gm(a,b,c,d){return(new lh(a)).gb(b,c).then(function(e){return new fm(e,d)})};function hm(a){var b=ig(a);if(!(b&&b.exp&&b.auth_time&&b.iat))throw new t("internal-error","An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");N(this,{token:a,expirationTime:bf(1E3*b.exp),authTime:bf(1E3*b.auth_time),issuedAtTime:bf(1E3*b.iat),signInProvider:b.firebase&&b.firebase.sign_in_provider?b.firebase.sign_in_provider:null,signInSecondFactor:b.firebase&&b.firebase.sign_in_second_factor?b.firebase.sign_in_second_factor:null,claims:b})}
;function im(a,b,c){var d=b&&b[jm];if(!d)throw new t("argument-error","Internal assert: Invalid MultiFactorResolver");this.a=a;this.f=nb(b);this.g=c;this.c=new yg(null,d);this.b=[];var e=this;w(b[km]||[],function(f){(f=tf(f))&&e.b.push(f)});M(this,"auth",this.a);M(this,"session",this.c);M(this,"hints",this.b)}var km="mfaInfo",jm="mfaPendingCredential";im.prototype.Rc=function(a){var b=this;return a.tb(this.a.a,this.c).then(function(c){var d=nb(b.f);delete d[km];delete d[jm];z(d,c);return b.g(d)})};function lm(a,b,c,d){t.call(this,"multi-factor-auth-required",d,b);this.b=new im(a,b,c);M(this,"resolver",this.b)}r(lm,t);function mm(a,b,c){if(a&&n(a.serverResponse)&&"auth/multi-factor-auth-required"===a.code)try{return new lm(b,a.serverResponse,c,a.message)}catch(d){}return null};function nm(){}nm.prototype.tb=function(a,b,c){return b.type==zg?om(this,a,b,c):pm(this,a,b)};function om(a,b,c,d){return c.Ha().then(function(e){e={idToken:e};"undefined"!==typeof d&&(e.displayName=d);z(e,{phoneVerificationInfo:hh(a.a)});return O(b,Gj,e)})}function pm(a,b,c){return c.Ha().then(function(d){d={mfaPendingCredential:d};z(d,{phoneVerificationInfo:hh(a.a)});return O(b,Hj,d)})}function qm(a){M(this,"factorId",a.fa);this.a=a}r(qm,nm);
function rm(a){qm.call(this,a);if(this.a.fa!=lh.PROVIDER_ID)throw new t("argument-error","firebase.auth.PhoneMultiFactorAssertion requires a valid firebase.auth.PhoneAuthCredential");}r(rm,qm);function sm(a,b){G.call(this,a);for(var c in b)this[c]=b[c]}r(sm,G);function tm(a,b){this.a=a;this.b=[];this.c=q(this.yc,this);nd(this.a,"userReloaded",this.c);var c=[];b&&b.multiFactor&&b.multiFactor.enrolledFactors&&w(b.multiFactor.enrolledFactors,function(d){var e=null,f={};if(d){d.uid&&(f[qf]=d.uid);d.displayName&&(f[rf]=d.displayName);d.enrollmentTime&&(f[sf]=(new Date(d.enrollmentTime)).toISOString());d.phoneNumber&&(f[pf]=d.phoneNumber);try{e=new uf(f)}catch(g){}d=e}else d=null;d&&c.push(d)});um(this,c)}
function vm(a){var b=[];w(a.mfaInfo||[],function(c){(c=tf(c))&&b.push(c)});return b}k=tm.prototype;k.yc=function(a){um(this,vm(a.hd))};function um(a,b){a.b=b;M(a,"enrolledFactors",b)}k.Sb=function(){return this.a.I().then(function(a){return new yg(a,null)})};k.fc=function(a,b){var c=this,d=this.a.a;return this.Sb().then(function(e){return a.tb(d,e,b)}).then(function(e){wm(c.a,e);return c.a.reload()})};
k.bd=function(a){var b=this,c="string"===typeof a?a:a.uid,d=this.a.a;return this.a.I().then(function(e){return O(d,Lj,{idToken:e,mfaEnrollmentId:c})}).then(function(e){var f=Qa(b.b,function(g){return g.uid!=c});um(b,f);wm(b.a,e);return b.a.reload().o(function(g){if("auth/user-token-expired"!=g.code)throw g;})})};k.w=function(){return{multiFactor:{enrolledFactors:Ra(this.b,function(a){return a.w()})}}};function xm(a,b,c){this.h=a;this.i=b;this.g=c;this.c=3E4;this.f=96E4;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}xm.prototype.start=function(){this.a=this.c;ym(this,!0)};function zm(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}function ym(a,b){a.stop();a.b=Fd(zm(a,b)).then(function(){return af()}).then(function(){return a.h()}).then(function(){ym(a,!0)}).o(function(c){a.i(c)&&ym(a,!1)})}
xm.prototype.stop=function(){this.b&&(this.b.cancel(),this.b=null)};function Am(a){this.f=a;this.b=this.a=null;this.c=Date.now()}Am.prototype.w=function(){return{apiKey:this.f.c,refreshToken:this.a,accessToken:this.b&&this.b.toString(),expirationTime:this.c}};function Bm(a,b){"undefined"===typeof b&&(a.b?(b=a.b,b=b.a-b.g):b=0);a.c=Date.now()+1E3*b}function Cm(a,b){a.b=jg(b[Dg]||"");a.a=b.refreshToken;b=b.expiresIn;Bm(a,"undefined"!==typeof b?Number(b):void 0)}function Dm(a,b){a.b=b.b;a.a=b.a;a.c=b.c}
function Em(a,b){return Wi(a.f,b).then(function(c){a.b=jg(c.access_token);a.a=c.refresh_token;Bm(a,c.expires_in);return{accessToken:a.b.toString(),refreshToken:a.a}}).o(function(c){"auth/user-token-expired"==c.code&&(a.a=null);throw c;})}Am.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?F(new t("user-token-expired")):a||!this.b||Date.now()>this.c-3E4?this.a?Em(this,{grant_type:"refresh_token",refresh_token:this.a}):E(null):E({accessToken:this.b.toString(),refreshToken:this.a})};function Fm(a,b){this.a=a||null;this.b=b||null;N(this,{lastSignInTime:bf(b||null),creationTime:bf(a||null)})}function Gm(a){return new Fm(a.a,a.b)}Fm.prototype.w=function(){return{lastLoginAt:this.b,createdAt:this.a}};function Hm(a,b,c,d,e,f){N(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}
function Im(a,b,c){this.N=[];this.l=a.apiKey;this.m=a.appName;this.s=a.authDomain||null;var d=index_esm/* default.SDK_VERSION */.Z.SDK_VERSION?Oe(index_esm/* default.SDK_VERSION */.Z.SDK_VERSION):null;this.a=new Ii(this.l,Ca(Da),d);(this.u=a.emulatorConfig||null)&&Pi(this.a,this.u);this.h=new Am(this.a);Jm(this,b[Dg]);Cm(this.h,b);M(this,"refreshToken",this.h.a);Km(this,c||{});H.call(this);this.P=!1;this.s&&Re()&&(this.b=Xl(this.s,this.l,this.m,this.u));this.W=[];this.i=null;this.D=Lm(this);this.ba=q(this.ib,this);var e=this;this.za=null;this.Pa=function(f){e.xa(f.h)};
this.qa=null;this.Ba=function(f){Mm(e,f.c)};this.$=null;this.aa=[];this.Oa=function(f){Nm(e,f.f)};this.ja=null;this.S=new tm(this,c);M(this,"multiFactor",this.S)}r(Im,H);Im.prototype.xa=function(a){this.za=a;Oi(this.a,a)};function Mm(a,b){a.u=b;Pi(a.a,b);a.b&&(b=a.b,a.b=Xl(a.s,a.l,a.m,a.u),a.P&&(Ql(b,a),Pl(a.b,a)))}Im.prototype.la=function(){return this.za};function Om(a,b){a.qa&&xd(a.qa,"languageCodeChanged",a.Pa);(a.qa=b)&&nd(b,"languageCodeChanged",a.Pa)}
function Pm(a,b){a.$&&xd(a.$,"emulatorConfigChanged",a.Ba);(a.$=b)&&nd(b,"emulatorConfigChanged",a.Ba)}function Nm(a,b){a.aa=b;Ri(a.a,index_esm/* default.SDK_VERSION */.Z.SDK_VERSION?Oe(index_esm/* default.SDK_VERSION */.Z.SDK_VERSION,a.aa):null)}Im.prototype.Ga=function(){return Za(this.aa)};function Qm(a,b){a.ja&&xd(a.ja,"frameworkChanged",a.Oa);(a.ja=b)&&nd(b,"frameworkChanged",a.Oa)}Im.prototype.ib=function(){this.D.b&&(this.D.stop(),this.D.start())};
function Rm(a){try{return index_esm/* default.app */.Z.app(a.m).auth()}catch(b){throw new t("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.m+"'!");}}function Lm(a){return new xm(function(){return a.I(!0)},function(b){return b&&"auth/network-request-failed"==b.code?!0:!1},function(){var b=a.h.c-Date.now()-3E5;return 0<b?b:0})}function Sm(a){a.J||a.D.b||(a.D.start(),xd(a,"tokenChanged",a.ba),nd(a,"tokenChanged",a.ba))}function Tm(a){xd(a,"tokenChanged",a.ba);a.D.stop()}
function Jm(a,b){a.Aa=b;M(a,"_lat",b)}function Um(a,b){Xa(a.W,function(c){return c==b})}function Vm(a){for(var b=[],c=0;c<a.W.length;c++)b.push(a.W[c](a));return Jc(b).then(function(){return a})}function Wm(a){a.b&&!a.P&&(a.P=!0,Pl(a.b,a))}
function Km(a,b){N(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,tenantId:b.tenantId||null,metadata:new Fm(b.createdAt,b.lastLoginAt),providerData:[]});a.a.b=a.tenantId}M(Im.prototype,"providerId","firebase");function Xm(){}function Ym(a){return E().then(function(){if(a.J)throw new t("app-deleted");})}
function Zm(a){return Ra(a.providerData,function(b){return b.providerId})}function $m(a,b){b&&(an(a,b.providerId),a.providerData.push(b))}function an(a,b){Xa(a.providerData,function(c){return c.providerId==b})}function bn(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&M(a,b,c)}
function cn(a,b){a!=b&&(N(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,tenantId:b.tenantId,providerData:[]}),b.metadata?M(a,"metadata",Gm(b.metadata)):M(a,"metadata",new Fm),w(b.providerData,function(c){$m(a,c)}),Dm(a.h,b.h),M(a,"refreshToken",a.h.a),um(a.S,b.S.b))}k=Im.prototype;k.reload=function(){var a=this;return R(this,Ym(this).then(function(){return dn(a).then(function(){return Vm(a)}).then(Xm)}))};
function dn(a){return a.I().then(function(b){var c=a.isAnonymous;return en(a,b).then(function(){c||bn(a,"isAnonymous",!1);return b})})}k.oc=function(a){return this.I(a).then(function(b){return new hm(b)})};k.I=function(a){var b=this;return R(this,Ym(this).then(function(){return b.h.getToken(a)}).then(function(c){if(!c)throw new t("internal-error");c.accessToken!=b.Aa&&(Jm(b,c.accessToken),b.dispatchEvent(new sm("tokenChanged")));bn(b,"refreshToken",c.refreshToken);return c.accessToken}))};
function wm(a,b){b[Dg]&&a.Aa!=b[Dg]&&(Cm(a.h,b),a.dispatchEvent(new sm("tokenChanged")),Jm(a,b[Dg]),bn(a,"refreshToken",a.h.a))}function en(a,b){return O(a.a,Ij,{idToken:b}).then(q(a.Kc,a))}
k.Kc=function(a){a=a.users;if(!a||!a.length)throw new t("internal-error");a=a[0];Km(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt,tenantId:a.tenantId});for(var b=fn(a),c=0;c<b.length;c++)$m(this,b[c]);bn(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length));this.dispatchEvent(new sm("userReloaded",{hd:a}))};
function fn(a){return(a=a.providerUserInfo)&&a.length?Ra(a,function(b){return new Hm(b.rawId,b.providerId,b.email,b.displayName,b.photoUrl,b.phoneNumber)}):[]}k.Lc=function(a){gf("firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");return this.ub(a)};
k.ub=function(a){var b=this,c=null;return R(this,a.c(this.a,this.uid).then(function(d){wm(b,d);c=gn(b,d,"reauthenticate");b.i=null;return b.reload()}).then(function(){return c}),!0)};function hn(a,b){return dn(a).then(function(){if(Va(Zm(a),b))return Vm(a).then(function(){throw new t("provider-already-linked");})})}k.Cc=function(a){gf("firebase.User.prototype.linkAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");return this.rb(a)};
k.rb=function(a){var b=this,c=null;return R(this,hn(this,a.providerId).then(function(){return b.I()}).then(function(d){return a.b(b.a,d)}).then(function(d){c=gn(b,d,"link");return jn(b,d)}).then(function(){return c}))};k.Dc=function(a,b){var c=this;return R(this,hn(this,"phone").then(function(){return gm(Rm(c),a,b,q(c.rb,c))}))};k.Mc=function(a,b){var c=this;return R(this,E().then(function(){return gm(Rm(c),a,b,q(c.ub,c))}),!0)};
function gn(a,b,c){var d=qh(b);b=og(b);return kf({user:a,credential:d,additionalUserInfo:b,operationType:c})}function jn(a,b){wm(a,b);return a.reload().then(function(){return a})}k.Cb=function(a){var b=this;return R(this,this.I().then(function(c){return b.a.Cb(c,a)}).then(function(c){wm(b,c);return b.reload()}))};k.ed=function(a){var b=this;return R(this,this.I().then(function(c){return a.b(b.a,c)}).then(function(c){wm(b,c);return b.reload()}))};
k.Db=function(a){var b=this;return R(this,this.I().then(function(c){return b.a.Db(c,a)}).then(function(c){wm(b,c);return b.reload()}))};
k.Eb=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return Ym(this);var b=this;return R(this,this.I().then(function(c){return b.a.Eb(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(c){wm(b,c);bn(b,"displayName",c.displayName||null);bn(b,"photoURL",c.photoUrl||null);w(b.providerData,function(d){"password"===d.providerId&&(M(d,"displayName",b.displayName),M(d,"photoURL",b.photoURL))});return Vm(b)}).then(Xm))};
k.cd=function(a){var b=this;return R(this,dn(this).then(function(c){return Va(Zm(b),a)?rj(b.a,c,[a]).then(function(d){var e={};w(d.providerUserInfo||[],function(f){e[f.providerId]=!0});w(Zm(b),function(f){e[f]||an(b,f)});e[lh.PROVIDER_ID]||M(b,"phoneNumber",null);return Vm(b)}):Vm(b).then(function(){throw new t("no-such-provider");})}))};
k.delete=function(){var a=this;return R(this,this.I().then(function(b){return O(a.a,Fj,{idToken:b})}).then(function(){a.dispatchEvent(new sm("userDeleted"))})).then(function(){for(var b=0;b<a.N.length;b++)a.N[b].cancel("app-deleted");Om(a,null);Pm(a,null);Qm(a,null);a.N=[];a.J=!0;Tm(a);M(a,"refreshToken",null);a.b&&Ql(a.b,a)})};
k.Gb=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.ga||null)==b||"reauthViaRedirect"==a&&(this.ga||null)==b?!0:!1};k.na=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.C?this.C(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.C)};
k.Fa=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?q(this.Lb,this):"reauthViaPopup"==a&&b==(this.g||null)?q(this.Mb,this):"linkViaRedirect"==a&&(this.ga||null)==b?q(this.Lb,this):"reauthViaRedirect"==a&&(this.ga||null)==b?q(this.Mb,this):null};k.Ec=function(a){var b=this;return kn(this,"linkViaPopup",a,function(){return hn(b,a.providerId).then(function(){return Vm(b)})},!1)};k.Nc=function(a){return kn(this,"reauthViaPopup",a,function(){return E()},!0)};
function kn(a,b,c,d,e){if(!Re())return F(new t("operation-not-supported-in-this-environment"));if(a.i&&!e)return F(a.i);var f=ng(c.providerId),g=Qe(a.uid+":::"),h=null;(!Te()||Ie())&&a.s&&c.isOAuthProvider&&(h=ek(a.s,a.l,a.m,b,c,null,g,index_esm/* default.SDK_VERSION */.Z.SDK_VERSION||null,null,null,a.tenantId,a.u));var m=ze(h,f&&f.va,f&&f.ua);d=d().then(function(){ln(a);if(!e)return a.I().then(function(){})}).then(function(){return Tl(a.b,m,b,c,g,!!h,a.tenantId)}).then(function(){return new D(function(p,v){a.na(b,null,new t("cancelled-popup-request"),
a.g||null);a.f=p;a.C=v;a.g=g;a.c=Vl(a.b,a,b,m,g)})}).then(function(p){m&&ye(m);return p?kf(p):null}).o(function(p){m&&ye(m);throw p;});return R(a,d,e)}k.Fc=function(a){var b=this;return mn(this,"linkViaRedirect",a,function(){return hn(b,a.providerId)},!1)};k.Oc=function(a){return mn(this,"reauthViaRedirect",a,function(){return E()},!0)};
function mn(a,b,c,d,e){if(!Re())return F(new t("operation-not-supported-in-this-environment"));if(a.i&&!e)return F(a.i);var f=null,g=Qe(a.uid+":::");d=d().then(function(){ln(a);if(!e)return a.I().then(function(){})}).then(function(){a.ga=g;return Vm(a)}).then(function(h){a.ha&&(h=a.ha,h=h.b.set(nn,a.w(),h.a));return h}).then(function(){return Ul(a.b,b,c,g,a.tenantId)}).o(function(h){f=h;if(a.ha)return on(a.ha);throw f;}).then(function(){if(f)throw f;});return R(a,d,e)}
function ln(a){if(!a.b||!a.P){if(a.b&&!a.P)throw new t("internal-error");throw new t("auth-domain-config-required");}}k.Lb=function(a,b,c,d){var e=this;this.c&&(this.c.cancel(),this.c=null);var f=null;c=this.I().then(function(g){return Hg(e.a,{requestUri:a,postBody:d,sessionId:b,idToken:g})}).then(function(g){f=gn(e,g,"link");return jn(e,g)}).then(function(){return f});return R(this,c)};
k.Mb=function(a,b,c,d){var e=this;this.c&&(this.c.cancel(),this.c=null);var f=null,g=E().then(function(){return Cg(Ig(e.a,{requestUri:a,sessionId:b,postBody:d,tenantId:c}),e.uid)}).then(function(h){f=gn(e,h,"reauthenticate");wm(e,h);e.i=null;return e.reload()}).then(function(){return f});return R(this,g,!0)};
k.vb=function(a){var b=this,c=null;return R(this,this.I().then(function(d){c=d;return"undefined"===typeof a||mb(a)?{}:bg(new Sf(a))}).then(function(d){return b.a.vb(c,d)}).then(function(d){if(b.email!=d)return b.reload()}).then(function(){}))};k.Fb=function(a,b){var c=this,d=null;return R(this,this.I().then(function(e){d=e;return"undefined"===typeof b||mb(b)?{}:bg(new Sf(b))}).then(function(e){return c.a.Fb(d,a,e)}).then(function(e){if(c.email!=e)return c.reload()}).then(function(){}))};
function R(a,b,c){var d=pn(a,b,c);a.N.push(d);d.oa(function(){Wa(a.N,d)});return d.o(function(e){var f=null;e&&"auth/multi-factor-auth-required"===e.code&&(f=mm(e.w(),Rm(a),q(a.jc,a)));throw f||e;})}k.jc=function(a){var b=null,c=this;a=Cg(E(a),c.uid).then(function(d){b=gn(c,d,"reauthenticate");wm(c,d);c.i=null;return c.reload()}).then(function(){return b});return R(this,a,!0)};
function pn(a,b,c){return a.i&&!c?(b.cancel(),F(a.i)):b.o(function(d){!d||"auth/user-disabled"!=d.code&&"auth/user-token-expired"!=d.code||(a.i||a.dispatchEvent(new sm("userInvalidated")),a.i=d);throw d;})}k.toJSON=function(){return this.w()};
k.w=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,tenantId:this.tenantId,providerData:[],apiKey:this.l,appName:this.m,authDomain:this.s,stsTokenManager:this.h.w(),redirectEventId:this.ga||null};this.metadata&&z(a,this.metadata.w());w(this.providerData,function(b){a.providerData.push(lf(b))});z(a,this.S.w());return a};
function qn(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName,emulatorConfig:a.emulatorConfig},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken){c[Dg]=a.stsTokenManager.accessToken;c.refreshToken=a.stsTokenManager.refreshToken||null;var d=a.stsTokenManager.expirationTime;d&&(c.expiresIn=(d-Date.now())/1E3)}else return null;var e=new Im(b,c,a);a.providerData&&w(a.providerData,function(f){f&&$m(e,kf(f))});a.redirectEventId&&(e.ga=a.redirectEventId);
return e}function rn(a,b,c,d){var e=new Im(a,b);c&&(e.ha=c);d&&Nm(e,d);return e.reload().then(function(){return e})}function sn(a,b,c,d){var e=a.h,f={};f[Dg]=e.b&&e.b.toString();f.refreshToken=e.a;b=new Im(b||{apiKey:a.l,authDomain:a.s,appName:a.m},f);c&&(b.ha=c);d&&Nm(b,d);cn(b,a);return b};function tn(a){this.a=a;this.b=Vk()}var nn={name:"redirectUser",F:"session"};function on(a){return Zk(a.b,nn,a.a)}function un(a,b){return a.b.get(nn,a.a).then(function(c){c&&b&&(c.authDomain=b);return qn(c||{})})};function vn(a){this.a=a;this.b=Vk();this.c=null;this.f=wn(this);this.b.addListener(xn("local"),this.a,q(this.g,this))}vn.prototype.g=function(){var a=this,b=xn("local");yn(this,function(){return E().then(function(){return a.c&&"local"!=a.c.F?a.b.get(b,a.a):null}).then(function(c){if(c)return zn(a,"local").then(function(){a.c=b})})})};function zn(a,b){var c=[],d;for(d in Rk)Rk[d]!==b&&c.push(Zk(a.b,xn(Rk[d]),a.a));c.push(Zk(a.b,An,a.a));return Ic(c)}
function wn(a){var b=xn("local"),c=xn("session"),d=xn("none");return Yk(a.b,b,a.a).then(function(){return a.b.get(c,a.a)}).then(function(e){return e?c:a.b.get(d,a.a).then(function(f){return f?d:a.b.get(b,a.a).then(function(g){return g?b:a.b.get(An,a.a).then(function(h){return h?xn(h):b})})})}).then(function(e){a.c=e;return zn(a,e.F)}).o(function(){a.c||(a.c=b)})}var An={name:"persistence",F:"session"};function xn(a){return{name:"authUser",F:a}}
vn.prototype.yb=function(a){var b=null,c=this;Sk(a);return yn(this,function(){return a!=c.c.F?c.b.get(c.c,c.a).then(function(d){b=d;return zn(c,a)}).then(function(){c.c=xn(a);if(b)return c.b.set(c.c,b,c.a)}):E()})};function Bn(a){return yn(a,function(){return a.b.set(An,a.c.F,a.a)})}function Cn(a,b){return yn(a,function(){return a.b.set(a.c,b.w(),a.a)})}function Dn(a){return yn(a,function(){return Zk(a.b,a.c,a.a)})}
function En(a,b,c){return yn(a,function(){return a.b.get(a.c,a.a).then(function(d){d&&b&&(d.authDomain=b);d&&c&&(d.emulatorConfig=c);return qn(d||{})})})}function yn(a,b){a.f=a.f.then(b,b);return a.f};function Fn(a){this.l=!1;M(this,"settings",new em);M(this,"app",a);if(S(this).options&&S(this).options.apiKey)a=index_esm/* default.SDK_VERSION */.Z.SDK_VERSION?Oe(index_esm/* default.SDK_VERSION */.Z.SDK_VERSION):null,this.a=new Ii(S(this).options&&S(this).options.apiKey,Ca(Da),a);else throw new t("invalid-api-key");this.P=[];this.s=[];this.N=[];this.Pa=index_esm/* default.INTERNAL.createSubscribe */.Z.INTERNAL.createSubscribe(q(this.zc,this));this.W=void 0;this.ib=index_esm/* default.INTERNAL.createSubscribe */.Z.INTERNAL.createSubscribe(q(this.Ac,this));Gn(this,null);this.i=new vn(S(this).options.apiKey+":"+S(this).name);this.D=
new tn(S(this).options.apiKey+":"+S(this).name);this.$=T(this,Hn(this));this.h=T(this,In(this));this.ba=!1;this.ja=q(this.Zc,this);this.Ba=q(this.da,this);this.qa=q(this.mc,this);this.za=q(this.wc,this);this.Aa=q(this.xc,this);this.b=null;Jn(this);this.INTERNAL={};this.INTERNAL["delete"]=q(this.delete,this);this.INTERNAL.logFramework=q(this.Gc,this);this.u=0;H.call(this);Kn(this);this.J=[];this.R=null}r(Fn,H);function Ln(a){G.call(this,"languageCodeChanged");this.h=a}r(Ln,G);
function Mn(a){G.call(this,"emulatorConfigChanged");this.c=a}r(Mn,G);function Nn(a){G.call(this,"frameworkChanged");this.f=a}r(Nn,G);k=Fn.prototype;k.yb=function(a){a=this.i.yb(a);return T(this,a)};k.xa=function(a){this.aa===a||this.l||(this.aa=a,Oi(this.a,this.aa),this.dispatchEvent(new Ln(this.la())))};k.la=function(){return this.aa};k.fd=function(){var a=l.navigator;this.xa(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};
k.gd=function(a,b){if(!this.R){if(!/^https?:\/\//.test(a))throw new t("argument-error","Emulator URL must start with a valid scheme (http:// or https://).");b=b?!!b.disableWarnings:!1;On(b);this.R={url:a,ec:b};this.settings.jb=!0;Pi(this.a,this.R);this.dispatchEvent(new Mn(this.R))}};
function On(a){"undefined"!==typeof console&&"function"===typeof console.info&&console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");l.document&&!a&&Ee().then(function(){var b=l.document.createElement("div");b.innerText="Running in emulator mode. Do not use with production credentials.";b.style.position="fixed";b.style.width="100%";b.style.backgroundColor="#ffffff";b.style.border=".1em solid #000000";b.style.color=
"#b50000";b.style.bottom="0px";b.style.left="0px";b.style.margin="0px";b.style.zIndex=1E4;b.style.textAlign="center";b.classList.add("firebase-emulator-warning");l.document.body.appendChild(b)})}k.Gc=function(a){this.J.push(a);Ri(this.a,index_esm/* default.SDK_VERSION */.Z.SDK_VERSION?Oe(index_esm/* default.SDK_VERSION */.Z.SDK_VERSION,this.J):null);this.dispatchEvent(new Nn(this.J))};k.Ga=function(){return Za(this.J)};k.zb=function(a){this.S===a||this.l||(this.S=a,this.a.b=this.S)};k.T=function(){return this.S};
function Kn(a){Object.defineProperty(a,"lc",{get:function(){return this.la()},set:function(b){this.xa(b)},enumerable:!1});a.aa=null;Object.defineProperty(a,"ti",{get:function(){return this.T()},set:function(b){this.zb(b)},enumerable:!1});a.S=null;Object.defineProperty(a,"emulatorConfig",{get:function(){if(this.R){var b=J(this.R.url);b=kf({protocol:b.c,host:b.a,port:b.g,options:kf({disableWarnings:this.R.ec})})}else b=null;return b},enumerable:!1})}
k.toJSON=function(){return{apiKey:S(this).options.apiKey,authDomain:S(this).options.authDomain,appName:S(this).name,currentUser:U(this)&&U(this).w()}};function Pn(a){return a.Oa||F(new t("auth-domain-config-required"))}function Jn(a){var b=S(a).options.authDomain,c=S(a).options.apiKey;b&&Re()&&(a.Oa=a.$.then(function(){if(!a.l){a.b=Xl(b,c,S(a).name,a.R);Pl(a.b,a);U(a)&&Wm(U(a));if(a.m){Wm(a.m);var d=a.m;d.xa(a.la());Om(d,a);d=a.m;Nm(d,a.J);Qm(d,a);d=a.m;Mm(d,a.R);Pm(d,a);a.m=null}return a.b}}))}
k.Gb=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};k.na=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.C?this.C(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.C)};k.Fa=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?q(this.ic,this):null};
k.ic=function(a,b,c,d){var e=this,f={requestUri:a,postBody:d,sessionId:b,tenantId:c};this.c&&(this.c.cancel(),this.c=null);return e.$.then(function(){return Qn(e,Fg(e.a,f))})};
k.Xc=function(a){if(!Re())return F(new t("operation-not-supported-in-this-environment"));var b=this,c=ng(a.providerId),d=Qe(),e=null;(!Te()||Ie())&&S(this).options.authDomain&&a.isOAuthProvider&&(e=ek(S(this).options.authDomain,S(this).options.apiKey,S(this).name,"signInViaPopup",a,null,d,index_esm/* default.SDK_VERSION */.Z.SDK_VERSION||null,null,null,this.T(),this.R));var f=ze(e,c&&c.va,c&&c.ua);c=Pn(this).then(function(g){return Tl(g,f,"signInViaPopup",a,d,!!e,b.T())}).then(function(){return new D(function(g,h){b.na("signInViaPopup",
null,new t("cancelled-popup-request"),b.g);b.f=g;b.C=h;b.g=d;b.c=Vl(b.b,b,"signInViaPopup",f,d)})}).then(function(g){f&&ye(f);return g?kf(g):null}).o(function(g){f&&ye(f);throw g;});return T(this,c)};k.Yc=function(a){if(!Re())return F(new t("operation-not-supported-in-this-environment"));var b=this,c=Pn(this).then(function(){return Bn(b.i)}).then(function(){return Ul(b.b,"signInViaRedirect",a,void 0,b.T())});return T(this,c)};
function Rn(a){if(!Re())return F(new t("operation-not-supported-in-this-environment"));var b=Pn(a).then(function(){return a.b.ra()}).then(function(c){return c?kf(c):null});return T(a,b)}k.ra=function(){var a=this;return Rn(this).then(function(b){a.b&&$l(a.b.b);return b}).o(function(b){a.b&&$l(a.b.b);throw b;})};
k.dd=function(a){if(!a)return F(new t("null-user"));if(this.S!=a.tenantId)return F(new t("tenant-id-mismatch"));var b=this,c={};c.apiKey=S(this).options.apiKey;c.authDomain=S(this).options.authDomain;c.appName=S(this).name;var d=sn(a,c,b.D,b.Ga());return T(this,this.h.then(function(){if(S(b).options.apiKey!=a.l)return d.reload()}).then(function(){if(U(b)&&a.uid==U(b).uid)return cn(U(b),a),b.da(a);Gn(b,d);Wm(d);return b.da(d)}).then(function(){Sn(b)}))};
function Tn(a,b){var c={};c.apiKey=S(a).options.apiKey;c.authDomain=S(a).options.authDomain;c.appName=S(a).name;a.R&&(c.emulatorConfig=a.R);return a.$.then(function(){return rn(c,b,a.D,a.Ga())}).then(function(d){if(U(a)&&d.uid==U(a).uid)return cn(U(a),d),a.da(d);Gn(a,d);Wm(d);return a.da(d)}).then(function(){Sn(a)})}
function Gn(a,b){U(a)&&(Um(U(a),a.Ba),xd(U(a),"tokenChanged",a.qa),xd(U(a),"userDeleted",a.za),xd(U(a),"userInvalidated",a.Aa),Tm(U(a)));b&&(b.W.push(a.Ba),nd(b,"tokenChanged",a.qa),nd(b,"userDeleted",a.za),nd(b,"userInvalidated",a.Aa),0<a.u&&Sm(b));M(a,"currentUser",b);b&&(b.xa(a.la()),Om(b,a),Nm(b,a.J),Qm(b,a),Mm(b,a.R),Pm(b,a))}k.Bb=function(){var a=this,b=this.h.then(function(){a.b&&$l(a.b.b);if(!U(a))return E();Gn(a,null);return Dn(a.i).then(function(){Sn(a)})});return T(this,b)};
function Un(a){var b=un(a.D,S(a).options.authDomain).then(function(c){if(a.m=c)c.ha=a.D;return on(a.D)});return T(a,b)}function Hn(a){var b=S(a).options.authDomain,c=Un(a).then(function(){return En(a.i,b,a.R)}).then(function(d){return d?(d.ha=a.D,a.m&&(a.m.ga||null)==(d.ga||null)?d:d.reload().then(function(){return Cn(a.i,d).then(function(){return d})}).o(function(e){return"auth/network-request-failed"==e.code?d:Dn(a.i)})):null}).then(function(d){Gn(a,d||null)});return T(a,c)}
function In(a){return a.$.then(function(){return Rn(a)}).o(function(){}).then(function(){if(!a.l)return a.ja()}).o(function(){}).then(function(){if(!a.l){a.ba=!0;var b=a.i;b.b.addListener(xn("local"),b.a,a.ja)}})}
k.Zc=function(){var a=this;return En(this.i,S(this).options.authDomain).then(function(b){if(!a.l){var c;if(c=U(a)&&b){c=U(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return cn(U(a),b),U(a).I();if(U(a)||b)Gn(a,b),b&&(Wm(b),b.ha=a.D),a.b&&Pl(a.b,a),Sn(a)}})};k.da=function(a){return Cn(this.i,a)};k.mc=function(){Sn(this);this.da(U(this))};k.wc=function(){this.Bb()};k.xc=function(){this.Bb()};
function Qn(a,b){var c=null,d=null;return T(a,b.then(function(e){c=qh(e);d=og(e);return Tn(a,e)},function(e){var f=null;e&&"auth/multi-factor-auth-required"===e.code&&(f=mm(e.w(),a,q(a.kc,a)));throw f||e;}).then(function(){return kf({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}k.kc=function(a){var b=this;return this.h.then(function(){return Qn(b,E(a))})};k.zc=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};
k.Ac=function(a){var b=this;Vn(this,function(){a.next(U(b))})};k.Ic=function(a,b,c){var d=this;this.ba&&Promise.resolve().then(function(){"function"===typeof a?a(U(d)):"function"===typeof a.next&&a.next(U(d))});return this.Pa(a,b,c)};k.Hc=function(a,b,c){var d=this;this.ba&&Promise.resolve().then(function(){d.W=d.getUid();"function"===typeof a?a(U(d)):"function"===typeof a.next&&a.next(U(d))});return this.ib(a,b,c)};
k.nc=function(a){var b=this,c=this.h.then(function(){return U(b)?U(b).I(a).then(function(d){return{accessToken:d}}):null});return T(this,c)};k.Tc=function(a){var b=this;return this.h.then(function(){return Qn(b,O(b.a,Kj,{token:a}))}).then(function(c){var d=c.user;bn(d,"isAnonymous",!1);b.da(d);return c})};k.Uc=function(a,b){var c=this;return this.h.then(function(){return Qn(c,O(c.a,ah,{email:a,password:b}))})};
k.dc=function(a,b){var c=this;return this.h.then(function(){return Qn(c,O(c.a,Ej,{email:a,password:b}))})};k.ab=function(a){var b=this;return this.h.then(function(){return Qn(b,a.ka(b.a))})};k.Sc=function(a){gf("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInWithCredential instead.");return this.ab(a)};
k.Ab=function(){var a=this;return this.h.then(function(){var b=U(a);if(b&&b.isAnonymous){var c=kf({providerId:null,isNewUser:!1});return kf({user:b,credential:null,additionalUserInfo:c,operationType:"signIn"})}return Qn(a,a.a.Ab()).then(function(d){var e=d.user;bn(e,"isAnonymous",!0);a.da(e);return d})})};function S(a){return a.app}function U(a){return a.currentUser}k.getUid=function(){return U(this)&&U(this).uid||null};function Wn(a){return U(a)&&U(a)._lat||null}
function Sn(a){if(a.ba){for(var b=0;b<a.s.length;b++)if(a.s[b])a.s[b](Wn(a));if(a.W!==a.getUid()&&a.N.length)for(a.W=a.getUid(),b=0;b<a.N.length;b++)if(a.N[b])a.N[b](Wn(a))}}k.cc=function(a){this.addAuthTokenListener(a);this.u++;0<this.u&&U(this)&&Sm(U(this))};k.Pc=function(a){var b=this;w(this.s,function(c){c==a&&b.u--});0>this.u&&(this.u=0);0==this.u&&U(this)&&Tm(U(this));this.removeAuthTokenListener(a)};
k.addAuthTokenListener=function(a){var b=this;this.s.push(a);T(this,this.h.then(function(){b.l||Va(b.s,a)&&a(Wn(b))}))};k.removeAuthTokenListener=function(a){Xa(this.s,function(b){return b==a})};function Vn(a,b){a.N.push(b);T(a,a.h.then(function(){!a.l&&Va(a.N,b)&&a.W!==a.getUid()&&(a.W=a.getUid(),b(Wn(a)))}))}
k.delete=function(){this.l=!0;for(var a=0;a<this.P.length;a++)this.P[a].cancel("app-deleted");this.P=[];this.i&&(a=this.i,a.b.removeListener(xn("local"),a.a,this.ja));this.b&&(Ql(this.b,this),$l(this.b.b));return Promise.resolve()};function T(a,b){a.P.push(b);b.oa(function(){Wa(a.P,b)});return b}k.hc=function(a){return T(this,aj(this.a,a))};k.Bc=function(a){return!!fh(a)};
k.xb=function(a,b){var c=this;return T(this,E().then(function(){var d=new Sf(b);if(!d.c)throw new t("argument-error",$f+" must be true when sending sign in link to email");return bg(d)}).then(function(d){return c.a.xb(a,d)}).then(function(){}))};k.jd=function(a){return this.Sa(a).then(function(b){return b.data.email})};k.ob=function(a,b){return T(this,this.a.ob(a,b).then(function(){}))};k.Sa=function(a){return T(this,this.a.Sa(a).then(function(b){return new vf(b)}))};
k.kb=function(a){return T(this,this.a.kb(a).then(function(){}))};k.wb=function(a,b){var c=this;return T(this,E().then(function(){return"undefined"===typeof b||mb(b)?{}:bg(new Sf(b))}).then(function(d){return c.a.wb(a,d)}).then(function(){}))};k.Wc=function(a,b){return T(this,gm(this,a,b,q(this.ab,this)))};
k.Vc=function(a,b){var c=this;return T(this,E().then(function(){var d=b||re(),e=eh(a,d);d=fh(d);if(!d)throw new t("argument-error","Invalid email link!");if(d.tenantId!==c.T())throw new t("tenant-id-mismatch");return c.ab(e)}))};function Xn(){}Xn.prototype.render=function(){};Xn.prototype.reset=function(){};Xn.prototype.getResponse=function(){};Xn.prototype.execute=function(){};function Yn(){this.a={};this.b=1E12}var Zn=null;Yn.prototype.render=function(a,b){this.a[this.b.toString()]=new $n(a,b);return this.b++};Yn.prototype.reset=function(a){var b=ao(this,a);a=bo(a);b&&a&&(b.delete(),delete this.a[a])};Yn.prototype.getResponse=function(a){return(a=ao(this,a))?a.getResponse():null};Yn.prototype.execute=function(a){(a=ao(this,a))&&a.execute()};function ao(a,b){return(b=bo(b))?a.a[b]||null:null}function bo(a){return(a="undefined"===typeof a?1E12:a)?a.toString():null}
function $n(a,b){this.g=!1;this.c=b;this.a=this.b=null;this.h="invisible"!==this.c.size;this.f=kc(a);var c=this;this.i=function(){c.execute()};this.h?this.execute():nd(this.f,"click",this.i)}$n.prototype.getResponse=function(){co(this);return this.b};
$n.prototype.execute=function(){co(this);var a=this;this.a||(this.a=setTimeout(function(){a.b=Me();var b=a.c.callback,c=a.c["expired-callback"];if(b)try{b(a.b)}catch(d){}a.a=setTimeout(function(){a.a=null;a.b=null;if(c)try{c()}catch(d){}a.h&&a.execute()},6E4)},500))};$n.prototype.delete=function(){co(this);this.g=!0;clearTimeout(this.a);this.a=null;xd(this.f,"click",this.i)};function co(a){if(a.g)throw Error("reCAPTCHA mock was already deleted!");};function eo(){}M(eo,"FACTOR_ID","phone");function fo(){}fo.prototype.g=function(){Zn||(Zn=new Yn);return E(Zn)};fo.prototype.c=function(){};var go=null;function ho(){this.b=l.grecaptcha?Infinity:0;this.f=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}var io=new qb(rb,"https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"),jo=new Ze(3E4,6E4);
ho.prototype.g=function(a){var b=this;return new D(function(c,d){var e=setTimeout(function(){d(new t("network-request-failed"))},jo.get());if(!l.grecaptcha||a!==b.f&&!b.b){l[b.a]=function(){if(l.grecaptcha){b.f=a;var g=l.grecaptcha.render;l.grecaptcha.render=function(h,m){h=g(h,m);b.b++;return h};clearTimeout(e);c(l.grecaptcha)}else clearTimeout(e),d(new t("internal-error"));delete l[b.a]};var f=zb(io,{onload:b.a,hl:a||""});E(Bi(f)).o(function(){clearTimeout(e);d(new t("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else clearTimeout(e),
c(l.grecaptcha)})};ho.prototype.c=function(){this.b--};var ko=null;function lo(a,b,c,d,e,f,g){M(this,"type","recaptcha");this.c=this.f=null;this.J=!1;this.v=b;this.g=null;g?(go||(go=new fo),g=go):(ko||(ko=new ho),g=ko);this.m=g;this.a=c||{theme:"light",type:"image"};this.h=[];if(this.a[mo])throw new t("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.i="invisible"===this.a[no];if(!l.document)throw new t("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
if(!kc(b)||!this.i&&kc(b).hasChildNodes())throw new t("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.s=new Ii(a,f||null,e||null);this.u=d||function(){return null};var h=this;this.l=[];var m=this.a[oo];this.a[oo]=function(v){po(h,v);if("function"===typeof m)m(v);else if("string"===typeof m){var B=L(m,l);"function"===typeof B&&B(v)}};var p=this.a[qo];this.a[qo]=function(){po(h,null);if("function"===typeof p)p();else if("string"===typeof p){var v=
L(p,l);"function"===typeof v&&v()}}}var oo="callback",qo="expired-callback",mo="sitekey",no="size";function po(a,b){for(var c=0;c<a.l.length;c++)try{a.l[c](b)}catch(d){}}function ro(a,b){Xa(a.l,function(c){return c==b})}function so(a,b){a.h.push(b);b.oa(function(){Wa(a.h,b)});return b}k=lo.prototype;
k.Ia=function(){var a=this;return this.f?this.f:this.f=so(this,E().then(function(){if(Se()&&!Je())return Ee();throw new t("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return a.m.g(a.u())}).then(function(b){a.g=b;return O(a.s,Jj,{})}).then(function(b){a.a[mo]=b.recaptchaSiteKey}).o(function(b){a.f=null;throw b;}))};
k.render=function(){to(this);var a=this;return so(this,this.Ia().then(function(){if(null===a.c){var b=a.v;if(!a.i){var c=kc(b);b=nc("DIV");c.appendChild(b)}a.c=a.g.render(b,a.a)}return a.c}))};k.verify=function(){to(this);var a=this;return so(this,this.render().then(function(b){return new D(function(c){var d=a.g.getResponse(b);if(d)c(d);else{var e=function(f){f&&(ro(a,e),c(f))};a.l.push(e);a.i&&a.g.execute(a.c)}})}))};k.reset=function(){to(this);null!==this.c&&this.g.reset(this.c)};
function to(a){if(a.J)throw new t("internal-error","RecaptchaVerifier instance has been destroyed.");}k.clear=function(){to(this);this.J=!0;this.m.c();for(var a=0;a<this.h.length;a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.i){a=kc(this.v);for(var b;b=a.firstChild;)a.removeChild(b)}};
function uo(a,b,c){var d=!1;try{this.b=c||index_esm/* default.app */.Z.app()}catch(g){throw new t("argument-error","No firebase.app.App instance is currently initialized.");}if(this.b.options&&this.b.options.apiKey)c=this.b.options.apiKey;else throw new t("invalid-api-key");var e=this,f=null;try{f=this.b.auth().Ga()}catch(g){}try{d=this.b.auth().settings.appVerificationDisabledForTesting}catch(g){}f=index_esm/* default.SDK_VERSION */.Z.SDK_VERSION?Oe(index_esm/* default.SDK_VERSION */.Z.SDK_VERSION,f):null;lo.call(this,c,a,b,function(){try{var g=e.b.auth().la()}catch(h){g=
null}return g},f,Ca(Da),d)}r(uo,lo);function vo(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,g=0;g<b.length;g++)if(b[g].optional)f=!0;else{if(f)throw new t("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].M(c[e])&&!f){b=b[e];if(0>e||e>=wo.length)throw new t("internal-error",
"Argument validator received an unsupported number of arguments.");c=wo[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.K+".";break a}d=null}}if(d)throw new t("argument-error",a+" failed: "+d);}var wo="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",K:"a valid string",optional:!!b,M:function(c){return"string"===typeof c}}}
function xo(a,b){return{name:a||"",K:"a boolean",optional:!!b,M:function(c){return"boolean"===typeof c}}}function W(a,b){return{name:a||"",K:"a valid object",optional:!!b,M:n}}function yo(a,b){return{name:a||"",K:"a function",optional:!!b,M:function(c){return"function"===typeof c}}}function zo(a,b){return{name:a||"",K:"null",optional:!!b,M:function(c){return null===c}}}function Ao(){return{name:"",K:"an HTML element",optional:!1,M:function(a){return!!(a&&a instanceof Element)}}}
function Bo(){return{name:"auth",K:"an instance of Firebase Auth",optional:!0,M:function(a){return!!(a&&a instanceof Fn)}}}function Co(){return{name:"app",K:"an instance of Firebase App",optional:!0,M:function(a){return!!(a&&a instanceof index_esm/* default.app.App */.Z.app.App)}}}function Do(a){return{name:a?a+"Credential":"credential",K:a?"a valid "+a+" credential":"a valid credential",optional:!1,M:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.ka||!c)}}}
function Eo(){return{name:"multiFactorAssertion",K:"a valid multiFactorAssertion",optional:!1,M:function(a){return a?!!a.tb:!1}}}function Fo(){return{name:"authProvider",K:"a valid Auth provider",optional:!1,M:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function Go(a,b){return n(a)&&"string"===typeof a.type&&a.type===b&&"function"===typeof a.Ha}function Ho(a){return n(a)&&"string"===typeof a.uid}
function Io(){return{name:"applicationVerifier",K:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,M:function(a){return!(!a||"string"!==typeof a.type||"function"!==typeof a.verify)}}}function X(a,b,c,d){return{name:c||"",K:a.K+" or "+b.K,optional:!!d,M:function(e){return a.M(e)||b.M(e)}}};function Y(a,b){for(var c in b){var d=b[c].name;a[d]=Jo(d,a[c],b[c].j)}}function Ko(a,b){for(var c in b){var d=b[c].name;d!==c&&Object.defineProperty(a,d,{get:ua(function(e){return this[e]},c),set:ua(function(e,f,g,h){vo(e,[g],[h],!0);this[f]=h},d,c,b[c].lb),enumerable:!0})}}function Z(a,b,c,d){a[b]=Jo(b,c,d)}
function Jo(a,b,c){function d(){var g=Array.prototype.slice.call(arguments);vo(e,c,g);return b.apply(this,g)}if(!c)return b;var e=Lo(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function Lo(a){a=a.split(".");return a[a.length-1]};Y(Fn.prototype,{kb:{name:"applyActionCode",j:[V("code")]},Sa:{name:"checkActionCode",j:[V("code")]},ob:{name:"confirmPasswordReset",j:[V("code"),V("newPassword")]},dc:{name:"createUserWithEmailAndPassword",j:[V("email"),V("password")]},hc:{name:"fetchSignInMethodsForEmail",j:[V("email")]},ra:{name:"getRedirectResult",j:[]},Bc:{name:"isSignInWithEmailLink",j:[V("emailLink")]},Hc:{name:"onAuthStateChanged",j:[X(W(),yo(),"nextOrObserver"),yo("opt_error",!0),yo("opt_completed",!0)]},Ic:{name:"onIdTokenChanged",
j:[X(W(),yo(),"nextOrObserver"),yo("opt_error",!0),yo("opt_completed",!0)]},wb:{name:"sendPasswordResetEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),zo(null,!0),"opt_actionCodeSettings",!0)]},xb:{name:"sendSignInLinkToEmail",j:[V("email"),W("actionCodeSettings")]},yb:{name:"setPersistence",j:[V("persistence")]},Sc:{name:"signInAndRetrieveDataWithCredential",j:[Do()]},Ab:{name:"signInAnonymously",j:[]},ab:{name:"signInWithCredential",j:[Do()]},Tc:{name:"signInWithCustomToken",j:[V("token")]},
Uc:{name:"signInWithEmailAndPassword",j:[V("email"),V("password")]},Vc:{name:"signInWithEmailLink",j:[V("email"),V("emailLink",!0)]},Wc:{name:"signInWithPhoneNumber",j:[V("phoneNumber"),Io()]},Xc:{name:"signInWithPopup",j:[Fo()]},Yc:{name:"signInWithRedirect",j:[Fo()]},dd:{name:"updateCurrentUser",j:[X(function(a){return{name:"user",K:"an instance of Firebase User",optional:!!a,M:function(b){return!!(b&&b instanceof Im)}}}(),zo(),"user")]},Bb:{name:"signOut",j:[]},toJSON:{name:"toJSON",j:[V(null,
!0)]},fd:{name:"useDeviceLanguage",j:[]},gd:{name:"useEmulator",j:[V("url"),W("options",!0)]},jd:{name:"verifyPasswordResetCode",j:[V("code")]}});Ko(Fn.prototype,{lc:{name:"languageCode",lb:X(V(),zo(),"languageCode")},ti:{name:"tenantId",lb:X(V(),zo(),"tenantId")}});Fn.Persistence=Rk;Fn.Persistence.LOCAL="local";Fn.Persistence.SESSION="session";Fn.Persistence.NONE="none";
Y(Im.prototype,{"delete":{name:"delete",j:[]},oc:{name:"getIdTokenResult",j:[xo("opt_forceRefresh",!0)]},I:{name:"getIdToken",j:[xo("opt_forceRefresh",!0)]},Cc:{name:"linkAndRetrieveDataWithCredential",j:[Do()]},rb:{name:"linkWithCredential",j:[Do()]},Dc:{name:"linkWithPhoneNumber",j:[V("phoneNumber"),Io()]},Ec:{name:"linkWithPopup",j:[Fo()]},Fc:{name:"linkWithRedirect",j:[Fo()]},Lc:{name:"reauthenticateAndRetrieveDataWithCredential",j:[Do()]},ub:{name:"reauthenticateWithCredential",j:[Do()]},Mc:{name:"reauthenticateWithPhoneNumber",
j:[V("phoneNumber"),Io()]},Nc:{name:"reauthenticateWithPopup",j:[Fo()]},Oc:{name:"reauthenticateWithRedirect",j:[Fo()]},reload:{name:"reload",j:[]},vb:{name:"sendEmailVerification",j:[X(W("opt_actionCodeSettings",!0),zo(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",j:[V(null,!0)]},cd:{name:"unlink",j:[V("provider")]},Cb:{name:"updateEmail",j:[V("email")]},Db:{name:"updatePassword",j:[V("password")]},ed:{name:"updatePhoneNumber",j:[Do("phone")]},Eb:{name:"updateProfile",j:[W("profile")]},
Fb:{name:"verifyBeforeUpdateEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),zo(null,!0),"opt_actionCodeSettings",!0)]}});Y(Yn.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(Xn.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(D.prototype,{oa:{name:"finally"},o:{name:"catch"},then:{name:"then"}});
Ko(em.prototype,{appVerificationDisabled:{name:"appVerificationDisabledForTesting",lb:xo("appVerificationDisabledForTesting")}});Y(fm.prototype,{confirm:{name:"confirm",j:[V("verificationCode")]}});Z(Bg,"fromJSON",function(a){a="string"===typeof a?JSON.parse(a):a;for(var b,c=[Mg,dh,kh,Jg],d=0;d<c.length;d++)if(b=c[d](a))return b;return null},[X(V(),W(),"json")]);Z(Zg,"credential",function(a,b){return new Yg(a,b)},[V("email"),V("password")]);Y(Yg.prototype,{w:{name:"toJSON",j:[V(null,!0)]}});
Y(Qg.prototype,{Ca:{name:"addScope",j:[V("scope")]},Ka:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Qg,"credential",Rg,[X(V(),W(),"token")]);Z(Zg,"credentialWithLink",eh,[V("email"),V("emailLink")]);Y(Sg.prototype,{Ca:{name:"addScope",j:[V("scope")]},Ka:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Sg,"credential",Tg,[X(V(),W(),"token")]);Y(Ug.prototype,{Ca:{name:"addScope",j:[V("scope")]},Ka:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});
Z(Ug,"credential",Vg,[X(V(),X(W(),zo()),"idToken"),X(V(),zo(),"accessToken",!0)]);Y(Wg.prototype,{Ka:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Wg,"credential",Xg,[X(V(),W(),"token"),V("secret",!0)]);Y(Pg.prototype,{Ca:{name:"addScope",j:[V("scope")]},credential:{name:"credential",j:[X(V(),X(W(),zo()),"optionsOrIdToken"),X(V(),zo(),"accessToken",!0)]},Ka:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Y(Kg.prototype,{w:{name:"toJSON",j:[V(null,!0)]}});
Y(Eg.prototype,{w:{name:"toJSON",j:[V(null,!0)]}});Z(lh,"credential",ph,[V("verificationId"),V("verificationCode")]);
Y(lh.prototype,{gb:{name:"verifyPhoneNumber",j:[X(V(),function(a,b){return{name:a||"phoneInfoOptions",K:"valid phone info options",optional:!!b,M:function(c){return c?c.session&&c.phoneNumber?Go(c.session,zg)&&"string"===typeof c.phoneNumber:c.session&&c.multiFactorHint?Go(c.session,Ag)&&Ho(c.multiFactorHint):c.session&&c.multiFactorUid?Go(c.session,Ag)&&"string"===typeof c.multiFactorUid:c.phoneNumber?"string"===typeof c.phoneNumber:!1:!1}}}(),"phoneInfoOptions"),Io()]}});
Y(gh.prototype,{w:{name:"toJSON",j:[V(null,!0)]}});Y(t.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(yh.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(xh.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(lm.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(im.prototype,{Rc:{name:"resolveSignIn",j:[Eo()]}});
Y(tm.prototype,{Sb:{name:"getSession",j:[]},fc:{name:"enroll",j:[Eo(),V("displayName",!0)]},bd:{name:"unenroll",j:[X({name:"multiFactorInfo",K:"a valid multiFactorInfo",optional:!1,M:Ho},V(),"multiFactorInfoIdentifier")]}});Y(uo.prototype,{clear:{name:"clear",j:[]},render:{name:"render",j:[]},verify:{name:"verify",j:[]}});Z(Jf,"parseLink",Rf,[V("link")]);Z(eo,"assertion",function(a){return new rm(a)},[Do("phone")]);
(function(){if("undefined"!==typeof index_esm/* default */.Z&&index_esm/* default.INTERNAL */.Z.INTERNAL&&index_esm/* default.INTERNAL.registerComponent */.Z.INTERNAL.registerComponent){var a={ActionCodeInfo:{Operation:{EMAIL_SIGNIN:Af,PASSWORD_RESET:"PASSWORD_RESET",RECOVER_EMAIL:"RECOVER_EMAIL",REVERT_SECOND_FACTOR_ADDITION:Cf,VERIFY_AND_CHANGE_EMAIL:Bf,VERIFY_EMAIL:"VERIFY_EMAIL"}},Auth:Fn,AuthCredential:Bg,Error:t};Z(a,"EmailAuthProvider",Zg,[]);Z(a,"FacebookAuthProvider",Qg,[]);Z(a,"GithubAuthProvider",Sg,[]);Z(a,"GoogleAuthProvider",Ug,[]);Z(a,"TwitterAuthProvider",Wg,[]);
Z(a,"OAuthProvider",Pg,[V("providerId")]);Z(a,"SAMLAuthProvider",Og,[V("providerId")]);Z(a,"PhoneAuthProvider",lh,[Bo()]);Z(a,"RecaptchaVerifier",uo,[X(V(),Ao(),"recaptchaContainer"),W("recaptchaParameters",!0),Co()]);Z(a,"ActionCodeURL",Jf,[]);Z(a,"PhoneMultiFactorGenerator",eo,[]);index_esm/* default.INTERNAL.registerComponent */.Z.INTERNAL.registerComponent({name:"auth",instanceFactory:function(b){b=b.getProvider("app").getImmediate();return new Fn(b)},multipleInstances:!1,serviceProps:a,instantiationMode:"LAZY",type:"PUBLIC",onInstanceCreated:function(b){b.getProvider("auth-internal").initialize()}});
index_esm/* default.INTERNAL.registerComponent */.Z.INTERNAL.registerComponent({name:"auth-internal",instanceFactory:function(b){b=b.getProvider("auth").getImmediate();return{getUid:q(b.getUid,b),getToken:q(b.nc,b),addAuthTokenListener:q(b.cc,b),removeAuthTokenListener:q(b.Pc,b)}},multipleInstances:!1,instantiationMode:"LAZY",type:"PRIVATE"});index_esm/* default.registerVersion */.Z.registerVersion("@firebase/auth","0.16.8");index_esm/* default.INTERNAL.extendNamespace */.Z.INTERNAL.extendNamespace({User:Im})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");
})();}).apply(typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

//# sourceMappingURL=auth.esm.js.map

;// CONCATENATED MODULE: ./node_modules/firebase/auth/dist/index.esm.js

//# sourceMappingURL=index.esm.js.map

// EXTERNAL MODULE: ./api/firebase.ts + 1 modules
var firebase = __webpack_require__(54087);
// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(66564);
// EXTERNAL MODULE: ./models/User.ts + 4 modules
var User = __webpack_require__(70884);
// EXTERNAL MODULE: ./components/index.ts + 4 modules
var components = __webpack_require__(66893);
// EXTERNAL MODULE: ./enums/index.ts + 3 modules
var enums = __webpack_require__(39933);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(50744);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(60950);
// EXTERNAL MODULE: ./components/Layout/index.tsx + 12 modules
var Layout = __webpack_require__(46323);
// EXTERNAL MODULE: ./components/ProfileSkeleton/index.module.scss
var index_module = __webpack_require__(14677);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/ProfileSkeleton/index.tsx







var ProfileSkeleton = function() {
    var ref = (0,useTranslation/* default */.Z)(), t = ref.t, lang = ref.lang;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        countryCode: lang,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
            className: (index_module_default()).account,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* SkeletonTheme */.y, {
                baseColor: "#22222E",
                highlightColor: "#2D2D3A",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            paddingBottom: 100,
                            paddingTop: 148,
                            width: 770,
                            maxWidth: "100%"
                        },
                        className: "d-flex align-items-center justify-content-start ml-auto mr-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                className: "d-block",
                                style: {
                                    width: 70,
                                    height: 70,
                                    borderRadius: "100%",
                                    marginRight: 32
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                            style: {
                                                width: 220,
                                                height: 48,
                                                marginBottom: 8
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                            style: {
                                                width: 195,
                                                height: 22
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (index_module_default()).subContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("profile:subscription")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    style: {
                                        width: 240,
                                        height: 33
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                style: {
                                    marginBottom: 42
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    style: {
                                        width: 320,
                                        height: 27
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                            style: {
                                                width: "100%",
                                                height: 83
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                            style: {
                                                width: "100%",
                                                height: 83
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                            style: {
                                                width: "100%",
                                                height: 83
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (index_module_default()).forms,
                        style: {
                            paddingBottom: 80
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        onSubmit: function() {
                                            return false;
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                style: {
                                                    marginBottom: 30
                                                },
                                                children: t("profile:personal_details")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: t("profile:full_name")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                className: "d-block",
                                                style: {
                                                    width: "100%",
                                                    height: 50,
                                                    marginBottom: 12
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: t("profile:ui_language")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                className: "d-block",
                                                style: {
                                                    width: "100%",
                                                    height: 50,
                                                    marginBottom: 12
                                                }
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        onSubmit: function() {
                                            return false;
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                style: {
                                                    marginBottom: 30
                                                },
                                                children: t("profile:password_change")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: t("profile:actual_password")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                className: "d-block",
                                                style: {
                                                    width: "100%",
                                                    height: 50,
                                                    marginBottom: 12
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: t("profile:new_password")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                className: "d-block",
                                                style: {
                                                    width: "100%",
                                                    height: 50,
                                                    marginBottom: 12
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: t("profile:new_password_again")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                className: "d-block",
                                                style: {
                                                    width: "100%",
                                                    height: 50,
                                                    marginBottom: 12
                                                }
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()("col-md-12", (index_module_default()).forms),
                                    style: {
                                        marginTop: 80,
                                        paddingBottom: 80
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: t("profile:email_newsletter")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            style: {
                                                marginBottom: 40
                                            },
                                            children: t("profile:email_newsletter_text")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                            className: "d-block",
                                            style: {
                                                width: 200,
                                                height: 50,
                                                marginBottom: 12
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()("col-md-12", (index_module_default()).forms),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            style: {
                                                marginBottom: 30
                                            },
                                            children: t("profile:purchase_history")
                                        }),
                                        Array.from(Array(4).keys()).map(function(_, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    borderBottom: "1px solid rgba(255, 255, 255, .12)",
                                                    padding: "20px 0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                        className: "d-block",
                                                        style: {
                                                            width: 80,
                                                            height: 18,
                                                            marginBottom: 3
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                        className: "d-block",
                                                        style: {
                                                            width: 140,
                                                            height: 25,
                                                            marginBottom: 3
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                        className: "d-block",
                                                        style: {
                                                            width: 100,
                                                            height: 16,
                                                            marginBottom: 0
                                                        }
                                                    })
                                                ]
                                            }, i);
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (index_module_default()).forms,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        style: {
                                            fontSize: "155.55555556%",
                                            marginBottom: 30
                                        },
                                        children: t("profile:delete_account")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        style: {
                                            opacity: 0.7,
                                            marginBottom: 40
                                        },
                                        children: t("profile:delete_account_text")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        style: {
                                            width: 152,
                                            height: 50
                                        }
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./helpers/index.ts + 50 modules
var helpers = __webpack_require__(17651);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var nookies_dist = __webpack_require__(12774);
// EXTERNAL MODULE: ./context/langContext.ts
var langContext = __webpack_require__(70082);
;// CONCATENATED MODULE: ./context/authContext.tsx
















var refreshTokenTimeout;
var authContext = /*#__PURE__*/ (0,react.createContext)({
    user: null,
    setUser: null,
    signin: null,
    signout: null,
    signInWithCustomToken: null,
    isAnonymous: false,
    reloadUser: null,
    isUserLoaded: false,
    deleteUser: null,
    handleVerifyEmail: null,
    resetPassword: null,
    changePassword: null,
    resendVerificationEmail: null,
    locale: null
});
function withAuth(WrappedComponent) {
    var route = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : enums/* RouteType.DefaultRedirect */.Yt.DefaultRedirect, skeletonType = arguments.length > 2 ? arguments[2] : void 0;
    var WithAuthRedirectWrapper = function(props) {
        var router = (0,next_router.useRouter)();
        var locale = (0,langContext/* useLang */.J)().locale;
        var ref = useProvideAuth(), user = ref.user, isAnonymous = ref.isAnonymous, isUserLoaded = ref.isUserLoaded;
        var _route = route === enums/* RouteType.DefaultRedirect */.Yt.DefaultRedirect ? helpers/* Permalink.login */.xm.login(locale) : route;
        if (typeof route !== "string") {
            _route = route[locale];
        }
        if (!isUserLoaded) {
            if (skeletonType === enums/* SkeletonType.Browse */.CC.Browse) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* BrowseSkeleton */.C_, {});
            }
            if (skeletonType === enums/* SkeletonType.Profile */.CC.Profile) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileSkeleton, {});
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LoadingPage */.h2, {});
        } else if (!user && isAnonymous) {
            // trying hit secured page, but user is anonymous -> login
            router.push(_route || "/");
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LoadingPage */.h2, {});
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props));
        }
    };
    return WithAuthRedirectWrapper;
}
/**
 * Use when user only needs to see the page when not subscribed.
 *
 * @export
 * @template CP
 * @template IP
 * @param {NextPage<CP, IP>} WrappedComponent
 * @returns {NextPage<CP, IP>}
 */ function withNoSubscription(WrappedComponent) {
    var WithNoSubscriptionWrapper = function(props) {
        var router = (0,next_router.useRouter)();
        var locale = (0,langContext/* useLang */.J)().locale;
        var user = useProvideAuth().user;
        if ((user === null || user === void 0 ? void 0 : user.isSubscriber) && !(user === null || user === void 0 ? void 0 : user.needsToPay)) {
            router.push(helpers/* Permalink.root */.xm.root(user, locale));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* BrowseSkeleton */.C_, {});
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props));
        }
    };
    return WithNoSubscriptionWrapper;
}
/**
 * Force logged in user with isWeekOldWithoutSub sympt. to redirect to Choose plan page.
 *
 * @export
 * @template CP
 * @template IP
 * @param {NextPage<CP, IP>} WrappedComponent
 * @param {(string | { [index: string]: string })} [route=RouteType.ChoosePlan]
 * @param {SkeletonType} [skeletonType]
 * @return {*}  {NextPage<CP, IP>}
 */ function withForcePlanToLoggedInUnsubs(WrappedComponent) {
    var route = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : enums/* RouteType.ChoosePlan */.Yt.ChoosePlan, skeletonType = arguments.length > 2 ? arguments[2] : void 0;
    var WithPlanRedirectWrapper = function(props) {
        var router = (0,next_router.useRouter)();
        var locale = (0,langContext/* useLang */.J)().locale;
        var ref = useProvideAuth(), user = ref.user, isUserLoaded = ref.isUserLoaded;
        var _route = route;
        if (typeof route !== "string") {
            _route = route[locale];
        }
        if (!isUserLoaded) {
            if (skeletonType === enums/* SkeletonType.Browse */.CC.Browse) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* BrowseSkeleton */.C_, {});
            }
            if (skeletonType === enums/* SkeletonType.Profile */.CC.Profile) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileSkeleton, {});
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props));
        } else if (user && user.isWeekOldWithoutSub) {
            router.replace("/".concat(_route));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LoadingPage */.h2, {});
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props));
        }
    };
    return WithPlanRedirectWrapper;
}
function redirectWhenAuth(WrappedComponent) {
    var route = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : enums/* RouteType.Welcome */.Yt.Welcome;
    var WithAuthRedirectWrapper = function(props) {
        var router = (0,next_router.useRouter)();
        var locale = (0,langContext/* useLang */.J)().locale;
        var ref = useProvideAuth(), user = ref.user, isAnonymous = ref.isAnonymous, isUserLoaded = ref.isUserLoaded;
        var _route = route;
        if (typeof route !== "string") {
            _route = route[locale];
        }
        if (!isUserLoaded) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LoadingPage */.h2, {});
        } else if (!isAnonymous && user) {
            // trying hit secured page, but user is anonymous -> login
            router.push(_route || "/");
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LoadingPage */.h2, {});
        } else {
            if ((0,helpers/* isLoginRoute */.wF)(router.asPath) && user) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LoadingPage */.h2, {});
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props));
        }
    };
    return WithAuthRedirectWrapper;
}
function ProvideAuth(param) {
    var children = param.children;
    var auth = useProvideAuth();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(authContext.Provider, {
        value: (0,_object_spread/* default */.Z)({}, auth),
        children: children
    });
}
var useAuth = function() {
    return (0,react.useContext)(authContext);
};
function broadcastToken(token) {
    (0,nookies_dist.setCookie)(null, "USER", token, {
        maxAge: 30 * 24 * 60 * 60,
        path: "/"
    });
    window.dispatchEvent(new CustomEvent(enums/* Events.AuthToken */.zW.AuthToken, {
        detail: token
    }));
}
function useProvideAuth() {
    var ref = (0,react.useState)(null), user = ref[0], setUser = ref[1];
    var ref1 = (0,react.useState)(false), isAnonymous = ref1[0], setAnonymous = ref1[1];
    var ref2 = (0,react.useState)(false), isUserLoaded = ref2[0], setIsUserLoaded = ref2[1];
    var locale = function() {
        var cookies = (0,nookies_dist.parseCookies)();
        var ref;
        return (ref = user === null || user === void 0 ? void 0 : user.language) !== null && ref !== void 0 ? ref : cookies.NEXT_LOCALE;
    }();
    var setUserAndToken = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(user) {
            var idToken, cookies, userResult, userModel, _language;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsUserLoaded(false);
                        _ctx.next = 3;
                        return user.getIdToken();
                    case 3:
                        idToken = _ctx.sent;
                        broadcastToken(idToken);
                        if (!idToken) {
                            _ctx.next = 17;
                            break;
                        }
                        cookies = (0,nookies_dist.parseCookies)();
                        _ctx.next = 9;
                        return (0,client/* getSharedApiClient */.L)().getUser();
                    case 9:
                        userResult = _ctx.sent;
                        userModel = User/* default.fromJSON */.Z.fromJSON(userResult);
                        setUser(userModel);
                        setAnonymous(false);
                        ;
                        (0,helpers/* forceLanguage */.MI)((_language = userModel.language) !== null && _language !== void 0 ? _language : cookies.NEXT_LOCALE);
                        setIsUserLoaded(true);
                        return _ctx.abrupt("return", userModel);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function setUserAndToken(user) {
            return _ref.apply(this, arguments);
        };
    }();
    var signin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(email, password) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", firebase/* firebaseApp.auth */.H.auth().signInWithEmailAndPassword(email, password).then(function(param) {
                            var user = param.user;
                            if (user && user.emailVerified) {
                                setUserAndToken(user);
                                setAnonymous(false);
                            }
                            return user;
                        }));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function signin(email, password) {
            return _ref.apply(this, arguments);
        };
    }();
    var signInWithCustomToken = function(customToken) {
        return firebase/* firebaseApp.auth */.H.auth().signInWithCustomToken(customToken).then(function(userCredential) {
            if (userCredential.user.emailVerified) {
                setUserAndToken(userCredential.user);
                setAnonymous(false);
            }
            return true;
        }).catch(function() {
            return false;
        });
    };
    var signout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", firebase/* firebaseApp.auth */.H.auth().signOut().then(function() {
                            setUser(null);
                            broadcastToken(null);
                            setAnonymous(true);
                        }));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function signout() {
            return _ref.apply(this, arguments);
        };
    }();
    var reloadUser = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var currentUser;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!firebase/* firebaseApp.auth */.H.auth().currentUser) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 3;
                        return firebase/* firebaseApp.auth */.H.auth().currentUser.reload();
                    case 3:
                        currentUser = firebase/* firebaseApp.auth */.H.auth().currentUser;
                        if (!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.emailVerified)) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 7;
                        return setUserAndToken(currentUser);
                    case 7:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function reloadUser() {
            return _ref.apply(this, arguments);
        };
    }();
    var changePassword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(currentPassword, newPassword) {
            var signIn;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return firebase/* firebaseApp.auth */.H.auth().signInWithEmailAndPassword(user.email, currentPassword);
                    case 3:
                        signIn = _ctx.sent;
                        if (!(signIn === null || signIn === void 0 ? void 0 : signIn.user)) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 7;
                        return signIn.user.updatePassword(newPassword);
                    case 7:
                        return _ctx.abrupt("return", true);
                    case 8:
                        return _ctx.abrupt("return", false);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", false);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }));
        return function changePassword(currentPassword, newPassword) {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * TODO: use dramox backend version
   */ var resendVerificationEmail = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, currentUser;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        currentUser = (ref = firebase/* firebaseApp.auth */.H.auth()) === null || ref === void 0 ? void 0 : ref.currentUser;
                        _ctx.next = 5;
                        return currentUser === null || currentUser === void 0 ? void 0 : currentUser.sendEmailVerification();
                    case 5:
                        return _ctx.abrupt("return", true);
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", false);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function resendVerificationEmail() {
            return _ref.apply(this, arguments);
        };
    }();
    var resetPassword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(actionCode, password) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", firebase/* firebaseApp.auth */.H.auth().verifyPasswordResetCode(actionCode).then(function(email) {
                            firebase/* firebaseApp.auth */.H.auth().confirmPasswordReset(actionCode, password).then(function() {
                                firebase/* firebaseApp.auth */.H.auth().signInWithEmailAndPassword(email, password).then(function(userCredential) {
                                    if (userCredential.user.emailVerified) {
                                        setUserAndToken(userCredential.user);
                                        setAnonymous(false);
                                    }
                                    return Promise.resolve();
                                });
                            });
                        }).catch(function() {
                            return Promise.reject();
                        }));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function resetPassword(actionCode, password) {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteUser = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return firebase/* firebaseApp.auth */.H.auth().currentUser.delete();
                    case 2:
                        (0,nookies_dist.destroyCookie)(null, "USER", {
                            path: "/"
                        });
                        setAnonymous(true);
                        setUser(null);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteUser() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleVerifyEmail = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(actionCode) {
            var unsub;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return firebase/* firebaseApp.auth */.H.auth().applyActionCode(actionCode);
                    case 3:
                        unsub = firebase/* firebaseApp.auth */.H.auth().onAuthStateChanged(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(user) {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            if (!user) {
                                                _ctx.next = 4;
                                                break;
                                            }
                                            _ctx.next = 3;
                                            return setUserAndToken(user);
                                        case 3:
                                            setAnonymous(false);
                                        case 4:
                                            unsub();
                                            return _ctx.abrupt("return", Promise.resolve());
                                        case 6:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(user) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return function handleVerifyEmail(actionCode) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var unsubscribe = firebase/* firebaseApp.auth */.H.auth().onAuthStateChanged(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(user) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(user && user.emailVerified)) {
                                _ctx.next = 5;
                                break;
                            }
                            _ctx.next = 3;
                            return setUserAndToken(user);
                        case 3:
                            _ctx.next = 6;
                            break;
                        case 5:
                            {
                                setUser(null);
                                setAnonymous(true);
                                setIsUserLoaded(true);
                            }
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(user) {
                return _ref.apply(this, arguments);
            };
        }());
        // Cleanup subscription on unmount
        return function() {
            return unsubscribe();
        };
    }, []);
    var refreshToken = function() {
        if (firebase/* firebaseApp.auth */.H.auth().currentUser) {
            firebase/* firebaseApp.auth */.H.auth().currentUser.getIdToken(true).then(broadcastToken);
        }
    };
    (0,react.useEffect)(function() {
        window.clearInterval(refreshTokenTimeout);
        // silently update id token each 20 minutes
        if (user) {
            refreshTokenTimeout = window.setInterval(refreshToken, 20 * 60 * 1000);
            document.onvisibilitychange = function() {
                if (!document.hidden) {
                    refreshToken();
                }
            };
            window.onfocus = function() {
                refreshToken();
            };
        }
    }, [
        user
    ]);
    // Return the user object and auth methods
    return {
        deleteUser: deleteUser,
        isUserLoaded: isUserLoaded,
        isAnonymous: isAnonymous,
        reloadUser: reloadUser,
        user: user,
        setUser: setUser,
        signin: signin,
        signout: signout,
        signInWithCustomToken: signInWithCustomToken,
        handleVerifyEmail: handleVerifyEmail,
        resetPassword: resetPassword,
        changePassword: changePassword,
        resendVerificationEmail: resendVerificationEmail,
        locale: locale
    };
}


/***/ }),

/***/ 52662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uj": function() { return /* reexport */ NotificationProvider; },
  "Yo": function() { return /* reexport */ authContext/* ProvideAuth */.Yo; },
  "Sc": function() { return /* reexport */ popupContext/* ProvidePopup */.Sc; },
  "aC": function() { return /* reexport */ authContext/* useAuth */.aC; },
  "nw": function() { return /* reexport */ useNotificationContext; },
  "eL": function() { return /* reexport */ useNotificationQueue; },
  "BF": function() { return /* reexport */ popupContext/* usePopup */.BF; },
  "DE": function() { return /* reexport */ authContext/* withForcePlanToLoggedInUnsubs */.DE; }
});

// UNUSED EXPORTS: ProvideStripe, popupContext, redirectWhenAuth, useProvidePopup, useStripeCtx, withAuth, withNoSubscription

// EXTERNAL MODULE: ./context/authContext.tsx + 3 modules
var authContext = __webpack_require__(13102);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
;// CONCATENATED MODULE: ./node_modules/react-notification-provider/dist/react-notification-provider.esm.js


/**
 * This hook lets you create a notification queue that can be manipulated. It accepts a notification type that describes
 * the shape of every notification that is allowed to be emitted. This doesn't provide any UI for the notifications.
 * This is left up to the end user to implement.
 *
 * This means you'll need to create your own NotificationProvider to create the queue, render the notifications, and
 * provide the queue API to your components so they can add notifications.
 *
 *      interface Data {
 *        message: string;
 *      }
 *
 *      function MyNotificationProvider() {
 *        const queue = useQueue<Data>();
 *
 *        return (
 *          queue.list.map(item => {
 *            return <div>{item.message}</div>
 *          })
 *        )
 *      }
 */

function useQueue(initialValue) {
  var _useState = (0,react.useState)(initialValue),
      entries = _useState[0].entries,
      setQueue = _useState[1];
  /**
   * Add a new notification to the queue. If the ID already exists it will updated.
   * @param id Unique string identifier for notification.
   * @param data
   */


  var add = (0,react.useCallback)(function (id, data) {
    setQueue(function (queue) {
      return queue.add(id, data);
    });
  }, [setQueue]);
  /**
   * Remove a notification by ID
   * @param id Unique string identifier for a notification
   */

  var remove = (0,react.useCallback)(function (id) {
    setQueue(function (queue) {
      return queue.remove(id);
    });
  }, [setQueue]);
  /**
   * Remove all notifications from the page.
   */

  var removeAll = (0,react.useCallback)(function () {
    setQueue(function (queue) {
      return queue.removeAll();
    });
  }, [setQueue]);
  return (0,react.useMemo)(function () {
    return {
      add: add,
      remove: remove,
      removeAll: removeAll,
      entries: entries
    };
  }, [add, remove, removeAll, entries]);
}
/**
 * Create an immutable queue. Adding and removing items will return a new queue.
 */

function createImmutableQueue(entries) {
  if (entries === void 0) {
    entries = [];
  }

  return {
    add: function add(id, data) {
      var matchIndex = entries.findIndex(function (n) {
        return n.id === id;
      });
      var copy = entries.slice();

      if (matchIndex > -1) {
        copy.splice(matchIndex, 1, {
          id: id,
          data: data
        });
      } else {
        copy.push({
          id: id,
          data: data
        });
      }

      return createImmutableQueue(copy);
    },
    remove: function remove(id) {
      return createImmutableQueue(entries.filter(function (n) {
        return n.id !== id;
      }));
    },
    removeAll: function removeAll() {
      return createImmutableQueue();
    },
    entries: entries
  };
}
/**
 * Create a mutable queue. Adding and removing items will return the same queue.
 */

function createMockImmutableQueue(initialValue) {
  if (initialValue === void 0) {
    initialValue = [];
  }

  var entries = initialValue;

  var updateEntries = function updateEntries(queue) {
    entries.splice(0, entries.length);
    entries.push.apply(entries, queue.entries);
  };

  return {
    add: function add(id, data) {
      var queue = createImmutableQueue(entries).add(id, data);
      updateEntries(queue);
      return this;
    },
    remove: function remove(id) {
      var queue = createImmutableQueue(entries).remove(id);
      updateEntries(queue);
      return this;
    },
    removeAll: function removeAll() {
      var queue = createImmutableQueue(entries).removeAll();
      updateEntries(queue);
      return this;
    },
    entries: entries
  };
}
/**
 * Create a React context and hook for accessing it typed to your notification shape.
 *
 *      const { NotificationQueueProvider, useNotifications } = createNotificationContext<Notification>();
 *
 * This allows you to skip some of the ceremony needed to setup your own notification renderer.
 */

function createNotificationContext() {
  var NotificationQueueContext = (0,react.createContext)(null);
  /**
   * This hook allows you to add and remove notifications from within your components.
   */

  function useNotificationQueue() {
    var queue = (0,react.useContext)(NotificationQueueContext);

    if (!queue) {
      throw new Error('Missing <NotificationProvider>');
    }

    return queue;
  }
  /**
   * This component should wrap your app. It allows components to use the useNotifications hook.
   * @param props
   */


  function NotificationProvider(props) {
    var children = props.children,
        initialQueue = props.queue;
    var queue = useQueue(initialQueue ? initialQueue : createImmutableQueue());
    return react.createElement(NotificationQueueContext.Provider, {
      value: queue
    }, children);
  }
  /**
   * Create a fake notification queue that can be used during tests and stories. Unlike the normal queue this one isn't
   * immutable, so you'll be able to inspect the state of the queue between renders:
   *
   *      const queue = createMockNotificationQueue();
   *
   *      const { findByText } = render(
   *        <MockNotificationQueueProvider queue={queue}>
   *          <MyComponent />
   *        </MockNotificationQueueProvider>
   *      );
   *
   *      const el = await findByText('Submit');
   *
   *      act(() => {
   *        fireEvent.click(el);
   *      })
   *
   *      expect(queue.list.length).toBe(1);
   *      expect(queue.list[0]).toEqual({ id: 'submitting', data: { message: 'Submitting...' } });
   *
   * This will let you test that notifications are correctly firing without needing to look for elements in the DOM.
   */


  function createNotificationQueue() {
    return createImmutableQueue();
  }

  function createMockNotificationQueue() {
    return createMockImmutableQueue();
  }

  return {
    NotificationQueueContext: NotificationQueueContext,
    NotificationProvider: NotificationProvider,
    useNotificationQueue: useNotificationQueue,
    createNotificationQueue: createNotificationQueue,
    createMockNotificationQueue: createMockNotificationQueue
  };
}


//# sourceMappingURL=react-notification-provider.esm.js.map

// EXTERNAL MODULE: ./node_modules/uuid/index.js
var uuid = __webpack_require__(46513);
;// CONCATENATED MODULE: ./context/notificationContext.ts


// This function creates a React context and hooks for you so you'll want to export these.
var ref = createNotificationContext(), NotificationProvider = ref.NotificationProvider, useNotificationQueue = ref.useNotificationQueue;

/**
 * Shorthand use of useNotificationQueue
 * provides uuid for the useNotificationQueue.add() function.
 */ var useNotificationContext = function() {
    var ref = useNotificationQueue(), add = ref.add, removeAll = ref.removeAll;
    var createNotification = function(data) {
        removeAll();
        add((0,uuid.v4)(), data);
    };
    return {
        createNotification: createNotification
    };
};

// EXTERNAL MODULE: ./context/popupContext.tsx
var popupContext = __webpack_require__(30785);
// EXTERNAL MODULE: ./context/stripeContext.tsx + 1 modules
var stripeContext = __webpack_require__(16096);
;// CONCATENATED MODULE: ./context/index.ts






/***/ }),

/***/ 70082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useLang; },
/* harmony export */   "k": function() { return /* binding */ useLocalisedError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2746);
/* harmony import */ var enums__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39933);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17651);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62044);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12774);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57919);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_i18n__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _authContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13102);







var useLang = function() {
    var user = (0,_authContext__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .aC)().user;
    var lang = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().lang;
    var cookies = (0,nookies__WEBPACK_IMPORTED_MODULE_3__.parseCookies)();
    var locale;
    if (!helpers__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(window.location.pathname.split("/"), 2), _locale = ref[1];
        if (_i18n__WEBPACK_IMPORTED_MODULE_4__.locales.indexOf(_locale) > -1) {
            locale = _locale;
        }
    }
    var ref1, ref2;
    locale = (ref2 = (ref1 = locale !== null && locale !== void 0 ? locale : user === null || user === void 0 ? void 0 : user.language) !== null && ref1 !== void 0 ? ref1 : cookies.NEXT_LOCALE) !== null && ref2 !== void 0 ? ref2 : !helpers__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk ? (0,helpers__WEBPACK_IMPORTED_MODULE_1__/* .getLocaleFromUrl */ .GB)(window.location.pathname) : lang;
    return {
        locale: locale
    };
};
var useLocalisedError = function() {
    var localisedError = function localisedError(errorCode) {
        switch(errorCode){
            case enums__WEBPACK_IMPORTED_MODULE_0__/* .AppApiError.CodeNoLongerValid */ .ub.CodeNoLongerValid:
                return t("choose-plan:error_code_no_longer_valid");
            case enums__WEBPACK_IMPORTED_MODULE_0__/* .AppApiError.CodeDoesNotExist */ .ub.CodeDoesNotExist:
                return t("choose-plan:code_not_exists");
            case enums__WEBPACK_IMPORTED_MODULE_0__/* .AppApiError.DiscountAlreadyUsed */ .ub.DiscountAlreadyUsed:
                return t("choose-plan:error_code_discount_already_used");
            case enums__WEBPACK_IMPORTED_MODULE_0__/* .AppApiError.OtherDiscountIsActive */ .ub.OtherDiscountIsActive:
                return t("choose-plan:error_discount_already_active");
            case enums__WEBPACK_IMPORTED_MODULE_0__/* .AppApiError.PromoReferralNotAllowed */ .ub.PromoReferralNotAllowed:
                return t("choose-plan:error_promo_referral_not_allowed");
            case enums__WEBPACK_IMPORTED_MODULE_0__/* .AppApiError.PromoAlreadyUsed */ .ub.PromoAlreadyUsed:
                return t("choose-plan:error_promo_already_used");
            case enums__WEBPACK_IMPORTED_MODULE_0__/* .AppApiError.PromoNotAllowed */ .ub.PromoNotAllowed:
                return t("choose-plan:error_promo_not_allowed");
            case enums__WEBPACK_IMPORTED_MODULE_0__/* .AppApiError.VoucherAlreadyUsed */ .ub.VoucherAlreadyUsed:
                return t("choose-plan:error_promo_voucher_already_used");
            case enums__WEBPACK_IMPORTED_MODULE_0__/* .AppApiError.VoucherExpired */ .ub.VoucherExpired:
                return t("choose-plan:error_voucher_expired");
            case enums__WEBPACK_IMPORTED_MODULE_0__/* .AppApiError.VoucherDoesNotExist */ .ub.VoucherDoesNotExist:
                return t("choose-plan:code_not_exists");
            default:
                return null;
        }
    };
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().t;
    return {
        localisedError: localisedError
    };
};


/***/ }),

/***/ 30785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ usePopup; },
/* harmony export */   "Sc": function() { return /* binding */ ProvidePopup; },
/* harmony export */   "cy": function() { return /* binding */ popupContext; }
/* harmony export */ });
/* unused harmony export useProvidePopup */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5447);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99728);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56168);





var popupContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    popupType: null,
    onClose: null,
    t: null,
    setPopupConfig: null,
    setPopup: null,
    data: null
});
function usePopup() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(popupContext);
}
function useProvidePopup() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), popup = ref[0], setPopupConfig = ref[1];
    var setPopup = function(popupType) {
        setPopupConfig({
            popupType: popupType
        });
    };
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, popup), {
        setPopupConfig: setPopupConfig,
        setPopup: setPopup
    });
}
function ProvidePopup(param) {
    var children = param.children;
    var popup = useProvidePopup();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(popupContext.Provider, {
        value: popup,
        children: children
    });
}


/***/ }),

/***/ 16096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ ProvideStripe; },
  "o": function() { return /* binding */ useStripeCtx; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(43692);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5447);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(44453);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
;// CONCATENATED MODULE: ./node_modules/@stripe/stripe-js/dist/stripe.esm.js
var V3_URL = 'https://js.stripe.com/v3';
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var findScript = function findScript() {
  var scripts = document.querySelectorAll("script[src^=\"".concat(V3_URL, "\"]"));

  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];

    if (!V3_URL_REGEX.test(script.src)) {
      continue;
    }

    return script;
  }

  return null;
};

var injectScript = function injectScript(params) {
  var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
  var script = document.createElement('script');
  script.src = "".concat(V3_URL).concat(queryString);
  var headOrBody = document.head || document.body;

  if (!headOrBody) {
    throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
  }

  headOrBody.appendChild(script);
  return script;
};

var registerWrapper = function registerWrapper(stripe, startTime) {
  if (!stripe || !stripe._registerWrapper) {
    return;
  }

  stripe._registerWrapper({
    name: 'stripe-js',
    version: "1.30.0",
    startTime: startTime
  });
};

var stripePromise = null;
var loadScript = function loadScript(params) {
  // Ensure that we only attempt to load Stripe.js at most once
  if (stripePromise !== null) {
    return stripePromise;
  }

  stripePromise = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined') {
      // Resolve to null when imported server side. This makes the module
      // safe to import in an isomorphic code base.
      resolve(null);
      return;
    }

    if (window.Stripe && params) {
      console.warn(EXISTING_SCRIPT_MESSAGE);
    }

    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }

    try {
      var script = findScript();

      if (script && params) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
      } else if (!script) {
        script = injectScript(params);
      }

      script.addEventListener('load', function () {
        if (window.Stripe) {
          resolve(window.Stripe);
        } else {
          reject(new Error('Stripe.js not available'));
        }
      });
      script.addEventListener('error', function () {
        reject(new Error('Failed to load Stripe.js'));
      });
    } catch (error) {
      reject(error);
      return;
    }
  });
  return stripePromise;
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
  if (maybeStripe === null) {
    return null;
  }

  var stripe = maybeStripe.apply(undefined, args);
  registerWrapper(stripe, startTime);
  return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

// own script injection.

var stripePromise$1 = Promise.resolve().then(function () {
  return loadScript(null);
});
var loadCalled = false;
stripePromise$1["catch"](function (err) {
  if (!loadCalled) {
    console.warn(err);
  }
});
var loadStripe = function loadStripe() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  loadCalled = true;
  var startTime = Date.now();
  return stripePromise$1.then(function (maybeStripe) {
    return initStripe(maybeStripe, args, startTime);
  });
};



// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
;// CONCATENATED MODULE: ./context/stripeContext.tsx







var stripeContext = /*#__PURE__*/ (0,react.createContext)({
    stripe: null,
    createPaymentMethod: null,
    // redirectToCheckout: null,
    confirmCardPayment: null,
    cardHasError: true,
    stripeCard: null,
    stripeError: null,
    setElementsLoaded: null,
    confirmCardSetup: null,
    disableCardInput: null,
    enableCardInput: null
});
var useStripeCtx = function() {
    return (0,react.useContext)(stripeContext);
};
function ProvideStripe(WrappedComponent) {
    var WithAuthRedirectWrapper = function(props) {
        var stripeCtx = useStripeProvider();
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(stripeContext.Provider, {
            value: stripeCtx,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props))
        });
    };
    return WithAuthRedirectWrapper;
}
function useStripeProvider() {
    var ref = (0,react.useState)(), stripe = ref[0], setStripe = ref[1];
    var lang = (0,useTranslation/* default */.Z)().lang;
    var card = (0,react.useRef)();
    var ref1 = (0,react.useState)(true), cardHasError = ref1[0], setCardHasError = ref1[1];
    var ref2 = (0,react.useState)(false), elementsLoaded = ref2[0], setElementsLoaded = ref2[1];
    var ref3 = (0,react.useState)(null), cardElement = ref3[0], setCardElement = ref3[1];
    var stripeCard = (0,react.useRef)(null);
    var stripeError = (0,react.useRef)(null);
    // init stripe after "render"
    (0,react.useEffect)(function() {
        var initStripe = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var _stripe;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return loadStripe("pk_live_51HS1JIBQnQ2CfwQIuEEgL8upWDuFRkQgMPdZ66zyMCvsaWaHpivo1s5kfVb1azV3HczQTo9vseEep3bkmVkvo2Yp0053qJ0WfH", {
                                locale: lang
                            });
                        case 3:
                            _stripe = _ctx.sent;
                            setStripe(_stripe);
                            _ctx.next = 10;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            console.warn("Failed to load stripe instance");
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }));
            return function initStripe() {
                return _ref.apply(this, arguments);
            };
        }();
        initStripe();
    }, []);
    (0,react.useEffect)(function() {
        var load = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var elements, style, cardElement, clsFocus, clsError;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            elements = stripe.elements();
                            style = {
                                base: {
                                    iconColor: "white",
                                    color: "white",
                                    fontSmoothing: "antialiased",
                                    fontSize: "18px",
                                    "::placeholder": {
                                        color: "rgba(white, .7)"
                                    }
                                },
                                invalid: {
                                    color: "#ffab2e",
                                    iconColor: "#ffab2e"
                                }
                            };
                            cardElement = elements.create("card", {
                                style: style
                            });
                            // Add an instance of the card Element into the <div>.
                            if (stripeCard.current) {
                                cardElement.mount(stripeCard.current);
                                clsFocus = "focus";
                                clsError = "error";
                                cardElement.on("focus", function() {
                                    stripeCard.current.classList.add(clsFocus);
                                });
                                cardElement.on("blur", function() {
                                    stripeCard.current.classList.remove(clsFocus);
                                });
                                // Handle real-time validation errors from the card Element.
                                cardElement.on("change", function(event) {
                                    // console.log('event.error ', event.error);
                                    if (event.error) {
                                        stripeCard.current.classList.add(clsError);
                                        stripeError.current.textContent = event.error.message;
                                    } else {
                                        stripeCard.current.classList.remove(clsError);
                                    }
                                    setCardHasError(!!event.error);
                                });
                                card.current = cardElement;
                                setCardElement(cardElement);
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function load() {
                return _ref.apply(this, arguments);
            };
        }();
        if (stripeCard.current !== null) {
            try {
                if (stripe) {
                    load();
                }
            } catch (e) {
                console.log("loading stripe ...", e);
            }
        }
        return function() {
            setElementsLoaded(false);
        };
    }, [
        elementsLoaded,
        stripe
    ]);
    var createPaymentMethod = function() {
        return stripe.createPaymentMethod({
            type: "card",
            card: card.current
        });
    };
    var confirmCardPayment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(client_secret, name, paymentMethod) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", stripe.confirmCardPayment(client_secret, {
                            payment_method: (card === null || card === void 0 ? void 0 : card.current) ? {
                                card: card.current,
                                billing_details: {
                                    name: name
                                }
                            } : paymentMethod
                        }));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function confirmCardPayment(client_secret, name, paymentMethod) {
            return _ref.apply(this, arguments);
        };
    }();
    var confirmCardSetup = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(clientSecret, name) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", stripe.confirmCardSetup(clientSecret, {
                            payment_method: {
                                card: card.current,
                                billing_details: {
                                    name: name
                                }
                            }
                        }));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function confirmCardSetup(clientSecret, name) {
            return _ref.apply(this, arguments);
        };
    }();
    // const redirectToCheckout = async (sessionId: string) => stripe.redirectToCheckout({ sessionId });
    var enableCardInput = (0,react.useCallback)(function() {
        cardElement === null || cardElement === void 0 ? void 0 : cardElement.update({
            disabled: false
        });
    }, [
        cardElement
    ]);
    var disableCardInput = (0,react.useCallback)(function() {
        cardElement === null || cardElement === void 0 ? void 0 : cardElement.update({
            disabled: true
        });
    }, [
        cardElement
    ]);
    return {
        stripe: stripe,
        setElementsLoaded: setElementsLoaded,
        createPaymentMethod: createPaymentMethod,
        confirmCardPayment: confirmCardPayment,
        // redirectToCheckout,
        cardHasError: cardHasError,
        stripeCard: stripeCard,
        stripeError: stripeError,
        confirmCardSetup: confirmCardSetup,
        enableCardInput: enableCardInput,
        disableCardInput: disableCardInput
    };
}


/***/ }),

/***/ 10129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ BuyType; },
/* harmony export */   "e": function() { return /* binding */ CardType; }
/* harmony export */ });
var BuyType;
(function(BuyType) {
    BuyType["Voucher"] = "voucher";
    BuyType["Card"] = "card";
})(BuyType || (BuyType = {}));
var CardType;
(function(CardType) {
    CardType["NewCard"] = "new-card";
})(CardType || (CardType = {}));


/***/ }),

/***/ 72473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ Country; }
/* harmony export */ });
var Country;
(function(Country) {
    Country["Slovakia"] = "sk";
    Country["Czechia"] = "cz";
    Country["Ukraine"] = "ua";
    Country["Poland"] = "pl";
    Country["World"] = "en";
})(Country || (Country = {}));


/***/ }),

/***/ 49590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ DRMLicenseType; },
/* harmony export */   "X": function() { return /* binding */ DRMLicenseKey; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42299);

var DRMLicenseType;
(function(DRMLicenseType) {
    DRMLicenseType[DRMLicenseType["Widevine"] = 1] = "Widevine";
    DRMLicenseType[DRMLicenseType["FairPlay"] = 2] = "FairPlay";
    DRMLicenseType[DRMLicenseType["PlayReady"] = 3] = "PlayReady";
})(DRMLicenseType || (DRMLicenseType = {}));
var _obj;
var DRMLicenseKey = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, DRMLicenseType.Widevine, "com.widevine.alpha"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, DRMLicenseType.PlayReady, "com.microsoft.playready"), _obj);


/***/ }),

/***/ 10367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ LoginErrorType; },
/* harmony export */   "u": function() { return /* binding */ AppApiError; }
/* harmony export */ });
var AppApiError;
(function(AppApiError) {
    AppApiError["PatchUserError"] = "PatchUserError";
    AppApiError["RedeemVoucherError"] = "RedeemVoucherError";
    AppApiError["SubscriptionPaymentError"] = "SubscriptionPaymentError";
    AppApiError["DonationError"] = "DonationError";
    AppApiError["VoucherPaymentError"] = "VoucherPaymentError";
    AppApiError["PaymentNeeded"] = "PaymentNeeded";
    AppApiError["AddCard"] = "AddCard";
    AppApiError["UserError"] = "UserError";
    AppApiError["QueryParamsMissing"] = "QueryParamMissing";
    AppApiError["AuthInvalid"] = "AuthInvalid";
    AppApiError["CodeNoLongerValid"] = "CODE_NO_LONGER_VALID";
    AppApiError["CodeDoesNotExist"] = "CODE_DOES_NOT_EXIST";
    AppApiError["DiscountAlreadyUsed"] = "DISCOUNT_ALREADY_USED";
    AppApiError["OtherDiscountIsActive"] = "DISCOUNT_ACTIVE";
    AppApiError["PromoReferralNotAllowed"] = "PROMO_REFERRAL_NOT_ALLOWED";
    AppApiError["PromoAlreadyUsed"] = "PROMO_ALREADY_USED";
    AppApiError["PromoNotAllowed"] = "PROMO_NOT_ALLOWED";
    AppApiError["VoucherAlreadyUsed"] = "VOUCHER_ALREADY_USED";
    AppApiError["VoucherExpired"] = "VOUCHER_EXPIRED";
    AppApiError["VoucherDoesNotExist"] = "VOUCHER_DOES_NOT_EXIST";
})(AppApiError || (AppApiError = {}));
var LoginErrorType;
(function(LoginErrorType) {
    LoginErrorType["WrongPassword"] = "auth/wrong-password";
    LoginErrorType["UserNotFound"] = "auth/user-not-found";
})(LoginErrorType || (LoginErrorType = {}));


/***/ }),

/***/ 39933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ub": function() { return /* reexport */ errors/* AppApiError */.u; },
  "D": function() { return /* reexport */ buyType/* BuyType */.D; },
  "eT": function() { return /* reexport */ buyType/* CardType */.e; },
  "B4": function() { return /* reexport */ CookiesType; },
  "zW": function() { return /* reexport */ Events; },
  "lS": function() { return /* reexport */ namespaces/* Namespace */.l; },
  "eX": function() { return /* reexport */ playlistType/* PlaylistType */.e; },
  "kQ": function() { return /* reexport */ popupType/* PopupType */.k; },
  "xL": function() { return /* reexport */ planQueryType/* QueryType */.x; },
  "Yt": function() { return /* reexport */ routeType/* RouteType */.Y; },
  "CC": function() { return /* reexport */ SkeletonType; },
  "BU": function() { return /* reexport */ storageKeys/* StorageKeys */.B; }
});

// UNUSED EXPORTS: DRMLicenseKey, DRMLicenseType, LoginErrorType

// EXTERNAL MODULE: ./enums/buyType.ts
var buyType = __webpack_require__(10129);
;// CONCATENATED MODULE: ./enums/cookies.ts
var CookiesType;
(function(CookiesType) {
    CookiesType["Auth"] = "auth";
    CookiesType["RefreshToken"] = "refreshToken";
    CookiesType["AllowAnalytics"] = "ALLOW_GDPR";
})(CookiesType || (CookiesType = {}));

// EXTERNAL MODULE: ./enums/drm.ts
var drm = __webpack_require__(49590);
// EXTERNAL MODULE: ./enums/errors.ts
var errors = __webpack_require__(10367);
;// CONCATENATED MODULE: ./enums/events.ts
var Events;
(function(Events) {
    Events["AuthToken"] = "authToken";
    Events["Language"] = "language";
})(Events || (Events = {}));

// EXTERNAL MODULE: ./enums/namespaces.ts
var namespaces = __webpack_require__(99731);
// EXTERNAL MODULE: ./enums/planQueryType.ts
var planQueryType = __webpack_require__(70375);
// EXTERNAL MODULE: ./enums/playlistType.ts
var playlistType = __webpack_require__(54071);
// EXTERNAL MODULE: ./enums/popupType.ts
var popupType = __webpack_require__(91360);
// EXTERNAL MODULE: ./enums/routeType.js
var routeType = __webpack_require__(33973);
;// CONCATENATED MODULE: ./enums/skeletonType.ts
var SkeletonType;
(function(SkeletonType) {
    SkeletonType[SkeletonType["Browse"] = 1] = "Browse";
    SkeletonType[SkeletonType["Profile"] = 2] = "Profile";
})(SkeletonType || (SkeletonType = {}));

// EXTERNAL MODULE: ./enums/storageKeys.ts
var storageKeys = __webpack_require__(52294);
;// CONCATENATED MODULE: ./enums/index.ts














/***/ }),

/***/ 99731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Namespace; }
/* harmony export */ });
var Namespace;
(function(Namespace) {
    Namespace["Common"] = "common";
    Namespace["PlayDetail"] = "play-detail";
    Namespace["Theaters"] = "theaters";
    Namespace["Celebrities"] = "celebrities";
    Namespace["Login"] = "login";
    Namespace["Register"] = "register";
    Namespace["Profile"] = "profile";
    Namespace["ForgottenPassword"] = "forgotten-password";
    Namespace["ChoosePlan"] = "choose-plan";
    Namespace["Vouchers"] = "vouchers";
    Namespace["Popups"] = "popups";
    Namespace["Welcome"] = "welcome";
    Namespace["FAQ"] = "faq";
    Namespace["FAQHome"] = "faq-home";
    Namespace["AboutUs"] = "about-us";
    Namespace["Contact"] = "contact";
    Namespace["SmartTV"] = "smart-tv";
    Namespace["Schools"] = "schools";
    Namespace["Authorship"] = "authorship";
    Namespace["Seo"] = "seo";
    Namespace["EmailHandle"] = "email-handle";
    Namespace["HowToWatch"] = "how-to-watch";
    Namespace["MobileApps"] = "mobile-apps";
    Namespace["VideoStreaming"] = "video-streaming";
    Namespace["Settings"] = "content_settings_title";
    Namespace["InviteFriends"] = "invite-friends";
    Namespace["Player"] = "player";
    Namespace["UaSupport"] = "ua-support";
    Namespace["EasterContest"] = "easter-contest";
    Namespace["Discount"] = "discount";
    Namespace["DiscountMay2022"] = "discount-may-2022";
    Namespace["Broadcast"] = "broadcast";
    Namespace["ChristmasContest"] = "christmas-contest";
})(Namespace || (Namespace = {}));


/***/ }),

/***/ 70375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ QueryType; }
/* harmony export */ });
var QueryType;
(function(QueryType) {
    QueryType["Weekly"] = "weekly";
    QueryType["Monthly"] = "monthly";
    QueryType["Yearly"] = "yearly";
    QueryType["Voucher"] = "voucher";
})(QueryType || (QueryType = {}));


/***/ }),

/***/ 54071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ PlaylistType; }
/* harmony export */ });
var PlaylistType;
(function(PlaylistType) {
    PlaylistType["Section"] = "section";
    PlaylistType["SameCast"] = "cast";
    PlaylistType["SameGenre"] = "genre";
    PlaylistType["Theater"] = "theater";
    PlaylistType["Genres"] = "genres";
})(PlaylistType || (PlaylistType = {}));


/***/ }),

/***/ 91360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ PopupType; }
/* harmony export */ });
var PopupType;
(function(PopupType) {
    PopupType["SetPrimaryCard"] = "changeChard";
    PopupType["DeleteCard"] = "deleteCard";
    PopupType["DeleteUser"] = "deleteUser";
    PopupType["RemoveSubscription"] = "removeSubscription";
    PopupType["BuySubscription"] = "buySubscription";
    PopupType["NewsletterSubscription"] = "NewsletterSubscription";
    PopupType["Login"] = "Login";
    PopupType["LowQuality"] = "LowQuality";
    PopupType["PromoDiscount"] = "PromoDiscount";
    PopupType["Cookies"] = "Cookies";
    PopupType["CookiesBar"] = "CookiesBar";
})(PopupType || (PopupType = {}));


/***/ }),

/***/ 33973:
/***/ (function(__unused_webpack_module, exports) {

var RouteType = {
    DefaultRedirect: "redirect",
    Collection: {
        cs: "nabidka",
        en: "browse",
        sk: "ponuka",
        uk: "perehlyadaty",
        pl: "przegladaj"
    },
    Welcome: "",
    PlayDetail: {
        cs: "divadla/[slug]/[playSlug]",
        en: "theatres/[slug]/[playSlug]",
        sk: "divadla/[slug]/[playSlug]",
        uk: "teatry/[slug]/[playSlug]",
        pl: "teatry/[slug]/[playSlug]"
    },
    TheatreDetail: {
        cs: "divadla/[slug]",
        en: "theatres/[slug]",
        sk: "divadla/[slug]",
        uk: "teatry/[slug]",
        pl: "teatry/[slug]"
    },
    Theatres: {
        cs: "divadla",
        en: "theatres",
        sk: "divadla",
        uk: "teatry",
        pl: "teatry"
    },
    Playlist: "playlist",
    FeaturedSection: {
        cs: "sekce/[slug]",
        en: "section/[slug]",
        sk: "sekcia/[slug]",
        uk: "rozdil/[slug]",
        pl: "sekcja/[slug]"
    },
    SameGenre: {
        cs: "stejny-zanr/[slug]",
        en: "same-genre/[slug]",
        sk: "rovnaky-zaner/[slug]",
        uk: "schozhe-za-zhanrom/[slug]",
        pl: "ten-sam-gatunek/[slug]"
    },
    SameCast: {
        cs: "stejne-obsazeni/[slug]",
        en: "same-cast/[slug]",
        sk: "rovnake-obsadenie/[slug]",
        uk: "ti-sami-aktory/[slug]",
        pl: "ten-sam-aktor/[slug]"
    },
    Genre: {
        cs: "zanr/[slug]",
        en: "genre/[slug]",
        sk: "zaner/[slug]",
        uk: "zhanr/[slug]",
        pl: "gatunek/[slug]"
    },
    MostPopular: {
        en: "most-popular-theatre-performances",
        cs: "nejpopularnejsi-divadelni-predstaveni",
        sk: "najpopularnejsie-divadelne-predstavenia",
        uk: "najpopulyarnishi-teatralni-vystavy",
        pl: "najpopularniejsze-spektakle-teatralne"
    },
    RecentlyAdded: {
        en: "recently-added-theatre-performances",
        cs: "nove-pridana-divadelni-predstaveni",
        sk: "novopridane-divadelne-predstavenia",
        uk: "novi-teatralni-vystavy",
        pl: "ostatnio-dodane-przedstawienia"
    },
    CurrentlyWatching: {
        en: "currently-watching",
        cs: "prave-rozkoukane",
        sk: "prave-pozerate",
        uk: "zaraz-dyvytes",
        pl: "ostatnio-ogladane"
    },
    DramoxOriginals: {
        en: "dramox-originals",
        cs: "original-dramox",
        sk: "dramox-originals",
        uk: "dramox-originals",
        pl: "dramox-originals"
    },
    Celebrity: {
        cs: "osobnost/[slug]",
        en: "celebrity/[slug]",
        sk: "osobnost/[slug]",
        uk: "znamenytist/[slug]",
        pl: "gwiazdy/[slug]"
    },
    Donate: {
        cs: "prispevek-divadlu",
        en: "donate",
        sk: "prispevok-divadlu",
        uk: "pidtrymaty",
        pl: "darowizna"
    },
    DonateTheatre: {
        en: "donate/[slug]",
        cs: "prispevek-divadlu/[slug]",
        sk: "prispevok-divadlu/[slug]",
        uk: "pidtrymaty-teatr/[slug]",
        pl: "darowizna/[slug]"
    },
    About: {
        en: "about-us",
        cs: "o-nas",
        sk: "o-nas",
        uk: "pro-nas",
        pl: "o-nas"
    },
    Voucher: {
        en: "gift-vouchers",
        cs: "darkove-poukazy",
        sk: "darcekove-poukazy",
        uk: "podarunkovyi-vaucher",
        pl: "voucher-podarunkowy"
    },
    VoucherBuy: {
        en: "buy-gift-voucher",
        cs: "koupit-darkovy-poukaz",
        sk: "kupit-darcekovy-poukaz",
        uk: "kupyty-podarunkovyi-vaucher",
        pl: "kup-voucher-podarunkowy"
    },
    ForSchools: {
        en: "for-schools",
        cs: "pro-skoly",
        sk: "pre-skoly",
        uk: "dlya-shkil",
        pl: "dla-szkol"
    },
    SmartTV: {
        en: "smart-tv",
        cs: "chytre-televize",
        sk: "smart-tv",
        uk: "smart-tv",
        pl: "smart-tv"
    },
    Contact: {
        en: "contact",
        cs: "kontakt",
        sk: "kontakt",
        uk: "kontakty",
        pl: "kontakt"
    },
    FAQ: {
        en: "frequently-asked-questions",
        cs: "casto-kladene-dotazy",
        sk: "casto-kladene-otazky",
        uk: "poshyreni-pytannya",
        pl: "najczesciej-zadawane-pytania"
    },
    Login: {
        en: "login",
        cs: "prihlaseni",
        sk: "prihlasenie",
        uk: "uviity",
        pl: "login"
    },
    RegisterStep1: {
        en: "register/step-1",
        cs: "registrace/krok-1",
        sk: "registracia/krok-1",
        uk: "rejestraciya/krok-1",
        pl: "rejestracja/krok-1"
    },
    RegisterStep2: {
        en: "register/step-2",
        cs: "registrace/krok-2",
        sk: "registracia/krok-2",
        uk: "rejestraciya/krok-2",
        pl: "rejestracja/krok-2"
    },
    RegisterConfirmEmail: {
        en: "register/confirm-email",
        cs: "registrace/potvrzeni-emailu",
        sk: "registracia/potvrdenie-emailu",
        uk: "rejestraciya/pidtverdzhenya-email",
        pl: "rejestracja/potwierdz-email"
    },
    RegisterContentSettings: {
        en: "register/content-settings",
        cs: "registrace/nastaveni-obsahu",
        sk: "registracia/nastavenie-obsahu",
        uk: "rejestraciya/nalashtuvannia-vmistu",
        pl: "rejestracja/ustawienia-zawartosci"
    },
    ForgottenPassword: {
        en: "forgotten-password",
        cs: "zapomenute-heslo",
        sk: "zabudnute-heslo",
        uk: "zabuly-parol",
        pl: "zapomniane-haslo"
    },
    Profile: "profile",
    TermsAndConditions: {
        en: "terms-and-conditions",
        cs: "podminky-pouziti",
        sk: "podmienky-pouzivania",
        uk: "polozhennya-ta-umovy",
        pl: "zasady-uzytkowania"
    },
    PrivacyPolicy: {
        en: "privacy-policy",
        cs: "ochrana-soukromi",
        sk: "ochrana-sukromia",
        uk: "konfidencijnist",
        pl: "polityka-prywatnosci"
    },
    Cookies: {
        en: "cookies",
        cs: "cookies",
        sk: "cookies",
        uk: "cookies",
        pl: "cookies"
    },
    Authorship: {
        en: "authorship",
        cs: "autorska-prava",
        sk: "autorske-prava",
        uk: "avtorski-prava",
        pl: "prawa-autorskie"
    },
    ChoosePlan: "choose-plan",
    Watch: {
        cs: "sledovat-divadelni-predstaveni-online/[slug]",
        en: "watch-online/[slug]",
        sk: "sledovat-divadlo-online/[slug]",
        uk: "dyvytysya-onlain/[slug]",
        pl: "ogladaj-online/[slug]"
    },
    Preview: {
        cs: "ukazka-predstaveni/[slug]",
        en: "preview/[slug]",
        sk: "ukazka-predstavenia/[slug]",
        uk: "poperednij-perehlyad/[slug]",
        pl: "zapowiedz/[slug]"
    },
    HowToWatch: {
        cs: "jak-sledovat",
        en: "how-to-watch",
        sk: "ako-sledovat",
        uk: "jak-dyvytys",
        pl: "jak-ogladac"
    },
    HowToWatchWeb: {
        cs: "jak-sledovat/web",
        en: "how-to-watch/web",
        sk: "ako-sledovat/web",
        uk: "jak-dyvytys/web",
        pl: "jak-ogladac/web"
    },
    HowToWatchMobile: {
        cs: "jak-sledovat/mobilni-aplikace",
        en: "how-to-watch/mobile-apps",
        sk: "ako-sledovat/mobilna-aplikacia",
        uk: "jak-dyvytys/mobilnyi-dodatok",
        pl: "jak-ogladac/aplikacja-mobilna"
    },
    HowToWatchMobileAndroid: {
        cs: "jak-sledovat/mobilni-aplikace/google-android",
        en: "how-to-watch/mobile-apps/google-android",
        sk: "ako-sledovat/mobilna-aplikacia/google-android",
        uk: "jak-dyvytys/mobilnyi-dodatok/google-android",
        pl: "jak-ogladac/aplikacja-mobilna/google-android"
    },
    HowToWatchMobileIOS: {
        cs: "jak-sledovat/mobilni-aplikace/apple-ios",
        en: "how-to-watch/mobile-apps/apple-ios",
        sk: "ako-sledovat/mobilna-aplikacia/apple-ios",
        uk: "jak-dyvytys/mobilnyi-dodatok/apple-ios",
        pl: "jak-ogladac/aplikacja-mobilna/apple-ios"
    },
    HowToWatchAndroidTV: {
        cs: "jak-sledovat/chytre-televize/android-tv",
        en: "how-to-watch/smart-tv/android-tv",
        sk: "ako-sledovat/smart-tv/android-tv",
        uk: "jak-dyvytys/smart-tv/android-tv",
        pl: "jak-ogladac/smart-tv/android-tv"
    },
    HowToWatchSmartTV: {
        cs: "jak-sledovat/chytre-televize",
        en: "how-to-watch/smart-tv",
        sk: "ako-sledovat/smart-tv",
        uk: "jak-dyvytys/smart-tv",
        pl: "jak-ogladac/smart-tv"
    },
    HowToWatchSmartTVSamsung: {
        cs: "jak-sledovat/chytre-televize/samsung-tizen",
        en: "how-to-watch/smart-tv/samsung-tizen",
        sk: "ako-sledovat/smart-tv/samsung-tizen",
        uk: "jak-dyvytys/smart-tv/samsung-tizen",
        pl: "jak-ogladac/smart-tv/samsung-tizen"
    },
    HowToWatchSmartTVLG: {
        cs: "jak-sledovat/chytre-televize/lg-webos",
        en: "how-to-watch/smart-tv/lg-webos",
        sk: "ako-sledovat/smart-tv/lg-webos",
        uk: "jak-dyvytys/smart-tv/lg-webos",
        pl: "jak-ogladac/smart-tv/lg-webos"
    },
    HowToWatchStreaming: {
        cs: "jak-sledovat/sdileni-obrazovky",
        en: "how-to-watch/video-streaming",
        sk: "ako-sledovat/zdielanie-obrazovky",
        uk: "jak-dyvytys/video-translyaciya",
        pl: "jak-ogladac/udostepnianie-obrazu"
    },
    HowToWatchStreamingChromecast: {
        cs: "jak-sledovat/sdileni-obrazovky/google-chromecast",
        en: "how-to-watch/video-streaming/google-chromecast",
        sk: "ako-sledovat/zdielanie-obrazovky/google-chromecast",
        uk: "jak-dyvytys/video-translyaciya/google-chromecast",
        pl: "jak-ogladac/udostepnianie-obrazu/google-chromecast"
    },
    HowToWatchStreamingAirplay: {
        cs: "jak-sledovat/sdileni-obrazovky/apple-airplay",
        en: "how-to-watch/video-streaming/apple-airplay",
        sk: "ako-sledovat/zdielanie-obrazovky/apple-airplay",
        uk: "jak-dyvytys/video-translyaciya/apple-airplay",
        pl: "jak-ogladac/udostepnianie-obrazu/apple-airplay"
    },
    ContentSettings: {
        cs: "nastaveni-obsahu",
        en: "content-settings",
        sk: "nastavenie-obsahu",
        uk: "nalashuvannya-vmistu",
        pl: "ustawienia-zawartosci"
    },
    InviteFriends: {
        cs: "pozvat-pratele",
        en: "invite-friends",
        sk: "pozvat-priatelov",
        uk: "zaprosyty-druziv",
        pl: "zapros-znajomych"
    },
    WatchList: {
        cs: "muj-seznam",
        en: "watch-list",
        sk: "moj-zoznam",
        uk: "mij-spysok",
        pl: "moja-lista"
    },
    UaSupport: {
        cs: "podpora-ukrajinskym-divadlum",
        en: "help-ukraine-theatres",
        sk: "pomoc-ukrajinskym-divadlam",
        uk: "pidtrymaite-ukrainski-teatry",
        pl: "pomoz-ukrainskim-teatrom"
    },
    EasterContest: {
        cs: "velikonocni-soutez",
        en: "easter-contest",
        sk: "velkonocna-sutaz",
        uk: "velykodniy-konkurs",
        pl: "konkurs-wielkanocny"
    },
    Discount: {
        cs: "dramox-za-pulku",
        en: "dramox-50-off",
        sk: "dramox-za-polovicu",
        uk: "dramox-50-ua",
        pl: "dramox-50-pl"
    },
    ChristmasContest: {
        cs: "vanocni-soutez",
        en: "christmas-contest",
        sk: "vianocna-sutaz",
        uk: "rizdvyanyi-konkurs",
        pl: "konkurs-swiateczny"
    },
    Discount2022: {
        cs: "dramox-kveten-33",
        en: "dramox-may-33",
        sk: "dramox-maj-33",
        uk: "dramox-traven-33",
        pl: "dramox-maj-33"
    },
    Broadcast: {
        cs: "vysilani",
        en: "broadcast",
        sk: "vysilanie",
        uk: "movlennya",
        pl: "transmisja"
    },
    ConversionLandingPage: {
        cs: "homepage",
        en: "homepage",
        sk: "homepage",
        uk: "homepage",
        pl: "homepage"
    }
};
exports.Y = RouteType;


/***/ }),

/***/ 52294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ StorageKeys; }
/* harmony export */ });
var StorageKeys;
(function(StorageKeys) {
    StorageKeys["REGISTER_DETAILS"] = "register-details";
    StorageKeys["SUBTITLES"] = "subtitles";
    StorageKeys["HOMEPAGE_PLAN_TYPE"] = "homepage-plan-type";
})(StorageKeys || (StorageKeys = {}));


/***/ }),

/***/ 48408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ swiper_esm_bundle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(32363);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(62139);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(49573);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(42299);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(94981);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(54146);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs + 1 modules
var _possible_constructor_return = __webpack_require__(10797);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(2746);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(84911);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 2 modules
var _create_super = __webpack_require__(66334);
;// CONCATENATED MODULE: ./node_modules/ssr-window/dist/ssr-window.esm.js
/**
 * SSR Window 2.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: May 12, 2020
 */
/* eslint-disable no-param-reassign */
function isObject(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend(target, src) {
    if (target === void 0) { target = {}; }
    if (src === void 0) { src = {}; }
    Object.keys(src).forEach(function (key) {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (isObject(src[key]) &&
            isObject(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend(target[key], src[key]);
        }
    });
}

var doc = typeof document !== 'undefined' ? document : {};
var ssrDocument = {
    body: {},
    addEventListener: function () { },
    removeEventListener: function () { },
    activeElement: {
        blur: function () { },
        nodeName: '',
    },
    querySelector: function () {
        return null;
    },
    querySelectorAll: function () {
        return [];
    },
    getElementById: function () {
        return null;
    },
    createEvent: function () {
        return {
            initEvent: function () { },
        };
    },
    createElement: function () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function () { },
            getElementsByTagName: function () {
                return [];
            },
        };
    },
    createElementNS: function () {
        return {};
    },
    importNode: function () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
extend(doc, ssrDocument);

var win = typeof window !== 'undefined' ? window : {};
var ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState: function () { },
        pushState: function () { },
        go: function () { },
        back: function () { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function () { },
    removeEventListener: function () { },
    getComputedStyle: function () {
        return {
            getPropertyValue: function () {
                return '';
            },
        };
    },
    Image: function () { },
    Date: function () { },
    screen: {},
    setTimeout: function () { },
    clearTimeout: function () { },
    matchMedia: function () {
        return {};
    },
};
extend(win, ssrWindow);



;// CONCATENATED MODULE: ./node_modules/dom7/dist/dom7.modular.js
/**
 * Dom7 2.1.5
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * http://framework7.io/docs/dom.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 *
 * Licensed under MIT
 *
 * Released on: May 15, 2020
 */


class Dom7 {
  constructor(arr) {
    const self = this;
    // Create array-like object
    for (let i = 0; i < arr.length; i += 1) {
      self[i] = arr[i];
    }
    self.length = arr.length;
    // Return collection with methods
    return this;
  }
}

function $(selector, context) {
  const arr = [];
  let i = 0;
  if (selector && !context) {
    if (selector instanceof Dom7) {
      return selector;
    }
  }
  if (selector) {
      // String
    if (typeof selector === 'string') {
      let els;
      let tempParent;
      const html = selector.trim();
      if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
        let toCreate = 'div';
        if (html.indexOf('<li') === 0) toCreate = 'ul';
        if (html.indexOf('<tr') === 0) toCreate = 'tbody';
        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
        if (html.indexOf('<tbody') === 0) toCreate = 'table';
        if (html.indexOf('<option') === 0) toCreate = 'select';
        tempParent = doc.createElement(toCreate);
        tempParent.innerHTML = html;
        for (i = 0; i < tempParent.childNodes.length; i += 1) {
          arr.push(tempParent.childNodes[i]);
        }
      } else {
        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
          // Pure ID selector
          els = [doc.getElementById(selector.trim().split('#')[1])];
        } else {
          // Other selectors
          els = (context || doc).querySelectorAll(selector.trim());
        }
        for (i = 0; i < els.length; i += 1) {
          if (els[i]) arr.push(els[i]);
        }
      }
    } else if (selector.nodeType || selector === win || selector === doc) {
      // Node/element
      arr.push(selector);
    } else if (selector.length > 0 && selector[0].nodeType) {
      // Array of elements or instance of Dom
      for (i = 0; i < selector.length; i += 1) {
        arr.push(selector[i]);
      }
    }
  }
  return new Dom7(arr);
}

$.fn = Dom7.prototype;
$.Class = Dom7;
$.Dom7 = Dom7;

function unique(arr) {
  const uniqueArray = [];
  for (let i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }
  return uniqueArray;
}
function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, (match, group1) => group1.toUpperCase());
}

function requestAnimationFrame(callback) {
  if (window.requestAnimationFrame) return window.requestAnimationFrame(callback);
  else if (window.webkitRequestAnimationFrame) return window.webkitRequestAnimationFrame(callback);
  return window.setTimeout(callback, 1000 / 60);
}
function cancelAnimationFrame(id) {
  if (window.cancelAnimationFrame) return window.cancelAnimationFrame(id);
  else if (window.webkitCancelAnimationFrame) return window.webkitCancelAnimationFrame(id);
  return window.clearTimeout(id);
}

// Classes and attributes
function addClass(className) {
  if (typeof className === 'undefined') {
    return this;
  }
  const classes = className.split(' ');
  for (let i = 0; i < classes.length; i += 1) {
    for (let j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.add(classes[i]);
    }
  }
  return this;
}
function removeClass(className) {
  const classes = className.split(' ');
  for (let i = 0; i < classes.length; i += 1) {
    for (let j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.remove(classes[i]);
    }
  }
  return this;
}
function hasClass(className) {
  if (!this[0]) return false;
  return this[0].classList.contains(className);
}
function toggleClass(className) {
  const classes = className.split(' ');
  for (let i = 0; i < classes.length; i += 1) {
    for (let j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.toggle(classes[i]);
    }
  }
  return this;
}
function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  }

  // Set attrs
  for (let i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      // eslint-disable-next-line
      for (const attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }
  return this;
}
// eslint-disable-next-line
function removeAttr(attr) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }
  return this;
}
// eslint-disable-next-line
function prop(props, value) {
  if (arguments.length === 1 && typeof props === 'string') {
    // Get prop
    if (this[0]) return this[0][props];
  } else {
    // Set props
    for (let i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i][props] = value;
      } else {
        // Object
        // eslint-disable-next-line
        for (const propName in props) {
          this[i][propName] = props[propName];
        }
      }
    }
    return this;
  }
}
function data(key, value) {
  let el;
  if (typeof value === 'undefined') {
    el = this[0];
    // Get value
    if (el) {
      if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
        return el.dom7ElementDataStorage[key];
      }

      const dataKey = el.getAttribute(`data-${key}`);
      if (dataKey) {
        return dataKey;
      }
      return undefined;
    }
    return undefined;
  }

  // Set value
  for (let i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }
  return this;
}
function removeData(key) {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];
    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
      el.dom7ElementDataStorage[key] = null;
      delete el.dom7ElementDataStorage[key];
    }
  }
}
function dataset() {
  const el = this[0];
  if (!el) return undefined;
  const dataset = {}; // eslint-disable-line
  if (el.dataset) {
    // eslint-disable-next-line
    for (const dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (let i = 0; i < el.attributes.length; i += 1) {
      // eslint-disable-next-line
      const attr = el.attributes[i];
      if (attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
      }
    }
  }
  // eslint-disable-next-line
  for (const key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;
    else if (dataset[key] === 'true') dataset[key] = true;
    else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }
  return dataset;
}
function val(value) {
  const dom = this;
  if (typeof value === 'undefined') {
    if (dom[0]) {
      if (dom[0].multiple && dom[0].nodeName.toLowerCase() === 'select') {
        const values = [];
        for (let i = 0; i < dom[0].selectedOptions.length; i += 1) {
          values.push(dom[0].selectedOptions[i].value);
        }
        return values;
      }
      return dom[0].value;
    }
    return undefined;
  }

  for (let i = 0; i < dom.length; i += 1) {
    const el = dom[i];
    if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') {
      for (let j = 0; j < el.options.length; j += 1) {
        el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
      }
    } else {
      el.value = value;
    }
  }
  return dom;
}
// Transforms
// eslint-disable-next-line
function transform(transform) {
  for (let i = 0; i < this.length; i += 1) {
    const elStyle = this[i].style;
    elStyle.webkitTransform = transform;
    elStyle.transform = transform;
  }
  return this;
}
function transition(duration) {
  if (typeof duration !== 'string') {
    duration = `${duration}ms`; // eslint-disable-line
  }
  for (let i = 0; i < this.length; i += 1) {
    const elStyle = this[i].style;
    elStyle.webkitTransitionDuration = duration;
    elStyle.transitionDuration = duration;
  }
  return this;
}
// Events
function on(...args) {
  let [eventType, targetSelector, listener, capture] = args;
  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }
  if (!capture) capture = false;

  function handleLiveEvent(e) {
    const target = e.target;
    if (!target) return;
    const eventData = e.target.dom7EventData || [];
    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }
    if ($(target).is(targetSelector)) listener.apply(target, eventData);
    else {
      const parents = $(target).parents(); // eslint-disable-line
      for (let k = 0; k < parents.length; k += 1) {
        if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
      }
    }
  }
  function handleEvent(e) {
    const eventData = e && e.target ? e.target.dom7EventData || [] : [];
    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }
    listener.apply(this, eventData);
  }
  const events = eventType.split(' ');
  let j;
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];
    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener,
          proxyListener: handleEvent,
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
        el.dom7LiveListeners[event].push({
          listener,
          proxyListener: handleLiveEvent,
        });
        el.addEventListener(event, handleLiveEvent, capture);
      }
    }
  }
  return this;
}
function off(...args) {
  let [eventType, targetSelector, listener, capture] = args;
  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }
  if (!capture) capture = false;

  const events = eventType.split(' ');
  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];
    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      let handlers;
      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }
      if (handlers && handlers.length) {
        for (let k = handlers.length - 1; k >= 0; k -= 1) {
          const handler = handlers[k];
          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }
  return this;
}
function once(...args) {
  const dom = this;
  let [eventName, targetSelector, listener, capture] = args;
  if (typeof args[1] === 'function') {
    [eventName, listener, capture] = args;
    targetSelector = undefined;
  }
  function onceHandler(...eventArgs) {
    listener.apply(this, eventArgs);
    dom.off(eventName, targetSelector, onceHandler, capture);
    if (onceHandler.dom7proxy) {
      delete onceHandler.dom7proxy;
    }
  }
  onceHandler.dom7proxy = listener;
  return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger(...args) {
  const events = args[0].split(' ');
  const eventData = args[1];
  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];
    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      let evt;
      try {
        evt = new win.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true,
        });
      } catch (e) {
        evt = doc.createEvent('Event');
        evt.initEvent(event, true, true);
        evt.detail = eventData;
      }
      // eslint-disable-next-line
      el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
      el.dispatchEvent(evt);
      el.dom7EventData = [];
      delete el.dom7EventData;
    }
  }
  return this;
}
function transitionEnd(callback) {
  const events = ['webkitTransitionEnd', 'transitionend'];
  const dom = this;
  let i;
  function fireCallBack(e) {
    /* jshint validthis:true */
    if (e.target !== this) return;
    callback.call(this, e);
    for (i = 0; i < events.length; i += 1) {
      dom.off(events[i], fireCallBack);
    }
  }
  if (callback) {
    for (i = 0; i < events.length; i += 1) {
      dom.on(events[i], fireCallBack);
    }
  }
  return this;
}
function animationEnd(callback) {
  const events = ['webkitAnimationEnd', 'animationend'];
  const dom = this;
  let i;
  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    for (i = 0; i < events.length; i += 1) {
      dom.off(events[i], fireCallBack);
    }
  }
  if (callback) {
    for (i = 0; i < events.length; i += 1) {
      dom.on(events[i], fireCallBack);
    }
  }
  return this;
}
// Sizing/Styles
function width() {
  if (this[0] === window) {
    return window.innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}
function dom7_modular_outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      // eslint-disable-next-line
      const styles = this.styles();
      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function height() {
  if (this[0] === window) {
    return window.innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}
function dom7_modular_outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      // eslint-disable-next-line
      const styles = this.styles();
      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function offset() {
  if (this.length > 0) {
    const el = this[0];
    const box = el.getBoundingClientRect();
    const body = doc.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === win ? win.scrollY : el.scrollTop;
    const scrollLeft = el === win ? win.scrollX : el.scrollLeft;
    return {
      top: (box.top + scrollTop) - clientTop,
      left: (box.left + scrollLeft) - clientLeft,
    };
  }

  return null;
}
function hide() {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }
  return this;
}
function show() {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];
    if (el.style.display === 'none') {
      el.style.display = '';
    }
    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }
  return this;
}
function styles() {
  if (this[0]) return win.getComputedStyle(this[0], null);
  return {};
}
function css(props, value) {
  let i;
  if (arguments.length === 1) {
    if (typeof props === 'string') {
      if (this[0]) return win.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      for (i = 0; i < this.length; i += 1) {
        // eslint-disable-next-line
        for (let prop in props) {
          this[i].style[prop] = props[prop];
        }
      }
      return this;
    }
  }
  if (arguments.length === 2 && typeof props === 'string') {
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }
    return this;
  }
  return this;
}

// Dom manipulation
function toArray() {
  const arr = [];
  for (let i = 0; i < this.length; i += 1) {
    arr.push(this[i]);
  }
  return arr;
}
// Iterate over the collection passing elements to `callback`
function each(callback) {
  // Don't bother continuing without a callback
  if (!callback) return this;
  // Iterate over the current collection
  for (let i = 0; i < this.length; i += 1) {
    // If the callback returns false
    if (callback.call(this[i], i, this[i]) === false) {
      // End the loop early
      return this;
    }
  }
  // Return `this` to allow chained DOM operations
  return this;
}
function forEach(callback) {
  // Don't bother continuing without a callback
  if (!callback) return this;
  // Iterate over the current collection
  for (let i = 0; i < this.length; i += 1) {
    // If the callback returns false
    if (callback.call(this[i], this[i], i) === false) {
      // End the loop early
      return this;
    }
  }
  // Return `this` to allow chained DOM operations
  return this;
}
function filter(callback) {
  const matchedItems = [];
  const dom = this;
  for (let i = 0; i < dom.length; i += 1) {
    if (callback.call(dom[i], i, dom[i])) matchedItems.push(dom[i]);
  }
  return new Dom7(matchedItems);
}
function map(callback) {
  const modifiedItems = [];
  const dom = this;
  for (let i = 0; i < dom.length; i += 1) {
    modifiedItems.push(callback.call(dom[i], i, dom[i]));
  }
  return new Dom7(modifiedItems);
}
// eslint-disable-next-line
function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : undefined;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }
  return this;
}
// eslint-disable-next-line
function dom7_modular_text(text) {
  if (typeof text === 'undefined') {
    if (this[0]) {
      return this[0].textContent.trim();
    }
    return null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }
  return this;
}
function is(selector) {
  const el = this[0];
  let compareWith;
  let i;
  if (!el || typeof selector === 'undefined') return false;
  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    else if (el.msMatchesSelector) return el.msMatchesSelector(selector);

    compareWith = $(selector);
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }
    return false;
  } else if (selector === doc) return el === doc;
  else if (selector === win) return el === win;

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }
    return false;
  }
  return false;
}
function indexOf(el) {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i] === el) return i;
  }
  return -1;
}
function index() {
  let child = this[0];
  let i;
  if (child) {
    i = 0;
    // eslint-disable-next-line
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return undefined;
}
// eslint-disable-next-line
function eq(index) {
  if (typeof index === 'undefined') return this;
  const length = this.length;
  let returnIndex;
  if (index > length - 1) {
    return new Dom7([]);
  }
  if (index < 0) {
    returnIndex = length + index;
    if (returnIndex < 0) return new Dom7([]);
    return new Dom7([this[returnIndex]]);
  }
  return new Dom7([this[index]]);
}
function append(...args) {
  let newChild;

  for (let k = 0; k < args.length; k += 1) {
    newChild = args[k];
    for (let i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        const tempDiv = doc.createElement('div');
        tempDiv.innerHTML = newChild;
        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (let j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}
// eslint-disable-next-line
function appendTo(parent) {
  $(parent).append(this);
  return this;
}
function prepend(newChild) {
  let i;
  let j;
  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      const tempDiv = doc.createElement('div');
      tempDiv.innerHTML = newChild;
      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }
  return this;
}
// eslint-disable-next-line
function prependTo(parent) {
  $(parent).prepend(this);
  return this;
}
function insertBefore(selector) {
  const before = $(selector);
  for (let i = 0; i < this.length; i += 1) {
    if (before.length === 1) {
      before[0].parentNode.insertBefore(this[i], before[0]);
    } else if (before.length > 1) {
      for (let j = 0; j < before.length; j += 1) {
        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
      }
    }
  }
}
function insertAfter(selector) {
  const after = $(selector);
  for (let i = 0; i < this.length; i += 1) {
    if (after.length === 1) {
      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
    } else if (after.length > 1) {
      for (let j = 0; j < after.length; j += 1) {
        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
      }
    }
  }
}
function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return new Dom7([this[0].nextElementSibling]);
      }
      return new Dom7([]);
    }

    if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
    return new Dom7([]);
  }
  return new Dom7([]);
}
function nextAll(selector) {
  const nextEls = [];
  let el = this[0];
  if (!el) return new Dom7([]);
  while (el.nextElementSibling) {
    const next = el.nextElementSibling; // eslint-disable-line
    if (selector) {
      if ($(next).is(selector)) nextEls.push(next);
    } else nextEls.push(next);
    el = next;
  }
  return new Dom7(nextEls);
}
function prev(selector) {
  if (this.length > 0) {
    const el = this[0];
    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return new Dom7([el.previousElementSibling]);
      }
      return new Dom7([]);
    }

    if (el.previousElementSibling) return new Dom7([el.previousElementSibling]);
    return new Dom7([]);
  }
  return new Dom7([]);
}
function prevAll(selector) {
  const prevEls = [];
  let el = this[0];
  if (!el) return new Dom7([]);
  while (el.previousElementSibling) {
    const prev = el.previousElementSibling; // eslint-disable-line
    if (selector) {
      if ($(prev).is(selector)) prevEls.push(prev);
    } else prevEls.push(prev);
    el = prev;
  }
  return new Dom7(prevEls);
}
function siblings(selector) {
  return this.nextAll(selector).add(this.prevAll(selector));
}
function dom7_modular_parent(selector) {
  const parents = []; // eslint-disable-line
  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }
  return $(unique(parents));
}
function parents(selector) {
  const parents = []; // eslint-disable-line
  for (let i = 0; i < this.length; i += 1) {
    let parent = this[i].parentNode; // eslint-disable-line
    while (parent) {
      if (selector) {
        if ($(parent).is(selector)) parents.push(parent);
      } else {
        parents.push(parent);
      }
      parent = parent.parentNode;
    }
  }
  return $(unique(parents));
}
function closest(selector) {
  let closest = this; // eslint-disable-line
  if (typeof selector === 'undefined') {
    return new Dom7([]);
  }
  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }
  return closest;
}
function find(selector) {
  const foundElements = [];
  for (let i = 0; i < this.length; i += 1) {
    const found = this[i].querySelectorAll(selector);
    for (let j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }
  return new Dom7(foundElements);
}
function children(selector) {
  const children = []; // eslint-disable-line
  for (let i = 0; i < this.length; i += 1) {
    const childNodes = this[i].childNodes;

    for (let j = 0; j < childNodes.length; j += 1) {
      if (!selector) {
        if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
      } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }
  return new Dom7(unique(children));
}
function remove() {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }
  return this;
}
function detach() {
  return this.remove();
}
function add(...args) {
  const dom = this;
  let i;
  let j;
  for (i = 0; i < args.length; i += 1) {
    const toAdd = $(args[i]);
    for (j = 0; j < toAdd.length; j += 1) {
      dom[dom.length] = toAdd[j];
      dom.length += 1;
    }
  }
  return dom;
}
function empty() {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];
    if (el.nodeType === 1) {
      for (let j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }
      el.textContent = '';
    }
  }
  return this;
}

function scrollTo(...args) {
  let [left, top, duration, easing, callback] = args;
  if (args.length === 4 && typeof easing === 'function') {
    callback = easing;
    [left, top, duration, callback, easing] = args;
  }
  if (typeof easing === 'undefined') easing = 'swing';

  return this.each(function animate() {
    const el = this;
    let currentTop;
    let currentLeft;
    let maxTop;
    let maxLeft;
    let newTop;
    let newLeft;
    let scrollTop; // eslint-disable-line
    let scrollLeft; // eslint-disable-line
    let animateTop = top > 0 || top === 0;
    let animateLeft = left > 0 || left === 0;
    if (typeof easing === 'undefined') {
      easing = 'swing';
    }
    if (animateTop) {
      currentTop = el.scrollTop;
      if (!duration) {
        el.scrollTop = top;
      }
    }
    if (animateLeft) {
      currentLeft = el.scrollLeft;
      if (!duration) {
        el.scrollLeft = left;
      }
    }
    if (!duration) return;
    if (animateTop) {
      maxTop = el.scrollHeight - el.offsetHeight;
      newTop = Math.max(Math.min(top, maxTop), 0);
    }
    if (animateLeft) {
      maxLeft = el.scrollWidth - el.offsetWidth;
      newLeft = Math.max(Math.min(left, maxLeft), 0);
    }
    let startTime = null;
    if (animateTop && newTop === currentTop) animateTop = false;
    if (animateLeft && newLeft === currentLeft) animateLeft = false;
    function render(time = new Date().getTime()) {
      if (startTime === null) {
        startTime = time;
      }
      const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      const easeProgress = easing === 'linear' ? progress : (0.5 - (Math.cos(progress * Math.PI) / 2));
      let done;
      if (animateTop) scrollTop = currentTop + (easeProgress * (newTop - currentTop));
      if (animateLeft) scrollLeft = currentLeft + (easeProgress * (newLeft - currentLeft));
      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
        el.scrollTop = newTop;
        done = true;
      }
      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
        el.scrollTop = newTop;
        done = true;
      }
      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }
      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (done) {
        if (callback) callback();
        return;
      }
      if (animateTop) el.scrollTop = scrollTop;
      if (animateLeft) el.scrollLeft = scrollLeft;
      requestAnimationFrame(render);
    }
    requestAnimationFrame(render);
  });
}
// scrollTop(top, duration, easing, callback) {
function scrollTop(...args) {
  let [top, duration, easing, callback] = args;
  if (args.length === 3 && typeof easing === 'function') {
    [top, duration, callback, easing] = args;
  }
  const dom = this;
  if (typeof top === 'undefined') {
    if (dom.length > 0) return dom[0].scrollTop;
    return null;
  }
  return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft(...args) {
  let [left, duration, easing, callback] = args;
  if (args.length === 3 && typeof easing === 'function') {
    [left, duration, callback, easing] = args;
  }
  const dom = this;
  if (typeof left === 'undefined') {
    if (dom.length > 0) return dom[0].scrollLeft;
    return null;
  }
  return dom.scrollTo(left, undefined, duration, easing, callback);
}

function animate(initialProps, initialParams) {
  const els = this;
  const a = {
    props: Object.assign({}, initialProps),
    params: Object.assign({
      duration: 300,
      easing: 'swing', // or 'linear'
      /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */
    }, initialParams),

    elements: els,
    animating: false,
    que: [],

    easingProgress(easing, progress) {
      if (easing === 'swing') {
        return 0.5 - (Math.cos(progress * Math.PI) / 2);
      }
      if (typeof easing === 'function') {
        return easing(progress);
      }
      return progress;
    },
    stop() {
      if (a.frameId) {
        cancelAnimationFrame(a.frameId);
      }
      a.animating = false;
      a.elements.each((index, el) => {
        const element = el;
        delete element.dom7AnimateInstance;
      });
      a.que = [];
    },
    done(complete) {
      a.animating = false;
      a.elements.each((index, el) => {
        const element = el;
        delete element.dom7AnimateInstance;
      });
      if (complete) complete(els);
      if (a.que.length > 0) {
        const que = a.que.shift();
        a.animate(que[0], que[1]);
      }
    },
    animate(props, params) {
      if (a.animating) {
        a.que.push([props, params]);
        return a;
      }
      const elements = [];

      // Define & Cache Initials & Units
      a.elements.each((index, el) => {
        let initialFullValue;
        let initialValue;
        let unit;
        let finalValue;
        let finalFullValue;

        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;

        elements[index] = {
          container: el,
        };
        Object.keys(props).forEach((prop) => {
          initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
          initialValue = parseFloat(initialFullValue);
          unit = initialFullValue.replace(initialValue, '');
          finalValue = parseFloat(props[prop]);
          finalFullValue = props[prop] + unit;
          elements[index][prop] = {
            initialFullValue,
            initialValue,
            unit,
            finalValue,
            finalFullValue,
            currentValue: initialValue,
          };
        });
      });

      let startTime = null;
      let time;
      let elementsDone = 0;
      let propsDone = 0;
      let done;
      let began = false;

      a.animating = true;

      function render() {
        time = new Date().getTime();
        let progress;
        let easeProgress;
        // let el;
        if (!began) {
          began = true;
          if (params.begin) params.begin(els);
        }
        if (startTime === null) {
          startTime = time;
        }
        if (params.progress) {
          // eslint-disable-next-line
          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), ((startTime + params.duration) - time < 0 ? 0 : (startTime + params.duration) - time), startTime);
        }

        elements.forEach((element) => {
          const el = element;
          if (done || el.done) return;
          Object.keys(props).forEach((prop) => {
            if (done || el.done) return;
            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
            easeProgress = a.easingProgress(params.easing, progress);
            const { initialValue, finalValue, unit } = el[prop];
            el[prop].currentValue = initialValue + (easeProgress * (finalValue - initialValue));
            const currentValue = el[prop].currentValue;

            if (
              (finalValue > initialValue && currentValue >= finalValue) ||
              (finalValue < initialValue && currentValue <= finalValue)) {
              el.container.style[prop] = finalValue + unit;
              propsDone += 1;
              if (propsDone === Object.keys(props).length) {
                el.done = true;
                elementsDone += 1;
              }
              if (elementsDone === elements.length) {
                done = true;
              }
            }
            if (done) {
              a.done(params.complete);
              return;
            }
            el.container.style[prop] = currentValue + unit;
          });
        });
        if (done) return;
        // Then call
        a.frameId = requestAnimationFrame(render);
      }
      a.frameId = requestAnimationFrame(render);
      return a;
    },
  };

  if (a.elements.length === 0) {
    return els;
  }

  let animateInstance;
  for (let i = 0; i < a.elements.length; i += 1) {
    if (a.elements[i].dom7AnimateInstance) {
      animateInstance = a.elements[i].dom7AnimateInstance;
    } else a.elements[i].dom7AnimateInstance = a;
  }
  if (!animateInstance) {
    animateInstance = a;
  }

  if (initialProps === 'stop') {
    animateInstance.stop();
  } else {
    animateInstance.animate(a.props, a.params);
  }

  return els;
}

function stop() {
  const els = this;
  for (let i = 0; i < els.length; i += 1) {
    if (els[i].dom7AnimateInstance) {
      els[i].dom7AnimateInstance.stop();
    }
  }
}

const noTrigger = ('resize scroll').split(' ');
function eventShortcut(name, ...args) {
  if (typeof args[0] === 'undefined') {
    for (let i = 0; i < this.length; i += 1) {
      if (noTrigger.indexOf(name) < 0) {
        if (name in this[i]) this[i][name]();
        else {
          $(this[i]).trigger(name);
        }
      }
    }
    return this;
  }
  return this.on(name, ...args);
}

function click(...args) {
  return eventShortcut.bind(this)('click', ...args);
}
function dom7_modular_blur(...args) {
  return eventShortcut.bind(this)('blur', ...args);
}
function dom7_modular_focus(...args) {
  return eventShortcut.bind(this)('focus', ...args);
}
function focusin(...args) {
  return eventShortcut.bind(this)('focusin', ...args);
}
function focusout(...args) {
  return eventShortcut.bind(this)('focusout', ...args);
}
function keyup(...args) {
  return eventShortcut.bind(this)('keyup', ...args);
}
function keydown(...args) {
  return eventShortcut.bind(this)('keydown', ...args);
}
function keypress(...args) {
  return eventShortcut.bind(this)('keypress', ...args);
}
function dom7_modular_submit(...args) {
  return eventShortcut.bind(this)('submit', ...args);
}
function change(...args) {
  return eventShortcut.bind(this)('change', ...args);
}
function mousedown(...args) {
  return eventShortcut.bind(this)('mousedown', ...args);
}
function mousemove(...args) {
  return eventShortcut.bind(this)('mousemove', ...args);
}
function mouseup(...args) {
  return eventShortcut.bind(this)('mouseup', ...args);
}
function mouseenter(...args) {
  return eventShortcut.bind(this)('mouseenter', ...args);
}
function mouseleave(...args) {
  return eventShortcut.bind(this)('mouseleave', ...args);
}
function mouseout(...args) {
  return eventShortcut.bind(this)('mouseout', ...args);
}
function mouseover(...args) {
  return eventShortcut.bind(this)('mouseover', ...args);
}
function touchstart(...args) {
  return eventShortcut.bind(this)('touchstart', ...args);
}
function touchend(...args) {
  return eventShortcut.bind(this)('touchend', ...args);
}
function touchmove(...args) {
  return eventShortcut.bind(this)('touchmove', ...args);
}
function resize(...args) {
  return eventShortcut.bind(this)('resize', ...args);
}
function dom7_modular_scroll(...args) {
  return eventShortcut.bind(this)('scroll', ...args);
}



;// CONCATENATED MODULE: ./external/swiper/js/swiper.esm.bundle.js










/**
 * Swiper 5.4.5
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://swiperjs.com
 *
 * Copyright 2014-2020 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 16, 2020
 */ 

var Methods = {
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    toggleClass: toggleClass,
    attr: attr,
    removeAttr: removeAttr,
    data: data,
    transform: transform,
    transition: transition,
    on: on,
    off: off,
    trigger: trigger,
    transitionEnd: transitionEnd,
    outerWidth: dom7_modular_outerWidth,
    outerHeight: dom7_modular_outerHeight,
    offset: offset,
    css: css,
    each: each,
    html: html,
    text: dom7_modular_text,
    is: is,
    index: index,
    eq: eq,
    append: append,
    prepend: prepend,
    next: next,
    nextAll: nextAll,
    prev: prev,
    prevAll: prevAll,
    parent: dom7_modular_parent,
    parents: parents,
    closest: closest,
    find: find,
    children: children,
    filter: filter,
    remove: remove,
    add: add,
    styles: styles
};
Object.keys(Methods).forEach(function(methodName) {
    $.fn[methodName] = $.fn[methodName] || Methods[methodName];
});
var Utils = {
    deleteProps: function deleteProps(obj) {
        var object = obj;
        Object.keys(object).forEach(function(key) {
            try {
                object[key] = null;
            } catch (e) {
            // no getter for object
            }
            try {
                delete object[key];
            } catch (e1) {
            // something got wrong
            }
        });
    },
    nextTick: function nextTick(callback) {
        var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return setTimeout(callback, delay);
    },
    now: function now() {
        return Date.now();
    },
    getTranslate: function getTranslate(el) {
        var axis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x";
        var matrix;
        var curTransform;
        var transformMatrix;
        var curStyle = win.getComputedStyle(el, null);
        if (win.WebKitCSSMatrix) {
            curTransform = curStyle.transform || curStyle.webkitTransform;
            if (curTransform.split(",").length > 6) {
                curTransform = curTransform.split(", ").map(function(a) {
                    return a.replace(",", ".");
                }).join(", ");
            }
            // Some old versions of Webkit choke when 'none' is passed; pass
            // empty string instead in this case
            transformMatrix = new win.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
        } else {
            transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
            matrix = transformMatrix.toString().split(",");
        }
        if (axis === "x") {
            // Latest Chrome and webkits Fix
            if (win.WebKitCSSMatrix) curTransform = transformMatrix.m41;
            else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
            else curTransform = parseFloat(matrix[4]);
        }
        if (axis === "y") {
            // Latest Chrome and webkits Fix
            if (win.WebKitCSSMatrix) curTransform = transformMatrix.m42;
            else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
            else curTransform = parseFloat(matrix[5]);
        }
        return curTransform || 0;
    },
    parseUrlQuery: function parseUrlQuery(url) {
        var query = {};
        var urlToParse = url || win.location.href;
        var i;
        var params;
        var param;
        var length;
        if (typeof urlToParse === "string" && urlToParse.length) {
            urlToParse = urlToParse.indexOf("?") > -1 ? urlToParse.replace(/\S*\?/, "") : "";
            params = urlToParse.split("&").filter(function(paramsPart) {
                return paramsPart !== "";
            });
            length = params.length;
            for(i = 0; i < length; i += 1){
                param = params[i].replace(/#\S+/g, "").split("=");
                query[decodeURIComponent(param[0])] = typeof param[1] === "undefined" ? undefined : decodeURIComponent(param[1]) || "";
            }
        }
        return query;
    },
    isObject: function isObject(o) {
        return typeof o === "object" && o !== null && o.constructor && o.constructor === Object;
    },
    extend: function extend() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var to = Object(args[0]);
        for(var i = 1; i < args.length; i += 1){
            var nextSource = args[i];
            if (nextSource !== undefined && nextSource !== null) {
                var keysArray = Object.keys(Object(nextSource));
                for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                    var nextKey = keysArray[nextIndex];
                    var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                    if (desc !== undefined && desc.enumerable) {
                        if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                            Utils.extend(to[nextKey], nextSource[nextKey]);
                        } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                            to[nextKey] = {};
                            Utils.extend(to[nextKey], nextSource[nextKey]);
                        } else {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
        }
        return to;
    }
};
var Support = function Support() {
    return {
        touch: !!("ontouchstart" in win || win.DocumentTouch && (0,_instanceof/* default */.Z)(doc, win.DocumentTouch)),
        pointerEvents: !!win.PointerEvent && "maxTouchPoints" in win.navigator && win.navigator.maxTouchPoints >= 0,
        observer: function checkObserver() {
            return "MutationObserver" in win || "WebkitMutationObserver" in win;
        }(),
        passiveListener: function checkPassiveListener() {
            var supportsPassive = false;
            try {
                var opts = Object.defineProperty({}, "passive", {
                    // eslint-disable-next-line
                    get: function get() {
                        supportsPassive = true;
                    }
                });
                win.addEventListener("testPassiveListener", null, opts);
            } catch (e) {
            // No support
            }
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return "ongesturestart" in win;
        }()
    };
}();
var SwiperClass = /*#__PURE__*/ function() {
    "use strict";
    function SwiperClass() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_class_call_check/* default */.Z)(this, SwiperClass);
        var self = this;
        self.params = params;
        // Events
        self.eventsListeners = {};
        if (self.params && self.params.on) {
            Object.keys(self.params.on).forEach(function(eventName) {
                self.on(eventName, self.params.on[eventName]);
            });
        }
    }
    (0,_create_class/* default */.Z)(SwiperClass, [
        {
            key: "on",
            value: function on(events, handler, priority) {
                var self = this;
                if (typeof handler !== "function") return self;
                var method = priority ? "unshift" : "push";
                events.split(" ").forEach(function(event) {
                    if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
                    self.eventsListeners[event][method](handler);
                });
                return self;
            }
        },
        {
            key: "once",
            value: function once(events, handler, priority) {
                var self = this;
                if (typeof handler !== "function") return self;
                function onceHandler() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    self.off(events, onceHandler);
                    if (onceHandler.f7proxy) {
                        delete onceHandler.f7proxy;
                    }
                    handler.apply(self, args);
                }
                onceHandler.f7proxy = handler;
                return self.on(events, onceHandler, priority);
            }
        },
        {
            key: "off",
            value: function off(events, handler) {
                var self = this;
                if (!self.eventsListeners) return self;
                events.split(" ").forEach(function(event) {
                    if (typeof handler === "undefined") {
                        self.eventsListeners[event] = [];
                    } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
                        self.eventsListeners[event].forEach(function(eventHandler, index) {
                            if (eventHandler === handler || eventHandler.f7proxy && eventHandler.f7proxy === handler) {
                                self.eventsListeners[event].splice(index, 1);
                            }
                        });
                    }
                });
                return self;
            }
        },
        {
            key: "emit",
            value: function emit() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var self = this;
                if (!self.eventsListeners) return self;
                var events;
                var _$data;
                var context;
                if (typeof args[0] === "string" || Array.isArray(args[0])) {
                    events = args[0];
                    _$data = args.slice(1, args.length);
                    context = self;
                } else {
                    events = args[0].events;
                    _$data = args[0].data;
                    context = args[0].context || self;
                }
                var eventsArray = Array.isArray(events) ? events : events.split(" ");
                eventsArray.forEach(function(event) {
                    if (self.eventsListeners && self.eventsListeners[event]) {
                        var handlers = [];
                        self.eventsListeners[event].forEach(function(eventHandler) {
                            handlers.push(eventHandler);
                        });
                        handlers.forEach(function(eventHandler) {
                            eventHandler.apply(context, _$data);
                        });
                    }
                });
                return self;
            }
        },
        {
            key: "useModulesParams",
            value: function useModulesParams(instanceParams) {
                var instance = this;
                if (!instance.modules) return;
                Object.keys(instance.modules).forEach(function(moduleName) {
                    var module = instance.modules[moduleName];
                    // Extend params
                    if (module.params) {
                        Utils.extend(instanceParams, module.params);
                    }
                });
            }
        },
        {
            key: "useModules",
            value: function useModules() {
                var modulesParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var instance = this;
                if (!instance.modules) return;
                Object.keys(instance.modules).forEach(function(moduleName) {
                    var module = instance.modules[moduleName];
                    var moduleParams = modulesParams[moduleName] || {};
                    // Extend instance methods and props
                    if (module.instance) {
                        Object.keys(module.instance).forEach(function(modulePropName) {
                            var moduleProp = module.instance[modulePropName];
                            if (typeof moduleProp === "function") {
                                instance[modulePropName] = moduleProp.bind(instance);
                            } else {
                                instance[modulePropName] = moduleProp;
                            }
                        });
                    }
                    // Add event listeners
                    if (module.on && instance.on) {
                        Object.keys(module.on).forEach(function(moduleEventName) {
                            instance.on(moduleEventName, module.on[moduleEventName]);
                        });
                    }
                    // Module create callback
                    if (module.create) {
                        module.create.bind(instance)(moduleParams);
                    }
                });
            }
        }
    ], [
        {
            key: "components",
            set: function set(components) {
                var Class = this;
                if (!Class.use) return;
                Class.use(components);
            }
        },
        {
            key: "installModule",
            value: function installModule(module) {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    params[_key - 1] = arguments[_key];
                }
                var Class = this;
                if (!Class.prototype.modules) Class.prototype.modules = {};
                var name = module.name || "".concat(Object.keys(Class.prototype.modules).length, "_").concat(Utils.now());
                Class.prototype.modules[name] = module;
                // Prototype
                if (module.proto) {
                    Object.keys(module.proto).forEach(function(key) {
                        Class.prototype[key] = module.proto[key];
                    });
                }
                // Class
                if (module.static) {
                    Object.keys(module.static).forEach(function(key) {
                        Class[key] = module.static[key];
                    });
                }
                // Callback
                if (module.install) {
                    module.install.apply(Class, params);
                }
                return Class;
            }
        },
        {
            key: "use",
            value: function use(module) {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    params[_key - 1] = arguments[_key];
                }
                var _Class;
                var Class = this;
                if (Array.isArray(module)) {
                    module.forEach(function(m) {
                        return Class.installModule(m);
                    });
                    return Class;
                }
                return (_Class = Class).installModule.apply(_Class, [
                    module
                ].concat((0,_to_consumable_array/* default */.Z)(params)));
            }
        }
    ]);
    return SwiperClass;
}();
function updateSize() {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== "undefined") {
        width = swiper.params.width;
    } else {
        width = $el[0].clientWidth;
    }
    if (typeof swiper.params.height !== "undefined") {
        height = swiper.params.height;
    } else {
        height = $el[0].clientHeight;
    }
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
        return;
    }
    // Subtract paddings
    width = width - parseInt($el.css("padding-left"), 10) - parseInt($el.css("padding-right"), 10);
    height = height - parseInt($el.css("padding-top"), 10) - parseInt($el.css("padding-bottom"), 10);
    Utils.extend(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function updateSlides() {
    var slidesForMargin = function slidesForMargin(slideIndex) {
        if (!params.cssMode) return true;
        if (slideIndex === slides.length - 1) {
            return false;
        }
        return true;
    };
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl, swiperSize = swiper.size, rtl = swiper.rtlTranslate, wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children(".".concat(swiper.params.slideClass));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") {
        offsetBefore = params.slidesOffsetBefore.call(swiper);
    }
    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") {
        offsetAfter = params.slidesOffsetAfter.call(swiper);
    }
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.snapGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var _$index = 0;
    if (typeof swiperSize === "undefined") {
        return;
    }
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
        spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    }
    swiper.virtualSize = -spaceBetween;
    // reset margins
    if (rtl) slides.css({
        marginLeft: "",
        marginTop: ""
    });
    else slides.css({
        marginRight: "",
        marginBottom: ""
    });
    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
        if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
            slidesNumberEvenToRows = slidesLength;
        } else {
            slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
        }
        if (params.slidesPerView !== "auto" && params.slidesPerColumnFill === "row") {
            slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
        }
    }
    // Calc slides
    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
    for(var i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        var slide = slides.eq(i);
        if (params.slidesPerColumn > 1) {
            // Set slides order
            var newSlideOrderIndex = void 0;
            var column = void 0;
            var row = void 0;
            if (params.slidesPerColumnFill === "row" && params.slidesPerGroup > 1) {
                var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
                var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
                var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
                row = Math.floor(slideIndexInGroup / columnsInGroup);
                column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
                newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
                slide.css({
                    "-webkit-box-ordinal-group": newSlideOrderIndex,
                    "-moz-box-ordinal-group": newSlideOrderIndex,
                    "-ms-flex-order": newSlideOrderIndex,
                    "-webkit-order": newSlideOrderIndex,
                    order: newSlideOrderIndex
                });
            } else if (params.slidesPerColumnFill === "column") {
                column = Math.floor(i / slidesPerColumn);
                row = i - column * slidesPerColumn;
                if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
                    row += 1;
                    if (row >= slidesPerColumn) {
                        row = 0;
                        column += 1;
                    }
                }
            } else {
                row = Math.floor(i / slidesPerRow);
                column = i - row * slidesPerRow;
            }
            slide.css("margin-".concat(swiper.isHorizontal() ? "top" : "left"), row !== 0 && params.spaceBetween && "".concat(params.spaceBetween, "px"));
        }
        if (slide.css("display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            var slideStyles = win.getComputedStyle(slide[0], null);
            var currentTransform = slide[0].style.transform;
            var currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) {
                slide[0].style.transform = "none";
            }
            if (currentWebKitTransform) {
                slide[0].style.webkitTransform = "none";
            }
            if (params.roundLengths) {
                slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            } else {
                // eslint-disable-next-line
                if (swiper.isHorizontal()) {
                    var width = parseFloat(slideStyles.getPropertyValue("width"));
                    var paddingLeft = parseFloat(slideStyles.getPropertyValue("padding-left"));
                    var paddingRight = parseFloat(slideStyles.getPropertyValue("padding-right"));
                    var marginLeft = parseFloat(slideStyles.getPropertyValue("margin-left"));
                    var marginRight = parseFloat(slideStyles.getPropertyValue("margin-right"));
                    var boxSizing = slideStyles.getPropertyValue("box-sizing");
                    if (boxSizing && boxSizing === "border-box") {
                        slideSize = width + marginLeft + marginRight;
                    } else {
                        slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
                    }
                } else {
                    var height = parseFloat(slideStyles.getPropertyValue("height"));
                    var paddingTop = parseFloat(slideStyles.getPropertyValue("padding-top"));
                    var paddingBottom = parseFloat(slideStyles.getPropertyValue("padding-bottom"));
                    var marginTop = parseFloat(slideStyles.getPropertyValue("margin-top"));
                    var marginBottom = parseFloat(slideStyles.getPropertyValue("margin-bottom"));
                    var boxSizing1 = slideStyles.getPropertyValue("box-sizing");
                    if (boxSizing1 && boxSizing1 === "border-box") {
                        slideSize = height + marginTop + marginBottom;
                    } else {
                        slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
                    }
                }
            }
            if (currentTransform) {
                slide[0].style.transform = currentTransform;
            }
            if (currentWebKitTransform) {
                slide[0].style.webkitTransform = currentWebKitTransform;
            }
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) {
                if (swiper.isHorizontal()) {
                    slides[i].style.width = "".concat(slideSize, "px");
                } else {
                    slides[i].style.height = "".concat(slideSize, "px");
                }
            }
        }
        if (slides[i]) {
            slides[i].swiperSlideSize = slideSize;
        }
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (_$index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((_$index - Math.min(swiper.params.slidesPerGroupSkip, _$index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        _$index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) {
        $wrapperEl.css({
            width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
        });
    }
    if (params.setWrapperSize) {
        if (swiper.isHorizontal()) $wrapperEl.css({
            width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
        });
        else $wrapperEl.css({
            height: "".concat(swiper.virtualSize + params.spaceBetween, "px")
        });
    }
    if (params.slidesPerColumn > 1) {
        swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
        if (swiper.isHorizontal()) $wrapperEl.css({
            width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
        });
        else $wrapperEl.css({
            height: "".concat(swiper.virtualSize + params.spaceBetween, "px")
        });
        if (params.centeredSlides) {
            newSlidesGrid = [];
            for(var i1 = 0; i1 < snapGrid.length; i1 += 1){
                var slidesGridItem = snapGrid[i1];
                if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i1] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid = newSlidesGrid;
        }
    }
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        newSlidesGrid = [];
        for(var i2 = 0; i2 < snapGrid.length; i2 += 1){
            var slidesGridItem1 = snapGrid[i2];
            if (params.roundLengths) slidesGridItem1 = Math.floor(slidesGridItem1);
            if (snapGrid[i2] <= swiper.virtualSize - swiperSize) {
                newSlidesGrid.push(slidesGridItem1);
            }
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
            snapGrid.push(swiper.virtualSize - swiperSize);
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        if (swiper.isHorizontal()) {
            if (rtl) slides.filter(slidesForMargin).css({
                marginLeft: "".concat(spaceBetween, "px")
            });
            else slides.filter(slidesForMargin).css({
                marginRight: "".concat(spaceBetween, "px")
            });
        } else slides.filter(slidesForMargin).css({
            marginBottom: "".concat(spaceBetween, "px")
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        var maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map(function(snap) {
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        var allSlidesSize1 = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize1 += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize1 -= params.spaceBetween;
        if (allSlidesSize1 < swiperSize) {
            var allSlidesOffset = (swiperSize - allSlidesSize1) / 2;
            snapGrid.forEach(function(snap, snapIndex) {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach(function(snap, snapIndex) {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Utils.extend(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (slidesLength !== previousSlidesLength) {
        swiper.emit("slidesLengthChange");
    }
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
        swiper.emit("slidesGridLengthChange");
    }
    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateSlidesOffset();
    }
}
function updateAutoHeight(speed) {
    var swiper = this;
    var activeSlides = [];
    var newHeight = 0;
    var i;
    if (typeof speed === "number") {
        swiper.setTransition(speed);
    } else if (speed === true) {
        swiper.setTransition(swiper.params.speed);
    }
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) {
            swiper.visibleSlides.each(function(index, slide) {
                activeSlides.push(slide);
            });
        } else {
            for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
                var _$index = swiper.activeIndex + i;
                if (_$index > swiper.slides.length) break;
                activeSlides.push(swiper.slides.eq(_$index)[0]);
            }
        }
    } else {
        activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
    }
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1){
        if (typeof activeSlides[i] !== "undefined") {
            var height = activeSlides[i].offsetHeight;
            newHeight = height > newHeight ? height : newHeight;
        }
    }
    // Update Height
    if (newHeight) swiper.$wrapperEl.css("height", "".concat(newHeight, "px"));
}
function updateSlidesOffset() {
    var swiper = this;
    var slides = swiper.slides;
    for(var i = 0; i < slides.length; i += 1){
        slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
    }
}
function updateSlidesProgress() {
    var translate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides, rtl = swiper.rtlTranslate;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
            var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
            var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
            var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
            if (isVisible) {
                swiper.visibleSlides.push(slide);
                swiper.visibleSlidesIndexes.push(i);
                slides.eq(i).addClass(params.slideVisibleClass);
            }
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = $(swiper.visibleSlides);
}
function updateProgress(translate) {
    var swiper = this;
    if (typeof translate === "undefined") {
        var multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress, isBeginning = swiper.isBeginning, isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Utils.extend(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) {
        swiper.emit("reachBeginning toEdge");
    }
    if (isEnd && !wasEnd) {
        swiper.emit("reachEnd toEdge");
    }
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
        swiper.emit("fromEdge");
    }
    swiper.emit("progress", progress);
}
function updateSlidesClasses() {
    var swiper = this;
    var slides = swiper.slides, params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex, realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass("".concat(params.slideActiveClass, " ").concat(params.slideNextClass, " ").concat(params.slidePrevClass, " ").concat(params.slideDuplicateActiveClass, " ").concat(params.slideDuplicateNextClass, " ").concat(params.slideDuplicatePrevClass));
    var activeSlide;
    if (isVirtual) {
        activeSlide = swiper.$wrapperEl.find(".".concat(params.slideClass, '[data-swiper-slide-index="').concat(activeIndex, '"]'));
    } else {
        activeSlide = slides.eq(activeIndex);
    }
    // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) {
            $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ')[data-swiper-slide-index="').concat(realIndex, '"]')).addClass(params.slideDuplicateActiveClass);
        } else {
            $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, '[data-swiper-slide-index="').concat(realIndex, '"]')).addClass(params.slideDuplicateActiveClass);
        }
    }
    // Next Slide
    var nextSlide = activeSlide.nextAll(".".concat(params.slideClass)).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    }
    // Prev Slide
    var prevSlide = activeSlide.prevAll(".".concat(params.slideClass)).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) {
            $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ')[data-swiper-slide-index="').concat(nextSlide.attr("data-swiper-slide-index"), '"]')).addClass(params.slideDuplicateNextClass);
        } else {
            $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, '[data-swiper-slide-index="').concat(nextSlide.attr("data-swiper-slide-index"), '"]')).addClass(params.slideDuplicateNextClass);
        }
        if (prevSlide.hasClass(params.slideDuplicateClass)) {
            $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ')[data-swiper-slide-index="').concat(prevSlide.attr("data-swiper-slide-index"), '"]')).addClass(params.slideDuplicatePrevClass);
        } else {
            $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, '[data-swiper-slide-index="').concat(prevSlide.attr("data-swiper-slide-index"), '"]')).addClass(params.slideDuplicatePrevClass);
        }
    }
}
function updateActiveIndex(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid, snapGrid = swiper.snapGrid, params = swiper.params, previousIndex = swiper.activeIndex, previousRealIndex = swiper.realIndex, previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === "undefined") {
        for(var i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== "undefined") {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
                    activeIndex = i;
                } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
                    activeIndex = i + 1;
                }
            } else if (translate >= slidesGrid[i]) {
                activeIndex = i;
            }
        }
        // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) {
        snapIndex = snapGrid.indexOf(translate);
    } else {
        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    }
    // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") || activeIndex, 10);
    Utils.extend(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) {
        swiper.emit("realIndexChange");
    }
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        swiper.emit("slideChange");
    }
}
function updateClickedSlide(e) {
    var swiper = this;
    var params = swiper.params;
    var slide = $(e.target).closest(".".concat(params.slideClass))[0];
    var slideFound = false;
    if (slide) {
        for(var i = 0; i < swiper.slides.length; i += 1){
            if (swiper.slides[i] === slide) slideFound = true;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) {
            swiper.clickedIndex = parseInt($(slide).attr("data-swiper-slide-index"), 10);
        } else {
            swiper.clickedIndex = $(slide).index();
        }
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
        swiper.slideToClickedSlide();
    }
}
var update = {
    updateSize: updateSize,
    updateSlides: updateSlides,
    updateAutoHeight: updateAutoHeight,
    updateSlidesOffset: updateSlidesOffset,
    updateSlidesProgress: updateSlidesProgress,
    updateProgress: updateProgress,
    updateSlidesClasses: updateSlidesClasses,
    updateActiveIndex: updateActiveIndex,
    updateClickedSlide: updateClickedSlide
};
function getTranslate() {
    var axis = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.isHorizontal() ? "x" : "y";
    var swiper = this;
    var params = swiper.params, rtl = swiper.rtlTranslate, translate = swiper.translate, $wrapperEl = swiper.$wrapperEl;
    if (params.virtualTranslate) {
        return rtl ? -translate : translate;
    }
    if (params.cssMode) {
        return translate;
    }
    var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function setTranslate(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate, params = swiper.params, $wrapperEl = swiper.$wrapperEl, wrapperEl = swiper.wrapperEl, progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) {
        x = rtl ? -translate : translate;
    } else {
        y = translate;
    }
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) {
        wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    } else if (!params.virtualTranslate) {
        $wrapperEl.transform("translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)"));
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
        newProgress = 0;
    } else {
        newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== progress) {
        swiper.updateProgress(translate);
    }
    swiper.emit("setTranslate", swiper.translate, byController);
}
function minTranslate() {
    return -this.snapGrid[0];
}
function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo() {
    var translate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, translateBounds = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, internal = arguments.length > 4 ? arguments[4] : void 0;
    var swiper = this;
    var params = swiper.params, wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) {
        return false;
    }
    var _$minTranslate = swiper.minTranslate();
    var _$maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > _$minTranslate) newTranslate = _$minTranslate;
    else if (translateBounds && translate < _$maxTranslate) newTranslate = _$maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        if (speed === 0) {
            wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        } else {
            // eslint-disable-next-line
            if (wrapperEl.scrollTo) {
                var _obj;
                wrapperEl.scrollTo((_obj = {}, (0,_define_property/* default */.Z)(_obj, isH ? "left" : "top", -newTranslate), (0,_define_property/* default */.Z)(_obj, "behavior", "smooth"), _obj));
            } else {
                wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
            }
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) {
                swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                    if (!swiper || swiper.destroyed) return;
                    if (e.target !== this) return;
                    swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                    swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
                    swiper.onTranslateToWrapperTransitionEnd = null;
                    delete swiper.onTranslateToWrapperTransitionEnd;
                    if (runCallbacks) {
                        swiper.emit("transitionEnd");
                    }
                };
            }
            swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var translate = {
    getTranslate: getTranslate,
    setTranslate: setTranslate,
    minTranslate: minTranslate,
    maxTranslate: maxTranslate,
    translateTo: translateTo
};
function setTransition(duration, byController) {
    var swiper = this;
    if (!swiper.params.cssMode) {
        swiper.$wrapperEl.transition(duration);
    }
    swiper.emit("setTransition", duration, byController);
}
function transitionStart() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, direction = arguments.length > 1 ? arguments[1] : void 0;
    var swiper = this;
    var activeIndex = swiper.activeIndex, params = swiper.params, previousIndex = swiper.previousIndex;
    if (params.cssMode) return;
    if (params.autoHeight) {
        swiper.updateAutoHeight();
    }
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit("transitionStart");
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit("slideResetTransitionStart");
            return;
        }
        swiper.emit("slideChangeTransitionStart");
        if (dir === "next") {
            swiper.emit("slideNextTransitionStart");
        } else {
            swiper.emit("slidePrevTransitionStart");
        }
    }
}
function swiper_esm_bundle_transitionEnd() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, direction = arguments.length > 1 ? arguments[1] : void 0;
    var swiper = this;
    var activeIndex = swiper.activeIndex, previousIndex = swiper.previousIndex, params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit("transitionEnd");
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit("slideResetTransitionEnd");
            return;
        }
        swiper.emit("slideChangeTransitionEnd");
        if (dir === "next") {
            swiper.emit("slideNextTransitionEnd");
        } else {
            swiper.emit("slidePrevTransitionEnd");
        }
    }
}
var swiper_esm_bundle_transition = {
    setTransition: setTransition,
    transitionStart: transitionStart,
    transitionEnd: swiper_esm_bundle_transitionEnd
};
function slideTo() {
    var _$index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, internal = arguments.length > 3 ? arguments[3] : void 0;
    var swiper = this;
    var slideIndex = _$index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate, wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) {
        return false;
    }
    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
        swiper.emit("beforeSlideChangeStart");
    }
    var translate = -snapGrid[snapIndex];
    // Update progress
    swiper.updateProgress(translate);
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        for(var i = 0; i < slidesGrid.length; i += 1){
            if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
                slideIndex = i;
            }
        }
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
            return false;
        }
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    var direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) {
            swiper.updateAutoHeight();
        }
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") {
            swiper.setTranslate(translate);
        }
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var t = -translate;
        if (rtl) {
            t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
        }
        if (speed === 0) {
            wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
        } else {
            // eslint-disable-next-line
            if (wrapperEl.scrollTo) {
                var _obj;
                wrapperEl.scrollTo((_obj = {}, (0,_define_property/* default */.Z)(_obj, isH ? "left" : "top", t), (0,_define_property/* default */.Z)(_obj, "behavior", "smooth"), _obj));
            } else {
                wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            }
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onSlideToWrapperTransitionEnd) {
                swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
                    if (!swiper || swiper.destroyed) return;
                    if (e.target !== this) return;
                    swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
                    swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
                    swiper.onSlideToWrapperTransitionEnd = null;
                    delete swiper.onSlideToWrapperTransitionEnd;
                    swiper.transitionEnd(runCallbacks, direction);
                };
            }
            swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
        }
    }
    return true;
}
function slideToLoop() {
    var _$index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, internal = arguments.length > 3 ? arguments[3] : void 0;
    var swiper = this;
    var newIndex = _$index;
    if (swiper.params.loop) {
        newIndex += swiper.loopedSlides;
    }
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function slideNext() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    var params = swiper.params, animating = swiper.animating;
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;
    if (params.loop) {
        if (animating) return false;
        swiper.loopFix();
        // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function slidePrev() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var normalize = function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    };
    var swiper = this;
    var params = swiper.params, animating = swiper.animating, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, rtlTranslate = swiper.rtlTranslate;
    if (params.loop) {
        if (animating) return false;
        swiper.loopFix();
        // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function(val) {
        return normalize(val);
    });
    var normalizedSlidesGrid = slidesGrid.map(function(val) {
        return normalize(val);
    });
    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        snapGrid.forEach(function(snap) {
            if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
        });
    }
    var prevIndex;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function slideReset() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function slideToClosest() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0, threshold = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
    var swiper = this;
    var _$index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, _$index);
    var snapIndex = skip + Math.floor((_$index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
            _$index += swiper.params.slidesPerGroup;
        }
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        var prevSnap = swiper.snapGrid[snapIndex - 1];
        var currentSnap1 = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap1 - prevSnap) * threshold) {
            _$index -= swiper.params.slidesPerGroup;
        }
    }
    _$index = Math.max(_$index, 0);
    _$index = Math.min(_$index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(_$index, speed, runCallbacks, internal);
}
function slideToClickedSlide() {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl;
    var slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt($(swiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(".".concat(params.slideClass, '[data-swiper-slide-index="').concat(realIndex, '"]:not(.').concat(params.slideDuplicateClass, ")")).eq(0).index();
                Utils.nextTick(function() {
                    swiper.slideTo(slideToIndex);
                });
            } else {
                swiper.slideTo(slideToIndex);
            }
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(".".concat(params.slideClass, '[data-swiper-slide-index="').concat(realIndex, '"]:not(.').concat(params.slideDuplicateClass, ")")).eq(0).index();
            Utils.nextTick(function() {
                swiper.slideTo(slideToIndex);
            });
        } else {
            swiper.slideTo(slideToIndex);
        }
    } else {
        swiper.slideTo(slideToIndex);
    }
}
var slide = {
    slideTo: slideTo,
    slideToLoop: slideToLoop,
    slideNext: slideNext,
    slidePrev: slidePrev,
    slideReset: slideReset,
    slideToClosest: slideToClosest,
    slideToClickedSlide: slideToClickedSlide
};
function loopCreate() {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl;
    // Remove duplicated slides
    $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass)).remove();
    var slides = $wrapperEl.children(".".concat(params.slideClass));
    if (params.loopFillGroupWithBlank) {
        var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(var i = 0; i < blankSlidesNum; i += 1){
                var blankNode = $(doc.createElement("div")).addClass("".concat(params.slideClass, " ").concat(params.slideBlankClass));
                $wrapperEl.append(blankNode);
            }
            slides = $wrapperEl.children(".".concat(params.slideClass));
        }
    }
    if (params.slidesPerView === "auto" && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) {
        swiper.loopedSlides = slides.length;
    }
    var prependSlides = [];
    var appendSlides = [];
    slides.each(function(index, el) {
        var slide = $(el);
        if (index < swiper.loopedSlides) appendSlides.push(el);
        if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
        slide.attr("data-swiper-slide-index", index);
    });
    for(var i1 = 0; i1 < appendSlides.length; i1 += 1){
        $wrapperEl.append($(appendSlides[i1].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
    for(var i2 = prependSlides.length - 1; i2 >= 0; i2 -= 1){
        $wrapperEl.prepend($(prependSlides[i2].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
}
function loopFix() {
    var swiper = this;
    swiper.emit("beforeLoopFix");
    var activeIndex = swiper.activeIndex, slides = swiper.slides, loopedSlides = swiper.loopedSlides, allowSlidePrev = swiper.allowSlidePrev, allowSlideNext = swiper.allowSlideNext, snapGrid = swiper.snapGrid, rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate();
    // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        var slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) {
            swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
        }
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        var slideChanged1 = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged1 && diff !== 0) {
            swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
}
function loopDestroy() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params, slides = swiper.slides;
    $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, ",.").concat(params.slideClass, ".").concat(params.slideBlankClass)).remove();
    slides.removeAttr("data-swiper-slide-index");
}
var loop = {
    loopCreate: loopCreate,
    loopFix: loopFix,
    loopDestroy: loopDestroy
};
function setGrabCursor(moving) {
    var swiper = this;
    if (Support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.el;
    el.style.cursor = "move";
    el.style.cursor = moving ? "-webkit-grabbing" : "-webkit-grab";
    el.style.cursor = moving ? "-moz-grabbin" : "-moz-grab";
    el.style.cursor = moving ? "grabbing" : "grab";
}
function unsetGrabCursor() {
    var swiper = this;
    if (Support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper.el.style.cursor = "";
}
var grabCursor = {
    setGrabCursor: setGrabCursor,
    unsetGrabCursor: unsetGrabCursor
};
function appendSlide(slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params;
    if (params.loop) {
        swiper.loopDestroy();
    }
    if (typeof slides === "object" && "length" in slides) {
        for(var i = 0; i < slides.length; i += 1){
            if (slides[i]) $wrapperEl.append(slides[i]);
        }
    } else {
        $wrapperEl.append(slides);
    }
    if (params.loop) {
        swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
        swiper.update();
    }
}
function prependSlide(slides) {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex;
    if (params.loop) {
        swiper.loopDestroy();
    }
    var newActiveIndex = activeIndex + 1;
    if (typeof slides === "object" && "length" in slides) {
        for(var i = 0; i < slides.length; i += 1){
            if (slides[i]) $wrapperEl.prepend(slides[i]);
        }
        newActiveIndex = activeIndex + slides.length;
    } else {
        $wrapperEl.prepend(slides);
    }
    if (params.loop) {
        swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
        swiper.update();
    }
    swiper.slideTo(newActiveIndex, 0, false);
}
function addSlide(index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(".".concat(params.slideClass));
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];
    for(var i = baseLength - 1; i >= index; i -= 1){
        var currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(var i1 = 0; i1 < slides.length; i1 += 1){
            if (slides[i1]) $wrapperEl.append(slides[i1]);
        }
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else {
        $wrapperEl.append(slides);
    }
    for(var i2 = 0; i2 < slidesBuffer.length; i2 += 1){
        $wrapperEl.append(slidesBuffer[i2]);
    }
    if (params.loop) {
        swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
        swiper.update();
    }
    if (params.loop) {
        swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
        swiper.slideTo(newActiveIndex, 0, false);
    }
}
function removeSlide(slidesIndexes) {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(".".concat(params.slideClass));
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(var i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) {
        swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
        swiper.update();
    }
    if (params.loop) {
        swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
        swiper.slideTo(newActiveIndex, 0, false);
    }
}
function removeAllSlides() {
    var swiper = this;
    var slidesIndexes = [];
    for(var i = 0; i < swiper.slides.length; i += 1){
        slidesIndexes.push(i);
    }
    swiper.removeSlide(slidesIndexes);
}
var manipulation = {
    appendSlide: appendSlide,
    prependSlide: prependSlide,
    addSlide: addSlide,
    removeSlide: removeSlide,
    removeAllSlides: removeAllSlides
};
var Device = function Device() {
    var platform = win.navigator.platform;
    var ua = win.navigator.userAgent;
    var device = {
        ios: false,
        android: false,
        androidChrome: false,
        desktop: false,
        iphone: false,
        ipod: false,
        ipad: false,
        edge: false,
        ie: false,
        firefox: false,
        macos: false,
        windows: false,
        cordova: !!(win.cordova || win.phonegap),
        phonegap: !!(win.cordova || win.phonegap),
        electron: false
    };
    var screenWidth = win.screen.width;
    var screenHeight = win.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var ie = ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
    var edge = ua.indexOf("Edge/") >= 0;
    var firefox = ua.indexOf("Gecko/") >= 0 && ua.indexOf("Firefox/") >= 0;
    var windows = platform === "Win32";
    var electron = ua.toLowerCase().indexOf("electron") >= 0;
    var macos = platform === "MacIntel";
    // iPadOs 13 fix
    if (!ipad && macos && Support.touch && (screenWidth === 1024 && screenHeight === 1366 // Pro 12.9
     || screenWidth === 834 && screenHeight === 1194 // Pro 11
     || screenWidth === 834 && screenHeight === 1112 // Pro 10.5
     || screenWidth === 768 && screenHeight === 1024 // other
    )) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        macos = false;
    }
    device.ie = ie;
    device.edge = edge;
    device.firefox = firefox;
    // Android
    if (android && !windows) {
        device.os = "android";
        device.osVersion = android[2];
        device.android = true;
        device.androidChrome = ua.toLowerCase().indexOf("chrome") >= 0;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // iOS
    if (iphone && !ipod) {
        device.osVersion = iphone[2].replace(/_/g, ".");
        device.iphone = true;
    }
    if (ipad) {
        device.osVersion = ipad[2].replace(/_/g, ".");
        device.ipad = true;
    }
    if (ipod) {
        device.osVersion = ipod[3] ? ipod[3].replace(/_/g, ".") : null;
        device.ipod = true;
    }
    // iOS 8+ changed UA
    if (device.ios && device.osVersion && ua.indexOf("Version/") >= 0) {
        if (device.osVersion.split(".")[0] === "10") {
            device.osVersion = ua.toLowerCase().split("version/")[1].split(" ")[0];
        }
    }
    // Webview
    device.webView = !!((iphone || ipad || ipod) && (ua.match(/.*AppleWebKit(?!.*Safari)/i) || win.navigator.standalone)) || win.matchMedia && win.matchMedia("(display-mode: standalone)").matches;
    device.webview = device.webView;
    device.standalone = device.webView;
    // Desktop
    device.desktop = !(device.ios || device.android) || electron;
    if (device.desktop) {
        device.electron = electron;
        device.macos = macos;
        device.windows = windows;
        if (device.macos) {
            device.os = "macos";
        }
        if (device.windows) {
            device.os = "windows";
        }
    }
    // Pixel Ratio
    device.pixelRatio = win.devicePixelRatio || 1;
    // Export object
    return device;
}();
function onTouchStart(event) {
    var swiper = this;
    var _$data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches;
    if (swiper.animating && params.preventInteractionOnTransition) {
        return;
    }
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var $targetEl = $(e.target);
    if (params.touchEventsTarget === "wrapper") {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    _$data.isTouchEvent = e.type === "touchstart";
    if (!_$data.isTouchEvent && "which" in e && e.which === 3) return;
    if (!_$data.isTouchEvent && "button" in e && e.button > 0) return;
    if (_$data.isTouched && _$data.isMoved) return;
    if (params.noSwiping && $targetEl.closest(params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass))[0]) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= win.screen.width - edgeSwipeThreshold)) {
        return;
    }
    Utils.extend(_$data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    _$data.touchStartTime = Utils.now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) _$data.allowThresholdMove = false;
    if (e.type !== "touchstart") {
        var preventDefault = true;
        if ($targetEl.is(_$data.formElements)) preventDefault = false;
        if (doc.activeElement && $(doc.activeElement).is(_$data.formElements) && doc.activeElement !== $targetEl[0]) {
            doc.activeElement.blur();
        }
        var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if (params.touchStartForcePreventDefault || shouldPreventDefault) {
            e.preventDefault();
        }
    }
    swiper.emit("touchStart", e);
}
function onTouchMove(event) {
    /*
   * Fix for Safari where blurring inputs/selects within swiper doesn't trigger swiper's "ontouchend" event.
   * As a workaround we check if any buttons are truly pressed (or touches performed) on "touchmove".
   * Inconsistency results in allowing the opposite touch state.
   */ if (Browser.isSafari && Device.desktop && !!event.buttons !== this.allowTouchMove) {
        this.allowTouchMove = !!event.buttons;
    }
    var swiper = this;
    var _$data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!_$data.isTouched) {
        if (_$data.startMoving && _$data.isScrolling) {
            swiper.emit("touchMoveOpposite", e);
        }
        return;
    }
    if (_$data.isTouchEvent && e.type !== "touchmove") return;
    var targetTouch = e.type === "touchmove" && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    var pageX = e.type === "touchmove" ? targetTouch.pageX : e.pageX;
    var pageY = e.type === "touchmove" ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        // isMoved = true;
        swiper.allowClick = false;
        if (_$data.isTouched) {
            Utils.extend(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            _$data.touchStartTime = Utils.now();
        }
        return;
    }
    if (_$data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) {
            // Vertical
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                _$data.isTouched = false;
                _$data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
            return;
        }
    }
    if (_$data.isTouchEvent && doc.activeElement) {
        if (e.target === doc.activeElement && $(e.target).is(_$data.formElements)) {
            _$data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (_$data.allowTouchCallbacks) {
        swiper.emit("touchMove", e);
    }
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof _$data.isScrolling === "undefined") {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
            _$data.isScrolling = false;
        } else {
            // eslint-disable-next-line
            if (diffX * diffX + diffY * diffY >= 25) {
                touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
                _$data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
            }
        }
    }
    if (_$data.isScrolling) {
        swiper.emit("touchMoveOpposite", e);
    }
    if (typeof _$data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
            _$data.startMoving = true;
        }
    }
    if (_$data.isScrolling) {
        _$data.isTouched = false;
        return;
    }
    if (!_$data.startMoving) {
        return;
    }
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) {
        e.preventDefault();
    }
    if (params.touchMoveStopPropagation && !params.nested) {
        e.stopPropagation();
    }
    if (!_$data.isMoved) {
        if (params.loop) {
            swiper.loopFix();
        }
        _$data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
        }
        _$data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
            swiper.setGrabCursor(true);
        }
        swiper.emit("sliderFirstMove", e);
    }
    swiper.emit("sliderMove", e);
    _$data.isMoved = true;
    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    _$data.currentTranslate = diff + _$data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
        resistanceRatio = 0;
    }
    if (diff > 0 && _$data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) _$data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + _$data.startTranslate + diff, resistanceRatio);
    } else if (diff < 0 && _$data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) _$data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - _$data.startTranslate - diff, resistanceRatio);
    }
    if (disableParentSwiper) {
        e.preventedByNestedSwiper = true;
    }
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && _$data.currentTranslate < _$data.startTranslate) {
        _$data.currentTranslate = _$data.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && _$data.currentTranslate > _$data.startTranslate) {
        _$data.currentTranslate = _$data.startTranslate;
    }
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || _$data.allowThresholdMove) {
            if (!_$data.allowThresholdMove) {
                _$data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                _$data.currentTranslate = _$data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            _$data.currentTranslate = _$data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
        // Velocity
        if (_$data.velocities.length === 0) {
            _$data.velocities.push({
                position: touches[swiper.isHorizontal() ? "startX" : "startY"],
                time: _$data.touchStartTime
            });
        }
        _$data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: Utils.now()
        });
    }
    // Update progress
    swiper.updateProgress(_$data.currentTranslate);
    // Update translate
    swiper.setTranslate(_$data.currentTranslate);
}
function onTouchEnd(event) {
    var swiper = this;
    var _$data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, $wrapperEl = swiper.$wrapperEl, slidesGrid = swiper.slidesGrid, snapGrid = swiper.snapGrid;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (_$data.allowTouchCallbacks) {
        swiper.emit("touchEnd", e);
    }
    _$data.allowTouchCallbacks = false;
    if (!_$data.isTouched) {
        if (_$data.isMoved && params.grabCursor) {
            swiper.setGrabCursor(false);
        }
        _$data.isMoved = false;
        _$data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && _$data.isMoved && _$data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(false);
    }
    // Time diff
    var touchEndTime = Utils.now();
    var timeDiff = touchEndTime - _$data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        swiper.updateClickedSlide(e);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - _$data.lastClickTime < 300) {
            swiper.emit("doubleTap doubleClick", e);
        }
    }
    _$data.lastClickTime = Utils.now();
    Utils.nextTick(function() {
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!_$data.isTouched || !_$data.isMoved || !swiper.swipeDirection || touches.diff === 0 || _$data.currentTranslate === _$data.startTranslate) {
        _$data.isTouched = false;
        _$data.isMoved = false;
        _$data.startMoving = false;
        return;
    }
    _$data.isTouched = false;
    _$data.isMoved = false;
    _$data.startMoving = false;
    var currentPos;
    if (params.followFinger) {
        currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
        currentPos = -_$data.currentTranslate;
    }
    if (params.cssMode) {
        return;
    }
    if (params.freeMode) {
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) {
                swiper.slideTo(snapGrid.length - 1);
            } else {
                swiper.slideTo(swiper.slides.length - 1);
            }
            return;
        }
        if (params.freeModeMomentum) {
            if (_$data.velocities.length > 1) {
                var lastMoveEvent = _$data.velocities.pop();
                var velocityEvent = _$data.velocities.pop();
                var distance = lastMoveEvent.position - velocityEvent.position;
                var time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
                    swiper.velocity = 0;
                }
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || Utils.now() - lastMoveEvent.time > 300) {
                    swiper.velocity = 0;
                }
            } else {
                swiper.velocity = 0;
            }
            swiper.velocity *= params.freeModeMomentumVelocityRatio;
            _$data.velocities.length = 0;
            var momentumDuration = 1000 * params.freeModeMomentumRatio;
            var momentumDistance = swiper.velocity * momentumDuration;
            var newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            var doBounce = false;
            var afterBouncePosition;
            var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
            var needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeModeMomentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) {
                        newPosition = swiper.maxTranslate() - bounceAmount;
                    }
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    _$data.allowMomentumBounce = true;
                } else {
                    newPosition = swiper.maxTranslate();
                }
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeModeMomentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) {
                        newPosition = swiper.minTranslate() + bounceAmount;
                    }
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    _$data.allowMomentumBounce = true;
                } else {
                    newPosition = swiper.minTranslate();
                }
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeModeSticky) {
                var nextSlide;
                for(var j = 0; j < snapGrid.length; j += 1){
                    if (snapGrid[j] > -newPosition) {
                        nextSlide = j;
                        break;
                    }
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") {
                    newPosition = snapGrid[nextSlide];
                } else {
                    newPosition = snapGrid[nextSlide - 1];
                }
                newPosition = -newPosition;
            }
            if (needsLoopFix) {
                swiper.once("transitionEnd", function() {
                    swiper.loopFix();
                });
            }
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) {
                    momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                } else {
                    momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                }
                if (params.freeModeSticky) {
                    // If freeModeSticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) {
                        momentumDuration = params.speed;
                    } else if (moveDistance < 2 * currentSlideSize) {
                        momentumDuration = params.speed * 1.5;
                    } else {
                        momentumDuration = params.speed * 2.5;
                    }
                }
            } else if (params.freeModeSticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeModeMomentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(function() {
                    if (!swiper || swiper.destroyed || !_$data.allowMomentumBounce) return;
                    swiper.emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(function() {
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(function() {
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(function() {
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else {
                swiper.updateProgress(newPosition);
            }
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeModeSticky) {
            swiper.slideToClosest();
            return;
        }
        if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        return;
    }
    // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for(var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        var increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment1 = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment1);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment1);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") {
                swiper.slideTo(stopIndex + increment1);
            }
            if (swiper.swipeDirection === "prev") {
                swiper.slideTo(stopIndex);
            }
        } else if (e.target === swiper.navigation.nextEl) {
            swiper.slideTo(stopIndex + increment1);
        } else {
            swiper.slideTo(stopIndex);
        }
    }
}
function onResize() {
    var swiper = this;
    var params = swiper.params, el = swiper.el;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) {
        swiper.setBreakpoint();
    }
    // Save locks
    var allowSlideNext = swiper.allowSlideNext, allowSlidePrev = swiper.allowSlidePrev, snapGrid = swiper.snapGrid;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.run();
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
    }
}
function onClick(e) {
    var swiper = this;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function onScroll() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl, rtlTranslate = swiper.rtlTranslate;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) {
        if (rtlTranslate) {
            swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
        } else {
            swiper.translate = -wrapperEl.scrollLeft;
        }
    } else {
        swiper.translate = -wrapperEl.scrollTop;
    }
    // eslint-disable-next-line
    if (swiper.translate === -0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
        newProgress = 0;
    } else {
        newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== swiper.progress) {
        swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    }
    swiper.emit("setTranslate", swiper.translate, false);
}
var dummyEventAttached = false;
function dummyEventListener() {}
function attachEvents() {
    var swiper = this;
    var params = swiper.params, touchEvents = swiper.touchEvents, el = swiper.el, wrapperEl = swiper.wrapperEl;
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
    if (params.cssMode) {
        swiper.onScroll = onScroll.bind(swiper);
    }
    swiper.onClick = onClick.bind(swiper);
    var capture = !!params.nested;
    // Touch Events
    if (!Support.touch && Support.pointerEvents) {
        el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
        if (Support.touch) {
            var passiveListener = touchEvents.start === "touchstart" && Support.passiveListener && params.passiveListeners ? {
                passive: true,
                capture: false
            } : false;
            el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
            el.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? {
                passive: false,
                capture: capture
            } : capture);
            el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
            if (touchEvents.cancel) {
                el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
            }
            if (!dummyEventAttached) {
                doc.addEventListener("touchstart", dummyEventListener);
                dummyEventAttached = true;
            }
        }
        if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
            el.addEventListener("mousedown", swiper.onTouchStart, false);
            doc.addEventListener("mousemove", swiper.onTouchMove, capture);
            doc.addEventListener("mouseup", swiper.onTouchEnd, false);
        }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
        el.addEventListener("click", swiper.onClick, true);
    }
    if (params.cssMode) {
        wrapperEl.addEventListener("scroll", swiper.onScroll);
    }
    // Resize handler
    if (params.updateOnWindowResize) {
        swiper.on(Device.ios || Device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
    } else {
        swiper.on("observerUpdate", onResize, true);
    }
}
function detachEvents() {
    var swiper = this;
    var params = swiper.params, touchEvents = swiper.touchEvents, el = swiper.el, wrapperEl = swiper.wrapperEl;
    var capture = !!params.nested;
    // Touch Events
    if (!Support.touch && Support.pointerEvents) {
        el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
        if (Support.touch) {
            var passiveListener = touchEvents.start === "onTouchStart" && Support.passiveListener && params.passiveListeners ? {
                passive: true,
                capture: false
            } : false;
            el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
            el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
            el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
            if (touchEvents.cancel) {
                el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
            }
        }
        if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
            el.removeEventListener("mousedown", swiper.onTouchStart, false);
            doc.removeEventListener("mousemove", swiper.onTouchMove, capture);
            doc.removeEventListener("mouseup", swiper.onTouchEnd, false);
        }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
        el.removeEventListener("click", swiper.onClick, true);
    }
    if (params.cssMode) {
        wrapperEl.removeEventListener("scroll", swiper.onScroll);
    }
    // Resize handler
    swiper.off(Device.ios || Device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize);
}
var events = {
    attachEvents: attachEvents,
    detachEvents: detachEvents
};
function setBreakpoint() {
    var swiper = this;
    var activeIndex = swiper.activeIndex, initialized = swiper.initialized, _loopedSlides = swiper.loopedSlides, loopedSlides = _loopedSlides === void 0 ? 0 : _loopedSlides, params = swiper.params, $el = swiper.$el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints);
    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
        var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
        if (breakpointOnlyParams) {
            [
                "slidesPerView",
                "spaceBetween",
                "slidesPerGroup",
                "slidesPerGroupSkip",
                "slidesPerColumn"
            ].forEach(function(param) {
                var paramValue = breakpointOnlyParams[param];
                if (typeof paramValue === "undefined") return;
                if (param === "slidesPerView" && (paramValue === "AUTO" || paramValue === "auto")) {
                    breakpointOnlyParams[param] = "auto";
                } else if (param === "slidesPerView") {
                    breakpointOnlyParams[param] = parseFloat(paramValue);
                } else {
                    breakpointOnlyParams[param] = parseInt(paramValue, 10);
                }
            });
        }
        var breakpointParams = breakpointOnlyParams || swiper.originalParams;
        var wasMultiRow = params.slidesPerColumn > 1;
        var isMultiRow = breakpointParams.slidesPerColumn > 1;
        if (wasMultiRow && !isMultiRow) {
            $el.removeClass("".concat(params.containerModifierClass, "multirow ").concat(params.containerModifierClass, "multirow-column"));
        } else if (!wasMultiRow && isMultiRow) {
            $el.addClass("".concat(params.containerModifierClass, "multirow"));
            if (breakpointParams.slidesPerColumnFill === "column") {
                $el.addClass("".concat(params.containerModifierClass, "multirow-column"));
            }
        }
        var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
        var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
        if (directionChanged && initialized) {
            swiper.changeDirection();
        }
        Utils.extend(swiper.params, breakpointParams);
        Utils.extend(swiper, {
            allowTouchMove: swiper.params.allowTouchMove,
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev
        });
        swiper.currentBreakpoint = breakpoint;
        if (needsReLoop && initialized) {
            swiper.loopDestroy();
            swiper.loopCreate();
            swiper.updateSlides();
            swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
        }
        swiper.emit("breakpoint", breakpointParams);
    }
}
function getBreakpoint(breakpoints) {
    // Get breakpoint for window width
    if (!breakpoints) return undefined;
    var breakpoint = false;
    var points = Object.keys(breakpoints).map(function(point) {
        if (typeof point === "string" && point.indexOf("@") === 0) {
            var minRatio = parseFloat(point.substr(1));
            var value = win.innerHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort(function(a, b) {
        return parseInt(a.value, 10) - parseInt(b.value, 10);
    });
    for(var i = 0; i < points.length; i += 1){
        var _i = points[i], point = _i.point, value = _i.value;
        if (value <= win.innerWidth) {
            breakpoint = point;
        }
    }
    return breakpoint || "max";
}
var breakpoints = {
    setBreakpoint: setBreakpoint,
    getBreakpoint: getBreakpoint
};
function addClasses() {
    var swiper = this;
    var classNames = swiper.classNames, params = swiper.params, rtl = swiper.rtl, $el = swiper.$el;
    var suffixes = [];
    suffixes.push("initialized");
    suffixes.push(params.direction);
    if (params.freeMode) {
        suffixes.push("free-mode");
    }
    if (params.autoHeight) {
        suffixes.push("autoheight");
    }
    if (rtl) {
        suffixes.push("rtl");
    }
    if (params.slidesPerColumn > 1) {
        suffixes.push("multirow");
        if (params.slidesPerColumnFill === "column") {
            suffixes.push("multirow-column");
        }
    }
    if (Device.android) {
        suffixes.push("android");
    }
    if (Device.ios) {
        suffixes.push("ios");
    }
    if (params.cssMode) {
        suffixes.push("css-mode");
    }
    suffixes.forEach(function(suffix) {
        classNames.push(params.containerModifierClass + suffix);
    });
    $el.addClass(classNames.join(" "));
}
function removeClasses() {
    var swiper = this;
    var $el = swiper.$el, classNames = swiper.classNames;
    $el.removeClass(classNames.join(" "));
}
var classes = {
    addClasses: addClasses,
    removeClasses: removeClasses
};
function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
    var onReady = function onReady() {
        if (callback) callback();
    };
    var image;
    var isPicture = $(imageEl).parent("picture")[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new win.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) {
                image.sizes = sizes;
            }
            if (srcset) {
                image.srcset = srcset;
            }
            if (src) {
                image.src = src;
            }
        } else {
            onReady();
        }
    } else {
        // image already loaded...
        onReady();
    }
}
function preloadImages() {
    var onReady = function onReady() {
        if (typeof swiper === "undefined" || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit("imagesReady");
        }
    };
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find("img");
    for(var i = 0; i < swiper.imagesToLoad.length; i += 1){
        var imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute("src"), imageEl.srcset || imageEl.getAttribute("srcset"), imageEl.sizes || imageEl.getAttribute("sizes"), true, onReady);
    }
}
var swiper_esm_bundle_images = {
    loadImage: loadImage,
    preloadImages: preloadImages
};
function checkOverflow() {
    var swiper = this;
    var params = swiper.params;
    var wasLocked = swiper.isLocked;
    var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;
    if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
        swiper.isLocked = lastSlidePosition <= swiper.size;
    } else {
        swiper.isLocked = swiper.snapGrid.length === 1;
    }
    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked;
    // events
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
    if (wasLocked && wasLocked !== swiper.isLocked) {
        swiper.isEnd = false;
        if (swiper.navigation) swiper.navigation.update();
    }
}
var checkOverflow$1 = {
    checkOverflow: checkOverflow
};
var defaults = {
    init: true,
    direction: "horizontal",
    touchEventsTarget: "container",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    //
    preventInteractionOnTransition: false,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // Breakpoints
    breakpoints: undefined,
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: "column",
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    // NS
    containerModifierClass: "swiper-container-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    // Callbacks
    runCallbacksOnInit: true
};
/* eslint no-param-reassign: "off" */ var prototypes = {
    update: update,
    translate: translate,
    transition: swiper_esm_bundle_transition,
    slide: slide,
    loop: loop,
    grabCursor: grabCursor,
    manipulation: manipulation,
    events: events,
    breakpoints: breakpoints,
    checkOverflow: checkOverflow$1,
    classes: classes,
    images: swiper_esm_bundle_images
};
var extendedDefaults = {};
var Swiper = /*#__PURE__*/ function(SwiperClass1) {
    "use strict";
    (0,_inherits/* default */.Z)(Swiper, SwiperClass1);
    var _super = (0,_create_super/* default */.Z)(Swiper);
    function Swiper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, Swiper);
        var _this;
        var el;
        var params;
        if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
            params = args[0];
        } else {
            var ref;
            ref = (0,_sliced_to_array/* default */.Z)(args, 2), el = ref[0], params = ref[1], ref;
        }
        if (!params) params = {};
        params = Utils.extend({}, params);
        if (el && !params.el) params.el = el;
        _this = _super.call(this, params);
        Object.keys(prototypes).forEach(function(prototypeGroup) {
            Object.keys(prototypes[prototypeGroup]).forEach(function(protoMethod) {
                if (!Swiper.prototype[protoMethod]) {
                    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
                }
            });
        });
        // Swiper Instance
        var swiper = (0,_assert_this_initialized/* default */.Z)(_this);
        if (typeof swiper.modules === "undefined") {
            swiper.modules = {};
        }
        Object.keys(swiper.modules).forEach(function(moduleName) {
            var module = swiper.modules[moduleName];
            if (module.params) {
                var moduleParamName = Object.keys(module.params)[0];
                var moduleParams = module.params[moduleParamName];
                if (typeof moduleParams !== "object" || moduleParams === null) return;
                if (!(moduleParamName in params && "enabled" in moduleParams)) return;
                if (params[moduleParamName] === true) {
                    params[moduleParamName] = {
                        enabled: true
                    };
                }
                if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) {
                    params[moduleParamName].enabled = true;
                }
                if (!params[moduleParamName]) params[moduleParamName] = {
                    enabled: false
                };
            }
        });
        // Extend defaults with modules params
        var swiperParams = Utils.extend({}, defaults);
        swiper.useModulesParams(swiperParams);
        // Extend defaults with passed params
        swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
        swiper.originalParams = Utils.extend({}, swiper.params);
        swiper.passedParams = Utils.extend({}, params);
        // Save Dom lib
        swiper.$ = $;
        // Find el
        var $el = $(swiper.params.el);
        el = $el[0];
        if (!el) {
            return (0,_possible_constructor_return/* default */.Z)(_this, undefined);
        }
        if ($el.length > 1) {
            var swipers = [];
            $el.each(function(index, containerEl) {
                var newParams = Utils.extend({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            return (0,_possible_constructor_return/* default */.Z)(_this, swipers);
        }
        el.swiper = swiper;
        $el.data("swiper", swiper);
        // Find Wrapper
        var $wrapperEl;
        if (el && el.shadowRoot && el.shadowRoot.querySelector) {
            $wrapperEl = $(el.shadowRoot.querySelector(".".concat(swiper.params.wrapperClass)));
            // Children needs to return slot items
            $wrapperEl.children = function(options) {
                return $el.children(options);
            };
        } else {
            $wrapperEl = $el.children(".".concat(swiper.params.wrapperClass));
        }
        // Extend Swiper
        Utils.extend(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            // Classes
            classNames: [],
            // Slides
            slides: $(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal: function isHorizontal() {
                return swiper.params.direction === "horizontal";
            },
            isVertical: function isVertical() {
                return swiper.params.direction === "vertical";
            },
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
            wrongRTL: $wrapperEl.css("display") === "-webkit-box",
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                var touch = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel"
                ];
                var desktop = [
                    "mousedown",
                    "mousemove",
                    "mouseup"
                ];
                if (Support.pointerEvents) {
                    desktop = [
                        "pointerdown",
                        "pointermove",
                        "pointerup"
                    ];
                }
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                formElements: "input, select, option, textarea, button, video, label",
                // Last click time
                lastClickTime: Utils.now(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        // Install Modules
        swiper.useModules();
        // Init
        if (swiper.params.init) {
            swiper.init();
        }
        // Return app instance
        return (0,_possible_constructor_return/* default */.Z)(_this, swiper);
    }
    (0,_create_class/* default */.Z)(Swiper, [
        {
            key: "slidesPerViewDynamic",
            value: function slidesPerViewDynamic() {
                var swiper = this;
                var params = swiper.params, slides = swiper.slides, slidesGrid = swiper.slidesGrid, swiperSize = swiper.size, activeIndex = swiper.activeIndex;
                var spv = 1;
                if (params.centeredSlides) {
                    var slideSize = slides[activeIndex].swiperSlideSize;
                    var breakLoop;
                    for(var i = activeIndex + 1; i < slides.length; i += 1){
                        if (slides[i] && !breakLoop) {
                            slideSize += slides[i].swiperSlideSize;
                            spv += 1;
                            if (slideSize > swiperSize) breakLoop = true;
                        }
                    }
                    for(var i1 = activeIndex - 1; i1 >= 0; i1 -= 1){
                        if (slides[i1] && !breakLoop) {
                            slideSize += slides[i1].swiperSlideSize;
                            spv += 1;
                            if (slideSize > swiperSize) breakLoop = true;
                        }
                    }
                } else {
                    for(var i2 = activeIndex + 1; i2 < slides.length; i2 += 1){
                        if (slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize) {
                            spv += 1;
                        }
                    }
                }
                return spv;
            }
        },
        {
            key: "update",
            value: function update() {
                var _$setTranslate = function _$setTranslate() {
                    var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
                    var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
                    swiper.setTranslate(newTranslate);
                    swiper.updateActiveIndex();
                    swiper.updateSlidesClasses();
                };
                var swiper = this;
                if (!swiper || swiper.destroyed) return;
                var snapGrid = swiper.snapGrid, params = swiper.params;
                // Breakpoints
                if (params.breakpoints) {
                    swiper.setBreakpoint();
                }
                swiper.updateSize();
                swiper.updateSlides();
                swiper.updateProgress();
                swiper.updateSlidesClasses();
                var translated;
                if (swiper.params.freeMode) {
                    _$setTranslate();
                    if (swiper.params.autoHeight) {
                        swiper.updateAutoHeight();
                    }
                } else {
                    if ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
                        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
                    } else {
                        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
                    }
                    if (!translated) {
                        _$setTranslate();
                    }
                }
                if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
                    swiper.checkOverflow();
                }
                swiper.emit("update");
            }
        },
        {
            key: "changeDirection",
            value: function changeDirection(newDirection) {
                var needUpdate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var swiper = this;
                var currentDirection = swiper.params.direction;
                if (!newDirection) {
                    // eslint-disable-next-line
                    newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
                }
                if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") {
                    return swiper;
                }
                swiper.$el.removeClass("".concat(swiper.params.containerModifierClass).concat(currentDirection)).addClass("".concat(swiper.params.containerModifierClass).concat(newDirection));
                swiper.params.direction = newDirection;
                swiper.slides.each(function(slideIndex, slideEl) {
                    if (newDirection === "vertical") {
                        slideEl.style.width = "";
                    } else {
                        slideEl.style.height = "";
                    }
                });
                swiper.emit("changeDirection");
                if (needUpdate) swiper.update();
                return swiper;
            }
        },
        {
            key: "init",
            value: function init() {
                var swiper = this;
                if (swiper.initialized) return;
                swiper.emit("beforeInit");
                // Set breakpoint
                if (swiper.params.breakpoints) {
                    swiper.setBreakpoint();
                }
                // Add Classes
                swiper.addClasses();
                // Create loop
                if (swiper.params.loop) {
                    swiper.loopCreate();
                }
                // Update size
                swiper.updateSize();
                // Update slides
                swiper.updateSlides();
                if (swiper.params.watchOverflow) {
                    swiper.checkOverflow();
                }
                // Set Grab Cursor
                if (swiper.params.grabCursor) {
                    swiper.setGrabCursor();
                }
                if (swiper.params.preloadImages) {
                    swiper.preloadImages();
                }
                // Slide To Initial Slide
                if (swiper.params.loop) {
                    swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
                } else {
                    swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
                }
                // Attach events
                swiper.attachEvents();
                // Init Flag
                swiper.initialized = true;
                // Emit
                swiper.emit("init");
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var deleteInstance = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, cleanStyles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var swiper = this;
                var params = swiper.params, $el = swiper.$el, $wrapperEl = swiper.$wrapperEl, slides = swiper.slides;
                if (typeof swiper.params === "undefined" || swiper.destroyed) {
                    return null;
                }
                swiper.emit("beforeDestroy");
                // Init Flag
                swiper.initialized = false;
                // Detach events
                swiper.detachEvents();
                // Destroy loop
                if (params.loop) {
                    swiper.loopDestroy();
                }
                // Cleanup styles
                if (cleanStyles) {
                    swiper.removeClasses();
                    $el.removeAttr("style");
                    $wrapperEl.removeAttr("style");
                    if (slides && slides.length) {
                        slides.removeClass([
                            params.slideVisibleClass,
                            params.slideActiveClass,
                            params.slideNextClass,
                            params.slidePrevClass, 
                        ].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index");
                    }
                }
                swiper.emit("destroy");
                // Detach emitter events
                Object.keys(swiper.eventsListeners).forEach(function(eventName) {
                    swiper.off(eventName);
                });
                if (deleteInstance !== false) {
                    swiper.$el[0].swiper = null;
                    swiper.$el.data("swiper", null);
                    Utils.deleteProps(swiper);
                }
                swiper.destroyed = true;
                return null;
            }
        }
    ], [
        {
            key: "extendDefaults",
            value: function extendDefaults(newDefaults) {
                Utils.extend(extendedDefaults, newDefaults);
            }
        },
        {
            key: "extendedDefaults",
            get: function get() {
                return extendedDefaults;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return defaults;
            }
        },
        {
            key: "Class",
            get: function get() {
                return SwiperClass;
            }
        },
        {
            key: "$",
            get: function get() {
                return $;
            }
        }
    ]);
    return Swiper;
}(SwiperClass);
var Device$1 = {
    name: "device",
    proto: {
        device: Device
    },
    static: {
        device: Device
    }
};
var Support$1 = {
    name: "support",
    proto: {
        support: Support
    },
    static: {
        support: Support
    }
};
var Browser = function Browser() {
    var isSafari = function isSafari() {
        var ua = win.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    };
    return {
        isEdge: !!win.navigator.userAgent.match(/Edge/g),
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent)
    };
}();
var Browser$1 = {
    name: "browser",
    proto: {
        browser: Browser
    },
    static: {
        browser: Browser
    }
};
var Resize = {
    name: "resize",
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            resize: {
                resizeHandler: function resizeHandler() {
                    if (!swiper || swiper.destroyed || !swiper.initialized) return;
                    swiper.emit("beforeResize");
                    swiper.emit("resize");
                },
                orientationChangeHandler: function orientationChangeHandler() {
                    if (!swiper || swiper.destroyed || !swiper.initialized) return;
                    swiper.emit("orientationchange");
                }
            }
        });
    },
    on: {
        init: function init() {
            var swiper = this;
            // Emit resize
            win.addEventListener("resize", swiper.resize.resizeHandler);
            // Emit orientationchange
            win.addEventListener("orientationchange", swiper.resize.orientationChangeHandler);
        },
        destroy: function destroy() {
            var swiper = this;
            win.removeEventListener("resize", swiper.resize.resizeHandler);
            win.removeEventListener("orientationchange", swiper.resize.orientationChangeHandler);
        }
    }
};
var Observer = {
    func: win.MutationObserver || win.WebkitMutationObserver,
    attach: function attach(target) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var swiper = this;
        var ObserverFunc = Observer.func;
        var observer = new ObserverFunc(function(mutations) {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                swiper.emit("observerUpdate", mutations[0]);
                return;
            }
            var observerUpdate = function observerUpdate() {
                swiper.emit("observerUpdate", mutations[0]);
            };
            if (win.requestAnimationFrame) {
                win.requestAnimationFrame(observerUpdate);
            } else {
                win.setTimeout(observerUpdate, 0);
            }
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        swiper.observer.observers.push(observer);
    },
    init: function init() {
        var swiper = this;
        if (!Support.observer || !swiper.params.observer) return;
        if (swiper.params.observeParents) {
            var containerParents = swiper.$el.parents();
            for(var i = 0; i < containerParents.length; i += 1){
                swiper.observer.attach(containerParents[i]);
            }
        }
        // Observe container
        swiper.observer.attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        swiper.observer.attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    },
    destroy: function destroy() {
        var swiper = this;
        swiper.observer.observers.forEach(function(observer) {
            observer.disconnect();
        });
        swiper.observer.observers = [];
    }
};
var Observer$1 = {
    name: "observer",
    params: {
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            observer: {
                init: Observer.init.bind(swiper),
                attach: Observer.attach.bind(swiper),
                destroy: Observer.destroy.bind(swiper),
                observers: []
            }
        });
    },
    on: {
        init: function init() {
            var swiper = this;
            swiper.observer.init();
        },
        destroy: function destroy() {
            var swiper = this;
            swiper.observer.destroy();
        }
    }
};
var Virtual = {
    update: function update(force) {
        var onRendered = function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) {
                swiper.lazy.load();
            }
        };
        var swiper = this;
        var _params = swiper.params, slidesPerView = _params.slidesPerView, slidesPerGroup = _params.slidesPerGroup, centeredSlides = _params.centeredSlides;
        var _virtual = swiper.params.virtual, addSlidesBefore = _virtual.addSlidesBefore, addSlidesAfter = _virtual.addSlidesAfter;
        var _virtual1 = swiper.virtual, previousFrom = _virtual1.from, previousTo = _virtual1.to, slides = _virtual1.slides, previousSlidesGrid = _virtual1.slidesGrid, renderSlide = _virtual1.renderSlide, previousOffset = _virtual1.offset;
        swiper.updateActiveIndex();
        var activeIndex = swiper.activeIndex || 0;
        var offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        var slidesAfter;
        var slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
            slidesBefore = slidesPerGroup + addSlidesAfter;
        }
        var from = Math.max((activeIndex || 0) - slidesBefore, 0);
        var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        var _$offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Utils.extend(swiper.virtual, {
            from: from,
            to: to,
            offset: _$offset,
            slidesGrid: swiper.slidesGrid
        });
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && _$offset !== previousOffset) {
                swiper.slides.css(offsetProp, "".concat(_$offset, "px"));
            }
            swiper.updateProgress();
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: _$offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    var slidesToRender = [];
                    for(var i = from; i <= to; i += 1){
                        slidesToRender.push(slides[i]);
                    }
                    return slidesToRender;
                }()
            });
            onRendered();
            return;
        }
        var prependIndexes = [];
        var appendIndexes = [];
        if (force) {
            swiper.$wrapperEl.find(".".concat(swiper.params.slideClass)).remove();
        } else {
            for(var i = previousFrom; i <= previousTo; i += 1){
                if (i < from || i > to) {
                    swiper.$wrapperEl.find(".".concat(swiper.params.slideClass, '[data-swiper-slide-index="').concat(i, '"]')).remove();
                }
            }
        }
        for(var i1 = 0; i1 < slides.length; i1 += 1){
            if (i1 >= from && i1 <= to) {
                if (typeof previousTo === "undefined" || force) {
                    appendIndexes.push(i1);
                } else {
                    if (i1 > previousTo) appendIndexes.push(i1);
                    if (i1 < previousFrom) prependIndexes.push(i1);
                }
            }
        }
        appendIndexes.forEach(function(index) {
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort(function(a, b) {
            return b - a;
        }).forEach(function(index) {
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children(".swiper-slide").css(offsetProp, "".concat(_$offset, "px"));
        onRendered();
    },
    renderSlide: function renderSlide(slide, index) {
        var swiper = this;
        var params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) {
            return swiper.virtual.cache[index];
        }
        var $slideEl = params.renderSlide ? $(params.renderSlide.call(swiper, slide, index)) : $('<div class="'.concat(swiper.params.slideClass, '" data-swiper-slide-index="').concat(index, '">').concat(slide, "</div>"));
        if (!$slideEl.attr("data-swiper-slide-index")) $slideEl.attr("data-swiper-slide-index", index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    },
    appendSlide: function appendSlide(slides) {
        var swiper = this;
        if (typeof slides === "object" && "length" in slides) {
            for(var i = 0; i < slides.length; i += 1){
                if (slides[i]) swiper.virtual.slides.push(slides[i]);
            }
        } else {
            swiper.virtual.slides.push(slides);
        }
        swiper.virtual.update(true);
    },
    prependSlide: function prependSlide(slides) {
        var swiper = this;
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(var i = 0; i < slides.length; i += 1){
                if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            }
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else {
            swiper.virtual.slides.unshift(slides);
        }
        if (swiper.params.virtual.cache) {
            var cache = swiper.virtual.cache;
            var newCache = {};
            Object.keys(cache).forEach(function(cachedIndex) {
                var $cachedEl = cache[cachedIndex];
                var cachedElIndex = $cachedEl.attr("data-swiper-slide-index");
                if (cachedElIndex) {
                    $cachedEl.attr("data-swiper-slide-index", parseInt(cachedElIndex, 10) + 1);
                }
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        swiper.virtual.update(true);
        swiper.slideTo(newActiveIndex, 0);
    },
    removeSlide: function removeSlide(slidesIndexes) {
        var swiper = this;
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        var activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) {
            for(var i = slidesIndexes.length - 1; i >= 0; i -= 1){
                swiper.virtual.slides.splice(slidesIndexes[i], 1);
                if (swiper.params.virtual.cache) {
                    delete swiper.virtual.cache[slidesIndexes[i]];
                }
                if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
                activeIndex = Math.max(activeIndex, 0);
            }
        } else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
            }
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        swiper.virtual.update(true);
        swiper.slideTo(activeIndex, 0);
    },
    removeAllSlides: function removeAllSlides() {
        var swiper = this;
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) {
            swiper.virtual.cache = {};
        }
        swiper.virtual.update(true);
        swiper.slideTo(0, 0);
    }
};
var Virtual$1 = {
    name: "virtual",
    params: {
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            virtual: {
                update: Virtual.update.bind(swiper),
                appendSlide: Virtual.appendSlide.bind(swiper),
                prependSlide: Virtual.prependSlide.bind(swiper),
                removeSlide: Virtual.removeSlide.bind(swiper),
                removeAllSlides: Virtual.removeAllSlides.bind(swiper),
                renderSlide: Virtual.renderSlide.bind(swiper),
                slides: swiper.params.virtual.slides,
                cache: {}
            }
        });
    },
    on: {
        beforeInit: function beforeInit() {
            var swiper = this;
            if (!swiper.params.virtual.enabled) return;
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "virtual"));
            var overwriteParams = {
                watchSlidesProgress: true
            };
            Utils.extend(swiper.params, overwriteParams);
            Utils.extend(swiper.originalParams, overwriteParams);
            if (!swiper.params.initialSlide) {
                swiper.virtual.update();
            }
        },
        setTranslate: function setTranslate() {
            var swiper = this;
            if (!swiper.params.virtual.enabled) return;
            swiper.virtual.update();
        }
    }
};
var Keyboard = {
    handle: function handle(event) {
        var swiper = this;
        var rtl = swiper.rtlTranslate;
        var e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var kc = e.keyCode || e.charCode;
        var pageUpDown = swiper.params.keyboard.pageUpDown;
        var isPageUp = pageUpDown && kc === 33;
        var isPageDown = pageUpDown && kc === 34;
        var isArrowLeft = kc === 37;
        var isArrowRight = kc === 39;
        var isArrowUp = kc === 38;
        var isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
            return false;
        }
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
            return false;
        }
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
            return undefined;
        }
        if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === "input" || doc.activeElement.nodeName.toLowerCase() === "textarea")) {
            return undefined;
        }
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            var inView = false;
            // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(".".concat(swiper.params.slideClass)).length > 0 && swiper.$el.parents(".".concat(swiper.params.slideActiveClass)).length === 0) {
                return undefined;
            }
            var windowWidth = win.innerWidth;
            var windowHeight = win.innerHeight;
            var swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            var swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiper.width,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiper.height
                ],
                [
                    swiperOffset.left + swiper.width,
                    swiperOffset.top + swiper.height
                ], 
            ];
            for(var i = 0; i < swiperCoord.length; i += 1){
                var point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        swiper.emit("keyPress", kc);
        return undefined;
    },
    enable: function enable() {
        var swiper = this;
        if (swiper.keyboard.enabled) return;
        $(doc).on("keydown", swiper.keyboard.handle);
        swiper.keyboard.enabled = true;
    },
    disable: function disable() {
        var swiper = this;
        if (!swiper.keyboard.enabled) return;
        $(doc).off("keydown", swiper.keyboard.handle);
        swiper.keyboard.enabled = false;
    }
};
var Keyboard$1 = {
    name: "keyboard",
    params: {
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            keyboard: {
                enabled: false,
                enable: Keyboard.enable.bind(swiper),
                disable: Keyboard.disable.bind(swiper),
                handle: Keyboard.handle.bind(swiper)
            }
        });
    },
    on: {
        init: function init() {
            var swiper = this;
            if (swiper.params.keyboard.enabled) {
                swiper.keyboard.enable();
            }
        },
        destroy: function destroy() {
            var swiper = this;
            if (swiper.keyboard.enabled) {
                swiper.keyboard.disable();
            }
        }
    }
};
function isEventSupported() {
    var eventName = "onwheel";
    var isSupported = eventName in doc;
    if (!isSupported) {
        var element = doc.createElement("div");
        element.setAttribute(eventName, "return;");
        isSupported = typeof element[eventName] === "function";
    }
    if (!isSupported && doc.implementation && doc.implementation.hasFeature && doc.implementation.hasFeature("", "") !== true) {
        // This is the only way to test support for the `wheel` event in IE9+.
        isSupported = doc.implementation.hasFeature("Events.wheel", "3.0");
    }
    return isSupported;
}
var Mousewheel = {
    lastScrollTime: Utils.now(),
    lastEventBeforeSnap: undefined,
    recentWheelEvents: [],
    event: function event() {
        if (win.navigator.userAgent.indexOf("firefox") > -1) return "DOMMouseScroll";
        return isEventSupported() ? "wheel" : "mousewheel";
    },
    normalize: function normalize(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var sX = 0;
        var sY = 0; // spinX, spinY
        var pX = 0;
        var pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) {
            sY = e.detail;
        }
        if ("wheelDelta" in e) {
            sY = -e.wheelDelta / 120;
        }
        if ("wheelDeltaY" in e) {
            sY = -e.wheelDeltaY / 120;
        }
        if ("wheelDeltaX" in e) {
            sX = -e.wheelDeltaX / 120;
        }
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) {
            pY = e.deltaY;
        }
        if ("deltaX" in e) {
            pX = e.deltaX;
        }
        if (e.shiftKey && !pX) {
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) {
            sX = pX < 1 ? -1 : 1;
        }
        if (pY && !sY) {
            sY = pY < 1 ? -1 : 1;
        }
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    },
    handleMouseEnter: function handleMouseEnter() {
        var swiper = this;
        swiper.mouseEntered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
        var swiper = this;
        swiper.mouseEntered = false;
    },
    handle: function handle(event) {
        var e = event;
        var swiper = this;
        var params = swiper.params.mousewheel;
        if (swiper.params.cssMode) {
            e.preventDefault();
        }
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarged !== "container") {
            target = $(swiper.params.mousewheel.eventsTarged);
        }
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var _$data = Mousewheel.normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(_$data.pixelX) > Math.abs(_$data.pixelY)) delta = -_$data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(_$data.pixelY) > Math.abs(_$data.pixelX)) delta = -_$data.pixelY;
            else return true;
        } else {
            delta = Math.abs(_$data.pixelX) > Math.abs(_$data.pixelY) ? -_$data.pixelX * rtlFactor : -_$data.pixelY;
        }
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        if (!swiper.params.freeMode) {
            // Register the new event in a variable which stores the relevant data
            var newEvent = {
                time: Utils.now(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event
            };
            // Keep the most recent events
            var recentWheelEvents = swiper.mousewheel.recentWheelEvents;
            if (recentWheelEvents.length >= 2) {
                recentWheelEvents.shift(); // only store the last N events
            }
            var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
                    swiper.mousewheel.animateSlider(newEvent);
                }
            } else {
                swiper.mousewheel.animateSlider(newEvent);
            }
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (swiper.mousewheel.releaseScroll(newEvent)) {
                return true;
            }
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            var newEvent1 = {
                time: Utils.now(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            var lastEventBeforeSnap = swiper.mousewheel.lastEventBeforeSnap;
            var ignoreWheelEvents = lastEventBeforeSnap && newEvent1.time < lastEventBeforeSnap.time + 500 && newEvent1.delta <= lastEventBeforeSnap.delta && newEvent1.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                swiper.mousewheel.lastEventBeforeSnap = undefined;
                if (swiper.params.loop) {
                    swiper.loopFix();
                }
                var position = swiper.getTranslate() + delta * params.sensitivity;
                var wasBeginning = swiper.isBeginning;
                var wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
                    swiper.updateSlidesClasses();
                }
                if (swiper.params.freeModeSticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momuntum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(swiper.mousewheel.timeout);
                    swiper.mousewheel.timeout = undefined;
                    var recentWheelEvents1 = swiper.mousewheel.recentWheelEvents;
                    if (recentWheelEvents1.length >= 15) {
                        recentWheelEvents1.shift(); // only store the last N events
                    }
                    var prevEvent1 = recentWheelEvents1.length ? recentWheelEvents1[recentWheelEvents1.length - 1] : undefined;
                    var firstEvent = recentWheelEvents1[0];
                    recentWheelEvents1.push(newEvent1);
                    if (prevEvent1 && (newEvent1.delta > prevEvent1.delta || newEvent1.direction !== prevEvent1.direction)) {
                        // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                        recentWheelEvents1.splice(0);
                    } else if (recentWheelEvents1.length >= 15 && newEvent1.time - firstEvent.time < 500 && firstEvent.delta - newEvent1.delta >= 1 && newEvent1.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        var snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        swiper.mousewheel.lastEventBeforeSnap = newEvent1;
                        recentWheelEvents1.splice(0);
                        swiper.mousewheel.timeout = Utils.nextTick(function() {
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!swiper.mousewheel.timeout) {
                        // if we get here, then we haven't detected the end of a momentum scroll, so
                        // we'll consider a scroll "complete" when there haven't been any wheel events
                        // for 500ms.
                        swiper.mousewheel.timeout = Utils.nextTick(function() {
                            var snapToThreshold = 0.5;
                            swiper.mousewheel.lastEventBeforeSnap = newEvent1;
                            recentWheelEvents1.splice(0);
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 500);
                    }
                }
                // Emit event
                if (!ignoreWheelEvents) swiper.emit("scroll", e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    },
    animateSlider: function animateSlider(newEvent) {
        var swiper = this;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && Utils.now() - swiper.mousewheel.lastScrollTime < 60) {
            // Return false as a default
            return true;
        }
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                swiper.emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            swiper.emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        swiper.mousewheel.lastScrollTime = new win.Date().getTime();
        // Return false as a default
        return false;
    },
    releaseScroll: function releaseScroll(newEvent) {
        var swiper = this;
        var params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
                // Return true to animate scroll on edges
                return true;
            }
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
            // Return true to animate scroll on edges
            return true;
        }
        return false;
    },
    enable: function enable() {
        var swiper = this;
        var event = Mousewheel.event();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
            return true;
        }
        if (!event) return false;
        if (swiper.mousewheel.enabled) return false;
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarged !== "container") {
            target = $(swiper.params.mousewheel.eventsTarged);
        }
        target.on("mouseenter", swiper.mousewheel.handleMouseEnter);
        target.on("mouseleave", swiper.mousewheel.handleMouseLeave);
        target.on(event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = true;
        return true;
    },
    disable: function disable() {
        var swiper = this;
        var event = Mousewheel.event();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
            return true;
        }
        if (!event) return false;
        if (!swiper.mousewheel.enabled) return false;
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarged !== "container") {
            target = $(swiper.params.mousewheel.eventsTarged);
        }
        target.off(event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = false;
        return true;
    }
};
var Mousewheel$1 = {
    name: "mousewheel",
    params: {
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarged: "container"
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            mousewheel: {
                enabled: false,
                enable: Mousewheel.enable.bind(swiper),
                disable: Mousewheel.disable.bind(swiper),
                handle: Mousewheel.handle.bind(swiper),
                handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
                handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
                animateSlider: Mousewheel.animateSlider.bind(swiper),
                releaseScroll: Mousewheel.releaseScroll.bind(swiper),
                lastScrollTime: Utils.now(),
                lastEventBeforeSnap: undefined,
                recentWheelEvents: []
            }
        });
    },
    on: {
        init: function init() {
            var swiper = this;
            if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
                swiper.mousewheel.disable();
            }
            if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
        },
        destroy: function destroy() {
            var swiper = this;
            if (swiper.params.cssMode) {
                swiper.mousewheel.enable();
            }
            if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
        }
    }
};
var Navigation = {
    update: function update() {
        // Update Navigation Buttons
        var swiper = this;
        var params = swiper.params.navigation;
        if (swiper.params.loop) return;
        var _navigation = swiper.navigation, $nextEl = _navigation.$nextEl, $prevEl = _navigation.$prevEl;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                $prevEl.addClass(params.disabledClass);
            } else {
                $prevEl.removeClass(params.disabledClass);
            }
            $prevEl[swiper.params.watchOverflow && swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                $nextEl.addClass(params.disabledClass);
            } else {
                $nextEl.removeClass(params.disabledClass);
            }
            $nextEl[swiper.params.watchOverflow && swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
    },
    onPrevClick: function onPrevClick(e) {
        var swiper = this;
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop) return;
        swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
        var swiper = this;
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop) return;
        swiper.slideNext();
    },
    init: function init() {
        var swiper = this;
        var params = swiper.params.navigation;
        if (!(params.nextEl || params.prevEl)) return;
        var $nextEl;
        var $prevEl;
        if (params.nextEl) {
            $nextEl = $(params.nextEl);
            if (swiper.params.uniqueNavElements && typeof params.nextEl === "string" && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
                $nextEl = swiper.$el.find(params.nextEl);
            }
        }
        if (params.prevEl) {
            $prevEl = $(params.prevEl);
            if (swiper.params.uniqueNavElements && typeof params.prevEl === "string" && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
                $prevEl = swiper.$el.find(params.prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            $nextEl.on("click", swiper.navigation.onNextClick);
        }
        if ($prevEl && $prevEl.length > 0) {
            $prevEl.on("click", swiper.navigation.onPrevClick);
        }
        Utils.extend(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
    },
    destroy: function destroy() {
        var swiper = this;
        var _navigation = swiper.navigation, $nextEl = _navigation.$nextEl, $prevEl = _navigation.$prevEl;
        if ($nextEl && $nextEl.length) {
            $nextEl.off("click", swiper.navigation.onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off("click", swiper.navigation.onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
};
var Navigation$1 = {
    name: "navigation",
    params: {
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock"
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            navigation: {
                init: Navigation.init.bind(swiper),
                update: Navigation.update.bind(swiper),
                destroy: Navigation.destroy.bind(swiper),
                onNextClick: Navigation.onNextClick.bind(swiper),
                onPrevClick: Navigation.onPrevClick.bind(swiper)
            }
        });
    },
    on: {
        init: function init() {
            var swiper = this;
            swiper.navigation.init();
            swiper.navigation.update();
        },
        toEdge: function toEdge() {
            var swiper = this;
            swiper.navigation.update();
        },
        fromEdge: function fromEdge() {
            var swiper = this;
            swiper.navigation.update();
        },
        destroy: function destroy() {
            var swiper = this;
            swiper.navigation.destroy();
        },
        click: function click(e) {
            var swiper = this;
            var _navigation = swiper.navigation, $nextEl = _navigation.$nextEl, $prevEl = _navigation.$prevEl;
            if (swiper.params.navigation.hideOnClick && !$(e.target).is($prevEl) && !$(e.target).is($nextEl)) {
                var isHidden;
                if ($nextEl) {
                    isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
                } else if ($prevEl) {
                    isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
                }
                if (isHidden === true) {
                    swiper.emit("navigationShow", swiper);
                } else {
                    swiper.emit("navigationHide", swiper);
                }
                if ($nextEl) {
                    $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
                }
                if ($prevEl) {
                    $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
                }
            }
        }
    }
};
var Pagination = {
    update: function update() {
        // Render || Update Pagination bullets/items
        var swiper = this;
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el;
        // Current/Total
        var current;
        var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
                current -= slidesLength - swiper.loopedSlides * 2;
            }
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== "bullets") current = total + current;
        } else if (typeof swiper.snapIndex !== "undefined") {
            current = swiper.snapIndex;
        } else {
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            var bullets = swiper.pagination.bullets;
            var firstIndex;
            var lastIndex;
            var midIndex;
            if (params.dynamicBullets) {
                swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? "outerWidth" : "outerHeight"](true);
                $el.css(swiper.isHorizontal() ? "width" : "height", "".concat(swiper.pagination.bulletSize * (params.dynamicMainBullets + 4), "px"));
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;
                    if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
                        swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
                    } else if (swiper.pagination.dynamicBulletIndex < 0) {
                        swiper.pagination.dynamicBulletIndex = 0;
                    }
                }
                firstIndex = current - swiper.pagination.dynamicBulletIndex;
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass("".concat(params.bulletActiveClass, " ").concat(params.bulletActiveClass, "-next ").concat(params.bulletActiveClass, "-next-next ").concat(params.bulletActiveClass, "-prev ").concat(params.bulletActiveClass, "-prev-prev ").concat(params.bulletActiveClass, "-main"));
            if ($el.length > 1) {
                bullets.each(function(index, bullet) {
                    var $bullet = $(bullet);
                    var bulletIndex = $bullet.index();
                    if (bulletIndex === current) {
                        $bullet.addClass(params.bulletActiveClass);
                    }
                    if (params.dynamicBullets) {
                        if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                            $bullet.addClass("".concat(params.bulletActiveClass, "-main"));
                        }
                        if (bulletIndex === firstIndex) {
                            $bullet.prev().addClass("".concat(params.bulletActiveClass, "-prev")).prev().addClass("".concat(params.bulletActiveClass, "-prev-prev"));
                        }
                        if (bulletIndex === lastIndex) {
                            $bullet.next().addClass("".concat(params.bulletActiveClass, "-next")).next().addClass("".concat(params.bulletActiveClass, "-next-next"));
                        }
                    }
                });
            } else {
                var $bullet = bullets.eq(current);
                var bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    var $firstDisplayedBullet = bullets.eq(firstIndex);
                    var $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(var i = firstIndex; i <= lastIndex; i += 1){
                        bullets.eq(i).addClass("".concat(params.bulletActiveClass, "-main"));
                    }
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
                            for(var i1 = params.dynamicMainBullets; i1 >= 0; i1 -= 1){
                                bullets.eq(bullets.length - i1).addClass("".concat(params.bulletActiveClass, "-main"));
                            }
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass("".concat(params.bulletActiveClass, "-prev"));
                        } else {
                            $firstDisplayedBullet.prev().addClass("".concat(params.bulletActiveClass, "-prev")).prev().addClass("".concat(params.bulletActiveClass, "-prev-prev"));
                            $lastDisplayedBullet.next().addClass("".concat(params.bulletActiveClass, "-next")).next().addClass("".concat(params.bulletActiveClass, "-next-next"));
                        }
                    } else {
                        $firstDisplayedBullet.prev().addClass("".concat(params.bulletActiveClass, "-prev")).prev().addClass("".concat(params.bulletActiveClass, "-prev-prev"));
                        $lastDisplayedBullet.next().addClass("".concat(params.bulletActiveClass, "-next")).next().addClass("".concat(params.bulletActiveClass, "-next-next"));
                    }
                }
            }
            if (params.dynamicBullets) {
                var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
                var offsetProp = rtl ? "right" : "left";
                bullets.css(swiper.isHorizontal() ? offsetProp : "top", "".concat(bulletsOffset, "px"));
            }
        }
        if (params.type === "fraction") {
            $el.find(".".concat(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find(".".concat(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === "progressbar") {
            var progressbarDirection;
            if (params.progressbarOpposite) {
                progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
            } else {
                progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
            }
            var scale = (current + 1) / total;
            var scaleX = 1;
            var scaleY = 1;
            if (progressbarDirection === "horizontal") {
                scaleX = scale;
            } else {
                scaleY = scale;
            }
            $el.find(".".concat(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(".concat(scaleX, ") scaleY(").concat(scaleY, ")")).transition(swiper.params.speed);
        }
        if (params.type === "custom" && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            swiper.emit("paginationRender", swiper, $el[0]);
        } else {
            swiper.emit("paginationUpdate", swiper, $el[0]);
        }
        $el[swiper.params.watchOverflow && swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
    },
    render: function render() {
        // Render Container
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el;
        var paginationHTML = "";
        if (params.type === "bullets") {
            var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            for(var i = 0; i < numberOfBullets; i += 1){
                if (params.renderBullet) {
                    paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
                } else {
                    paginationHTML += "<".concat(params.bulletElement, ' class="').concat(params.bulletClass, '"></').concat(params.bulletElement, ">");
                }
            }
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find(".".concat(params.bulletClass));
        }
        if (params.type === "fraction") {
            if (params.renderFraction) {
                paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            } else {
                paginationHTML = '<span class="'.concat(params.currentClass, '"></span>') + " / " + '<span class="'.concat(params.totalClass, '"></span>');
            }
            $el.html(paginationHTML);
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) {
                paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            } else {
                paginationHTML = '<span class="'.concat(params.progressbarFillClass, '"></span>');
            }
            $el.html(paginationHTML);
        }
        if (params.type !== "custom") {
            swiper.emit("paginationRender", swiper.pagination.$el[0]);
        }
    },
    init: function init() {
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el) return;
        var $el = $(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1) {
            $el = swiper.$el.find(params.el);
        }
        if (params.type === "bullets" && params.clickable) {
            $el.addClass(params.clickableClass);
        }
        $el.addClass(params.modifierClass + params.type);
        if (params.type === "bullets" && params.dynamicBullets) {
            $el.addClass("".concat(params.modifierClass).concat(params.type, "-dynamic"));
            swiper.pagination.dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) {
                params.dynamicMainBullets = 1;
            }
        }
        if (params.type === "progressbar" && params.progressbarOpposite) {
            $el.addClass(params.progressbarOppositeClass);
        }
        if (params.clickable) {
            $el.on("click", ".".concat(params.bulletClass), function onClick(e) {
                e.preventDefault();
                var _$index = $(this).index() * swiper.params.slidesPerGroup;
                if (swiper.params.loop) _$index += swiper.loopedSlides;
                swiper.slideTo(_$index);
            });
        }
        Utils.extend(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
    },
    destroy: function destroy() {
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) {
            $el.off("click", ".".concat(params.bulletClass));
        }
    }
};
var Pagination$1 = {
    name: "pagination",
    params: {
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: function(number) {
                return number;
            },
            formatFractionTotal: function(number) {
                return number;
            },
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active",
            modifierClass: "swiper-pagination-",
            currentClass: "swiper-pagination-current",
            totalClass: "swiper-pagination-total",
            hiddenClass: "swiper-pagination-hidden",
            progressbarFillClass: "swiper-pagination-progressbar-fill",
            progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
            clickableClass: "swiper-pagination-clickable",
            lockClass: "swiper-pagination-lock"
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            pagination: {
                init: Pagination.init.bind(swiper),
                render: Pagination.render.bind(swiper),
                update: Pagination.update.bind(swiper),
                destroy: Pagination.destroy.bind(swiper),
                dynamicBulletIndex: 0
            }
        });
    },
    on: {
        init: function init() {
            var swiper = this;
            swiper.pagination.init();
            swiper.pagination.render();
            swiper.pagination.update();
        },
        activeIndexChange: function activeIndexChange() {
            var swiper = this;
            if (swiper.params.loop) {
                swiper.pagination.update();
            } else if (typeof swiper.snapIndex === "undefined") {
                swiper.pagination.update();
            }
        },
        snapIndexChange: function snapIndexChange() {
            var swiper = this;
            if (!swiper.params.loop) {
                swiper.pagination.update();
            }
        },
        slidesLengthChange: function slidesLengthChange() {
            var swiper = this;
            if (swiper.params.loop) {
                swiper.pagination.render();
                swiper.pagination.update();
            }
        },
        snapGridLengthChange: function snapGridLengthChange() {
            var swiper = this;
            if (!swiper.params.loop) {
                swiper.pagination.render();
                swiper.pagination.update();
            }
        },
        destroy: function destroy() {
            var swiper = this;
            swiper.pagination.destroy();
        },
        click: function click(e) {
            var swiper = this;
            if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(e.target).hasClass(swiper.params.pagination.bulletClass)) {
                var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
                if (isHidden === true) {
                    swiper.emit("paginationShow", swiper);
                } else {
                    swiper.emit("paginationHide", swiper);
                }
                swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
            }
        }
    }
};
var Scrollbar = {
    setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate, progress = swiper.progress;
        var dragSize = scrollbar.dragSize, trackSize = scrollbar.trackSize, $dragEl = scrollbar.$dragEl, $el = scrollbar.$el;
        var params = swiper.params.scrollbar;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) {
                newSize = trackSize + newPos;
            }
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) {
            newSize = trackSize - newPos;
        }
        if (swiper.isHorizontal()) {
            $dragEl.transform("translate3d(".concat(newPos, "px, 0, 0)"));
            $dragEl[0].style.width = "".concat(newSize, "px");
        } else {
            $dragEl.transform("translate3d(0px, ".concat(newPos, "px, 0)"));
            $dragEl[0].style.height = "".concat(newSize, "px");
        }
        if (params.hide) {
            clearTimeout(swiper.scrollbar.timeout);
            $el[0].style.opacity = 1;
            swiper.scrollbar.timeout = setTimeout(function() {
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function updateSize() {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar;
        var $dragEl = scrollbar.$dragEl, $el = scrollbar.$el;
        $dragEl[0].style.width = "";
        $dragEl[0].style.height = "";
        var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        var divider = swiper.size / swiper.virtualSize;
        var moveDivider = divider * (trackSize / swiper.size);
        var dragSize;
        if (swiper.params.scrollbar.dragSize === "auto") {
            dragSize = trackSize * divider;
        } else {
            dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        }
        if (swiper.isHorizontal()) {
            $dragEl[0].style.width = "".concat(dragSize, "px");
        } else {
            $dragEl[0].style.height = "".concat(dragSize, "px");
        }
        if (divider >= 1) {
            $el[0].style.display = "none";
        } else {
            $el[0].style.display = "";
        }
        if (swiper.params.scrollbar.hide) {
            $el[0].style.opacity = 0;
        }
        Utils.extend(scrollbar, {
            trackSize: trackSize,
            divider: divider,
            moveDivider: moveDivider,
            dragSize: dragSize
        });
        scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? "addClass" : "removeClass"](swiper.params.scrollbar.lockClass);
    },
    getPointerPosition: function getPointerPosition(e) {
        var swiper = this;
        if (swiper.isHorizontal()) {
            return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientX : e.clientX;
        }
        return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientY : e.clientY;
    },
    setDragPosition: function setDragPosition(e) {
        var swiper = this;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var $el = scrollbar.$el, dragSize = scrollbar.dragSize, trackSize = scrollbar.trackSize, dragStartPos = scrollbar.dragStartPos;
        var positionRatio;
        positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) {
            positionRatio = 1 - positionRatio;
        }
        var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
        var swiper = this;
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el, $dragEl = scrollbar.$dragEl;
        swiper.scrollbar.isTouched = true;
        swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        scrollbar.setDragPosition(e);
        clearTimeout(swiper.scrollbar.dragTimeout);
        $el.transition(0);
        if (params.hide) {
            $el.css("opacity", 1);
        }
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css("scroll-snap-type", "none");
        }
        swiper.emit("scrollbarDragStart", e);
    },
    onDragMove: function onDragMove(e) {
        var swiper = this;
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el, $dragEl = scrollbar.$dragEl;
        if (!swiper.scrollbar.isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        scrollbar.setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        swiper.emit("scrollbarDragMove", e);
    },
    onDragEnd: function onDragEnd(e) {
        var swiper = this;
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el;
        if (!swiper.scrollbar.isTouched) return;
        swiper.scrollbar.isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css("scroll-snap-type", "");
            $wrapperEl.transition("");
        }
        if (params.hide) {
            clearTimeout(swiper.scrollbar.dragTimeout);
            swiper.scrollbar.dragTimeout = Utils.nextTick(function() {
                $el.css("opacity", 0);
                $el.transition(400);
            }, 1000);
        }
        swiper.emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) {
            swiper.slideToClosest();
        }
    },
    enableDraggable: function enableDraggable() {
        var swiper = this;
        if (!swiper.params.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, touchEventsTouch = swiper.touchEventsTouch, touchEventsDesktop = swiper.touchEventsDesktop, params = swiper.params;
        var $el = scrollbar.$el;
        var target = $el[0];
        var activeListener = Support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        var passiveListener = Support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!Support.touch) {
            target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
            doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
            doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
        } else {
            target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
            target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
            target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
        }
    },
    disableDraggable: function disableDraggable() {
        var swiper = this;
        if (!swiper.params.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, touchEventsTouch = swiper.touchEventsTouch, touchEventsDesktop = swiper.touchEventsDesktop, params = swiper.params;
        var $el = scrollbar.$el;
        var target = $el[0];
        var activeListener = Support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        var passiveListener = Support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!Support.touch) {
            target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
            doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
            doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
        } else {
            target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
            target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
            target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
        }
    },
    init: function init() {
        var swiper = this;
        if (!swiper.params.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, $swiperEl = swiper.$el;
        var params = swiper.params.scrollbar;
        var $el = $(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
            $el = $swiperEl.find(params.el);
        }
        var $dragEl = $el.find(".".concat(swiper.params.scrollbar.dragClass));
        if ($dragEl.length === 0) {
            $dragEl = $('<div class="'.concat(swiper.params.scrollbar.dragClass, '"></div>'));
            $el.append($dragEl);
        }
        Utils.extend(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) {
            scrollbar.enableDraggable();
        }
    },
    destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.disableDraggable();
    }
};
var Scrollbar$1 = {
    name: "scrollbar",
    params: {
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag"
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            scrollbar: {
                init: Scrollbar.init.bind(swiper),
                destroy: Scrollbar.destroy.bind(swiper),
                updateSize: Scrollbar.updateSize.bind(swiper),
                setTranslate: Scrollbar.setTranslate.bind(swiper),
                setTransition: Scrollbar.setTransition.bind(swiper),
                enableDraggable: Scrollbar.enableDraggable.bind(swiper),
                disableDraggable: Scrollbar.disableDraggable.bind(swiper),
                setDragPosition: Scrollbar.setDragPosition.bind(swiper),
                getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
                onDragStart: Scrollbar.onDragStart.bind(swiper),
                onDragMove: Scrollbar.onDragMove.bind(swiper),
                onDragEnd: Scrollbar.onDragEnd.bind(swiper),
                isTouched: false,
                timeout: null,
                dragTimeout: null
            }
        });
    },
    on: {
        init: function init() {
            var swiper = this;
            swiper.scrollbar.init();
            swiper.scrollbar.updateSize();
            swiper.scrollbar.setTranslate();
        },
        update: function update() {
            var swiper = this;
            swiper.scrollbar.updateSize();
        },
        resize: function resize() {
            var swiper = this;
            swiper.scrollbar.updateSize();
        },
        observerUpdate: function observerUpdate() {
            var swiper = this;
            swiper.scrollbar.updateSize();
        },
        setTranslate: function setTranslate() {
            var swiper = this;
            swiper.scrollbar.setTranslate();
        },
        setTransition: function setTransition(duration) {
            var swiper = this;
            swiper.scrollbar.setTransition(duration);
        },
        destroy: function destroy() {
            var swiper = this;
            swiper.scrollbar.destroy();
        }
    }
};
var Parallax = {
    setTransform: function setTransform(el, progress) {
        var swiper = this;
        var rtl = swiper.rtl;
        var $el = $(el);
        var rtlFactor = rtl ? -1 : 1;
        var p = $el.attr("data-swiper-parallax") || "0";
        var x = $el.attr("data-swiper-parallax-x");
        var y = $el.attr("data-swiper-parallax-y");
        var scale = $el.attr("data-swiper-parallax-scale");
        var opacity = $el.attr("data-swiper-parallax-opacity");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) {
            x = "".concat(parseInt(x, 10) * progress * rtlFactor, "%");
        } else {
            x = "".concat(x * progress * rtlFactor, "px");
        }
        if (y.indexOf("%") >= 0) {
            y = "".concat(parseInt(y, 10) * progress, "%");
        } else {
            y = "".concat(y * progress, "px");
        }
        if (typeof opacity !== "undefined" && opacity !== null) {
            var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === "undefined" || scale === null) {
            $el.transform("translate3d(".concat(x, ", ").concat(y, ", 0px)"));
        } else {
            var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform("translate3d(".concat(x, ", ").concat(y, ", 0px) scale(").concat(currentScale, ")"));
        }
    },
    setTranslate: function setTranslate() {
        var swiper = this;
        var $el = swiper.$el, slides = swiper.slides, progress = swiper.progress, snapGrid = swiper.snapGrid;
        $el.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(index, el) {
            swiper.parallax.setTransform(el, progress);
        });
        slides.each(function(slideIndex, slideEl) {
            var slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") {
                slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            }
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            $(slideEl).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(index, el) {
                swiper.parallax.setTransform(el, slideProgress);
            });
        });
    },
    setTransition: function setTransition() {
        var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed;
        var swiper = this;
        var $el = swiper.$el;
        $el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(index, parallaxEl) {
            var $parallaxEl = $(parallaxEl);
            var parallaxDuration = parseInt($parallaxEl.attr("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    }
};
var Parallax$1 = {
    name: "parallax",
    params: {
        parallax: {
            enabled: false
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            parallax: {
                setTransform: Parallax.setTransform.bind(swiper),
                setTranslate: Parallax.setTranslate.bind(swiper),
                setTransition: Parallax.setTransition.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function beforeInit() {
            var swiper = this;
            if (!swiper.params.parallax.enabled) return;
            swiper.params.watchSlidesProgress = true;
            swiper.originalParams.watchSlidesProgress = true;
        },
        init: function init() {
            var swiper = this;
            if (!swiper.params.parallax.enabled) return;
            swiper.parallax.setTranslate();
        },
        setTranslate: function setTranslate() {
            var swiper = this;
            if (!swiper.params.parallax.enabled) return;
            swiper.parallax.setTranslate();
        },
        setTransition: function setTransition(duration) {
            var swiper = this;
            if (!swiper.params.parallax.enabled) return;
            swiper.parallax.setTransition(duration);
        }
    }
};
var Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        var x1 = e.targetTouches[0].pageX;
        var y1 = e.targetTouches[0].pageY;
        var x2 = e.targetTouches[1].pageX;
        var y2 = e.targetTouches[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
    },
    // Events
    onGestureStart: function onGestureStart(e) {
        var swiper = this;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
        if (!Support.gestures) {
            if (e.type !== "touchstart" || e.type === "touchstart" && e.targetTouches.length < 2) {
                return;
            }
            zoom.fakeGestureTouched = true;
            gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = $(e.target).closest(".".concat(swiper.params.slideClass));
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target");
            gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
            gesture.maxRatio = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) {
            gesture.$imageEl.transition(0);
        }
        swiper.zoom.isScaling = true;
    },
    onGestureChange: function onGestureChange(e) {
        var swiper = this;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (!Support.gestures) {
            if (e.type !== "touchmove" || e.type === "touchmove" && e.targetTouches.length < 2) {
                return;
            }
            zoom.fakeGestureMoved = true;
            gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (Support.gestures) {
            zoom.scale = e.scale * zoom.currentScale;
        } else {
            zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
        }
        if (zoom.scale > gesture.maxRatio) {
            zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        }
        if (zoom.scale < params.minRatio) {
            zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        }
        gesture.$imageEl.transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
    },
    onGestureEnd: function onGestureEnd(e) {
        var swiper = this;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (!Support.gestures) {
            if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
                return;
            }
            if (e.type !== "touchend" || e.type === "touchend" && e.changedTouches.length < 2 && !Device.android) {
                return;
            }
            zoom.fakeGestureTouched = false;
            zoom.fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
        zoom.currentScale = zoom.scale;
        zoom.isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    },
    onTouchStart: function onTouchStart(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture, image = zoom.image;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (Device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function onTouchMove(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture, image = zoom.image, velocity = zoom.velocity;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], "x") || 0;
            image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], "y") || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
            if (swiper.rtl) {
                image.startX = -image.startX;
                image.startY = -image.startY;
            }
        }
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !zoom.isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) {
            e.preventDefault();
        }
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) {
            image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        }
        if (image.currentX > image.maxX) {
            image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        }
        if (image.currentY < image.minY) {
            image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        }
        if (image.currentY > image.maxY) {
            image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
        }
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform("translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)"));
    },
    onTouchEnd: function onTouchEnd() {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture, image = zoom.image, velocity = zoom.velocity;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = velocity.x * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocity.y * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)"));
    },
    onTransitionEnd: function onTransitionEnd() {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) {
                gesture.$imageEl.transform("translate3d(0,0,0) scale(1)");
            }
            if (gesture.$imageWrapEl) {
                gesture.$imageWrapEl.transform("translate3d(0,0,0)");
            }
            zoom.scale = 1;
            zoom.currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    },
    // Toggle Zoom
    toggle: function toggle(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) {
            // Zoom Out
            zoom.out();
        } else {
            // Zoom In
            zoom.in(e);
        }
    },
    in: function _in(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        var gesture = zoom.gesture, image = zoom.image;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
                gesture.$slideEl = swiper.$wrapperEl.children(".".concat(swiper.params.slideActiveClass));
            } else {
                gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target");
            gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        gesture.$slideEl.addClass("".concat(params.zoomedSlideClass));
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.type === "touchend" ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === "touchend" ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        zoom.currentScale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left;
            offsetY = gesture.$slideEl.offset().top;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) {
                translateX = translateMinX;
            }
            if (translateX > translateMaxX) {
                translateX = translateMaxX;
            }
            if (translateY < translateMinY) {
                translateY = translateMinY;
            }
            if (translateY > translateMaxY) {
                translateY = translateMaxY;
            }
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform("translate3d(".concat(translateX, "px, ").concat(translateY, "px,0)"));
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
    },
    out: function out() {
        var swiper = this;
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        var gesture = zoom.gesture;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
                gesture.$slideEl = swiper.$wrapperEl.children(".".concat(swiper.params.slideActiveClass));
            } else {
                gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target");
            gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = 1;
        zoom.currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform("translate3d(0,0,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)");
        gesture.$slideEl.removeClass("".concat(params.zoomedSlideClass));
        gesture.$slideEl = undefined;
    },
    // Attach/Detach Events
    enable: function enable() {
        var swiper = this;
        var zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        var passiveListener = swiper.touchEvents.start === "touchstart" && Support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var activeListenerWithCapture = Support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        var slideSelector = ".".concat(swiper.params.slideClass);
        // Scale image
        if (Support.gestures) {
            swiper.$wrapperEl.on("gesturestart", slideSelector, zoom.onGestureStart, passiveListener);
            swiper.$wrapperEl.on("gesturechange", slideSelector, zoom.onGestureChange, passiveListener);
            swiper.$wrapperEl.on("gestureend", slideSelector, zoom.onGestureEnd, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) {
                swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
            }
        }
        // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, ".".concat(swiper.params.zoom.containerClass), zoom.onTouchMove, activeListenerWithCapture);
    },
    disable: function disable() {
        var swiper = this;
        var zoom = swiper.zoom;
        if (!zoom.enabled) return;
        swiper.zoom.enabled = false;
        var passiveListener = swiper.touchEvents.start === "touchstart" && Support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var activeListenerWithCapture = Support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        var slideSelector = ".".concat(swiper.params.slideClass);
        // Scale image
        if (Support.gestures) {
            swiper.$wrapperEl.off("gesturestart", slideSelector, zoom.onGestureStart, passiveListener);
            swiper.$wrapperEl.off("gesturechange", slideSelector, zoom.onGestureChange, passiveListener);
            swiper.$wrapperEl.off("gestureend", slideSelector, zoom.onGestureEnd, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) {
                swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
            }
        }
        // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, ".".concat(swiper.params.zoom.containerClass), zoom.onTouchMove, activeListenerWithCapture);
    }
};
var Zoom$1 = {
    name: "zoom",
    params: {
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    },
    create: function create() {
        var swiper = this;
        var zoom = {
            enabled: false,
            scale: 1,
            currentScale: 1,
            isScaling: false,
            gesture: {
                $slideEl: undefined,
                slideWidth: undefined,
                slideHeight: undefined,
                $imageEl: undefined,
                $imageWrapEl: undefined,
                maxRatio: 3
            },
            image: {
                isTouched: undefined,
                isMoved: undefined,
                currentX: undefined,
                currentY: undefined,
                minX: undefined,
                minY: undefined,
                maxX: undefined,
                maxY: undefined,
                width: undefined,
                height: undefined,
                startX: undefined,
                startY: undefined,
                touchesStart: {},
                touchesCurrent: {}
            },
            velocity: {
                x: undefined,
                y: undefined,
                prevPositionX: undefined,
                prevPositionY: undefined,
                prevTime: undefined
            }
        };
        "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach(function(methodName) {
            zoom[methodName] = Zoom[methodName].bind(swiper);
        });
        Utils.extend(swiper, {
            zoom: zoom
        });
        var scale = 1;
        Object.defineProperty(swiper.zoom, "scale", {
            get: function get() {
                return scale;
            },
            set: function set(value) {
                if (scale !== value) {
                    var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
                    var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
                    swiper.emit("zoomChange", value, imageEl, slideEl);
                }
                scale = value;
            }
        });
    },
    on: {
        init: function init() {
            var swiper = this;
            if (swiper.params.zoom.enabled) {
                swiper.zoom.enable();
            }
        },
        destroy: function destroy() {
            var swiper = this;
            swiper.zoom.disable();
        },
        touchStart: function touchStart(e) {
            var swiper = this;
            if (!swiper.zoom.enabled) return;
            swiper.zoom.onTouchStart(e);
        },
        touchEnd: function touchEnd(e) {
            var swiper = this;
            if (!swiper.zoom.enabled) return;
            swiper.zoom.onTouchEnd(e);
        },
        doubleTap: function doubleTap(e) {
            var swiper = this;
            if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
                swiper.zoom.toggle(e);
            }
        },
        transitionEnd: function transitionEnd() {
            var swiper = this;
            if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
                swiper.zoom.onTransitionEnd();
            }
        },
        slideChange: function slideChange() {
            var swiper = this;
            if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
                swiper.zoom.onTransitionEnd();
            }
        }
    }
};
var Lazy = {
    loadInSlide: function loadInSlide(index) {
        var loadInDuplicate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var swiper = this;
        var params = swiper.params.lazy;
        if (typeof index === "undefined") return;
        if (swiper.slides.length === 0) return;
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var $slideEl = isVirtual ? swiper.$wrapperEl.children(".".concat(swiper.params.slideClass, '[data-swiper-slide-index="').concat(index, '"]')) : swiper.slides.eq(index);
        var $images = $slideEl.find(".".concat(params.elementClass, ":not(.").concat(params.loadedClass, "):not(.").concat(params.loadingClass, ")"));
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
            $images = $images.add($slideEl[0]);
        }
        if ($images.length === 0) return;
        $images.each(function(imageIndex, imageEl) {
            var $imageEl = $(imageEl);
            $imageEl.addClass(params.loadingClass);
            var background = $imageEl.attr("data-background");
            var src = $imageEl.attr("data-src");
            var srcset = $imageEl.attr("data-srcset");
            var sizes = $imageEl.attr("data-sizes");
            var $pictureEl = $imageEl.parent("picture");
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function() {
                if (typeof swiper === "undefined" || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css("background-image", 'url("'.concat(background, '")'));
                    $imageEl.removeAttr("data-background");
                } else {
                    if (srcset) {
                        $imageEl.attr("srcset", srcset);
                        $imageEl.removeAttr("data-srcset");
                    }
                    if (sizes) {
                        $imageEl.attr("sizes", sizes);
                        $imageEl.removeAttr("data-sizes");
                    }
                    if ($pictureEl.length) {
                        $pictureEl.children("source").each(function(sourceIndex, sourceEl) {
                            var $source = $(sourceEl);
                            if ($source.attr("data-srcset")) {
                                $source.attr("srcset", $source.attr("data-srcset"));
                                $source.removeAttr("data-srcset");
                            }
                        });
                    }
                    if (src) {
                        $imageEl.attr("src", src);
                        $imageEl.removeAttr("data-src");
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(".".concat(params.preloaderClass)).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    var slideOriginalIndex = $slideEl.attr("data-swiper-slide-index");
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        var originalSlide = swiper.$wrapperEl.children('[data-swiper-slide-index="'.concat(slideOriginalIndex, '"]:not(.').concat(swiper.params.slideDuplicateClass, ")"));
                        swiper.lazy.loadInSlide(originalSlide.index(), false);
                    } else {
                        var duplicatedSlide = swiper.$wrapperEl.children(".".concat(swiper.params.slideDuplicateClass, '[data-swiper-slide-index="').concat(slideOriginalIndex, '"]'));
                        swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                swiper.emit("lazyImageReady", $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) {
                    swiper.updateAutoHeight();
                }
            });
            swiper.emit("lazyImageLoad", $slideEl[0], $imageEl[0]);
        });
    },
    load: function load() {
        var slideExist = function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(".".concat(swiperParams.slideClass, '[data-swiper-slide-index="').concat(index, '"]')).length) {
                    return true;
                }
            } else if (slides[index]) return true;
            return false;
        };
        var slideIndex = function slideIndex(slideEl) {
            if (isVirtual) {
                return $(slideEl).attr("data-swiper-slide-index");
            }
            return $(slideEl).index();
        };
        var swiper = this;
        var $wrapperEl = swiper.$wrapperEl, swiperParams = swiper.params, slides = swiper.slides, activeIndex = swiper.activeIndex;
        var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        var params = swiperParams.lazy;
        var slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === "auto") {
            slidesPerView = 0;
        }
        if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;
        if (swiper.params.watchSlidesVisibility) {
            $wrapperEl.children(".".concat(swiperParams.slideVisibleClass)).each(function(elIndex, slideEl) {
                var _$index = isVirtual ? $(slideEl).attr("data-swiper-slide-index") : $(slideEl).index();
                swiper.lazy.loadInSlide(_$index);
            });
        } else if (slidesPerView > 1) {
            for(var i = activeIndex; i < activeIndex + slidesPerView; i += 1){
                if (slideExist(i)) swiper.lazy.loadInSlide(i);
            }
        } else {
            swiper.lazy.loadInSlide(activeIndex);
        }
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                var amount = params.loadPrevNextAmount;
                var spv = slidesPerView;
                var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
                // Next Slides
                for(var i1 = activeIndex + slidesPerView; i1 < maxIndex; i1 += 1){
                    if (slideExist(i1)) swiper.lazy.loadInSlide(i1);
                }
                // Prev Slides
                for(var i2 = minIndex; i2 < activeIndex; i2 += 1){
                    if (slideExist(i2)) swiper.lazy.loadInSlide(i2);
                }
            } else {
                var nextSlide = $wrapperEl.children(".".concat(swiperParams.slideNextClass));
                if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));
                var prevSlide = $wrapperEl.children(".".concat(swiperParams.slidePrevClass));
                if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
            }
        }
    }
};
var Lazy$1 = {
    name: "lazy",
    params: {
        lazy: {
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            elementClass: "swiper-lazy",
            loadingClass: "swiper-lazy-loading",
            loadedClass: "swiper-lazy-loaded",
            preloaderClass: "swiper-lazy-preloader"
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            lazy: {
                initialImageLoaded: false,
                load: Lazy.load.bind(swiper),
                loadInSlide: Lazy.loadInSlide.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function beforeInit() {
            var swiper = this;
            if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
                swiper.params.preloadImages = false;
            }
        },
        init: function init() {
            var swiper = this;
            if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
                swiper.lazy.load();
            }
        },
        scroll: function scroll() {
            var swiper = this;
            if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
                swiper.lazy.load();
            }
        },
        resize: function resize() {
            var swiper = this;
            if (swiper.params.lazy.enabled) {
                swiper.lazy.load();
            }
        },
        scrollbarDragMove: function scrollbarDragMove() {
            var swiper = this;
            if (swiper.params.lazy.enabled) {
                swiper.lazy.load();
            }
        },
        transitionStart: function transitionStart() {
            var swiper = this;
            if (swiper.params.lazy.enabled) {
                if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) {
                    swiper.lazy.load();
                }
            }
        },
        transitionEnd: function transitionEnd() {
            var swiper = this;
            if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
                swiper.lazy.load();
            }
        },
        slideChange: function slideChange() {
            var swiper = this;
            if (swiper.params.lazy.enabled && swiper.params.cssMode) {
                swiper.lazy.load();
            }
        }
    }
};
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ var Controller = {
    LinearSpline: function LinearSpline(x, y) {
        var binarySearch = function search() {
            var maxIndex;
            var minIndex;
            var guess;
            return function(array, val) {
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) {
                        minIndex = guess;
                    } else {
                        maxIndex = guess;
                    }
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        var i1;
        var i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function getInterpolateFunction(c) {
        var swiper = this;
        if (!swiper.controller.spline) {
            swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
        }
    },
    setTranslate: function setTranslate(setTranslate1, byController) {
        var setControlledTranslate = function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                swiper.controller.getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) {
                controlledTranslate = c.maxTranslate() - controlledTranslate;
            }
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        };
        var swiper = this;
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;
        if (Array.isArray(controlled)) {
            for(var i = 0; i < controlled.length; i += 1){
                if (controlled[i] !== byController && (0,_instanceof/* default */.Z)(controlled[i], Swiper)) {
                    setControlledTranslate(controlled[i]);
                }
            }
        } else if ((0,_instanceof/* default */.Z)(controlled, Swiper) && byController !== controlled) {
            setControlledTranslate(controlled);
        }
    },
    setTransition: function setTransition(duration, byController) {
        var setControlledTransition = function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) {
                    Utils.nextTick(function() {
                        c.updateAutoHeight();
                    });
                }
                c.$wrapperEl.transitionEnd(function() {
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === "slide") {
                        c.loopFix();
                    }
                    c.transitionEnd();
                });
            }
        };
        var swiper = this;
        var controlled = swiper.controller.control;
        var i;
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1){
                if (controlled[i] !== byController && (0,_instanceof/* default */.Z)(controlled[i], Swiper)) {
                    setControlledTransition(controlled[i]);
                }
            }
        } else if ((0,_instanceof/* default */.Z)(controlled, Swiper) && byController !== controlled) {
            setControlledTransition(controlled);
        }
    }
};
var Controller$1 = {
    name: "controller",
    params: {
        controller: {
            control: undefined,
            inverse: false,
            by: "slide"
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            controller: {
                control: swiper.params.controller.control,
                getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
                setTranslate: Controller.setTranslate.bind(swiper),
                setTransition: Controller.setTransition.bind(swiper)
            }
        });
    },
    on: {
        update: function update() {
            var swiper = this;
            if (!swiper.controller.control) return;
            if (swiper.controller.spline) {
                swiper.controller.spline = undefined;
                delete swiper.controller.spline;
            }
        },
        resize: function resize() {
            var swiper = this;
            if (!swiper.controller.control) return;
            if (swiper.controller.spline) {
                swiper.controller.spline = undefined;
                delete swiper.controller.spline;
            }
        },
        observerUpdate: function observerUpdate() {
            var swiper = this;
            if (!swiper.controller.control) return;
            if (swiper.controller.spline) {
                swiper.controller.spline = undefined;
                delete swiper.controller.spline;
            }
        },
        setTranslate: function setTranslate(translate, byController) {
            var swiper = this;
            if (!swiper.controller.control) return;
            swiper.controller.setTranslate(translate, byController);
        },
        setTransition: function setTransition(duration, byController) {
            var swiper = this;
            if (!swiper.controller.control) return;
            swiper.controller.setTransition(duration, byController);
        }
    }
};
var a11y = {
    makeElFocusable: function makeElFocusable($el) {
        $el.attr("tabIndex", "0");
        return $el;
    },
    makeElNotFocusable: function makeElNotFocusable($el) {
        $el.attr("tabIndex", "-1");
        return $el;
    },
    addElRole: function addElRole($el, role) {
        $el.attr("role", role);
        return $el;
    },
    addElLabel: function addElLabel($el, label) {
        $el.attr("aria-label", label);
        return $el;
    },
    disableEl: function disableEl($el) {
        $el.attr("aria-disabled", true);
        return $el;
    },
    enableEl: function enableEl($el) {
        $el.attr("aria-disabled", false);
        return $el;
    },
    onEnterKey: function onEnterKey(e) {
        var swiper = this;
        var params = swiper.params.a11y;
        if (e.keyCode !== 13) return;
        var $targetEl = $(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) {
                swiper.slideNext();
            }
            if (swiper.isEnd) {
                swiper.a11y.notify(params.lastSlideMessage);
            } else {
                swiper.a11y.notify(params.nextSlideMessage);
            }
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) {
                swiper.slidePrev();
            }
            if (swiper.isBeginning) {
                swiper.a11y.notify(params.firstSlideMessage);
            } else {
                swiper.a11y.notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && $targetEl.is(".".concat(swiper.params.pagination.bulletClass))) {
            $targetEl[0].click();
        }
    },
    notify: function notify(message) {
        var swiper = this;
        var notification = swiper.a11y.liveRegion;
        if (notification.length === 0) return;
        notification.html("");
        notification.html(message);
    },
    updateNavigation: function updateNavigation() {
        var swiper = this;
        if (swiper.params.loop || !swiper.navigation) return;
        var _navigation = swiper.navigation, $nextEl = _navigation.$nextEl, $prevEl = _navigation.$prevEl;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                swiper.a11y.disableEl($prevEl);
                swiper.a11y.makeElNotFocusable($prevEl);
            } else {
                swiper.a11y.enableEl($prevEl);
                swiper.a11y.makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                swiper.a11y.disableEl($nextEl);
                swiper.a11y.makeElNotFocusable($nextEl);
            } else {
                swiper.a11y.enableEl($nextEl);
                swiper.a11y.makeElFocusable($nextEl);
            }
        }
    },
    updatePagination: function updatePagination() {
        var swiper = this;
        var params = swiper.params.a11y;
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
            swiper.pagination.bullets.each(function(bulletIndex, bulletEl) {
                var $bulletEl = $(bulletEl);
                swiper.a11y.makeElFocusable($bulletEl);
                swiper.a11y.addElRole($bulletEl, "button");
                swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
            });
        }
    },
    init: function init() {
        var swiper = this;
        swiper.$el.append(swiper.a11y.liveRegion);
        // Navigation
        var params = swiper.params.a11y;
        var $nextEl;
        var $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) {
            $nextEl = swiper.navigation.$nextEl;
        }
        if (swiper.navigation && swiper.navigation.$prevEl) {
            $prevEl = swiper.navigation.$prevEl;
        }
        if ($nextEl) {
            swiper.a11y.makeElFocusable($nextEl);
            swiper.a11y.addElRole($nextEl, "button");
            swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
            $nextEl.on("keydown", swiper.a11y.onEnterKey);
        }
        if ($prevEl) {
            swiper.a11y.makeElFocusable($prevEl);
            swiper.a11y.addElRole($prevEl, "button");
            swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
            $prevEl.on("keydown", swiper.a11y.onEnterKey);
        }
        // Pagination
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
            swiper.pagination.$el.on("keydown", ".".concat(swiper.params.pagination.bulletClass), swiper.a11y.onEnterKey);
        }
    },
    destroy: function destroy() {
        var swiper = this;
        if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
        var $nextEl;
        var $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) {
            $nextEl = swiper.navigation.$nextEl;
        }
        if (swiper.navigation && swiper.navigation.$prevEl) {
            $prevEl = swiper.navigation.$prevEl;
        }
        if ($nextEl) {
            $nextEl.off("keydown", swiper.a11y.onEnterKey);
        }
        if ($prevEl) {
            $prevEl.off("keydown", swiper.a11y.onEnterKey);
        }
        // Pagination
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
            swiper.pagination.$el.off("keydown", ".".concat(swiper.params.pagination.bulletClass), swiper.a11y.onEnterKey);
        }
    }
};
var A11y = {
    name: "a11y",
    params: {
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}"
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            a11y: {
                liveRegion: $('<span class="'.concat(swiper.params.a11y.notificationClass, '" aria-live="assertive" aria-atomic="true"></span>'))
            }
        });
        Object.keys(a11y).forEach(function(methodName) {
            swiper.a11y[methodName] = a11y[methodName].bind(swiper);
        });
    },
    on: {
        init: function init() {
            var swiper = this;
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.init();
            swiper.a11y.updateNavigation();
        },
        toEdge: function toEdge() {
            var swiper = this;
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.updateNavigation();
        },
        fromEdge: function fromEdge() {
            var swiper = this;
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.updateNavigation();
        },
        paginationUpdate: function paginationUpdate() {
            var swiper = this;
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.updatePagination();
        },
        destroy: function destroy() {
            var swiper = this;
            if (!swiper.params.a11y.enabled) return;
            swiper.a11y.destroy();
        }
    }
};
var History = {
    init: function init() {
        var swiper = this;
        if (!swiper.params.history) return;
        if (!win.history || !win.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        var history = swiper.history;
        history.initialized = true;
        history.paths = History.getPathValues();
        if (!history.paths.key && !history.paths.value) return;
        history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) {
            win.addEventListener("popstate", swiper.history.setHistoryPopState);
        }
    },
    destroy: function destroy() {
        var swiper = this;
        if (!swiper.params.history.replaceState) {
            win.removeEventListener("popstate", swiper.history.setHistoryPopState);
        }
    },
    setHistoryPopState: function setHistoryPopState() {
        var swiper = this;
        swiper.history.paths = History.getPathValues();
        swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function getPathValues() {
        var pathArray = win.location.pathname.slice(1).split("/").filter(function(part) {
            return part !== "";
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    },
    setHistory: function setHistory(key, index) {
        var swiper = this;
        if (!swiper.history.initialized || !swiper.params.history.enabled) return;
        var slide = swiper.slides.eq(index);
        var value = History.slugify(slide.attr("data-history"));
        if (!win.location.pathname.includes(key)) {
            value = "".concat(key, "/").concat(value);
        }
        var currentState = win.history.state;
        if (currentState && currentState.value === value) {
            return;
        }
        if (swiper.params.history.replaceState) {
            win.history.replaceState({
                value: value
            }, null, value);
        } else {
            win.history.pushState({
                value: value
            }, null, value);
        }
    },
    slugify: function slugify(text) {
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    },
    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
        var swiper = this;
        if (value) {
            for(var i = 0, length = swiper.slides.length; i < length; i += 1){
                var slide = swiper.slides.eq(i);
                var slideHistory = History.slugify(slide.attr("data-history"));
                if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    var _$index = slide.index();
                    swiper.slideTo(_$index, speed, runCallbacks);
                }
            }
        } else {
            swiper.slideTo(0, speed, runCallbacks);
        }
    }
};
var History$1 = {
    name: "history",
    params: {
        history: {
            enabled: false,
            replaceState: false,
            key: "slides"
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            history: {
                init: History.init.bind(swiper),
                setHistory: History.setHistory.bind(swiper),
                setHistoryPopState: History.setHistoryPopState.bind(swiper),
                scrollToSlide: History.scrollToSlide.bind(swiper),
                destroy: History.destroy.bind(swiper)
            }
        });
    },
    on: {
        init: function init() {
            var swiper = this;
            if (swiper.params.history.enabled) {
                swiper.history.init();
            }
        },
        destroy: function destroy() {
            var swiper = this;
            if (swiper.params.history.enabled) {
                swiper.history.destroy();
            }
        },
        transitionEnd: function transitionEnd() {
            var swiper = this;
            if (swiper.history.initialized) {
                swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
            }
        },
        slideChange: function slideChange() {
            var swiper = this;
            if (swiper.history.initialized && swiper.params.cssMode) {
                swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
            }
        }
    }
};
var HashNavigation = {
    onHashCange: function onHashCange() {
        var swiper = this;
        swiper.emit("hashChange");
        var newHash = doc.location.hash.replace("#", "");
        var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr("data-hash");
        if (newHash !== activeSlideHash) {
            var newIndex = swiper.$wrapperEl.children(".".concat(swiper.params.slideClass, '[data-hash="').concat(newHash, '"]')).index();
            if (typeof newIndex === "undefined") return;
            swiper.slideTo(newIndex);
        }
    },
    setHash: function setHash() {
        var swiper = this;
        if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
            win.history.replaceState(null, null, "#".concat(swiper.slides.eq(swiper.activeIndex).attr("data-hash")) || 0);
            swiper.emit("hashSet");
        } else {
            var slide = swiper.slides.eq(swiper.activeIndex);
            var hash = slide.attr("data-hash") || slide.attr("data-history");
            doc.location.hash = hash || "";
            swiper.emit("hashSet");
        }
    },
    init: function init() {
        var swiper = this;
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        swiper.hashNavigation.initialized = true;
        var hash = doc.location.hash.replace("#", "");
        if (hash) {
            var speed = 0;
            for(var i = 0, length = swiper.slides.length; i < length; i += 1){
                var slide = swiper.slides.eq(i);
                var slideHash = slide.attr("data-hash") || slide.attr("data-history");
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    var _$index = slide.index();
                    swiper.slideTo(_$index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) {
            $(win).on("hashchange", swiper.hashNavigation.onHashCange);
        }
    },
    destroy: function destroy() {
        var swiper = this;
        if (swiper.params.hashNavigation.watchState) {
            $(win).off("hashchange", swiper.hashNavigation.onHashCange);
        }
    }
};
var HashNavigation$1 = {
    name: "hash-navigation",
    params: {
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            hashNavigation: {
                initialized: false,
                init: HashNavigation.init.bind(swiper),
                destroy: HashNavigation.destroy.bind(swiper),
                setHash: HashNavigation.setHash.bind(swiper),
                onHashCange: HashNavigation.onHashCange.bind(swiper)
            }
        });
    },
    on: {
        init: function init() {
            var swiper = this;
            if (swiper.params.hashNavigation.enabled) {
                swiper.hashNavigation.init();
            }
        },
        destroy: function destroy() {
            var swiper = this;
            if (swiper.params.hashNavigation.enabled) {
                swiper.hashNavigation.destroy();
            }
        },
        transitionEnd: function transitionEnd() {
            var swiper = this;
            if (swiper.hashNavigation.initialized) {
                swiper.hashNavigation.setHash();
            }
        },
        slideChange: function slideChange() {
            var swiper = this;
            if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
                swiper.hashNavigation.setHash();
            }
        }
    }
};
/* eslint no-underscore-dangle: "off" */ var Autoplay = {
    run: function run() {
        var swiper = this;
        var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        var delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr("data-swiper-autoplay")) {
            delay = $activeSlideEl.attr("data-swiper-autoplay") || swiper.params.autoplay.delay;
        }
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = Utils.nextTick(function() {
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    swiper.slidePrev(swiper.params.speed, true, true);
                    swiper.emit("autoplay");
                } else if (!swiper.isBeginning) {
                    swiper.slidePrev(swiper.params.speed, true, true);
                    swiper.emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    swiper.emit("autoplay");
                } else {
                    swiper.autoplay.stop();
                }
            } else if (swiper.params.loop) {
                swiper.loopFix();
                swiper.slideNext(swiper.params.speed, true, true);
                swiper.emit("autoplay");
            } else if (!swiper.isEnd) {
                swiper.slideNext(swiper.params.speed, true, true);
                swiper.emit("autoplay");
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                swiper.slideTo(0, swiper.params.speed, true, true);
                swiper.emit("autoplay");
            } else {
                swiper.autoplay.stop();
            }
            if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();
        }, delay);
    },
    start: function start() {
        var swiper = this;
        if (typeof swiper.autoplay.timeout !== "undefined") return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        swiper.emit("autoplayStart");
        swiper.autoplay.run();
        return true;
    },
    stop: function stop() {
        var swiper = this;
        if (!swiper.autoplay.running) return false;
        if (typeof swiper.autoplay.timeout === "undefined") return false;
        if (swiper.autoplay.timeout) {
            clearTimeout(swiper.autoplay.timeout);
            swiper.autoplay.timeout = undefined;
        }
        swiper.autoplay.running = false;
        swiper.emit("autoplayStop");
        return true;
    },
    pause: function pause(speed) {
        var swiper = this;
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            swiper.autoplay.run();
        } else {
            swiper.$wrapperEl[0].addEventListener("transitionend", swiper.autoplay.onTransitionEnd);
            swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.autoplay.onTransitionEnd);
        }
    }
};
var Autoplay$1 = {
    name: "autoplay",
    params: {
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            autoplay: {
                running: false,
                paused: false,
                run: Autoplay.run.bind(swiper),
                start: Autoplay.start.bind(swiper),
                stop: Autoplay.stop.bind(swiper),
                pause: Autoplay.pause.bind(swiper),
                onVisibilityChange: function onVisibilityChange() {
                    if (document.visibilityState === "hidden" && swiper.autoplay.running) {
                        swiper.autoplay.pause();
                    }
                    if (document.visibilityState === "visible" && swiper.autoplay.paused) {
                        swiper.autoplay.run();
                        swiper.autoplay.paused = false;
                    }
                },
                onTransitionEnd: function onTransitionEnd(e) {
                    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
                    if (e.target !== this) return;
                    swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.autoplay.onTransitionEnd);
                    swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.autoplay.onTransitionEnd);
                    swiper.autoplay.paused = false;
                    if (!swiper.autoplay.running) {
                        swiper.autoplay.stop();
                    } else {
                        swiper.autoplay.run();
                    }
                }
            }
        });
    },
    on: {
        init: function init() {
            var swiper = this;
            if (swiper.params.autoplay.enabled) {
                swiper.autoplay.start();
                document.addEventListener("visibilitychange", swiper.autoplay.onVisibilityChange);
            }
        },
        beforeTransitionStart: function beforeTransitionStart(speed, internal) {
            var swiper = this;
            if (swiper.autoplay.running) {
                if (internal || !swiper.params.autoplay.disableOnInteraction) {
                    swiper.autoplay.pause(speed);
                } else {
                    swiper.autoplay.stop();
                }
            }
        },
        sliderFirstMove: function sliderFirstMove() {
            var swiper = this;
            if (swiper.autoplay.running) {
                if (swiper.params.autoplay.disableOnInteraction) {
                    swiper.autoplay.stop();
                } else {
                    swiper.autoplay.pause();
                }
            }
        },
        touchEnd: function touchEnd() {
            var swiper = this;
            if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
                swiper.autoplay.run();
            }
        },
        destroy: function destroy() {
            var swiper = this;
            if (swiper.autoplay.running) {
                swiper.autoplay.stop();
            }
            document.removeEventListener("visibilitychange", swiper.autoplay.onVisibilityChange);
        }
    }
};
var Fade = {
    setTranslate: function setTranslate() {
        var swiper = this;
        var slides = swiper.slides;
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = swiper.slides.eq(i);
            var _$offset = $slideEl[0].swiperSlideOffset;
            var tx = -_$offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            $slideEl.css({
                opacity: slideOpacity
            }).transform("translate3d(".concat(tx, "px, ").concat(ty, "px, 0px)"));
        }
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        var slides = swiper.slides, $wrapperEl = swiper.$wrapperEl;
        slides.transition(duration);
        if (swiper.params.virtualTranslate && duration !== 0) {
            var eventTriggered = false;
            slides.transitionEnd(function() {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                var triggerEvents = [
                    "webkitTransitionEnd",
                    "transitionend"
                ];
                for(var i = 0; i < triggerEvents.length; i += 1){
                    $wrapperEl.trigger(triggerEvents[i]);
                }
            });
        }
    }
};
var EffectFade = {
    name: "effect-fade",
    params: {
        fadeEffect: {
            crossFade: false
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            fadeEffect: {
                setTranslate: Fade.setTranslate.bind(swiper),
                setTransition: Fade.setTransition.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function beforeInit() {
            var swiper = this;
            if (swiper.params.effect !== "fade") return;
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "fade"));
            var overwriteParams = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: true
            };
            Utils.extend(swiper.params, overwriteParams);
            Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate() {
            var swiper = this;
            if (swiper.params.effect !== "fade") return;
            swiper.fadeEffect.setTranslate();
        },
        setTransition: function setTransition(duration) {
            var swiper = this;
            if (swiper.params.effect !== "fade") return;
            swiper.fadeEffect.setTransition(duration);
        }
    }
};
var Cube = {
    setTranslate: function setTranslate() {
        var swiper = this;
        var $el = swiper.$el, $wrapperEl = swiper.$wrapperEl, slides = swiper.slides, swiperWidth = swiper.width, swiperHeight = swiper.height, rtl = swiper.rtlTranslate, swiperSize = swiper.size;
        var params = swiper.params.cubeEffect;
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var wrapperRotate = 0;
        var $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: "".concat(swiperWidth, "px")
                });
            } else {
                $cubeShadowEl = $el.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = slides.eq(i);
            var slideIndex = i;
            if (isVirtual) {
                slideIndex = parseInt($slideEl.attr("data-swiper-slide-index"), 10);
            }
            var slideAngle = slideIndex * 90;
            var round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            var tx = 0;
            var ty = 0;
            var tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) {
                tx = -tx;
            }
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            var _$transform = "rotateX(".concat(isHorizontal ? 0 : -slideAngle, "deg) rotateY(").concat(isHorizontal ? slideAngle : 0, "deg) translate3d(").concat(tx, "px, ").concat(ty, "px, ").concat(tz, "px)");
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(_$transform);
            if (params.slideShadows) {
                // Set shadows
                var shadowBefore = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                var shadowAfter = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if (shadowBefore.length === 0) {
                    shadowBefore = $('<div class="swiper-slide-shadow-'.concat(isHorizontal ? "left" : "top", '"></div>'));
                    $slideEl.append(shadowBefore);
                }
                if (shadowAfter.length === 0) {
                    shadowAfter = $('<div class="swiper-slide-shadow-'.concat(isHorizontal ? "right" : "bottom", '"></div>'));
                    $slideEl.append(shadowAfter);
                }
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
        }
        $wrapperEl.css({
            "-webkit-transform-origin": "50% 50% -".concat(swiperSize / 2, "px"),
            "-moz-transform-origin": "50% 50% -".concat(swiperSize / 2, "px"),
            "-ms-transform-origin": "50% 50% -".concat(swiperSize / 2, "px"),
            "transform-origin": "50% 50% -".concat(swiperSize / 2, "px")
        });
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl.transform("translate3d(0px, ".concat(swiperWidth / 2 + params.shadowOffset, "px, ").concat(-swiperWidth / 2, "px) rotateX(90deg) rotateZ(0deg) scale(").concat(params.shadowScale, ")"));
            } else {
                var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                var scale1 = params.shadowScale;
                var scale2 = params.shadowScale / multiplier;
                var _$offset = params.shadowOffset;
                $cubeShadowEl.transform("scale3d(".concat(scale1, ", 1, ").concat(scale2, ") translate3d(0px, ").concat(swiperHeight / 2 + _$offset, "px, ").concat(-swiperHeight / 2 / scale2, "px) rotateX(-90deg)"));
            }
        }
        var zFactor = Browser.isSafari || Browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform("translate3d(0px,0,".concat(zFactor, "px) rotateX(").concat(swiper.isHorizontal() ? 0 : wrapperRotate, "deg) rotateY(").concat(swiper.isHorizontal() ? -wrapperRotate : 0, "deg)"));
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        var $el = swiper.$el, slides = swiper.slides;
        slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            $el.find(".swiper-cube-shadow").transition(duration);
        }
    }
};
var EffectCube = {
    name: "effect-cube",
    params: {
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            cubeEffect: {
                setTranslate: Cube.setTranslate.bind(swiper),
                setTransition: Cube.setTransition.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function beforeInit() {
            var swiper = this;
            if (swiper.params.effect !== "cube") return;
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "cube"));
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
            var overwriteParams = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            };
            Utils.extend(swiper.params, overwriteParams);
            Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate() {
            var swiper = this;
            if (swiper.params.effect !== "cube") return;
            swiper.cubeEffect.setTranslate();
        },
        setTransition: function setTransition(duration) {
            var swiper = this;
            if (swiper.params.effect !== "cube") return;
            swiper.cubeEffect.setTransition(duration);
        }
    }
};
var Flip = {
    setTranslate: function setTranslate() {
        var swiper = this;
        var slides = swiper.slides, rtl = swiper.rtlTranslate;
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = slides.eq(i);
            var progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) {
                progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            }
            var _$offset = $slideEl[0].swiperSlideOffset;
            var rotate = -180 * progress;
            var rotateY = rotate;
            var rotateX = 0;
            var tx = -_$offset;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) {
                rotateY = -rotateY;
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (swiper.params.flipEffect.slideShadows) {
                // Set shadows
                var shadowBefore = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                var shadowAfter = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if (shadowBefore.length === 0) {
                    shadowBefore = $('<div class="swiper-slide-shadow-'.concat(swiper.isHorizontal() ? "left" : "top", '"></div>'));
                    $slideEl.append(shadowBefore);
                }
                if (shadowAfter.length === 0) {
                    shadowAfter = $('<div class="swiper-slide-shadow-'.concat(swiper.isHorizontal() ? "right" : "bottom", '"></div>'));
                    $slideEl.append(shadowAfter);
                }
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
            $slideEl.transform("translate3d(".concat(tx, "px, ").concat(ty, "px, 0px) rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg)"));
        }
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        var slides = swiper.slides, activeIndex = swiper.activeIndex, $wrapperEl = swiper.$wrapperEl;
        slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        if (swiper.params.virtualTranslate && duration !== 0) {
            var eventTriggered = false;
            // eslint-disable-next-line
            slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
                eventTriggered = true;
                swiper.animating = false;
                var triggerEvents = [
                    "webkitTransitionEnd",
                    "transitionend"
                ];
                for(var i = 0; i < triggerEvents.length; i += 1){
                    $wrapperEl.trigger(triggerEvents[i]);
                }
            });
        }
    }
};
var EffectFlip = {
    name: "effect-flip",
    params: {
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            flipEffect: {
                setTranslate: Flip.setTranslate.bind(swiper),
                setTransition: Flip.setTransition.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function beforeInit() {
            var swiper = this;
            if (swiper.params.effect !== "flip") return;
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "flip"));
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
            var overwriteParams = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: true
            };
            Utils.extend(swiper.params, overwriteParams);
            Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate() {
            var swiper = this;
            if (swiper.params.effect !== "flip") return;
            swiper.flipEffect.setTranslate();
        },
        setTransition: function setTransition(duration) {
            var swiper = this;
            if (swiper.params.effect !== "flip") return;
            swiper.flipEffect.setTransition(duration);
        }
    }
};
var Coverflow = {
    setTranslate: function setTranslate() {
        var swiper = this;
        var swiperWidth = swiper.width, swiperHeight = swiper.height, slides = swiper.slides, $wrapperEl = swiper.$wrapperEl, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.coverflowEffect;
        var isHorizontal = swiper.isHorizontal();
        var _$transform = swiper.translate;
        var center = isHorizontal ? -_$transform + swiperWidth / 2 : -_$transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth;
        // Each slide offset from center
        for(var i = 0, length = slides.length; i < length; i += 1){
            var $slideEl = slides.eq(i);
            var slideSize = slidesSizesGrid[i];
            var slideOffset = $slideEl[0].swiperSlideOffset;
            var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
            var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            var translateZ = -translate * Math.abs(offsetMultiplier);
            var stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) {
                stretch = parseFloat(params.stretch) / 100 * slideSize;
            }
            var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            var slideTransform = "translate3d(".concat(translateX, "px,").concat(translateY, "px,").concat(translateZ, "px)  rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg) scale(").concat(scale, ")");
            $slideEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                var $shadowBeforeEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                var $shadowAfterEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if ($shadowBeforeEl.length === 0) {
                    $shadowBeforeEl = $('<div class="swiper-slide-shadow-'.concat(isHorizontal ? "left" : "top", '"></div>'));
                    $slideEl.append($shadowBeforeEl);
                }
                if ($shadowAfterEl.length === 0) {
                    $shadowAfterEl = $('<div class="swiper-slide-shadow-'.concat(isHorizontal ? "right" : "bottom", '"></div>'));
                    $slideEl.append($shadowAfterEl);
                }
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
        // Set correct perspective for IE10
        if (Support.pointerEvents || Support.prefixedPointerEvents) {
            var ws = $wrapperEl[0].style;
            ws.perspectiveOrigin = "".concat(center, "px 50%");
        }
    },
    setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
    }
};
var EffectCoverflow = {
    name: "effect-coverflow",
    params: {
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            coverflowEffect: {
                setTranslate: Coverflow.setTranslate.bind(swiper),
                setTransition: Coverflow.setTransition.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function beforeInit() {
            var swiper = this;
            if (swiper.params.effect !== "coverflow") return;
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "coverflow"));
            swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
            swiper.params.watchSlidesProgress = true;
            swiper.originalParams.watchSlidesProgress = true;
        },
        setTranslate: function setTranslate() {
            var swiper = this;
            if (swiper.params.effect !== "coverflow") return;
            swiper.coverflowEffect.setTranslate();
        },
        setTransition: function setTransition(duration) {
            var swiper = this;
            if (swiper.params.effect !== "coverflow") return;
            swiper.coverflowEffect.setTransition(duration);
        }
    }
};
var Thumbs = {
    init: function init() {
        var swiper = this;
        var _params = swiper.params, thumbsParams = _params.thumbs;
        var SwiperClass = swiper.constructor;
        if ((0,_instanceof/* default */.Z)(thumbsParams.swiper, SwiperClass)) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Utils.extend(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Utils.extend(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if (Utils.isObject(thumbsParams.swiper)) {
            swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                slideToClickedSlide: false
            }));
            swiper.thumbs.swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", swiper.thumbs.onThumbClick);
    },
    onThumbClick: function onThumbClick() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        var slideToIndex;
        if (thumbsSwiper.params.loop) {
            slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        } else {
            slideToIndex = clickedIndex;
        }
        if (swiper.params.loop) {
            var currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix();
                // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            var prevIndex = swiper.slides.eq(currentIndex).prevAll('[data-swiper-slide-index="'.concat(slideToIndex, '"]')).eq(0).index();
            var nextIndex = swiper.slides.eq(currentIndex).nextAll('[data-swiper-slide-index="'.concat(slideToIndex, '"]')).eq(0).index();
            if (typeof prevIndex === "undefined") slideToIndex = nextIndex;
            else if (typeof nextIndex === "undefined") slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    },
    update: function update(initial) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        var slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            var currentThumbsIndex = thumbsSwiper.activeIndex;
            var newThumbsIndex;
            var direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix();
                    // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                }
                // Find actual thumbs index to slide to
                var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll('[data-swiper-slide-index="'.concat(swiper.realIndex, '"]')).eq(0).index();
                var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll('[data-swiper-slide-index="'.concat(swiper.realIndex, '"]')).eq(0).index();
                if (typeof prevThumbsIndex === "undefined") newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === "undefined") newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) {
                newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            }
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) {
                        newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    } else {
                        newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                    }
                } else if (newThumbsIndex > currentThumbsIndex) {
                    newThumbsIndex = newThumbsIndex - slidesPerView + 1;
                }
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
        // Activate thumbs
        var thumbsToActivate = 1;
        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
            thumbsToActivate = swiper.params.slidesPerView;
        }
        if (!swiper.params.thumbs.multipleActiveThumbs) {
            thumbsToActivate = 1;
        }
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
            for(var i = 0; i < thumbsToActivate; i += 1){
                thumbsSwiper.$wrapperEl.children('[data-swiper-slide-index="'.concat(swiper.realIndex + i, '"]')).addClass(thumbActiveClass);
            }
        } else {
            for(var i1 = 0; i1 < thumbsToActivate; i1 += 1){
                thumbsSwiper.slides.eq(swiper.realIndex + i1).addClass(thumbActiveClass);
            }
        }
    }
};
var Thumbs$1 = {
    name: "thumbs",
    params: {
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-container-thumbs"
        }
    },
    create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
            thumbs: {
                swiper: null,
                init: Thumbs.init.bind(swiper),
                update: Thumbs.update.bind(swiper),
                onThumbClick: Thumbs.onThumbClick.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function beforeInit() {
            var swiper = this;
            var thumbs = swiper.params.thumbs;
            if (!thumbs || !thumbs.swiper) return;
            swiper.thumbs.init();
            swiper.thumbs.update(true);
        },
        slideChange: function slideChange() {
            var swiper = this;
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        update: function update() {
            var swiper = this;
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        resize: function resize() {
            var swiper = this;
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        observerUpdate: function observerUpdate() {
            var swiper = this;
            if (!swiper.thumbs.swiper) return;
            swiper.thumbs.update();
        },
        setTransition: function setTransition(duration) {
            var swiper = this;
            var thumbsSwiper = swiper.thumbs.swiper;
            if (!thumbsSwiper) return;
            thumbsSwiper.setTransition(duration);
        },
        beforeDestroy: function beforeDestroy() {
            var swiper = this;
            var thumbsSwiper = swiper.thumbs.swiper;
            if (!thumbsSwiper) return;
            if (swiper.thumbs.swiperCreated && thumbsSwiper) {
                thumbsSwiper.destroy();
            }
        }
    }
};
// Swiper Class
var components = [
    Device$1,
    Support$1,
    Browser$1,
    Resize,
    Observer$1,
    Virtual$1,
    Keyboard$1,
    Mousewheel$1,
    Navigation$1,
    Pagination$1,
    Scrollbar$1,
    Parallax$1,
    Zoom$1,
    Lazy$1,
    Controller$1,
    A11y,
    History$1,
    HashNavigation$1,
    Autoplay$1,
    EffectFade,
    EffectCube,
    EffectFlip,
    EffectCoverflow,
    Thumbs$1
];
if (typeof Swiper.use === "undefined") {
    Swiper.use = Swiper.Class.use;
    Swiper.installModule = Swiper.Class.installModule;
}
Swiper.use(components);
/* harmony default export */ var swiper_esm_bundle = (Swiper); //# sourceMappingURL=swiper.esm.bundle.js.map


/***/ }),

/***/ 86639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ Analytics; },
/* harmony export */   "Zf": function() { return /* binding */ SEZNAM_CID_SUCCESS_SUBSCRIPTION; },
/* harmony export */   "sP": function() { return /* binding */ SEZNAM_CID_SUCCESS_REGISTRATION; },
/* harmony export */   "yO": function() { return /* binding */ SEZNAM_CID_SUCCESS_VOUCHER; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62139);

var SEZNAM_CID_SUCCESS_SUBSCRIPTION = "100068650";
var SEZNAM_CID_SUCCESS_VOUCHER = "100071337";
var SEZNAM_CID_SUCCESS_REGISTRATION = "100071335";
var GA_ID = "GTM-M27M94C";
var Analytics = /*#__PURE__*/ function() {
    "use strict";
    function Analytics() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Analytics);
    }
    /* Analytics for GTM */ Analytics.v2_signUp = function v2_signUp() {
        Analytics.gtmEvent("sign_up");
    };
    Analytics.v2_subscriptionPurchase = function v2_subscriptionPurchase(plan) {
        Analytics.gtmEvent("subscription_purchase", {
            subscription_type: "".concat(plan.recurrence.length, "_").concat(plan.recurrence.unit.toLowerCase()),
            currency: plan.price.currency,
            value: plan.price.value
        });
    };
    Analytics.v2_subscriptionPurchaseWithCoupon = function v2_subscriptionPurchaseWithCoupon(coupon) {
        Analytics.gtmEvent("subscription_purchase", {
            coupon: coupon
        });
    };
    Analytics.v2_subscriptionRenewal = function v2_subscriptionRenewal(plan) {
        Analytics.gtmEvent("subscription_renewal", {
            subscription_type: "".concat(plan.recurrence.length, "_").concat(plan.recurrence.unit.toLowerCase()),
            currency: plan.price.currency,
            value: plan.price.value
        });
    };
    Analytics.v2_subscriptionCancel = function v2_subscriptionCancel(plan) {
        Analytics.gtmEvent("subscription_cancel", {
            subscription_type: "".concat(plan.recurrence.length, "_").concat(plan.recurrence.unit.toLowerCase()),
            currency: plan.price.currency,
            value: plan.price.value
        });
    };
    Analytics.v2_voucherPurchase = function v2_voucherPurchase(plan) {
        Analytics.gtmEvent("voucher_purchase", {
            subscription_type: "".concat(plan.recurrence.length, "_").concat(plan.recurrence.unit.toLowerCase()),
            currency: plan.price.currency,
            value: plan.price.value
        });
    };
    Analytics.v2_trailerView = function v2_trailerView(title, theatreName, playProgress) {
        Analytics.gtmEvent("trailer_view", {
            video_title: title,
            theater_name: theatreName,
            play_progress: playProgress
        });
    };
    Analytics.v2_playView = function v2_playView(title, theatreName, playProgress) {
        Analytics.gtmEvent("play_view", {
            video_title: title,
            theater_name: theatreName,
            play_progress: playProgress
        });
    };
    Analytics.v2_watchlistAdd = function v2_watchlistAdd(title, theatreName) {
        Analytics.gtmEvent("watchlist_add", {
            video_title: title,
            theater_name: theatreName
        });
        Analytics.facebookEvent("AddToWishlist");
    };
    Analytics.v2_watchlistRemove = function v2_watchlistRemove(title, theatreName) {
        Analytics.gtmEvent("watchlist_remove", {
            video_title: title,
            theater_name: theatreName
        });
        Analytics.facebookEvent("RemoveFromWatchlist");
    };
    Analytics.v2_theatreDonation = function v2_theatreDonation(theatreName, currency, value) {
        Analytics.gtmEvent("theater_donation", {
            theater_name: theatreName,
            currency: currency,
            value: value
        });
    };
    Analytics.v2_trialStart = function v2_trialStart() {
        Analytics.gtmEvent("trial_start");
        Analytics.facebookEvent("StartTrial");
    };
    /* // Analytics for GTM */ /* Facebook */ Analytics.completeRegistration = function completeRegistration() {
        Analytics.facebookEvent("CompleteRegistration");
    };
    Analytics.setCurrentUrlForGoogle = function setCurrentUrlForGoogle(path) {
        var gtag = window.gtag;
        if (gtag) {
            gtag("config", {
                page_path: path
            });
        } else {
            console.log("GA setting current", path);
        }
    };
    Analytics.facebookEvent = function facebookEvent(operation, body) {
        var fbq = window.fbq;
        if (fbq) {
            fbq("track", operation, body);
        } else {
            console.log("Facebook event logged", operation, body);
        }
    };
    return Analytics;
}();
Analytics.gtmEvent = function(eventName) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var data = Object.assign({
        event: eventName
    }, params);
    if (window.dataLayer) {
        window.dataLayer.push(data);
    } else {
        console.log("GTM event logged", data);
    }
};
/* class */ 


/***/ }),

/***/ 61400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62139);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49573);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54146);
/* harmony import */ var _enums_drm__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49590);
/* provided dependency */ var process = __webpack_require__(89885);




/* class */ var PlaformHelper = /*#__PURE__*/ function() {
    "use strict";
    function PlaformHelper() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, PlaformHelper);
        this.isDevelopment = "production" !== "production";
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(PlaformHelper, [
        {
            key: "IS_MAC",
            get: // eslint-disable-next-line @typescript-eslint/no-unused-vars
            function get() {
                return navigator.platform.indexOf("Mac") > -1;
            }
        },
        {
            key: "IS_WINDOWS",
            get: function get() {
                return navigator.platform.indexOf("Win") > -1;
            }
        },
        {
            key: "USER_AGENT",
            get: function get() {
                return window.navigator && window.navigator.userAgent || "";
            }
        },
        {
            key: "IE_VERSION",
            get: function get() {
                return function() {
                    var result = /MSIE\s(\d+)\.\d/.exec(this.USER_AGENT);
                    var version = result && parseFloat(result[1]);
                    if (!version && /Trident\/7.0/i.test(this.USER_AGENT) && /rv:11.0/.test(this.USER_AGENT)) {
                        version = 11.0;
                    }
                    return version;
                }();
            }
        },
        {
            key: "IS_EDGE",
            get: function get() {
                return this.USER_AGENT.indexOf("Edge/") > -1;
            }
        },
        {
            key: "IS_CHROMIUM_EDGE",
            get: function get() {
                return this.USER_AGENT.indexOf("Edg/") > -1;
            }
        },
        {
            key: "IS_ANDROID",
            get: function get() {
                return /Android/i.test(this.USER_AGENT);
            }
        },
        {
            key: "IS_CHROME",
            get: function get() {
                return !this.IS_EDGE && !this.IS_CHROMIUM_EDGE && (/Chrome/i.test(this.USER_AGENT) || /CriOS/i.test(this.USER_AGENT));
            }
        },
        {
            key: "IS_SAFARI",
            get: function get() {
                return /Safari/i.test(this.USER_AGENT) && !this.IS_CHROME && !this.IS_ANDROID && !this.IS_EDGE && !this.IS_CHROMIUM_EDGE;
            }
        },
        {
            key: "IS_IE",
            get: // eslint-disable-next-line @typescript-eslint/no-unused-vars
            function get() {
                return this.IS_EDGE || this.IE_VERSION;
            }
        },
        {
            key: "TOUCH_ENABLED",
            get: function get() {
                return Boolean("ontouchstart" in window || window.navigator.maxTouchPoints || // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                (window.DocumentTouch && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(window.document, window.DocumentTouch)));
            }
        },
        {
            key: "IS_IPOD",
            get: function get() {
                return /iPod/i.test(this.USER_AGENT);
            }
        },
        {
            key: "IS_IPAD",
            get: function get() {
                return /iPad/i.test(this.USER_AGENT) || this.IS_SAFARI && this.TOUCH_ENABLED && !/iPhone/i.test(this.USER_AGENT);
            }
        },
        {
            key: "IS_IPHONE",
            get: function get() {
                return /iPhone/i.test(this.USER_AGENT) && !this.IS_IPAD;
            }
        },
        {
            key: "IS_IOS",
            get: function get() {
                return this.IS_IPHONE || this.IS_IPAD || this.IS_IPOD;
            }
        },
        {
            key: "IS_APPLE",
            get: function get() {
                return this.IS_IOS || this.IS_SAFARI;
            }
        },
        {
            key: "isProduction",
            get: function get() {
                return !this.isDevelopment;
            }
        },
        {
            key: "platform",
            get: function get() {
                var _PLATFORM;
                return (_PLATFORM = process.env.PLATFORM) !== null && _PLATFORM !== void 0 ? _PLATFORM : "web";
            }
        },
        {
            key: "drmLicenseServerUrl",
            get: function get() {
                if (this.drmLicenseType === _enums_drm__WEBPACK_IMPORTED_MODULE_0__/* .DRMLicenseType.Widevine */ .R.Widevine) {
                    return "https://widevine.keyos.com/api/v4/getLicense";
                }
                return "https://playready.keyos.com/api/v4/getLicense";
            }
        },
        {
            key: "drmLicenseType",
            get: function get() {
                // use Google's Widevine license as a default
                var license = _enums_drm__WEBPACK_IMPORTED_MODULE_0__/* .DRMLicenseType.Widevine */ .R.Widevine;
                if (this.IS_SAFARI || this.IS_IOS) {
                    license = _enums_drm__WEBPACK_IMPORTED_MODULE_0__/* .DRMLicenseType.FairPlay */ .R.FairPlay;
                } else if (this.IS_EDGE && this.IS_WINDOWS) {
                    // Only switch to PlayReady on Windows with non-Chromium based Edge
                    license = _enums_drm__WEBPACK_IMPORTED_MODULE_0__/* .DRMLicenseType.PlayReady */ .R.PlayReady;
                }
                return license;
            }
        },
        {
            key: "drmLicenseTypeKey",
            get: function get() {
                return _enums_drm__WEBPACK_IMPORTED_MODULE_0__/* .DRMLicenseKey */ .X[this.drmLicenseType];
            }
        },
        {
            key: "isApple",
            get: function get() {
                return this.IS_APPLE;
            }
        },
        {
            key: "isChrome",
            get: function get() {
                return this.IS_CHROME;
            }
        },
        {
            key: "isSafari",
            get: function get() {
                return this.IS_SAFARI;
            }
        },
        {
            key: "isMobile",
            get: function get() {
                return this.IS_IOS || this.IS_ANDROID;
            }
        },
        {
            key: "isMobileSafari",
            get: function get() {
                return this.IS_IOS && this.IS_SAFARI;
            }
        }
    ]);
    return PlaformHelper;
}();
/* harmony default export */ __webpack_exports__["Z"] = (new PlaformHelper());


/***/ }),

/***/ 47118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rv": function() { return /* binding */ sortByKeys; },
/* harmony export */   "a": function() { return /* binding */ sortAlphabetically; },
/* harmony export */   "ew": function() { return /* binding */ truncateTitle; },
/* harmony export */   "in": function() { return /* binding */ determinePluralFromNumber; },
/* harmony export */   "kj": function() { return /* binding */ truncateSeoDescription; },
/* harmony export */   "mR": function() { return /* binding */ unifyArray; },
/* harmony export */   "sN": function() { return /* binding */ userLogo; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "um": function() { return /* binding */ formatCard; }
/* harmony export */ });
/* unused harmony exports utf8_encode, utf8_decode, truncate */
/* harmony import */ var utf8__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7827);
/* harmony import */ var utf8__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(utf8__WEBPACK_IMPORTED_MODULE_0__);

function sortByKeys(array, sortAttr, sortKeys) {
    var result = sortKeys === null || sortKeys === void 0 ? void 0 : sortKeys.map(function(sk) {
        return array === null || array === void 0 ? void 0 : array.find(function(item) {
            return item[sortAttr] === sk;
        });
    });
    var rest = array === null || array === void 0 ? void 0 : array.filter(function(item) {
        return sortKeys.indexOf(item[sortAttr]) === -1;
    });
    return result.concat(rest).filter(function(r) {
        return !!r;
    });
}
function utf8_encode(str) {
    try {
        return utf.decode(utf.encode(str));
    } catch (e) {
        return str;
    }
}
function utf8_decode(str) {
    try {
        return utf.decode(str);
    } catch (e) {
        return str;
    }
}
function truncateTitle(title) {
    if (title && title.length >= 45) {
        return title.split("").slice(0, title.lastIndexOf(" ", 45)).join("") + "...";
    }
    return title;
}
function sortAlphabetically(array, attr) {
    return array === null || array === void 0 ? void 0 : array.sort(function(a, b) {
        if (attr in a && attr in b) {
            return a[attr].localeCompare(b[attr]);
        }
        return 0;
    });
}
function unifyArray(array) {
    return array.filter(function(v, i, a) {
        return a.indexOf(v) === i;
    });
}
var isServer = function() {
    return "object" === "undefined";
};
// export const encodeBase64 = (obj) => {
//   const str = JSON.stringify(obj);
//   return Buffer.from(str).toString('base64');
// };
var userLogo = function(name) {
    return name && name.length > 0 ? name[0] : "";
};
var formatCard = function(lastDigits) {
    return "\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 ".concat(lastDigits);
};
/**
 * Truncates the given text to the specified length without breaking the words.
 *
 * @param {string} text
 * @param {number} max
 * @returns {string}
 */ function truncate(text, max) {
    return text && text.length > max ? "".concat(text.slice(0, max).split(" ").slice(0, -1).join(" "), "...") : text;
}
function truncateSeoDescription(desc) {
    return truncate(desc, 157);
}
var Plural;
(function(Plural) {
    Plural["Zero"] = "zero";
    Plural["One"] = "one";
    Plural["Few"] = "few";
    Plural["Many"] = "many";
})(Plural || (Plural = {}));
function determinePluralFromNumber(num) {
    if (num === 0) {
        return Plural.Zero;
    } else if (num === 1) {
        return Plural.One;
    } else if (num <= 4) {
        return Plural.Few;
    } else {
        return Plural.Many;
    }
}


/***/ }),

/***/ 17651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xm": function() { return /* reexport */ Permalink; },
  "Fi": function() { return /* reexport */ jsx/* basicSEO */.F; },
  "gk": function() { return /* reexport */ closeDialog; },
  "_P": function() { return /* reexport */ countryFromHost; },
  "yx": function() { return /* reexport */ countryHasNoTrial; },
  "b_": function() { return /* reexport */ countryHasTrial; },
  "ZS": function() { return /* reexport */ createFormSchema; },
  "Ds": function() { return /* reexport */ debounce; },
  "in": function() { return /* reexport */ common/* determinePluralFromNumber */["in"]; },
  "Pn": function() { return /* reexport */ domainFromHost; },
  "EZ": function() { return /* reexport */ donateRule; },
  "$D": function() { return /* reexport */ emailRule; },
  "MI": function() { return /* reexport */ forceLanguage; },
  "um": function() { return /* reexport */ common/* formatCard */.um; },
  "p6": function() { return /* reexport */ formatDate; },
  "B3": function() { return /* reexport */ formatYear; },
  "A9": function() { return /* reexport */ getCastImg; },
  "bn": function() { return /* reexport */ getDOM; },
  "Cd": function() { return /* reexport */ getDOMCls; },
  "GB": function() { return /* reexport */ getLocaleFromUrl; },
  "jU": function() { return /* reexport */ getNoTrialTranslationKeyIfNeeded; },
  "ho": function() { return /* reexport */ host; },
  "sQ": function() { return /* reexport */ imageUrl; },
  "Ur": function() { return /* reexport */ isLiveProduction; },
  "wF": function() { return /* reexport */ isLoginRoute; },
  "lZ": function() { return /* reexport */ isMobileView; },
  "rQ": function() { return /* reexport */ isPerformanceRoute; },
  "yv": function() { return /* reexport */ isProduction; },
  "sk": function() { return /* reexport */ common/* isServer */.sk; },
  "vB": function() { return /* reexport */ kinoboxLink; },
  "Op": function() { return /* reexport */ localeFromHost; },
  "vb": function() { return /* reexport */ localeToCountry; },
  "_Q": function() { return /* reexport */ localiseUrl; },
  "ji": function() { return /* reexport */ notEmptyRule; },
  "A": function() { return /* reexport */ passwordAgainRule; },
  "nk": function() { return /* reexport */ passwordRule; },
  "G0": function() { return /* reexport */ removeErrorClass; },
  "Fx": function() { return /* reexport */ resetForm; },
  "bp": function() { return /* reexport */ sec2time; },
  "UH": function() { return /* reexport */ sec2toHHMMSS; },
  "bG": function() { return /* reexport */ setLoadingState; },
  "Tf": function() { return /* reexport */ signCookie; },
  "V3": function() { return /* reexport */ slugifyString; },
  "a": function() { return /* reexport */ common/* sortAlphabetically */.a; },
  "Rv": function() { return /* reexport */ common/* sortByKeys */.Rv; },
  "Q$": function() { return /* reexport */ toggleDialogWithCls; },
  "ew": function() { return /* reexport */ common/* truncateTitle */.ew; },
  "mZ": function() { return /* reexport */ twoLetterShortName; },
  "mR": function() { return /* reexport */ common/* unifyArray */.mR; },
  "sN": function() { return /* reexport */ common/* userLogo */.sN; },
  "G$": function() { return /* reexport */ validateForm; }
});

// UNUSED EXPORTS: SEZNAM_CID_SUCCESS_REGISTRATION, SEZNAM_CID_SUCCESS_SUBSCRIPTION, SEZNAM_CID_SUCCESS_VOUCHER, StorageItem, clsLoading, createRedirectIfNeeded, getFormInputs, getHtmlEl, getPrefferedDomainForCountry, getServerSideLang, isBrowseRoute, isDevelopment, isGoogleUserAgent, isHomeRoute, isIPWhitelistedForSkippingIPCheck, isNotAllowWhenLogged, isNotAllowWhenUnlogged, numberRule, setHost, shuffleArray, truncate, truncateSeoDescription, utf8_decode, utf8_encode

// EXTERNAL MODULE: ./enums/country.ts
var enums_country = __webpack_require__(72473);
;// CONCATENATED MODULE: ./helpers/env.ts

var isLiveProduction = !!+"1";
var isDevelopment = "production" !== "production";
var isProduction = !isDevelopment;
var localeCountryMap = {
    cs: enums_country/* Country.Czechia */.c.Czechia,
    sk: enums_country/* Country.Slovakia */.c.Slovakia,
    uk: enums_country/* Country.Ukraine */.c.Ukraine,
    pl: enums_country/* Country.Poland */.c.Poland
};
function isIPWhitelistedForSkippingIPCheck(ip) {
    // only whitelist for dev
    if (isLiveProduction) {
        return false;
    }
    var whitelist = "34.199.54.x\n  34.232.25.x\n  34.232.119.x\n  34.236.25.x\n  35.171.175.x\n  52.54.90.x\n  52.202.195.x\n  52.203.14.x\n  52.204.96.x\n  34.218.156.x\n  34.218.168.x\n  52.41.219.x\n  35.155.178.x\n  35.160.177.x\n  34.216.18.x";
    var whitelistIps = whitelist.split("\n").map(function(ip) {
        return ip.replace(".x", "");
    });
    return whitelistIps.filter(function(_ip) {
        return ip.indexOf(_ip) !== -1;
    }).length > 0;
}
function isGoogleUserAgent(agent) {
    return (agent !== null && agent !== void 0 ? agent : "").search(/(G|g)oogle/g) > -1;
}
var _host;
var _lang;
function setHost(host) {
    _host = host;
}
function host() {
    if (true) {
        return window.location.host;
    }
    return _host;
}
function getServerSideLang() {
    return _lang;
}
function localeToCountry(locale) {
    return localeCountryMap[locale];
}
/**
 * Some countries don't have trial. Return alternative translation key for the original key
 *
 * @export
 * @param {string} originalKey
 * @param {string} countryLocale
 * @returns
 */ function getNoTrialTranslationKeyIfNeeded(originalKey, countryCode) {
    if (countryHasNoTrial(countryCode)) {
        var namespace = "";
        var key = "";
        var namespaceSplit = originalKey.split(":");
        if (namespaceSplit.length > 1) {
            namespace = namespaceSplit[0];
        }
        key = namespaceSplit[namespaceSplit.length - 1];
        var context = key.split(".");
        context[context.length - 1] = "no_trial_".concat(context[context.length - 1]);
        return [
            namespace,
            context.join(".")
        ].filter(function(t) {
            return !!t;
        }).join(":");
    }
    return originalKey;
}
function countryHasNoTrial(country) {
    return country === "pl";
}
function countryHasTrial(country) {
    return !countryHasNoTrial(country);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(43692);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(84911);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(44453);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(67902);
;// CONCATENATED MODULE: ./helpers/dom.ts




var CLS_DIALOG_OPEN = "dialog-open";
function closeDialog(cls) {
    getDOMCls().remove(CLS_DIALOG_OPEN, cls);
}
var getDOM = function() {
    return document;
};
var getDOMCls = function() {
    return getDOM().documentElement.classList;
};
var getHtmlEl = function() {
    return getDOM().documentElement;
};
var isMobileView = function() {
    return window.innerWidth < constants/* MOBILE_VIEW_PX */.Xx;
};
function toggleDialogWithCls(cls) {
    var closeOnEsc = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, onClose = arguments.length > 2 ? arguments[2] : void 0;
    var _list;
    if (!Array.isArray(cls)) {
        cls = [
            cls
        ];
    }
    var elHtml = getHtmlEl();
    var list = getDOMCls();
    (_list = list).add.apply(_list, (0,_to_consumable_array/* default */.Z)(cls).concat([
        CLS_DIALOG_OPEN
    ]));
    if (closeOnEsc) {
        var close = function() {
            var _list;
            (_list = list).remove.apply(_list, (0,_to_consumable_array/* default */.Z)(cls).concat([
                CLS_DIALOG_OPEN
            ]));
            elHtml.removeEventListener("keydown", closeKeyboardEvent, false);
            onClose && onClose();
        };
        var closeKeyboardEvent = function(e) {
            if (e.code === "Escape") {
                close();
            }
        };
        elHtml.addEventListener("keydown", closeKeyboardEvent, false);
    }
}
var debounce = function(func) {
    var waitFor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var timeout;
    var a = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _len, args, _key, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        for(_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = _args[_key];
                        }
                        return _ctx.abrupt("return", new Promise(function(resolve) {
                            if (timeout) {
                                clearTimeout(timeout);
                            }
                            timeout = setTimeout(function() {
                                return resolve(func.apply(void 0, (0,_to_consumable_array/* default */.Z)(args)));
                            }, waitFor);
                        }));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function a() {
            return _ref.apply(this, arguments);
        };
    }();
    return a;
};

// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(47118);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(1780);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isDate/index.js

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(55686);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = (0,toDate/* default */.Z)(dirtyDate);
  return !isNaN(Number(date));
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

/* harmony default export */ var _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ var _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js






/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addMilliseconds/index.js



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var timestamp = (0,toDate/* default */.Z)(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ var format_formatters = (formatters_formatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ var format_longFormatters = (longFormatters);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(63288);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/format/index.js









 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || en_US;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = (0,toDate/* default */.Z)(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = format_formatters[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/cs/_lib/formatDistance/index.js
var formatDistance_formatDistanceLocale = {
  lessThanXSeconds: {
    one: {
      regular: 'méně než sekunda',
      past: 'před méně než sekundou',
      future: 'za méně než sekundu'
    },
    few: {
      regular: 'méně než {{count}} sekundy',
      past: 'před méně než {{count}} sekundami',
      future: 'za méně než {{count}} sekundy'
    },
    many: {
      regular: 'méně než {{count}} sekund',
      past: 'před méně než {{count}} sekundami',
      future: 'za méně než {{count}} sekund'
    }
  },
  xSeconds: {
    one: {
      regular: 'sekunda',
      past: 'před sekundou',
      future: 'za sekundu'
    },
    few: {
      regular: '{{count}} sekundy',
      past: 'před {{count}} sekundami',
      future: 'za {{count}} sekundy'
    },
    many: {
      regular: '{{count}} sekund',
      past: 'před {{count}} sekundami',
      future: 'za {{count}} sekund'
    }
  },
  halfAMinute: {
    other: {
      regular: 'půl minuty',
      past: 'před půl minutou',
      future: 'za půl minuty'
    }
  },
  lessThanXMinutes: {
    one: {
      regular: 'méně než minuta',
      past: 'před méně než minutou',
      future: 'za méně než minutu'
    },
    few: {
      regular: 'méně než {{count}} minuty',
      past: 'před méně než {{count}} minutami',
      future: 'za méně než {{count}} minuty'
    },
    many: {
      regular: 'méně než {{count}} minut',
      past: 'před méně než {{count}} minutami',
      future: 'za méně než {{count}} minut'
    }
  },
  xMinutes: {
    one: {
      regular: 'minuta',
      past: 'před minutou',
      future: 'za minutu'
    },
    few: {
      regular: '{{count}} minuty',
      past: 'před {{count}} minutami',
      future: 'za {{count}} minuty'
    },
    many: {
      regular: '{{count}} minut',
      past: 'před {{count}} minutami',
      future: 'za {{count}} minut'
    }
  },
  aboutXHours: {
    one: {
      regular: 'přibližně hodina',
      past: 'přibližně před hodinou',
      future: 'přibližně za hodinu'
    },
    few: {
      regular: 'přibližně {{count}} hodiny',
      past: 'přibližně před {{count}} hodinami',
      future: 'přibližně za {{count}} hodiny'
    },
    many: {
      regular: 'přibližně {{count}} hodin',
      past: 'přibližně před {{count}} hodinami',
      future: 'přibližně za {{count}} hodin'
    }
  },
  xHours: {
    one: {
      regular: 'hodina',
      past: 'před hodinou',
      future: 'za hodinu'
    },
    few: {
      regular: '{{count}} hodiny',
      past: 'před {{count}} hodinami',
      future: 'za {{count}} hodiny'
    },
    many: {
      regular: '{{count}} hodin',
      past: 'před {{count}} hodinami',
      future: 'za {{count}} hodin'
    }
  },
  xDays: {
    one: {
      regular: 'den',
      past: 'před dnem',
      future: 'za den'
    },
    few: {
      regular: '{{count}} dny',
      past: 'před {{count}} dny',
      future: 'za {{count}} dny'
    },
    many: {
      regular: '{{count}} dní',
      past: 'před {{count}} dny',
      future: 'za {{count}} dní'
    }
  },
  aboutXWeeks: {
    one: {
      regular: 'přibližně týden',
      past: 'přibližně před týdnem',
      future: 'přibližně za týden'
    },
    few: {
      regular: 'přibližně {{count}} týdny',
      past: 'přibližně před {{count}} týdny',
      future: 'přibližně za {{count}} týdny'
    },
    many: {
      regular: 'přibližně {{count}} týdnů',
      past: 'přibližně před {{count}} týdny',
      future: 'přibližně za {{count}} týdnů'
    }
  },
  xWeeks: {
    one: {
      regular: 'týden',
      past: 'před týdnem',
      future: 'za týden'
    },
    few: {
      regular: '{{count}} týdny',
      past: 'před {{count}} týdny',
      future: 'za {{count}} týdny'
    },
    many: {
      regular: '{{count}} týdnů',
      past: 'před {{count}} týdny',
      future: 'za {{count}} týdnů'
    }
  },
  aboutXMonths: {
    one: {
      regular: 'přibližně měsíc',
      past: 'přibližně před měsícem',
      future: 'přibližně za měsíc'
    },
    few: {
      regular: 'přibližně {{count}} měsíce',
      past: 'přibližně před {{count}} měsíci',
      future: 'přibližně za {{count}} měsíce'
    },
    many: {
      regular: 'přibližně {{count}} měsíců',
      past: 'přibližně před {{count}} měsíci',
      future: 'přibližně za {{count}} měsíců'
    }
  },
  xMonths: {
    one: {
      regular: 'měsíc',
      past: 'před měsícem',
      future: 'za měsíc'
    },
    few: {
      regular: '{{count}} měsíce',
      past: 'před {{count}} měsíci',
      future: 'za {{count}} měsíce'
    },
    many: {
      regular: '{{count}} měsíců',
      past: 'před {{count}} měsíci',
      future: 'za {{count}} měsíců'
    }
  },
  aboutXYears: {
    one: {
      regular: 'přibližně rok',
      past: 'přibližně před rokem',
      future: 'přibližně za rok'
    },
    few: {
      regular: 'přibližně {{count}} roky',
      past: 'přibližně před {{count}} roky',
      future: 'přibližně za {{count}} roky'
    },
    many: {
      regular: 'přibližně {{count}} roků',
      past: 'přibližně před {{count}} roky',
      future: 'přibližně za {{count}} roků'
    }
  },
  xYears: {
    one: {
      regular: 'rok',
      past: 'před rokem',
      future: 'za rok'
    },
    few: {
      regular: '{{count}} roky',
      past: 'před {{count}} roky',
      future: 'za {{count}} roky'
    },
    many: {
      regular: '{{count}} roků',
      past: 'před {{count}} roky',
      future: 'za {{count}} roků'
    }
  },
  overXYears: {
    one: {
      regular: 'více než rok',
      past: 'před více než rokem',
      future: 'za více než rok'
    },
    few: {
      regular: 'více než {{count}} roky',
      past: 'před více než {{count}} roky',
      future: 'za více než {{count}} roky'
    },
    many: {
      regular: 'více než {{count}} roků',
      past: 'před více než {{count}} roky',
      future: 'za více než {{count}} roků'
    }
  },
  almostXYears: {
    one: {
      regular: 'skoro rok',
      past: 'skoro před rokem',
      future: 'skoro za rok'
    },
    few: {
      regular: 'skoro {{count}} roky',
      past: 'skoro před {{count}} roky',
      future: 'skoro za {{count}} roky'
    },
    many: {
      regular: 'skoro {{count}} roků',
      past: 'skoro před {{count}} roky',
      future: 'skoro za {{count}} roků'
    }
  }
};
function formatDistance_formatDistance(token, count, options) {
  options = options || {};
  var scheme = formatDistance_formatDistanceLocale[token]; // cs pluralization

  var pluralToken;

  if (typeof scheme.other === 'object') {
    pluralToken = 'other';
  } else if (count === 1) {
    pluralToken = 'one';
  } else if (count > 1 && count < 5) {
    pluralToken = 'few';
  } else {
    pluralToken = 'many';
  } // times


  var suffixExist = options.addSuffix === true;
  var comparison = options.comparison;
  var timeToken;

  if (suffixExist && comparison === -1) {
    timeToken = 'past';
  } else if (suffixExist && comparison === 1) {
    timeToken = 'future';
  } else {
    timeToken = 'regular';
  }

  return scheme[pluralToken][timeToken].replace('{{count}}', count);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/cs/_lib/formatLong/index.js

var formatLong_dateFormats = {
  full: 'EEEE, d. MMMM yyyy',
  long: 'd. MMMM yyyy',
  medium: 'd. M. yyyy',
  short: 'dd.MM.yyyy'
};
var formatLong_timeFormats = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var formatLong_dateTimeFormats = {
  full: "{{date}} 'v' {{time}}",
  long: "{{date}} 'v' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong_formatLong = {
  date: buildFormatLongFn({
    formats: formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var cs_lib_formatLong = (formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/cs/_lib/formatRelative/index.js
var accusativeWeekdays = ['neděli', 'pondělí', 'úterý', 'středu', 'čtvrtek', 'pátek', 'sobotu'];
var formatRelative_formatRelativeLocale = {
  lastWeek: "'poslední' eeee 've' p",
  yesterday: "'včera v' p",
  today: "'dnes v' p",
  tomorrow: "'zítra v' p",
  nextWeek: function (date, _baseDate, _options) {
    var day = date.getUTCDay();
    return "'v " + accusativeWeekdays[day] + " o' p";
  },
  other: 'P'
};
function formatRelative_formatRelative(token, date, baseDate, options) {
  var format = formatRelative_formatRelativeLocale[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/cs/_lib/localize/index.js

var localize_eraValues = {
  narrow: ['př. n. l.', 'n. l.'],
  abbreviated: ['př. n. l.', 'n. l.'],
  wide: ['před naším letopočtem', 'našeho letopočtu']
};
var localize_quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1. čtvrtletí', '2. čtvrtletí', '3. čtvrtletí', '4. čtvrtletí'],
  wide: ['1. čtvrtletí', '2. čtvrtletí', '3. čtvrtletí', '4. čtvrtletí']
};
var localize_monthValues = {
  narrow: ['L', 'Ú', 'B', 'D', 'K', 'Č', 'Č', 'S', 'Z', 'Ř', 'L', 'P'],
  abbreviated: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
  wide: ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec']
};
var formattingMonthValues = {
  narrow: ['L', 'Ú', 'B', 'D', 'K', 'Č', 'Č', 'S', 'Z', 'Ř', 'L', 'P'],
  abbreviated: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
  wide: ['ledna', 'února', 'března', 'dubna', 'května', 'června', 'července', 'srpna', 'září', 'října', 'listopadu', 'prosince']
};
var localize_dayValues = {
  narrow: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
  short: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
  abbreviated: ['ned', 'pon', 'úte', 'stř', 'čtv', 'pát', 'sob'],
  wide: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota']
};
var localize_dayPeriodValues = {
  narrow: {
    am: 'dop.',
    pm: 'odp.',
    midnight: 'půlnoc',
    noon: 'poledne',
    morning: 'ráno',
    afternoon: 'odpoledne',
    evening: 'večer',
    night: 'noc'
  },
  abbreviated: {
    am: 'dop.',
    pm: 'odp.',
    midnight: 'půlnoc',
    noon: 'poledne',
    morning: 'ráno',
    afternoon: 'odpoledne',
    evening: 'večer',
    night: 'noc'
  },
  wide: {
    am: 'dopoledne',
    pm: 'odpoledne',
    midnight: 'půlnoc',
    noon: 'poledne',
    morning: 'ráno',
    afternoon: 'odpoledne',
    evening: 'večer',
    night: 'noc'
  }
};
var localize_formattingDayPeriodValues = {
  narrow: {
    am: 'dop.',
    pm: 'odp.',
    midnight: 'půlnoc',
    noon: 'poledne',
    morning: 'ráno',
    afternoon: 'odpoledne',
    evening: 'večer',
    night: 'noc'
  },
  abbreviated: {
    am: 'dop.',
    pm: 'odp.',
    midnight: 'půlnoc',
    noon: 'poledne',
    morning: 'ráno',
    afternoon: 'odpoledne',
    evening: 'večer',
    night: 'noc'
  },
  wide: {
    am: 'dopoledne',
    pm: 'odpoledne',
    midnight: 'půlnoc',
    noon: 'poledne',
    morning: 'ráno',
    afternoon: 'odpoledne',
    evening: 'večer',
    night: 'noc'
  }
};

function localize_ordinalNumber(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '.';
}

var localize_localize = {
  ordinalNumber: localize_ordinalNumber,
  era: buildLocalizeFn({
    values: localize_eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: localize_quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: localize_monthValues,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: localize_dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: localize_dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: localize_formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var cs_lib_localize = (localize_localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/cs/_lib/match/index.js


var match_matchOrdinalNumberPattern = /^(\d+)\.?/i;
var match_parseOrdinalNumberPattern = /\d+/i;
var match_matchEraPatterns = {
  narrow: /^(p[řr]ed Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pe[řr]ed Kr\.|pe[řr]ed n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(p[řr]ed Kristem|pred na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var match_parseEraPatterns = {
  any: [/^p[řr]/i, /^(po|n)/i]
};
var match_matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
  wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
var match_parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var match_matchMonthPatterns = {
  narrow: /^[lúubdkčcszřrlp]/i,
  abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
  wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var match_parseMonthPatterns = {
  narrow: [/^l/i, /^[úu]/i, /^b/i, /^d/i, /^k/i, /^[čc]/i, /^[čc]/i, /^s/i, /^z/i, /^[řr]/i, /^l/i, /^p/i],
  any: [/^led/i, /^[úu]n/i, /^b[řr]e/i, /^dub/i, /^kv[ěe]/i, /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i, /^[čc]vc|[čc]erven(ec|ce)/i, /^srp/i, /^z[áa][řr]/i, /^[řr][íi]j/i, /^lis/i, /^pro/i]
};
var match_matchDayPatterns = {
  narrow: /^[npuúsčps]/i,
  short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
  abbreviated: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
  wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var match_parseDayPatterns = {
  narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
  any: [/^ne/i, /^po/i, /^ut/i, /^st/i, /^[čc]t/i, /^p/i, /^so/i]
};
var match_matchDayPeriodPatterns = {
  any: /^dopoledne|dop\.?|odpoledne|odp\.?|půlnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci/i
};
var match_parseDayPeriodPatterns = {
  any: {
    am: /^dop/i,
    pm: /^odp/i,
    midnight: /^p[ůu]lnoc/i,
    noon: /^poledne/i,
    morning: /r[áa]no/i,
    afternoon: /odpoledne/i,
    evening: /ve[čc]er/i,
    night: /noc/i
  }
};
var match_match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: match_matchOrdinalNumberPattern,
    parsePattern: match_parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: match_matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: match_matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: match_matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: match_matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: match_parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: match_matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: match_parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var cs_lib_match = (match_match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/cs/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
 */

var cs_locale = {
  code: 'cs',
  formatDistance: formatDistance_formatDistance,
  formatLong: cs_lib_formatLong,
  formatRelative: formatRelative_formatRelative,
  localize: cs_lib_localize,
  match: cs_lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var cs = (cs_locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-GB/_lib/formatLong/index.js

var _lib_formatLong_dateFormats = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var _lib_formatLong_timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var _lib_formatLong_dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var _lib_formatLong_formatLong = {
  date: buildFormatLongFn({
    formats: _lib_formatLong_dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: _lib_formatLong_timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: _lib_formatLong_dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var en_GB_lib_formatLong = (_lib_formatLong_formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-GB/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */

var en_GB_locale = {
  code: 'en-GB',
  formatDistance: _lib_formatDistance,
  formatLong: en_GB_lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var en_GB = (en_GB_locale);
;// CONCATENATED MODULE: ./helpers/date.ts


var formatDate = function(date, locale) {
    return date ? format(new Date(date), "d. M. yyyy", {
        locale: locale === "cs" ? cs : en_GB
    }) : "";
};
var formatYear = function(date, locale) {
    return date ? format(new Date(date), "yyyy", {
        locale: locale === "cs" ? cs : en_GB
    }) : "";
};
/**
 * Formats seconds to a human readable HH:MM:SS string.
 *
 * @export
 * @param {number} seconds
 * @returns {string}
 */ function sec2toHHMMSS(seconds) {
    var h = Math.floor(seconds / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);
    return [
        h,
        m > 9 ? m : h ? "0" + m : m || "0",
        s > 9 ? s : "0" + s
    ].filter(Boolean).join(":");
}
// https://stackoverflow.com/questions/6312993/javascript-seconds-to-time-string-with-format-hhmmss
function sec2time(val) {
    var sec_num = parseInt(val === null || val === void 0 ? void 0 : val.toString(), 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;
    if (seconds && !minutes && !hours) {
        return "<1m";
    }
    var result = "";
    if (minutes) {
        result = "".concat(minutes, "m");
    }
    if (hours) {
        result = "".concat(hours, "h ").concat(result);
    }
    return result;
}

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./components/DramoxImage/index.tsx
var DramoxImage = __webpack_require__(20010);
;// CONCATENATED MODULE: ./helpers/element.tsx



var getCastImg = function(cast) {
    if ("poster_url" in cast) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DramoxImage/* default */.Z, {
            className: "image",
            src: cast.poster_url,
            alt: cast.name,
            width: 36,
            height: 36,
            quality: 90
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "image",
        children: twoLetterShortName(cast.name)
    });
};

// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(94644);
;// CONCATENATED MODULE: ./helpers/form.ts

var clsLoading = "loading";
var createFormSchema = function(object) {
    return es/* object */.Ry().shape(object);
};
var notEmptyRule = function(ruleNotEmpty) {
    return es/* string */.Z_().required(ruleNotEmpty);
};
var passwordRule = function(rulePassword, ruleNotEmpty) {
    return es/* string */.Z_().min(8, rulePassword).required(ruleNotEmpty);
};
var passwordAgainRule = function(rulePassword, ruleNotEmpty, ruleDontMatch) {
    return es/* string */.Z_().min(8, rulePassword).oneOf([
        es/* ref */.iH("password"),
        null
    ], ruleDontMatch).required(ruleNotEmpty);
};
var numberRule = function(rule) {
    return yup.number().required(rule);
};
var donateRule = function(ruleDonateMin, ruleDonateMax, min, max) {
    return es/* number */.Rx().min(min, ruleDonateMin).max(max, ruleDonateMax).required(ruleDonateMin).typeError(ruleDonateMin);
};
var emailRule = function(ruleEmail, ruleNotEmpty) {
    return es/* string */.Z_().matches(// same email validator as in muvi's tweaked jquery.validator plugin
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, ruleEmail).required(ruleNotEmpty);
};
var getFormInputs = function(form) {
    return Array.prototype.slice.apply(form.elements).filter(function(el) {
        return el.tagName.toLowerCase() === "input";
    });
};
var resetForm = function(form) {
    if (form) {
        form.classList.remove(clsLoading);
        getFormInputs(form).forEach(function(i) {
            return i.disabled = false;
        });
    }
};
var removeErrorClass = function(form) {
    Array.prototype.slice.call(form.elements).forEach(function(el) {
        return el.classList.remove("error");
    });
};
var setLoadingState = function(form) {
    form === null || form === void 0 ? void 0 : form.classList.add(clsLoading);
    getFormInputs(form).forEach(function(i) {
        return i.disabled = true;
    });
};
var validateForm = function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
formSchema, validateObject, form) {
    var valid = true;
    var formEls = form.elements;
    removeErrorClass(form);
    setLoadingState(form);
    try {
        formSchema.validateSync(validateObject, {
            abortEarly: false
        });
    } catch (e) {
        var error = e;
        error.inner.forEach(function(err) {
            var inputEl = formEls.namedItem(err.path);
            console.log("err.path ", err === null || err === void 0 ? void 0 : err.path);
            if (inputEl) {
                inputEl.classList.add("error");
                inputEl.nextElementSibling.textContent = err.message;
            }
        });
        valid = false;
    }
    return valid;
};

// EXTERNAL MODULE: ./helpers/storageHelper.ts
var storageHelper = __webpack_require__(38869);
// EXTERNAL MODULE: ./config/routeTable.ts
var config_routeTable = __webpack_require__(82278);
;// CONCATENATED MODULE: ./helpers/routing.ts

var FORBIDDEN_WHEN_LOGGED = (/* unused pure expression or super */ null && ([
    "register",
    "login",
    "forgotten-password"
]));
var FORBIDDEN_WHEN_UNLOGGED = (/* unused pure expression or super */ null && ([
    "profile",
    "choose-plan"
]));
var isNotAllowWhenLogged = function(url) {
    return FORBIDDEN_WHEN_LOGGED.some(function(forbidden) {
        return url.includes(forbidden);
    });
};
var isNotAllowWhenUnlogged = function(url) {
    return FORBIDDEN_WHEN_UNLOGGED.some(function(forbidden) {
        return url.includes(forbidden);
    });
};
function getPrefferedDomainForCountry(country) {
    var _country;
    return (_country = routeTable[country]) !== null && _country !== void 0 ? _country : routeTable.default;
}

// EXTERNAL MODULE: ./helpers/jsx.tsx
var jsx = __webpack_require__(28808);
// EXTERNAL MODULE: ./node_modules/slugify/slugify.js
var slugify = __webpack_require__(42250);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);
;// CONCATENATED MODULE: ./helpers/string.ts

function twoLetterShortName(str) {
    var names = (str || "").trim().split(" ");
    return [
        names[0],
        names[names.length - 1]
    ].filter(function(s) {
        return !!s;
    }).map(function(s) {
        return s[0].toUpperCase();
    }).join("");
}
function slugifyString(str) {
    if (!str) {
        return null;
    }
    return slugify_default()(str, {
        lower: true,
        replacement: "-",
        remove: /[".,]/g,
        strict: true
    });
}

// EXTERNAL MODULE: ./helpers/Analytics.ts
var Analytics = __webpack_require__(86639);
// EXTERNAL MODULE: ./enums/index.ts + 3 modules
var enums = __webpack_require__(39933);
;// CONCATENATED MODULE: ./node_modules/jssha/dist/sha.mjs
/**
 * A JavaScript implementation of the SHA family of hashes - defined in FIPS PUB 180-4, FIPS PUB 202,
 * and SP 800-185 - as well as the corresponding HMAC implementation as defined in FIPS PUB 198-1.
 *
 * Copyright 2008-2020 Brian Turek, 1998-2009 Paul Johnston & Contributors
 * Distributed under the BSD License
 * See http://caligatio.github.com/jsSHA/ for more information
 */
const t="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";function n(t,n,e,r){let i,s,o;const h=n||[0],u=(e=e||0)>>>3,w=-1===r?3:0;for(i=0;i<t.length;i+=1)o=i+u,s=o>>>2,h.length<=s&&h.push(0),h[s]|=t[i]<<8*(w+r*(o%4));return{value:h,binLen:8*t.length+e}}function e(e,r,i){switch(r){case"UTF8":case"UTF16BE":case"UTF16LE":break;default:throw new Error("encoding must be UTF8, UTF16BE, or UTF16LE")}switch(e){case"HEX":return function(t,n,e){return function(t,n,e,r){let i,s,o,h;if(0!=t.length%2)throw new Error("String of HEX type must be in byte increments");const u=n||[0],w=(e=e||0)>>>3,c=-1===r?3:0;for(i=0;i<t.length;i+=2){if(s=parseInt(t.substr(i,2),16),isNaN(s))throw new Error("String of HEX type contains invalid characters");for(h=(i>>>1)+w,o=h>>>2;u.length<=o;)u.push(0);u[o]|=s<<8*(c+r*(h%4))}return{value:u,binLen:4*t.length+e}}(t,n,e,i)};case"TEXT":return function(t,n,e){return function(t,n,e,r,i){let s,o,h,u,w,c,f,a,l=0;const A=e||[0],E=(r=r||0)>>>3;if("UTF8"===n)for(f=-1===i?3:0,h=0;h<t.length;h+=1)for(s=t.charCodeAt(h),o=[],128>s?o.push(s):2048>s?(o.push(192|s>>>6),o.push(128|63&s)):55296>s||57344<=s?o.push(224|s>>>12,128|s>>>6&63,128|63&s):(h+=1,s=65536+((1023&s)<<10|1023&t.charCodeAt(h)),o.push(240|s>>>18,128|s>>>12&63,128|s>>>6&63,128|63&s)),u=0;u<o.length;u+=1){for(c=l+E,w=c>>>2;A.length<=w;)A.push(0);A[w]|=o[u]<<8*(f+i*(c%4)),l+=1}else for(f=-1===i?2:0,a="UTF16LE"===n&&1!==i||"UTF16LE"!==n&&1===i,h=0;h<t.length;h+=1){for(s=t.charCodeAt(h),!0===a&&(u=255&s,s=u<<8|s>>>8),c=l+E,w=c>>>2;A.length<=w;)A.push(0);A[w]|=s<<8*(f+i*(c%4)),l+=2}return{value:A,binLen:8*l+r}}(t,r,n,e,i)};case"B64":return function(n,e,r){return function(n,e,r,i){let s,o,h,u,w,c,f,a=0;const l=e||[0],A=(r=r||0)>>>3,E=-1===i?3:0,H=n.indexOf("=");if(-1===n.search(/^[a-zA-Z0-9=+/]+$/))throw new Error("Invalid character in base-64 string");if(n=n.replace(/=/g,""),-1!==H&&H<n.length)throw new Error("Invalid '=' found in base-64 string");for(o=0;o<n.length;o+=4){for(w=n.substr(o,4),u=0,h=0;h<w.length;h+=1)s=t.indexOf(w.charAt(h)),u|=s<<18-6*h;for(h=0;h<w.length-1;h+=1){for(f=a+A,c=f>>>2;l.length<=c;)l.push(0);l[c]|=(u>>>16-8*h&255)<<8*(E+i*(f%4)),a+=1}}return{value:l,binLen:8*a+r}}(n,e,r,i)};case"BYTES":return function(t,n,e){return function(t,n,e,r){let i,s,o,h;const u=n||[0],w=(e=e||0)>>>3,c=-1===r?3:0;for(s=0;s<t.length;s+=1)i=t.charCodeAt(s),h=s+w,o=h>>>2,u.length<=o&&u.push(0),u[o]|=i<<8*(c+r*(h%4));return{value:u,binLen:8*t.length+e}}(t,n,e,i)};case"ARRAYBUFFER":try{new ArrayBuffer(0)}catch(t){throw new Error("ARRAYBUFFER not supported by this environment")}return function(t,e,r){return function(t,e,r,i){return n(new Uint8Array(t),e,r,i)}(t,e,r,i)};case"UINT8ARRAY":try{new Uint8Array(0)}catch(t){throw new Error("UINT8ARRAY not supported by this environment")}return function(t,e,r){return n(t,e,r,i)};default:throw new Error("format must be HEX, TEXT, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY")}}function r(n,e,r,i){switch(n){case"HEX":return function(t){return function(t,n,e,r){let i,s,o="";const h=n/8,u=-1===e?3:0;for(i=0;i<h;i+=1)s=t[i>>>2]>>>8*(u+e*(i%4)),o+="0123456789abcdef".charAt(s>>>4&15)+"0123456789abcdef".charAt(15&s);return r.outputUpper?o.toUpperCase():o}(t,e,r,i)};case"B64":return function(n){return function(n,e,r,i){let s,o,h,u,w,c="";const f=e/8,a=-1===r?3:0;for(s=0;s<f;s+=3)for(u=s+1<f?n[s+1>>>2]:0,w=s+2<f?n[s+2>>>2]:0,h=(n[s>>>2]>>>8*(a+r*(s%4))&255)<<16|(u>>>8*(a+r*((s+1)%4))&255)<<8|w>>>8*(a+r*((s+2)%4))&255,o=0;o<4;o+=1)c+=8*s+6*o<=e?t.charAt(h>>>6*(3-o)&63):i.b64Pad;return c}(n,e,r,i)};case"BYTES":return function(t){return function(t,n,e){let r,i,s="";const o=n/8,h=-1===e?3:0;for(r=0;r<o;r+=1)i=t[r>>>2]>>>8*(h+e*(r%4))&255,s+=String.fromCharCode(i);return s}(t,e,r)};case"ARRAYBUFFER":try{new ArrayBuffer(0)}catch(t){throw new Error("ARRAYBUFFER not supported by this environment")}return function(t){return function(t,n,e){let r;const i=n/8,s=new ArrayBuffer(i),o=new Uint8Array(s),h=-1===e?3:0;for(r=0;r<i;r+=1)o[r]=t[r>>>2]>>>8*(h+e*(r%4))&255;return s}(t,e,r)};case"UINT8ARRAY":try{new Uint8Array(0)}catch(t){throw new Error("UINT8ARRAY not supported by this environment")}return function(t){return function(t,n,e){let r;const i=n/8,s=-1===e?3:0,o=new Uint8Array(i);for(r=0;r<i;r+=1)o[r]=t[r>>>2]>>>8*(s+e*(r%4))&255;return o}(t,e,r)};default:throw new Error("format must be HEX, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY")}}const i=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],s=[3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428],o=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225],h="Chosen SHA variant is not supported";function u(t,n){let e,r;const i=t.binLen>>>3,s=n.binLen>>>3,o=i<<3,h=4-i<<3;if(i%4!=0){for(e=0;e<s;e+=4)r=i+e>>>2,t.value[r]|=n.value[e>>>2]<<o,t.value.push(0),t.value[r+1]|=n.value[e>>>2]>>>h;return(t.value.length<<2)-4>=s+i&&t.value.pop(),{value:t.value,binLen:t.binLen+n.binLen}}return{value:t.value.concat(n.value),binLen:t.binLen+n.binLen}}function w(t){const n={outputUpper:!1,b64Pad:"=",outputLen:-1},e=t||{},r="Output length must be a multiple of 8";if(n.outputUpper=e.outputUpper||!1,e.b64Pad&&(n.b64Pad=e.b64Pad),e.outputLen){if(e.outputLen%8!=0)throw new Error(r);n.outputLen=e.outputLen}else if(e.shakeLen){if(e.shakeLen%8!=0)throw new Error(r);n.outputLen=e.shakeLen}if("boolean"!=typeof n.outputUpper)throw new Error("Invalid outputUpper formatting option");if("string"!=typeof n.b64Pad)throw new Error("Invalid b64Pad formatting option");return n}function c(t,n,r,i){const s=t+" must include a value and format";if(!n){if(!i)throw new Error(s);return i}if(void 0===n.value||!n.format)throw new Error(s);return e(n.format,n.encoding||"UTF8",r)(n.value)}class f{constructor(t,n,e){const r=e||{};if(this.t=n,this.i=r.encoding||"UTF8",this.numRounds=r.numRounds||1,isNaN(this.numRounds)||this.numRounds!==parseInt(this.numRounds,10)||1>this.numRounds)throw new Error("numRounds must a integer >= 1");this.s=t,this.o=[],this.h=0,this.u=!1,this.l=0,this.A=!1,this.H=[],this.S=[]}update(t){let n,e=0;const r=this.p>>>5,i=this.m(t,this.o,this.h),s=i.binLen,o=i.value,h=s>>>5;for(n=0;n<h;n+=r)e+this.p<=s&&(this.C=this.R(o.slice(n,n+r),this.C),e+=this.p);this.l+=e,this.o=o.slice(e>>>5),this.h=s%this.p,this.u=!0}getHash(t,n){let e,i,s=this.U;const o=w(n);if(this.v){if(-1===o.outputLen)throw new Error("Output length must be specified in options");s=o.outputLen}const h=r(t,s,this.K,o);if(this.A&&this.T)return h(this.T(o));for(i=this.F(this.o.slice(),this.h,this.l,this.g(this.C),s),e=1;e<this.numRounds;e+=1)this.v&&s%32!=0&&(i[i.length-1]&=16777215>>>24-s%32),i=this.F(i,s,0,this.B(this.s),s);return h(i)}setHMACKey(t,n,r){if(!this.L)throw new Error("Variant does not support HMAC");if(this.u)throw new Error("Cannot set MAC key after calling update");const i=e(n,(r||{}).encoding||"UTF8",this.K);this.M(i(t))}M(t){const n=this.p>>>3,e=n/4-1;let r;if(1!==this.numRounds)throw new Error("Cannot set numRounds with MAC");if(this.A)throw new Error("MAC key already set");for(n<t.binLen/8&&(t.value=this.F(t.value,t.binLen,0,this.B(this.s),this.U));t.value.length<=e;)t.value.push(0);for(r=0;r<=e;r+=1)this.H[r]=909522486^t.value[r],this.S[r]=1549556828^t.value[r];this.C=this.R(this.H,this.C),this.l=this.p,this.A=!0}getHMAC(t,n){const e=w(n);return r(t,this.U,this.K,e)(this.k())}k(){let t;if(!this.A)throw new Error("Cannot call getHMAC without first setting MAC key");const n=this.F(this.o.slice(),this.h,this.l,this.g(this.C),this.U);return t=this.R(this.S,this.B(this.s)),t=this.F(n,this.U,this.p,t,this.U),t}}function a(t,n){return t<<n|t>>>32-n}function l(t,n){return t>>>n|t<<32-n}function A(t,n){return t>>>n}function E(t,n,e){return t^n^e}function H(t,n,e){return t&n^~t&e}function S(t,n,e){return t&n^t&e^n&e}function b(t){return l(t,2)^l(t,13)^l(t,22)}function p(t,n){const e=(65535&t)+(65535&n);return(65535&(t>>>16)+(n>>>16)+(e>>>16))<<16|65535&e}function d(t,n,e,r){const i=(65535&t)+(65535&n)+(65535&e)+(65535&r);return(65535&(t>>>16)+(n>>>16)+(e>>>16)+(r>>>16)+(i>>>16))<<16|65535&i}function m(t,n,e,r,i){const s=(65535&t)+(65535&n)+(65535&e)+(65535&r)+(65535&i);return(65535&(t>>>16)+(n>>>16)+(e>>>16)+(r>>>16)+(i>>>16)+(s>>>16))<<16|65535&s}function C(t){return l(t,7)^l(t,18)^A(t,3)}function y(t){return l(t,6)^l(t,11)^l(t,25)}function R(t){return[1732584193,4023233417,2562383102,271733878,3285377520]}function U(t,n){let e,r,i,s,o,h,u;const w=[];for(e=n[0],r=n[1],i=n[2],s=n[3],o=n[4],u=0;u<80;u+=1)w[u]=u<16?t[u]:a(w[u-3]^w[u-8]^w[u-14]^w[u-16],1),h=u<20?m(a(e,5),H(r,i,s),o,1518500249,w[u]):u<40?m(a(e,5),E(r,i,s),o,1859775393,w[u]):u<60?m(a(e,5),S(r,i,s),o,2400959708,w[u]):m(a(e,5),E(r,i,s),o,3395469782,w[u]),o=s,s=i,i=a(r,30),r=e,e=h;return n[0]=p(e,n[0]),n[1]=p(r,n[1]),n[2]=p(i,n[2]),n[3]=p(s,n[3]),n[4]=p(o,n[4]),n}function v(t,n,e,r){let i;const s=15+(n+65>>>9<<4),o=n+e;for(;t.length<=s;)t.push(0);for(t[n>>>5]|=128<<24-n%32,t[s]=4294967295&o,t[s-1]=o/4294967296|0,i=0;i<t.length;i+=16)r=U(t.slice(i,i+16),r);return r}class K extends f{constructor(t,n,r){if("SHA-1"!==t)throw new Error(h);super(t,n,r);const i=r||{};this.L=!0,this.T=this.k,this.K=-1,this.m=e(this.t,this.i,this.K),this.R=U,this.g=function(t){return t.slice()},this.B=R,this.F=v,this.C=[1732584193,4023233417,2562383102,271733878,3285377520],this.p=512,this.U=160,this.v=!1,i.hmacKey&&this.M(c("hmacKey",i.hmacKey,this.K))}}function T(t){let n;return n="SHA-224"==t?s.slice():o.slice(),n}function F(t,n){let e,r,s,o,h,u,w,c,f,a,E;const R=[];for(e=n[0],r=n[1],s=n[2],o=n[3],h=n[4],u=n[5],w=n[6],c=n[7],E=0;E<64;E+=1)R[E]=E<16?t[E]:d(l(U=R[E-2],17)^l(U,19)^A(U,10),R[E-7],C(R[E-15]),R[E-16]),f=m(c,y(h),H(h,u,w),i[E],R[E]),a=p(b(e),S(e,r,s)),c=w,w=u,u=h,h=p(o,f),o=s,s=r,r=e,e=p(f,a);var U;return n[0]=p(e,n[0]),n[1]=p(r,n[1]),n[2]=p(s,n[2]),n[3]=p(o,n[3]),n[4]=p(h,n[4]),n[5]=p(u,n[5]),n[6]=p(w,n[6]),n[7]=p(c,n[7]),n}class g extends f{constructor(t,n,r){if("SHA-224"!==t&&"SHA-256"!==t)throw new Error(h);super(t,n,r);const i=r||{};this.T=this.k,this.L=!0,this.K=-1,this.m=e(this.t,this.i,this.K),this.R=F,this.g=function(t){return t.slice()},this.B=T,this.F=function(n,e,r,i){return function(t,n,e,r,i){let s,o;const h=15+(n+65>>>9<<4),u=n+e;for(;t.length<=h;)t.push(0);for(t[n>>>5]|=128<<24-n%32,t[h]=4294967295&u,t[h-1]=u/4294967296|0,s=0;s<t.length;s+=16)r=F(t.slice(s,s+16),r);return o="SHA-224"===i?[r[0],r[1],r[2],r[3],r[4],r[5],r[6]]:r,o}(n,e,r,i,t)},this.C=T(t),this.p=512,this.U="SHA-224"===t?224:256,this.v=!1,i.hmacKey&&this.M(c("hmacKey",i.hmacKey,this.K))}}class B{constructor(t,n){this.Y=t,this.N=n}}function L(t,n){let e;return n>32?(e=64-n,new B(t.N<<n|t.Y>>>e,t.Y<<n|t.N>>>e)):0!==n?(e=32-n,new B(t.Y<<n|t.N>>>e,t.N<<n|t.Y>>>e)):t}function M(t,n){let e;return n<32?(e=32-n,new B(t.Y>>>n|t.N<<e,t.N>>>n|t.Y<<e)):(e=64-n,new B(t.N>>>n|t.Y<<e,t.Y>>>n|t.N<<e))}function k(t,n){return new B(t.Y>>>n,t.N>>>n|t.Y<<32-n)}function Y(t,n,e){return new B(t.Y&n.Y^t.Y&e.Y^n.Y&e.Y,t.N&n.N^t.N&e.N^n.N&e.N)}function N(t){const n=M(t,28),e=M(t,34),r=M(t,39);return new B(n.Y^e.Y^r.Y,n.N^e.N^r.N)}function I(t,n){let e,r;e=(65535&t.N)+(65535&n.N),r=(t.N>>>16)+(n.N>>>16)+(e>>>16);const i=(65535&r)<<16|65535&e;e=(65535&t.Y)+(65535&n.Y)+(r>>>16),r=(t.Y>>>16)+(n.Y>>>16)+(e>>>16);return new B((65535&r)<<16|65535&e,i)}function X(t,n,e,r){let i,s;i=(65535&t.N)+(65535&n.N)+(65535&e.N)+(65535&r.N),s=(t.N>>>16)+(n.N>>>16)+(e.N>>>16)+(r.N>>>16)+(i>>>16);const o=(65535&s)<<16|65535&i;i=(65535&t.Y)+(65535&n.Y)+(65535&e.Y)+(65535&r.Y)+(s>>>16),s=(t.Y>>>16)+(n.Y>>>16)+(e.Y>>>16)+(r.Y>>>16)+(i>>>16);return new B((65535&s)<<16|65535&i,o)}function z(t,n,e,r,i){let s,o;s=(65535&t.N)+(65535&n.N)+(65535&e.N)+(65535&r.N)+(65535&i.N),o=(t.N>>>16)+(n.N>>>16)+(e.N>>>16)+(r.N>>>16)+(i.N>>>16)+(s>>>16);const h=(65535&o)<<16|65535&s;s=(65535&t.Y)+(65535&n.Y)+(65535&e.Y)+(65535&r.Y)+(65535&i.Y)+(o>>>16),o=(t.Y>>>16)+(n.Y>>>16)+(e.Y>>>16)+(r.Y>>>16)+(i.Y>>>16)+(s>>>16);return new B((65535&o)<<16|65535&s,h)}function x(t,n){return new B(t.Y^n.Y,t.N^n.N)}function _(t){const n=M(t,19),e=M(t,61),r=k(t,6);return new B(n.Y^e.Y^r.Y,n.N^e.N^r.N)}function O(t){const n=M(t,1),e=M(t,8),r=k(t,7);return new B(n.Y^e.Y^r.Y,n.N^e.N^r.N)}function P(t){const n=M(t,14),e=M(t,18),r=M(t,41);return new B(n.Y^e.Y^r.Y,n.N^e.N^r.N)}const V=[new B(i[0],3609767458),new B(i[1],602891725),new B(i[2],3964484399),new B(i[3],2173295548),new B(i[4],4081628472),new B(i[5],3053834265),new B(i[6],2937671579),new B(i[7],3664609560),new B(i[8],2734883394),new B(i[9],1164996542),new B(i[10],1323610764),new B(i[11],3590304994),new B(i[12],4068182383),new B(i[13],991336113),new B(i[14],633803317),new B(i[15],3479774868),new B(i[16],2666613458),new B(i[17],944711139),new B(i[18],2341262773),new B(i[19],2007800933),new B(i[20],1495990901),new B(i[21],1856431235),new B(i[22],3175218132),new B(i[23],2198950837),new B(i[24],3999719339),new B(i[25],766784016),new B(i[26],2566594879),new B(i[27],3203337956),new B(i[28],1034457026),new B(i[29],2466948901),new B(i[30],3758326383),new B(i[31],168717936),new B(i[32],1188179964),new B(i[33],1546045734),new B(i[34],1522805485),new B(i[35],2643833823),new B(i[36],2343527390),new B(i[37],1014477480),new B(i[38],1206759142),new B(i[39],344077627),new B(i[40],1290863460),new B(i[41],3158454273),new B(i[42],3505952657),new B(i[43],106217008),new B(i[44],3606008344),new B(i[45],1432725776),new B(i[46],1467031594),new B(i[47],851169720),new B(i[48],3100823752),new B(i[49],1363258195),new B(i[50],3750685593),new B(i[51],3785050280),new B(i[52],3318307427),new B(i[53],3812723403),new B(i[54],2003034995),new B(i[55],3602036899),new B(i[56],1575990012),new B(i[57],1125592928),new B(i[58],2716904306),new B(i[59],442776044),new B(i[60],593698344),new B(i[61],3733110249),new B(i[62],2999351573),new B(i[63],3815920427),new B(3391569614,3928383900),new B(3515267271,566280711),new B(3940187606,3454069534),new B(4118630271,4000239992),new B(116418474,1914138554),new B(174292421,2731055270),new B(289380356,3203993006),new B(460393269,320620315),new B(685471733,587496836),new B(852142971,1086792851),new B(1017036298,365543100),new B(1126000580,2618297676),new B(1288033470,3409855158),new B(1501505948,4234509866),new B(1607167915,987167468),new B(1816402316,1246189591)];function Z(t){return"SHA-384"===t?[new B(3418070365,s[0]),new B(1654270250,s[1]),new B(2438529370,s[2]),new B(355462360,s[3]),new B(1731405415,s[4]),new B(41048885895,s[5]),new B(3675008525,s[6]),new B(1203062813,s[7])]:[new B(o[0],4089235720),new B(o[1],2227873595),new B(o[2],4271175723),new B(o[3],1595750129),new B(o[4],2917565137),new B(o[5],725511199),new B(o[6],4215389547),new B(o[7],327033209)]}function j(t,n){let e,r,i,s,o,h,u,w,c,f,a,l;const A=[];for(e=n[0],r=n[1],i=n[2],s=n[3],o=n[4],h=n[5],u=n[6],w=n[7],a=0;a<80;a+=1)a<16?(l=2*a,A[a]=new B(t[l],t[l+1])):A[a]=X(_(A[a-2]),A[a-7],O(A[a-15]),A[a-16]),c=z(w,P(o),(H=h,S=u,new B((E=o).Y&H.Y^~E.Y&S.Y,E.N&H.N^~E.N&S.N)),V[a],A[a]),f=I(N(e),Y(e,r,i)),w=u,u=h,h=o,o=I(s,c),s=i,i=r,r=e,e=I(c,f);var E,H,S;return n[0]=I(e,n[0]),n[1]=I(r,n[1]),n[2]=I(i,n[2]),n[3]=I(s,n[3]),n[4]=I(o,n[4]),n[5]=I(h,n[5]),n[6]=I(u,n[6]),n[7]=I(w,n[7]),n}class q extends f{constructor(t,n,r){if("SHA-384"!==t&&"SHA-512"!==t)throw new Error(h);super(t,n,r);const i=r||{};this.T=this.k,this.L=!0,this.K=-1,this.m=e(this.t,this.i,this.K),this.R=j,this.g=function(t){return t.slice()},this.B=Z,this.F=function(n,e,r,i){return function(t,n,e,r,i){let s,o;const h=31+(n+129>>>10<<5),u=n+e;for(;t.length<=h;)t.push(0);for(t[n>>>5]|=128<<24-n%32,t[h]=4294967295&u,t[h-1]=u/4294967296|0,s=0;s<t.length;s+=32)r=j(t.slice(s,s+32),r);return o="SHA-384"===i?[(r=r)[0].Y,r[0].N,r[1].Y,r[1].N,r[2].Y,r[2].N,r[3].Y,r[3].N,r[4].Y,r[4].N,r[5].Y,r[5].N]:[r[0].Y,r[0].N,r[1].Y,r[1].N,r[2].Y,r[2].N,r[3].Y,r[3].N,r[4].Y,r[4].N,r[5].Y,r[5].N,r[6].Y,r[6].N,r[7].Y,r[7].N],o}(n,e,r,i,t)},this.C=Z(t),this.p=1024,this.U="SHA-384"===t?384:512,this.v=!1,i.hmacKey&&this.M(c("hmacKey",i.hmacKey,this.K))}}const D=[new B(0,1),new B(0,32898),new B(2147483648,32906),new B(2147483648,2147516416),new B(0,32907),new B(0,2147483649),new B(2147483648,2147516545),new B(2147483648,32777),new B(0,138),new B(0,136),new B(0,2147516425),new B(0,2147483658),new B(0,2147516555),new B(2147483648,139),new B(2147483648,32905),new B(2147483648,32771),new B(2147483648,32770),new B(2147483648,128),new B(0,32778),new B(2147483648,2147483658),new B(2147483648,2147516545),new B(2147483648,32896),new B(0,2147483649),new B(2147483648,2147516424)],G=[[0,36,3,41,18],[1,44,10,45,2],[62,6,43,15,61],[28,55,25,21,56],[27,20,39,8,14]];function J(t){let n;const e=[];for(n=0;n<5;n+=1)e[n]=[new B(0,0),new B(0,0),new B(0,0),new B(0,0),new B(0,0)];return e}function Q(t){let n;const e=[];for(n=0;n<5;n+=1)e[n]=t[n].slice();return e}function W(t,n){let e,r,i,s;const o=[],h=[];if(null!==t)for(r=0;r<t.length;r+=2)n[(r>>>1)%5][(r>>>1)/5|0]=x(n[(r>>>1)%5][(r>>>1)/5|0],new B(t[r+1],t[r]));for(e=0;e<24;e+=1){for(s=J(),r=0;r<5;r+=1)o[r]=(u=n[r][0],w=n[r][1],c=n[r][2],f=n[r][3],a=n[r][4],new B(u.Y^w.Y^c.Y^f.Y^a.Y,u.N^w.N^c.N^f.N^a.N));for(r=0;r<5;r+=1)h[r]=x(o[(r+4)%5],L(o[(r+1)%5],1));for(r=0;r<5;r+=1)for(i=0;i<5;i+=1)n[r][i]=x(n[r][i],h[r]);for(r=0;r<5;r+=1)for(i=0;i<5;i+=1)s[i][(2*r+3*i)%5]=L(n[r][i],G[r][i]);for(r=0;r<5;r+=1)for(i=0;i<5;i+=1)n[r][i]=x(s[r][i],new B(~s[(r+1)%5][i].Y&s[(r+2)%5][i].Y,~s[(r+1)%5][i].N&s[(r+2)%5][i].N));n[0][0]=x(n[0][0],D[e])}var u,w,c,f,a;return n}function $(t){let n,e,r=0;const i=[0,0],s=[4294967295&t,t/4294967296&2097151];for(n=6;n>=0;n--)e=s[n>>2]>>>8*n&255,0===e&&0===r||(i[r+1>>2]|=e<<8*(r+1),r+=1);return r=0!==r?r:1,i[0]|=r,{value:r+1>4?i:[i[0]],binLen:8+8*r}}function tt(t){return u($(t.binLen),t)}function nt(t,n){let e,r=$(n);r=u(r,t);const i=n>>>2,s=(i-r.value.length%i)%i;for(e=0;e<s;e++)r.value.push(0);return r.value}class et extends f{constructor(t,n,r){let i=6,s=0;super(t,n,r);const o=r||{};if(1!==this.numRounds){if(o.kmacKey||o.hmacKey)throw new Error("Cannot set numRounds with MAC");if("CSHAKE128"===this.s||"CSHAKE256"===this.s)throw new Error("Cannot set numRounds for CSHAKE variants")}switch(this.K=1,this.m=e(this.t,this.i,this.K),this.R=W,this.g=Q,this.B=J,this.C=J(),this.v=!1,t){case"SHA3-224":this.p=s=1152,this.U=224,this.L=!0,this.T=this.k;break;case"SHA3-256":this.p=s=1088,this.U=256,this.L=!0,this.T=this.k;break;case"SHA3-384":this.p=s=832,this.U=384,this.L=!0,this.T=this.k;break;case"SHA3-512":this.p=s=576,this.U=512,this.L=!0,this.T=this.k;break;case"SHAKE128":i=31,this.p=s=1344,this.U=-1,this.v=!0,this.L=!1,this.T=null;break;case"SHAKE256":i=31,this.p=s=1088,this.U=-1,this.v=!0,this.L=!1,this.T=null;break;case"KMAC128":i=4,this.p=s=1344,this.I(r),this.U=-1,this.v=!0,this.L=!1,this.T=this.X;break;case"KMAC256":i=4,this.p=s=1088,this.I(r),this.U=-1,this.v=!0,this.L=!1,this.T=this.X;break;case"CSHAKE128":this.p=s=1344,i=this._(r),this.U=-1,this.v=!0,this.L=!1,this.T=null;break;case"CSHAKE256":this.p=s=1088,i=this._(r),this.U=-1,this.v=!0,this.L=!1,this.T=null;break;default:throw new Error(h)}this.F=function(t,n,e,r,o){return function(t,n,e,r,i,s,o){let h,u,w=0;const c=[],f=i>>>5,a=n>>>5;for(h=0;h<a&&n>=i;h+=f)r=W(t.slice(h,h+f),r),n-=i;for(t=t.slice(h),n%=i;t.length<f;)t.push(0);for(h=n>>>3,t[h>>2]^=s<<h%4*8,t[f-1]^=2147483648,r=W(t,r);32*c.length<o&&(u=r[w%5][w/5|0],c.push(u.N),!(32*c.length>=o));)c.push(u.Y),w+=1,0==64*w%i&&(W(null,r),w=0);return c}(t,n,0,r,s,i,o)},o.hmacKey&&this.M(c("hmacKey",o.hmacKey,this.K))}_(t,n){const e=function(t){const n=t||{};return{funcName:c("funcName",n.funcName,1,{value:[],binLen:0}),customization:c("Customization",n.customization,1,{value:[],binLen:0})}}(t||{});n&&(e.funcName=n);const r=u(tt(e.funcName),tt(e.customization));if(0!==e.customization.binLen||0!==e.funcName.binLen){const t=nt(r,this.p>>>3);for(let n=0;n<t.length;n+=this.p>>>5)this.C=this.R(t.slice(n,n+(this.p>>>5)),this.C),this.l+=this.p;return 4}return 31}I(t){const n=function(t){const n=t||{};return{kmacKey:c("kmacKey",n.kmacKey,1),funcName:{value:[1128353099],binLen:32},customization:c("Customization",n.customization,1,{value:[],binLen:0})}}(t||{});this._(t,n.funcName);const e=nt(tt(n.kmacKey),this.p>>>3);for(let t=0;t<e.length;t+=this.p>>>5)this.C=this.R(e.slice(t,t+(this.p>>>5)),this.C),this.l+=this.p;this.A=!0}X(t){const n=u({value:this.o.slice(),binLen:this.h},function(t){let n,e,r=0;const i=[0,0],s=[4294967295&t,t/4294967296&2097151];for(n=6;n>=0;n--)e=s[n>>2]>>>8*n&255,0===e&&0===r||(i[r>>2]|=e<<8*r,r+=1);return r=0!==r?r:1,i[r>>2]|=r<<8*r,{value:r+1>4?i:[i[0]],binLen:8+8*r}}(t.outputLen));return this.F(n.value,n.binLen,this.l,this.g(this.C),t.outputLen)}}/* harmony default export */ var sha = (class{constructor(t,n,e){if("SHA-1"==t)this.O=new K(t,n,e);else if("SHA-224"==t||"SHA-256"==t)this.O=new g(t,n,e);else if("SHA-384"==t||"SHA-512"==t)this.O=new q(t,n,e);else{if("SHA3-224"!=t&&"SHA3-256"!=t&&"SHA3-384"!=t&&"SHA3-512"!=t&&"SHAKE128"!=t&&"SHAKE256"!=t&&"CSHAKE128"!=t&&"CSHAKE256"!=t&&"KMAC128"!=t&&"KMAC256"!=t)throw new Error(h);this.O=new et(t,n,e)}}update(t){this.O.update(t)}getHash(t,n){return this.O.getHash(t,n)}setHMACKey(t,n,e){this.O.setHMACKey(t,n,e)}getHMAC(t,n){return this.O.getHMAC(t,n)}});
//# sourceMappingURL=sha.mjs.map

// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(12774);
// EXTERNAL MODULE: ./node_modules/uuid/index.js
var node_modules_uuid = __webpack_require__(46513);
;// CONCATENATED MODULE: ./helpers/cookies.ts




function forceLanguage(lang, ctx) {
    (0,dist.setCookie)(ctx, "NEXT_LOCALE", lang, {
        maxAge: 30 * 24 * 60 * 60,
        path: "/"
    });
    if (ctx) {
        ctx.locale = lang;
    } else if (true) {
        window.dispatchEvent(new CustomEvent(enums/* Events.Language */.zW.Language, {
            detail: lang
        }));
    }
}
function signCookie(option) {
    var userAgent = navigator.userAgent;
    var uuid = (0,node_modules_uuid.v4)();
    var sha256 = new sha("SHA-256", "TEXT");
    sha256.update("".concat(option, ",").concat(userAgent, ",").concat(uuid));
    return [
        sha256.getHash("HEX"),
        uuid
    ];
}

;// CONCATENATED MODULE: ./helpers/array.ts

var _marked = runtime_default().mark(sample);
function shuffleArray(t) {
    return Array.from(sample(t, t.length));
}
function sample(t, n) {
    var r, i;
    return runtime_default().wrap(function sample$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                r = Array.from(t);
            case 1:
                if (!(n > 0 && r.length)) {
                    _ctx.next = 9;
                    break;
                }
                i = rand(r.length); // 1
                swap(r, i, r.length - 1); // 2
                _ctx.next = 6;
                return r.pop();
            case 6:
                n = n - 1;
                _ctx.next = 1;
                break;
            case 9:
            case "end":
                return _ctx.stop();
        }
    }, _marked);
}
var rand = function(n) {
    return Math.floor(Math.random() * n);
};
function swap(t, i, j) {
    var q = t[i];
    t[i] = t[j];
    t[j] = q;
    return t;
}

;// CONCATENATED MODULE: ./helpers/url.ts
function imageUrl(url, width, height, quality) {
    if (!url) {
        return null;
    }
    if (!(width || height) && !quality) {
        return url;
    }
    var domain = url.match(/https:\/\/[a-z0-9.]*/)[0];
    var path = url.replace(domain, "");
    return "".concat(domain, "/resize").concat(path, "?width=").concat(width || "-", "&height=").concat(height || "-", "&quality=").concat(quality !== null && quality !== void 0 ? quality : 100);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(62139);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(2746);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(28253);
// EXTERNAL MODULE: ./enums/routeType.js
var routeType = __webpack_require__(33973);
// EXTERNAL MODULE: ./i18n.js
var i18n = __webpack_require__(57919);
// EXTERNAL MODULE: ./api/apiHelpers.ts
var apiHelpers = __webpack_require__(65639);
;// CONCATENATED MODULE: ./helpers/navigation.ts










/**
 * Static class exposing all portal url helpers.
 *
 * @export
 * @class Permalink
 */ var Permalink = /*#__PURE__*/ function() {
    "use strict";
    function Permalink() {
        (0,_class_call_check/* default */.Z)(this, Permalink);
    }
    Permalink.play = function play(play1) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i18n.defaultLocale;
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        var theatreSlug = encodeURI("".concat(play1.theatre.id, "-").concat(slugifyString(((ref1 = (ref = play1.theatre.names) === null || ref === void 0 ? void 0 : ref.find(function(n) {
            return n.language === locale;
        })) === null || ref1 === void 0 ? void 0 : ref1.value) || ((ref2 = play1.theatre.names) === null || ref2 === void 0 ? void 0 : ref2.find(function(n) {
            return n.language === i18n.defaultLocale;
        }).value) || play1.theatre.name)));
        var ref7, ref8, ref9;
        var playSlug = encodeURI("".concat(play1.id, "-").concat(slugifyString((ref9 = (ref8 = (ref7 = (ref4 = (ref3 = play1.names) === null || ref3 === void 0 ? void 0 : ref3.find(function(n) {
            return n.language === locale;
        })) === null || ref4 === void 0 ? void 0 : ref4.value) !== null && ref7 !== void 0 ? ref7 : (ref6 = (ref5 = play1.names) === null || ref5 === void 0 ? void 0 : ref5.find(function(n) {
            return n.language === i18n.defaultLocale;
        })) === null || ref6 === void 0 ? void 0 : ref6.value) !== null && ref8 !== void 0 ? ref8 : play1.title) !== null && ref9 !== void 0 ? ref9 : play1.name)));
        return "/".concat(routeType/* RouteType.PlayDetail */.Y.PlayDetail[locale].replace("[slug]", theatreSlug).replace("[playSlug]", playSlug));
    };
    Permalink.playFromSearchResponse = function playFromSearchResponse(play) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.PlayDetail */.Y.PlayDetail[locale].replace("[slug]", encodeURI("".concat(play.theatre, "-").concat(slugifyString(play.theatre_name)))).replace("[playSlug]", encodeURI("".concat(play.id, "-").concat(slugifyString(play.name)))));
    };
    Permalink.celebrity = function celebrity(celebrity1) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i18n.defaultLocale;
        var ref, ref1, ref2, ref3;
        var slug = "".concat(celebrity1.id ? "".concat(celebrity1.id, "-") : "").concat(slugifyString(((ref1 = (ref = celebrity1.names) === null || ref === void 0 ? void 0 : ref.find(function(n) {
            return n.language === locale;
        })) === null || ref1 === void 0 ? void 0 : ref1.value) || ((ref3 = (ref2 = celebrity1.names) === null || ref2 === void 0 ? void 0 : ref2.find(function(n) {
            return n.language === i18n.defaultLocale;
        })) === null || ref3 === void 0 ? void 0 : ref3.value) || celebrity1.name));
        return "/".concat(routeType/* RouteType.Celebrity */.Y.Celebrity[locale].replace("[slug]", slug));
    };
    Permalink.theatres = function theatres() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.Theatres */.Y.Theatres[locale]);
    };
    Permalink.watchList = function watchList() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.WatchList */.Y.WatchList[locale]);
    };
    Permalink.theatre = function theatre(theatre1) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i18n.defaultLocale;
        var ref, ref1, ref2;
        var slug = encodeURI("".concat(theatre1.id ? "".concat(theatre1.id, "-") : "").concat(slugifyString(((ref1 = (ref = theatre1.names) === null || ref === void 0 ? void 0 : ref.find(function(n) {
            return n.language === locale;
        })) === null || ref1 === void 0 ? void 0 : ref1.value) || ((ref2 = theatre1.names) === null || ref2 === void 0 ? void 0 : ref2.find(function(n) {
            return n.language === i18n.defaultLocale;
        }).value) || theatre1.name)));
        return "/".concat(routeType/* RouteType.TheatreDetail */.Y.TheatreDetail[locale].replace("[slug]", slug));
    };
    Permalink.preview = function preview(play) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i18n.defaultLocale;
        var _title;
        return "/".concat(routeType/* RouteType.Preview */.Y.Preview[locale].replace("[slug]", encodeURI("".concat(play.id, "-").concat(slugifyString((_title = play.title) !== null && _title !== void 0 ? _title : play.name)))));
    };
    Permalink.watch = function watch(play) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i18n.defaultLocale;
        var _title;
        return "/".concat(routeType/* RouteType.Watch */.Y.Watch[locale].replace("[slug]", encodeURI("".concat(play.id, "-").concat(slugifyString((_title = play.title) !== null && _title !== void 0 ? _title : play.name)))));
    };
    Permalink.collection = function collection() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale, queryString = arguments.length > 1 ? arguments[1] : void 0;
        return "/".concat(routeType/* RouteType.Collection */.Y.Collection[locale]).concat(queryString ? "?".concat(queryString) : "");
    };
    Permalink.genre = function genre(section) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.Genre */.Y.Genre[locale].replace("[slug]", encodeURI("".concat(section.id, "-").concat(slugifyString(section.name)))));
    };
    Permalink.featuredSection = function featuredSection(section) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.FeaturedSection */.Y.FeaturedSection[locale].replace("[slug]", encodeURI("".concat(section.id, "-").concat(slugifyString(section.name)))));
    };
    Permalink.mostPopular = function mostPopular() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.MostPopular */.Y.MostPopular[locale]);
    };
    Permalink.currentlyWatching = function currentlyWatching() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.CurrentlyWatching */.Y.CurrentlyWatching[locale]);
    };
    Permalink.dramoxOriginals = function dramoxOriginals() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.DramoxOriginals */.Y.DramoxOriginals[locale]);
    };
    Permalink.recentlyAdded = function recentlyAdded() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.RecentlyAdded */.Y.RecentlyAdded[locale]);
    };
    Permalink.sameGenre = function sameGenre(play) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.SameGenre */.Y.SameGenre[locale].replace("[slug]", encodeURI("".concat(play.id, "-").concat(slugifyString(play.title)))));
    };
    Permalink.sameCast = function sameCast(play) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.SameCast */.Y.SameCast[locale].replace("[slug]", encodeURI("".concat(play.id, "-").concat(slugifyString(play.title)))));
    };
    Permalink.about = function about() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.About */.Y.About[locale]);
    };
    Permalink.forSchools = function forSchools() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.ForSchools */.Y.ForSchools[locale]);
    };
    Permalink.choosePlan = function choosePlan() {
        return "/".concat(routeType/* RouteType.ChoosePlan */.Y.ChoosePlan);
    };
    Permalink.smartTV = function smartTV() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.SmartTV */.Y.SmartTV[locale]);
    };
    Permalink.contact = function contact() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.Contact */.Y.Contact[locale]);
    };
    Permalink.faq = function faq() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.FAQ */.Y.FAQ[locale]);
    };
    Permalink.privacyPolicy = function privacyPolicy() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.PrivacyPolicy */.Y.PrivacyPolicy[locale]);
    };
    Permalink.cookie = function cookie() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.Cookies */.Y.Cookies[locale]);
    };
    Permalink.termsAndConditions = function termsAndConditions() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.TermsAndConditions */.Y.TermsAndConditions[locale]);
    };
    Permalink.authorship = function authorship() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.Authorship */.Y.Authorship[locale]);
    };
    Permalink.login = function login() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.Login */.Y.Login[locale]);
    };
    Permalink.forgottenPassword = function forgottenPassword() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.ForgottenPassword */.Y.ForgottenPassword[locale]);
    };
    Permalink.voucher = function voucher() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.Voucher */.Y.Voucher[locale]);
    };
    Permalink.donate = function donate() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.Donate */.Y.Donate[locale]);
    };
    Permalink.registerStep1 = function registerStep1() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.RegisterStep1 */.Y.RegisterStep1[locale]);
    };
    Permalink.registerStep2 = function registerStep2() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.RegisterStep2 */.Y.RegisterStep2[locale]);
    };
    Permalink.registerConfirmEmail = function registerConfirmEmail() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.RegisterConfirmEmail */.Y.RegisterConfirmEmail[locale]);
    };
    Permalink.registerContentSettings = function registerContentSettings() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale, queryString = arguments.length > 1 ? arguments[1] : void 0;
        return "/".concat(routeType/* RouteType.RegisterContentSettings */.Y.RegisterContentSettings[locale]).concat(queryString ? "?".concat(queryString) : "");
    };
    Permalink.contentSettings = function contentSettings() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.ContentSettings */.Y.ContentSettings[locale]);
    };
    Permalink.donateTheatre = function donateTheatre(theatre) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i18n.defaultLocale;
        var ref, ref1, ref2;
        var slug = encodeURI("".concat(theatre.id ? "".concat(theatre.id, "-") : "").concat(slugifyString(((ref1 = (ref = theatre.names) === null || ref === void 0 ? void 0 : ref.find(function(n) {
            return n.language === locale;
        })) === null || ref1 === void 0 ? void 0 : ref1.value) || ((ref2 = theatre.names) === null || ref2 === void 0 ? void 0 : ref2.find(function(n) {
            return n.language === i18n.defaultLocale;
        }).value) || theatre.name)));
        return "/".concat(routeType/* RouteType.DonateTheatre */.Y.DonateTheatre[locale].replace("[slug]", slug));
    };
    Permalink.howToWatch = function howToWatch() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.HowToWatch */.Y.HowToWatch[locale]);
    };
    Permalink.howToWatchWeb = function howToWatchWeb() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.HowToWatchWeb */.Y.HowToWatchWeb[locale]);
    };
    Permalink.howToWatchSmartTV = function howToWatchSmartTV() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.HowToWatchSmartTV */.Y.HowToWatchSmartTV[locale]);
    };
    Permalink.howToWatchSmartTVSamsung = function howToWatchSmartTVSamsung() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.HowToWatchSmartTVSamsung */.Y.HowToWatchSmartTVSamsung[locale]);
    };
    Permalink.howToWatchSmartTVLG = function howToWatchSmartTVLG() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.HowToWatchSmartTVLG */.Y.HowToWatchSmartTVLG[locale]);
    };
    Permalink.howToWatchMobile = function howToWatchMobile() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.HowToWatchMobile */.Y.HowToWatchMobile[locale]);
    };
    Permalink.howToWatchMobileAndroid = function howToWatchMobileAndroid() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.HowToWatchMobileAndroid */.Y.HowToWatchMobileAndroid[locale]);
    };
    Permalink.howToWatchMobileIOS = function howToWatchMobileIOS() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.HowToWatchMobileIOS */.Y.HowToWatchMobileIOS[locale]);
    };
    Permalink.howToWatchAndroidTv = function howToWatchAndroidTv() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.HowToWatchAndroidTV */.Y.HowToWatchAndroidTV[locale]);
    };
    Permalink.HowToWatchStreaming = function HowToWatchStreaming() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.HowToWatchStreaming */.Y.HowToWatchStreaming[locale]);
    };
    Permalink.HowToWatchStreamingChromecast = function HowToWatchStreamingChromecast() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.HowToWatchStreamingChromecast */.Y.HowToWatchStreamingChromecast[locale]);
    };
    Permalink.HowToWatchStreamingAirplay = function HowToWatchStreamingAirplay() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.HowToWatchStreamingAirplay */.Y.HowToWatchStreamingAirplay[locale]);
    };
    Permalink.root = function root(user) {
        var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i18n.defaultLocale, queryString = arguments.length > 2 ? arguments[2] : void 0;
        if (user) {
            return this.collection(locale, queryString);
        }
        return "/".concat(routeType/* RouteType.Welcome */.Y.Welcome).concat(queryString ? "?".concat(queryString) : "");
    };
    Permalink.christmasContest = function christmasContest() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.ChristmasContest */.Y.ChristmasContest[locale]);
    };
    Permalink.inviteFriends = function inviteFriends() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.InviteFriends */.Y.InviteFriends[locale]);
    };
    Permalink.uaSupport = function uaSupport() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.UaSupport */.Y.UaSupport[locale]);
    };
    Permalink.easterContest = function easterContest() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.EasterContest */.Y.EasterContest[locale]);
    };
    Permalink.broadcast = function broadcast() {
        var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : i18n.defaultLocale;
        return "/".concat(routeType/* RouteType.Broadcast */.Y.Broadcast[locale]);
    };
    return Permalink;
}();
/**
 * Converts current url to a localised url for a different locale.
 *
 * @export
 * @param {string} url
 * @param {string} newLocale
 * @returns {string}
 */ function localiseUrl(url, newLocale) {
    var currentLocale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : i18n.defaultLocale;
    if (!url) {
        return url;
    }
    var ref = (0,_sliced_to_array/* default */.Z)(url.split("?"), 2), _url = ref[0], queryString = ref[1];
    var ref1 = (0,_to_array/* default */.Z)(_url.split("/")), page = ref1[1], parts = ref1.slice(2);
    var final;
    try {
        Object.values(routeType/* RouteType */.Y).forEach(function(route) {
            if (typeof route === "object") {
                var ref = (0,_to_array/* default */.Z)(route[currentLocale].split("/")), _page = ref[0], _parts = ref.slice(1);
                if ("/".concat(route[currentLocale]) === url) {
                    final = "/".concat(route[newLocale]);
                } else if (!final && page === _page && parts.length === _parts.length) {
                    var ref1;
                    ref1 = (0,_to_array/* default */.Z)(route[newLocale].split("/")), _page = ref1[0], _parts = ref1.slice(1), ref1;
                    final = "/".concat(_page, "/").concat(_parts.map(function(_p, i) {
                        if (_p === "[slug]" || _p === "[playSlug]") {
                            return parts[i];
                        }
                        return _p;
                    }).join("/"));
                }
            }
        });
    } catch (e) {
        console.warn(url, newLocale, currentLocale);
    }
    if (!final) {
        final = url;
    }
    if (queryString) {
        final = "".concat(final, "?").concat(queryString);
    }
    return final;
}
function getLocaleFromUrl(url, host, currentLocale) {
    var page = url.split("/")[1].split("?")[0];
    if (i18n.locales.indexOf(page) > -1) {
        return page;
    }
    var queryString = url.split("?")[1];
    var locale;
    if (queryString) {
        var query = (0,apiHelpers/* parseQueryString */.dD)(queryString);
        var ref, ref1;
        locale = (ref1 = (ref = query["lang"]) !== null && ref !== void 0 ? ref : query["locale "]) !== null && ref1 !== void 0 ? ref1 : query["redirectUrl"] ? getLocaleFromUrl(query["redirectUrl"], host) : null;
    }
    if (!locale) {
        Object.values(routeType/* RouteType */.Y).filter(function(route) {
            return typeof route === "object";
        }).forEach(function(route) {
            if (!locale) {
                i18n.locales.forEach(function(_locale) {
                    // route matches current page
                    if (route[_locale].indexOf(page) > -1) {
                        if (currentLocale === _locale) {
                            /*
                 * If routes for different languages are the same, take currentLocale into account (if possible)
                 */ locale = _locale;
                        } else if (host && localeFromHost(host) === _locale || !locale) {
                            /*
                 * If routes for different languages are the same, take host into account (if possible)
                 */ locale = _locale;
                        }
                    }
                });
            }
        });
    }
    return locale;
}
function isLoginRoute(route) {
    return !!i18n.locales.map(Permalink.login).find(function(p) {
        return route.indexOf(p) !== -1;
    });
}
function isPerformanceRoute(route) {
    var routeParts = route.split("/").filter(function(route) {
        return !!route;
    });
    return !!Object.values(routeType/* RouteType.PlayDetail */.Y.PlayDetail).find(function(playRoute) {
        var playRouteParts = playRoute.split("/");
        return playRouteParts[0] === routeParts[0] && playRouteParts.length === routeParts.length;
    });
}
function isHomeRoute(route) {
    return route === "/";
}
function isBrowseRoute(route) {
    return route === "/browse";
}
function createRedirectIfNeeded(ctx, locale) {
    var url = ctx.req.url;
    var currentUrlLocale = getLocaleFromUrl(url, null, locale);
    // 1) get locale from the url, ie. /celebrity/ is recognised as "en"
    // 2) current locale is "cz", so translate to /osobnost/ and redirect!
    if (currentUrlLocale !== locale) {
        var localisedUrl = localiseUrl(url, locale, currentUrlLocale);
        // prevent weird 308 language redirect on local dev
        if (localisedUrl.indexOf(".json") > -1) {
            return null;
        }
        // prevent cycling on the same url
        if (url === localisedUrl) {
            return null;
        }
        return {
            redirect: {
                permanent: true,
                destination: localisedUrl
            }
        };
    }
    return null;
}
function localeFromHost(host) {
    var country = Object.keys(config_routeTable/* default */.Z).find(function(key) {
        return config_routeTable/* default */.Z[key] === host;
    });
    switch(country){
        case enums_country/* Country.Czechia */.c.Czechia:
            return "cs";
        case enums_country/* Country.Ukraine */.c.Ukraine:
            return "uk";
        case "default":
            return "en";
        default:
            return country;
    }
}
function domainFromHost(host) {
    var domain = Object.keys(config_routeTable/* default */.Z).find(function(key) {
        return config_routeTable/* default */.Z[key] === host;
    });
    if (domain === "default") {
        return "tv";
    }
    return domain;
}
function countryFromHost(host) {
    var country = Object.keys(config_routeTable/* default */.Z).find(function(key) {
        return config_routeTable/* default */.Z[key] === host;
    });
    if (country === "default") {
        return "xx";
    }
    return country;
}
function kinoboxLink(type, kinoboxId, name) {
    if (type === "person") {
        return "https://www.kinobox.cz/osobnosti/".concat(kinoboxId, "-").concat(slugify_default()(name, {
            lower: true
        }));
    }
    return "https://www.kinobox.cz/film/".concat(kinoboxId, "-").concat(slugify_default()(name, {
        lower: true
    }));
}

;// CONCATENATED MODULE: ./helpers/index.ts

















/***/ }),

/***/ 28808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ basicSEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var config_routeTable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82278);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75332);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56168);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47118);





/**
 * Returns meta tags for given title, description and image.
 *
 * @export
 * @param {string} title
 * @param {string} description
 * @param {string} imageUrl
 * @returns {JSX.Element}
 */ function basicSEO(title, description, imageUrl, tagTitle) {
    var truncateDescription = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    var _description = truncateDescription ? (0,_common__WEBPACK_IMPORTED_MODULE_4__/* .truncateSeoDescription */ .kj)(description) : description;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    var _imageUrl = imageUrl !== null && imageUrl !== void 0 ? imageUrl : "".concat((0,config_routeTable__WEBPACK_IMPORTED_MODULE_1__/* .baseUrl */ .F)(locale), "/jpg/og-image.jpg");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: tagTitle !== null && tagTitle !== void 0 ? tagTitle : title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: _description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: _description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: _description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: _imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image",
                content: _imageUrl
            })
        ]
    });
}


/***/ }),

/***/ 38869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StorageItem */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62139);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47118);


var StorageItem = function StorageItem(data) {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, StorageItem);
    this.key = data.key;
    this.value = data.value;
};
// class for working with local storage in browser (common that can use other classes for store some data)
var StorageHelper = /*#__PURE__*/ function() {
    "use strict";
    function StorageHelper() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, StorageHelper);
        this.localStorageSupported = !(0,_common__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk)() ? typeof window["localStorage"] != "undefined" && window["localStorage"] != null : false;
    }
    var _proto = StorageHelper.prototype;
    // add value to storage
    _proto.add = function add(key, item) {
        if (this.localStorageSupported) {
            localStorage.setItem(key, item);
        }
    };
    // get all values from storage (all items)
    _proto.getAllItems = function getAllItems() {
        var list = new Array();
        for(var i = 0; i < localStorage.length; i++){
            var key = localStorage.key(i);
            var value = localStorage.getItem(key);
            list.push(new StorageItem({
                key: key,
                value: value
            }));
        }
        return list;
    };
    // get only all values from localStorage
    _proto.getAllValues = function getAllValues() {
        var list = new Array();
        for(var i = 0; i < localStorage.length; i++){
            var key = localStorage.key(i);
            var value = localStorage.getItem(key);
            list.push(value);
        }
        return list;
    };
    // get one item by key from storage
    _proto.get = function get(key) {
        if (this.localStorageSupported) {
            var item = localStorage.getItem(key);
            return item;
        } else {
            return null;
        }
    };
    // add value to storage
    _proto.saveJSON = function saveJSON(key, item, cacheTtl) {
        if (this.localStorageSupported) {
            localStorage.setItem(key, JSON.stringify(item));
            if (cacheTtl) {
                var cacheKey = "".concat(key, "_ttl");
                var ttl = new Date().getTime() + cacheTtl;
                localStorage.setItem(cacheKey, ttl.toString());
            }
        }
    };
    _proto.getJSON = function getJSON(key) {
        if (this.localStorageSupported) {
            var item = this.get(key);
            if (item) {
                var cacheKey = "".concat(key, "_ttl");
                var ttl = localStorage.getItem(cacheKey);
                if (ttl && new Date().getTime() > +ttl) {
                    this.remove(key);
                    this.remove(cacheKey);
                    return null;
                }
                return JSON.parse(item);
            }
            return null;
        } else {
            return null;
        }
    };
    _proto.updateJSON = function updateJSON(key, update) {
        if (this.localStorageSupported) {
            var ref;
            var current = (ref = this.getJSON(key)) !== null && ref !== void 0 ? ref : {};
            var updated = Object.assign(current, update);
            this.saveJSON(key, updated);
            return null;
        } else {
            return null;
        }
    };
    // remove value from storage
    _proto.remove = function remove(key) {
        if (this.localStorageSupported) {
            localStorage.removeItem(key);
        }
    };
    // clear storage (remove all items from it)
    _proto.clear = function clear() {
        if (this.localStorageSupported) {
            localStorage.clear();
        }
    };
    return StorageHelper;
}();
/* harmony default export */ __webpack_exports__["Z"] = (new StorageHelper());


/***/ }),

/***/ 22135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jR": function() { return /* reexport */ useCategoryRowSwiper; },
  "$1": function() { return /* reexport */ useCloseMobileMenu; },
  "dH": function() { return /* reexport */ useFade; },
  "e5": function() { return /* reexport */ useHowToItems; },
  "Vq": function() { return /* reexport */ useOnScrollElement; },
  "Yc": function() { return /* reexport */ usePlayRow; },
  "oc": function() { return /* reexport */ useSwiper; },
  "qM": function() { return /* reexport */ useTheatreRow; },
  "_Q": function() { return /* reexport */ useWelcomeTheatresRow; }
});

// UNUSED EXPORTS: useAttachCloseOnClickToOverlay, useFilterTheaters, useOnClickOutside

// EXTERNAL MODULE: ./helpers/PlatformHelper.ts
var PlatformHelper = __webpack_require__(61400);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./helpers/index.ts + 50 modules
var helpers = __webpack_require__(17651);
;// CONCATENATED MODULE: ./hooks/ui.tsx



var useAttachCloseOnClickToOverlay = function() {
    useEffect(function() {
        // const elOverlayArr = Array.from(document.querySelectorAll(".menu, .dialog"));
        var overlay = document.querySelector("#whole-overlay");
        var onOverlayClick = function(e) {
            if (overlay === e.target) {
                e.preventDefault();
                e.stopImmediatePropagation();
                closeDialog();
            }
        };
        var overlayBoundEvents = "click touchstart".split(" ");
        overlayBoundEvents.forEach(function(e) {
            window.addEventListener(e, onOverlayClick, false);
        });
    }, []);
};
var useCloseMobileMenu = function() {
    (0,react.useEffect)(function() {
        window.addEventListener("resize", function() {
            if (!PlatformHelper/* default.isMobile */.Z.isMobile) {
                var mobileMenuCls = "mobile-menu-open";
                var htmlClsList = (0,helpers/* getDOMCls */.Cd)();
                htmlClsList.remove(mobileMenuCls);
            }
        });
    }, []);
};
function useOnClickOutside(ref, handler) {
    useEffect(function() {
        var listener = function(e) {
            // console.log("ref.current ", ref.current);
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(e.target)) {
                return;
            }
            handler(e);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return function() {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [
        ref,
        handler
    ]);
}
function useOnScrollElement(elementTop) {
    var ref = (0,react.useState)(false), scrolled = ref[0], setScrolled = ref[1];
    var removeWindowScrollEvent = function() {
        window.removeEventListener("scroll", debouncedScroll, false);
    };
    var handleScroll = (0,react.useCallback)(function() {
        if (elementTop === null) {
            return;
        }
        var isTop = elementTop <= window.scrollY + window.innerHeight + 100;
        if (isTop && !scrolled) {
            setScrolled(true);
            // unsubscribe from scrolling after we already scrolled!
            removeWindowScrollEvent();
        }
    }, [
        scrolled,
        elementTop
    ]);
    // throttle scroll sniffing to every ~3rd render frame (1000ms / 60fps * 3) to increase performance
    var debouncedScroll = (0,helpers/* debounce */.Ds)(handleScroll, 50);
    (0,react.useEffect)(function() {
        if (!scrolled && elementTop !== null) {
            window.addEventListener("scroll", debouncedScroll, false);
            debouncedScroll();
            return function() {
                removeWindowScrollEvent();
            };
        }
    }, [
        elementTop,
        scrolled,
        debouncedScroll
    ]);
    return scrolled;
}

// EXTERNAL MODULE: ./external/swiper/js/swiper.esm.bundle.js + 2 modules
var swiper_esm_bundle = __webpack_require__(48408);
;// CONCATENATED MODULE: ./hooks/carousel.ts



function useSwiper(ref, progressBarRef) {
    (0,react.useEffect)(function() {
        var timeout;
        if (ref) {
            var progressCls = "animate";
            var progress = progressBarRef;
            var slideChange = function() {
                if (progress.current) {
                    progress.current.classList.remove(progressCls);
                }
                timeout = setTimeout(function() {
                    if (progress.current) {
                        progress.current.classList.add(progressCls);
                    }
                }, 900);
            };
            new swiper_esm_bundle/* default */.Z(ref.current, {
                direction: "horizontal",
                effect: PlatformHelper/* default.isMobile */.Z.isMobile ? "slide" : "fade",
                touchStartPreventDefault: false,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                loop: true,
                on: {
                    slideChange: slideChange
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    renderBullet: function(_, className) {
                        return '\n              <div class="'.concat(className, '">\n                <svg viewBox="0 0 32 32" width="32" height="32" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n                  <circle r="16" cx="16" cy="16" stroke="white" fill="transparent" stroke-width="32" />\n                </svg>\n              </div>\n            ');
                    }
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false
                },
                keyboard: {
                    enabled: false
                }
            });
        }
        return function() {
            clearTimeout(timeout);
        };
    }, [
        ref,
        progressBarRef
    ]);
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(75332);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./hooks/swiper.ts



var useCategoryRowSwiper = function(ref, playlist) {
    (0,react.useEffect)(function() {
        if (ref.current) {
            new swiper_esm_bundle/* default */.Z(ref.current, {
                direction: "horizontal",
                slidesPerView: "auto",
                freeMode: true,
                navigation: {
                    nextEl: ref.current.querySelector(".next"),
                    prevEl: ref.current.querySelector(".prev")
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                }
            });
        }
    }, [
        ref,
        playlist
    ]);
};
var useFilterTheaters = function(ref) {
    var _$ref = useState(null), swiper = _$ref[0], setSwiper = _$ref[1];
    useEffect(function() {
        if (ref.current) {
            var instance = new Swiper(ref.current, {
                direction: "horizontal",
                slidesPerView: "auto",
                freeMode: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                }
            });
            setSwiper(instance);
        }
    }, [
        ref
    ]);
    return swiper;
};
var useTheatreRow = function(ref, row) {
    (0,react.useEffect)(function() {
        if (ref.current) {
            new swiper_esm_bundle/* default */.Z(ref.current, {
                direction: "horizontal",
                slidesPerView: "auto",
                freeMode: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                }
            });
        }
    }, [
        ref,
        row
    ]);
};
var usePlayRow = function(ref, load) {
    (0,react.useEffect)(function() {
        var swiper;
        if (ref.current && load) {
            swiper = new swiper_esm_bundle/* default */.Z(ref.current, {
                direction: "horizontal",
                slidesPerView: "auto",
                freeMode: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                }
            });
        }
        return function() {
            if (swiper) {
                swiper.destroy(true, true);
            }
        };
    }, [
        ref,
        load
    ]);
};
var useWelcomeTheatresRow = function(ref, theaters, rendered) {
    (0,react.useEffect)(function() {
        if (ref.current && (window === null || window === void 0 ? void 0 : window.innerWidth) < 992 && rendered) {
            new swiper_esm_bundle/* default */.Z(ref.current, {
                direction: "horizontal",
                slidesPerView: "auto",
                freeMode: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                }
            });
        }
    }, [
        ref,
        theaters,
        rendered
    ]);
};
var useHowToItemsInstance;
var useHowToItems = function(ref, rendered) {
    var initialSlide = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, windowWidth = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    (0,react.useEffect)(function() {
        useHowToItemsInstance && useHowToItemsInstance.destroy(true, true);
        if (windowWidth < 992 && rendered) {
            useHowToItemsInstance = new swiper_esm_bundle/* default */.Z(ref.current, {
                direction: "horizontal",
                slidesPerView: "auto",
                initialSlide: initialSlide,
                centeredSlides: true,
                spaceBetween: 30,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                }
            });
            useHowToItemsInstance.on("slideChangeTransitionEnd", function() {
                router_default().push(useHowToItemsInstance.slides[useHowToItemsInstance.activeIndex].querySelector("a").href);
            });
        }
    }, [
        ref,
        rendered,
        initialSlide,
        windowWidth
    ]);
};
var useFade = function(ref, items) {
    (0,react.useEffect)(function() {
        new swiper_esm_bundle/* default */.Z(ref.current, {
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            slidesPerView: 1,
            effect: "fade",
            keyboard: {
                enabled: false
            }
        });
    }, [
        ref,
        items
    ]);
};

;// CONCATENATED MODULE: ./hooks/index.ts





/***/ }),

/***/ 57919:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var locales = (__webpack_require__(74782)/* .locales */ .k1);
module.exports = {
    locales: locales,
    defaultLocale: "en",
    pages: {
        "*": [
            "common",
            "settings",
            "popups",
            "welcome",
            "seo",
            "register",
            "profile",
            "ua-support",
            "discount",
            "christmas-contest", 
        ],
        "/": [
            "faq-home",
            "smart-tv",
            "mobile-apps"
        ],
        "/homepage": [
            "faq-home",
            "welcome"
        ],
        "/preview/[slug]": [
            "player"
        ],
        "/performance/[slug]": [
            "play-detail"
        ],
        "/watch-online/[slug]": [
            "play-detail",
            "player"
        ],
        "rgx:/theatres*": [
            "theaters",
            "play-detail"
        ],
        "rgx:/donate*": [
            "theaters",
            "choose-plan"
        ],
        "/login": [
            "login"
        ],
        "rgx:/register/*": [
            "register",
            "settings"
        ],
        "/profile": [
            "choose-plan",
            "profile"
        ],
        "rgx:/newsletter/*": [
            "profile"
        ],
        "/forgotten-password": [
            "forgotten-password"
        ],
        "/choose-plan": [
            "choose-plan",
            "profile"
        ],
        "rgx:/gift-vouchers*": [
            "vouchers"
        ],
        "/frequently-asked-questions": [
            "faq"
        ],
        "/about-us": [
            "about-us",
            "contact"
        ],
        "/contact": [
            "contact"
        ],
        "rgx:/smart-tv/*": [
            "smart-tv"
        ],
        "/for-schools": [
            "schools"
        ],
        "/authorship": [
            "authorship"
        ],
        "/email/handle": [
            "email-handle"
        ],
        "/content-settings": [
            "profile"
        ],
        "rgx:/how-to-watch/*": [
            "how-to-watch"
        ],
        "rgx:/how-to-watch/mobile-apps/*": [
            "mobile-apps"
        ],
        "rgx:/how-to-watch/video-streaming/*": [
            "video-streaming"
        ],
        "/invite-friends": [
            "invite-friends"
        ],
        "/ua-support": [
            "ua-support"
        ],
        "/discount-may-2022": [
            "discount-may-2022"
        ],
        "/broadcast": [
            "broadcast"
        ],
        "/christmas-contest": [
            "christmas-contest"
        ]
    },
    loadLocaleFrom: function(lang, ns) {
        // eslint-disable-next-line no-undef
        return __webpack_require__(22152)("./".concat(lang, "/").concat(ns, ".json"));
    }
};


/***/ }),

/***/ 70884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ models_User; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(62139);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(49573);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(55686);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(1780);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isWithinInterval/index.js



/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   isWithinRange(
 *     new Date(2014, 0, 3),
 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
 *   )
 *
 *   // v2.0.0 onward
 *
 *   isWithinInterval(
 *     new Date(2014, 0, 3),
 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
 *   )
 *   ```
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var time = (0,toDate/* default */.Z)(dirtyDate).getTime();
  var startTime = (0,toDate/* default */.Z)(interval.start).getTime();
  var endTime = (0,toDate/* default */.Z)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(63288);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfDay/index.js


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarDays/index.js



var MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js


 // Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.

function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */


function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull); // Prevent negative zero

  return result === 0 ? 0 : result;
}
// EXTERNAL MODULE: ./typings/api/index.ts + 9 modules
var api = __webpack_require__(81962);
;// CONCATENATED MODULE: ./models/User.ts




var User = /*#__PURE__*/ function() {
    "use strict";
    function User() {
        (0,_class_call_check/* default */.Z)(this, User);
        this.content_languages = [];
    }
    User.fromJSON = function fromJSON(json) {
        return Object.assign(new User(), json);
    };
    (0,_create_class/* default */.Z)(User, [
        {
            key: "showProfileWarning",
            get: function get() {
                return this.isInGracePeriod && this.auto_renew;
            }
        },
        {
            key: "needsToPay",
            get: function get() {
                return this.isSubscriber && this.isInGracePeriod && this.auto_renew;
            }
        },
        {
            key: "isInGracePeriod",
            get: function get() {
                try {
                    var now = new Date();
                    var expiration = new Date(this.subscription_expiration);
                    var subscriptionTill = new Date(this.subscription_purchased_till);
                    return !!(this.plan && isWithinInterval(now, {
                        start: subscriptionTill,
                        end: expiration
                    }));
                } catch (e) {
                    return false;
                }
            }
        },
        {
            key: "isSubscriber",
            get: function get() {
                if (this.subscription_expiration) {
                    return new Date(this.subscription_expiration) > new Date();
                }
                return !!this.subscription_type && this.subscription_type !== api/* SubscriptionType.None */.Qe.None;
            }
        },
        {
            key: "isWeekOldWithoutSub",
            get: function get() {
                return differenceInDays(new Date(), new Date(this.register_time)) <= 7 && !this.isSubscriber;
            }
        },
        {
            key: "showAdvancedChoosePlanForm",
            get: function get() {
                return !this.had_subscription && this.components && this.components["choose_plan"] === 1;
            }
        }
    ]);
    return User;
}();
/* harmony default export */ var models_User = (User);


/***/ }),

/***/ 61321:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        var normalizeLocalePath = (__webpack_require__(84078).normalizeLocalePath);
        var detectDomainLocale = (__webpack_require__(65533).detectDomainLocale);
        var target = locale || normalizeLocalePath(path, locales).detectedLocale;
        var domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            var proto = "http".concat(domain.http ? "" : "s", "://");
            var finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 31895:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _sliced_to_array = (__webpack_require__(24633)/* ["default"] */ .Z);
var _type_of = (__webpack_require__(94243)["default"]);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(56168));
var _router = __webpack_require__(35351);
var _addLocale = __webpack_require__(53787);
var _routerContext = __webpack_require__(99479);
var _appRouterContext = __webpack_require__(81042);
var _useIntersection = __webpack_require__(59472);
var _getDomainLocale = __webpack_require__(61321);
var _addBasePath = __webpack_require__(79653);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// @ts-ignore useTransition exist
var hasUseTransition = typeof _react.default.useTransition !== "undefined";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, startTransition) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // replace state instead of push if prop is present
        router[replace ? "replace" : "push"](href, as, {
            shallow: shallow,
            locale: locale,
            scroll: scroll
        });
    };
    if (startTransition) {
        startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _objectWithoutPropertiesLoose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var ref = _sliced_to_array(hasUseTransition ? // @ts-ignore useTransition exists
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.default.useTransition() : [], 2), /* isPending */ startTransition = ref[1];
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref1 = _react.default.useMemo(function() {
        var ref = _sliced_to_array((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref1.href, as = ref1.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref2 = _sliced_to_array((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref2[0], isVisible = ref2[1], resetVisible = ref2[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, appRouter ? startTransition : undefined);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 84078:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
var normalizeLocalePath = function(pathname, locales) {
    if (true) {
        return (__webpack_require__(5984).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname: pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 59472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _sliced_to_array = (__webpack_require__(24633)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(56168);
var _requestIdleCallback = __webpack_require__(33512);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _sliced_to_array((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _sliced_to_array((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (unobserve.current) {
                unobserve.current();
                unobserve.current = undefined;
            }
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                unobserve.current = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
            }
            return function() {
                unobserve.current == null ? void 0 : unobserve.current();
                unobserve.current = undefined;
            };
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 81042:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.FullAppTreeContext = exports.AppTreeContext = exports.AppRouterContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(56168));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var AppTreeContext = _react.default.createContext(null);
exports.AppTreeContext = AppTreeContext;
var FullAppTreeContext = _react.default.createContext(null);
exports.FullAppTreeContext = FullAppTreeContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 30117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _instanceof = (__webpack_require__(70911)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _react = _interopRequireDefault(__webpack_require__(56168));
var _loadable = _interopRequireDefault(__webpack_require__(42374));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 37208:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(56168));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42374:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var _class_call_check = (__webpack_require__(57711)/* ["default"] */ .Z);
var _create_class = (__webpack_require__(76260)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(56168));
var _loadableContext = __webpack_require__(37208);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var useSyncExternalStore = ( true ? __webpack_require__(56168) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _class_call_check(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _create_class(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            var _this1 = this;
                            this._delay = setTimeout(function() {
                                _this1._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        var _this2 = this;
                        this._timeout = setTimeout(function() {
                            _this2._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 89143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5447);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(99728);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(84911);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./i18n.js
var i18n = __webpack_require__(57919);
var i18n_default = /*#__PURE__*/__webpack_require__.n(i18n);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/I18nProvider.js + 1 modules
var I18nProvider = __webpack_require__(67014);
;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/getConfig.js
function getConfig() {
    var g = typeof window === 'undefined' ? __webpack_require__.g : window;
    return g.i18nConfig;
}

;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/getPageNamespaces.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function flat(a) {
    return a.reduce(function (b, c) { return b.concat(c); }, []);
}
function getPageNamespaces(_a, page, ctx) {
    var _b = _a.pages, pages = _b === void 0 ? {} : _b;
    return __awaiter(this, void 0, void 0, function () {
        var rgx, getNs, rgxs, _c, _d, _e, _f;
        var _this = this;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    rgx = 'rgx:';
                    getNs = function (ns) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2, typeof ns === 'function' ? ns(ctx) : ns || []];
                    }); }); };
                    rgxs = Object.keys(pages).reduce(function (arr, p) {
                        if (p.substring(0, rgx.length) === rgx &&
                            new RegExp(p.replace(rgx, '')).test(page)) {
                            arr.push(getNs(pages[p]));
                        }
                        return arr;
                    }, []);
                    _c = [[]];
                    return [4, getNs(pages['*'])];
                case 1:
                    _d = [__spreadArray.apply(void 0, _c.concat([(_g.sent()), true]))];
                    return [4, getNs(pages[page])];
                case 2:
                    _e = [__spreadArray.apply(void 0, _d.concat([(_g.sent()), true]))];
                    _f = flat;
                    return [4, Promise.all(rgxs)];
                case 3: return [2, __spreadArray.apply(void 0, _e.concat([_f.apply(void 0, [_g.sent()]), true]))];
            }
        });
    });
}

;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/loadNamespaces.js
/* provided dependency */ var process = __webpack_require__(89885);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var loadNamespaces_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var loadNamespaces_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var colorEnabled = process.env.NODE_DISABLE_COLORS == null &&
    process.env.NO_COLOR == null &&
    process.env.TERM !== 'dumb' &&
    process.env.FORCE_COLOR !== '0';
function loadNamespaces(config) {
    var _a, _b;
    if (config === void 0) { config = {}; }
    return loadNamespaces_awaiter(this, void 0, void 0, function () {
        var conf, localesToIgnore, __lang, page, namespaces, defaultLoader, pageNamespaces, color;
        return loadNamespaces_generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    conf = __assign(__assign({}, getConfig()), config);
                    localesToIgnore = conf.localesToIgnore || ['default'];
                    __lang = ((_a = conf.req) === null || _a === void 0 ? void 0 : _a.locale) ||
                        conf.locale ||
                        ((_b = conf.router) === null || _b === void 0 ? void 0 : _b.locale) ||
                        conf.defaultLocale ||
                        '';
                    if (!conf.pathname) {
                        console.warn('🚨 [next-translate] You forgot to pass the "pathname" inside "loadNamespaces" configuration');
                        return [2, { __lang: __lang }];
                    }
                    if (localesToIgnore.includes(__lang))
                        return [2, { __lang: __lang }];
                    if (!conf.loaderName && conf.loader !== false) {
                        console.warn('🚨 [next-translate] You can remove the "loadNamespaces" helper, unless you set "loader: false" in your i18n config file.');
                    }
                    page = removeTrailingSlash(conf.pathname.replace(/\/index$/, '')) || '/';
                    return [4, getPageNamespaces(conf, page, conf)];
                case 1:
                    namespaces = _c.sent();
                    defaultLoader = function () { return Promise.resolve({}); };
                    return [4, Promise.all(namespaces.map(function (ns) {
                            return typeof conf.loadLocaleFrom === 'function'
                                ? conf.loadLocaleFrom(__lang, ns)
                                : defaultLoader(__lang, ns);
                        })).catch(function () { })];
                case 2:
                    pageNamespaces = (_c.sent()) || [];
                    if (conf.logBuild !== false && typeof window === 'undefined') {
                        color = function (c) { return (colorEnabled ? "\u001B[36m".concat(c, "\u001B[0m") : c); };
                        console.log(color('next-translate'), "- compiled page:", color(page), '- locale:', color(__lang), '- namespaces:', color(namespaces.join(', ')), '- used loader:', color(conf.loaderName || '-'));
                    }
                    return [2, {
                            __lang: __lang,
                            __namespaces: namespaces.reduce(function (obj, ns, i) {
                                obj[ns] = pageNamespaces[i] || null;
                                return obj;
                            }, {}),
                        }];
            }
        });
    });
}
function removeTrailingSlash(path) {
    if (path === void 0) { path = ''; }
    return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
}

;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/appWithI18n.js
var appWithI18n_assign = (undefined && undefined.__assign) || function () {
    appWithI18n_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return appWithI18n_assign.apply(this, arguments);
};
var appWithI18n_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var appWithI18n_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function appWithI18n(AppToTranslate, config) {
    var _this = this;
    if (config === void 0) { config = {}; }
    if (!config.isLoader && config.loader !== false) {
        console.warn('🚨 [next-translate] You can remove the "appWithI18n" HoC on the _app.js, unless you set "loader: false" in your i18n config file.');
    }
    function AppWithTranslations(props) {
        var _a, _b;
        var defaultLocale = config.defaultLocale;
        return (react.createElement(I18nProvider/* default */.Z, { lang: ((_a = props.pageProps) === null || _a === void 0 ? void 0 : _a.__lang) || props.__lang || defaultLocale, namespaces: ((_b = props.pageProps) === null || _b === void 0 ? void 0 : _b.__namespaces) || props.__namespaces, config: config },
            react.createElement(AppToTranslate, appWithI18n_assign({}, props))));
    }
    if (typeof config.staticsHoc === 'function') {
        config.staticsHoc(AppWithTranslations, AppToTranslate);
    }
    if (typeof window === 'undefined')
        __webpack_require__.g.i18nConfig = config;
    else
        window.i18nConfig = config;
    if (config.skipInitialProps)
        return AppWithTranslations;
    AppWithTranslations.getInitialProps = function (appCtx) { return appWithI18n_awaiter(_this, void 0, void 0, function () {
        var ctx, appProps, _a;
        return appWithI18n_generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ctx = appWithI18n_assign(appWithI18n_assign({}, (appCtx.ctx || {})), (appCtx || {}));
                    appProps = { pageProps: {} };
                    if (!AppToTranslate.getInitialProps) return [3, 2];
                    return [4, AppToTranslate.getInitialProps(appCtx)];
                case 1:
                    appProps = (_b.sent()) || {};
                    _b.label = 2;
                case 2:
                    _a = [appWithI18n_assign({}, appProps)];
                    return [4, loadNamespaces(appWithI18n_assign(appWithI18n_assign(appWithI18n_assign({}, ctx), config), { loaderName: 'getInitialProps' }))];
                case 3: return [2, appWithI18n_assign.apply(void 0, _a.concat([(_b.sent())]))];
            }
        });
    }); };
    return AppWithTranslations;
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(75332);
// EXTERNAL MODULE: ./styles/main.scss
var main = __webpack_require__(7727);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/skeleton.css
var skeleton = __webpack_require__(34714);
// EXTERNAL MODULE: ./context/index.ts + 2 modules
var context = __webpack_require__(52662);
// EXTERNAL MODULE: ./helpers/Analytics.ts
var Analytics = __webpack_require__(86639);
;// CONCATENATED MODULE: ./pages/_app.tsx




// @ts-ignore

// @ts-ignore

// @ts-ignore






function Dramox(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var ref = (0,react.useState)([]), history = ref[0], setHistory = ref[1];
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath;
    (0,react.useEffect)(function() {
        setHistory([
            asPath
        ]);
        // since we use SPA and hard history pushes don't occur, update current page's url for every virtual page change
        router.events.on("beforeHistoryChange", function(route) {
            return Analytics/* default.setCurrentUrlForGoogle */.ZP.setCurrentUrlForGoogle(route);
        });
        // hook app's version on window
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window._version = {
            version: "9.0.2",
            commit: "178a20c",
            environment: "production",
            domain: "dramox.tv"
        };
    }, []);
    (0,react.useEffect)(function() {
        if (history[history.length - 1] !== asPath) {
            setHistory(function(prevState) {
                return (0,_to_consumable_array/* default */.Z)(prevState).concat([
                    asPath
                ]);
            });
        }
    }, [
        asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* ProvideAuth */.Yo, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* ProvidePopup */.Sc, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* NotificationContext */.uj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({
                    history: history
                }, pageProps))
            })
        })
    });
}
var __Page_Next_Translate__ = Dramox;
// @ts-ignore
/* harmony default export */ var _app = (appWithI18n(__Page_Next_Translate__, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (i18n_default())), {
    // @ts-ignore
    isLoader: true,
    // @ts-ignore
    skipInitialProps: true
}))); // @ts-ignore


/***/ }),

/***/ 48729:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// NAMESPACE OBJECT: ./node_modules/@sentry/core/esm/integrations/index.js
var integrations_namespaceObject = {};
__webpack_require__.r(integrations_namespaceObject);
__webpack_require__.d(integrations_namespaceObject, {
  "FunctionToString": function() { return FunctionToString; },
  "InboundFilters": function() { return InboundFilters; }
});

// NAMESPACE OBJECT: ./node_modules/@sentry/browser/esm/integrations/index.js
var esm_integrations_namespaceObject = {};
__webpack_require__.r(esm_integrations_namespaceObject);
__webpack_require__.d(esm_integrations_namespaceObject, {
  "Breadcrumbs": function() { return Breadcrumbs; },
  "Dedupe": function() { return Dedupe; },
  "GlobalHandlers": function() { return GlobalHandlers; },
  "LinkedErrors": function() { return LinkedErrors; },
  "TryCatch": function() { return TryCatch; },
  "UserAgent": function() { return UserAgent; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(61557);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(50416);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js

var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = (0,object/* getOriginalFunction */.HK)(this) || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(7663);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(45855);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(81197);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/flags.js
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var flags_IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = _mergeOptions(self_1._options, clientOptions);
                    return _shouldDropEvent(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

/** JSDoc */
function _mergeOptions(internalOptions, clientOptions) {
    if (internalOptions === void 0) { internalOptions = {}; }
    if (clientOptions === void 0) { clientOptions = {}; }
    return {
        allowUrls: (0,tslib_es6/* __spread */.fl)((internalOptions.whitelistUrls || []), (internalOptions.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
        denyUrls: (0,tslib_es6/* __spread */.fl)((internalOptions.blacklistUrls || []), (internalOptions.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
        ignoreErrors: (0,tslib_es6/* __spread */.fl)((internalOptions.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
    };
}
/** JSDoc */
function _shouldDropEvent(event, options) {
    if (options.ignoreInternal && _isSentryError(event)) {
        flags_IS_DEBUG_BUILD &&
            esm_logger/* logger.warn */.kg.warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0,misc/* getEventDescription */.jH)(event));
        return true;
    }
    if (_isIgnoredError(event, options.ignoreErrors)) {
        flags_IS_DEBUG_BUILD &&
            esm_logger/* logger.warn */.kg.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0,misc/* getEventDescription */.jH)(event));
        return true;
    }
    if (_isDeniedUrl(event, options.denyUrls)) {
        flags_IS_DEBUG_BUILD &&
            esm_logger/* logger.warn */.kg.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0,misc/* getEventDescription */.jH)(event) + ".\nUrl: " + _getEventFilterUrl(event));
        return true;
    }
    if (!_isAllowedUrl(event, options.allowUrls)) {
        flags_IS_DEBUG_BUILD &&
            esm_logger/* logger.warn */.kg.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0,misc/* getEventDescription */.jH)(event) + ".\nUrl: " + _getEventFilterUrl(event));
        return true;
    }
    return false;
}
function _isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) {
        return false;
    }
    return _getPossibleEventMessages(event).some(function (message) {
        return ignoreErrors.some(function (pattern) { return (0,string/* isMatchingPattern */.zC)(message, pattern); });
    });
}
function _isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) {
        return false;
    }
    var url = _getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function (pattern) { return (0,string/* isMatchingPattern */.zC)(url, pattern); });
}
function _isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) {
        return true;
    }
    var url = _getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function (pattern) { return (0,string/* isMatchingPattern */.zC)(url, pattern); });
}
function _getPossibleEventMessages(event) {
    if (event.message) {
        return [event.message];
    }
    if (event.exception) {
        try {
            var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
            return ["" + value, type + ": " + value];
        }
        catch (oO) {
            flags_IS_DEBUG_BUILD && esm_logger/* logger.error */.kg.error("Cannot extract message for event " + (0,misc/* getEventDescription */.jH)(event));
            return [];
        }
    }
    return [];
}
function _isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    }
    catch (e) {
        // ignore
    }
    return false;
}
function _getLastValidUrl(frames) {
    if (frames === void 0) { frames = []; }
    for (var i = frames.length - 1; i >= 0; i--) {
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
            return frame.filename || null;
        }
    }
    return null;
}
function _getEventFilterUrl(event) {
    try {
        if (event.stacktrace) {
            return _getLastValidUrl(event.stacktrace.frames);
        }
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        }
        catch (e) {
            // ignore
        }
        return frames_1 ? _getLastValidUrl(frames_1) : null;
    }
    catch (oO) {
        flags_IS_DEBUG_BUILD && esm_logger/* logger.error */.kg.error("Cannot extract url for event " + (0,misc/* getEventDescription */.jH)(event));
        return null;
    }
}
//# sourceMappingURL=inboundfilters.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/index.js


//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/global.js
var esm_global = __webpack_require__(5177);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/hub.js + 2 modules
var esm_hub = __webpack_require__(1756);
;// CONCATENATED MODULE: ./node_modules/@sentry/types/esm/severity.js
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// TODO: in v7, these can disappear, because they now also exist in `@sentry/utils`. (Having them there rather than here
// is nice because then it enforces the idea that only types are exported from `@sentry/types`.)
var SeverityLevels = (/* unused pure expression or super */ null && (['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical']));
//# sourceMappingURL=severity.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(44290);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(2389);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(80963);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Helper to decycle json objects
 */
function memoBuilder() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) {
                return true;
            }
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < inner.length; i++) {
            var value = inner[i];
            if (value === obj) {
                return true;
            }
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) {
            inner.delete(obj);
        }
        else {
            for (var i = 0; i < inner.length; i++) {
                if (inner[i] === obj) {
                    inner.splice(i, 1);
                    break;
                }
            }
        }
    }
    return [memoize, unmemoize];
}
//# sourceMappingURL=memo.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var esm_stacktrace = __webpack_require__(28791);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output..
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
function normalize(input, depth, maxProperties) {
    if (depth === void 0) { depth = +Infinity; }
    if (maxProperties === void 0) { maxProperties = +Infinity; }
    try {
        // since we're at the outermost level, there is no key
        return visit('', input, depth, maxProperties);
    }
    catch (err) {
        return { ERROR: "**non-serializable** (" + err + ")" };
    }
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(key, value, depth, maxProperties, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (maxProperties === void 0) { maxProperties = +Infinity; }
    if (memo === void 0) { memo = memoBuilder(); }
    var _a = (0,tslib_es6/* __read */.CR)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
        try {
            return valueWithToJSON.toJSON();
        }
        catch (err) {
            // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
        }
    }
    // Get the simple cases out of the way first
    if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))) {
        return value;
    }
    var stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) {
        return stringified;
    }
    // We're also done if we've reached the max depth
    if (depth === 0) {
        // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
        return stringified.replace('object ', '');
    }
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) {
        return '[Circular ~]';
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = (Array.isArray(value) ? [] : {});
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = ((0,is/* isError */.VZ)(value) || (0,is/* isEvent */.cO)(value) ? (0,object/* convertToPlainObject */.Sh)(value) : value);
    for (var visitKey in visitable) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
            continue;
        }
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
// TODO remove this in v7 (this means the method will no longer be exported, under any name)

/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(key, 
// this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) {
            return '[Domain]';
        }
        if (key === 'domainEmitter') {
            return '[DomainEmitter]';
        }
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
            return '[Global]';
        }
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) {
            return '[Window]';
        }
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) {
            return '[Document]';
        }
        // React's SyntheticEvent thingy
        if ((0,is/* isSyntheticEvent */.Cy)(value)) {
            return '[SyntheticEvent]';
        }
        if (typeof value === 'number' && value !== value) {
            return '[NaN]';
        }
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) {
            return '[undefined]';
        }
        if (typeof value === 'function') {
            return "[Function: " + (0,esm_stacktrace/* getFunctionName */.$P)(value) + "]";
        }
        if (typeof value === 'symbol') {
            return "[" + String(value) + "]";
        }
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') {
            return "[BigInt: " + String(value) + "]";
        }
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    }
    catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
//# sourceMappingURL=normalize.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(14464);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js

// global reference to slice
var UNKNOWN_FUNCTION = '?';
var OPERA10_PRIORITY = 10;
var OPERA11_PRIORITY = 20;
var CHROME_PRIORITY = 30;
var WINJS_PRIORITY = 40;
var GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true,
    };
    if (lineno !== undefined) {
        frame.lineno = lineno;
    }
    if (colno !== undefined) {
        frame.colno = colno;
    }
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var chrome = function (line) {
    var parts = chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0,tslib_es6/* __read */.CR)(extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var chromeStackParser = [CHROME_PRIORITY, chrome];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var gecko = function (line) {
    var _a;
    var parts = geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || UNKNOWN_FUNCTION;
        _a = (0,tslib_es6/* __read */.CR)(extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var geckoStackParser = [GECKO_PRIORITY, gecko];
var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var winjs = function (line) {
    var parts = winjsRegex.exec(line);
    return parts
        ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
        : undefined;
};
var winjsStackParser = [WINJS_PRIORITY, winjs];
var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var opera10 = function (line) {
    var parts = opera10Regex.exec(line);
    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var opera10StackParser = [OPERA10_PRIORITY, opera10];
var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var opera11 = function (line) {
    var parts = opera11Regex.exec(line);
    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var opera11StackParser = [OPERA11_PRIORITY, opera11];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
var extractSafariExtensionDetails = function (func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension
        ? [
            func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
            isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename,
        ]
        : [func, filename];
};
//# sourceMappingURL=stack-parsers.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js




/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromError(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = parseStackFrames(ex);
    var exception = {
        type: ex && ex.name,
        value: extractMessage(ex),
    };
    if (frames.length) {
        exception.stacktrace = { frames: frames };
    }
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0,object/* extractExceptionKeysForMessage */.zf)(exception),
                },
            ],
        },
        extra: {
            __serialized__: normalizeToSize(exception),
        },
    };
    if (syntheticException) {
        var frames_1 = parseStackFrames(syntheticException);
        if (frames_1.length) {
            event.stacktrace = { frames: frames_1 };
        }
    }
    return event;
}
/**
 * @hidden
 */
function eventFromError(ex) {
    return {
        exception: {
            values: [exceptionFromError(ex)],
        },
    };
}
/** Parses stack frames from an error */
function parseStackFrames(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = getPopSize(ex);
    try {
        return (0,esm_stacktrace/* createStackParser */.pE)(opera10StackParser, opera11StackParser, chromeStackParser, winjsStackParser, geckoStackParser)(stacktrace, popSize);
    }
    catch (e) {
        // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') {
            return ex.framesToPop;
        }
        if (reactMinifiedRegexp.test(ex.message)) {
            return 1;
        }
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(exception, hint, attachStacktrace) {
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, attachStacktrace);
    (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
    event.level = Severity.Error;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(message, level, hint, attachStacktrace) {
    if (level === void 0) { level = Severity.Info; }
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromString(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}
/**
 * @hidden
 */
function eventFromUnknownInput(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0,is/* isErrorEvent */.VW)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return eventFromError(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0,is/* isDOMError */.TX)(exception) || (0,is/* isDOMException */.fm)(exception)) {
        var domException = exception;
        if ('stack' in exception) {
            event = eventFromError(exception);
        }
        else {
            var name_1 = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = eventFromString(message, syntheticException, attachStacktrace);
            (0,misc/* addExceptionTypeValue */.Db)(event, message);
        }
        if ('code' in domException) {
            event.tags = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event.tags), { 'DOMException.code': "" + domException.code });
        }
        return event;
    }
    if ((0,is/* isError */.VZ)(exception)) {
        // we have a real Error object, do nothing
        return eventFromError(exception);
    }
    if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = eventFromPlainObject(objectException, syntheticException, isUnhandledRejection);
        (0,misc/* addExceptionMechanism */.EG)(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, attachStacktrace);
    (0,misc/* addExceptionTypeValue */.Db)(event, "" + exception, undefined);
    (0,misc/* addExceptionMechanism */.EG)(event, {
        synthetic: true,
    });
    return event;
}
/**
 * @hidden
 */
function eventFromString(input, syntheticException, attachStacktrace) {
    var event = {
        message: input,
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = parseStackFrames(syntheticException);
        if (frames_2.length) {
            event.stacktrace = { frames: frames_2 };
        }
    }
    return event;
}
//# sourceMappingURL=eventbuilder.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/flags.js
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var esm_flags_IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var esm = __webpack_require__(75300);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/polyfill.js
var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
            // @ts-ignore typescript complains about indexing so we remove
            obj[prop] = proto[prop];
        }
    }
    return obj;
}
//# sourceMappingURL=polyfill.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/error.js


/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

//# sourceMappingURL=error.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/flags.js
var flags = __webpack_require__(86834);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/dsn.js



/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsnToString(dsn, withPassword) {
    if (withPassword === void 0) { withPassword = false; }
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return (protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') +
        ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
}
function dsnFromString(str) {
    var match = DSN_REGEX.exec(str);
    if (!match) {
        throw new SentryError("Invalid Sentry Dsn: " + str);
    }
    var _a = (0,tslib_es6/* __read */.CR)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) {
            projectId = projectMatch[0];
        }
    }
    return dsnFromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, publicKey: publicKey });
}
function dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) {
        components.publicKey = components.user;
    }
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId,
    };
}
function validateDsn(dsn) {
    if (!flags/* IS_DEBUG_BUILD */.h) {
        return;
    }
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
    requiredComponents.forEach(function (component) {
        if (!dsn[component]) {
            throw new SentryError("Invalid Sentry Dsn: " + component + " missing");
        }
    });
    if (!projectId.match(/^\d+$/)) {
        throw new SentryError("Invalid Sentry Dsn: Invalid projectId " + projectId);
    }
    if (!isValidProtocol(protocol)) {
        throw new SentryError("Invalid Sentry Dsn: Invalid protocol " + protocol);
    }
    if (port && isNaN(parseInt(port, 10))) {
        throw new SentryError("Invalid Sentry Dsn: Invalid port " + port);
    }
    return true;
}
/** The Sentry Dsn, identifying a Sentry instance and project. */
function makeDsn(from) {
    var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
    validateDsn(components);
    return components;
}
//# sourceMappingURL=dsn.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/api.js

var SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/
var API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn, metadata, tunnel) {
        if (metadata === void 0) { metadata = {}; }
        this.dsn = dsn;
        this._dsnObject = makeDsn(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */
    API.prototype.forceEnvelope = function () {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */
    API.prototype.getBaseApiEndpoint = function () {
        return getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */
    API.prototype.getStoreEndpoint = function () {
        return getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        return getStoreEndpointWithUrlEncodedAuth(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
        return getEnvelopeEndpointWithUrlEncodedAuth(this._dsnObject, this._tunnel);
    };
    return API;
}());

/** Initializes API Details */
function initAPIDetails(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: makeDsn(dsn),
        tunnel: tunnel,
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn, target) {
    return "" + getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn) {
    return (0,object/* urlEncode */._j)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: SENTRY_API_VERSION,
    });
}
/** Returns the store endpoint URL. */
function getStoreEndpoint(dsn) {
    return _getIngestEndpoint(dsn, 'store');
}
/**
 * Returns the store endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getStoreEndpointWithUrlEncodedAuth(dsn) {
    return getStoreEndpoint(dsn) + "?" + _encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */
function _getEnvelopeEndpoint(dsn) {
    return _getIngestEndpoint(dsn, 'envelope');
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel) {
    return tunnel ? tunnel : _getEnvelopeEndpoint(dsn) + "?" + _encodedAuth(dsn);
}
/**
 * Returns an object that can be used in request headers.
 * This is needed for node and the old /store endpoint in sentry
 */
function getRequestHeaders(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) {
        header.push("sentry_secret=" + dsn.pass);
    }
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', '),
    };
}
/** Returns the url to the report dialog endpoint. */
function getReportDialogEndpoint(dsnLike, dialogOptions) {
    var dsn = makeDsn(dsnLike);
    var endpoint = getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + dsnToString(dsn);
    for (var key in dialogOptions) {
        if (key === 'dsn') {
            continue;
        }
        if (key === 'user') {
            if (!dialogOptions.user) {
                continue;
            }
            if (dialogOptions.user.name) {
                encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            }
            if (dialogOptions.user.email) {
                encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
            }
        }
        else {
            encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
        }
    }
    return endpoint + "?" + encodedOptions;
}
//# sourceMappingURL=api.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/helpers.js




var global = (0,esm_global/* getGlobalObject */.R)();
var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) { options = {}; }
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            return wrapper;
        }
        // We don't wanna wrap it twice
        if ((0,object/* getOriginalFunction */.HK)(fn)) {
            return fn;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        }
        catch (ex) {
            ignoreNextOnError();
            (0,esm/* withScope */.$e)(function (scope) {
                scope.addEventProcessor(function (event) {
                    if (options.mechanism) {
                        (0,misc/* addExceptionTypeValue */.Db)(event, undefined, undefined);
                        (0,misc/* addExceptionMechanism */.EG)(event, options.mechanism);
                    }
                    event.extra = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event.extra), { arguments: args });
                    return event;
                });
                (0,esm/* captureException */.Tb)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0,object/* markFunctionWrapped */.$Q)(sentryWrapped, fn);
    (0,object/* addNonEnumerableProperty */.xp)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
        // eslint-disable-next-line no-empty
    }
    catch (_oO) { }
    return sentryWrapped;
}
/**
 * Injects the Report Dialog script
 * @hidden
 */
function injectReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!global.document) {
        return;
    }
    if (!options.eventId) {
        esm_flags_IS_DEBUG_BUILD && esm_logger/* logger.error */.kg.error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        esm_flags_IS_DEBUG_BUILD && esm_logger/* logger.error */.kg.error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = global.document.createElement('script');
    script.async = true;
    script.src = getReportDialogEndpoint(options.dsn, options);
    if (options.onLoad) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        script.onload = options.onLoad;
    }
    var injectionPoint = global.document.head || global.document.body;
    if (injectionPoint) {
        injectionPoint.appendChild(script);
    }
}
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js

/* eslint-disable @typescript-eslint/no-unsafe-member-access */






/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */
        this._installFunc = {
            onerror: _installGlobalOnErrorHandler,
            onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
        };
        this._options = (0,tslib_es6/* __assign */.pi)({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for (var key in options) {
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

/** JSDoc */
function _installGlobalOnErrorHandler() {
    (0,instrument/* addInstrumentationHandler */.o)('error', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (data) {
        var _a = (0,tslib_es6/* __read */.CR)(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
            return;
        }
        var event = error === undefined && (0,is/* isString */.HD)(msg)
            ? _eventFromIncompleteOnError(msg, url, line, column)
            : _enhanceEventWithInitialFrame(eventFromUnknownInput(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = Severity.Error;
        addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
    (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (e) {
        var _a = (0,tslib_es6/* __read */.CR)(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) {
                error = e.reason;
            }
            // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
            // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
            // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
            // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
            // https://github.com/getsentry/sentry-javascript/issues/2380
            else if ('detail' in e && 'reason' in e.detail) {
                error = e.detail.reason;
            }
        }
        catch (_oO) {
            // no-empty
        }
        if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
            return true;
        }
        var event = (0,is/* isPrimitive */.pt)(error)
            ? _eventFromRejectionWithPrimitive(error)
            : eventFromUnknownInput(error, undefined, attachStacktrace, true);
        event.level = Severity.Error;
        addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason),
                },
            ],
        },
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message,
                },
            ],
        },
    };
    return _enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = (event.exception = event.exception || {});
    // event.exception.values
    var ev = (e.values = e.values || []);
    // event.exception.values[0]
    var ev0 = (ev[0] = ev[0] || {});
    // event.exception.values[0].stacktrace
    var ev0s = (ev0.stacktrace = ev0.stacktrace || {});
    // event.exception.values[0].stacktrace.frames
    var ev0sf = (ev0s.frames = ev0s.frames || []);
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) {
        ev0sf.push({
            colno: colno,
            filename: filename,
            function: '?',
            in_app: true,
            lineno: lineno,
        });
    }
    return event;
}
function globalHandlerLog(type) {
    esm_flags_IS_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("Global Handler attached: " + type);
}
function addMechanismAndCapture(hub, error, event, type) {
    (0,misc/* addExceptionMechanism */.EG)(event, {
        handled: false,
        type: type,
    });
    hub.captureEvent(event, {
        originalException: error,
    });
}
function getHubAndAttachStacktrace() {
    var hub = (0,esm_hub/* getCurrentHub */.Gd)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [hub, attachStacktrace];
}
//# sourceMappingURL=globalhandlers.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js



var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function TryCatch(options) {
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
        this._options = (0,tslib_es6/* __assign */.pi)({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        var global = (0,esm_global/* getGlobalObject */.R)();
        if (this._options.setTimeout) {
            (0,object/* fill */.hl)(global, 'setTimeout', _wrapTimeFunction);
        }
        if (this._options.setInterval) {
            (0,object/* fill */.hl)(global, 'setInterval', _wrapTimeFunction);
        }
        if (this._options.requestAnimationFrame) {
            (0,object/* fill */.hl)(global, 'requestAnimationFrame', _wrapRAF);
        }
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
            (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
        }
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

/** JSDoc */
function _wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var originalCallback = args[0];
        args[0] = wrap(originalCallback, {
            mechanism: {
                data: { function: (0,esm_stacktrace/* getFunctionName */.$P)(original) },
                handled: true,
                type: 'instrument',
            },
        });
        return original.apply(this, args);
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            wrap(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0,esm_stacktrace/* getFunctionName */.$P)(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }),
        ]);
    };
}
/** JSDoc */
function _wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
        xmlHttpRequestProps.forEach(function (prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0,object/* fill */.hl)(xhr, prop, function (original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: (0,esm_stacktrace/* getFunctionName */.$P)(original),
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    };
                    // If Instrument integration has been called before TryCatch, get the name of original function
                    var originalFunction = (0,object/* getOriginalFunction */.HK)(original);
                    if (originalFunction) {
                        wrapOptions.mechanism.data.handler = (0,esm_stacktrace/* getFunctionName */.$P)(originalFunction);
                    }
                    // Otherwise wrap directly
                    return wrap(original, wrapOptions);
                });
            }
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */
function _wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0,esm_global/* getGlobalObject */.R)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
        return;
    }
    (0,object/* fill */.hl)(proto, 'addEventListener', function (original) {
        return function (eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') {
                    fn.handleEvent = wrap(fn.handleEvent.bind(fn), {
                        mechanism: {
                            data: {
                                function: 'handleEvent',
                                handler: (0,esm_stacktrace/* getFunctionName */.$P)(fn),
                                target: target,
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    });
                }
            }
            catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                wrap(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0,esm_stacktrace/* getFunctionName */.$P)(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }),
                options,
            ]);
        };
    });
    (0,object/* fill */.hl)(proto, 'removeEventListener', function (originalRemoveEventListener) {
        return function (eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */
            var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) {
                    originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            }
            catch (e) {
                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}
//# sourceMappingURL=trycatch.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/enums.js
var enums_SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];
//# sourceMappingURL=enums.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/severity.js


function isSupportedSeverity(level) {
    return enums_SeverityLevels.indexOf(level) !== -1;
}
/**
 * Converts a string-based level into a {@link Severity}.
 *
 * @param level string representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
    if (level === 'warn')
        return Severity.Warning;
    if (isSupportedSeverity(level)) {
        return level;
    }
    return Severity.Log;
}
//# sourceMappingURL=severity.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable max-lines */



/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = (0,tslib_es6/* __assign */.pi)({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */
    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
        if (!this._options.sentry) {
            return;
        }
        (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0,misc/* getEventDescription */.jH)(event),
        }, {
            event: event,
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        if (this._options.console) {
            (0,instrument/* addInstrumentationHandler */.o)('console', _consoleBreadcrumb);
        }
        if (this._options.dom) {
            (0,instrument/* addInstrumentationHandler */.o)('dom', _domBreadcrumb(this._options.dom));
        }
        if (this._options.xhr) {
            (0,instrument/* addInstrumentationHandler */.o)('xhr', _xhrBreadcrumb);
        }
        if (this._options.fetch) {
            (0,instrument/* addInstrumentationHandler */.o)('fetch', _fetchBreadcrumb);
        }
        if (this._options.history) {
            (0,instrument/* addInstrumentationHandler */.o)('history', _historyBreadcrumb);
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') {
            keyAttrs = [keyAttrs];
        }
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? (0,browser/* htmlTreeAsString */.R)(handlerData.event.target, keyAttrs)
                : (0,browser/* htmlTreeAsString */.R)(handlerData.event, keyAttrs);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global,
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console',
        },
        level: severityFromString(handlerData.level),
        message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        }
        else {
            // Don't capture a breadcrumb for passed assertions
            return;
        }
    }
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level,
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) {
            return;
        }
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code,
            },
            type: 'http',
        }, {
            xhr: handlerData.xhr,
            input: body,
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) {
        return;
    }
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
        // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
    }
    if (handlerData.error) {
        (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: 'fetch',
            data: handlerData.fetchData,
            level: Severity.Error,
            type: 'http',
        }, {
            data: handlerData.error,
            input: handlerData.args,
        });
    }
    else {
        (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
            category: 'fetch',
            data: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, handlerData.fetchData), { status_code: handlerData.response.status }),
            type: 'http',
        }, {
            input: handlerData.args,
            response: handlerData.response,
        });
    }
}
/**
 * Creates breadcrumbs from history API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _historyBreadcrumb(handlerData) {
    var global = (0,esm_global/* getGlobalObject */.R)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0,misc/* parseUrl */.en)(global.location.href);
    var parsedFrom = (0,misc/* parseUrl */.en)(from);
    var parsedTo = (0,misc/* parseUrl */.en)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) {
        parsedFrom = parsedLoc;
    }
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
        to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
        from = parsedFrom.relative;
    }
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to,
        },
    });
}
//# sourceMappingURL=breadcrumbs.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/scope.js
var esm_scope = __webpack_require__(94421);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js




var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        (0,esm_scope/* addGlobalEventProcessor */.c)(function (event, hint) {
            var self = (0,esm_hub/* getCurrentHub */.Gd)().getIntegration(LinkedErrors);
            return self ? _handler(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

/**
 * @inheritDoc
 */
function _handler(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
        return event;
    }
    var linkedErrors = _walkErrorTree(limit, hint.originalException, key);
    event.exception.values = (0,tslib_es6/* __spread */.fl)(linkedErrors, event.exception.values);
    return event;
}
/**
 * JSDOC
 */
function _walkErrorTree(limit, error, key, stack) {
    if (stack === void 0) { stack = []; }
    if (!(0,is/* isInstanceOf */.V9)(error[key], Error) || stack.length + 1 >= limit) {
        return stack;
    }
    var exception = exceptionFromError(error[key]);
    return _walkErrorTree(limit, error[key], key, (0,tslib_es6/* __spread */.fl)([exception], stack));
}
//# sourceMappingURL=linkederrors.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/useragent.js



var useragent_global = (0,esm_global/* getGlobalObject */.R)();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        (0,esm_scope/* addGlobalEventProcessor */.c)(function (event) {
            if ((0,esm_hub/* getCurrentHub */.Gd)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!useragent_global.navigator && !useragent_global.location && !useragent_global.document) {
                    return event;
                }
                // grab as much info as exists and add it to the event
                var url = (event.request && event.request.url) || (useragent_global.location && useragent_global.location.href);
                var referrer = (useragent_global.document || {}).referrer;
                var userAgent = (useragent_global.navigator || {}).userAgent;
                var headers = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (event.request && event.request.headers)), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
                var request = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (url && { url: url })), { headers: headers });
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event), { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js


/** Deduplication filter */
var Dedupe = /** @class */ (function () {
    function Dedupe() {
        /**
         * @inheritDoc
         */
        this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */
    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if (dedupe_shouldDropEvent(currentEvent, self._previousEvent)) {
                        esm_flags_IS_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                }
                catch (_oO) {
                    return (self._previousEvent = currentEvent);
                }
                return (self._previousEvent = currentEvent);
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */
    Dedupe.id = 'Dedupe';
    return Dedupe;
}());

/** JSDoc */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) {
        return false;
    }
    if (_isSameMessageEvent(currentEvent, previousEvent)) {
        return true;
    }
    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
        return true;
    }
    return false;
}
/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) {
        return false;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
        return false;
    }
    if (currentMessage !== previousMessage) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) {
        return false;
    }
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) {
        return true;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
        return false;
    }
    currentFrames = currentFrames;
    previousFrames = previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) {
        return false;
    }
    // Otherwise, compare the two
    for (var i = 0; i < previousFrames.length; i++) {
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename ||
            frameA.lineno !== frameB.lineno ||
            frameA.colno !== frameB.colno ||
            frameA.function !== frameB.function) {
            return false;
        }
    }
    return true;
}
/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) {
        return true;
    }
    // If only one event has a fingerprint, but not the other one, they are not the same
    if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
        return false;
    }
    currentFingerprint = currentFingerprint;
    previousFingerprint = previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    }
    catch (_oO) {
        return false;
    }
}
/** JSDoc */
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */
function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        try {
            // @ts-ignore Object could be undefined
            return exception.values[0].stacktrace.frames;
        }
        catch (_oO) {
            return undefined;
        }
    }
    else if (event.stacktrace) {
        return event.stacktrace.frames;
    }
    return undefined;
}
//# sourceMappingURL=dedupe.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/index.js






//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/index.js






var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var _window = (0,esm_global/* getGlobalObject */.R)();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
var INTEGRATIONS = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, windowIntegrations), integrations_namespaceObject), esm_integrations_namespaceObject);

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/version.js
var SDK_VERSION = '6.19.7';
//# sourceMappingURL=version.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/sdk.js



/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        if (flags_IS_DEBUG_BUILD) {
            esm_logger/* logger.enable */.kg.enable();
        }
        else {
            // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        }
    }
    var hub = (0,esm_hub/* getCurrentHub */.Gd)();
    var scope = hub.getScope();
    if (scope) {
        scope.update(options.initialScope);
    }
    var client = new clientClass(options);
    hub.bindClient(client);
}
//# sourceMappingURL=sdk.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(26757);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integration.js




var installedIntegrations = [];
/**
 * @private
 */
function filterDuplicates(integrations) {
    return integrations.reduce(function (acc, integrations) {
        if (acc.every(function (accIntegration) { return integrations.name !== accIntegration.name; })) {
            acc.push(integrations);
        }
        return acc;
    }, []);
}
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && (0,tslib_es6/* __spread */.fl)(options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = (0,tslib_es6/* __spread */.fl)(filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) {
        // Filter out integrations that are also included in user options
        integrations = (0,tslib_es6/* __spread */.fl)(integrations.filter(function (integrations) {
            return userIntegrations.every(function (userIntegration) { return userIntegration.name !== integrations.name; });
        }), filterDuplicates(userIntegrations));
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) { return i.name; });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, (0,tslib_es6/* __spread */.fl)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(esm_scope/* addGlobalEventProcessor */.c, esm_hub/* getCurrentHub */.Gd);
    installedIntegrations.push(integration.name);
    flags_IS_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0,object/* addNonEnumerableProperty */.xp)(integrations, 'initialized', true);
    return integrations;
}
//# sourceMappingURL=integration.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/baseclient.js

/* eslint-disable max-lines */




var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Number of calls being processed */
        this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = makeDsn(options.dsn);
        }
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
            flags_IS_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0,is/* isPrimitive */.pt)(message)
            ? this._getBackend().eventFromMessage(String(message), level, hint)
            : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
            flags_IS_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureSession = function (session) {
        if (!this._isEnabled()) {
            flags_IS_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) {
            flags_IS_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
        }
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({ init: false });
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getTransport = function () {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function (clientFinished) {
            return _this.getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return clientFinished && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */
    BaseClient.prototype.setupIntegrations = function () {
        if (this._isEnabled() && !this._integrations.initialized) {
            this._integrations = setupIntegrations(this._options);
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            flags_IS_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */
    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for (var exceptions_1 = (0,tslib_es6/* __values */.XA)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);
        if (shouldUpdateAndSend) {
            session.update((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (crashed && { status: 'crashed' })), { errors: session.errors || Number(errored || crashed) }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */
    BaseClient.prototype._sendSession = function (session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */
    BaseClient.prototype._isClientDoneProcessing = function (timeout) {
        var _this = this;
        return new syncpromise/* SyncPromise */.cW(function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function () {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)()), timestamp: event.timestamp || (0,time/* dateTimestampInSeconds */.yW)() });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) {
            finalScope = esm_scope/* Scope.clone */.s.clone(finalScope).update(hint.captureContext);
        }
        // We prepare the result here with a resolved Event.
        var result = (0,syncpromise/* resolvedSyncPromise */.WD)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) {
            // In case we have a hub we reassign it.
            result = finalScope.applyToEvent(prepared, hint);
        }
        return result.then(function (evt) {
            if (evt) {
                // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
                // it is only attached as extra data to the event if the event somehow skips being normalized
                evt.sdkProcessingMetadata = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, evt.sdkProcessingMetadata), { normalizeDepth: normalize(normalizeDepth) + " (" + typeof normalizeDepth + ")" });
            }
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
                return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            }
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */
    BaseClient.prototype._normalizeEvent = function (event, depth, maxBreadth) {
        if (!event) {
            return null;
        }
        var normalized = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, event), (event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function (b) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, b), (b.data && {
                data: normalize(b.data, depth, maxBreadth),
            }))); }),
        })), (event.user && {
            user: normalize(event.user, depth, maxBreadth),
        })), (event.contexts && {
            contexts: normalize(event.contexts, depth, maxBreadth),
        })), (event.extra && {
            extra: normalize(event.extra, depth, maxBreadth),
        }));
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            normalized.contexts.trace = event.contexts.trace;
        }
        normalized.sdkProcessingMetadata = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, normalized.sdkProcessingMetadata), { baseClientNormalized: true });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */
    BaseClient.prototype._applyClientOptions = function (event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) {
            event.environment = 'environment' in options ? environment : 'production';
        }
        if (event.release === undefined && release !== undefined) {
            event.release = release;
        }
        if (event.dist === undefined && dist !== undefined) {
            event.dist = dist;
        }
        if (event.message) {
            event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
        }
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) {
            exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
        }
        var request = event.request;
        if (request && request.url) {
            request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
        }
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */
    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0,tslib_es6/* __spread */.fl)((event.sdk.integrations || []), integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */
    BaseClient.prototype._sendEvent = function (event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */
    BaseClient.prototype._captureEvent = function (event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function (finalEvent) {
            return finalEvent.event_id;
        }, function (reason) {
            flags_IS_DEBUG_BUILD && esm_logger/* logger.error */.kg.error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) {
                transport.recordLostEvent(outcome, category);
            }
        }
        if (!this._isEnabled()) {
            return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('SDK not enabled, will not capture event.'));
        }
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint)
            .then(function (prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new SentryError('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) {
                return prepared;
            }
            var beforeSendResult = beforeSend(prepared, hint);
            return _ensureBeforeSendRv(beforeSendResult);
        })
            .then(function (processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new SentryError('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) {
                _this._updateSessionFromEvent(session, processedEvent);
            }
            _this._sendEvent(processedEvent);
            return processedEvent;
        })
            .then(null, function (reason) {
            if (reason instanceof SentryError) {
                throw reason;
            }
            _this.captureException(reason, {
                data: {
                    __sentry__: true,
                },
                originalException: reason,
            });
            throw new SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */
    BaseClient.prototype._process = function (promise) {
        var _this = this;
        this._numProcessing += 1;
        void promise.then(function (value) {
            _this._numProcessing -= 1;
            return value;
        }, function (reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}());

/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */
function _ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0,is/* isThenable */.J8)(rv)) {
        return rv.then(function (event) {
            if (!((0,is/* isPlainObject */.PO)(event) || event === null)) {
                throw new SentryError(nullErr);
            }
            return event;
        }, function (e) {
            throw new SentryError("beforeSend rejected with " + e);
        });
    }
    else if (!((0,is/* isPlainObject */.PO)(rv) || rv === null)) {
        throw new SentryError(nullErr);
    }
    return rv;
}
//# sourceMappingURL=baseclient.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/envelope.js


/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items) {
    if (items === void 0) { items = []; }
    return [headers, items];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
    var _a = __read(envelope, 2), headers = _a[0], items = _a[1];
    return [headers, __spread(items, [newItem])];
}
/**
 * Get the type of the envelope. Grabs the type from the first envelope item.
 */
function getEnvelopeType(envelope) {
    var _a = (0,tslib_es6/* __read */.CR)(envelope, 2), _b = (0,tslib_es6/* __read */.CR)(_a[1], 1), _c = (0,tslib_es6/* __read */.CR)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
/**
 * Serializes an envelope into a string.
 */
function serializeEnvelope(envelope) {
    var _a = (0,tslib_es6/* __read */.CR)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function (acc, item) {
        var _a = (0,tslib_es6/* __read */.CR)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0,is/* isPrimitive */.pt)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}
//# sourceMappingURL=envelope.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/request.js



/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) {
        return;
    }
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return { name: name, version: version };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) {
        return event;
    }
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0,tslib_es6/* __spread */.fl)((event.sdk.integrations || []), (sdkInfo.integrations || []));
    event.sdk.packages = (0,tslib_es6/* __spread */.fl)((event.sdk.packages || []), (sdkInfo.packages || []));
    return event;
}
/** Creates an envelope from a Session */
function createSessionEnvelope(session, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: dsnToString(api.dsn) }));
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [{ type: type }, session];
    var envelope = createEnvelope(envelopeHeaders, [envelopeItem]);
    return [envelope, type];
}
/** Creates a SentryRequest from a Session. */
function sessionToSentryRequest(session, api) {
    var _a = (0,tslib_es6/* __read */.CR)(createSessionEnvelope(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: serializeEnvelope(envelope),
        type: type,
        url: getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel),
    };
}
/**
 * Create an Envelope from an event. Note that this is duplicated from below,
 * but on purpose as this will be refactored in v7.
 */
function createEventEnvelope(event, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: dsnToString(api.dsn) }));
    var eventItem = [
        {
            type: eventType,
            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
        },
        event,
    ];
    return createEnvelope(envelopeHeaders, [eventItem]);
}
/** Creates a SentryRequest from an event. */
function eventToSentryRequest(event, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    }
    catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify(normalize(event));
        }
        catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: { message: innerErr.message, stack: innerErr.stack },
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope
            ? getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel)
            : getStoreEndpointWithUrlEncodedAuth(api.dsn),
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: dsnToString(api.dsn) }));
        var eventItem = [
            {
                type: eventType,
                sample_rates: [{ id: samplingMethod, rate: sampleRate }],
            },
            req.body,
        ];
        var envelope = createEnvelope(envelopeHeaders, [eventItem]);
        req.body = serializeEnvelope(envelope);
    }
    return req;
}
//# sourceMappingURL=request.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/noop.js

/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return (0,syncpromise/* resolvedSyncPromise */.WD)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped',
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    };
    return NoopTransport;
}());

//# sourceMappingURL=noop.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/basebackend.js






/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            flags_IS_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new SentryError('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new SentryError('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport &&
            this._options.dsn &&
            this._options._experiments &&
            this._options._experiments.newTransport) {
            var api = initAPIDetails(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = createEventEnvelope(event, api);
            void this._newTransport.send(env).then(null, function (reason) {
                flags_IS_DEBUG_BUILD && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
            });
        }
        else {
            void this._transport.sendEvent(event).then(null, function (reason) {
                flags_IS_DEBUG_BUILD && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
            });
        }
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendSession = function (session) {
        if (!this._transport.sendSession) {
            flags_IS_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport &&
            this._options.dsn &&
            this._options._experiments &&
            this._options._experiments.newTransport) {
            var api = initAPIDetails(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0,tslib_es6/* __read */.CR)(createSessionEnvelope(session, api), 1), env = _a[0];
            void this._newTransport.send(env).then(null, function (reason) {
                flags_IS_DEBUG_BUILD && esm_logger/* logger.error */.kg.error('Error while sending session:', reason);
            });
        }
        else {
            void this._transport.sendSession(session).then(null, function (reason) {
                flags_IS_DEBUG_BUILD && esm_logger/* logger.error */.kg.error('Error while sending session:', reason);
            });
        }
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new NoopTransport();
    };
    return BaseBackend;
}());

//# sourceMappingURL=basebackend.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(66946);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/promisebuffer.js


/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */
    function add(taskProducer) {
        if (!isReady()) {
            return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise due to buffer limit reached.'));
        }
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) {
            buffer.push(task);
        }
        void task
            .then(function () { return remove(task); })
            // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
            // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
            // have promises, so TS has to polyfill when down-compiling.)
            .then(null, function () {
            return remove(task).then(null, function () {
                // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */
    function drain(timeout) {
        return new syncpromise/* SyncPromise */.cW(function (resolve, reject) {
            var counter = buffer.length;
            if (!counter) {
                return resolve(true);
            }
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function (item) {
                void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(function () {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain,
    };
}
//# sourceMappingURL=promisebuffer.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js

var DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now) {
    if (now === void 0) { now = Date.now(); }
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return DEFAULT_RETRY_AFTER;
}
/**
 * Gets the time that given category is disabled until for rate limiting
 */
function disabledUntil(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now) {
    if (now === void 0) { now = Date.now(); }
    return disabledUntil(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 * Returns true if headers contains a non-empty rate limiting header.
 */
function updateRateLimits(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) { now = Date.now(); }
    var updatedRateLimits = (0,tslib_es6/* __assign */.pi)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) {
        try {
            /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */
            for (var _c = (0,tslib_es6/* __values */.XA)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
                var limit = _d.value;
                var parameters = limit.split(':', 2);
                var headerDelay = parseInt(parameters[0], 10);
                var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
                if (!parameters[1]) {
                    updatedRateLimits.all = now + delay;
                }
                else {
                    try {
                        for (var _e = (e_2 = void 0, (0,tslib_es6/* __values */.XA)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var category = _f.value;
                            updatedRateLimits[category] = now + delay;
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    else if (retryAfterHeader) {
        updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
    }
    return updatedRateLimits;
}
//# sourceMappingURL=ratelimit.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/status.js
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */
function eventStatusFromHttpCode(code) {
    if (code >= 200 && code < 300) {
        return 'success';
    }
    if (code === 429) {
        return 'rate_limit';
    }
    if (code >= 400 && code < 500) {
        return 'invalid';
    }
    if (code >= 500) {
        return 'failed';
    }
    return 'unknown';
}
//# sourceMappingURL=status.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/base.js

var ERROR_TRANSPORT_CATEGORY = 'error';
var TRANSACTION_TRANSPORT_CATEGORY = 'transaction';
var ATTACHMENT_TRANSPORT_CATEGORY = 'attachment';
var SESSION_TRANSPORT_CATEGORY = 'session';
var DEFAULT_TRANSPORT_BUFFER_SIZE = 30;
/**
 * Creates a `NewTransport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(options, makeRequest, buffer) {
    if (buffer === void 0) { buffer = makePromiseBuffer(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE); }
    var rateLimits = {};
    var flush = function (timeout) { return buffer.drain(timeout); };
    function send(envelope) {
        var envCategory = getEnvelopeType(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: serializeEnvelope(envelope),
        };
        // Don't add to buffer if transport is already rate-limited
        if (isRateLimited(rateLimits, category)) {
            return (0,syncpromise/* rejectedSyncPromise */.$2)({
                status: 'rate_limit',
                reason: getRateLimitReason(rateLimits, category),
            });
        }
        var requestTask = function () {
            return makeRequest(request).then(function (_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = eventStatusFromHttpCode(statusCode);
                if (headers) {
                    rateLimits = updateRateLimits(rateLimits, headers);
                }
                if (status === 'success') {
                    return (0,syncpromise/* resolvedSyncPromise */.WD)({ status: status, reason: reason });
                }
                return (0,syncpromise/* rejectedSyncPromise */.$2)({
                    status: status,
                    reason: reason ||
                        body ||
                        (status === 'rate_limit' ? getRateLimitReason(rateLimits, category) : 'Unknown transport error'),
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush,
    };
}
function getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date(disabledUntil(rateLimits, category)).toISOString();
}
//# sourceMappingURL=base.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/async.js
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forget(promise) {
    void promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}
//# sourceMappingURL=async.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/utils.js


var utils_global = (0,esm_global/* getGlobalObject */.R)();
var cachedFetchImpl;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
    if (cachedFetchImpl) {
        return cachedFetchImpl;
    }
    /* eslint-disable @typescript-eslint/unbound-method */
    // Fast path to avoid DOM I/O
    if ((0,supports/* isNativeFetch */.Du)(utils_global.fetch)) {
        return (cachedFetchImpl = utils_global.fetch.bind(utils_global));
    }
    var document = utils_global.document;
    var fetchImpl = utils_global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') {
        try {
            var sandbox = document.createElement('iframe');
            sandbox.hidden = true;
            document.head.appendChild(sandbox);
            var contentWindow = sandbox.contentWindow;
            if (contentWindow && contentWindow.fetch) {
                fetchImpl = contentWindow.fetch;
            }
            document.head.removeChild(sandbox);
        }
        catch (e) {
            esm_flags_IS_DEBUG_BUILD &&
                esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
        }
    }
    return (cachedFetchImpl = fetchImpl.bind(utils_global));
    /* eslint-enable @typescript-eslint/unbound-method */
}
/**
 * Sends sdk client report using sendBeacon or fetch as a fallback if available
 *
 * @param url report endpoint
 * @param body report payload
 */
function sendReport(url, body) {
    var isRealNavigator = Object.prototype.toString.call(utils_global && utils_global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof utils_global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = utils_global.navigator.sendBeacon.bind(utils_global.navigator);
        return sendBeacon(url, body);
    }
    if ((0,supports/* supportsFetch */.Ak)()) {
        var fetch_1 = getNativeFetchImplementation();
        return forget(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true,
        }));
    }
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/new-fetch.js



/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeNewFetchTransport(options, nativeFetch) {
    if (nativeFetch === void 0) { nativeFetch = getNativeFetchImplementation(); }
    function makeRequest(request) {
        var requestOptions = (0,tslib_es6/* __assign */.pi)({ body: request.body, method: 'POST', referrerPolicy: 'origin' }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function (response) {
            return response.text().then(function (body) { return ({
                body: body,
                headers: {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After'),
                },
                reason: response.statusText,
                statusCode: response.status,
            }); });
        });
    }
    return createTransport({ bufferSize: options.bufferSize }, makeRequest);
}
//# sourceMappingURL=new-fetch.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/clientreport.js


/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        { type: 'client_report' },
        {
            timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
            discarded_events: discarded_events,
        },
    ];
    return createEnvelope(dsn ? { dsn: dsn } : {}, [clientReportItem]);
}
//# sourceMappingURL=clientreport.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/base.js





function requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var base_global = (0,esm_global/* getGlobalObject */.R)();
/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = makePromiseBuffer(30);
        /** Locks transport after receiving rate limits in a response */
        this._rateLimits = {};
        this._outcomes = {};
        this._api = initAPIDetails(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = getStoreEndpointWithUrlEncodedAuth(this._api.dsn);
        if (this.options.sendClientReports && base_global.document) {
            base_global.document.addEventListener('visibilitychange', function () {
                if (base_global.document.visibilityState === 'hidden') {
                    _this._flushOutcomes();
                }
            });
        }
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (event) {
        return this._sendRequest(eventToSentryRequest(event, this._api), event);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendSession = function (session) {
        return this._sendRequest(sessionToSentryRequest(session, this._api), session);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.recordLostEvent = function (reason, category) {
        var _a;
        if (!this.options.sendClientReports) {
            return;
        }
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = requestTypeToCategory(category) + ":" + reason;
        esm_flags_IS_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], (_a !== null && _a !== void 0 ? _a : 0)) + 1;
    };
    /**
     * Send outcomes as an envelope
     */
    BaseTransport.prototype._flushOutcomes = function () {
        if (!this.options.sendClientReports) {
            return;
        }
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            esm_flags_IS_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('No outcomes to flush');
            return;
        }
        esm_flags_IS_DEBUG_BUILD && esm_logger/* logger.log */.kg.log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = getEnvelopeEndpointWithUrlEncodedAuth(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function (key) {
            var _a = (0,tslib_es6/* __read */.CR)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key],
            };
            // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = createClientReportEnvelope(discardedEvents, this._api.tunnel && dsnToString(this._api.dsn));
        try {
            sendReport(url, serializeEnvelope(envelope));
        }
        catch (e) {
            esm_flags_IS_DEBUG_BUILD && esm_logger/* logger.error */.kg.error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */
    BaseTransport.prototype._handleResponse = function (_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = eventStatusFromHttpCode(response.status);
        this._rateLimits = updateRateLimits(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) {
            esm_flags_IS_DEBUG_BUILD &&
                // eslint-disable-next-line deprecation/deprecation
                esm_logger/* logger.warn */.kg.warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        }
        if (status === 'success') {
            resolve({ status: status });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */
    BaseTransport.prototype._disabledUntil = function (requestType) {
        var category = requestTypeToCategory(requestType);
        return new Date(disabledUntil(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */
    BaseTransport.prototype._isRateLimited = function (requestType) {
        var category = requestTypeToCategory(requestType);
        return isRateLimited(this._rateLimits, category);
    };
    return BaseTransport;
}());

//# sourceMappingURL=base.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js




/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) { fetchImpl = getNativeFetchImplementation(); }
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: ((0,supports/* supportsReferrerPolicy */.hv)() ? 'origin' : ''),
        };
        if (this.options.fetchParameters !== undefined) {
            Object.assign(options, this.options.fetchParameters);
        }
        if (this.options.headers !== undefined) {
            options.headers = this.options.headers;
        }
        return this._buffer
            .add(function () {
            return new syncpromise/* SyncPromise */.cW(function (resolve, reject) {
                void _this._fetch(sentryRequest.url, options)
                    .then(function (response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After'),
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject,
                    });
                })
                    .catch(reject);
            });
        })
            .then(undefined, function (reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof SentryError) {
                _this.recordLostEvent('queue_overflow', sentryRequest.type);
            }
            else {
                _this.recordLostEvent('network_error', sentryRequest.type);
            }
            throw reason;
        });
    };
    return FetchTransport;
}(BaseTransport));

//# sourceMappingURL=fetch.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/new-xhr.js


/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
var XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeNewXHRTransport(options) {
    function makeRequest(request) {
        return new syncpromise/* SyncPromise */.cW(function (resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After'),
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status,
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for (var header in options.headers) {
                if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
                    xhr.setRequestHeader(header, options.headers[header]);
                }
            }
            xhr.send(request.body);
        });
    }
    return createTransport({ bufferSize: options.bufferSize }, makeRequest);
}
//# sourceMappingURL=new-xhr.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js



/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        return this._buffer
            .add(function () {
            return new syncpromise/* SyncPromise */.cW(function (resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function () {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After'),
                        };
                        _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
                    }
                };
                request.open('POST', sentryRequest.url);
                for (var header in _this.options.headers) {
                    if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) {
                        request.setRequestHeader(header, _this.options.headers[header]);
                    }
                }
                request.send(sentryRequest.body);
            });
        })
            .then(undefined, function (reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof SentryError) {
                _this.recordLostEvent('queue_overflow', sentryRequest.type);
            }
            else {
                _this.recordLostEvent('network_error', sentryRequest.type);
            }
            throw reason;
        });
    };
    return XHRTransport;
}(BaseTransport));

//# sourceMappingURL=xhr.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/backend.js






/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        return eventFromException(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = Severity.Info; }
        return eventFromMessage(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this._options.transportOptions), { dsn: this._options.dsn, tunnel: this._options.tunnel, sendClientReports: this._options.sendClientReports, _metadata: this._options._metadata });
        var api = initAPIDetails(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel);
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if ((0,supports/* supportsFetch */.Ak)()) {
            var requestOptions = (0,tslib_es6/* __assign */.pi)({}, transportOptions.fetchParameters);
            this._newTransport = makeNewFetchTransport({ requestOptions: requestOptions, url: url });
            return new FetchTransport(transportOptions);
        }
        this._newTransport = makeNewXHRTransport({
            url: url,
            headers: transportOptions.headers,
        });
        return new XHRTransport(transportOptions);
    };
    return BrowserBackend;
}(BaseBackend));

//# sourceMappingURL=backend.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/client.js







/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: SDK_VERSION,
                },
            ],
            version: SDK_VERSION,
        };
        _this = _super.call(this, BrowserBackend, options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = (0,esm_global/* getGlobalObject */.R)().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            esm_flags_IS_DEBUG_BUILD && esm_logger/* logger.error */.kg.error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        injectReportDialog((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { dsn: options.dsn || this.getDsn() }));
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._sendEvent = function (event) {
        var integration = this.getIntegration(Breadcrumbs);
        if (integration) {
            integration.addSentryBreadcrumb(event);
        }
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}(BaseClient));

//# sourceMappingURL=client.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/sdk.js







var defaultIntegrations = [
    new InboundFilters(),
    new FunctionToString(),
    new TryCatch(),
    new Breadcrumbs(),
    new GlobalHandlers(),
    new LinkedErrors(),
    new Dedupe(),
    new UserAgent(),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = (0,esm_global/* getGlobalObject */.R)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    if (options.autoSessionTracking === undefined) {
        options.autoSessionTracking = true;
    }
    if (options.sendClientReports === undefined) {
        options.sendClientReports = true;
    }
    initAndBind(BrowserClient, options);
    if (options.autoSessionTracking) {
        startSessionTracking();
    }
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    var hub = getCurrentHub();
    var scope = hub.getScope();
    if (scope) {
        options.user = __assign(__assign({}, scope.getUser()), options.user);
    }
    if (!options.eventId) {
        options.eventId = hub.lastEventId();
    }
    var client = hub.getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return getCurrentHub().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
    var client = getCurrentHub().getClient();
    if (client) {
        return client.flush(timeout);
    }
    IS_DEBUG_BUILD && logger.warn('Cannot flush events. No client defined.');
    return resolvedSyncPromise(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
    var client = getCurrentHub().getClient();
    if (client) {
        return client.close(timeout);
    }
    IS_DEBUG_BUILD && logger.warn('Cannot flush events and disable SDK. No client defined.');
    return resolvedSyncPromise(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
    return internalWrap(fn)();
}
function startSessionOnHub(hub) {
    hub.startSession({ ignoreDuration: true });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
    var window = (0,esm_global/* getGlobalObject */.R)();
    var document = window.document;
    if (typeof document === 'undefined') {
        esm_flags_IS_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0,esm_hub/* getCurrentHub */.Gd)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) {
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0,instrument/* addInstrumentationHandler */.o)('history', function (_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) {
            startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
        }
    });
}
//# sourceMappingURL=sdk.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/sdk.js

/**
 * Inits the React SDK
 */
function sdk_init(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
        name: 'sentry.javascript.react',
        packages: [
            {
                name: 'npm:@sentry/react',
                version: SDK_VERSION,
            },
        ],
        version: SDK_VERSION,
    };
    init(options);
}
//# sourceMappingURL=sdk.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(86208);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/flags.js
var esm_flags = __webpack_require__(72354);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(85253);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(10351);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/tracing.js
var TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$');
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
    var matches = traceparent.match(TRACEPARENT_REGEXP);
    if (matches) {
        var parentSampled = void 0;
        if (matches[3] === '1') {
            parentSampled = true;
        }
        else if (matches[3] === '0') {
            parentSampled = false;
        }
        return {
            traceId: matches[1],
            parentSampled: parentSampled,
            parentSpanId: matches[2],
        };
    }
    return undefined;
}
//# sourceMappingURL=tracing.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/constants.js
var constants = __webpack_require__(16416);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/backgroundtab.js




var backgroundtab_global = (0,esm_global/* getGlobalObject */.R)();
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
    if (backgroundtab_global && backgroundtab_global.document) {
        backgroundtab_global.document.addEventListener('visibilitychange', function () {
            var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
            if (backgroundtab_global.document.hidden && activeTransaction) {
                var statusType = 'cancelled';
                esm_flags/* IS_DEBUG_BUILD */.h &&
                    esm_logger/* logger.log */.kg.log("[Tracing] Transaction: " + statusType + " -> since tab moved to the background, op: " + activeTransaction.op);
                // We should not set status if it is already set, this prevent important statuses like
                // error or data loss from being overwritten on transaction.
                if (!activeTransaction.status) {
                    activeTransaction.setStatus(statusType);
                }
                activeTransaction.setTag('visibilitychange', 'document.hidden');
                activeTransaction.setTag(constants/* FINISH_REASON_TAG */.d, constants/* IDLE_TRANSACTION_FINISH_REASONS.2 */.x[2]);
                activeTransaction.finish();
            }
        });
    }
    else {
        esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
    }
}
//# sourceMappingURL=backgroundtab.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(88090);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/bindReporter.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var bindReporter = function (callback, metric, reportAllChanges) {
    var prevValue;
    return function (forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                metric.delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (metric.delta || prevValue === undefined) {
                    prevValue = metric.value;
                    callback(metric);
                }
            }
        }
    };
};
//# sourceMappingURL=bindReporter.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
var generateUniqueID = function () {
    return "v2-" + Date.now() + "-" + (Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};
//# sourceMappingURL=generateUniqueID.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/initMetric.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var initMetric = function (name, value) {
    return {
        name: name,
        value: (value !== null && value !== void 0 ? value : -1),
        delta: 0,
        entries: [],
        id: generateUniqueID(),
    };
};
//# sourceMappingURL=initMetric.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/observe.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
var observe = function (type, callback) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            // More extensive feature detect needed for Firefox due to:
            // https://github.com/GoogleChrome/web-vitals/issues/142
            if (type === 'first-input' && !('PerformanceEventTiming' in self)) {
                return;
            }
            var po = new PerformanceObserver(function (l) { return l.getEntries().map(callback); });
            po.observe({ type: type, buffered: true });
            return po;
        }
    }
    catch (e) {
        // Do nothing.
    }
    return;
};
//# sourceMappingURL=observe.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/onHidden.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var onHidden = function (cb, once) {
    var onHiddenOrPageHide = function (event) {
        if (event.type === 'pagehide' || (0,esm_global/* getGlobalObject */.R)().document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
};
//# sourceMappingURL=onHidden.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getCLS.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var getCLS = function (onReport, reportAllChanges) {
    var metric = initMetric('CLS', 0);
    var report;
    var sessionValue = 0;
    var sessionEntries = [];
    var entryHandler = function (entry) {
        // Only count layout shifts without recent user input.
        // TODO: Figure out why entry can be undefined
        if (entry && !entry.hadRecentInput) {
            var firstSessionEntry = sessionEntries[0];
            var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
            // If the entry occurred less than 1 second after the previous entry and
            // less than 5 seconds after the first entry in the session, include the
            // entry in the current session. Otherwise, start a new session.
            if (sessionValue &&
                sessionEntries.length !== 0 &&
                entry.startTime - lastSessionEntry.startTime < 1000 &&
                entry.startTime - firstSessionEntry.startTime < 5000) {
                sessionValue += entry.value;
                sessionEntries.push(entry);
            }
            else {
                sessionValue = entry.value;
                sessionEntries = [entry];
            }
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                if (report) {
                    report();
                }
            }
        }
    };
    var po = observe('layout-shift', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        onHidden(function () {
            po.takeRecords().map(entryHandler);
            report(true);
        });
    }
};
//# sourceMappingURL=getCLS.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var firstHiddenTime = -1;
var initHiddenTime = function () {
    return (0,esm_global/* getGlobalObject */.R)().document.visibilityState === 'hidden' ? 0 : Infinity;
};
var trackChanges = function () {
    // Update the time if/when the document becomes hidden.
    onHidden(function (_a) {
        var timeStamp = _a.timeStamp;
        firstHiddenTime = timeStamp;
    }, true);
};
var getVisibilityWatcher = function () {
    if (firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        firstHiddenTime = initHiddenTime();
        trackChanges();
    }
    return {
        get firstHiddenTime() {
            return firstHiddenTime;
        },
    };
};
//# sourceMappingURL=getVisibilityWatcher.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getFID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var getFID = function (onReport, reportAllChanges) {
    var visibilityWatcher = getVisibilityWatcher();
    var metric = initMetric('FID');
    var report;
    var entryHandler = function (entry) {
        // Only report if the page wasn't hidden prior to the first input.
        if (report && entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    var po = observe('first-input', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        onHidden(function () {
            po.takeRecords().map(entryHandler);
            po.disconnect();
        }, true);
    }
};
//# sourceMappingURL=getFID.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getLCP.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var reportedMetricIDs = {};
var getLCP = function (onReport, reportAllChanges) {
    var visibilityWatcher = getVisibilityWatcher();
    var metric = initMetric('LCP');
    var report;
    var entryHandler = function (entry) {
        // The startTime attribute returns the value of the renderTime if it is not 0,
        // and the value of the loadTime otherwise.
        var value = entry.startTime;
        // If the page was hidden prior to paint time of the entry,
        // ignore it and mark the metric as final, otherwise add the entry.
        if (value < visibilityWatcher.firstHiddenTime) {
            metric.value = value;
            metric.entries.push(entry);
        }
        if (report) {
            report();
        }
    };
    var po = observe('largest-contentful-paint', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        var stopListening_1 = function () {
            if (!reportedMetricIDs[metric.id]) {
                po.takeRecords().map(entryHandler);
                po.disconnect();
                reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        ['keydown', 'click'].forEach(function (type) {
            addEventListener(type, stopListening_1, { once: true, capture: true });
        });
        onHidden(stopListening_1, true);
    }
};
//# sourceMappingURL=getLCP.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/metrics.js








var metrics_global = (0,esm_global/* getGlobalObject */.R)();
/** Class tracking metrics  */
var MetricsInstrumentation = /** @class */ (function () {
    function MetricsInstrumentation(_reportAllChanges) {
        if (_reportAllChanges === void 0) { _reportAllChanges = false; }
        this._reportAllChanges = _reportAllChanges;
        this._measurements = {};
        this._performanceCursor = 0;
        if (!(0,node/* isNodeEnv */.KV)() && metrics_global && metrics_global.performance && metrics_global.document) {
            if (metrics_global.performance.mark) {
                metrics_global.performance.mark('sentry-tracing-init');
            }
            this._trackCLS();
            this._trackLCP();
            this._trackFID();
        }
    }
    /** Add performance related spans to a transaction */
    MetricsInstrumentation.prototype.addPerformanceEntries = function (transaction) {
        var _this = this;
        if (!metrics_global || !metrics_global.performance || !metrics_global.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
            // Gatekeeper if performance API not available
            return;
        }
        esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
        var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
        var responseStartTimestamp;
        var requestStartTimestamp;
        metrics_global.performance
            .getEntries()
            .slice(this._performanceCursor)
            .forEach(function (entry) {
            var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
            var duration = (0,utils/* msToSec */.XL)(entry.duration);
            if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
                return;
            }
            switch (entry.entryType) {
                case 'navigation': {
                    addNavigationSpans(transaction, entry, timeOrigin);
                    responseStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart);
                    requestStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart);
                    break;
                }
                case 'mark':
                case 'paint':
                case 'measure': {
                    var startTimestamp = addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    var firstHidden = getVisibilityWatcher();
                    // Only report if the page wasn't hidden prior to the web vital.
                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log('[Measurements] Adding FP');
                        _this._measurements['fp'] = { value: entry.startTime };
                        _this._measurements['mark.fp'] = { value: startTimestamp };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log('[Measurements] Adding FCP');
                        _this._measurements['fcp'] = { value: entry.startTime };
                        _this._measurements['mark.fcp'] = { value: startTimestamp };
                    }
                    break;
                }
                case 'resource': {
                    var resourceName = entry.name.replace(metrics_global.location.origin, '');
                    addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
                default:
                // Ignore other entry types.
            }
        });
        this._performanceCursor = Math.max(performance.getEntries().length - 1, 0);
        this._trackNavigator(transaction);
        // Measurements are only available for pageload transactions
        if (transaction.op === 'pageload') {
            // normalize applicable web vital values to be relative to transaction.startTimestamp
            var timeOrigin_1 = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
            // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
            // start of the response in milliseconds
            if (typeof responseStartTimestamp === 'number') {
                esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
                this._measurements['ttfb'] = { value: (responseStartTimestamp - transaction.startTimestamp) * 1000 };
                if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
                    // Capture the time spent making the request and receiving the first byte of the response.
                    // This is the time between the start of the request and the start of the response in milliseconds.
                    this._measurements['ttfb.requestTime'] = { value: (responseStartTimestamp - requestStartTimestamp) * 1000 };
                }
            }
            ['fcp', 'fp', 'lcp'].forEach(function (name) {
                if (!_this._measurements[name] || timeOrigin_1 >= transaction.startTimestamp) {
                    return;
                }
                // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
                // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
                // to be adjusted to be relative to transaction.startTimestamp.
                var oldValue = _this._measurements[name].value;
                var measurementTimestamp = timeOrigin_1 + (0,utils/* msToSec */.XL)(oldValue);
                // normalizedValue should be in milliseconds
                var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
                var delta = normalizedValue - oldValue;
                esm_flags/* IS_DEBUG_BUILD */.h &&
                    esm_logger/* logger.log */.kg.log("[Measurements] Normalized " + name + " from " + oldValue + " to " + normalizedValue + " (" + delta + ")");
                _this._measurements[name].value = normalizedValue;
            });
            if (this._measurements['mark.fid'] && this._measurements['fid']) {
                // create span for FID
                _startChild(transaction, {
                    description: 'first input delay',
                    endTimestamp: this._measurements['mark.fid'].value + (0,utils/* msToSec */.XL)(this._measurements['fid'].value),
                    op: 'web.vitals',
                    startTimestamp: this._measurements['mark.fid'].value,
                });
            }
            // If FCP is not recorded we should not record the cls value
            // according to the new definition of CLS.
            if (!('fcp' in this._measurements)) {
                delete this._measurements.cls;
            }
            transaction.setMeasurements(this._measurements);
            tagMetricInfo(transaction, this._lcpEntry, this._clsEntry);
            transaction.setTag('sentry_reportAllChanges', this._reportAllChanges);
        }
    };
    /**
     * Capture the information of the user agent.
     */
    MetricsInstrumentation.prototype._trackNavigator = function (transaction) {
        var navigator = metrics_global.navigator;
        if (!navigator) {
            return;
        }
        // track network connectivity
        var connection = navigator.connection;
        if (connection) {
            if (connection.effectiveType) {
                transaction.setTag('effectiveConnectionType', connection.effectiveType);
            }
            if (connection.type) {
                transaction.setTag('connectionType', connection.type);
            }
            if (isMeasurementValue(connection.rtt)) {
                this._measurements['connection.rtt'] = { value: connection.rtt };
            }
            if (isMeasurementValue(connection.downlink)) {
                this._measurements['connection.downlink'] = { value: connection.downlink };
            }
        }
        if (isMeasurementValue(navigator.deviceMemory)) {
            transaction.setTag('deviceMemory', String(navigator.deviceMemory));
        }
        if (isMeasurementValue(navigator.hardwareConcurrency)) {
            transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
        }
    };
    /** Starts tracking the Cumulative Layout Shift on the current page. */
    MetricsInstrumentation.prototype._trackCLS = function () {
        var _this = this;
        // See:
        // https://web.dev/evolving-cls/
        // https://web.dev/cls-web-tooling/
        getCLS(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS');
            _this._measurements['cls'] = { value: metric.value };
            _this._clsEntry = entry;
        });
    };
    /** Starts tracking the Largest Contentful Paint on the current page. */
    MetricsInstrumentation.prototype._trackLCP = function () {
        var _this = this;
        getLCP(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
            var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
            esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP');
            _this._measurements['lcp'] = { value: metric.value };
            _this._measurements['mark.lcp'] = { value: timeOrigin + startTime };
            _this._lcpEntry = entry;
        }, this._reportAllChanges);
    };
    /** Starts tracking the First Input Delay on the current page. */
    MetricsInstrumentation.prototype._trackFID = function () {
        var _this = this;
        getFID(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);
            var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
            esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log('[Measurements] Adding FID');
            _this._measurements['fid'] = { value: metric.value };
            _this._measurements['mark.fid'] = { value: timeOrigin + startTime };
        });
    };
    return MetricsInstrumentation;
}());

/** Instrument navigation entries */
function addNavigationSpans(transaction, entry, timeOrigin) {
    ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(function (event) {
        addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    addRequest(transaction, entry, timeOrigin);
}
/** Create measure related spans */
function addMeasureSpans(transaction, entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    _startChild(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp,
    });
    return measureStartTimestamp;
}
/** Create resource-related spans */
function addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
        return;
    }
    var data = {};
    if ('transferSize' in entry) {
        data['Transfer Size'] = entry.transferSize;
    }
    if ('encodedBodySize' in entry) {
        data['Encoded Body Size'] = entry.encodedBodySize;
    }
    if ('decodedBodySize' in entry) {
        data['Decoded Body Size'] = entry.decodedBodySize;
    }
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    _startChild(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? "resource." + entry.initiatorType : 'resource',
        startTimestamp: startTimestamp,
        data: data,
    });
}
/** Create performance navigation related spans */
function addPerformanceNavigationTiming(transaction, entry, event, timeOrigin, description, eventEnd) {
    var end = eventEnd ? entry[eventEnd] : entry[event + "End"];
    var start = entry[event + "Start"];
    if (!start || !end) {
        return;
    }
    _startChild(transaction, {
        op: 'browser',
        description: (description !== null && description !== void 0 ? description : event),
        startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(start),
        endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(end),
    });
}
/** Create request and response related spans */
function addRequest(transaction, entry, timeOrigin) {
    _startChild(transaction, {
        op: 'browser',
        description: 'request',
        startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart),
        endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd),
    });
    _startChild(transaction, {
        op: 'browser',
        description: 'response',
        startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart),
        endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd),
    });
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, _a) {
    var startTimestamp = _a.startTimestamp, ctx = (0,tslib_es6/* __rest */._T)(_a, ["startTimestamp"]);
    if (startTimestamp && transaction.startTimestamp > startTimestamp) {
        transaction.startTimestamp = startTimestamp;
    }
    return transaction.startChild((0,tslib_es6/* __assign */.pi)({ startTimestamp: startTimestamp }, ctx));
}
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
    return typeof value === 'number' && isFinite(value);
}
/** Add LCP / CLS data to transaction to allow debugging */
function tagMetricInfo(transaction, lcpEntry, clsEntry) {
    if (lcpEntry) {
        esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if (lcpEntry.element) {
            transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.R)(lcpEntry.element));
        }
        if (lcpEntry.id) {
            transaction.setTag('lcp.id', lcpEntry.id);
        }
        if (lcpEntry.url) {
            // Trim URL to the first 200 characters.
            transaction.setTag('lcp.url', lcpEntry.url.trim().slice(0, 200));
        }
        transaction.setTag('lcp.size', lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if (clsEntry && clsEntry.sources) {
        esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
        clsEntry.sources.forEach(function (source, index) {
            return transaction.setTag("cls.source." + (index + 1), (0,browser/* htmlTreeAsString */.R)(source.node));
        });
    }
}
//# sourceMappingURL=metrics.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/request.js



var DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];
var defaultRequestInstrumentationOptions = {
    traceFetch: true,
    traceXHR: true,
    tracingOrigins: DEFAULT_TRACING_ORIGINS,
};
/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var _a = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaultRequestInstrumentationOptions), _options), traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
    // We should cache url -> decision so that we don't have to compute
    // regexp everytime we create a request.
    var urlMap = {};
    var defaultShouldCreateSpan = function (url) {
        if (urlMap[url]) {
            return urlMap[url];
        }
        var origins = tracingOrigins;
        urlMap[url] =
            origins.some(function (origin) { return (0,string/* isMatchingPattern */.zC)(url, origin); }) &&
                !(0,string/* isMatchingPattern */.zC)(url, 'sentry_key');
        return urlMap[url];
    };
    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
    // That's why we filter out already unwanted Spans from tracingOrigins
    var shouldCreateSpan = defaultShouldCreateSpan;
    if (typeof shouldCreateSpanForRequest === 'function') {
        shouldCreateSpan = function (url) {
            return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
        };
    }
    var spans = {};
    if (traceFetch) {
        (0,instrument/* addInstrumentationHandler */.o)('fetch', function (handlerData) {
            fetchCallback(handlerData, shouldCreateSpan, spans);
        });
    }
    if (traceXHR) {
        (0,instrument/* addInstrumentationHandler */.o)('xhr', function (handlerData) {
            xhrCallback(handlerData, shouldCreateSpan, spans);
        });
    }
}
/**
 * Create and track fetch request spans
 */
function fetchCallback(handlerData, shouldCreateSpan, spans) {
    if (!(0,utils/* hasTracingEnabled */.zu)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
        return;
    }
    if (handlerData.endTimestamp) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId)
            return;
        var span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                // TODO (kmclb) remove this once types PR goes through
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                span.setHttpStatus(handlerData.response.status);
            }
            else if (handlerData.error) {
                span.setStatus('internal_error');
            }
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, handlerData.fetchData), { type: 'fetch' }),
            description: handlerData.fetchData.method + " " + handlerData.fetchData.url,
            op: 'http.client',
        });
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
        var request = (handlerData.args[0] = handlerData.args[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var options = (handlerData.args[1] = handlerData.args[1] || {});
        var headers = options.headers;
        if ((0,is/* isInstanceOf */.V9)(request, Request)) {
            headers = request.headers;
        }
        if (headers) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (typeof headers.append === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                headers.append('sentry-trace', span.toTraceparent());
            }
            else if (Array.isArray(headers)) {
                headers = (0,tslib_es6/* __spread */.fl)(headers, [['sentry-trace', span.toTraceparent()]]);
            }
            else {
                headers = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, headers), { 'sentry-trace': span.toTraceparent() });
            }
        }
        else {
            headers = { 'sentry-trace': span.toTraceparent() };
        }
        options.headers = headers;
    }
}
/**
 * Create and track xhr request spans
 */
function xhrCallback(handlerData, shouldCreateSpan, spans) {
    if (!(0,utils/* hasTracingEnabled */.zu)() ||
        (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
        !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))) {
        return;
    }
    var xhr = handlerData.xhr.__sentry_xhr__;
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp) {
        var spanId = handlerData.xhr.__sentry_xhr_span_id__;
        if (!spanId)
            return;
        var span = spans[spanId];
        if (span) {
            span.setHttpStatus(xhr.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    // if not, create a new span to track it
    var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, xhr.data), { type: 'xhr', method: xhr.method, url: xhr.url }),
            description: xhr.method + " " + xhr.url,
            op: 'http.client',
        });
        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
        if (handlerData.xhr.setRequestHeader) {
            try {
                handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
            }
            catch (_) {
                // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
            }
        }
    }
}
//# sourceMappingURL=request.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/router.js


var router_global = (0,esm_global/* getGlobalObject */.R)();
/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(customStartTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
    if (!router_global || !router_global.location) {
        esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    var startingUrl = router_global.location.href;
    var activeTransaction;
    if (startTransactionOnPageLoad) {
        activeTransaction = customStartTransaction({ name: router_global.location.pathname, op: 'pageload' });
    }
    if (startTransactionOnLocationChange) {
        (0,instrument/* addInstrumentationHandler */.o)('history', function (_a) {
            var to = _a.to, from = _a.from;
            /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */
            if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                startingUrl = undefined;
                return;
            }
            if (from !== to) {
                startingUrl = undefined;
                if (activeTransaction) {
                    esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log("[Tracing] Finishing current transaction with op: " + activeTransaction.op);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeTransaction.finish();
                }
                activeTransaction = customStartTransaction({ name: router_global.location.pathname, op: 'navigation' });
            }
        });
    }
}
//# sourceMappingURL=router.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/browsertracing.js










var DEFAULT_MAX_TRANSACTION_DURATION_SECONDS = 600;
var DEFAULT_BROWSER_TRACING_OPTIONS = (0,tslib_es6/* __assign */.pi)({ idleTimeout: idletransaction/* DEFAULT_IDLE_TIMEOUT */.nT, markBackgroundTransactions: true, maxTransactionDuration: DEFAULT_MAX_TRANSACTION_DURATION_SECONDS, routingInstrumentation: instrumentRoutingWithDefaults, startTransactionOnLocationChange: true, startTransactionOnPageLoad: true }, defaultRequestInstrumentationOptions);
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
var BrowserTracing = /** @class */ (function () {
    function BrowserTracing(_options) {
        /**
         * @inheritDoc
         */
        this.name = BrowserTracing.id;
        /** Store configured idle timeout so that it can be added as a tag to transactions */
        this._configuredIdleTimeout = undefined;
        var tracingOrigins = defaultRequestInstrumentationOptions.tracingOrigins;
        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
        if (_options) {
            this._configuredIdleTimeout = _options.idleTimeout;
            if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins) && _options.tracingOrigins.length !== 0) {
                tracingOrigins = _options.tracingOrigins;
            }
            else {
                esm_flags/* IS_DEBUG_BUILD */.h && (this._emitOptionsWarning = true);
            }
        }
        this.options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, DEFAULT_BROWSER_TRACING_OPTIONS), _options), { tracingOrigins: tracingOrigins });
        var _metricOptions = this.options._metricOptions;
        this._metrics = new MetricsInstrumentation(_metricOptions && _metricOptions._reportAllChanges);
    }
    /**
     * @inheritDoc
     */
    BrowserTracing.prototype.setupOnce = function (_, getCurrentHub) {
        var _this = this;
        this._getCurrentHub = getCurrentHub;
        if (this._emitOptionsWarning) {
            esm_flags/* IS_DEBUG_BUILD */.h &&
                esm_logger/* logger.warn */.kg.warn('[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.');
            esm_flags/* IS_DEBUG_BUILD */.h &&
                esm_logger/* logger.warn */.kg.warn("[Tracing] We added a reasonable default for you: " + defaultRequestInstrumentationOptions.tracingOrigins);
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, instrumentRouting = _a.routingInstrumentation, startTransactionOnLocationChange = _a.startTransactionOnLocationChange, startTransactionOnPageLoad = _a.startTransactionOnPageLoad, markBackgroundTransactions = _a.markBackgroundTransactions, traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
        instrumentRouting(function (context) { return _this._createRouteTransaction(context); }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) {
            registerBackgroundTabDetection();
        }
        instrumentOutgoingRequests({ traceFetch: traceFetch, traceXHR: traceXHR, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest });
    };
    /** Create routing idle transaction. */
    BrowserTracing.prototype._createRouteTransaction = function (context) {
        var _this = this;
        if (!this._getCurrentHub) {
            esm_flags/* IS_DEBUG_BUILD */.h &&
                esm_logger/* logger.warn */.kg.warn("[Tracing] Did not create " + context.op + " transaction because _getCurrentHub is invalid.");
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, beforeNavigate = _a.beforeNavigate, idleTimeout = _a.idleTimeout, maxTransactionDuration = _a.maxTransactionDuration;
        var parentContextFromHeader = context.op === 'pageload' ? getHeaderContext() : undefined;
        var expandedContext = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), parentContextFromHeader), { trimEnd: true });
        var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        var finalContext = modifiedContext === undefined ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, expandedContext), { sampled: false }) : modifiedContext;
        if (finalContext.sampled === false) {
            esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log("[Tracing] Will not send " + finalContext.op + " transaction because of beforeNavigate.");
        }
        esm_flags/* IS_DEBUG_BUILD */.h && esm_logger/* logger.log */.kg.log("[Tracing] Starting " + finalContext.op + " transaction on scope");
        var hub = this._getCurrentHub();
        var location = (0,esm_global/* getGlobalObject */.R)().location;
        var idleTransaction = (0,hubextensions/* startIdleTransaction */.lb)(hub, finalContext, idleTimeout, true, { location: location });
        idleTransaction.registerBeforeFinishCallback(function (transaction, endTimestamp) {
            _this._metrics.addPerformanceEntries(transaction);
            adjustTransactionDuration((0,utils/* secToMs */.WB)(maxTransactionDuration), transaction, endTimestamp);
        });
        idleTransaction.setTag('idleTimeout', this._configuredIdleTimeout);
        return idleTransaction;
    };
    /**
     * @inheritDoc
     */
    BrowserTracing.id = 'BrowserTracing';
    return BrowserTracing;
}());

/**
 * Gets transaction context from a sentry-trace meta.
 *
 * @returns Transaction context data from the header or undefined if there's no header or the header is malformed
 */
function getHeaderContext() {
    var header = getMetaContent('sentry-trace');
    if (header) {
        return extractTraceparentData(header);
    }
    return undefined;
}
/** Returns the value of a meta tag */
function getMetaContent(metaName) {
    var el = (0,esm_global/* getGlobalObject */.R)().document.querySelector("meta[name=" + metaName + "]");
    return el ? el.getAttribute('content') : null;
}
/** Adjusts transaction value based on max transaction duration */
function adjustTransactionDuration(maxDuration, transaction, endTimestamp) {
    var diff = endTimestamp - transaction.startTimestamp;
    var isOutdatedTransaction = endTimestamp && (diff > maxDuration || diff < 0);
    if (isOutdatedTransaction) {
        transaction.setStatus('deadline_exceeded');
        transaction.setTag('maxTransactionDurationExceeded', 'true');
    }
}
//# sourceMappingURL=browsertracing.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/index.js



// This is already exported as part of `Integrations` above (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
//
// Previously we expected users to import tracing integrations like
//
// import { Integrations } from '@sentry/tracing';
// const instance = new Integrations.BrowserTracing();
//
// This makes the integrations unable to be treeshaken though. To address this, we now have
// this individual export. We now expect users to consume BrowserTracing like so:
//
// import { BrowserTracing } from '@sentry/tracing';
// const instance = new BrowserTracing();
//
// For an example of of the new usage of BrowserTracing, see @sentry/nextjs index.client.ts


// eslint-disable-next-line deprecation/deprecation





// We are patching the global object with our hub extension methods
(0,hubextensions/* addExtensionMethods */.ro)();


//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(75332);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/performance/client.js
/* eslint-disable @typescript-eslint/no-explicit-any */



var client_global = (0,esm_global/* getGlobalObject */.R)();
var DEFAULT_TAGS = {
    'routing.instrumentation': 'next-router',
};
var activeTransaction = undefined;
var prevTransactionName = undefined;
var startTransaction = undefined;
/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(startTransactionCb, startTransactionOnPageLoad, startTransactionOnLocationChange) {
    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
    startTransaction = startTransactionCb;
    router_default().ready(function () {
        // We can only start the pageload transaction when we have access to the parameterized
        // route name. Setting the transaction name after the transaction is started could lead
        // to possible race conditions with the router, so this approach was taken.
        if (startTransactionOnPageLoad) {
            prevTransactionName = (router_default()).route !== null ? (0,misc/* stripUrlQueryAndFragment */.rt)((router_default()).route) : client_global.location.pathname;
            activeTransaction = startTransactionCb({
                name: prevTransactionName,
                op: 'pageload',
                tags: DEFAULT_TAGS,
            });
        }
        // Spans that aren't attached to any transaction are lost; so if transactions aren't
        // created (besides potentially the onpageload transaction), no need to wrap the router.
        if (!startTransactionOnLocationChange)
            return;
        // `withRouter` uses `useRouter` underneath:
        // https://github.com/vercel/next.js/blob/de42719619ae69fbd88e445100f15701f6e1e100/packages/next/client/with-router.tsx#L21
        // Router events also use the router:
        // https://github.com/vercel/next.js/blob/de42719619ae69fbd88e445100f15701f6e1e100/packages/next/client/router.ts#L92
        // `Router.changeState` handles the router state changes, so it may be enough to only wrap it
        // (instead of wrapping all of the Router's functions).
        var routerPrototype = Object.getPrototypeOf((router_default()).router);
        (0,object/* fill */.hl)(routerPrototype, 'changeState', changeStateWrapper);
    });
}
/**
 * Wraps Router.changeState()
 * https://github.com/vercel/next.js/blob/da97a18dafc7799e63aa7985adc95f213c2bf5f3/packages/next/next-server/lib/router/router.ts#L1204
 * Start a navigation transaction every time the router changes state.
 */
function changeStateWrapper(originalChangeStateWrapper) {
    var wrapper = function (method, 
    // The parameterized url, ex. posts/[id]/[comment]
    url, 
    // The actual url, ex. posts/85/my-comment
    as, options) {
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        var args = [];
        for (
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        var _i = 4; 
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        _i < arguments.length; 
        // At the moment there are no additional arguments (meaning the rest parameter is empty).
        // This is meant to protect from future additions to Next.js API, especially since this is an
        // internal API.
        _i++) {
            // At the moment there are no additional arguments (meaning the rest parameter is empty).
            // This is meant to protect from future additions to Next.js API, especially since this is an
            // internal API.
            args[_i - 4] = arguments[_i];
        }
        var newTransactionName = (0,misc/* stripUrlQueryAndFragment */.rt)(url);
        // do not start a transaction if it's from the same page
        if (startTransaction !== undefined && prevTransactionName !== newTransactionName) {
            if (activeTransaction) {
                activeTransaction.finish();
            }
            var tags = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, DEFAULT_TAGS), { method: method }), options);
            if (prevTransactionName) {
                tags.from = prevTransactionName;
            }
            prevTransactionName = newTransactionName;
            activeTransaction = startTransaction({
                name: prevTransactionName,
                op: 'navigation',
                tags: tags,
            });
        }
        return originalChangeStateWrapper.call.apply(originalChangeStateWrapper, (0,tslib_es6/* __spread */.fl)([this, method, url, as, options], args));
    };
    return wrapper;
}
//# sourceMappingURL=client.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/metadata.js

var PACKAGE_NAME_PREFIX = 'npm:@sentry/';
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
    options._metadata = options._metadata || {};
    options._metadata.sdk =
        options._metadata.sdk ||
            {
                name: 'sentry.javascript.nextjs',
                packages: names.map(function (name) { return ({
                    name: "" + PACKAGE_NAME_PREFIX + name,
                    version: SDK_VERSION,
                }); }),
                version: SDK_VERSION,
            };
}
//# sourceMappingURL=metadata.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/userIntegrations.js

/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
    // Ex. foo.bar.zoop will extract foo and bar.zoop
    var match = keyPath.match(/([a-z]+)\.(.*)/i);
    if (match === null) {
        obj[keyPath] = value;
    }
    else {
        setNestedKey(obj[match[1]], match[2], value);
    }
}
/**
 * Retrieves the patched integrations with the provided integration.
 *
 * The integration must be present in the final user integrations, and they are compared
 * by integration name. If the user has defined one, there's nothing to patch; if not,
 * the provided integration is added.
 *
 * @param integration The integration to patch, if necessary.
 * @param userIntegrations Integrations defined by the user.
 * @param options options to update for a particular integration
 * @returns Final integrations, patched if necessary.
 */
function addIntegration(integration, userIntegrations, options) {
    if (options === void 0) { options = {}; }
    if (Array.isArray(userIntegrations)) {
        return addIntegrationToArray(integration, userIntegrations, options);
    }
    else {
        return addIntegrationToFunction(integration, userIntegrations, options);
    }
}
function addIntegrationToArray(integration, userIntegrations, options) {
    var includesName = false;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var x = 0; x < userIntegrations.length; x++) {
        if (userIntegrations[x].name === integration.name) {
            includesName = true;
        }
        var op = options[userIntegrations[x].name];
        if (op) {
            setNestedKey(userIntegrations[x], op.keyPath, op.value);
        }
    }
    if (includesName) {
        return userIntegrations;
    }
    return (0,tslib_es6/* __spread */.fl)(userIntegrations, [integration]);
}
function addIntegrationToFunction(integration, userIntegrationsFunc, options) {
    var wrapper = function (defaultIntegrations) {
        var userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);
        return addIntegrationToArray(integration, userFinalIntegrations, options);
    };
    return wrapper;
}
//# sourceMappingURL=userIntegrations.js.map
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js








var Integrations = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, INTEGRATIONS), { BrowserTracing: BrowserTracing });
// This is already exported as part of `Integrations` above (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
//
// Previously we expected users to import `BrowserTracing` like this:
//
// import { Integrations } from '@sentry/nextjs';
// const instance = new Integrations.BrowserTracing();
//
// This makes the integrations unable to be treeshaken though. To address this, we now have
// this individual export. We now expect users to consume BrowserTracing like so:
//
// import { BrowserTracing } from '@sentry/nextjs';
// const instance = new BrowserTracing();

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function index_client_init(options) {
    buildMetadata(options, ['nextjs', 'react']);
    options.environment = options.environment || "production";
    // Only add BrowserTracing if a tracesSampleRate or tracesSampler is set
    var integrations = options.tracesSampleRate === undefined && options.tracesSampler === undefined
        ? options.integrations
        : createClientIntegrations(options.integrations);
    sdk_init((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { integrations: integrations }));
    (0,esm/* configureScope */.e)(function (scope) {
        scope.setTag('runtime', 'browser');
        scope.addEventProcessor(function (event) { return (event.type === 'transaction' && event.transaction === '/404' ? null : event); });
    });
}
var defaultBrowserTracingIntegration = new BrowserTracing({
    tracingOrigins: (0,tslib_es6/* __spread */.fl)(defaultRequestInstrumentationOptions.tracingOrigins, [/^(api\/)/]),
    routingInstrumentation: nextRouterInstrumentation,
});
function createClientIntegrations(integrations) {
    if (integrations) {
        return addIntegration(defaultBrowserTracingIntegration, integrations, {
            BrowserTracing: { keyPath: 'options.routingInstrumentation', value: nextRouterInstrumentation },
        });
    }
    else {
        return [defaultBrowserTracingIntegration];
    }
}
//# sourceMappingURL=index.client.js.map
;// CONCATENATED MODULE: ./sentry.client.config.js
/* provided dependency */ var process = __webpack_require__(89885);
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

var SENTRY_DSN = process.env.SENTRY_DSN || "https://b47bba2962d14419b835048b88b91e39@o342444.ingest.sentry.io/5764823";
index_client_init({
    dsn: SENTRY_DSN
});


/***/ }),

/***/ 81962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* reexport */ Currency; },
  "QT": function() { return /* reexport */ PlayState; },
  "Qe": function() { return /* reexport */ SubscriptionType; },
  "Xm": function() { return /* reexport */ UserPromoType; }
});

// UNUSED EXPORTS: CelebrityRole, Language, Order, PlaysRequestOrderBy, SimilarPlayType

;// CONCATENATED MODULE: ./typings/api/celebrity-role.ts
var CelebrityRole;
(function(CelebrityRole) {
    CelebrityRole["Director"] = "Director";
    CelebrityRole["Actor"] = "Actor";
    CelebrityRole["Author"] = "Author";
})(CelebrityRole || (CelebrityRole = {}));

;// CONCATENATED MODULE: ./typings/api/currency.ts
var Currency;
(function(Currency) {
    Currency["Czk"] = "CZK";
    Currency["Eur"] = "EUR";
    Currency["Uah"] = "UAH";
    Currency["Pln"] = "PLN";
})(Currency || (Currency = {}));

;// CONCATENATED MODULE: ./typings/api/language.ts
var Language;
(function(Language) {
    Language["Czech"] = "CZECH";
    Language["English"] = "ENGLISH";
})(Language || (Language = {}));

;// CONCATENATED MODULE: ./typings/api/order.ts
var Order;
(function(Order) {
    Order["Asc"] = "asc";
    Order["Desc"] = "desc";
})(Order || (Order = {}));

;// CONCATENATED MODULE: ./typings/api/play-state.ts
var PlayState;
(function(PlayState) {
    PlayState["PROMOTED"] = "PROMOTED";
    PlayState["PUBLISHED"] = "PUBLISHED";
})(PlayState || (PlayState = {}));

;// CONCATENATED MODULE: ./typings/api/plays-request-order-by.ts
var PlaysRequestOrderBy;
(function(PlaysRequestOrderBy) {
    PlaysRequestOrderBy["Views"] = "views";
    PlaysRequestOrderBy["UserProgress"] = "user_progress";
})(PlaysRequestOrderBy || (PlaysRequestOrderBy = {}));

;// CONCATENATED MODULE: ./typings/api/similar-play-type.ts
var SimilarPlayType;
(function(SimilarPlayType) {
    SimilarPlayType["Cast"] = "cast";
    SimilarPlayType["Genre"] = "genre";
})(SimilarPlayType || (SimilarPlayType = {}));

;// CONCATENATED MODULE: ./typings/api/subscription-type.ts
var SubscriptionType;
(function(SubscriptionType) {
    SubscriptionType["Trial"] = "TRIAL";
    SubscriptionType["Regular"] = "REGULAR";
    SubscriptionType["Voucher"] = "VOUCHER";
    SubscriptionType["None"] = "NONE";
    SubscriptionType["Unlimited"] = "UNLIMITED";
})(SubscriptionType || (SubscriptionType = {}));

;// CONCATENATED MODULE: ./typings/api/user.ts
var UserPromoType;
(function(UserPromoType) {
    UserPromoType["USER_INVITATION"] = "USER_INVITATION";
    UserPromoType["CAMPAIGN"] = "CAMPAIGN";
})(UserPromoType || (UserPromoType = {}));

;// CONCATENATED MODULE: ./typings/api/index.ts























































































































































































/***/ }),

/***/ 58772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordionHeader":"Accordion_accordionHeader__sKWux","enlarge":"Accordion_enlarge__SXRbt","enlargeAndShift":"Accordion_enlargeAndShift__emxjn","grow":"Accordion_grow__3BwTJ","rotate":"Accordion_rotate__O4F8k","slide-down":"Accordion_slide-down__h3Cty","slide-up":"Accordion_slide-up__TNahj","progressShow":"Accordion_progressShow__ldcsw","pulsate":"Accordion_pulsate__qrNbA","fromHalfOpacityToFull":"Accordion_fromHalfOpacityToFull__5Fwz9"};

/***/ }),

/***/ 51257:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttons":"BrowseSkeleton_buttons__MJ9Vy"};

/***/ }),

/***/ 79206:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imgPlaceholder":"DramoxImage_imgPlaceholder__2DNuW"};

/***/ }),

/***/ 86901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faqList":"FAQList_faqList__VIAqJ","expanded":"FAQList_expanded__C1mUV"};

/***/ }),

/***/ 88115:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerFluid":"Layout_containerFluid___rdUZ"};

/***/ }),

/***/ 70040:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingComponent_loading__FqHy7","rotate":"LoadingComponent_rotate__8IA14","medium":"LoadingComponent_medium__pZcRq","enlarge":"LoadingComponent_enlarge__8LyxH","enlargeAndShift":"LoadingComponent_enlargeAndShift__U9JNh","grow":"LoadingComponent_grow__0BMOS","slide-down":"LoadingComponent_slide-down__8zEYi","slide-up":"LoadingComponent_slide-up__AF3kd","progressShow":"LoadingComponent_progressShow__mHeAB","pulsate":"LoadingComponent_pulsate__btXar","fromHalfOpacityToFull":"LoadingComponent_fromHalfOpacityToFull__bAkn1"};

/***/ }),

/***/ 36249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingPage_loading__MuTf_"};

/***/ }),

/***/ 49228:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newsletterDialog":"NewsletterSubscriptionDialog_newsletterDialog__l44yn","loaded":"NewsletterSubscriptionDialog_loaded__QaJ7w"};

/***/ }),

/***/ 14677:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sub":"ProfileSkeleton_sub__IIw7c","subContainer":"ProfileSkeleton_subContainer__XMOxP","forms":"ProfileSkeleton_forms__pKr_u","enlarge":"ProfileSkeleton_enlarge__xYP_f","enlargeAndShift":"ProfileSkeleton_enlargeAndShift__qbtF5","grow":"ProfileSkeleton_grow__Clioc","rotate":"ProfileSkeleton_rotate__l3lxA","slide-down":"ProfileSkeleton_slide-down__q_Y4N","slide-up":"ProfileSkeleton_slide-up__UwazA","progressShow":"ProfileSkeleton_progressShow__5Or_G","pulsate":"ProfileSkeleton_pulsate__QbCxQ","fromHalfOpacityToFull":"ProfileSkeleton_fromHalfOpacityToFull__MF3q1"};

/***/ }),

/***/ 22202:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"notificationList":"notificationList_notificationList__q0Kkm","notification":"notificationList_notification__Uk9Fw","notificationDanger":"notificationList_notificationDanger__bjzfO"};

/***/ }),

/***/ 34714:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7727:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 86383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 68060:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 32363:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}


/***/ }),

/***/ 43692:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 62139:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 49573:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ }),

/***/ 66334:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs + 1 modules
var _possible_constructor_return = __webpack_require__(10797);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0,_possible_constructor_return/* default */.Z)(this, result);
    };
}

/***/ }),

/***/ 42299:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 94981:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}


/***/ }),

/***/ 54146:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 84434:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 26383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 5447:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42299);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 99728:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 27427:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 10797:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _possibleConstructorReturn; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(32363);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return (0,_assert_this_initialized/* default */.Z)(self);
}


/***/ }),

/***/ 2746:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68060);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84434);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26383);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94612);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 28253:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68060);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84434);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26383);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94612);





function _toArray(arr) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 84911:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(86383);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(84434);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(94612);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 94612:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86383);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 60950:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Skeleton; },
/* harmony export */   "y": function() { return /* binding */ SkeletonTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);


/**
 * @internal
 */
const SkeletonThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = react__WEBPACK_IMPORTED_MODULE_0__.useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: i },
                skeletonSpan,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null)));
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, { key: i }, el))
        : elements));
}

function SkeletonTheme({ children, ...styleOptions }) {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(SkeletonThemeContext.Provider, { value: styleOptions }, children));
}




/***/ }),

/***/ 86552:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"authorship_provider":"Provozovatel služby","about_colaboration_question":"Máte zájem o spolupráci?","about_contact_us":"Kontaktujte nás zde","about_creators":"Kdo za Dramox stojí?","about_partners":"Naši partneři","about_project":"O projektu","about_schools":"Dramox pro školy nabízí učitelům možnost, jak udělat výuku zábavnější. Studenti objeví krásy divadla a literatury způsobem, na jaký jsou zvyklí – sledováním videa online. Užijí si také vyplňování pracovních listů, které k nim mluví jazykem, jemuž rozumí – emotikony, FB příspěvky, obrázky... <0>Více informací</0>.","about_theaters":"Zobrazit všechna divadla","about_colaboration":"Kdo s námi hraje?","person_about_1":"Vystudoval divadelní vědu. Využívá kombinace technického a humanitního vzdělání. Pomáhal stavět několik digitálních společností. Věnoval se práci obchodníka pro Jablotron nebo společnost Creative Dock.","person_about_2":"Pomáhal spustit videoportál voyo.cz. Vlastní firmu Weemazz 2.0, která pro vlastníky autorských práv odstraňuje z internetu nelegální kopie jejich děl. Celou svou kariéru pracuje v digitální sféře.","person_about_3":"Spoluzakladatel, duchovní otec myšlenky Dramox, internetový podnikatel a majitel značky Livesport, kterou celosvětově využívá více jak 90 milionů uživatelů.","person_title_1":"Martin Zavadil","person_title_2":"Radim Horák","person_title_3":"Martin Hájek","forschools_footer":"Pro školy","about_project_description":"<0><1>Dramox</1> je vaše divadlo online, které za měsíční předplatné nabízí stovky divadelních záznamů na jednom místě. Sledujte svá oblíbená představení nebo objevujte nová, kdykoliv a kdekoliv budete chtít, a to zcela bez reklam. Pravidelně přidáváme nová, rozmanitá představení všech žánrů.</0><0>Podporujeme divadelní umění. Většina z každého předplatného jde přímo divadlům, autorům a hercům. Své oblíbené divadlo můžete podpořit také libovolnou částkou navíc.</0><0><1>Věříme</1>, že společně dokážeme spojit diváka s jeho oblíbeným divadlem a také mu představit divadla nová, která by sám neobjevil.</0> ","legislative":"Orgánem dohledu nad poskytováním audiovizuálních mediálních služeb na vyžádání je Rada pro rozhlasové atelevizní vysílání."}');

/***/ }),

/***/ 73431:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"menu_authorship":"Autorská práva","authorship_email":"Děkujeme za Váš e-mail.","authorship_email_fail":"Vaši zprávu se nepodařilo odeslat. Opakujte akci prosím později.","authorship_message_for_us":"Zpráva pro nás","authorship_provider":"Provozovatel služby","authorship_send_form":"Odeslat formulář","authorship_title":"Dotaz týkající se autorských práv","authorship_your_email":"Váš e-mail","authorship_perex":"<0>Jste majitelem autorských práv k některému z představení uvedených na Dramoxu?</0><0>Pokud Vaše autorská práva nezastupuje některý z kolektivních správců (DILIA, OSA, Aura-pont, Intergram atd.) a my s Vámi nejsme v kontaktu, napište nám prosím.</0><0>Ačkoliv jsme udělali maximum, abychom oslovili opravdu všechny autory, je možné, že o Vás zatím nevíme.</0><0>Kontaktujte nás prosím níže uvedeným formulářem. Neprodleně se Vám ozveme a vše s Vámi velmi rádi probereme.</0><0>Děkujeme.<1></1>Tým Dramox</0>","authorship_field_required":"Toto pole je povinné.","authorship_max_length":"Maximální délka pole je: ","authorship_email_invalid":"E-mail není validní. Použijte formát email@example.cz"}');

/***/ }),

/***/ 22582:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"broadcast_title":"Živé vysílání","video_placeholder":"Aktuálně nevysíláme","schedule_title":"Harmonogram"}');

/***/ }),

/***/ 1646:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Zvolte si předplatné","payment_info":"Noví členové se baví divadlem online prvních 7 dní ZDARMA. Většina z každého předplatného jde přímo divadlům, autorům a hercům. Zrušte kdykoliv.","payment_occour":"Platba proběhne {{date}}","payment_sub_info":"S ročním plánem ušetříte necelých {{yearPriceDiff}} ročně.","voucher_label":"Dárkový poukaz","voucher_placeholder":"Zadejte kód","got_voucher":"Mám dárkový poukaz","redeem_voucher":"Uplatnit","activate_yearly":"Aktivovat roční plán","activate_monthly":"Aktivovat měsíční plán","changes_not_saved":"Změny se nepodařilo uložit. Prosím opakujte akci později.","changes_saved":"Změny se uložily.","subscription_activated":"Předplatné se aktivovalo.","error_general":"Něco se pokazilo. Prosím zkuste to později.","price_with_vat":"{{price}}\\ns DPH","advanced_form":{"title":"Vyberte si předplatné a choďte do divadla třeba každý den","switch_to_voucher":"nebo použijte dárkový poukaz","monthly":"7 dní zdarma,<0>pak za {{price_formatted}} měsíčně</0>","yearly":"7 dní zdarma,<0>pak za {{price_formatted}} ročně</0>","button_activate":"Aktivovat 7denní zkušební období","timeline_title":"Jak funguje 7denní<0></0>bezplatné zkušební období","timeline_step_1":"<0>Dnes</0>Začátek bezplatného zkušebního období","timeline_step_2":"<0>Za 7 dní ({{date_formatted}})</0>Dojde k první platbě za zvolené předplatné.<1></1>Pokud v průběhu zrušíte, nic se účtovat nebude.","timeline_step_3":"Předplatné se automaticky obnovuje až do chvíle, kdy ho zrušíte.","voucher_title":"Použijte dárkový poukaz","switch_to_card":"Nemám dárkový poukaz","voucher_description_title":"Darujte svým blízkým divadlo online a kupte jim poukaz do Dramoxu","voucher_description_subtitle":"Na jednom místě zhlédnou stovky divadelních záznamů z desítek divadel","voucher_description_action":"Zakoupit dárkový poukaz","use_promo_code":"Přidat promo kód (nepovinné)","promo_code_placeholder":"Zadat promo kód","timeline_step_4":"<0>Za 5 dní ({{date_formatted}})</0>Pošleme e-mail s upozorněním, že se<1></1>blíží první platba za předplatné.","no_trial_button_activate":"Aktivujte své předplatné","no_trial_timeline_title":"Vyberte si své předplatné.","no_trial_timeline_step_1":"Začněte se už dnes bavit Dramoxem.","no_trial_monthly":"<0>{{price_formatted}} měsíčně</0>","no_trial_yearly":"<0>{{price_formatted}} ročně</0>"},"code_not_exists":"Kód neexistuje","card_number_invalid":"Číslo vaší karty je neúplné.","error_code_no_longer_valid":"Platnost kódu již vypršela.","error_voucher_expired":"Platnost kódu již vypršela.","error_code_discount_already_used":"Sleva byla již v minulosti uplatněna.","error_discount_already_active":"Promo kód nelze aktivovat. Máte již aktivní jinou slevu na předplatné.","error_promo_referral_not_allowed":"Promo kód lze použít pouze při zakládání nového účtu.","error_promo_already_used":"Promo kód již byl v minulosti aktivován.","error_promo_voucher_already_used":"Promo kód byl již využit.","error_promo_not_allowed":"Promo kód lze využít pouze v rámci aktivního předplatného.","voucher_invalid":"Voucher je neplatný.","code_already_used":"Promo kód byl již použitý","no_trial_payment_info":"Předplatné můžete kdykoliv zrušit. Polovina z každého předplatného jde přímo divadlům, autorům a hercům."}');

/***/ }),

/***/ 1749:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"contest_title":"SOUTĚŽ Vánoce s Dramoxem","contest_btn":"Přihlásit se do soutěže","contest_desc":"Bavte se divadlem po celý advent a vyhrajte lístky do divadla i předplatné na Dramox","contest_description":"Uvařte si horký čaj, uvelebte se v křesle a pusťte si každý večer Dramox. Letos za sledování divadla online od 1. 12. do 21. 12. odměňujeme vstupenkami do divadel a poukazy na Dramox. A co je nejlepší, Ježíšek u nás přijde s předstihem už 22. 12. a jednomu z vás přinese divadelní balíček, ve kterém nebudou chybět lístky do oblíbeného Dejvického divadla.","contest_what_win_title":"Co můžete vyhrát?","contest_what_win":"Každý týden soutěžíme o tyto ceny, probíhají celkem tři kola:","contest_what_1":"<0>1. místo</0><1><2>2 lístky do divadla</2><2>poukaz do Dramoxu na 6 měsíců</2></1>","contest_what_2":"<0>2. místo</0><1><2>2 lístky do divadla</2><2>poukaz do Dramoxu na 3 měsíce</2></1>","contest_what_3":"<0>3. - 5. místo</0><1><2>2 lístky do divadla</2><2>poukaz do Dramoxu na 1 měsíc</2></1>","contest_what_main_price":"Hlavní cena za celé období od 1. 12. do 21. 12.:","contest_what_price":"Divadelní balíček s lístky do Dejvického divadla, ročním předplatným na Dramox a stylovými dárkovými předměty Dramox","contest_tip_title":"💡 Náš tip: Čím víc představení uvidíte, tím větší máte šanci na výhru.","contest_tip_desc":"Příklad: Marie v pátek 1. 12. zhlédla jedno představení, další si pustila v úterý 5. 12. a ve středu 6. 12. V nedělním slosování pro první adventní týden má tak trojnásobnou šanci na výhru. Navíc ji automaticky zařadíme do závěrečného slosování o divadelní balíček po ukončení soutěže ve čtvrtek 21. 12. 2023 ve 24:00.","contest_how_play":"Jak soutěžit?","contest_how_1":"<0>Registrujte se ve formuláři.</0> Použijte e-mail, kterým jste registrovaní na Dramoxu.","contest_how_2":"Každý soutěžní týden zhlédněte co nejvíce představení na Dramox.cz. Čím víc si jich pustíte, tím víckrát vás zařadíme mezi soutěžící o ceny.","contest_how_3":"Na konci každého týdne náhodně vybereme pět z vás, kteří získají jednu z cen. Výherce informujeme e-mailem. I když nevyhrajete v průběžném týdenním vyhodnocení, nesmutněte. Soutěžní kola jsou tři. Soutěžte další týden a třeba budete mezi výherci právě vy. Na konci soutěže máte šanci získat hlavní cenu – balíček se vstupenkami do Dejvického divadla, ročním předplatným Dramox a dárkovými předměty Dramox. Jejího vítěze budeme znát odpoledne 22. 12.","contest_how_4":"Sledujte nás také na sociálních sítích <0>Facebook</0>, <1>Instagram</1> a <2>Twitter</2> – dozvíte se, co je v soutěži nového, a získáte inspiraci, co si právě pustit. Dáte si Kouli nebo Zimní pohádku? Je to jen na vás!","contest_rules_title":"Pravidla soutěže Vánoce s Dramoxem","contest_rule_1":"Soutěž začíná 1. 12. 2023 v 0:01, končí 21. 12. 2023 ve 24:00.","contest_rule_2":"Soutěž probíhá v následujících obdobích:","contest_rule_2_1":"1. týden: od 1. 12. 0:01 do 7. 12. 2023 24:00, vyhlášení vítězů: pátek 8. 12. 2023","contest_rule_2_2":"2. týden: od 8. 12. 0:01 do 14. 12. 2023 24:00, vyhlášení vítězů: pátek 15. 12. 2023","contest_rule_2_3":"3. týden: od 15. 12. 0:01 do 21. 12. 2023 24:00, vyhlášení vítězů: pátek 22. 12. 2023","contest_rule_2_4":"4. týden: od 18. 12. 0.01 do 23. 12. 2022 12.00, vyhlášení vítězů: pátek 23. 12. 2022","contest_rule_3":"Zapojit se může každý divák registrovaný na Dramox.cz, který má aktivní předplatné nebo využívá zkušební 7denní období, a současně se registroval do soutěže Vánoce s Dramoxem prostřednictvím soutěžního formuláře.","contest_rule_4":"Vítězové jednotlivých kol jsou vybráni náhodným výběrem vždy ze všech soutěžících, kteří se v daném týdnu zapojili. Vítěze vyhlásíme na našich sociálních sítích a v newsletterech.","contest_rule_5":"Hlavní cena – divadelní balíček plný cen a roční předplatné Dramoxu může vyhrát kterýkoliv soutěžící, který se zapojil v období 1. 12. 2023 - 21. 12. 2023 bez ohledu na to, zda již některou z cen vyhrál, nebo ne. Hlavní cena je pouze jedna pro celou soutěž. Náhodným výběrem bude vybrán jediný soutěžící 22. 12. Vítěze vyhlásíme na našich sociálních sítích a v newsletteru.","contest_rule_more":"Kompletní pravidla Vánoční soutěže s Dramoxem jsou <0>zde</0>","contest_info_toolbar_2023":"⭐ SOUTĚŽ Vánoce s Dramoxem: Vyhrajte vstupenky do divadel i dárkové poukazy na Dramox","contest_info_toolbar_2024":"⭐ SOUTĚŽ Vánoce s Dramoxem: Vyhrajte vstupenky do divadel i dárkové poukazy na Dramox"}');

/***/ }),

/***/ 58891:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"more":"Více","more_about_play":"Více o představení","previous_play":"Předchozí představení","play_btn":"Přehrát","play_btn_long":"Přehrát divadelní představení","next_play":"Další představení","coming_soon":"Již brzy","continue":"Pokračovat","continue_remaining":"Zbývá {{time}}","most_popular":"Nejpopulárnější","popular":"Populární","recently_added":"Nedávno přidané","currently_watching":"Pokračovat v přehrávání","drama":"Drama","comedy":"Komedie","tragedy":"Tragédie","all_genres":"Všechny žánry","actors":"Herci a herečky","performances":"Divadelní představení","theatres":"Divadla","search_placeholder":"Představení, herec, divadlo...","no_search_results":"K zadanému heslu nemáme žádné výsledky.","menu":{"home":"Domů","genres":"Žánry","theatres":"Divadla","about":"O Dramoxu","theatre":"Podpořte divadla","voucher":"Dárkové poukazy","login":"Přihlásit se","try_free":"Registrujte se","about_project":"O projektu","for_schools":"Pro školy","smart_tv":"Chytré televize","mobile_apps":"Mobilní aplikace","how_to_watch":"Jak sledovat","contact":"Kontakt","faq":"Často se ptáte","my_profile":"Můj profil","logout":"Odhlásit se","terms_conditions":"Podmínky používání","cookies":"Zásady používání Cookies","authorship":"Autorská práva","privacy_policy":"Ochrana soukromí","content_settings":"Jazyky představení","try_now":"Vyzkoušet","logo_mobile":"Prvních 7 dní ZDARMA","search":"Hledat","invite_friends":"Pozvat přátele","watch_list":"Můj seznam","broadcast":"Vysílání","no_trial_try_free":"Registrujte se","christmas_contest":"Vánoční soutěž"},"form":{"not_empty":"Hodnota nesmí být prázdná.","password_min_chars":"Heslo musí mít alespoň 8 znaků.","email_format":"Zadejte e-mail ve správném formátu.","wrong_credentials":"Nesprávný e-mail nebo heslo.","already_exists":"E-mail již existuje.","password_dont_match":"Hesla se neshodují.","payment_secured_with":"Zabezpečeno technologií","payment_card":"Platební karta","add_card":"Přidat kartu","card_tooltip":"Přijímáme karty VISA, Mastercard, eBenefity","activate":"Aktivovat","recaptcha_error_global":"Captcha není validní, prosíme obnovte stránku.","recaptcha_error_expired":"Platnost captchy vypršela, zaškrtněte ji prosím znovu.","recaptcha_error_not_checked":"Prosím zaškrtněte, ať víme, že nejste robot!"},"not_found":{"title":"Stránka nebyla nalezena.","description":"Je nám líto, ale požadovanou stránku jsme nenašli.","btn":"Zpět na úvodní stránku"},"saved_cards":"Uložené karty","saved_cards_placeholder":"Zvolte kartu","card_email":"E-mail","add_new_card":"Přidat novou kartu","playlist_section_title":"Divadelní představení z kategorie {{section}}","playlist_genre_title":"Divadelní představení v žánru {{genre}}","playlist_same_genre_title":"{{performance}} – podobná divadelní představení","playlist_same_cast_title":"{{performance}} – představení s podobným obsazením","playlist_currently_watching_title":"Právě sledujete","playlist_most_popular_title":"Nejoblíbenější představení","playlist_recent_title":"Nejnovější divadelní představení","country":"Země","pick_country":"Vyberte zemi","performance_not_found":{"title":"Představení nenalezeno","description":"Požadované představení buď neexistuje, nebo není ve vaší zemi momentálně dostupné."},"playlist_dramox_originals_title":"Dramox Originals","dramox_originals":"Dramox Originals","open_in_mobile_app":"Otevřít v aplikaci Dramox","watch_list":"Můj seznam","sort_from":"Řadit od","sort_date_desc":"Datum přidání (od nejnovějšího)","sort_date_asc":"Datum přidání (od nejstaršího)","sort_alphabetically_desc":"Abecedně (A-Z)","add_first_play":"Přidejte první představení","how_add":"Novou položku přidáte pomocí tlačítka “Můj seznam” v detailu představení","check_library":"Prohlédnout knihovnu","month_zero":"{{count}} měsíců","month_one":"{{count}} měsíc","month_few":"{{count}} měsíce","month_many":"{{count}} měsíců","day_zero":"{{count}} dnů","day_one":"{{count}} den","day_few":"{{count}} dny","day_many":"{{count}} dnů","week_zero":"{{count}} týdnů","week_one":"{{count}} týden","week_few":"{{count}} týdny","week_many":"{{count}} týdnů","cookies_bar":{"less_text":"Milí diváci, používáme soubory cookies, které vám zpříjemňují sledování divadla online.","learn_more":"Chci vědět víc","accept_all":"Rozumím","only_functional":"Pouze funkční"},"cookie_updated":"Aktualizováno 24. 5. 2022","or":"Nebo","year_zero":"{{count}} roků","year_one":"{{count}} rok","year_few":"{{count}} roky","year_many":"{{count}} roků","ownership":"Od září 2024 Dramox s.r.o. vlastní Nadace Livesport."}');

/***/ }),

/***/ 80801:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"authorship_provider":"Provozovatel služby","contact_ceo":"Ředitel","contact_cofounder":"Spoluzakladatel","contact_coo":"Provozní ředitel","person_title_1":"Martin Zavadil","person_title_2":"Radim Horák","person_title_3":"Martin Hájek","press_download":"Stáhnout Press Kit","press_media":"Pro média","press_text":"Stáhněte si firemní Press Kit, který obsahuje loga Dramox ve všech formátech.","ua_contact":"Manager","ua_contact_name":"Olia Shylo","company":"Dramox s.r.o.","address":"Bucharova 2928/14a, Stodůlky","ico":"IČO: 09222103","cooperation":"napoveda@dramox.cz","ua_company":"Dramox s.r.o.","ua_address":"Бухарова 2928/14а, Стодолки (Прага 13), 158 00 Прага","ua_ico":"Реєстраційний номер: 09222103","ua_cooperation":"napoveda@dramox.cz"}');

/***/ }),

/***/ 1350:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"may_2022_tag_title":"Sleva 33 % na předplatné | Dramox","may_2022_title":"Sleva 33 % až na 5 měsíců Dramoxu. Bavte se skvělým divadlem jen za 199 Kč měsíčně","may_2022_subtitle":"Nepropásněte jedinečnou příležitost. Sledujte Dramox 5 měsíců s výraznou slevou 33 % a ušetřete až 500 Kč. Díky výjimečné slevě na předplatné zaplatíte jen 199 Kč/měsíc místo obvyklých 299 Kč. Nabídka platí pouze do 31. 5. 2022.","may_2022_exclusive":"EXKLUZIVNĚ","may_2022_text_mask_1":"Štěpán Kozub, Ivan Trojan, Pavla Tomicová… díky Dramoxu si můžete domů na návštěvu pozvat ty největší herecké hvězdy, které zahrají jen pro vás. Abychom divadlo a kulturu přiblížili co nejvíce lidem, máme pro vás předplatné se slevou 33 % až na 5 měsíců. Sledujte Dramox jen za 199 Kč/měsíc a ušetřete 500 Kč.","may_2022_text_mask_2":"👉 Náš tip: Využijte 33% slevu na roční předplatné. Ušetříte téměř 1 000 Kč.","may_2022_text_mask_3":"⏰ Sleva 33 % na předplatné platí od 1. do 31. 5. 2022. Aktivujte si ji hned teď. Slevu nelze sčítat s jinými slevami.","may_2022_how_watch_title":"Jak slevu využít","may_2022_how_watch_1":"Přihlaste se do svého <0>profilu</0> na Dramox.com.ua. Pokud jste na Dramoxu poprvé, vytvořte si novou <1>registraci</1>.","may_2022_how_watch_2":"Při výběru předplatného zadejte do pole <0>„Přidat promo kód“</0> tento slevový kód: <0>DRAMOXKVETEN33</0>","may_2022_how_watch_3":"Nyní se bavte tím nejlepším divadlem online a ušetřete 33 % ze svého předplatného.","may_2022_how_watch_p":"Potřebujete poradit?","may_2022_how_watch_help":"Napište našim milým nápovědám, vše s vámi vyřeší: <0>napoveda@dramox.cz</0>","may_2022_discount_email":"napoveda@dramox.cz"}');

/***/ }),

/***/ 54342:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"tag_title":"Sleva 50 % na předplatné | Dramox","title":"Sleva 50 % na 6 měsíců Dramoxu. Bavte se divadlem jen za 149 Kč měsíčně","subtitle":"Nepropásněte jedinečnou příležitost, jak sledovat Dramox 6 měsíců za polovinu. Ušetřete s výjimečnou slevou 50 % z ceny předplatného. Místo 299 Kč zaplatíte jen 149 Kč. Nabídka platí pouze 7 dní. Využít ji může kdokoliv. I vy.","exclusive":"Exkluzivně","text_mask_1":"Trojan, Hofmann, Tomicová – díky Dramoxu si můžete domů na návštěvu pozvat ty největší herecké hvězdy, které zahrají jen pro vás. Abychom divadlo a kulturu přiblížili co nejvíce lidem, máme pro vás předplatné za polovinu. Sledujte Dramox až 6 měsíců jen za 149 Kč/měsíc a ušetřete 900 Kč oproti běžnému předplatnému","text_mask_2":"👉 Náš tip, jak ušetřit nejvíc: Využijte 50% slevu na roční předplatné. Ušetříte 1500 Kč.","text_mask_3":"⏰ Sleva 50 % na předplatné platí pouze 7 dní od 14. do 20. 4. 2022. Aktivujte si ji hned teď. Slevu nelze sčítat s jinými slevami.","how_watch_title":"Jak sledovat","how_watch_1":"<0>Přihlaste</0> se do svého profilu na Dramox.com.ua. Pokud profil na Dramoxu zatím nemáte, <1>vytvořte si novou registraci</1>","how_watch_2":"Při výběru předplatného zadejte do pole „Přidat promo kód“ tento slevový kód: <0>DRAMOXZAPULKU</0>","how_watch_3":"Nyní máte divadlo online o 50 % levnější po dobu až 6 měsíců s měsíčním předplatným nebo po celých 12 měsíců, pokud jste zvolili roční předplatné","how_watch_p":"Potřebujete poradit?","how_watch_help":"Napište naším milým nápovědám, vše s vámi vyřeší: <0>napoveda@dramox.cz</0>","discount_email":"napoveda@dramox.cz"}');

/***/ }),

/***/ 32535:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"toolbar":"🐣 SOUTĚŽ Velikonoce s Dramoxem: Vyhrajte vstupenky do Městských divadel pražských a poukazy na předplatné","title":"Velikonoce s Dramoxem","sign_in":"Přihlásit se do soutěže","subtitle_1":"Bavte se divadlem a vyhrajte vstupenky i poukazy na předplatné","subtitle_2":"Oslavte jaro, jak se sluší a patří – ve společnosti rodiny, přátel a skvělého divadla. Velikonoční nadílku vám letos místo zajíčka přinese Dramox. Sledujte od 12. do 18. 4. 2022 co nejvíc představení online a my vás za to odměníme vstupenkami do Městských divadel pražských a poukazy do Dramoxu v hodnotě až 1590 Kč. Užijte si veselé divadelní Velikonoce.","contest":"Soutěž","price_title":"Co můžete vyhrát","price_desc":"Letos o Velikonocích soutěžíme o tyto ceny:","price_first":"<1>1. místo </1> <0/> 2 lístky do divadla <0/> poukaz do Dramoxu na 6 měsíců","price_second":"<1>2. místo </1> <0/> 2 lístky do divadla <0/> poukaz do Dramoxu na 3 měsíce","price_third":"<1>3. místo </1> <0/> 2 lístky do divadla <0/> poukaz do Dramoxu na 1 měsíc","chance_title":"🌷Náš tip: Čím víc představení uvidíte, tím větší máte šanci na výhru","chance_text":"Příklad: Anna v úterý 12. 4. zhlédla jedno představení, další si pustila ve středu 13. 4. a ve čtvrtek 14. 4. V závěrečném slosování bude její jméno celkem 3x a má tak trojnásobnou šanci na výhru.","how_to_title":"Jak soutěžit","how_to_1":"<0>Registrujte se ve formuláři.</0> Použijte e-mail, kterým jste registrovaní na Dramoxu.","how_to_2":"V období od 12. do 18. 4. 2022 zhlédněte co nejvíce představení na Dramox.cz. Čím víc si jich pustíte, tím víckrát vás zařadíme mezi soutěžící o první tři ceny.","how_to_3":"Na konci soutěžního období v úterý 19. 4. 2022 náhodně vybereme tři z vás, kteří získají jednu z výše uvedených cen. Ve hře jsou vstupenky do Městských divadel pražských a dárkové poukazy na předplatné Dramoxu.","how_to_4":"O výhercích soutěže vás budeme informovat e-mailem. Sledujte nás také na sociálních sítích <facebook>Facebook</facebook>, <instagram>Instagram</instagram>, <twitter>Twitter</twitter> a <youtube>YouTube</youtube> – získáte spoustu inspirace, co si právě pustit. Máte chuť na Jedlíky čokolády nebo třeba kávičku s Maryšou?","btn_signin":"Přihlásit se do soutěže","rules_title":"Zjednodušená pravidla soutěže Velikonoce s Dramoxem:","rule_1":"Soutěž začíná 11. 4. 2022 v 0:01, končí 18. 4. 2022 ve 23:59.","rule_2":"Zapojit se může každý divák registrovaný na Dramox.cz, který má aktivní předplatné nebo využívá zkušební 7denní období, a současně se registroval do soutěže Velikonoce s Dramoxem prostřednictvím soutěžního formuláře.","rule_3":"Vítězové budou vybráni náhodným výběrem ze všech soutěžících, kteří se v daném období (viz bod 1) do soutěže zapojili. Vítěze vyhlásíme na našich sociálních sítích a v newsletterech.","rule_more":"Kompletní pravidla soutěže Velikonoce s Dramoxem jsou <0>zde</0>.","tag_title":"Soutěž Velikonoce | Dramox"}');

/***/ }),

/***/ 58588:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"reset_password_h1":"Nastavte si heslo a máte hotovo.","new_password":"Nové heslo","new_password_again":"Nové heslo znovu","submit":"Potvrdit","reset_password_placeholder":"Alespoň 8 znaků","reset_password_error":"Platnost odkazu pro obnovení hesla již vypršela."}');

/***/ }),

/***/ 14103:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"items":{"1":{"q":"Co je Dramox?","a":"Dramox je největší online videotéka s divadlem na světě. Na jednom místě najdete více než 450 záznamů divadelních představení z celé ČR i ze zahraničí, která si kdykoliv snadno pustíte na chytré televizi, na počítači, tabletu i v mobilním telefonu, a navíc zcela bez reklam. Neustále přidáváme nová představení a obsah Dramoxu rozšiřujeme. Můžete být v divadle třeba každý den, aniž byste se převlékli z pyžama."},"2":{"q":"Co mohu na Dramoxu sledovat?","a":"Najdete u nás stovky představení všech žánrů z více než 250 divadelních scén včetně těch, kde je neustále vyprodáno nebo kam to máte lán cesty. V rámci předplatného máte kdykoliv k dispozici archivní a dnes již legendární divadelní inscenace, cenami ověnčené herecké osobnosti nebo čerstvé divadelní novinky. Všechno máme - drama, komedii, operu, balet, muzikál, nový cirkus i bohatou nabídku představení pro děti. Stačí si vybrat."},"3":{"q":"Kolik Dramox stojí?","a":"Měsíc s Dramoxem vás vyjde na méně než jedna vstupenka do divadla. Měsíční předplatné pořídíte za {{monthly}}, a když si Dramox předplatíte na celý rok za {{yearly}}, ušetříte ročně {{yearlyDiscount}}. Dramox vznikl na podporu divadla, celých 55 % z každého předplatného tedy posíláme zpět divadlům, autorům a hercům. Spolu s námi tak podporujete divadelní kulturu, jako kdybyste chodili do divadla. Děkujeme."},"4":{"q":"Kolik představení mohu vidět?","a":"Kolik chcete a jak často chcete. Počet sledování není omezen. V rámci předplatného se můžete dívat na libovolný počet představení nebo sledovat svoje oblíbené kusy opakovaně. Jak se vám líbí."},"5":{"q":"Jak mohu předplatné zrušit?","a":"Jednoduše: přihlaste se do svého profilu na Dramoxu, v pravém horním rohu klikněte na červené kolečko a zvolte položku „Můj profil“. Otevře se vám stránka vašeho profilu, kde zvolíte „Zrušit předplatné“. A máte hotovo, po skončení předplaceného období (měsíc nebo rok) se vám již předplatné znovu neobnoví. Váš profil ale nezanikne, můžete se tedy k divadlu kdykoliv vrátit."}}}');

/***/ }),

/***/ 58700:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Často se ptáte","know_more":"Nenašli jste, co jste hledali? Napište nám prosím na","items":{"1":{"q":"Co je Dramox?","a":"Dramox je divadlo online. Streamovací služba, která za měsíční předplatné nabízí největší výběr divadelních záznamů na jednom místě.\\n\\nSledujte svá oblíbená představení nebo objevujte nová, kdykoliv a kdekoliv budete chtít, a to zcela bez reklam. Pravidelně přidáváme nová představení."},"2":{"q":"Co mohu na Dramoxu sledovat?","a":"Najdete u nás stovky představení všech žánrů z více než 250 divadelních scén včetně těch, kde je neustále vyprodáno nebo kam to máte lán cesty. V rámci předplatného máte kdykoliv k dispozici archivní a dnes již legendární divadelní inscenace, cenami ověnčené herecké osobnosti nebo čerstvé divadelní novinky. Všechno máme - drama, komedii, operu, balet, muzikál, nový cirkus i bohatou nabídku představení pro děti. Stačí si vybrat."},"3":{"q":"Kolik představení mohu vidět?","a":"Kolik chcete a jak často chcete. Počet sledování není omezen. V rámci předplatného se můžete dívat na libovolný počet představení nebo sledovat svoje oblíbené kusy opakovaně. Jak se vám líbí."},"4":{"q":"Jak mohu divadlo sledovat?","a":"Pro přehrávání potřebujete webový prohlížeč a internetové připojení. Stačí se jen zaregistrovat na Dramoxu a poté si již užíváte divadlo online kdykoliv a kdekoliv budete chtít. Pro větší pohodlí si stáhněte mobilní nebo televizní aplikaci. Využít můžete také bezdrátový přenos obrazu a zvuku prostřednictvím Chromecast a AirPlay."},"5":{"q":"Kolik Dramox stojí?","a":"Měsíc s Dramoxem vás vyjde na méně než jedna vstupenka do divadla. Měsíční předplatné pořídíte za {{monthly}}, a když si Dramox předplatíte na celý rok za {{yearly}}, ušetříte ročně {{yearlyDiscount}}. Dramox vznikl na podporu divadla, celých 55 % z každého předplatného tedy posíláme zpět divadlům, autorům a hercům. Spolu s námi tak podporujete divadelní kulturu, jako kdybyste chodili do divadla. Děkujeme."},"6":{"q":"Kde všude je Dramox dostupný?","a":"S Dramoxem se můžete bavit kdekoliv na světě. Máme pro vás tu nejširší nabídku divadelních představení, ať už se opalujete v Karibiku nebo právě sjíždíte sjezdovky v Alpách. Užívejte si divadlo online bez hranic. I přes to, že se snažíme vyjednávat licence do všech zemí světa, některá představení nemusí být ve vaší zemi dostupná."},"7":{"q":"Jsou na Dramoxu reklamy?","a":"Nejsou, ani to neplánujeme."},"8":{"q":"Jak mohu předplatné zrušit?","a":"Jednoduše: přihlaste se do svého profilu na Dramoxu, v pravém horním rohu klikněte na červené kolečko a zvolte položku „Můj profil“. Otevře se vám stránka vašeho profilu, kde zvolíte „Zrušit předplatné“. A máte hotovo, po skončení předplaceného období (měsíc nebo rok) se vám již předplatné znovu neobnoví. Váš profil ale nezanikne, můžete se tedy k divadlu kdykoliv vrátit."},"9":{"q":"Jak mohu předplatné znovu aktivovat?","a":"Přihlaste se do svého profilu na Dramoxu. V pravém horním rohu klikněte na červené kolečko a zvolte „Můj profil“. Otevře se vám stránka vašeho profilu, kde zvolíte „Koupit předplatné“."},"10":{"q":"Jak sledovat Dramox na chytré televizi bez aplikace?","a":"Náš přehrávač podporuje také bezdrátový přenos obrazu a zvuku prostřednictvím Chromecast a AirPlay. Pokud vaše televize používá tyto technologie, můžete si jednoduše promítat představení Dramoxu z mobilního telefonu do televize. Spusťte ve svém mobilním telefonu vybrané představení, v pravém dolním rohu se objeví ikonka monitoru. Po kliknutí na ni se vám zobrazí nabídka televizí, které jsou připojené ke stejné wi-fi síti a podporují technologie Chromecast a Airplay. Vyberte vaši televizi a během pár vteřin se vám začne představení přehrávat na televizi. Ovládat ho můžete přímo z telefonu."},"11":{"q":"Máte Dramox aplikaci pro chytré televize?","a":"Ano, aktuálně máme aplikaci pro chytré televize Samsung a LG. Více informací, jak si televizní aplikaci Dramox nainstalovat, najdete na stránce <linkSmartTvGuide>Chytré televize</linkSmartTvGuide>. Brzy se také pustíme do vývoje aplikací pro ostatní televize."},"12":{"q":"Je Dramox dostupný i v chytrém telefonu?","a":"Ano, je. Stáhněte si mobilní aplikaci Dramox pro maximální pohodlí při sledování divadla online. Aplikaci pro iOS stahujte v <linkAppStore>App Store</linkAppStore>, aplikaci pro Android najdete na <linkGooglePlay>Google Play</linkGooglePlay>."},"13":{"q":"Jaká divadla najdu v Dramoxu?","a":"Všechna spolupracující divadla uvádíme na stránce <linkAboutUs>O projektu</linkAboutUs>."},"14":{"q":"Jak funguje zkušební období?","a":"Vyzkoušejte divadlo online ZDARMA na 7 dní. Stačí se registrovat. Pokud se vám Dramox líbí, nemusíte dělat nic, předplatné se aktivuje automaticky. Když se před koncem zkušební doby rozhodnete předplatné ukončit, nebudeme vám nic účtovat. Již aktivní předplatné snadno zrušíte pár kliknutími ve svém profilu. Bez sankcí a dalších závazků.","no_trial_q":"Jak Dramox funguje?","no_trial_a":"Pokud se rozhodnete předplatné zrušit před jeho ukončením, nebudou vám účtovány žádné poplatky. Aktivní předplatné můžete jednoduše zrušit ve svém účtu."},"15":{"q":"Jak mohu divadlo podpořit?","a":"Jednoduše tím, že budete Dramox využívat a sledovat záznamy divadelních představení. Polovina z každého předplatného jde přímo divadlům, autorům a hercům. Svým oblíbeným tvůrcům můžete věnovat i další libovolnou částku navíc. Předáme jim téměř celý darovaný obnos. Pro sebe si nic nenecháme, pouze zaplatíme platební bráně za poskytnutí technologie pro bezpečnou platbu."},"16":{"q":"Na kolika zařízeních můžu Dramox sledovat?","a":"Ke sledování Dramoxu můžete použít tolik zařízení, kolik chcete, ne však s jedním účtem souběžně. To znamená, že pokud si chcete Dramox pustit na telefonu a ve stejný okamžik také na počítači, potřebujete dva oddělené účty. Pokud ale doma sledujete Dramox na notebooku a v tramvaji cestou do práce si pustíte představení v tabletu, stačí vám účet jeden."},"17":{"q":"Můžu předplatné Dramoxu koupit jako dárkový poukaz?","a":"Divadlo online jako dárek? Skvělý nápad! V nabídce máme předplatné Dramoxu na 1 měsíc, 3 měsíce, 6 měsíců nebo celý rok. Poukaz můžete použít 1 rok ode dne zakoupení. Jeho platnost začíná okamžikem, kdy ho aktivujete. Více o dárkových poukazech najdete na stránce <linkVouchers>Dárkové poukazy</linkVouchers>."},"18":{"q":"Jak uplatnit poukaz, když mám aktivní předplatné?","a":"Přihlaste se do svého profilu na Dramoxu. V pravém horním rohu klikněte na červené kolečko a zvolte „Můj profil“. Otevře se vám stránka vašeho profilu, kde zvolíte „Zrušit předplatné“. Jakmile období vašeho aktuálního předplatného skončí, vyzveme vás, abyste pro další sledování uhradili nové předplatné. Ve svém profilu při výběru předplatného zvolíte „Mám dárkový poukaz“ a zadáte svůj unikátní kód z poukazu."},"19":{"q":"Jak zvát přátele do Dramoxu a získat až 5 měsíců předplatného zdarma?","a":"<p>Baví vás Dramox a znáte někoho, koho by divadlo online bavilo také? Doporučte nás a získejte až 5 měsíců předplatného zdarma. Nabídku může využít každý, kdo je registrovaný na <linkDramox>Dramox.com.ua</linkDramox> a má nebo měl předplatné Dramoxu, popřípadě využil dárkový poukaz. </p> <p>Jak na to? Přihlaste se do svého profilu, klikněte na červené kolečko v pravém horním rohu a vyberte Pozvat přátele. Zde máte připravený promo kód, který můžete sdílet až s 5 přáteli a získat tak 5 měsíců předplatného zdarma. </p> <p>Za každého, kdo se registruje na Dramoxu, zadá promo kód a aktivuje své předplatné, vám automaticky přidáme 1 měsíc předplatného zdarma. Celkem tak můžete Dramox zdarma sledovat až 5 měsíců a ušetřit téměř 1 500 Kč. Přátelé, kteří si aktivují předplatné Dramoxu, získají také 1 měsíc předplatného zdarma. </p> <p> Ještě nemáte profil na Dramoxu? Registrujte se <linkRegister>tady</linkRegister>. Stačí pár kliknutí a máte prvních 7 dní s Dramoxem zdarma, poté se vám automaticky aktivuje měsíční předplatné. Pak už můžete začít rozdávat promo kód a získat až 5 měsíců divadla online zdarma.</p>","no_trial_a":"Baví vás Dramox a znáte někoho, koho by divadlo online bavilo také? Doporučte nás a získejte až 5 měsíců předplatného zdarma. Tuto nabídku může využít každý, kdo je registrován na <linkDramox>Dramox.tv</linkDramox> s aktivním nebo neaktivním předplatným, a to pomocí kreditní karty nebo voucheru. Stačí se přihlásit ke svému účtu Dramox, najet na červenou ikonu vpravo nahoře a v rozbalovací nabídce kliknout na „Pozvat přátele“. Poté si můžete zobrazit svůj promo kód, který lze použít až pětkrát. Pozvěte své přátele, aby vyzkoušeli naši platformu pro streamování divadelních představení, a získejte až 5 měsíců předplatného zdarma. Za každého, kdo se registruje na Dramoxu, zadá váš promo kód a aktivuje své předplatné, vám automaticky přidáme 1 měsíc předplatného zdarma. Přátelé, kteří si aktivují předplatné Dramoxu, získají také 1 měsíc předplatného zdarma. Ještě nemáte účet na Dramoxu? Zaregistrujte se <linkRegister>zde</linkRegister> a vyberte si svůj plán předplatného.\\n"}}}');

/***/ }),

/***/ 73675:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Zapomněli jste heslo? Nevadí, pomůžeme.","email":"E-mail","email_placeholder":"Zadejte e-mailovou adresu","btn":"Obnovit heslo","server_error":"E-mail neexistuje.","changes_not_saved":"Obnovení hesla se nezdařilo. Prosím opakujte akci později.","changes_saved":"Odkaz na obnovení hesla jsme zaslali na Váš e-mail."}');

/***/ }),

/***/ 66993:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Sledujte Dramox doma i na cestách","web":{"title":"Počítače\\na notebooky","supported_browsers":"Podporované prohlížeče","subtitle":"Webový portál Dramox","content":"Podporujeme většinu běžných prohlížečů dostupných na operačních systémech Windows, Linux a macOS.","button":"Začít sledovat"},"smart_tv":{"title":"Chytré televize","samsung_title":"Televizní aplikace pro Samsung","samsung_description":"Aplikace Dramox pro modely 2018 a vyšší s operačním systémem Tizen 4.0 a vyšším","lg_title":"Televizní aplikace pro LG","lg_description":"Aplikace Dramox pro modely 2016 a vyšší s operačním systémem WebOS 3.0 a vyšším","button":"Návod k instalaci"},"mobile":{"title":"Chytré telefony\\na tablety","android_title":"Mobilní aplikace pro Android","android_description":"Podporujeme mobilní telefony a tablety s operačním systémem Android 5.1.1 a vyšší.","ios_title":"Mobilní aplikace pro iOS","ios_description":"Podporujeme mobilní telefony a tablety s operačním systémem iOS 11 a vyšší.","button":"Návod k instalaci"},"streaming":{"title":"Chromecast\\na AirPlay","airplay_title":"Apple AirPlay","airplay_description":"Sdílejte divadelní představení do své televize díky technologii AirPlay od Applu.","chromecast_title":"Google Chromecast","chromecast_description":"Sdílejte divadelní představení do své televize díky technologii Chromecast od Googlu.","button":"Jak to funguje"}}');

/***/ }),

/***/ 18380:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Pozvěte přátele a získejte až 5 měsíců Dramoxu zdarma","code_for_friend":"Promo kód pro vaše přátele (1 kód můžete předat až 5 přátelům)","copy_code":"Zkopírovat kód","what_to_do":"Co musí mí přátelé udělat?","step_1":"Vytvoří si nový účet na Dramoxu.","step_2":"Při výběru svého předplatného zadají promo kód: <0>{{promoCode}}</0>","step_3":"Aktivují předplatné alespoň na 1 měsíc zadáním platební karty.\\n","step_4":"Po první stržené platbě za předplatné získáte vy i váš přítel 1 měsíc Dramoxu zdarma.","invited_friends":"Pozvaní přátelé","invite_benefit":"Pozvěte přátele a získejte zdarma až 5 měsíců s Dramoxem. Přátelé, kteří si aktivují předplatné Dramoxu, získají také 1 měsíc zdarma.","title_not_allowed":"Zvaní přátel je dostupné pouze uživatelům s předplatným","buy_subscription":"Koupit předplatné","more_1":"Více informací o předplatném zjistíte v sekci ","more_2":"Často se ptáte","code_copied":"Kód zkopírován","description_not_allowed":"Pozvat přátele může pouze uživatel, který má nebo měl předplatné Dramoxu, popřípadě využil dárkový poukaz. Zatím jste si Dramox nikdy nepředplatili? Kupte si předplatné hned teď, doporučte Dramox přátelům a získejte až 5 měsíců divadla online zdarma. Pokud se zrovna nacházíte ve zkušebním období zdarma, musíte počkat, dokud neproběhne první platba.","no_trial_description_not_allowed":"Tato nabídka je dostupná pro všechny registrované na <linkDramox>Dramox.cz</linkDramox> s aktivním nebo neaktivním předplatným, s použitím kreditní karty nebo voucheru. Ještě nemáte účet na Dramoxu? Zaregistrujte se <linkRegister>zde</linkRegister> a vyberte si své předplatné."}');

/***/ }),

/***/ 40692:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"login":"Přihlášení","not_register_yet":"Nemáte účet?","try_trial":"Chci Dramox na 7 dní ZDARMA","email":"E-mail","password":"Heslo","forgotten_password":"Zapomněli jste heslo?","login_btn":"Přihlásit","not_activated":"Omlouváme se, ale Váš účet ještě nebyl aktivován. Pokud je Váš účet již aktivní, prosím kontaktujte nás.","no_trial_try_trial":"Začněte své dobrodružství s Dramoxem."}');

/***/ }),

/***/ 73108:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"android_title":"Mobilní aplikace pro Android","android_description":"Dostupné pro mobilní telefony a tablety s operačním systémem Android 5.1.1 a vyšší. Potřebujete poradit? Napište nám prosím na <a href=\\"mailto:napoveda@dramox.cz\\">napoveda@dramox.czt</a>.","android_instalation":"Instalace mobilní aplikace Dramox","android_step_1":"<a href=\\"https://play.google.com/store/apps/details?id=cz.dramox.dramox\\" target=\\"_blank\\">Klikněte na tento odkaz pro stažení aplikace</a> nebo na mobilním telefonu otevřete obchod s aplikacemi Google Play a zadejte do vyhledávače Dramox.","android_step_2":"Nainstalujte aplikaci kliknutím na tlačítko <strong>Instalovat</strong>.","android_step_3":"Otevřete nově nainstalovanou aplikaci Dramox.","android_step_4":"Po spuštění aplikace se přihlaste pomocí e-mailu a hesla, které používáte pro přihlášení do svého účtu na Dramoxu.","android_step_5":"Líbí se vám aplikace Dramox? Ohodnoťte ji prosím v obchodě s aplikacemi Google Play.","ios_title":"Mobilní aplikace pro iOS","ios_description":"Dostupné pro mobilní telefony a tablety s operačním systémem iOS 11 a vyšší. Potřebujete poradit? Napište nám prosím na <a href=\\"mailto:napoveda@dramox.cz\\">napoveda@dramox.cz</a>.","ios_instalation":"Instalace mobilní aplikace Dramox","ios_step_1":"<a href=\\"https://apps.apple.com/cz/app/dramox-divadlo-online/id1563430137?l=cs\\" target=\\"_blank\\">Klikněte na tento odkaz pro stažení aplikace</a> nebo na mobilním telefonu otevřete obchod s aplikacemi App Store a zadejte do vyhledávače Dramox.","ios_step_2":"Nainstalujte aplikaci kliknutím na tlačítko <strong>Získat</strong>.","ios_step_3":"Otevřete nově nainstalovanou aplikaci Dramox.","ios_step_4":"Po spuštění aplikace se přihlaste pomocí e-mailu a hesla, které používáte pro přihlášení do svého účtu na Dramoxu.","ios_step_5":"Líbí se vám aplikace Dramox? Ohodnoťte ji prosím v obchodě s aplikacemi App Store."}');

/***/ }),

/***/ 62214:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"premiere":"Premiéra","trailer":"Upoutávka","support":"Podpořit","genres":"Žánry","awards":"Získané ocenění","same_cast":"Stejní účinkující","similar_genre":"Žánrově podobné","theatre_more":"Více od tohoto divadla","show_all":"Zobrazit vše","cast":"Herecké obsazení","donate_bubble_title":"Líbilo se vám představení?","donate_bubble_link":"Podpořte divadlo","playback_error_title":"Video nyní nelze přehrát.","playback_error_content":"Je nám líto, ale požadované představení nelze přehrát. Zkontrolujte prosím své připojení k internetu a akci opakujte.","playback_error_action":"Vrátit se na detail představení","low_quality":"Inscenace se sníženou kvalitou záznamu","support_theater":"Podpořte divadlo online","watch_list":"Můj seznam","on_watch_list":"Na seznamu","added_to_watch_list":"Přidáno na seznam","removed_from_watch_list":"Odebráno ze seznamu"}');

/***/ }),

/***/ 93409:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"auto_quality":"Automaticky","back":"Zpět","captions":"Titulky","cast_to_other_devices":"Chromecast","enter_picture_in_picture":"Zapnout mini přehrávač","exit_fullscreen":"Vypnout režim celé obrazovky","exit_picture_in_picture":"Vypnout mini přehrávač","fullscreen":"Režim celé obrazovky","language":"Jazyk","live":"Živě","more_settings":"Další nastavení","multiple_languages":"Více jazyků","mute":"Vypnout zvuk","not_applicable":"Nelze aplikovat","off":"Vypnuto","on":"Zapnuto","pause":"Pozastavit","picture_in_picture":"Mini přehrávač","play":"Spustit","resolution":"Kvalita","seek":"Posunout","undetermined_language":"Neznámý jazyk","unmute":"Zapnout zvuk","volume":"Hlasitost"}');

/***/ }),

/***/ 8433:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"activate_subscription_title":"Aktivujte si předplatné","activate_subcription_content":"A získejte přístup k desítkám legálních divadelních záznamů ke zhlédnutí online!","activate_subscription_button":"Vybrat předplatné","login_title":"Přihlášení","login_content":"Přehrání divadelní hry je dostupné pouze přihlášeným uživatelům s aktivním předplatným.","login_action":"Přihlásit","login_footer":"Nemáte účet? <0>Zaregistrujte se</0>","low_quality_title":"Snížená kvalita záznamu","low_quality_text":"Omluvte prosím sníženou kvalitu. Tento záznam je jediný a ten nejlepší, který máme k dispozici. Inscenace nás však zaujala natolik, že by byla škoda nepředstavit vám ji na Dramoxu. Proto jsme se rozhodli ji zde uvést i přes nižší kvalitu. Přejeme vám příjemné divadelní zážitky.","low_quality_btn":"Rozumím"}');

/***/ }),

/***/ 50945:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"my_profile":"Můj profil","subscription":"Předplatné","subscription_unlimited":"Aktuálně využíváte neomezené předplatné.","unlimited_description":"Užijte si sledování na Dramoxu!","monthly":"Měsíční","yearly":"Roční","price_with_vat":"{{price}} s DPH","voucher":"Mám dárkový poukaz","subscription_none":"Kupte měsíční nebo roční předplatné na Dramox","subscription_none_text":"A získejte přístup k desítkám legálních divadelních záznamů ke zhlédnutí online!","personal_details":"Osobní údaje","full_name":"Jméno a příjmení","save_changes":"Uložit změny","password_change":"Změna hesla","password_change_success":"Heslo se změnilo.","password_change_fail":"Změna hesla se nezdařila.","account_delete_success":"Účet byl smazán.","actual_password":"Aktuální heslo","new_password":"Nové heslo","new_password_again":"Nové heslo znovu","purchase_history":"Historie objednávek","delete_account":"Smazat účet","delete_account_text":"Smazáním účtu dojde k zaniknutí aktivního předplatného a smazání veškerých dat na serveru Dramox.","theatre_donate":"Příspěvek divadlu","subscription_bundles":"Předplatné","voucher_pay":"Dárkový poukaz","empty_purchase":"Při první platbě za předplatné nebo příspěvek divadlu, v této sekci uvidíte historii plateb.","recurrence_monthly":"Aktuálně využíváte měsíční předplatné.","recurrence_quarterly":"Aktuálně využíváte 3 měsíční předplatné.","recurrence_semi_annual":"Aktuálně využíváte půlroční předplatné.","recurrence_yearly":"Aktuálně využíváte roční předplatné.","subscription_expired_trial":"Zkušební období Vám skončí <0>{{date}}</0>. Stejný den dojde k zakoupení předplatného.","subscription_expired":"K automatické obnově předplatného dojde <0>{{date}}</0>","delete_account_title":"Smazání účtu","delete_popup_close":"Zavřít","delete_account_submit":"Smazat celý účet","delete_subscription_title":"Zrušení předplatného","delete_subscription_text":"Stávající plán Vám zůstává až do jeho vypršení. Poté jej automaticky zrušíme.","cancel_subscription":"Zrušit předplatné","choose_card":"Zvolit kartu","choose_card_text":"Opravdu chcete použít kartu pro všechny budoucí platby?","btn_submit":"Potvrdit","remove_card":"Odstranit kartu","remove_card_text":"Opravdu chcete odstranit platební kartu ze svého účtu?","card_primary":"hlavní","card_choose":"Vybrat","card_no_added":"Nebyla přidána žádná karta.","subscription_end_description":"Váš plán automaticky skončí <0>{{date}}</0>.","profile_changes_not_saved":"Změny se nepodařilo uložit. Prosím opakujte akci později.","profile_changes_saved":"Změny uloženy","card_added":"Platební karta přidána.","card_added_error":"Vaše karta byla zamítnuta. Prosím zkontrolujte zadané údaje a platnost karty.","load_more":"Načíst více","subscription_canceled_success":"Předplatné je nyní zrušeno!","subscription_canceled_fail":"Zrušení předplatného selhalo.","payment_card_delete_success":"Platební karta byla odebrána.","payment_card_delete_fail":"Odebrání platební karty selhalo.","change_payment_card_primary_success":"Primární karta byla nastavena.","change_payment_card_primary_fail":"Nastavení primární karty selhalo.","email_newsletter":"Newsletter","email_newsletter_text":"Přejete si dostávat e-mailem newsletter o novinkách na Dramoxu?","email_newsletter_action_subscribe":"Chci odebírat novinky","email_newsletter_action_unsubscribe":"Odhlásit","email_newsletter_success_title":"Děkujeme za příhlášení k odběru novinek.","email_newsletter_success_description":"Nyní můžete toto okno zavřít.","residency_tooltip":"Pokud jste rezidentem jiné země, kontaktujte prosím naši podporu.","language_select":"Výběr jazyka","grace_period_title":"Předplatné se nedaří automaticky prodloužit","grace_period_description":"Zkontrolujte prosím své platební údaje a výši zůstatku na kartě. Do {{date}} se budeme jednou denně pokoušet předplatné automaticky prodloužit. Poté přestane být služba dostupná a předplatné zrušíme.","grace_period_action":"Uhradit nyní - {{price}}","delete_subscription_grace_text":"Plán bude zrušen","ui_language":"Jazyk webové stránky","prolonged_subscription":"Prodloužili jsme vám předplatné.","remove_sub_promo_title":"Je nám líto, že chcete odejít","remove_sub_promo_text":"Pozvěte přátelé a získejte Dramox až na 5 měsíců zdarma","remove_sub_get_more":"Zjistit více","remove_sub_or":"nebo","remove_sub_removing":"Předplatné zrušte. Stávající plán Vám bude ponechán až do jeho vypršení. Poté bude automaticky zrušen.","sub_from_campaign":"Momentálně využíváte období zdarma z promo akce.","sub_from_user":"Momentálně využíváte období zdarma od Vašich přátel.","discount_info":"Do {{date}} využíváte slevu {{discount}}% na zakoupené předplatné.","promo_discount_title":"<0>{{discount}}%</0>sleva na {{timespan}}","promo_discount_content":"Aktivací získáte {{discount}}% slevu na předplatné na {{timespan}}.","promo_free_title":"<0>{{timespan}}</0>předplatného zdarma","promo_free_content":"Aktivací získáte {{timespan}} navíc k vašemu aktuálnímu předplatnému.","promo_action":"Aktivovat slevu","promo_activation_success":"Promo kód aktivován.","promo_activation_fail":"Promo kód se nepodařilo aktivovat.","no_trial_subscription_expired_trial":"Vaše předplatné automaticky obnovíme {{date}}.","promo_code_heading":"Zadat dárkový poukaz nebo promo kód","promo_code_input_placeholder":"Zadat kód","promo_code_button_enter":"Zadat kód","promo_code_button_activate":"Aktivovat"}');

/***/ }),

/***/ 24778:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Stovky legálních divadelních záznamů ke zhlédnutí online","description":"<0>Prvních 7 dní máte <1>ZDARMA</1>. Předplatné můžete kdykoliv zrušit.</0>","full_name":"Jméno a příjmení","email":"E-mail","btn_continue":"Pokračovat","register_terms":"<0>Kliknutím na tlačítko „Pokračovat“ souhlasíte s <1>Obchodními podmínkami</1> a <2>Ochranou soukromí</2>.</0>","already_account":"Už máte účet?","login_prompt":"Přihlaste se","setup_password":"Hurá, blížíte se do cíle. Nyní si prosím nastavte heslo.","password_placeholder":"Alespoň 8 znaků","password":"Heslo","password_again":"Heslo znovu","changes_not_saved":"Požadavek se nepodařilo zpracovat. Prosím opakujte akci později.","changes_saved":"Změny uloženy","confirm_email_title":"Prosím zkontrolujte svou e-mailovou schránku.","confirm_email_text":"<0>Na adresu <1>{{email}}</1> jsme Vám zaslali e-mail s odkazem k aktivaci Vašeho účtu.</0>","country_of_residence":"Země pobytu","no_trial_description":"<0>Své předplatné můžete kdykoliv zrušit. </0>"}');

/***/ }),

/***/ 6320:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"forschools_bottom_desc":"Předplaťte si divadlo online za poloviční cenu {{studentMonthly}} na měsíc pro jednoho studenta.","forschools_button":"Objednat Dramox pro školu","forschools_description":"Dramox pro školy vám dává možnost, jak udělat výuku zábavnější. Studenti objeví krásy divadla a literatury způsobem, na jaký jsou zvyklí – sledováním videa online. Užijí si také vyplňování pracovních listů, které k nim mluví jazykem, jemuž rozumí – emotikony, FB příspěvky, obrázky...","forschools_footer":"Dramox pro školy","forschools_for_class_desc_1":"Napište nám prosím na <0>skoly@dramox.cz</0>.","forschools_for_class_desc_2_1":"My se vám co nejdříve ozveme. Společně dořešíme podrobnosti a domluvíme se, kolik poukazů si jako škola nebo třída objednáte.","forschools_for_class_desc_2_2":"Důležité: Každý student potřebuje svůj vlastní poukaz s unikátním kódem. Bohužel si nemůžete jako škola objednat jen jeden, který budete sdílet ve více lidech.","forschools_for_class_desc_3":"Škola zaplatí poukazy.","forschools_for_class_desc_4":"Po potvrzení platby vám poukazy obratem zašleme elektronicky.","forschools_for_class_desc_5":"Poukazy předáte svým studentům. Ti se registrují na Dramoxu a mohou začít sledovat divadlo online. Měsíc, tři nebo třeba celý rok, podle délky předplatného.","forschools_for_class_title":"Jak objednat divadlo online pro svou třídu nebo školu?","forschools_for_who_desc_1":"Pro střední školy a gymnázia, vyšší odborné a vysoké školy, případně poslední ročníky základní školy (žáky 8. a 9. tříd).","forschools_for_who_desc_2":"Pokud nepatříte k těmto institucím, ale zabýváte se vzděláváním a rádi byste tuto nabídku využili, napište nám prosím na <0>skoly@dramox.cz</0>. Něco vymyslíme.","forschools_for_who_title":"Pro koho je tato nabídka","forschools_obligatory":"V nabídce máme desítky příběhů z <0>povinné četby</0>, díky kterým se studenti dozví, koho milovala Maryša, kdo byl Raskolnikov i jak to dopadlo s Faustem. Další inscenace budou přibývat. Kromě povinné četby mohou studenti zhlédnout také desítky dalších divadelních záznamů. Klidně s popcornem a v teplákách.","forschools_price":"{{studentMonthly}}","forschools_price_desc":"měsíčně / pro jednoho studenta","forschools_student_price_desc":"Cena měsíčního předplatného je {{studentMonthly}} pro jednoho studenta. To je {{studentMonthlyPercentageDiscount}} % ceny oproti běžnému předplatnému za {{monthly}}.","forschools_student_price_title":"Jaká je zvýhodněná cena pro studenty?","forschools_title":"Dramox pro školy"}');

/***/ }),

/***/ 43328:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"welcome_title":"Dramox | Vaše divadlo online","welcome_description":"Vyzkoušejte Dramox na 7 dní ZDARMA a sledujte online stovky divadelních představení.","browse_title":"Stovky divadelních představení online | Dramox","browse_description":"Vybírejte na Dramoxu ze stovek divadelních představení online. To nejlepší z desítek divadel. Vyzkoušejte ZDARMA.","celebrity_title":"{{name}} | Divadlo online | Dramox","performance_title":"{{title}} | {{theatre}} online | Dramox","watch_performance_title":"{{title}} – zhlédnout online | {{theatre}} | Dramox","theatres_title":"Vaše oblíbená divadla online | Dramox","theatres_description":"Sledujte na Dramoxu záznamy stovek divadelních představení z desítek českých i zahraničních divadel. Vyzkoušejte ZDARMA. Najděte si své oblíbené divadlo online.","theatre_title":"{{name}} | Divadlo online | Dramox","404_title":"Dramox divadlo online | Hledá se stránka","404_description":"Bohužel tato stránka na Dramoxu není. Zkusíte si místo ní vybrat ze stovek divadelních představení online?","about_us_title":"Dramox divadlo online | Seznamte se s námi","about_us_description":"Dramox nabízí ke zhlédnutí online stovky divadelních představení. Vyzkoušejte ZDARMA. Máme také s 50% slevou Dramox pro školy pro podporu online výuky.","authorship_title":"Dramox divadlo online | Chráníme autorská práva","authorship_description":"Dramox divadlem online podporuje divadelní kulturu. Děláme vše proto, abychom každému tvůrci zajistili spravedlivý podíl z díla. Máme pouze legální záznamy.","choose_plan_title":"Dramox | Divadlo online na měsíc, tři nebo celý rok?","choose_plan_description":"Vyberte svůj nový plán","contact_title":"Dramox divadlo online | Napište nám","contact_description":"Máte otázky k Dramoxu a divadelním představením online? E-mailem napoveda@dramox.cz kontaktujte prosím naše milé nápovědy. Vše s Vámi vyřeší.","cookies_title":"Dramox divadlo online | Pro lepší divácký zážitek","cookies_description":"Divadlo online Dramox používá cookies, malé pomocníky pro dokonalý divácký zážitek. Vyzkoušejte ZDARMA, vyberte si ze stovek divadelních představení.","donate_home_title":"Podpořte divadla","donate_title":"Dramox | Podpořte {{theatre}} online","donate_description":"Přispějte na Dramoxu online svému oblíbenému divadlu, podpoříte jeho tvorbu a divadelní kulturu. Divadlu předáme téměř celý darovaný obnos. Pro sebe si nic nenecháme, pouze zaplatíme platební bráně za poskytnutí technologie pro bezpečnou platbu.","for_schools_title":"Divadlo online pro školy | Dramox","for_schools_description":"Objednejte Dramox pro školu se slevou 50 %. Nabízíme desítky příběhů z povinné četby ke sledování online. ZDARMA pracovní listy pro zábavnější online výuku.","forgotten_password_title":"Dramox divadlo online | Zapomenuté heslo","forgotten_password_description":"Za chvíli můžete na Dramoxu opět sledovat divadlo online. Pro nové heslo zadejte prosím svůj e-mail.","frequently_asked_questions_title":"Dramox | Nápověda","frequently_asked_questions_description":"Dramox je divadlo online. Stovky představení na jednom místě k vyzkoušení ZDARMA. Zajímá vás víc? Podívejte se prosím do častých otázek a odpovědí.","vouchers_buy_title":"Darujte divadlo online | Dramox","vouchers_buy_description":"Poukaz do online divadla Dramox potěší každého. Darujte přístup ke stovkám divadelních představení a zábavě online. Kupte hned, darujte kdykoliv.","login_title":"Dramox divadlo online | Přihlášení diváka","login_description":"Za okamžik můžete sledovat divadlo online na Dramoxu. Přihlaste se prosím svým e-mailem a heslem, které jste zvolili při registraci.","playlist_performance_similar_genre_title":"{{performance}} – Váš oblíbený divadelní žánr online | Dramox","playlist_performance_similar_genre_description":"Na Dramoxu najdete svůj oblíbený žánr v divadelním představení {{performance}} online. Činohra, muzikál, balet i loutky – nové záznamy přidáváme pravidelně. Sledujte už dnes.","playlist_performance_similar_cast_title":"{{performance}} – Vaši oblíbení herci online | Dramox","playlist_performance_similar_cast_description":"Na Dramoxu najdete své oblíbené herce v divadelním představení {{performance}} online. Vyzkoušejte ZDARMA. Sledujte už dnes.","playlist_genre_title":"Online divadelní představení v žánru {{genre}} | Dramox","playlist_genre_description":"Užijte si na Dramoxu svůj oblíbený žánr divadelních představení online. Činohra, muzikál, balet i loutky – nové záznamy přidáváme pravidelně. Vyzkoušejte ZDARMA.","playlist_featured_title":"Divadelní představení online z kategorie {{section}} | Dramox","playlist_featured_description":"Na Dramoxu najdete online divadelní představení z kategorie {{section}}. Bavte se divadlem ještě více.","playlist_currently_watching_title":"Dramox divadlo online | Právě sledujete","playlist_currently_watching_description":"Na Dramoxu sledujete online stovky divadelních představení z desítek českých a zahraničních divadel. Vyzkoušejte ZDARMA, bavte se divadlem online už dnes.","playlist_most_popular_title":"Dramox divadlo online | Nejoblíbenější představení","playlist_most_popular_description":"Zhlédněte na Dramoxu online nejoblíbenější divadelní představení podle diváků. Tragédie, komedie, romantika i pohádky – vybere si celá rodina.","playlist_recent_title":"Máme nová představení | Dramox divadlo online","playlist_recent_description":"Zhlédněte na Dramoxu online nejnovější divadelní představení. Tragédie, komedie, romantika i pohádky – nové záznamy přidáváme pravidelně. Vždy sledujete něco jiného.","profile_title":"Dramox divadlo online | Profil diváka","profile_description":"Vítejte v online divadle Dramoxu. Vyberte si ze stovek divadelních představení. Tragédie, komedie, romantika i pohádky pro děti – bavte se divadlem ještě více.","register_step1_title":"Dramox divadlo online | Registrace nového uživatele","register_step1_description":"Za okamžik můžete sledovat online divadlo na Dramoxu. Nejprve se prosím registrujte. ZDARMA první týden.","register_step2_title":"Dramox divadlo online | Nastavení hesla","register_step2_description":"Za chvíli můžete sledovat online divadlo na Dramoxu. Zvolte si prosím své heslo. Heslo můžete kdykoliv změnit.","register_confirm_email_title":"Dramox divadlo online | Potvrzení e-mailové adresy","register_confirm_email_description":"Za chvíli můžete na Dramoxu sledovat divadlo online. Potvrďte prosím svou e-mailovou adresu.","terms_conditions_title":"Dramox divadlo online | Obchodní podmínky","terms_conditions_description":"V Dramoxu máme transparentní pravidla a podmínky online sledování stovek divadelních představení. Věříme, že jasná a otevřená komunikace dělá dobré přátele.","privacy_policy_title":"Dramox divadlo online | Ochrana soukromí","privacy_policy_description":"V Dramoxu chráníme vaše soukromí. Všechny osobní údaje jsou u nás v bezpečí. Využíváme spolehlivé technologie a pracujeme v souladu s GDPR.","how_to_watch_web_title":"Divadlo online ve vašem počítači | Dramox","how_to_watch_web_description":"Sledujte divadlo online pohodlně ve svém počítači. Stovky představení a největší herecké hvězdy už dnes večer u vás doma. Vyzkoušejte na 7 dní zdarma.","how_to_watch_tv_title":"Aplikace pro chytré televize | Dramox divadlo online","how_to_watch_tv_description":"Stáhněte si televizní aplikace Dramox pro chytré televize. Nejlepší divadelní představení už dnes večer u vás doma. Vyzkoušejte na 7 dní zdarma.","how_to_watch_tv_samsung_title":"Aplikace pro TV Samsung | Dramox divadlo online","how_to_watch_tv_samsung_description":"Stáhněte si televizní aplikaci Dramox pro chytré televize Samsung s OS Tizen a bavte se divadlem online ještě více. Vyzkoušejte na 7 dní zdarma.","how_to_watch_tv_lg_title":"Aplikace pro TV LG | Dramox divadlo online","how_to_watch_tv_lg_description":"Stáhněte si televizní aplikaci Dramox pro chytré televize LG s WebOS a užívejte si divadlo online s maximem pohodlí. Vyzkoušejte na 7 dní zdarma.","how_to_watch_mobile_title":"Mobilní aplikace pro Android a iOS | Dramox divadlo online","how_to_watch_mobile_description":"Stáhněte si mobilní aplikace Dramox pro chytré telefony a tablety. Stovky představení a největší herecké hvězdy máte kdykoliv po ruce. Sledujte 7 dní zdarma.","how_to_watch_mobile_ios_title":"Aplikace pro iOS | Dramox divadlo online","how_to_watch_mobile_ios_description":"Stáhněte si mobilní aplikaci Dramox pro chytré telefony a tablety s iOS. Divadlo online tak máte kdykoliv po ruce. Vyzkoušejte na 7 dní zdarma.","how_to_watch_mobile_android_title":"Aplikace pro Android | Dramox divadlo online","how_to_watch_mobile_android_description":"Vyzkoušejte aplikaci Dramox pro chytré telefony a tablety s OS Android a užívejte si stovky představení ve svém mobilu. Sledujte 7 dní zdarma.","how_to_watch_streaming_title":"Divadlo online z mobilu do televize | Dramox","how_to_watch_streaming_description":"Sledujte divadlo online ve své chytré televizi i bez aplikace. Přehrávač Dramoxu podporuje bezdrátový přenos přes AirPlay a Chromecast z telefonu do televize.","how_to_watch_streaming_chromecast_title":"Dramox z mobilu do televize přes Chromecast","how_to_watch_streaming_chromecast_description":"Pusťte si Dramox ve své chytré televizi i bez aplikace. Náš přehrávač podporuje bezdrátový přenos z telefonu do televize přes Chromecast. Bavte se divadlem online.","how_to_watch_streaming_airplay_title":"Dramox z mobilu do televize přes AirPlay","how_to_watch_streaming_airplay_description":"Sledujte Dramox ve své chytré televizi i bez aplikace. Náš přehrávač podporuje bezdrátový přenos z telefonu do televize přes AirPlay. Je to snadné a pohodlné.","playlist_dramox_originals_title":"Pouze na Dramoxu | Dramox Originals","playlist_dramox_originals_description":"Natáčíme představení, která online jinde neuvidíte. Dramox Originals najdete exkluzivně jen na Dramox.cz Bavte se divadlem online, vyzkoušejte 7 dní ZDARMA.","content_settings_title":"Jazyky představení | Dramox","content_settings_description":"Vytvořte si divadlo online přesně na míru. Divadelní představení na Dramoxu si tak užijete ve větším pohodlí.","ua_support":"Podporujeme ukrajinskou kulturu","easter_contest_title":"Velikonoční soutěž o vstupenky a poukazy | Dramox","easter_contest_desc":"Vyhrajte lístky do divadel a dárkové poukazy. Bavte se během Velikonoc divadlem online. Čím víc představení na Dramoxu uvidíte, tím větší šance na výhru.","discount_title":"Sleva 50 % na 6 měsíců předplatného | Dramox","discount_description":"Sledujte divadlo online až 6 měsíců jen za 149 Kč/měsíc a ušetřete 900 Kč oproti běžnému předplatnému. Nabídka platí pouze 7 dní. Aktivujte si ji hned teď.","broadcast_title":"Živé vysílání","broadcast_description":"Živé vysílání novinek na Dramoxu","no_trial_how_to_watch_web_description":"Sledujte divadlo online pohodlně ve svém počítači. Získejte přístup ke stovkám představení a nejlepším divadlům přímo z domova.","no_trial_how_to_watch_tv_description":"Stáhněte si naši aplikaci pro chytré televize a bavte se nejlepším divadlem z celého světa.","no_trial_how_to_watch_tv_samsung_description":"Stáhněte si naši aplikaci pro chytré televize Samsung a sledujte nejlepší divadelní představení v pohodlí domova.","no_trial_how_to_watch_tv_lg_description":"Stáhněte si naši aplikaci pro chytré televize LG a sledujte nejlepší divadelní představení v pohodlí domova.","no_trial_how_to_watch_mobile_description":"Stáhněte si naši mobilní aplikaci pro chytré telefony a tablety a mějte stovky představení a nejlepší umělce kdykoliv na dosah ruky.","no_trial_how_to_watch_mobile_ios_description":"Stáhněte si naši mobilní aplikaci pro chytré telefony a tablety s iOS a mějte stovky představení a nejlepší umělce kdykoliv na dosah ruky.","no_trial_how_to_watch_mobile_android_description":"Stáhněte si naši mobilní aplikaci pro chytré telefony a tablety s OS Android a mějte stovky představení a nejlepší umělce kdykoliv na dosah ruky.","no_trial_playlist_dramox_originals_description":"Užijte si divadlo, které online jinde neuvidíte. Představení Dramox Originals natáčíme exkluzivně pro Dramox.cz.","christmas_contest_title":"Vánoční soutěž | Dramox divadlo online","christmas_contest_description":"Sledujte v prosinci divadlo online a vyhrajte poukazy do Dramoxu,  vstupenky do Dejvického a dalších divadel. Čím víc děl uvidíte, tím vyšší šance na výhru.","celebrity_default_about":"{{name}} působí na Dramoxu v představeních: {{plays}} z divadla: {{theatre}}. Užijte si divadlo online a bavte se se svými oblíbenými osobnostmi."}');

/***/ }),

/***/ 44622:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"content_settings_title":"Jazyky představení","perfomance_language_settings_title":"Volba jazyků divadelních představení","perfomance_language_settings_subtitle":"Ve kterých jazycích rádi sledujete divadelní představení? Přizpůsobte si zážitek na míru a my vám zobrazíme jen ty záznamy, kterým budete rozumět. Nastavení můžete kdykoliv změnit.","btn_content_settings_register_submit":"Potvrdit","btn_content_settings_register_skip":"Přeskočit","submit_error":"Nastavení se nepodařilo uložit. Zkuste to prosím znovu později.","submit_ok":"Nastavení se uložilo."}');

/***/ }),

/***/ 59849:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"samsung_title":"Aplikace Dramox pro chytré televize Samsung","samsung_desc":"Dostupná pro modely vyrobené od roku 2018 se systémem Tizen 4.0 a vyšším. Potřebujete poradit? Kontaktujte nás, prosím, na: <a href=\\"mailto:napoveda@dramox.cz\\">napoveda@dramox.cz</a>.","samsung_instalation":"Instalace aplikace Dramox","samsung_step_1":"Stiskněte tlačítko <b>Home</b> nebo tlačítko <b>Smart Hub</b> na svém ovladači.","samsung_step_2":"Vyberte ikonku <b>APPS</b> ve spodní části obrazovky.","samsung_step_3":"V aplikaci App Store, napište Dramox do ikonky <b>Search icon</b>.","samsung_step_4":"Vyberte aplikaci <b>Dramox</b>, která se zobrazí v nabídce.","samsung_step_5":"Na stránce s detaily aplikace stiskněte tlačítko <b>Install</b>. Pokud vás k tomu aplikace app store vyzve, přihlaste se do svého účtu Samsung.","samsung_step_6":"Po úspěšném dokončení instalace stiskněte tlačítko <b>Add to home screen</b>. Aplikace se objeví v nabídce ve spodní části obrazovky.","samsung_step_7":"Po spuštění aplikace Dramox se přihlaste pomocí svého e-mailu a hesla do svého účtu Dramox.","lg_title":"Aplikace Dramox pro chytré televize LG","lg_desc":"Dostupná pro modely 2016 a vyšší s operačním systémem WebOS 3.0 a vyšším. Potřebujete poradit? Napište nám prosím na: <a href=\\"mailto:napoveda@dramox.cz\\">napoveda@dramox.cz</a>.","lg_instalation":"Instalace aplikace Dramox","lg_step_1":"Stiskněte na ovladači tlačítko s <strong>ikonkou domečku</strong>.","lg_step_2":"V dolní ovládací liště zvolte dlaždici s názvem <strong>LG Content Store</strong>.","lg_step_3":"V obchodě s aplikacemi zvolte <strong>ikonku lupy</strong> a napište Dramox.","lg_step_4":"Vyberte aplikaci <strong>Dramox</strong>, kterou vám našeptá vyhledávání.","lg_step_5":"Na stránce s detailem aplikace klikněte na tlačítko <strong>Instalovat</strong>.","lg_step_6":"Po úspěšné instalaci se aplikace přidá na <strong>Domovskou obrazovku</strong> a zařadí na konec. Klikněte na akci <strong>Spustit</strong>.","lg_step_7":"Po spuštění aplikace Dramox se přihlaste pomocí e-mailu a hesla, které používáte pro přihlášení do svého účtu na Dramoxu."}');

/***/ }),

/***/ 62647:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"theatres":"Divadla","detail":"Detail","support":"Podpořit","web_page":"Webové stránky divadla","theatre_plays":"Představení tohoto divadla","choose_donate":"Vyberte divadlo, kterému chcete přispět","theatre":"Divadlo","continue":"Pokračovat","choose_theatre":"Vyberte divadlo","min_donate":"Minimální částka je {{value}} {{currency}}.","max_donate":"Maximální částka je {{value}} {{currency}}.","donate_how_much":"Kolik chcete přispět?","donate_note":"Divadlu předáme téměř celý darovaný obnos. Pro sebe si nic nenecháme, pouze zaplatíme platební bráně za poskytnutí technologie pro bezpečnou platbu.","amount_other":"Jiné","button_submit":"Potvrdit","changes_not_saved":"Změny se nepodařilo uložit. Prosím opakujte akci později.","changes_saved":"Změny uloženy","donation_success":"Děkujeme za Vaši podporu!","donation_fail":"Platba selhala.","amount_in_currency":"Částka v {{currency}}","must_login":"Nejdříve je nutné se přihlásit ke svému účtu.","dramox_theatres":"Divadla na Dramoxu","sort_alphabeticaly":"Abecedně","sort_newest":"Nejnovější","sort_popular":"Nejpopulárnější","sort":"Řazení","genre":"Žánr","language":"Jazyk","country":"Země","filter_all":"Vše","clear_filter":"Zrušit filtry","most_popular_theatres":"Nejpopulárnější divadla","popular_this_week_theatres":"Oblíbená divadla tento týden","no_theatres":"Nebyla nalezena žádná divadla","plays_count_zero":"{{count}} představení","plays_count_one":"{{count}} představení","plays_count_few":"{{count}} představení","plays_count_many":"{{count}} představení","register":"Zaregistrujte se","amount":{"one":"","few":"","other":"Jiné","many":""}}');

/***/ }),

/***/ 90519:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Podporujeme ukrajinskou kulturu: 100 % z předplatného pošleme ukrajinským divadlům","subtitle":"Ve čtvrtek 17. února na tiskové konferenci v Kyjevě Dramox oficiálně oznámil spuštění divadla online na Ukrajině. Očekávali jsme, že počet našich partnerských divadel bude rychle narůstat, nedávné události bohužel naše plány výrazně změnily.","text_1":"V těchto dnech se běžný i kulturní život na Ukrajině úplně zastavil. Dramox se stal jediným místem, kde můžete bezpečně zhlédnout představení.","text_2":"<p>Proto chceme ukrajinským divadlům co nejvíce pomoct a <span>předat jim 100 % z předplatného diváků. To znamená, že pokud <ukTheater>sledujete ukrajinské divadlo</ukTheater> na Dramoxu, přímo ho tím podporujete.</span></p>","how_watch_title":"Jak sledovat","how_watch_1":"Přihlaste se do svého profilu na Dramox.com.ua","how_watch_2":"<li>V nabídce svého profilu v pravém horním rohu obrazovky vyberte <span>Jazyky představení</span> a zvolte Українська (ukrajinština)</li>","how_watch_3":"Nyní máte přístup ke všem představením v ukrajinštině","how_watch_soon":"Již brzy se na Dramoxu objeví ještě více představení z ukrajinských divadel. K dalším také připravujeme titulky."}');

/***/ }),

/***/ 22473:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"airplay_title":"Sdílení obsahu do TV pomocí AirPlay","airplay_description":"AirPlay je technologie od společnosti Apple pro sdílení multimediálního obsahu do televize.","airplay_instalation":"Jak nasdílet představení pomocí AirPlay","airplay_step_1":"Vaše chytrá TV musí být připojená ke stejné wi-fi síti jako váš notebook, mobil nebo tablet.","airplay_step_2":"Televize musí podporovat technologii AirPlay.","airplay_step_3":"Spusťte vybrané divadelní představení – v prohlížeči <strong>Safari</strong> nebo v <a href=\\"https://apps.apple.com/cz/app/dramox-divadlo-online/id1563430137?l=cs\\" target=\\"blank\\">mobilní aplikaci pro iOS</a>.","airplay_step_4":"Klikněte na ikonku <0></0> v pravém dolním rohu.","airplay_step_5":"Vyberte z nabídky, do které televize ve své wi-fi síti chcete představení nasdílet.","chromecast_title":"Sdílení obsahu do TV pomocí Chromecast","chromecast_description":"Chromecast je technologie od společnosti Google pro sdílení multimediálního obsahu do televize.","chromecast_instalation":"Jak nasdílet představení pomocí Chromecast","chromecast_step_1":"Vaše chytrá TV musí být připojená ke stejné wi-fi síti jako váš notebook, mobil nebo tablet.","chromecast_step_2":"Televize musí podporovat technologii Chromecast.","chromecast_step_3":"Spusťte vybrané divadelní představení – <strong>v prohlížeči Chrome, Opera</strong> nebo v <a href=\\"https://play.google.com/store/apps/details?id=cz.dramox.dramox\\" target=\\"_blank\\">mobilní aplikaci pro Android.</a>","chromecast_step_4":"Klikněte na ikonku ozubeného kola <0></0> v pravém dolním rohu.","chromecast_step_5":"Klikněte na ikonku Chromecast. <0></0>","chromecast_step_6":"Vyberte z nabídky, do které televize ve své wi-fi síti chcete představení nasdílet."}');

/***/ }),

/***/ 29235:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Darujte Dramox - divadlo online","description":"Poukazem na Dramox darujete jedinečnou zábavu svým blízkým a zároveň podpoříte divadla, autory i herce. Většinu ze zakoupené částky předá Dramox právě jim.  \\n\\nPo zakoupení doručíme dárkový poukaz ve formátu PDF na Váš e-mail.","buy_btn":"Koupit dárkový poukaz","for_companies":"V případě zájmu o zakoupení většího množství (min. 10 a více) dárkových poukazů na IČO nám prosím napište na <contactMail>napoveda@dramox.cz</contactMail>.","price_with_vat":"{{price}} s DPH","buy_success":"Děkujeme. Dárkový poukaz Vám během chvilky přijde na Váš e-mail.","buy_fail":"Platba selhala.","givery":"Spolupracujeme s Givery.cz","buy_physical_voucher":"Chci fyzický poukaz +89 Kč"}');

/***/ }),

/***/ 90258:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"menu_faq":"Často se ptáte","theatres_list_title":"Seznam divadel","plays_list_title":"Vybraná divadelní představení","new_welcome_sec_1_title_cz":"Kultura nikdy nebyla blíž. Stovky českých i zahraničních divadel na jednom místě.","new_welcome_sec_1_title_xx":"Stovky divadel k vidění online na Dramoxu","new_welcome_sec_2_text_cz":"Stovky legálních divadelních záznamů ke zhlédnutí online","new_welcome_sec_2_text_xx":"Stovky legálních divadelních záznamů ke zhlédnutí online","new_welcome_sec_2_title_cz":"Prohlédnout knihovnu","new_welcome_sec_2_title_xx":"Prohlédnout knihovnu","new_welcome_sec_3_text_cz":"Sledováním Dramoxu podporujete divadelní kulturu. Celých 55 % předplatného totiž putuje zpět divadlům, tvůrcům a hercům. \\nNavíc můžete svým oblíbencům poslat další libovolnou částku navíc. Je to jako koupit si lístky, jen pohodlnější (a výhodnější).","new_welcome_sec_3_text_xx":"Sledováním Dramoxu podporujete divadelní kulturu. Celých 55 % předplatného totiž putuje zpět divadlům, tvůrcům a hercům. \\nNavíc můžete svým oblíbencům poslat další libovolnou částku navíc. Je to jako koupit si lístky, jen pohodlnější (a výhodnější).","new_welcome_sec_3_title_cz":"Více než polovinu každého předplatného posíláme divadlům","new_welcome_sec_3_title_xx":"Více než polovinu každého předplatného posíláme divadlům","new_welcome_sec_4_text_xx":"A už nikdy nebudete řešit, že je kultura příliš daleko. Představení těch nejlepších divadel si nyní pustíte kdekoliv a kdykoliv. Sledovat je můžete na mnoha zařízeních, v počítači, televizi i mobilu. Je to snadné a dostupné pro každého. Pohodlně se usaďte, začínáme.","new_welcome_sec_4_text_cz":"A už nikdy nebudete řešit, že je kultura příliš daleko. Představení těch nejlepších divadel si nyní pustíte kdekoliv a kdykoliv. Sledovat je můžete na mnoha zařízeních, v počítači, televizi i mobilu. Je to snadné a dostupné pro každého. Pohodlně se usaďte, začínáme.","new_welcome_sec_4_title_cz":"Zamilujte si Dramox","new_welcome_sec_4_title_xx":"Zamilujte si Dramox","new_welcome_sec_5_text_cz":"Své předplatné můžete kdykoliv zrušit.","new_welcome_sec_5_text_xx":"Své předplatné můžete kdykoliv zrušit.","new_welcome_sec_5_title_cz":"Vyzkoušejte Dramox na 7 dní zdarma","new_welcome_sec_5_title_xx":"Vyzkoušejte Dramox na 7 dní zdarma","welcome_button_long_xx":"Chci Dramox na 7 dní ZDARMA","welcome_button_long_cz":"Chci Dramox na 7 dní ZDARMA","welcome_price_cz":"Po zkušebním období za {{monthly}} měsíčně","welcome_price_xx":"Pak sledujte za {{monthly}} měsíčně. Většina z každého předplatného jde přímo divadlům. Zrušit můžete kdykoliv.","welcome_subtitle_xx":"Sledujte kdykoliv a kdekoliv máte chuť. Na chytré televizi, v mobilu, tabletu i na počítači.","welcome_subtitle_cz":"Sledujte kdykoliv a kdekoliv máte chuť. Na chytré televizi, v mobilu, tabletu i na počítači.","welcome_title_cz":"Udělejte si čas na divadlo. Stovky představení najdete na Dramoxu online.","welcome_title_xx":"Udělejte si čas na divadlo. Stovky představení najdete na Dramoxu online.","new_welcome_sec_1_title_sk":"Stovky divadel k vidění online na Dramoxu","new_welcome_sec_2_text_sk":"Stovky legálních divadelních záznamů ke zhlédnutí online","new_welcome_sec_2_title_sk":"Prohlédnout knihovnu","new_welcome_sec_3_text_sk":"Sledováním Dramoxu podporujete divadelní kulturu. Celých 55 % předplatného totiž putuje zpět divadlům, tvůrcům a hercům. \\nNavíc můžete svým oblíbencům poslat další libovolnou částku navíc. Je to jako koupit si lístky, jen pohodlnější (a výhodnější).","new_welcome_sec_3_title_sk":"Více než polovinu každého předplatného posíláme divadlům","new_welcome_sec_4_text_sk":"A už nikdy nebudete řešit, že je kultura příliš daleko. Představení těch nejlepších divadel si nyní pustíte kdekoliv a kdykoliv. Sledovat je můžete na mnoha zařízeních, v počítači, televizi i mobilu. Je to snadné a dostupné pro každého. Pohodlně se usaďte, začínáme.","new_welcome_sec_4_title_sk":"Zamilujte si Dramox","new_welcome_sec_5_text_sk":"Své předplatné můžete kdykoliv zrušit.","new_welcome_sec_5_title_sk":"Vyzkoušejte Dramox na 7 dní zdarma","welcome_button_long_sk":"Chci Dramox na 7 dní ZDARMA","welcome_price_sk":"Pak sledujte za {{monthly}} měsíčně. Většina z každého předplatného jde přímo divadlům. Zrušit můžete kdykoliv.","welcome_subtitle_sk":"Sledujte kdykoliv a kdekoliv máte chuť. Na chytré televizi, v mobilu, tabletu i na počítači.","welcome_title_sk":"Udělejte si čas na divadlo. Stovky představení najdete na Dramoxu online.","new_welcome_sec_1_title_ua":"Desítky divadel k vidění online na Dramoxu","new_welcome_sec_2_text_ua":"Stovky legálních divadelních záznamů ke zhlédnutí online","new_welcome_sec_2_title_ua":"Prohlédnout knihovnu","new_welcome_sec_3_text_ua":"Sledováním Dramoxu podporujete divadelní kulturu. Celých 55 % předplatného totiž putuje zpět divadlům, tvůrcům a hercům. \\nNavíc můžete svým oblíbencům poslat další libovolnou částku navíc. Je to jako koupit si lístky, jen pohodlnější (a výhodnější).","new_welcome_sec_3_title_ua":"Polovina z každého předplatného jde přímo divadlům.","new_welcome_sec_4_text_ua":"A už nikdy nebudete řešit, že je kultura příliš daleko. Představení těch nejlepších divadel si nyní pustíte kdekoliv a kdykoliv. Sledovat je můžete na mnoha zařízeních, v počítači, televizi i mobilu. Je to snadné a dostupné pro každého. Pohodlně se usaďte, začínáme.","new_welcome_sec_4_title_ua":"Zamilujte si Dramox","new_welcome_sec_5_text_ua":"Své předplatné můžete kdykoliv zrušit.","new_welcome_sec_5_title_ua":"Vyzkoušejte Dramox na 7 dní zdarma","welcome_button_long_ua":"Chci Dramox na 7 dní ZDARMA","welcome_price_ua":"Pak sledujte za {{monthly}} měsíčně. Polovina z každého předplatného jde přímo divadlům. Zrušit můžete kdykoliv.","welcome_subtitle_ua":"Sledujte kdykoliv a kdekoliv máte chuť. Na chytré televizi, v mobilu, tabletu i na počítači.","welcome_title_ua":"Největší výběr ukrajinských divadelních představení na jednom místě","new_welcome_sec_1_title_pl":"Stovky divadel online na Dramoxu","new_welcome_sec_2_text_pl":"Stovky divadelních představení k přehrání na Dramoxu","new_welcome_sec_2_title_pl":"Procházet knihovnu","new_welcome_sec_3_text_pl":"Sledujte představení a podporujte divadla po celém světě. Více než polovina z každého předplatného jde přímo divadlům. Svým oblíbeným umělcům můžete věnovat jakoukoliv další částku. Téměř celý výtěžek zašleme divadlu. Nic si nenecháváme, platíme pouze poplatek platební bráně za poskytnutí technologie pro bezpečné platby.","new_welcome_sec_3_title_pl":"Polovina z každého předplatného jde přímo divadlům.","new_welcome_sec_4_text_pl":"Divadlo na dosah vaší ruky. Sledujte ta nejlepší představení kdykoliv a kdekoliv – Dramox si snadno pustíte ve svém počítači, mobilním telefonu nebo chytré televizi. Divadlo online je tak dostupné opravdu každému. Dámy a pánové, prosím posaďte se, představení právě začíná.","new_welcome_sec_4_title_pl":"Zamilujte si Dramox","new_welcome_sec_5_text_pl":"Své předplatné můžete kdykoliv zrušit.","new_welcome_sec_5_title_pl":"Vyzkoušejte Dramox","welcome_button_long_pl":"Začněte svých 7 dní ZDARMA","welcome_price_pl":"Pak sledujte za {{monthly}}/měsíc, zrušit můžete kdykoliv. Polovina z každého předplatného jde přímo divadlům.","welcome_subtitle_pl":"Sledujte kdykoliv, kdekoliv.","welcome_title_pl":"Největší výběr polských divadelních představení na jednom místě","no_trial_welcome_button_long_xx":"Začněte sledovat divadlo online ","no_trial_welcome_button_long_cz":"Začněte sledovat divadlo online","no_trial_welcome_button_long_sk":"Začněte sledovat divadlo online","no_trial_welcome_button_long_ua":"Začněte sledovat divadlo online","no_trial_welcome_button_long_pl":"Začněte sledovat divadlo online","welcome_button_browse_xx":"Prohledat Dramox","welcome_button_browse_cz":"Prohledat Dramox","welcome_button_browse_sk":"Prohledat Dramox","welcome_button_browse_ua":"Prohledat Dramox","welcome_button_browse_pl":"Prohledat Dramox","welcome_subscription_title_xx":"Vyberte si předplatné a choďte do divadla třeba každý den","welcome_subscription_title_cz":"Vyberte si předplatné a choďte do divadla třeba každý den","welcome_subscription_title_sk":"Vyberte si předplatné a choďte do divadla třeba každý den","welcome_subscription_title_ua":"Vyberte si předplatné a choďte do divadla třeba každý den","welcome_subscription_title_pl":"Vyberte si předplatné a choďte do divadla třeba každý den","welcome_subscription_1_xx":"Stovky záznamů českých a zahraničních představení z více než 250 divadel","welcome_subscription_1_cz":"Stovky záznamů českých a zahraničních představení z více než 250 divadel","welcome_subscription_1_sk":"Stovky záznamů českých a zahraničních představení z více než 250 divadel","welcome_subscription_1_ua":"Stovky záznamů českých a zahraničních představení z více než 250 divadel","welcome_subscription_1_pl":"Stovky záznamů českých a zahraničních představení z více než 250 divadel","welcome_subscription_2_xx":"Činohra, muzikál, opera, balet, loutky i nový cirkus","welcome_subscription_2_cz":"Činohra, muzikál, opera, balet, loutky i nový cirkus","welcome_subscription_2_sk":"Činohra, muzikál, opera, balet, loutky i nový cirkus","welcome_subscription_2_ua":"Činohra, muzikál, opera, balet, loutky i nový cirkus","welcome_subscription_2_pl":"Činohra, muzikál, opera, balet, loutky i nový cirkus","welcome_subscription_3_xx":"Žádné reklamy ani další poplatky","welcome_subscription_3_cz":"Žádné reklamy ani další poplatky","welcome_subscription_3_sk":"Žádné reklamy ani další poplatky","welcome_subscription_3_ua":"Žádné reklamy ani další poplatky","welcome_subscription_3_pl":"Žádné reklamy ani další poplatky","welcome_subscription_button_1_xx":"7 dní zdarma,<1></1><0>pak za {{priceMonthly}} / měsíc</0>","welcome_subscription_button_1_cz":"7 dní zdarma,<1></1><0>pak za {{priceMonthly}} / měsíc</0>","welcome_subscription_button_1_sk":"7 dní zdarma,<1></1><0>pak za {{priceMonthly}} / měsíc</0>","welcome_subscription_button_1_ua":"7 dní zdarma,<1></1><0>pak za {{priceMonthly}} / měsíc</0>","welcome_subscription_button_1_pl":"7 dní zdarma,<1></1><0>pak za {{priceMonthly}} / měsíc</0>","welcome_subscription_button_2_xx":"7 dní zdarma,<1></1><0>pak za <2>{{beforeYearly}}</2> {{priceYearly}} / rok</0>","welcome_subscription_button_2_cz":"7 dní zdarma,<1></1><0>pak za <2>{{beforeYearly}}</2> {{priceYearly}} / rok</0>","welcome_subscription_button_2_sk":"7 dní zdarma,<1></1><0>pak za <2>{{beforeYearly}}</2> {{priceYearly}} / rok</0>","welcome_subscription_button_2_ua":"7 dní zdarma,<1></1><0>pak za <2>{{beforeYearly}}</2> {{priceYearly}} / rok</0>","welcome_subscription_button_2_pl":"7 dní zdarma,<1></1><0>pak za <2>{{beforeYearly}}</2> {{priceYearly}} / rok</0>","welcome_subscription_button_activate_xx":"Aktivovat zkušební období","welcome_subscription_button_activate_cz":"Aktivovat zkušební období","welcome_subscription_button_activate_sk":"Aktivovat zkušební období","welcome_subscription_button_activate_ua":"Aktivovat zkušební období","welcome_subscription_button_activate_pl":"Aktivovat zkušební období","welcome_subscription_cancel_note_xx":"Předplatné můžete kdykoliv zrušit.","welcome_subscription_cancel_note_cz":"Předplatné můžete kdykoliv zrušit.","welcome_subscription_cancel_note_sk":"Předplatné můžete kdykoliv zrušit.","welcome_subscription_cancel_note_ua":"Předplatné můžete kdykoliv zrušit.","welcome_subscription_cancel_note_pl":"Předplatné můžete kdykoliv zrušit."}');

/***/ }),

/***/ 88700:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"authorship_provider":"Service Provider","about_colaboration_question":"Are You Interested in Working with Us?","about_contact_us":"Contact Us","about_creators":"Who is behind Dramox?","about_partners":"Our Partners","about_project":"Our Project","about_schools":"Dramox For Schools offers teachers the opportunity to make their lessons more fun. Students will discover the beauty of theater and literature in a way that is entertaining to them – by watching videos online. You can find more details <0>here</0>.","about_theaters":"Show All Theaters","about_colaboration":"Partnering Theaters","person_about_1":"Martin holds a degree in theater studies. In his professional life he makes use of his expertise in humanities and technology.","person_about_2":"Radim helped launch the video portal voyo.cz. He\'s the owner of Weemazz 2.0, which helps copyright owners by removing illegal copies of their works from the internet. He has worked in the digital sphere throughout his career.","person_about_3":"The co-founder and spiritual father behind the entire concept of Dramox. He\'s a digital entrepreneur and brand owner of Livesport, which boasts more than 90 million users worldwide.","person_title_1":"Martin Zavadil","person_title_2":"Radim Horák","person_title_3":"Martin Hájek","forschools_footer":"For Schools","about_project_description":"<0>Dramox is online theater. It is a streaming service offering the largest selection of theater recordings for a monthly subscription fee, with new performances added each month. Watch your favorite plays or discover new ones, anytime, anywhere, and without commercials.</0><0>Dramox supports performing arts. Half of every subscription fee goes to theaters, artists and creators, and additional contributions are donated in full directly to theaters. Our primary goal is to extend the time people spend with theater and to make art and culture accessible to everyone, regardless of distance, language or any other impediment, while supporting local theaters and artists.</0>","legislative":"The supervisory authority for the provision of on-demand audiovisual media services is The Council for Radio and Television Broadcasting."}');

/***/ }),

/***/ 12249:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"menu_authorship":"Copyright","authorship_email":"Thank you for your email","authorship_email_fail":"We\'re sorry but your message could not be sent. Please try again later.","authorship_message_for_us":"Message","authorship_provider":"Service Provider","authorship_send_form":"Submit Form","authorship_title":"Copyright Query","authorship_your_email":"Your Email","authorship_perex":"<0>Are you a copyright owner of any of the performances listed on Dramox and we haven\'t reached out to you yet? Please write to us.</0><0>Although we have done our best to get in touch with all the authors, it is possible that we somehow missed you.</0><0>Please contact us by using the form below. We will get back to you right away and will happily discuss all details with you.</0><0>Thank you.<1></1>Dramox Team</0>","authorship_field_required":"This field is required.","authorship_max_length":"Max. length is: ","authorship_email_invalid":"Invalid email address. Please use the following format: email@example.com"}');

/***/ }),

/***/ 2665:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"broadcast_title":"Live broadcast","video_placeholder":"We are currently not broadcasting","schedule_title":"Schedule"}');

/***/ }),

/***/ 92991:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Choose your plan","payment_info":"New members can enjoy a free 7-day trial. Half of each subscription fee goes straight to the theaters, authors and actors. The subscription can be cancelled at any time.","payment_occour":"The payment will be processed on {{date}}","payment_sub_info":"By subscribing to the annual plan you save almost {{yearPriceDiff}} a year.","voucher_label":"Voucher","voucher_placeholder":"Enter your voucher code","got_voucher":"I have a voucher","redeem_voucher":"Redeem","activate_yearly":"Activate annual plan","activate_monthly":"Activate monthly plan","changes_not_saved":"Changes could not be saved. Please try again later.","changes_saved":"Changes saved.","subscription_activated":"Subscription plan activated.","error_general":"Something went wrong. Please try again later.","price_with_vat":"{{price}}\\nincl. VAT","advanced_form":{"title":"Choose your subscription","switch_to_voucher":"or use a voucher code","monthly":"7 days FREE, <0>then {{price_formatted}} monthly</0>","yearly":"7 days FREE,<0>then {{price_formatted}} yearly</0>","button_activate":"Activate free 7-day trial","timeline_title":"How does the free 7-day trial work?","timeline_step_1":"<0>Today</0>Start of your free 7-day trial.","timeline_step_2":"<0>In 7 days ({{date_formatted}})</0>The first payment for the selected subscription will be charged. If you cancel before this time, your card will not be charged.","timeline_step_3":"Subscription is renewed automatically until cancelled.","voucher_title":"Use a voucher code","switch_to_card":"I don\'t have a voucher code","voucher_description_title":"Give your family the gift of online theater by offering them a Dramox gift voucher","voucher_description_subtitle":"Stream thousands of minutes of entertainment from hundreds of theaters in one place","voucher_description_action":"Buy a gift voucher","use_promo_code":"Add promo code (optional)","promo_code_placeholder":"Enter promo code","timeline_step_4":"<0>In 5 days ({{date_formatted}})</0>We will send an email notifying you that <1></1>your first subscription payment is approaching.","no_trial_button_activate":"Activate your subscription","no_trial_timeline_title":"Choose your subscription plan.","no_trial_timeline_step_1":"Start using Dramox today.","no_trial_monthly":"<0>{{price_formatted}} per month</0>","no_trial_yearly":"<0>{{price_formatted}} per year</0>"},"code_not_exists":"Invalid code","card_number_invalid":"Your card number is incomplete.","error_code_no_longer_valid":"Code is no longer valid.","error_voucher_expired":"Code is no longer valid.","error_code_discount_already_used":"Discount code already used.","error_discount_already_active":"Promo code cannot be used. A discount is already active.","error_promo_referral_not_allowed":"Promo code can only be used when creating a new account.","error_promo_already_used":"Promo code has already been used.","error_promo_voucher_already_used":"Promo code has already been used.","error_promo_not_allowed":"Promo code can only be used within active subscription.","voucher_invalid":"The voucher code is invalid.","code_already_used":"Code already redeemed","no_trial_payment_info":"The subscription can be canceled at any time. Half of each subscription fee goes straight to the theaters, authors and actors."}');

/***/ }),

/***/ 54903:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"contest_title":"Christmas Contest with Dramox","contest_btn":"Enter the contest","contest_desc":"Enjoy world-class theater performances throughout Advent and win theater tickets and Dramox vouchers","contest_description":"Make yourself a hot cup of tea, snuggle up in your armchair and discover new theater performances with Dramox from December 1st to December 21st. This year, we\'re rewarding you with theater tickets and Dramox vouchers. And best of all, Santa Claus will be visiting on December 22nd to gift one lucky winner a theater bundle, including tickets to your favorite Dejvice Theater!","contest_what_win_title":"Prizes","contest_what_win":"The contest takes place in three weekly rounds for the chance to win the following prizes:","contest_what_1":"<0>1st place</0><1><2>2 x theater tickets</2><2>1 x 6 month Dramox voucher</2></1>","contest_what_2":"<0>2nd place</0><1><2>2 x theater tickets</2><2>1 x 3 month Dramox voucher</2></1>","contest_what_3":"<0>3rd-5th place</0><1><2>2 x theater tickets</2><2>1 x 1 month Dramox voucher</2></1>","contest_what_main_price":"Grand prize for the winner between December 1st to December 21st:","contest_what_price":"1 x theater bundle including tickets to Dejvice Theater + 1 x 1 year Dramox voucher + Dramox merch","contest_tip_title":"💡Our tip: The more performances you watch, the higher your chance of winning.","contest_tip_desc":"Example: You watch one performance on December 1st, a second one on December 5th and a third one on December 6th. You will automatically be entered into the final draw for a chance to win a theater bundle after the competition closes on Thursday, December 21rd at 12pm.","contest_how_play":"How it works","contest_how_1":"<0>Register using the form.</0> Make sure to use the same email address you registered with on Dramox!","contest_how_2":"Each contest week, discover new theater performances on Dramox. The more performances you watch, the higher your chance of winning.","contest_how_3":"At the end of each week, we will select five winners who will be notified of their prizes via email. At the end of the contest period you also have a chance to win the main prize: a theater bundle including Dejvice Theater tickets, a 1 year subscription to Dramox and Dramox merch. The winner will be announced on December 23rd in the afternoon.","contest_how_4":"Follow us on <0>Facebook</0>, <1>Instagram</1> and <2>Twitter</2> to stay updated about the contest and to get tips on what to watch next.","contest_rules_title":"Contest rules","contest_rule_1":"The contest starts on December 1st  2023 at 0am and ends on December 21rd 2022 at 12pm.","contest_rule_2":"The competition runs during the following periods:","contest_rule_2_1":"Week 1: from December 1st to December 7th, winners are announced on December 8th","contest_rule_2_2":"Week 2: from December 8th to December 14th, winners are announced on December 15th","contest_rule_2_3":"Week 3: from December 15th to December 21th, winners are announced on December 22th","contest_rule_2_4":"Week 4: from December 18th to December 23rd, winners are announced on December 23rd","contest_rule_3":"All users registered on Dramox with an active subscription or during their 7-day trial period, who have also registered using the contest form can participate.","contest_rule_4":"The winners of each weekly round will be announced on our social media and in our newsletter.","contest_rule_5":"The grand prize can be won by any contestant who entered between December 1st and December 21nd, regardless of whether or not they have already won any of the previous prizes. There is only one grand prize and a single contestant will be selected on December 22nd. We will announce the winner on our social media and in our newsletter.","contest_rule_more":"You can find the complete list of rules for the Christmas Contest <0>here</0>.","contest_info_toolbar_2023":"⭐ Christmas Contest with Dramox: Win theater tickets and Dramox gift vouchers","contest_info_toolbar_2024":""}');

/***/ }),

/***/ 4807:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"more":"More","more_about_play":"More Info","previous_play":"Previous performance","play_btn":"Play","play_btn_long":"Play Now","next_play":"Next performance","coming_soon":"Coming soon","continue":"Continue","continue_remaining":"{{time}} remaining","most_popular":"Most Popular","popular":"Popular","recently_added":"Recently Added","currently_watching":"Continue Watching","drama":"Drama","comedy":"Comedy","tragedy":"Tragedy","all_genres":"All Genres","actors":"Actors","performances":"Performances","theatres":"Theaters","search_placeholder":"Search title, theater, actor...","no_search_results":"No results found for the given query.","menu":{"home":"Home","genres":"Genres","theatres":"Theaters","about":"About","theatre":"Donate to a theater","voucher":"Vouchers","login":"Log In","try_free":"Register","about_project":"Our Project","for_schools":"For Schools","smart_tv":"Smart TV","mobile_apps":"Mobile Apps","how_to_watch":"How to Watch","contact":"Contact Us","faq":"FAQ","my_profile":"My Profile","logout":"Log Out","terms_conditions":"Terms & Conditions","cookies":"Cookie Policy","authorship":"Copyright","privacy_policy":"Privacy Policy","content_settings":"Language Preferences","try_now":"Try Now","logo_mobile":"FREE for 7 days","search":"Search","invite_friends":"Referral","watch_list":"Watchlist","broadcast":"Broadcasting","no_trial_try_free":"Register","christmas_contest":"Christmas contest"},"form":{"not_empty":"Value must not be empty","password_min_chars":"The password has to be at least 8 characters long.","email_format":"Invalid email format.","wrong_credentials":"Invalid username or password.","already_exists":"The email address is already in use.","password_dont_match":"Passwords do not match.","payment_secured_with":"Payment secured with","payment_card":"Payment Card","add_card":"Add Card","card_tooltip":"We accept VISA, Mastercard, eBenefity cards","activate":"Activate","recaptcha_error_global":"Captcha error occurred, please refresh the page.","recaptcha_error_expired":"Captcha expired, please click the checkbox again.","recaptcha_error_not_checked":"Please check to prove you\'re not a robot."},"not_found":{"title":"Page was not found","description":"We\'re sorry, but the page you requested could not be found.","btn":"Return to the Homepage"},"saved_cards":"Saved cards","saved_cards_placeholder":"Choose cards","card_email":"Email","add_new_card":"Add new card","playlist_section_title":"Performances from the category {{section}}","playlist_genre_title":"Performances from the genre {{genre}}","playlist_same_genre_title":"{{performance}} – similar performances","playlist_same_cast_title":"{{performance}} – performances with similar cast","playlist_currently_watching_title":"Currently watching","playlist_most_popular_title":"Most popular performances","playlist_recent_title":"Recently added performances","country":"Country","pick_country":"Select country","performance_not_found":{"title":"Performance was not found","description":"The required performance either doesn\'t exist, or isn\'t currently available in your country."},"playlist_dramox_originals_title":"Dramox Originals","dramox_originals":"Dramox Originals","open_in_mobile_app":"Open in Dramox Application","watch_list":"Watchlist","sort_from":"Sort by","sort_date_desc":"Date Added (Newest)","sort_date_asc":"Date Added (Oldest)","sort_alphabetically_desc":"Alphabetical (A-Z)","add_first_play":"Add your first performance","how_add":"You can add a new performance by clicking \\"+ Watchlist\\" in the performance\'s info page.","check_library":"View library","month_zero":"{{count}} months","month_one":"{{count}} month","month_few":"{{count}} months","month_many":"{{count}} months","day_zero":"{{count}} days","day_one":"{{count}} day","day_few":"{{count}} days","day_many":"{{count}} days","week_zero":"{{count}} weeks","week_one":"{{count}} week","week_few":"{{count}} weeks","week_many":"{{count}} weeks","cookies_bar":{"less_text":"Dear viewer, we use cookies to improve your online theater experience on our website.","learn_more":"Learn more","accept_all":"Agree to all","only_functional":"Agree to necessary"},"cookie_updated":"Updated 24.5.2022","or":"Or","year_zero":"{{count}} years","year_one":"{{count}} year","year_few":"{{count}} years","year_many":"{{count}} years","ownership":"Since September 2024, Dramox s.r.o. is owned by the Livesport Foundation."}');

/***/ }),

/***/ 26322:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"authorship_provider":"Service Provider","contact_ceo":"CEO","contact_cofounder":"Co-founder","contact_coo":"COO","person_title_1":"Martin Zavadil","person_title_2":"Radim Horák","person_title_3":"Martin Hájek","press_download":"Download Press Kit","press_media":"For Media","press_text":"Download the company\'s press kit, which contains Dramox logos in all formats.","ua_contact":"Manager","ua_contact_name":"Olia Shylo","company":"Dramox s.r.o.","address":"Bucharova 2928/14a, Stodůlky","ico":"IČO: 09222103","cooperation":"support@dramox.tv","ua_company":"Dramox s.r.o.","ua_address":"Бухарова 2928/14а, Стодолки (Прага 13), 158 00 Прага","ua_ico":"Реєстраційний номер: 09222103","ua_cooperation":"support@dramox.tv"}');

/***/ }),

/***/ 85697:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"may_2022_tag_title":"33% off your subscription | Dramox","may_2022_title":"33% off for up to 5 months of Dramox. Stream world-class theater for 199 CZK/month","may_2022_subtitle":"Don\'t miss the unique opportunity to stream Dramox for up to 5 months for only 199 CZK/month. Get 33% off your monthly subscription and save up to 500 CZK. This offer is valid for 1 month only.","may_2022_exclusive":"Limited Time Only","may_2022_text_mask_1":"Štěpán Kozub, Ivan Trojan, Pavla Tomicová - with Dramox, the biggest theater stars step into your living room and perform especially for you. To bring theater closer to a wider audience, we now offer a 33% discount on our monthly subscriptions. Stream Dramox for up to 5 months, for only 199 CZK/month.","may_2022_text_mask_2":"👉 Our tip: Get 33% off your annual subscription and save 1,000 CZK!","may_2022_text_mask_3":"⏰ Discount is valid for 1 month, between 1st - 31st May 2022 and may not be combined with other offers.","may_2022_how_watch_title":"How to claim your discount","may_2022_how_watch_1":"Log into your <0>account</0> or <1>register</1> with Dramox, if you are a first-time user","may_2022_how_watch_2":"After selecting your subscription plan, enter code <0>DRAMOXKVETEN33</0> in the <0>Add promo code</0> field","may_2022_how_watch_3":"Enjoy world-class online theater and save 33% on your subscription","may_2022_how_watch_p":"Do you need assistance?","may_2022_how_watch_help":"Contact our friendly customer service team at <0>napoveda@dramox.cz</0>","may_2022_discount_email":"support@dramox.tv"}');

/***/ }),

/***/ 22075:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"tag_title":"50% off your subscription | Dramox","title":"50% off for up to 6 months of Dramox. Stream world-class theater for €5.95/month","subtitle":"Don\'t miss the unique opportunity to stream Dramox for up to 6 months at half-price. Get 50% off your monthly subscription and save €5.95 each month. This offer is available worldwide and is valid for 7 days only.","exclusive":"Limited Time Only","text_mask_1":"Plácido Domingo, Colm Feore, Rolando Villazon - with Dramox, the biggest theater stars step into your living room and perform especially for you. To bring theater closer to a wider audience, we now offer a 50% discount on our monthly subscriptions. Stream Dramox for up to 6 months, for only €5.95/month.","text_mask_2":"👉 Our tip: Get 50% off your annual subscription and save €59.5!","text_mask_3":"⏰ Discount is valid for 7 days, between 14th - 20th April 2022 and may not be combined with other offers.","how_watch_title":"How to claim your discount","how_watch_1":"Log into your <0>account</0> or <1>register</1> with Dramox, if you are a first-time user","how_watch_2":"After selecting your subscription plan, enter code <0>DRAMOX50OFF</0> in the <0>Add promo code</0> field","how_watch_3":"Enjoy world-class online theater and save 50% on your subscription","how_watch_p":"Do you need assistance?","how_watch_help":"Contact our friendly customer service team at <0>support@dramox.tv</0>","discount_email":"support@dramox.tv"}');

/***/ }),

/***/ 47440:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"toolbar":"🐣 Easter Contest with Dramox: Win tickets to Prague City Theaters and subscription vouchers","title":"Easter with Dramox","sign_in":"Enter the competition","subtitle_1":"Enjoy online theater and win tickets and subscription vouchers","subtitle_2":"Celebrate spring in the company of family, friends and great theater. This year, instead of a bunny, Dramox brings you an Easter present. Stream as many Dramox performances as possible from 12 to 18 April 2022 and we will reward you with tickets to Prague City Theaters and gift vouchers worth up to 1590 CZK. Happy Easter! ","contest":"Contest","price_title":"What can you win?","price_desc":"The prizes are as follows:","price_first":"<1>1st place </1> <0/> 2 x theater tickets <0/> 6-months subscription voucher","price_second":"<1>2nd place </1> <0/> 2 x theater tickets <0/> 3-months subscription voucher","price_third":"<1>3rd place </1> <0/> 2 x theater tickets <0/> 1-month subscription voucher","chance_title":"🌷Our tip: The more you watch, the greater your chances of winning.","chance_text":"Example: A user watches one performance on Tuesday, 12th April, one on Wednesday, 13th April, and one on Thursday, 14th April. This user’s name will be included in the final draw 3 times, resulting in a higher chance of winning.","how_to_title":"How to compete?","how_to_1":"Register by completing the <0>contest entry form</0> Make sure to use the same email address that you are registered with on Dramox.","how_to_2":"Stream your favorite Dramox performances between 12 and 18 April 2022. The more you watch, the more times your name will be included in the contestant list.","how_to_3":"At the end of the competition period on Tuesday 19 April 2022, the three winners will be selected. Tickets to Prague City Theaters and subscription gift vouchers are up for grabs!","how_to_4":"We will announce the winners on our social channels and via our newsletter. Also, follow us on <facebook>Facebook</facebook>, <instagram>Instagram</instagram>, <twitter>Twitter</twitter> and <youtube>YouTube</youtube>  - you\'ll get plenty of inspiration on what to watch.","btn_signin":"Enter the competition","rules_title":"Rules of the Easter Contest:","rule_1":"The competition starts on 12 April 2022 at 0.01 a.m. and ends on 18 April 2022 at 11.59 p.m.","rule_2":"Participants are required to be registered on Dramox, with an active subscription or part of the 7-day trial period. Also, everyone who wishes to participate is required to fill in the contest entry form.","rule_3":"The winners will be selected from all contestants who have entered the contest during the given period (see point 1). We will announce the winners on our social channels and via our newsletter.","rule_more":"The complete rules of the Easter with Dramox competition are <0>here</0>.","tag_title":"Easter Contest | Dramox"}');

/***/ }),

/***/ 88266:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"reset_password_h1":"Set your password and you\'re ready to go.","new_password":"New Password","new_password_again":"New Password Again","submit":"Submit","reset_password_placeholder":"Minimum of 8 characters","reset_password_error":"The password change link is no longer valid."}');

/***/ }),

/***/ 92495:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"items":{"1":{"q":"What is Dramox?","a":"Dramox is online theater. It is a streaming service offering the largest selection of theater recordings. Watch your favorite plays or discover new ones, anytime, anywhere, and without commercials. New plays are added each month."},"2":{"q":"What can I find on Dramox?","a":"With Dramox you can watch performances from hundreds of theaters. You can choose from the good old classics, award-winning productions or brand new plays in search of an audience."},"3":{"q":"What are the different Dramox subscription plans?","a":"You can use Dramox for {{monthly}} per month or save {{yearlyDiscount}} by choosing an annual subscription plan for {{yearly}}. No hidden fees, no long-term agreements. You have the freedom to cancel your subscription online at any time. Half of your subscription fee goes to theaters, actors and creators."},"4":{"q":"How many plays can I watch?","a":"There is no limit to how many plays you can watch. You are welcome to discover as many as you would like."},"5":{"q":"How do I cancel my Dramox subscription?","a":"You have the freedom to cancel your subscription online at any time. Simply log into your Dramox account. Hover over the top-right corner icon and click on “My Profile” from the dropdown. On your profile page click on “Cancel Subscription”. You can continue to use Dramox until your current subscription ends. Your subscription will not be renewed.\\n"}}}');

/***/ }),

/***/ 60218:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Frequently Asked Questions","know_more":"Didn\'t find what you were looking for? Contact us at","items":{"1":{"q":"What is Dramox?","a":"Dramox is online theater. It is a streaming service offering the largest selection of theater recordings. Watch your favorite plays or discover new ones, anytime, anywhere, and without commercials. New plays are added each month."},"2":{"q":"What can I find on Dramox?","a":"Dramox offers access to the largest selection of world-class performances from world stages. Hundreds of world-class theaters and performances, and thousands of minutes of entertainment."},"3":{"q":"How many plays can I watch?","a":"There is no limit to how many plays you can watch. You are welcome to discover as many as you would like."},"4":{"q":"What do I need in order to use Dramox?","a":"Once your registration is confirmed, you can access Dramox using your internet browser and internet connection. Now you are ready to enjoy theater online."},"5":{"q":"What are the different Dramox subscription plans?","a":"You can use Dramox for {{monthly}} per month or save {{yearlyDiscount}} by choosing an annual subscription plan for {{yearly}}. No hidden fees, no long-term agreements. You have the freedom to cancel your subscription online at any time. Half of your subscription fee goes to theaters, actors and creators."},"6":{"q":"Which countries is Dramox available in?","a":"You can have fun with Dramox anywhere in the world. No matter if you are on the beach in the Caribbean or skiing in the Alps, you will always find the largest selection of theater performances on Dramox. Enjoy theater online and without limits. Please note that although we try our best to gain streaming licences for all countries around the world, some of the performances might not be available in your country."},"7":{"q":"What about commercials?","a":"There are no commercials on Dramox."},"8":{"q":"How do I cancel my Dramox subscription?","a":"You have the freedom to cancel your subscription online at any time. Simply log into your Dramox account. Hover over the top-right corner icon and click on “My Profile” from the dropdown. On your profile page click on “Cancel Subscription”. You can continue to use Dramox until your current subscription ends. Your subscription will not be renewed."},"9":{"q":"How do I resubscribe on Dramox?","a":"Simply log into your Dramox account. Hover over the top-right corner icon (red circle) and click on “My Profile” from the dropdown. On your profile page click on “Get Subscription” and choose your new subscription."},"10":{"q":"How do I use Dramox on a Smart TV without the Dramox app?","a":"Our media player supports wireless video and audio transmission using Chromecast or AirPlay. If your TV supports this technology, you can choose to mirror your smartphone screen on your TV screen. Simply choose a Dramox play on your phone and click on “Play”. Click on the monitor icon in the lower-right corner. Your screen should display a menu showing the list of TVs connected to the same Wi-Fi network. Select your TV from the menu, and you are now ready to watch Dramox theater and to control it directly from your phone.\\n"},"11":{"q":"Can I use Dramox as an app for Smart TVs?","a":"Yes, the Dramox app is now available for Samsung and LG TVs. For more information on how to use the Dramox app, visit our <linkSmartTvGuide>Smart TV Guide</linkSmartTvGuide>. We are currently in the process of developing apps for other TV brands."},"12":{"q":"Is Dramox available as a mobile app?","a":"Yes, it is. For more information please check out our <linkMobileAppsGuide>Smartphones and Tablets Guide</linkMobileAppsGuide>."},"13":{"q":"Which theaters has Dramox partnered with?","a":"You can find the list of partnering theaters on the <linkAboutUs>About Us</linkAboutUs> page."},"14":{"q":"How does a Dramox free trial work?","a":"Registering for a free 7-day trial is easy. Simply add your credit card details to your account and choose the Free Trial option. Your credit card will not be charged during your free 7-day trial and you have the freedom to cancel your subscription online at any time and with no cancellation fees. If you would like to continue using Dramox following the free 7-day trial, your subscription will begin automatically.","no_trial_q":"How does Dramox work?","no_trial_a":"If you decide to cancel your subscription before it ends, you will not be charged. You can simply cancel an active subscription from your account."},"15":{"q":"How can I support theaters?","a":"We send half of every subscription fee to theaters, artists and creators, so you are supporting theaters by simply watching your favorite performances on Dramox. If you would like to make an additional contribution, you are free to send any amount directly to the theaters of your choosing through our <linkDonate>Theater Donations page</linkDonate>. We do not keep any of the proceeds; we only pay the payment gateway for providing their technology for secure payments."},"16":{"q":"How many devices can I use to watch Dramox?","a":"You can use as many devices as you want, although not at the same time from the same account. This means that if you want to watch Dramox on your phone and on your laptop at the same time, you will need two separate accounts. However, if you watch Dramox on your laptop at home and you use your tablet on your way to work, one account will do."},"17":{"q":"Can I buy a Dramox subscription as a gift?","a":"Online theater as a gift? What a great idea! You can choose from our 1-month, 3-month, 6-month or 12-month subscription plans. The gift voucher becomes active once it is added by the recipient to their account, and it expires one year from the date of activation. To find out more about gift vouchers, visit our <linkVouchers>Vouchers</linkVouchers> page."},"18":{"q":"Can I use a gift voucher if I already have an active subscription?","a":"Yes, you can. Log into your Dramox account. Hover over the top-right red icon and click on “My Profile” from the dropdown. On your profile page click on “Cancel Subscription”. Once your current subscription expires, we will send you a notification asking you to make a payment, if you wish to continue your subscription. You will then be able to select the option “I have a voucher\\" instead of “Pay by card”, on your profile page."},"19":{"q":"How can I refer friends to Dramox and earn up to 5 months of free subscription?","a":"<p>Are you enjoying your Dramox experience and know someone who would enjoy online theater as well? Refer us and earn up to 5 months of free subscription. This offer is available for anyone registered on <linkDramox>Dramox.com.ua</linkDramox> with an active or inactive subscription, using a credit card or voucher.</p> <p>Simply log into your Dramox account, hover over the top-right red icon and click on “Referral” from the dropdown. You will then be able to view your referral code, which can be used up to 5 times. Invite your friends to try out our theater streaming platform and receive up to 5 months of free subscription, worth over €55. Each time one of your referred friends registers and activates their subscription using your referral code, you get a free month added to your subscription and they also receive a free month with Dramox.</p> <p>Don\'t have a Dramox account yet? Sign up <linkRegister>here</linkRegister> and choose your preferred subscription plan, which will begin with a free 7-day trial.</p>","no_trial_a":"Are you enjoying your Dramox experience and know someone who would enjoy online theater as well? Refer us and earn up to 5 months of free subscription. This offer is available for anyone registered on <linkDramox>Dramox.com.ua</linkDramox> with an active or inactive subscription, using a credit card or voucher. Simply log into your Dramox account, hover over the top-right red icon and click on “Referral” from the dropdown. You will then be able to view your referral code, which can be used up to 5 times. Invite your friends to try out our theater streaming platform and receive up to 5 months of free subscription. Each time one of your referred friends registers and activates their subscription using your referral code, you get a free month added to your subscription and they also receive a free month with Dramox. Don\'t have a Dramox account yet? Sign up <linkRegister>here</linkRegister> and choose your preferred subscription plan."}}}');

/***/ }),

/***/ 78762:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Did you forget your password? Don\'t worry, we\'ll help.","email":"Email","email_placeholder":"Enter email address","btn":"Reset password","server_error":"This email address doesn\'t exist","changes_not_saved":"Password reset failed. Please try again later.","changes_saved":"Password reset link was sent to your email."}');

/***/ }),

/***/ 57548:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Watch Dramox at home or on the road!","web":{"title":"PCs and laptops","supported_browsers":"Supported browsers","subtitle":"Web portal Dramox","content":"We support most of the commonly used web browsers on Windows, Linux, and macOS operating systems.","button":"Start Watching"},"smart_tv":{"title":"Smart TV","samsung_title":"App for Samsung Smart TV","samsung_description":"Dramox application for Samsung 2018 models and newer, with Tizen 4.0 OS & up.","lg_title":"App for LG Smart TV","lg_description":"Dramox application for 2016 models or newer with WebOS 3.0 & up.","button":"Installation Guide"},"mobile":{"title":"Smartphones\\nand tablets","android_title":"Mobile application for Android","android_description":"We support smartphones and tablets with the operating system Android 5.1.1 & up.","ios_title":"Mobile application for iOS","ios_description":"We support smartphones and tablets with the operating system of iOS 11 & up.","button":"Installation Guide"},"streaming":{"title":"Chromecast\\nand AirPlay","airplay_title":"Apple AirPlay","airplay_description":"Stream theater performances on your TV with Apple AirPlay.","chromecast_title":"Google Chromecast","chromecast_description":"Stream theater performances on your TV with Google Chromecast.","button":"How it Works"}}');

/***/ }),

/***/ 7756:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Refer your friends and receive up to 5 months of Dramox for free.","code_for_friend":"Referral code (can be redeemed up to 5 times)","copy_code":"Copy code","what_to_do":"What do my friends have to do?","step_1":"They create a new Dramox account.","step_2":"After choosing their subscription plan, they enter the referral code: <0>{{promoCode}}</0>","step_3":"They activate their subscription for at least 1 month by entering their payment card details.","step_4":"Once their first subscription is activated, you and your friends will receive 1 month of Dramox for free.","invited_friends":"Referred friends","invite_benefit":"Refer your friends and receive up to 5 months of Dramox for free. Friends who activate their Dramox subscription will also get 1 month free.","title_not_allowed":"Inviting friends is available only to users with a subscription.","buy_subscription":"Buy a Subscription","more_1":"More information about subscriptions can be found in ","more_2":"FAQ","code_copied":"Code copied","description_not_allowed":"This offer is available for anyone registered on Dramox with an active or inactive subscription, using a credit card or gift voucher. Never subscribed to Dramox before? Buy a subscription now, refer your friends and get up to 5 months of free online theater. If you are currently on a free trial, you have to wait until your paid subscription begins, once the trial period ends.","no_trial_description_not_allowed":"This offer is available for anyone registered on <linkDramox>Dramox.tv</linkDramox> with an active or inactive subscription, using a credit card or voucher. Don\'t have a Dramox account yet? Sign up <linkRegister>here</linkRegister> and choose your preferred subscription plan."}');

/***/ }),

/***/ 9305:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"login":"Log In","not_register_yet":"No account yet?","try_trial":"Try our FREE 7-day trial","email":"Email","password":"Password","forgotten_password":"Forgotten Password?","login_btn":"Log In","not_activated":"We\'re sorry but your account has not been activated. If you already have an active account, please contact us.","no_trial_try_trial":"Begin your Dramox adventure."}');

/***/ }),

/***/ 79609:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"android_title":"Mobile application for Android","android_description":"Available for smartphones and tablets with the operating system Android 5.1.1 & up. Do you need help? E-mail us at <a href=\\"mailto:support@dramox.tv\\">support@dramox.tv</a>.","android_instalation":"Installing the Dramox mobile application","android_step_1":"<a href=\\"https://play.google.com/store/apps/details?id=cz.dramox.dramox\\" target=\\"_blank\\">Click on this link to download the application</a>, or open Google Play on your smartphone and type Dramox in the search box.","android_step_2":"Install the application by clicking the <strong>Install button</strong>.","android_step_3":"Open the newly installed Dramox application.","android_step_4":"Log in with your email address and the password you use to log into your Dramox account.","android_step_5":"If you\'re happy with the app, we\'d appreciate it if you gave us a rating on Google Play.","ios_title":"Mobile application for iOS","ios_description":"Available for smartphones and tablets with the operating system iOS 11 & up. Do you need help? E-mail us at <a href=\\"mailto:support@dramox.tv\\">support@dramox.tv</a>.","ios_instalation":"Installing the Dramox mobile application","ios_step_1":"<a href=\\"https://apps.apple.com/cz/app/dramox-divadlo-online/id1563430137\\" target=\\"_blank\\">Click on this link to download the application</a> or open the App Store on you smartphone and type Dramox in the search box.","ios_step_2":"Install the application by clicking the <strong>Get</strong> button.","ios_step_3":"Open the newly installed Dramox application.","ios_step_4":"Log in with your email address and the password you use to log into your Dramox account.","ios_step_5":"If you\'re happy with the app, we\'d appreciate it if you gave us a rating on the App Store."}');

/***/ }),

/***/ 19610:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"premiere":"Premiere","trailer":"Trailer","support":"Donate","genres":"Genres","awards":"Awards","same_cast":"Same cast","similar_genre":"Similar performances","theatre_more":"More from this theater","show_all":"Show all","cast":"Cast","donate_bubble_title":"Liked the performance?","donate_bubble_link":"Support the theater","playback_error_title":"Video cannot be played at the moment","playback_error_content":"We apologize but the selected performance cannot be played at the moment. Please check your internet connection and try again.","playback_error_action":"Return to Perfomance Info","low_quality":"Performance with reduced video quality","support_theater":"Support online theater","watch_list":"Watchlist","on_watch_list":"On Watchlist","added_to_watch_list":"Added to Watchlist","removed_from_watch_list":"Removed from Watchlist"}');

/***/ }),

/***/ 8934:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"auto_quality":"Auto","back":"Back","captions":"Subtitles","cast_to_other_devices":"Chromecast","enter_picture_in_picture":"Enter Picture in Picture","exit_fullscreen":"Exit Fullscreen","exit_picture_in_picture":"Exit Picture in Picture","fullscreen":"Fullscreen","language":"Language","live":"Live","more_settings":"More Settings","multiple_languages":"More Languages","mute":"Mute","not_applicable":"Not Applicable","off":"Off","on":"On","pause":"Pause","picture_in_picture":"Picture in Picture","play":"Play","resolution":"Quality","seek":"Seek","undetermined_language":"Unknown Language","unmute":"Unmute","volume":"Volume"}');

/***/ }),

/***/ 73398:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"activate_subscription_title":"Activate your subscription","activate_subcription_content":"Gain access to hundreds of licensed theater recordings for you to watch online!","activate_subscription_button":"Choose your subscription plan","login_title":"Log In","login_content":"Performance is only available to logged in users with an active subscription.","login_action":"Log In","login_footer":"No account yet? <0>Register now</0>","low_quality_title":"Reduced video quality","low_quality_text":"Please excuse this recording’s reduced quality. This footage is the best we have available. However, we were so impressed by this production that it would be a shame not to present it to you on Dramox. We wish you a pleasant theatrical experience.","low_quality_btn":"Ok, I understand"}');

/***/ }),

/***/ 51891:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"my_profile":"My Profile","subscription":"Subscription Plan","subscription_unlimited":"Your current subscription plan is unlimited","unlimited_description":"Enjoy watching Dramox!","monthly":"Monthly","yearly":"Yearly","price_with_vat":"{{price}} incl. VAT","voucher":"I have a voucher","subscription_none":"Get a monthly or annual subscription plan with Dramox","subscription_none_text":"Gain access to hundreds of licensed theater recordings for you to watch online!","personal_details":"Personal Details","full_name":"Full Name","save_changes":"Save Changes","password_change":"Password Change","password_change_success":"Password was changed.","password_change_fail":"Password change failed.","account_delete_success":"Account was deleted.","actual_password":"Current Password","new_password":"New Password","new_password_again":"New Password Again","purchase_history":"Purchase History","delete_account":"Delete Account","delete_account_text":"Deleting the account will terminate your active subscription and delete all data on the Dramox server.","theatre_donate":"Theater donation","subscription_bundles":"Subscription","voucher_pay":"Voucher","empty_purchase":"Your purchase history will appear in this section once you\'ve made your first subscription payment or your first donation.","recurrence_monthly":"You\'re currently subscribed to a monthly plan","recurrence_quarterly":"You\'re currently subscribed to a quarterly plan","recurrence_semi_annual":"You\'re currently subscribed to a semi-annual plan","recurrence_yearly":"You\'re currently subscribed to an annual plan","subscription_expired_trial":"Your trial will run out on <0>{{date}}</0>. Your subscription will be automatically renewed on the same day.","subscription_expired":"Your subscription will be automatically renewed on <0>{{date}}</0>","delete_account_title":"Deleting the account","delete_popup_close":"Close","delete_account_submit":"Delete the entire account","delete_subscription_title":"Cancel subscription plan","delete_subscription_text":"Your current plan will still remain active until it expires. Then it will be cancelled automatically.","cancel_subscription":"Cancel subscription plan","choose_card":"Choose card","choose_card_text":"Are you sure you want to use this card for all future payments?","btn_submit":"Submit","remove_card":"Remove card","remove_card_text":"Are you sure you want to remove this card from your account?","card_primary":"primary","card_choose":"Choose","card_no_added":"No card added","subscription_end_description":"Your subscription plan will automatically end on <0>{{date}}</0>","profile_changes_not_saved":"Changes could not be saved. Please try again later.","profile_changes_saved":"Changes saved","card_added":"Card added successfuly.","card_added_error":"Your card was declined. Please check your card details and expiration date.","load_more":"Load more","subscription_canceled_success":"Subscription plan is now cancelled!","subscription_canceled_fail":"Failed to cancel your subscription.","payment_card_delete_success":"Card deleted successfully.","payment_card_delete_fail":"Failed to delete card.","change_payment_card_primary_success":"Your primary card has been set.","change_payment_card_primary_fail":"Failed to change the primary card.","email_newsletter":"Newsletter","email_newsletter_text":"Do you want to stay in the know and receive the Dramox newsletter?","email_newsletter_action_subscribe":"Subscribe to newsletter","email_newsletter_action_unsubscribe":"Deactivate","email_newsletter_success_title":"Thanks for subscribing to the newsletter.","email_newsletter_success_description":"You can now close this window.","residency_tooltip":"If this is not your country of residence, please contact our customer support.","language_select":"Select language","grace_period_title":"Your subscription could not be extended","grace_period_description":"Please check your payment details and your card balance. Until {{date}} we\'ll automatically try to extend your subscription once a day. After this date, the service will become unavailable and your subscription will be cancelled.","grace_period_action":"Pay Now - {{price}}","delete_subscription_grace_text":"Your subscription will be cancelled.","ui_language":"Website Language","prolonged_subscription":"We\'ve extended your subscription.","remove_sub_promo_title":"We are sorry you want to leave","remove_sub_promo_text":"Refer your friends and get up to 5 months of Dramox for free","remove_sub_get_more":"More","remove_sub_or":"or","remove_sub_removing":"Cancel the subscription. Your current plan will still remain active until it expires. Then it will be cancelled automatically.","sub_from_campaign":"You are currently enjoying the free period from the promotion.","sub_from_user":"You are currently enjoying the free period from your friends.","discount_info":"Until {{date}}, you have {{discount}}% discount on purchased subscriptions.","promo_discount_title":"<0>{{discount}}%</0>discount for {{timespan}}","promo_discount_content":"When activated you get {{discount}}% discount for {{timespan}} on your subscription.","promo_free_title":"<0>{{timespan}}</0>free subscription","promo_free_content":"When activated you get {{timespan}} free with your current subscription.","promo_action":"Activate discount","promo_activation_success":"Promo code activated.","promo_activation_fail":"Promo code failed to activate.","no_trial_subscription_expired_trial":"Your subscription will be automatically renewed on {{date}}.","promo_code_heading":"Enter a voucher or promo code","promo_code_input_placeholder":"Enter a code","promo_code_button_enter":"Enter a code","promo_code_button_activate":"Activate"}');

/***/ }),

/***/ 83141:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Hundreds of licensed theater recordings to watch online","description":"<0>FREE <1>7-day</1> Trial. The subscription plan can be cancelled anytime.</0>","full_name":"Full Name","email":"Email","btn_continue":"Continue","register_terms":"<0>By clicking “Continue” you agree with our <1>Terms & Conditions</1> and <2>Privacy policy</2>.</0>","already_account":"Already have an account?","login_prompt":"Log In","setup_password":"Almost there. Now set up a password.","password_placeholder":"Minimum 8 characters","password":"Password","password_again":"Password again","changes_not_saved":"Request couldn\'t be processed. Please try again later.","changes_saved":"Changes saved","confirm_email_title":"Please check your email inbox.","confirm_email_text":"<0>An email has been sent to <1>{{email}}</1> where you can activate your account by clicking the activation link.</0>","country_of_residence":"Country of Residence","no_trial_description":"<0>You can cancel your subscription anytime. </0>"}');

/***/ }),

/***/ 50128:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"forschools_bottom_desc":"Offer your students an online theater experience for just {{studentMonthly}}/month and save 50% off our standard monthly subscription fee.","forschools_button":"Order Dramox For Schools","forschools_description":"Dramox For Schools offers teachers the opportunity to make their lessons more fun. Students will discover the beauty of theater and literature in a way that is entertaining to them – by watching videos online. They will also have access to our worksheets, designed for their enjoyment, using emojis, Facebook comments, pictures..","forschools_footer":"For Schools","forschools_for_class_desc_1":"Please reach out to us at <0>education@dramox.tv</0>.","forschools_for_class_desc_2_1":"We will get back to you shortly, to discuss the specifics of your request. (E.g. number of vouchers, length of membership, etc.).","forschools_for_class_desc_2_2":"It is important to note that each voucher contains a unique code, which is valid for one student only. Unfortunately, one voucher cannot be shared amongst an entire class or school.","forschools_for_class_desc_3":"We will receive payment from your institution.","forschools_for_class_desc_4":"Upon successful payment, your ordered e-vouchers will be immediately sent over to the email address provided.","forschools_for_class_desc_5":"Your students will register on Dramox using their unique voucher code. Depending on the selected subscription plan, they will gain access to online theater performances, for 1, 3, 6 or 12 months.","forschools_for_class_title":"How do I order Dramox For Schools for my class or school?","forschools_for_who_desc_1":"Our offer is primarily available for students enrolled in secondary, post-secondary and higher education.","forschools_for_who_desc_2":"If you do not exactly match the above criteria, but are part of another type of educational institution and would like to take advantage of this offer, please contact us at <0>education@dramox.tv</0>. We will be happy to accommodate you.","forschools_for_who_title":"Who is this offer for?","forschools_obligatory":"We offer a large selection of theater performances based on stories from <0>compulsory reading</0> lists. New productions are added each month. Students also gain access to hundreds of other recordings, which they can easily watch while munching on popcorn or lounging around in their sweatpants.","forschools_price":"{{studentMonthly}}","forschools_price_desc":"monthly / per student","forschools_student_price_desc":"The price for a monthly student subscription plan is {{studentMonthly}} per student. That\'s {{studentMonthlyPercentageDiscount}} % off the standard subscription fee which is {{monthly}}.","forschools_student_price_title":"What is the discounted price for students?","forschools_title":"Dramox For Schools"}');

/***/ }),

/***/ 52540:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"welcome_title":"Dramox | Your online theater","welcome_description":"Watch hundreds of theater performances online with Dramox.","browse_title":"Hundreds of theater performances online | Dramox","browse_description":"Choose among hundreds of top theater performances online with Dramox. Try it out FOR FREE.","celebrity_title":"{{name}} | Online theater | Dramox","performance_title":"{{title}} | {{theatre}} online | Dramox","watch_performance_title":"{{title}} - watch online | {{theatre}} | Dramox","theatres_title":"Your favorite theaters online | Dramox","theatres_description":"Watch performances from hundreds of theaters with Dramox. Try it out for FREE. Find your favorite theater online.","theatre_title":"{{name}} | Online theater | Dramox","404_title":"Dramox online theater | Looking for the page","404_description":"Unfortunately we couldn\'t find the requested page on Dramox. Why don\'t you choose from the hundreds of online theater performances instead?","about_us_title":"Dramox online theater | About us","about_us_description":"Dramox offers hundreds of theater performances online. Try it out for FREE. To support remote learning programs, Dramox offers a 50 percent discount for schools.","authorship_title":"Dramox online theater | We protect copyrights","authorship_description":"Dramox supports theater culture by presenting theater performances online. We do our best to ensure that every author gets their fair share. Dramox exclusively offers licensed recordings.","choose_plan_title":"Dramox | Online theater for a month, or three, or a whole year?","choose_plan_description":"Choose your subscription plan","contact_title":"Dramox online theater | Contact Us","contact_description":"Do you have a question about Dramox or online theater performances? Please contact us at support@dramox.tv. We are happy to help.","cookies_title":"Dramox online theater | For a better viewing experience","cookies_description":"Dramox online theater uses cookies, little helpers for a perfect viewing experience. Try it out FOR FREE. Choose from hundreds of theater performances.","donate_home_title":"Support Theaters","donate_title":"Dramox | Support {{theatre}} online","donate_description":"By supporting your favorite online theater using Dramox, you also support the theater\'s productions and culture. Almost all of the proceeds go straight to the theater. We don\'t keep anything, we only pay the payment gateway for providing their technology for secure payments.","for_schools_title":"Online theater for schools | Dramox","for_schools_description":"Order a Dramox subscription plan for your school and get a 50 percent discount. There are dozens of stories from compulsory reading lists available online with Dramox. FREE worksheets for a more enjoyable online lesson.","forgotten_password_title":"Dramox online theater | Forgotten password","forgotten_password_description":"You can watch online theater with Dramox again in a moment. Please enter your email address to receive a new password.","frequently_asked_questions_title":"Dramox | Frequently asked questions","frequently_asked_questions_description":"Dramox is online theater. Choose from hundreds of performances and watch for FREE. Interested? Please check out our frequently asked questions.","vouchers_buy_title":"Online theater as a gift | Dramox","vouchers_buy_description":"A Dramox voucher is the perfect give for just about everyone. Give your loved ones the gift of  hundreds of theater performances and entertainment online. Buy now, give anytime.","login_title":"Dramox online theater | Login","login_description":"You can start watching online theater with Dramox in a moment. Please log in with your email address and the password you created during registration.","playlist_performance_similar_genre_title":"{{performance}} – Your favorite theater genre online | Dramox","playlist_performance_similar_genre_description":"You will find your favorite theater genre online with Dramox by watching {{performance}}. Drama, musicals, ballet, puppet shows - new performances are added regularly. Start watching today.","playlist_performance_similar_cast_title":"{{performance}} – Your favorite performing artists online | Dramox","playlist_performance_similar_cast_description":"You can find your favorite performing artists in the theater performance {{performance}} online with Dramox. Try it out FOR FREE. Start watching today.","playlist_genre_title":"Online theater performance of the genre {{genre}} | Dramox","playlist_genre_description":"Enjoy your favorite theater genre online on Dramox. Drama, musicals, ballet, puppet shows - new performances are added regularly. Try it out FOR FREE.","playlist_featured_title":"Online theater performance from the category {{section}} | Dramox","playlist_featured_description":"You will find a theater performance from the category {{section}} online on Dramox. Enjoy the theater even more!","playlist_currently_watching_title":"Dramox online theater | Currently watching","playlist_currently_watching_description":"Watch hundreds of  theater performances from dozens of theaters online with Dramox. Try it out FOR FREE. Have fun with online theater today!","playlist_most_popular_title":"Dramox online theater | Most popular performances","playlist_most_popular_description":"Watch the most popular theater performances with Dramox as rated by our online audiences. Tragedies, comedies, romance, as well as fairy tales - there\'s something for every member of the family.","playlist_recent_title":"New performances available | Dramox online theater","playlist_recent_description":"Watch the newest theater performances online on Dramox. Tragedies, comedies, romance, as well as fairy tales - new performances are added regularly. Watch a different performance every day.","profile_title":"Dramox online theater | My profile","profile_description":"Welcome to Dramox online theater. Select from hundreds of theater performances.Tragedies, comedies, romance, fairy tales for children – enjoy theater even more!","register_step1_title":"Dramox online theater | New user registration","register_step1_description":"You can start watching theater online with Dramox in just a moment. Please complete your registration.","register_step2_title":"Dramox online theater | Set up your password","register_step2_description":"You can start watching theater online with Dramox in just a moment. Please set up your password. It can be changed at any time.","register_confirm_email_title":"Dramox online theater | Email address confirmation","register_confirm_email_description":"You can start watching theater online with Dramox in just a moment. Please confirm your email address.","terms_conditions_title":"Dramox online theater | Terms and Conditions","terms_conditions_description":"We have transparent terms and conditions for watching hundreds of theater performances. We believe that open and straightforward communication is the key to making good friends.","privacy_policy_title":"Dramox online theater | Privacy policy","privacy_policy_description":"Here at Dramox we protect your privacy. Your personal data are safe with us. We use reliable technologies and work in compliance with GDPR.","how_to_watch_web_title":"Online theater on your computer | Dramox","how_to_watch_web_description":"Stream online theater comfortably on your computer. Access hundreds of performances and world-class theaters from your home! Try our free 7-day trial.","how_to_watch_tv_title":"Application for Smart TV | Dramox","how_to_watch_tv_description":"Download Dramox TV application for smart TVs. The best theater performances from the comfort of your home anytime. Try our free 7-day trial.","how_to_watch_tv_samsung_title":"App for Samsung TV | Dramox online theater","how_to_watch_tv_samsung_description":"Download our Samsung Smart TV app and watch the best theater shows in the comfort of your home. Try our free 7-day trial.","how_to_watch_tv_lg_title":"App for LG TV | Dramox online theater","how_to_watch_tv_lg_description":"Download our LG Smart TV app and watch the best theater shows in the comfort of your home. Try our free 7-day trial.","how_to_watch_mobile_title":"Mobile application for Android and iOS |  Dramox online theater","how_to_watch_mobile_description":"Download our mobile app for smartphones and tablets. Hundreds of performances and the best performing artists at your fingertips at any time. Try our free 7-day trial.","how_to_watch_mobile_ios_title":"App for iOS | Dramox online theater","how_to_watch_mobile_ios_description":"Download our mobile app for iOS smartphones and tablets and have online theater at your fingertips at any time. Try our free 7-day trial.","how_to_watch_mobile_android_title":"App for Android | Dramox online theater","how_to_watch_mobile_android_description":"Try our Dramox app for smartphones and tablets with OS Android and enjoy hundreds of performances on your smartphone. Try our free 7-day trial.","how_to_watch_streaming_title":"Online theater from phone to TV | Dramox","how_to_watch_streaming_description":"Watch online theater on your smart TV without an app. Dramox Player supports wireless streaming via AirPlay and Chromecast from your smartphone to the TV.","how_to_watch_streaming_chromecast_title":"Dramox from your smartphone to your TV via Chromecast","how_to_watch_streaming_chromecast_description":"Watch Dramox on your smart TV without using an app. Our player supports wireless connection between your smartphone and your TV via Chromecast. Enjoy online theater.","how_to_watch_streaming_airplay_title":"Dramox from your smartphone to your TV via AirPlay","how_to_watch_streaming_airplay_description":"Watch Dramox on your smart TV without using an app. Our player supports wireless connection between your smartphone and your TV via AirPlay. It’s easy and convenient.","playlist_dramox_originals_title":"Only on Dramox | Dramox Originals","playlist_dramox_originals_description":"Gain online access to exclusive Dramox productions. Watch Dramox Originals and enjoy world-class online theater, on Dramox.tv. Start your free 7-day trial.","content_settings_title":"Language Preferences | Dramox","content_settings_description":"Tailor your online theater experience to your preferences and enjoy Dramox to the fullest.","ua_support":"Support Ukrainian culture","easter_contest_title":"Easter Contest | Dramox","easter_contest_desc":"Win theater tickets and gift vouchers. Entertain yourself with online theater over Easter break. The more you watch, the greater your chances of winning.","discount_title":"50% off your subscription | Dramox","discount_description":"Stream world-class theater for up to 6 months for €5.95/month and save €35.7 on the standard subscription price. Offer valid for 7 days only. Claim now.","broadcast_title":"Live broadcasting","broadcast_description":"Live news broadcasting on Dramox","no_trial_how_to_watch_web_description":"Stream online theater comfortably on your computer. Access hundreds of performances and world-class theaters from your home!","no_trial_how_to_watch_tv_description":"Download our Smart TVs app and fall in love with world-class theater.","no_trial_how_to_watch_tv_samsung_description":"Download our Samsung Smart TV app and watch the best theater shows in the comfort of your home.","no_trial_how_to_watch_tv_lg_description":"Download our LG Smart TV app and watch the best theater shows in the comfort of your home.","no_trial_how_to_watch_mobile_description":"Download our mobile app for smartphones and tablets. Hundreds of performances and the best performing artists at your fingertips at any time.","no_trial_how_to_watch_mobile_ios_description":"Download our mobile app for iOS smartphones and tablets. Hundreds of performances and the best performing artists at your fingertips at any time.","no_trial_how_to_watch_mobile_android_description":"Download our mobile app for Android smartphones and tablets. Hundreds of performances and the best performing artists at your fingertips at any time.","no_trial_playlist_dramox_originals_description":"Gain online access to exclusive Dramox productions. Watch Dramox Originals and enjoy world-class online theater, on Dramox.tv","christmas_contest_title":"Christmas Contest | Dramox Online Theater","christmas_contest_description":"This December, stream online theater on Dramox and win gift vouchers, tickets to Dejvice Theater and many more. The more performances you watch, the higher your chance of winning.","celebrity_default_about":"{{name}} was directly involved in the following productions available on Dramox: {{plays}} from the following theater: {{theatre}}. Enjoy online theater with your favourite creatives."}');

/***/ }),

/***/ 72604:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"content_settings_title":"Language Preferences","perfomance_language_settings_title":"Select the language of theater performances","perfomance_language_settings_subtitle":"Tailor your online theater experience by filtering our playlist based on your preferred language. Your settings can be changed at any time.","btn_content_settings_register_submit":"Confirm","btn_content_settings_register_skip":"Skip","submit_error":"Settings could not be saved. Please try again later.","submit_ok":"Settings have been saved."}');

/***/ }),

/***/ 22207:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"samsung_title":"Dramox app for Samsung Smart TV","samsung_desc":"Available for 2018 models and newer, with OS Tizen 4.0 and later. Do you need help? Please contact us at <a href=\\"mailto:support@dramox.tv\\">support@dramox.tv</a>.","samsung_instalation":"Installing the Dramox TV application","samsung_step_1":"Press the <b>Home</b> button or the <b>Smart Hub</b> button on your remote control.","samsung_step_2":"Select the <b>APPS</b> tile from the bottom control bar.","samsung_step_3":"In the app store, select the <b>Search icon</b> and type in Dramox.","samsung_step_4":"Select the <b>Dramox</b> app from the search results.","samsung_step_5":"On the application details page, click the <b>Install</b> button. Log in with your Samsung account if prompted by the app store.","samsung_step_6":"After successful installation, click the <b>Add to home screen</b> button. The application will appear in the menu in the bottom control bar.","samsung_step_7":"After opening the Dramox app, log into your Dramox account by entering your email and password.","lg_title":"Dramox app for LG Smart TV","lg_desc":"Available for 2016 models and newer, with webOS 3.0 and higher. Do you need help? Please contact us at <a href=\\"mailto:support@dramox.tv\\">support@dramox.tv</a>.","lg_instalation":"Installing the Dramox TV application","lg_step_1":"Press the <b>Home</b> button on your remote control.","lg_step_2":"Select the <strong>LG Content Store</strong> tile from the bottom control bar.","lg_step_3":"In the app store, select the <b>Search icon</b> and type in Dramox.","lg_step_4":"Select the <b>Dramox</b> app from the search results.","lg_step_5":"On the application details page, click the <b>Install</b> button.","lg_step_6":"After successful installation, the Dramox app can be found at the end of your <strong>Home Screen</strong>. Click on <strong>Launch</strong>.","lg_step_7":"After opening the Dramox app, log into your Dramox account by entering your email and password."}');

/***/ }),

/***/ 74608:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"theatres":"Theaters","detail":"Detail","support":"Donate","web_page":"Theater Website","theatre_plays":"Plays by this theater","choose_donate":"Choose your favorite theater to donate to","theatre":"Theater","continue":"Continue","choose_theatre":"Choose theater","min_donate":"The minimum amount is {{value}} {{currency}}.","max_donate":"The maximum amount is {{value}} {{currency}}.","donate_how_much":"How much would you like to donate?","donate_note":"Almost all of the proceeds go straight to the theater. We don\'t keep anything, we only pay the payment gateway for providing their technology for secure payments.","amount_other":"Other","button_submit":"Submit","changes_not_saved":"Changes could not be saved. Please try again later.","changes_saved":"Changes saved","donation_success":"Thank your for your support!","donation_fail":"Payment failed.","amount_in_currency":"Amount in {{currency}}","must_login":"You need to log into your account first.","dramox_theatres":"Dramox theaters","sort_alphabeticaly":"Alphabetically","sort_newest":"Newest First","sort_popular":"Popular First","sort":"Sort","genre":"Genre","language":"Language","country":"Country","filter_all":"All","clear_filter":"Clear Filter","most_popular_theatres":"Most popular theaters","popular_this_week_theatres":"Popular theaters this week","no_theatres":"No theaters found.\\n","plays_count_zero":"{{count}} performance","plays_count_one":"{{count}} performance","plays_count_few":"{{count}} performances","plays_count_many":"{{count}} performances","register":"Register","amount":{"one":"","other":"","few":"","many":""}}');

/***/ }),

/***/ 16708:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Support Ukrainian culture: 100% of proceeds are sent to Ukrainian theaters","subtitle":"On the 17th of February, Dramox officially announced its Ukrainian expansion at a press conference in Kyiv, featuring 17 national theaters at the time. We expected the number of partnering theater companies to grow rapidly, however, recent events resulted in an unexpected halt to our plans. ","text_1":"Ordinary and cultural life have stopped in Ukraine and Dramox has become the only place where Ukrainian performances can be safely enjoyed.","text_2":"<p>That is why we are focused on maximizing our support, by offering <span>100% of the funds raised through subscriptions and donations. If you <ukTheater>watch Ukrainian performances</ukTheater>, you directly support Ukrainian theaters.</span></p>","how_watch_title":"How to watch","how_watch_1":"Log into your Dramox.tv account","how_watch_2":"<li>Click <span>Language Preferences</span> from the top-right dropdown menu and select Українська</li>","how_watch_3":"Now you can access all performances in Ukrainian","how_watch_soon":"More Ukrainian content will appear on Dramox shortly and we are currently in the process of adding English subtitles to more performances."}');

/***/ }),

/***/ 50156:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"airplay_title":"Streaming to a TV via AirPlay","airplay_description":"AirPlay is Apple technology used for streaming multimedia content from Apple devices on your TV.","airplay_instalation":"How to stream a performance via AirPlay","airplay_step_1":"Your smart TV must be connected to the same Wi-Fi as your laptop, smart phone, or tablet.","airplay_step_2":"The TV must support AirPlay technology.","airplay_step_3":"Play the selected performance - in <strong>Safari</strong> web browser or using the <a href=\\"https://apps.apple.com/cz/app/dramox-divadlo-online/id1563430137\\" target=\\"blank\\">mobile app for iOS</a>.","airplay_step_4":"Click the <0></0> icon in the bottom right-hand corner.","airplay_step_5":"In your Wi-Fi network, select the TV you want to stream the performance to.","chromecast_title":"Streaming to the TV via Chromecast","chromecast_description":"Chromecast is Google technology used for streaming multimedia content on your TV.","chromecast_instalation":"How to stream a performance via Chromecast","chromecast_step_1":"Your Smart TV must be connected to the same Wi-Fi as your laptop, smart phone, or tablet.","chromecast_step_2":"The TV must support Chromecast technology.","chromecast_step_3":"Play the selected performance - <strong>in Chrome, Opera web browser</strong> or using the <a href=\\"https://play.google.com/store/apps/details?id=cz.dramox.dramox\\" target=\\"_blank\\">mobile app for Android.</a>","chromecast_step_4":"Click the gear icon <0></0> in the bottom right-hand corner.","chromecast_step_5":"Click the Chromecast icon. <0></0>","chromecast_step_6":"In your Wi-Fi network, select the TV you want to stream the performance to."}');

/***/ }),

/***/ 92484:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Dramox as a Gift","description":"Treat your loved ones to unique entertainment while also supporting performing arts. Dramox sends most of the funds raised through subscriptions to theaters, creators, and actors.\\n\\nAfter successful payment, the voucher will be sent to your email.","buy_btn":"Buy a voucher","for_companies":"For companies wishing to purchase multiple gift vouchers (10 or more), please contact us at <contactMail>support@dramox.tv</contactMail>.","price_with_vat":"{{price}} with VAT","buy_success":"Thank you. The voucher will be sent to your email shortly.","buy_fail":"Payment failed.","givery":"In partnership with Givery.cz","buy_physical_voucher":"I want a physical voucher +89 CZK"}');

/***/ }),

/***/ 22799:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"menu_faq":"FAQ","theatres_list_title":"List of theaters","plays_list_title":"Selected performances","new_welcome_sec_1_title_cz":"Culture has never been closer.\\nHundreds of performances in one place.","new_welcome_sec_1_title_xx":"Culture has never been closer.\\nHundreds of performances in one place.","new_welcome_sec_2_text_cz":"Hundreds of theater performances available on Dramox","new_welcome_sec_2_text_xx":"Hundreds of theater performances available on Dramox","new_welcome_sec_2_title_cz":"Browse Library","new_welcome_sec_2_title_xx":"Browse Library","new_welcome_sec_3_text_cz":"By watching Dramox, you support theater culture. A full 55% of your subscription goes directly back to theaters, creators, and actors.\\n\\nPlus, you can send an extra contribution to your favorites anytime. It’s like buying tickets—just more convenient (and more affordable).","new_welcome_sec_3_text_xx":"By watching Dramox, you support theater culture. A full 55% of your subscription goes directly back to theaters, creators, and actors.\\n\\nPlus, you can send an extra contribution to your favorites anytime. It’s like buying tickets—just more convenient (and more affordable).","new_welcome_sec_3_title_cz":"Half of your subscription fee goes straight to the partnering theaters","new_welcome_sec_3_title_xx":"Half of your subscription fee goes straight to the partnering theaters","new_welcome_sec_4_text_xx":"Theater at your fingertips. Watch world-class performances anytime, anywhere. Now available on your computer, mobile phone and Smart TV. Dramox is easy to use and accessible to everyone. Ladies and gentlemen, please take your seats, the show is about to begin.","new_welcome_sec_4_text_cz":"Theater at your fingertips. Watch world-class performances anytime, anywhere. Now available on your computer, mobile phone and Smart TV. Dramox is easy to use and accessible to everyone. Ladies and gentlemen, please take your seats, the show is about to begin.","new_welcome_sec_4_title_cz":"Fall in love with Dramox","new_welcome_sec_4_title_xx":"Fall in love with Dramox","new_welcome_sec_5_text_cz":"You can cancel your subscription anytime.","new_welcome_sec_5_text_xx":"You can cancel your subscription anytime.","new_welcome_sec_5_title_cz":"Try Dramox for 7 days for free","new_welcome_sec_5_title_xx":"Try Dramox for 7 days for free","welcome_button_long_xx":"Start your FREE 7-day","welcome_button_long_cz":"Start your FREE 7-day","welcome_price_cz":"Then enjoy Dramox for {{monthly}} per month, cancel anytime.","welcome_price_xx":"Then enjoy Dramox for {{monthly}} per month, cancel anytime.","welcome_subtitle_xx":"Watch anytime, anywhere. On your smart TV, mobile, tablet, or computer.","welcome_subtitle_cz":"Watch anytime, anywhere. On your smart TV, mobile, tablet, or computer.","welcome_title_cz":"Make time for theater. You can find hundreds of performances online on Dramox","welcome_title_xx":"Take a moment for theater. Watch hundreds of performances online on Dramox.","new_welcome_sec_1_title_sk":"Culture has never been closer.\\nHundreds of performances in one place.","new_welcome_sec_2_text_sk":"Hundreds of theater performances available on Dramox","new_welcome_sec_2_title_sk":"Browse Library","new_welcome_sec_3_text_sk":"By watching Dramox, you support theater culture. A full 55% of your subscription goes directly back to theaters, creators, and actors.\\n\\nPlus, you can send an extra contribution to your favorites anytime. It’s like buying tickets—just more convenient (and more affordable).","new_welcome_sec_3_title_sk":"Half of your subscription fee goes straight to the partnering theaters","new_welcome_sec_4_text_sk":"Theater at your fingertips. Watch world-class performances anytime, anywhere. Now available on your computer, mobile phone and Smart TV. Dramox is easy to use and accessible to everyone. Ladies and gentlemen, please take your seats, the show is about to begin.","new_welcome_sec_4_title_sk":"Fall in love with Dramox","new_welcome_sec_5_text_sk":"You can cancel your subscription anytime.","new_welcome_sec_5_title_sk":"Try Dramox for 7 days for free","welcome_button_long_sk":"Start your FREE 7-day","welcome_price_sk":"Then enjoy Dramox for {{monthly}} per month, cancel anytime.","welcome_subtitle_sk":"Watch anytime, anywhere. On your smart TV, mobile, tablet, or computer.","welcome_title_sk":"Take a moment for theater. Watch hundreds of performances online on Dramox.","new_welcome_sec_1_title_ua":"Culture has never been closer.\\nHundreds of performances in one place.","new_welcome_sec_2_text_ua":"Hundreds of theater performances available on Dramox","new_welcome_sec_2_title_ua":"Browse Library","new_welcome_sec_3_text_ua":"By watching Dramox, you support theater culture. A full 55% of your subscription goes directly back to theaters, creators, and actors.\\n\\nPlus, you can send an extra contribution to your favorites anytime. It’s like buying tickets—just more convenient (and more affordable).","new_welcome_sec_3_title_ua":"Half of your subscription fee goes straight to the partnering theaters","new_welcome_sec_4_text_ua":"Theater at your fingertips. Watch world-class performances anytime, anywhere. Now available on your computer, mobile phone and Smart TV. Dramox is easy to use and accessible to everyone. Ladies and gentlemen, please take your seats, the show is about to begin.","new_welcome_sec_4_title_ua":"Fall in love with Dramox","new_welcome_sec_5_text_ua":"You can cancel your subscription anytime.","new_welcome_sec_5_title_ua":"Try Dramox for 7 days for free","welcome_button_long_ua":"Start your FREE 7-day","welcome_price_ua":"Then enjoy Dramox for {{monthly}} per month, cancel anytime.","welcome_subtitle_ua":"Watch anytime, anywhere. On your smart TV, mobile, tablet, or computer.","welcome_title_ua":"Take a moment for theater. Watch hundreds of performances online on Dramox.","new_welcome_sec_1_title_pl":"Culture has never been closer.\\nHundreds of performances in one place.","new_welcome_sec_2_text_pl":"Hundreds of theater performances available on Dramox","new_welcome_sec_2_title_pl":"Browse Library","new_welcome_sec_3_text_pl":"By watching Dramox, you support theater culture. A full 55% of your subscription goes directly back to theaters, creators, and actors.\\n\\nPlus, you can send an extra contribution to your favorites anytime. It’s like buying tickets—just more convenient (and more affordable).","new_welcome_sec_3_title_pl":"Half of your subscription fee goes straight to the partnering theaters","new_welcome_sec_4_text_pl":"Theater at your fingertips. Watch world-class performances anytime, anywhere. Now available on your computer, mobile phone and Smart TV. Dramox is easy to use and accessible to everyone. Ladies and gentlemen, please take your seats, the show is about to begin.","new_welcome_sec_4_title_pl":"Fall in love with Dramox","new_welcome_sec_5_text_pl":"You can cancel your subscription anytime.","new_welcome_sec_5_title_pl":"Try Dramox","welcome_button_long_pl":"Start your FREE 7-day","welcome_price_pl":"Then enjoy Dramox for {{monthly}} per month, cancel anytime.","welcome_subtitle_pl":"Watch anytime, anywhere. On your smart TV, mobile, tablet, or computer.","welcome_title_pl":"Take a moment for theater. Watch hundreds of performances online on Dramox.","no_trial_welcome_button_long_xx":"Begin your online theater adventure now","no_trial_welcome_button_long_cz":"Begin your online theater adventure now","no_trial_welcome_button_long_sk":"Begin your online theater adventure now","no_trial_welcome_button_long_ua":"Begin your online theater adventure now","no_trial_welcome_button_long_pl":"Begin your online theater adventure now","welcome_button_browse_xx":"Browse selection","welcome_button_browse_cz":"Browse selection","welcome_button_browse_sk":"Browse selection","welcome_button_browse_ua":"Browse selection","welcome_button_browse_pl":"Browse selection","welcome_subscription_title_xx":"Choose a subscription and enjoy theater any day you want.","welcome_subscription_title_cz":"Choose a subscription and enjoy theater any day you want.","welcome_subscription_title_sk":"Choose a subscription and enjoy theater any day you want.","welcome_subscription_title_ua":"Choose a subscription and enjoy theater any day you want.","welcome_subscription_title_pl":"Choose a subscription and enjoy theater any day you want.","welcome_subscription_1_xx":"Hundreds of recordings from over 250 theaters around the world.\\n\\n\\n\\n\\n\\n\\n\\n","welcome_subscription_1_cz":"Hundreds of recordings from over 250 theaters around the world.\\n\\n\\n\\n\\n\\n\\n\\n","welcome_subscription_1_sk":"Hundreds of recordings from over 250 theaters around the world.\\n\\n\\n\\n\\n\\n\\n\\n","welcome_subscription_1_ua":"Hundreds of recordings from over 250 theaters around the world.\\n\\n\\n\\n\\n\\n\\n\\n","welcome_subscription_1_pl":"Hundreds of recordings from over 250 theaters around the world.\\n\\n\\n\\n\\n\\n\\n\\n","welcome_subscription_2_xx":"Drama, musical, opera, ballet, puppetry, and contemporary circus","welcome_subscription_2_cz":"Drama, musical, opera, ballet, puppetry, and contemporary circus","welcome_subscription_2_sk":"Drama, musical, opera, ballet, puppetry, and contemporary circus","welcome_subscription_2_ua":"Drama, musical, opera, ballet, puppetry, and contemporary circus","welcome_subscription_2_pl":"Drama, musical, opera, ballet, puppetry, and contemporary circus","welcome_subscription_3_xx":"No ads, no extra fees","welcome_subscription_3_cz":"No ads, no extra fees","welcome_subscription_3_sk":"No ads, no extra fees","welcome_subscription_3_ua":"No ads, no extra fees","welcome_subscription_3_pl":"No ads, no extra fees","welcome_subscription_button_1_xx":"7 days FREE, <0>then {{priceMonthly}} monthly</0>","welcome_subscription_button_1_cz":"7 days FREE, <0>then {{priceMonthly}} monthly</0>","welcome_subscription_button_1_sk":"7 days FREE, <0>then {{priceMonthly}} monthly</0>","welcome_subscription_button_1_ua":"7 days FREE, <0>then {{priceMonthly}} monthly</0>","welcome_subscription_button_1_pl":"7 days FREE, <0>then {{priceMonthly}} monthly</0>","welcome_subscription_button_2_xx":"7 days FREE,<1></1><0>then <2>{{beforeYearly}}</2> {{priceYearly}} / yearly</0>","welcome_subscription_button_2_cz":"7 days FREE,<1></1><0>then <2>{{beforeYearly}}</2> {{priceYearly}} / yearly</0>","welcome_subscription_button_2_sk":"7 days FREE,<1></1><0>then <2>{{beforeYearly}}</2> {{priceYearly}} / yearly</0>","welcome_subscription_button_2_ua":"7 days FREE,<1></1><0>then <2>{{beforeYearly}}</2> {{priceYearly}} / yearly</0>","welcome_subscription_button_2_pl":"7 days FREE,<1></1><0>then <2>{{beforeYearly}}</2> {{priceYearly}} / yearly</0>","welcome_subscription_button_activate_xx":"Activate your trial period","welcome_subscription_button_activate_cz":"Activate your trial period","welcome_subscription_button_activate_sk":"Activate your trial period","welcome_subscription_button_activate_ua":"Activate your trial period","welcome_subscription_button_activate_pl":"Activate your trial period","welcome_subscription_cancel_note_xx":"You can cancel anytime","welcome_subscription_cancel_note_cz":"You can cancel anytime","welcome_subscription_cancel_note_sk":"You can cancel anytime","welcome_subscription_cancel_note_ua":"You can cancel anytime","welcome_subscription_cancel_note_pl":"You can cancel anytime"}');

/***/ }),

/***/ 48331:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"authorship_provider":"Dostawca usługi","about_colaboration_question":"Współpraca","about_contact_us":"Skontaktuj się z nami","about_creators":"Kim jesteśmy?","about_partners":"Partnerzy","about_project":"O projekcie","about_schools":"Dramox dla szkół to oferta kierowana do nauczycieli, którzy chcą zaoferować uczniom coś więcej niż zwyczajne lekcje. Dzięki nieograniczonemu dostępowi do spektakli w mgnieniu oka znajdziecie się w wirtualnej sali teatralnej. Nasze nowoczesne scenariusze lekcyjne pomogą przybliżyć młodym teatromanom fascynujący świat sztuki i literatury. Kliknij po <0>więcej szczegółów</0>.","about_theaters":"Pokaż wszystkie teatry","about_colaboration":"Kto gra z nami?","person_about_1":"Martin jest absolwentem teatrologii. W swojej pracy na co dzień korzysta zarówno ze swojej wiedzy humanistycznej, jak i doświadczeń w obszarze nowych technologii. Współtworzył kilka biznesów online, pracował również jako handlowiec w takich firmach, jak Jablotron czy Creative Dock.","person_about_2":"Radim współtworzył portalu voyo.cz. Jest właścicielem firmy Weemazz 2.0, która na zlecenie twórców zajmuje się usuwaniem z internetu nielegalnych kopii ich dzieł. Przez całą swoją karierę pracuje w branży cyfrowej.","person_about_3":"Współzałożyciel i duchowy ojciec koncepcji Dramoxu. Jest inwestorem i właścicielem marki Livesport, z której korzysta ponad 90 milionów użytkowników na całym świecie. Jest także jednym z inwestorów Liftago oraz Deník N. Wspiera organizację pozarządową EDUin.","person_title_1":"Martin Zavadil","person_title_2":"Radim Horák","person_title_3":"Martin Hájek","forschools_footer":"Dla szkół","about_project_description":"<0><1>Dramox</1> to teatr online. Platforma, która w ramach miesięcznej subskrypcji oferuje szeroki wybór nagrań przedstawień teatralnych z całego świata. U nas możesz oglądać swoje ulubione przedstawienia, a także odkrywać zupełnie nowe kiedy i gdzie chcesz – zupełnie bez reklam. Nasza biblioteka stale się powiększa. Dbamy o to, aby regularnie udostępniać Wam nowe spektakle.</0><0> Naszą misją jest nie tylko przybliżanie teatru wszystkim widzom, ale i wspieranie sztuki. Połowę kwoty z każdej subskrypcji przekazujemy teatrowi i twórcom spektaklu. Dzięki nam możesz również przekazać dowolną kwotę w formie darowizny do Twojego ulubionego Teatru. \\nPrzekonaj się, że świat teatru jest na wyciągniecie ręki.</0>","legislative":"Organem, który nadzoruje świadczenie usług audiowizualnych na żądanie jest Rada Radiofonii i Telewizji."}');

/***/ }),

/***/ 29554:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"menu_authorship":"Prawa autorskie","authorship_email":"Dziękujemy za wiadomość","authorship_email_fail":"Twoja wiadomość nie została wysłana. Spróbuj ponownie za chwilę.","authorship_message_for_us":"Wiadomość","authorship_provider":"Dostawca usługi","authorship_send_form":"Prześlij formularz","authorship_title":"Zapytanie dot. praw autorskich","authorship_your_email":"Twój e-mail","authorship_perex":"<0>Jesteś właścicielem praw do sztuki znajdującej się na Dramoxie? Jeśli jeszcze nie skontaktowaliśmy się z Tobą w tej sprawie, napisz do nas.</0><0>Mimo że dołożyliśmy wszelkich starań, aby nawiązać kontakt ze wszystkimi twórcami, być może nie udało nam się dotrzeć do Ciebie.</0><0>Skontaktuj się z nami za pomocą poniższego formularza, a my odezwiemy się jak najszybciej, żeby omówić wszystkie istotne kwestie.</0><0>Dziękujemy.<1></1>Zespół Dramoxu</0>\\n","authorship_field_required":"Pole jest wymagane","authorship_max_length":"Max. długość:","authorship_email_invalid":"Nieprawidłowy adres e-mail. Użyj formatu: e-mail@example.pl"}');

/***/ }),

/***/ 23006:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"broadcast_title":"Transmisja na żywo","video_placeholder":"Obecnie nie prowadzimy transmisji na żywo","schedule_title":"Harmonogram"}');

/***/ }),

/***/ 73140:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Wybierz swój plan","payment_info":"Plan abonamentowy może być anulowany w każdej chwili. Pamiętaj, że połowę kwoty z każdej subskrypcji przekazujemy teatrowi i twórcom spektaklu.","payment_occour":"Twoja płatność zostanie zrealizowana w dniu {{date}}","payment_sub_info":"Decydując się na roczną subskrypcję, zaoszczędzisz {{yearPriceDiff}} rocznie.","voucher_label":"Karta podarunkowa","voucher_placeholder":"Wpisz kod karty podarunkowej","got_voucher":"Mam kartę podarunkową","redeem_voucher":"Zrealizuj","activate_yearly":"Aktywuj roczny plan","activate_monthly":"Aktywuj miesięczny plan","changes_not_saved":"Zmiany nie zostały zapisane. Spróbuj ponownie za chwilę.","changes_saved":"Zmiany zostały zapisane.","subscription_activated":"Twoja subskrypcja została aktywowana.","error_general":"Coś poszło nie tak. Spróbuj ponownie za chwilę.","price_with_vat":"{{price}}\\nzawiera VAT","advanced_form":{"title":"Wybierz swoją subskrypcję","switch_to_voucher":"lub wykorzystaj kartę podarunkową","monthly":"<0>{{price_formatted}} miesięcznie</0>","yearly":"<0>{{price_formatted}} rocznie</0>","button_activate":"Testuj 7 dni za darmo","timeline_title":"Na czym polega 7-dniowy okres próbny?\\n","timeline_step_1":"<0>Dziś</0> rozpoczyna się Twój bezpłatny okres próbny.","timeline_step_2":"<0>Za 7 dni ({{date_formatted}})</0>pobierzemy pierwszą opłatę za Twoją subskrypcję.<1></1>Jeśli do tego czasu anulujesz swoją subskrypcję, Twoja karta nie zostanie obciążona żadną opłatą.","timeline_step_3":"Subskrypcja odnawia się automatycznie do momentu jej anulowania.","voucher_title":"Wykorzystaj kartę podarunkową","switch_to_card":"Nie mam karty podarunkowej","voucher_description_title":"Szukasz idealnego i oryginalnego prezentu dla członków rodziny? Podaruj im voucher do platformy Dramox!","voucher_description_subtitle":"W jednym miejscu znajdziesz setki sztuk teatralnych z całego świata","voucher_description_action":"Kup kartę podarunkową","use_promo_code":"Dodaj kod promocyjny (opcjonalne)","promo_code_placeholder":"Wpisz kod promocyjny","timeline_step_4":"<0>W ciągu 5 dni ({{date_formatted}})</0>otrzymasz od nas wiadomość e-mail, w której poinformujemy Cię, o nadchodzącym terminie płatności za pierwszą subskrypcję.","no_trial_button_activate":"Aktywuj subskrypcję","no_trial_timeline_title":"Wybierz swój plan subskrypcji.","no_trial_timeline_step_1":"Zacznij korzystać z Dramoxu już dziś.","no_trial_monthly":"<0>{{price_formatted}} miesięcznie</0>","no_trial_yearly":"<0>{{price_formatted}} rocznie</0>"},"code_not_exists":"Błędny kod","card_number_invalid":"Podaj właściwy numer karty.","error_code_no_longer_valid":"Ten kod jest już nieaktywny.","error_voucher_expired":"Ten kod jest już nieaktywny.","error_code_discount_already_used":"Ten kod promocyjny został już użyty.","error_discount_already_active":"Nie można użyć kodu. Korzystasz z innej promocji obniżającej cenę subskrypcji.","error_promo_referral_not_allowed":"Kod promocyjny może zostać użyty tylko podczas tworzenia nowego konta.","error_promo_already_used":"Kod promocyjny został aktywowany.","error_promo_voucher_already_used":"Kod promocyjny został już wykorzystany.","error_promo_not_allowed":"Kod promocyjny może być użyty jedynie z aktywną subskrypcją.","voucher_invalid":"voucher_nieprawidłowy","code_already_used":"kod_został_wykorzystany","no_trial_payment_info":"Plan abonamentowy może być anulowany w każdej chwili. Pamiętaj, że połowę kwoty z każdej subskrypcji przekazujemy teatrowi i twórcom spektaklu."}');

/***/ }),

/***/ 17665:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"contest_title":"Christmas Contest with Dramox","contest_btn":"Enter the contest","contest_desc":"Enjoy world-class theater performances throughout Advent and win theater tickets and Dramox vouchers","contest_description":"Make yourself a hot cup of tea, snuggle up in your armchair and discover new theater performances with Dramox from December 1st to December 21st. This year, we\'re rewarding you with theater tickets and Dramox vouchers. And best of all, Santa Claus will be visiting on December 22nd to gift one lucky winner a theater bundle, including tickets to your favorite Dejvice Theater!","contest_what_win_title":"Prizes","contest_what_win":"The contest takes place in three weekly rounds for the chance to win the following prizes:","contest_what_1":"<0>1st place</0><1><2>2 x theater tickets</2><2>1 x 6 month Dramox voucher</2></1>","contest_what_2":"<0>2nd place</0><1><2>2 x theater tickets</2><2>1 x 3 month Dramox voucher</2></1>","contest_what_3":"<0>3rd-5th place</0><1><2>2 x theater tickets</2><2>1 x 1 month Dramox voucher</2></1>","contest_what_main_price":"Grand prize for the winner between December 1st to December 21st:","contest_what_price":"1 x theater bundle including tickets to Dejvice Theater + 1 x 1 year Dramox voucher + Dramox merch","contest_tip_title":"💡Our tip: The more performances you watch, the higher your chance of winning.","contest_tip_desc":"Example: You watch one performance on December 1st, a second one on December 5th and a third one on December 6th. You will automatically be entered into the final draw for a chance to win a theater bundle after the competition closes on Thursday, December 21rd at 12pm.","contest_how_play":"How it works","contest_how_1":"<0>Register using the form.</0> Make sure to use the same email address you registered with on Dramox!","contest_how_2":"Each contest week, discover new theater performances on Dramox. The more performances you watch, the higher your chance of winning.","contest_how_3":"At the end of each week, we will select five winners who will be notified of their prizes via email. At the end of the contest period you also have a chance to win the main prize: a theater bundle including Dejvice Theater tickets, a 1 year subscription to Dramox and Dramox merch. The winner will be announced on December 23rd in the afternoon.","contest_how_4":"Follow us on <0>Facebook</0>, <1>Instagram</1> and <2>Twitter</2> to stay updated about the contest and to get tips on what to watch next.","contest_rules_title":"Contest rules","contest_rule_1":"The contest starts on December 1st  2023 at 0am and ends on December 21rd 2022 at 12pm.","contest_rule_2":"The competition runs during the following periods:","contest_rule_2_1":"Week 1: from December 1st to December 7th, winners are announced on December 8th","contest_rule_2_2":"Week 2: from December 8th to December 14th, winners are announced on December 15th","contest_rule_2_3":"Week 3: from December 15th to December 21th, winners are announced on December 22th","contest_rule_2_4":"Week 4: from December 18th to December 23rd, winners are announced on December 23rd","contest_rule_3":"All users registered on Dramox with an active subscription or during their 7-day trial period, who have also registered using the contest form can participate.","contest_rule_4":"The winners of each weekly round will be announced on our social media and in our newsletter.","contest_rule_5":"The grand prize can be won by any contestant who entered between December 1st and December 21nd, regardless of whether or not they have already won any of the previous prizes. There is only one grand prize and a single contestant will be selected on December 22nd. We will announce the winner on our social media and in our newsletter.","contest_rule_more":"You can find the complete list of rules for the Christmas Contest <0>here</0>.","contest_info_toolbar_2023":"⭐ Christmas Contest with Dramox: Win theater tickets and Dramox gift vouchers","contest_info_toolbar_2024":""}');

/***/ }),

/***/ 65978:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"more":"Więcej","more_about_play":"Więcej o tym spektaklu","previous_play":"Poprzedni spektakl","play_btn":"Odtwarzaj","play_btn_long":"Odtwarzaj teraz","next_play":"Następny spektakl","coming_soon":"Wkrótce","continue":"Oglądaj dalej","continue_remaining":"Pozostało {{time}} ","most_popular":"Najpopularniejsze","popular":"Popularne","recently_added":"Najnowsze","currently_watching":"Kontynuuj oglądanie","drama":"Dramat","comedy":"Komedia","tragedy":"Tragedia","all_genres":"Wszystkie gatunki","actors":"Aktorzy","performances":"Spektakle","theatres":"Teatry","search_placeholder":"Wyszukaj tytuł, teatr, aktora...","no_search_results":"Nie znaleziono","menu":{"home":"Strona główna","genres":"Gatunki","theatres":"Teatry","about":"O Dramoxie","theatre":"Wesprzyj teatry","voucher":"Karty podarunkowe","login":"Zaloguj się","try_free":"Zarejestruj się","about_project":"O projekcie","for_schools":"Dla szkół","smart_tv":"Smart TV","mobile_apps":"Aplikacje mobilne","how_to_watch":"Jak oglądać na Dramoxie?","contact":"Kontakt","faq":"FAQ","my_profile":"Mój profil","logout":"Wyloguj się","terms_conditions":"Warunki korzystania","cookies":"Ciasteczka","authorship":"Prawa autorskie","privacy_policy":"Polityka prywatności","content_settings":"Wybór języka","try_now":"Wypróbuj teraz","logo_mobile":"BEZPŁATNIE przez 7 dni","search":"Szukaj","invite_friends":"Poleć","watch_list":"Twoja lista","broadcast":"Transmisja","no_trial_try_free":"Zarejestruj się","christmas_contest":"Świąteczny konkurs"},"form":{"not_empty":"Pole nie może być puste","password_min_chars":"Hasło musi składać się z przynajmniej ośmiu znaków.","email_format":"Nieprawidłowy format adresu e-mail.","wrong_credentials":"Nieprawidłowa nazwa użytkownika lub hasło.","already_exists":"Adres e-mail już istnieje.","password_dont_match":"Podane hasła nie zgadzają się.","payment_secured_with":"Płatność zabezpieczona","payment_card":"Płatność kartą","add_card":"Dodaj kartę","card_tooltip":"Akceptujemy karty VISA, Mastercard oraz karty eBenefity ","activate":"Aktywuj","recaptcha_error_global":"Wystąpił błąd, prosimy odświeżyć stronę.","recaptcha_error_expired":"Kod wygasł, kliknij raz jeszcze.","recaptcha_error_not_checked":"Zaznacz, aby potwierdzić, że nie jesteś robotem."},"not_found":{"title":"Strona nie została znaleziona","description":"Przykro nam, strona, której szukasz nie została znaleziona","btn":"Wróć do Strony Głównej"},"saved_cards":"Zapisane karty","saved_cards_placeholder":"Wybierz kartę","card_email":"E-mail","add_new_card":"Dodaj nową kartę","playlist_section_title":"Spektakle z kategorii {{section}}","playlist_genre_title":"Spektakle z gatunku {{genre}}","playlist_same_genre_title":"{{performance}} – podobne spektakle","playlist_same_cast_title":"{{performance}} – spektakle z podobną obsadą","playlist_currently_watching_title":"Teraz oglądasz","playlist_most_popular_title":"Najpopularniejsze spektakle","playlist_recent_title":"Niedawno dodane spektakle","country":"Kraj","pick_country":"Wybierz kraj","performance_not_found":{"title":"Nie znaleziono spektaklu","description":"Spektaklu, którego szukasz nie ma na platformie bądź jest niedostępny w Twoim kraju."},"playlist_dramox_originals_title":"Dramox Originals","dramox_originals":"Dramox Originals","open_in_mobile_app":"Otwórz w aplikacji Dramox","watch_list":"Twoja lista","sort_from":"Sortuj","sort_date_desc":"Data dodania (od najnowszych)","sort_date_asc":"Data dodania (od najstarszych)","sort_alphabetically_desc":"Alfabetycznie (A-Z)","add_first_play":"Dodaj swoje pierwsze przedstawienie","how_add":"Możesz dodać spektakl, klikając \\"Twoja lista\\" na stronie głównej przedstawienia.","check_library":"Zobacz bibliotekę","month_zero":"{{count}} miesiące","month_one":"{{count}} miesiąc","month_few":"{{count}} miesiące","month_many":"{{count}} miesiące","day_zero":"{{count}} dni","day_one":"{{count}} dzień","day_few":"{{count}} dni","day_many":"{{count}} dni","week_zero":"{{count}} tydzień","week_one":"{{count}} tydzień","week_few":"{{count}} tygodni","week_many":"{{count}} tygodni","cookies_bar":{"less_text":"Drogi widzu, na naszej stronie używamy ciasteczek, aby Twoje wrażenia teatralne mogły być jeszcze lepsze.","learn_more":"Więcej","accept_all":"Zaakceptuj","only_functional":"Tylko konieczne"},"cookie_updated":"Zaktualizowano","or":"Lub","year_zero":"{{count}} lat","year_one":"{{count}} rok","year_few":"{{count}} lata","year_many":"{{count}} lat","ownership":"Since September 2024, Dramox s.r.o. is owned by the Livesport Foundation."}');

/***/ }),

/***/ 35753:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"authorship_provider":"Dostawca usługi","contact_ceo":"CEO","contact_cofounder":"Współzałożyciel","contact_coo":"COO","person_title_1":"Martin Zavadil","person_title_2":"Radim Horák","person_title_3":"Martin Hájek","press_download":"Pobierz teczkę prasową","press_media":"Dla mediów","press_text":"Pobierz zestaw dla mediów, który zawiera logo Dramoxu we wszystkich formatach.","ua_contact":"Manager","ua_contact_name":"Olia Shylo","company":"Dramox s.r.o.","address":"Bucharova 2928/14a, Stodůlky","ico":"IČO: 09222103","cooperation":"sufler@dramox.pl","ua_company":"Dramox s.r.o.","ua_address":"Бухарова 2928/14а, Стодолки (Прага 13), 158 00 Прага","ua_ico":"Реєстраційний номер: 09222103","ua_cooperation":"sufler@dramox.pl"}');

/***/ }),

/***/ 56690:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"may_2022_tag_title":"33% zniżki w Twojej subskrypcji | Dramox","may_2022_title":"33% zniżki na aż 5 miesięcy korzystania z Dramoxu! Oglądaj spektakle z najlepszych teatrów na świecie już za","may_2022_subtitle":"Nie pozwól, aby taka okazja przeszła Ci koło nosa! Skorzystaj z oferty i oglądaj spektakle na Dramoxie za XX aż do 5 miesięcy! Zdobądź 33% zniżki na swoją miesięczną subskrypcję. Spiesz się, ta oferta jest ważna tylko przez miesiąc!","may_2022_exclusive":"Oferta limitowana","may_2022_text_mask_1":"Štěpán Kozub, Ivan Trojan, Pavla Tomicová [NTM - zmienić na polskie (i te znane Polakom) nazwiska, jak już będą spektakle] – z Dramoxem masz niepowtarzalną szansę oglądać najjaśniejsze gwiazdy teatru z całego świata wprost ze swojej kanapy. Ale na tym nie koniec – aby przybliżyć świat sztuki większej liczbie widzów, oferujemy aż 33% zniżki na subskrypcję trwającą do 5 miesięcy!","may_2022_text_mask_2":"Nasza porada: skorzystaj z 33% zniżki, aby wykupić roczną subskrypcję. Dzięki temu zaoszczędzisz aż XX","may_2022_text_mask_3":"Zniżka jest ważna przez 1 miesiąc, między 1 a 31 maja 2022 i nie łączy się z innymi promocjami.","may_2022_how_watch_title":"Jak otrzymać zniżkę?","may_2022_how_watch_1":"Zaloguj się na swoje <0>konto</0> lub <1>zarejestruj się</1> na Dramoxie, jeśli jeszcze nie masz konta.","may_2022_how_watch_2":"Po wybraniu swojego planu subskrypcji, wpisz kod <0>DRAMOXKVETEN33</0> w polu  <0>Dodaj kod promocyjny/0>","may_2022_how_watch_3":"Ciesz się dostępem do najlepszych teatrów na świecie online i oszczędź aż 33% kwoty subskrypcji","may_2022_how_watch_p":"Potrzebujesz pomocy?","may_2022_how_watch_help":"Skontaktuj się z naszymi suflerami – działem obsługi klienta – pod adresem sufler@dramox.pl","may_2022_discount_email":"sufler@dramox.pl"}');

/***/ }),

/***/ 26206:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"tag_title":"50% zniżki w Twojej subskrypcji | Dramox","title":"50% zniżki na aż 6 miesięcy korzystania z Dramoxu! Oglądaj spektakle z najlepszych teatrów na świecie już za","subtitle":"Nie pozwól, aby taka okazja przeszła Ci koło nosa! Skorzystaj z oferty i oglądaj spektakle na Dramoxie za połowę ceny aż do 6 miesięcy! Zdobądź 50% zniżki na swoją miesięczną subskrypcję. Spiesz się, ta oferta jest ważna tylko przez 7 dni!","exclusive":"Oferta limitowana","text_mask_1":"Plácido Domingo, Colm Feore, Rolando Villazon – z Dramoxem masz niepowtarzalną szansę oglądać najjaśniejsze gwiazdy teatru z całego świata wprost ze swojej kanapy. Ale na tym nie koniec – aby przybliżyć świat sztuki większej liczbie widzów, oferujemy aż 50% zniżki na subskrypcję trwającą do 6 miesięcy!","text_mask_2":"Nasza porada: skorzystaj z 50% zniżki, aby wykupić roczną subskrypcję. Dzięki temu zaoszczędzisz aż XX","text_mask_3":"Zniżka jest ważna przez 7 dni, między 14 a 20 kwietnia 2022 i nie łączy się z innymi promocjami.","how_watch_title":"Jak otrzymać zniżkę?","how_watch_1":"Zaloguj się na swoje <0>konto</0> lub <1>zarejestruj się</1> na Dramoxie, jeśli jeszcze nie masz konta.","how_watch_2":"Po wybraniu swojego planu subskrypcji, wpisz kod <0>DRAMOX50OFF</0> w polu <0>Dodaj kod promocyjny/0>","how_watch_3":"Ciesz się dostępem do najlepszych teatrów na świecie online i oszczędź aż 50% kwoty subskrypcji","how_watch_p":"Potrzebujesz pomocy?","how_watch_help":"Skontaktuj się z naszymi suflerami – działem obsługi klienta – pod adresem sufler@dramox.pl","discount_email":"sufler@dramox.pl"}');

/***/ }),

/***/ 26409:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"toolbar":"Wielkanocny konkurs z Dramoxem: Wygraj bilety do teatrów i vouchery na darmową subskrypcję.","title":"Wielkanoc z Dramoxem","sign_in":"Weź udział w konkursie","subtitle_1":"Oglądaj spektakle online i wygrywaj bilety do teatru oraz vouchery na darmową subskrypcję","subtitle_2":"Szukasz pomysłu na wielkanocny prezent dla rodziny i przyjaciół? W tym roku Dramox z pomocą zajączka może obdarować zarówno Ciebie, jak i Twoich najbliższych! Oglądajcie tyle spektakli, ile dacie radę między 12 a 19 kwietnia, a my podarujemy wam bilety do teatrów i vouchery do Dramoxu!","contest":"Konkurs","price_title":"Co możesz wygrać?","price_desc":"Czekają na Ciebie następujące nagrody\\"","price_first":"<1>1. miejsce </1> <0/> 2 x bilety do teatru <0/> voucher na 6-miesięczną subskrypcję","price_second":"<1>2. miejsce </1> <0/> 2 x bilety do teatru <0/> voucher na 3-miesięczną subskrypcję","price_third":"<1>3. miejsce </1> <0/> 2 x bilety do teatru <0/> voucher na miesięczną subskrypcję","chance_title":"Nasza porada: Im więcej oglądasz, tym większe masz szanse na wygraną.","chance_text":"Przykład: Użytkownik obejrzał jeden spektakl we wtorek 12 kwietnia, jeden w środę 13 kwietnia oraz jeden w czwartek 14 kwietnia. Imię i nazwisko tego użytkownika pojawi się na liście konkursowej 3 razy, zapewniając mu większą szansę na wygraną.","how_to_title":"Jak wziąć udział w konkursie?","how_to_1":"Aby zarejestrować się, uzupełnij <0>formularz konkursowy</0>. Upewnij się, że użyty mail jest ten sam, co na Dramoxie.","how_to_2":"Oglądaj swoje ulubione przedstawienia między 12 i 18 kwietnia. Im więcej obejrzysz, tym częściej Twoje imię ma szanse pojawić się na liście konkursowej.","how_to_3":"Konkurs zakończy się we wtorek 19. kwietnia 2022 roku. Wybierzemy troje zwycięzców, którzy otrzymają bilety do teatrów, a także vouchery na darmową subskrypcję Dramoxu.","how_to_4":"Zwycięzców ogłosimy w naszych mediach społecznościowych oraz za pomocą newslettera. Żeby być na bieżąco, śledź nas na <facebook>Facebooku</facebook>, <instagram>Instagramie</instagram>, <twitter>Twitterze</twitter> and <youtube>YouTubie</youtube> – solidna dawka teatralnych inspiracji gwarantowana!","btn_signin":"Weź udział w konkursie","rules_title":"Reguły wielkanocnego konkursu:","rule_1":"Konkurs zaczyna się 12 kwietnia 2022 o 0.01, a kończy się 18 kwietnia o 23.59.","rule_2":"Uczestnicy muszą być zarejestrowani na Dramoxie. Każdy, kto chce wziąć udział w konkursie musi wypełnić najpierw formularz konkursowy.","rule_3":"Zwycięzcy będą wybrani spośród wszystkich uczestników biorących udział w zabawie w określonym przez regulamin terminie. O wygranej poinformujemy za pomocą naszych social mediów oraz newslettera.","rule_more":"Reguły wielkanocnego konkursu Dramoxu znajdziesz <0>tutaj</0>.","tag_title":"Konkurs wielkanocny | Dramox"}');

/***/ }),

/***/ 54623:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"reset_password_h1":"Ustaw hasło i rozpocznij oglądanie","new_password":"Nowe hasło","new_password_again":"Powtórz nowe hasło","submit":"Prześlij","reset_password_placeholder":"Przynajmniej osiem znaków","reset_password_error":"Link do zmiany hasła jest już nieaktywny."}');

/***/ }),

/***/ 44011:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"items":{"1":{"q":"Czym jest Dramox?","a":"Dramox to teatr online. To platforma streamingowa, która oferuje największy wybór nagrań spektakli teatralnych w jednym miejscu. Oglądaj swoje ulubione przedstawienia i poznawaj całkiem nowe – kiedy i gdzie tylko chcesz, zupełnie bez reklam. Świat teatru czeka, aż go odkryjesz – biblioteka Dramoxu regularnie powiększa się o kolejne produkcje."},"2":{"q":"Co znajdę na Dramoxie?","a":"Oferujemy spektakle wyprodukowane przez setki teatrów na całym świecie. Oglądaj klasykę, nagradzane produkcje lub zupełnie nowe sztuki, które dopiero czekają na odkrycie."},"3":{"q":"Ile kosztują poszczególne subskrypcje?","a":"Możesz korzystać z Dramoxu za {{monthly}} miesięcznie lub zaoszczędzić {{yearlyDiscount}}, wybierając plan roczny za {{yearly}}. Anulowanie subskrypcji jest bezpłatne i możesz to zrobić kiedy chcesz. Pamiętaj, że połowę kwoty z każdej subskrypcji przekazujemy teatrowi i twórcom spektaklu."},"4":{"q":"Ile spektakli mogę obejrzeć?","a":"Nie ma żadnych ograniczeń. Możesz oglądać tyle spektakli, ile zapragniesz."},"5":{"q":"Jak mogę anulować moją subskrypcję?","a":"Anulowanie subskrypcji jest niezwykle proste i bezpłatne. Ponieważ nie zawieramy długoterminowych umów, wystarczy, że zalogujesz się do swojego konta na Dramox.pl. Następnie, w prawym górnym rogu ekranu, kliknij czerwone kółeczko i wybierz \\"Mój Profil\\" oraz wybierz \\"Anuluj subskrypcję\\". Twoja subskrypcja nie zostanie ponownie odnowiona, ale możesz nadal korzystać z Dramoxu do końca ważności obecnego planu."}}}');

/***/ }),

/***/ 19354:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Często zadawane pytania","know_more":"Nie możesz znaleźć tego, czego szukasz? Skontaktuj się z nami","items":{"1":{"q":"Czym jest Dramox?","a":"Dramox to teatr online. Platforma, która w ramach miesięcznej subskrypcji oferuje szeroki wybór nagrań przedstawień teatralnych z całego świata. U nas możesz oglądać swoje ulubione przedstawienia, a także odkrywać zupełnie nowe kiedy i gdzie chcesz – zupełnie bez reklam. Dbamy o to, aby regularnie udostępniać Wam nowe spektakle."},"2":{"q":"Co znajdę na Dramoxie?","a":"Oferujemy nagrania spektakli wyprodukowanych przez setki teatrów na całym świecie. Oglądaj klasykę, nagradzane produkcje lub zupełnie nowe sztuki, które dopiero czekają, aby je odkryć."},"3":{"q":"Ile spektakli mogę obejrzeć?","a":"Nie ma żadnych ograniczeń. Możesz oglądać tyle spektakli, ile zapragniesz."},"4":{"q":"Czego potrzebuję, aby korzystać z Dramoxu?","a":"Po zakończeniu rejestracji potrzebujesz jedynie przeglądarki i łącza internetowego. Zacznij oglądać spektakle już dziś."},"5":{"q":"Ile kosztują poszczególne plany subskrypcji?","a":"Możesz korzystać z Dramoxu za {{monthly}} miesięcznie lub zaoszczędzić {{yearlyDiscount}}, wybierając plan roczny za {{yearly}}. Anulowanie subskrypcji jest bezpłatne i możesz to zrobić kiedy chcesz. Połowę kwoty z każdej subskrypcji przekazujemy teatrowi i twórcom spektaklu."},"6":{"q":"W jakich krajach mogę korzystać z Dramoxu?","a":"Możesz korzystać z oferty Dramoxu z dowolnego miejsca na ziemi. Niezależnie od tego, czy znajdujesz się na karaibskiej plaży czy szusujesz na nartach w Alpach. Zawsze masz dostęp do ogromnej kolekcji spektakli teatralnych na Dramoxie. Świat sztuki stoi przed Tobą otworem! Pamiętaj jednak, że ze względu na ograniczenia licencyjne niektórych spektakli, mogą być one niedostępne w danym kraju."},"7":{"q":"Co z reklamami?","a":"Na Dramoxie nie ma reklam."},"8":{"q":"Jak mogę anulować moją subskrypcję?","a":"Anulowanie subskrypcji jest niezwykle proste i bezpłatne. Ponieważ nie zawieramy długoterminowych umów, wystarczy, że zalogujesz się do swojego konta na Dramox.pl. Następnie, w prawym górnym rogu ekranu, kliknij czerwone kółeczko i wybierz \\"Mój Profil\\" oraz wybierz \\"Anuluj subskrypcję\\". Twoja subskrypcja nie zostanie ponownie odnowiona, ale możesz nadal korzystać z Dramoxu do końca ważności obecnego planu."},"9":{"q":"Jak mogę ponownie dołączyć?","a":"Zaloguj się do swojego konta na Dramoxie. Następnie w prawym górnym rogu kliknij czerwone kółeczko i wybierz \\"Mój Profil\\". Na stronie Twojego profilu kliknij \\"Subskrybuj\\"."},"10":{"q":"Jak mogę używać Dramoxu na Smart TV bez aplikacji Dramox?","a":"Nasza aplikacja obsługuje bezprzewodową transmisję obrazu i dźwięku za pomocą Chromecast lub AirPlay. Jeśli Twój telewizor obsługuje tę technologię, udostępnij obraz ekranu smartfona lub komputera na ekranie telewizora. Wybierz spektakl i naciśnij przycisk \\"Odtwarzaj\\". Kliknij ikonę monitora, która pojawi się w prawym dolnym rogu. Zobaczysz menu pokazujące, czy telewizor jest podłączony do tej samej sieci Wi-Fi, która obsługuje Chromecast lub AirPlay. Wybierz odbiornik i ciesz się przedstawieniem na ekranie swojego telewizora. "},"11":{"q":"Czy mogę używać Dramoxu jako aplikacji na Smart TV?","a":"Tak, aplikacja Dramoxu jest już dostępna dla telewizorów Samsung. Aby uzyskać więcej informacji na temat sposobu dodawania aplikacji Dramox, sprawdź nasz <linkSmartTvGuide>Przewodnik po Smart TV</linkSmartTvGuide> Pracujemy również nad dalszym rozwojem naszej aplikacji."},"12":{"q":"Czy Dramox jest dostępny w formie aplikacji mobilnej?","a":"Tak. Aby uzyskać więcej informacji na ten temat, sprawdź naszą <linkMobileAppsGuide>Instrukcję korzystania na telefonie i tablecie</linkMobileAppsGuide>."},"13":{"q":"Jakie teatry współpracują z Dramoxem?","a":"Pełna lista teatrów współpracujących z Dramoxem znajduje się na stronie <linkAboutUs>O nas</linkAboutUs>."},"14":{"q":"Na czym polega bezpłatny okres próbny?","a":"Aby wypróbować nasz 7-dniowy bezpłatny okres próbny wystarczy się zarejestrować. Jeśli spodoba Ci się Dramox, możesz dalej oglądać spektakle, a subskrypcja aktywuje się sama po upływie 7 dni. Jeśli zdecydujesz się zrezygnować z bezpłatnego okresu próbnego przed jego zakończeniem, nie zostaniesz obciążony żadnymi kosztami. Możesz po prostu anulować aktywną subskrypcję na swoim profilu za pomocą kilku kliknięć i bez żadnych opłat.","no_trial_q":"Jak działa Dramox?","no_trial_a":"Jeśli zdecydujesz się zrezygnować z subskrypcji przed jej zakończeniem, nie zostaniesz obciążony żadnymi kosztami. Możesz po prostu anulować aktywną subskrypcję na swoim profilu za pomocą kilku kliknięć i bez żadnych opłat."},"15":{"q":"Jak mogę wspierać teatry?","a":"Wspierasz je po prostu korzystając z Dramoxu, ponieważ połowę Twojej subskrypcji przekazujemy teatrowi i twórcom spektaklu. Możesz również wesprzeć swój ulubiony teatr, przekazując dowolną kwotę jako darowiznę. Cały przychód zostanie przekazany bezpośrednio wybranemu teatrowi. Nie zatrzymujemy nic dla siebie, a potrącona zostaje jedynie prowizja od bezpiecznego przelewu."},"16":{"q":"Z ilu urządzeń mogę korzystać?","a":"Używając jednego konta, możesz korzystać z dowolnej liczby urządzeń, ale nie w tym samym czasie. Oznacza to, że jeśli chcesz korzystać z Dramoxu jednocześnie na telefonie i na laptopie, będziesz potrzebować dwóch osobnych kont. Jeśli jednak oglądasz spektakle na laptopie w domu, a w drodze do pracy korzystasz z tabletu, wystarczy jedno konto."},"17":{"q":"Czy mogę kupić subskrypcję Dramoxu jako kartę podarunkową?","a":"Dostęp do teatru online jako prezent? Świetny pomysł! Możesz wybrać jeden z naszych planów subskrypcji: 1-miesięczny, 3-miesięczny, 6-miesięczny lub 12-miesięczny. Karta podarunkowa jest ważna przez jeden rok od daty jej zakupu, a działa od momentu aktywacji. Aby dowiedzieć się więcej o kartach podarunkowych, odwiedź naszą stronę <linkVouchers>Karta podarunkowa</linkVouchers>."},"18":{"q":"Jak wykorzystać kartę podarunkową, jeśli mam już aktywną subskrypcję?","a":"Zaloguj się na swoje konto na Dramoxie. W prawym górnym rogu kliknij czerwone kółeczko i wybierz opcję \\"Mój Profil\\". Na stronie Twojego profilu kliknij opcję \\"Anuluj subskrypcję\\". Jak tylko wygaśnie Twój obecny okres subskrypcji, wyślemy Ci powiadomienie i poprosimy o dokonanie płatności, jeśli chcesz kontynuować oglądanie. Na stronie swojego profilu możesz wtedy wybrać opcję \\"Użyj karty podarunkowej\\"."},"19":{"q":"W jaki sposób mogę zaprosić znajomych i zyskać do 5 darmowych miesięcy Dramoxu?","a":"Nie wyobrażasz sobie życia bez teatru online i znasz osoby, które mogłyby pokochać to doświadczenie tak samo mocno? Poleć nas i zdobądź aż do 5 miesięcy darmowej subskrypcji. Z tej oferty może skorzystać każdy, kto jest zarejestrowany na <linkDramox>Dramox.com.ua</linkDramox> zarówno z aktywną, jak i nieaktywną subskrypcją oraz ten, kto używa karty płatniczej, a także vouchera. Zaloguj się na swoje konto Dramox, najedź kursorem na czerwone kółko w prawym górnym rogu i kliknij \\"Poleć\\". Znajdziesz tam swój kod polecający, który może być użyty aż 5 razy. Zaproś swoich znajomych do wypróbowania doświadczenia, jakim jest teatr online i otrzymaj aż do 5 miesięcy subskrypcji za darmo – w ten sposób oszczędzasz do €55. Za każdym razem, kiedy Twój znajomy zarejestruje się używając Twojego kodu, a następnie aktywuje subskrypcję, oboje otrzymujecie darmowy miesiąc. Nie masz jeszcze konta na Dramoxie? Nie zwlekaj, zarejestruj się <linkRegister>tutaj</linkRegister> i wybierz plan.","no_trial_a":"Nie wyobrażasz sobie życia bez teatru online i znasz osoby, które mogłyby pokochać to doświadczenie tak samo mocno? Poleć nas i zdobądź aż do 5 miesięcy darmowej subskrypcji. Z tej oferty może skorzystać każdy, kto jest zarejestrowany na <linkDramox>Dramox.com.ua</linkDramox> zarówno z aktywną, jak i nieaktywną subskrypcją oraz ten, kto używa karty płatniczej, a także vouchera. Zaloguj się na swoje konto Dramox, najedź kursorem na czerwone kółko w prawym górnym rogu i kliknij \\"Poleć\\". Znajdziesz tam swój kod polecający, który może być użyty aż 5 razy. Zaproś swoich znajomych do wypróbowania doświadczenia, jakim jest teatr online i otrzymaj aż do 5 miesięcy subskrypcji za darmo. Za każdym razem, kiedy Twój znajomy zarejestruje się używając Twojego kodu, a następnie aktywuje subskrypcję, oboje otrzymujecie darmowy miesiąc. Nie masz jeszcze konta na Dramoxie? Nie zwlekaj, zarejestruj się <linkRegister>tutaj</linkRegister> i wybierz plan."}}}');

/***/ }),

/***/ 93154:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Nie pamiętasz hasła? Nie szkodzi, pomożemy.","email":"E-mail","email_placeholder":"Wpisz adres e-mail","btn":"Zresetuj hasło","server_error":"Podany e-mail nie istnieje","changes_not_saved":"Zresetowanie hasła nie powiodło się. Spróbuj ponownie później.","changes_saved":"Link do zresetowania hasła został wysłany na Twój adres e-mail."}');

/***/ }),

/***/ 1515:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Korzystaj z Dramoxu gdziekolwiek jesteś!","web":{"title":"Komputery i laptopy","supported_browsers":"Obsługiwane przeglądarki","subtitle":"Portal Dramox","content":"Obsługujemy najczęściej używane przeglądarki w systemach operacyjnych Windows, Linux i macOS.","button":"Rozpocznij oglądanie"},"smart_tv":{"title":"Smart TV","samsung_title":"Aplikacja na Samsung Smart TV","samsung_description":"Aplikacja Dramox dla modeli Samsung 2018 oraz nowszych, z systemem Tizen 4.0 OS oraz wyższym.","lg_title":"Aplikacja na LG Smart TV","lg_description":"Aplikacja Dramox dla modeli 2016 oraz nowszych, z systemem WebOS 3.0 oraz wyższym.","button":"Instrukcja instalacji"},"mobile":{"title":"Smartfony i tablety","android_title":"Aplikacja mobilna na Android","android_description":"Obsługujemy smartofony i tablety z systemem operacyjnym Android 5.1.1 lub wyższym.","ios_title":"Aplikacja mobilna na iOS","ios_description":"Obsługujemy smartfony i tablety z systemem operacyjnym iOS 11 lub wyższym.","button":"Przewodnik instalacji"},"streaming":{"title":"Chromecast i AirPlay","airplay_title":"Apple AirPlay","airplay_description":"Oglądaj przedstawienia teatralne na ekranie Twojego telewizora dzięki technologii Apple AirPlay.","chromecast_title":"Google Chromecast","chromecast_description":"Oglądaj przedstawienia teatralne na ekranie Twojego telewizora dzięki technologii Google Chromecast.","button":"Jak to działa?"}}');

/***/ }),

/***/ 57565:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Poleć nas swoim znajomym i otrzymaj aż do 5 miesięcy subskrypcji Dramoxu za darmo","code_for_friend":"Kod polecający (może być wykorzystany 5 razy)","copy_code":"Skopiuj kod","what_to_do":"Co muszą zrobić moi znajomi, aby korzystać z Dramoxu?","step_1":"Muszą utworzyć nowe konto na platformie Dramox.","step_2":"Po wybraniu planu subskrypcji należy wpisać kod polecający: <0>{{promoCode}}</0>","step_3":"Subskrypcja będzie aktywowana na minimum 1 miesiąc po zaktualizowaniu danych karty płatniczej.","step_4":"Kiedy tylko subskrypcja zostanie aktywowana, zarówno Ty, jak i Twój znajomy, otrzymacie miesiąc korzystania z Dramoxu za darmo.","invited_friends":"Zaproszeni znajomi","invite_benefit":"Poleć nas swoim znajomym i otrzymaj aż do 5 miesięcy subskrypcji Dramoxu za darmo. Każdy z Twoich znajomych, który aktywuje subskrypcję również otrzyma miesiąc za darmo.","title_not_allowed":"Zapraszanie znajomych jest możliwe jedynie z aktywną subskrypcją.","buy_subscription":"Wykup subskrypcję","more_1":"Więcej informacji na temat subskrypcji znajdziesz na ","more_2":"FAQ","code_copied":"Kod został skopiowany","description_not_allowed":"Ta oferta jest dostępna dla wszystkich zarejestrowanych na Dramoxie, zarówno z aktywną, jak i nieaktywną subskrypcją oraz dla tych, którzy używają karty płatniczej, a także vouchera. Nie masz jeszcze subskrypcji na Dramoxie? Najwyższy czas, żeby ją wykupić, a potem zaprosić przyjaciół – polecaj nas i zyskaj aż do 5 miesięcy za darmo! ","no_trial_description_not_allowed":"Ta oferta jest dostępna dla wszystkich zarejestrowanych na Dramox.pl, zarówno z aktywną, jak i nieaktywną subskrypcją oraz dla tych, którzy używają karty płatniczej, a także vouchera. Nie masz jeszcze subskrypcji na Dramoxie? Najwyższy czas, żeby ją wykupić, a potem zaprosić przyjaciół – polecaj nas i zyskaj aż do 5 miesięcy za darmo!"}');

/***/ }),

/***/ 76254:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"login":"Zaloguj się","not_register_yet":"Nie masz konta?","try_trial":"Wypróbuj 7-dniowy bezpłatny okres próbny","email":"E-mail","password":"Hasło","forgotten_password":"Nie pamiętasz hasła?","login_btn":"Zaloguj się","not_activated":"Przykro nam! Twoje konto nie zostało aktywowane. Jeśli masz już aktywne konto, skontaktuj się z nami.","no_trial_try_trial":"Rozpocznij przygodę z Dramoxem."}');

/***/ }),

/***/ 53813:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"android_title":"Aplikacja mobilna na system operacyjny Android","android_description":"Dostępna na smartfony i tablety z systemem operacyjnym Android 5.1.1 lub wyższym. Potrzebujesz pomocy? Skontaktuj się z nami: <a href=\\"mailto:sufler@dramox.pl\\">sufler@dramox.pl</a>.","android_instalation":"Instalacja aplikacji mobilnej Dramox","android_step_1":"<a href=\\"https://play.google.com/store/apps/details?id=cz.dramox.dramox\\" target=\\"_blank\\"> Kliknij, żeby pobrać aplikację  </a> lub skorzystaj z Google Play na Twoim telefonie i wyszukaj aplikację Dramox.","android_step_2":"Zainstaluj aplikację, klikając <strong>Instaluj</strong>.","android_step_3":"Otwórz zainstalowaną aplikację.","android_step_4":"Kiedy aplikacja uruchomi się, zaloguj się za pomocą adresu e-mail oraz hasła, których używasz do logowania się do konta na Dramoxie.","android_step_5":"Podoba Ci się nasza aplikacja? Będzie nam miło, jeśli ocenisz ją w Google Play.","ios_title":"Aplikacja mobilna na system operacyjny iOS","ios_description":"Dostępna na smartfony i tablety z systemem operacyjnym iOS 11 lub wyższym. Potrzebujesz pomocy? Skontaktuj się z nami: <a href=\\"mailto:sufler@dramox.pl\\">sufler@dramox.pl</a>.","ios_instalation":"Instalacja aplikacji Dramox","ios_step_1":"<a href=\\"https://apps.apple.com/cz/app/dramox-divadlo-online/id1563430137?l=cs\\" target=\\"_blank\\"> Kliknij, żeby pobrać aplikację  </a>, lub skorzystaj z App Store na Twoim telefonie i wyszukaj aplikację Dramox.","ios_step_2":"Zainstaluj aplikację, klikając <strong>przycisk Instaluj</strong>.","ios_step_3":"Otwórz zainstalowaną aplikację.","ios_step_4":"Kiedy aplikacja uruchomi się, zaloguj się adresem e-mail oraz hasłem, których używasz do logowania się do konta na Dramoxie.","ios_step_5":"Podoba Ci się nasza aplikacja? Będzie nam miło, jeśli ocenisz ją w App Store."}');

/***/ }),

/***/ 24699:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"premiere":"Premiera","trailer":"Zwiastun","support":"Wesprzyj teatr","genres":"Gatunki","awards":"Nagrody","same_cast":"Ta sama obsada","similar_genre":"Podobne gatunki","theatre_more":"Więcej przedstawień tego teatru","show_all":"Pokaż wszystkie","cast":"Obsada","donate_bubble_title":"Podobało Ci się to przedstawienie?","donate_bubble_link":"Wesprzyj ten teatr","playback_error_title":"Wideo nie może zostać odtworzone w tej chwili.","playback_error_content":"Przepraszamy, wybrane przedstawienie nie może być odtworzone w tej chwili. Sprawdź swoje połączenie internetowe i spróbuj ponownie za chwilę.","playback_error_action":"Wróć do szczegółów przedstawienia","low_quality":"Spektakl z niższą jakością wideo","support_theater":"Wspieraj teatr online","watch_list":"Twoja lista","on_watch_list":"Na Twojej liście","added_to_watch_list":"Dodane do Twojej listy","removed_from_watch_list":"Usunięte z Twojej listy"}');

/***/ }),

/***/ 35071:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"auto_quality":"Auto","back":"Wróć","captions":"Napisy","cast_to_other_devices":"Chromecast","enter_picture_in_picture":"Uruchom obraz w obrazie","exit_fullscreen":"Wyłącz tryb pełnoekranowy","exit_picture_in_picture":"Wyłącz obraz w obrazie","fullscreen":"Tryb pełnoekranowy","language":"Język","live":"Na żywo","more_settings":"Więcej opcji","multiple_languages":"Więcej języków","mute":"Wycisz","not_applicable":"Nie dotyczy","off":"Wyłącz","on":"Włącz","pause":"Pauza","picture_in_picture":"Obraz w obrazie","play":"Uruchom","resolution":"Jakość obrazu","seek":"Szukaj","undetermined_language":"Język nieznany","unmute":"Wyłącz wyciszenie","volume":"Poziom głośności"}');

/***/ }),

/***/ 84093:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"activate_subscription_title":"Aktywuj swoją subskrypcję","activate_subcription_content":"Uzyskaj dostęp do setek sztuk teatralnych i oglądaj je z każdego miejsca na ziemi – całkowicie legalnie!","activate_subscription_button":"Wybierz swoją subskrypcję","login_title":"Zaloguj się","login_content":"Spektakl dostępny tylko dla zalogowanych użytkowników z aktywną subskrypcją.","login_action":"Zaloguj się","login_footer":"Nie masz konta? <0>Zarejestruj się</0>","low_quality_title":"Obniżona jakość wideo","low_quality_text":"Nagranie tego spektaklu ma obniżoną jakość wideo, jednak jego wartość jest tak istotna, że zdecydowaliśmy się na jego udostępnienie na Dramoxie. Mamy nadzieję, że mimo tej niedogodności docenisz to przedstawienie tak, jak my!","low_quality_btn":"Rozumiem"}');

/***/ }),

/***/ 81978:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"my_profile":"Mój Profil","subscription":"Subskrypcja","subscription_unlimited":"Posiadasz nielimitowaną subskrypcję","unlimited_description":"Miłego oglądania!","monthly":"Miesięcznie","yearly":"Rocznie","price_with_vat":"{{price}} zawiera VAT","voucher":"Mam kartę podarunkową","subscription_none":"Kup miesięczną lub roczną subskrypcję Dramoxu","subscription_none_text":"Uzyskaj dostęp do setek sztuk teatralnych i oglądaj je z każdego miejsca na ziemi – całkowicie legalnie!","personal_details":"Dane osobowe","full_name":"Imię i nazwisko","save_changes":"Zapisz zmiany","password_change":"Zmiana hasła","password_change_success":"Hasło zostało zmienione.","password_change_fail":"Zmiana hasła nie powiodła się.","account_delete_success":"Konto zostało usunięte","actual_password":"Obecne hasło","new_password":"Nowe hasło","new_password_again":"Powtórz nowe hasło","purchase_history":"Historia zakupów","delete_account":"Skasuj konto","delete_account_text":"Skasowanie konta spowoduje zakończenie obecnej subskrypcji oraz usunięcie wszystkich danych z serwerów Dramox.tv","theatre_donate":"Darowizna","subscription_bundles":"Subskrypcja","voucher_pay":"Karta podarunkowa","empty_purchase":"Po pierwszej dokonanej płatności za subskrypcję lub po pierwszej przekazanej darowiźnie zobaczysz tutaj swoją historię zakupów.","recurrence_monthly":"Obecnie subskrybujesz plan miesięczny","recurrence_quarterly":"Obecnie subskrybujesz plan kwartalny","recurrence_semi_annual":"Obecnie subskrybujesz plan półroczny","recurrence_yearly":"Obecnie subskrybujesz plan roczny","subscription_expired_trial":"Twój bezpłatny okres próbny zakończy się w dniu {{date}}. Twoja subskrypcja zostanie automatycznie odnowiona w tym samym dniu.\\n","subscription_expired":"Twoja subskrypcja zostanie automatycznie odnowiona w dniu {{date}}","delete_account_title":"Usuwanie konta","delete_popup_close":"Zamknij","delete_account_submit":"Skasuj konto","delete_subscription_title":"Zrezygnuj z subskrypcji","delete_subscription_text":"Twoja subskrypcja pozostanie aktywna do momentu jej wygaśnięcia. Po tym czasie nie zostanie automatycznie odnowiona.","cancel_subscription":"Zrezygnuj z subskrypcji","choose_card":"Wybierz kartę","choose_card_text":"Czy chcesz korzystać z tej karty dla wszystkich przyszłych płatności?","btn_submit":"Prześlij","remove_card":"Usuń kartę","remove_card_text":"Czy na pewno chcesz usunąć kartę z Twojego konta?","card_primary":"podstawowa karta","card_choose":"Wybierz","card_no_added":"Brak karty","subscription_end_description":"Twoja subskrypcja automatycznie zakończy się w dniu {{date}}","profile_changes_not_saved":"Zmiany nie zostały zapisane. Spróbuj ponownie później.","profile_changes_saved":"Zmiany zostały zapisne.","card_added":"Karta została dodana.","card_added_error":"Twoja karta została odrzucona. Sprawdź dane i ważność karty.","load_more":"Załaduj więcej","subscription_canceled_success":"Twoja subskrypcja została anulowana.","subscription_canceled_fail":"Nie udało się anulować Twojej subskrypcji.","payment_card_delete_success":"Karta została usunięta.","payment_card_delete_fail":"Karta nie została usunięta.","change_payment_card_primary_success":"Podstawowa karta została dodana.","change_payment_card_primary_fail":"Nie udało się dodać Twojej podstawowej karty.","email_newsletter":"Newsletter","email_newsletter_text":"Chcesz być na bieżąco i otrzymywać newsletter Dramoxu?","email_newsletter_action_subscribe":"Zapisz się do newslettera","email_newsletter_action_unsubscribe":"Dezaktywuj","email_newsletter_success_title":"Dziękujemy za zapisanie się do newslettera","email_newsletter_success_description":"Możesz teraz zamknąć okno","residency_tooltip":"Jeśli to nie jest Twój kraj zamieszkania, skontaktuj się z naszą obsługą klienta.","language_select":"Wybierz język","grace_period_title":"Twoja subskrypcja nie może zostać przedłużona","grace_period_description":"Sprawdź szczegóły swojej płatności i stan swojego konta. Do {{data}} będziemy każdego dnia automatycznie próbowali przedłużyć Twoją subskrypcję. Po tej dacie usługa stanie się niedostępna, a subskrypcja zostanie anulowana.","grace_period_action":"Zapłać teraz – {{price}}","delete_subscription_grace_text":"Twoja subskrypcja zostanie anulowana","ui_language":"Język strony","prolonged_subscription":"Przedłużyliśmy Twoją subskrypcję.","remove_sub_promo_title":"Bardzo nam przykro, że postanawiasz nas opuścić","remove_sub_promo_text":"Poleć Dramox swoim znajomym i otrzymaj aż do 5 miesięcy darmowej subskrypcji","remove_sub_get_more":"Więcej","remove_sub_or":"lub","remove_sub_removing":"Anuluj subskrypcję. Twój obecny plan będzie aktywny do momentu wygaśnięcia, następnie zostanie automatycznie wyłączony.","sub_from_campaign":"Korzystasz z darmowego okresu w ramach promocji.","sub_from_user":"Korzystasz z darmowego okresu dzięki znajomemu.","discount_info":"Do {{date}} masz {{discount}}% zniżki na subskrypcje.","promo_discount_title":"<0>{{discount}}%</0>zniżki na {{timespan}}","promo_discount_content":"Po aktywowaniu otrzymasz {{discount}}% zniżki na {{timespan}} Twojej subskrypcji.","promo_free_title":"<0>{{timespan}}</0>darmowej subskrypcji","promo_free_content":"Po aktywowaniu otrzymasz {{timespan}} za darmo z Twoją obecną subskrypcją.","promo_action":"Aktywuj zniżkę","promo_activation_success":"Kod promocyjny został aktywowany.","promo_activation_fail":"Nie udało się aktywować kodu promocyjnego.","no_trial_subscription_expired_trial":"Twoja subskrypcja będzie automatycznie odnowiona w dniu {{date}}.","promo_code_heading":"Wpisz numer vouchera lub kod promocyjny","promo_code_input_placeholder":"Wpisz kod","promo_code_button_enter":"Wpisz kod","promo_code_button_activate":"Aktywuj"}');

/***/ }),

/***/ 20043:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Oglądaj legalnie setki sztuk teatralnych bez wychodzenia z domu!","description":"<0>7-dniowy <1>BEZPŁATNY</1> okres próbny. Możesz anulować subskrypcję w każdej chwili. </0>","full_name":"Imię i nazwisko","email":"E-mail","btn_continue":"Dalej","register_terms":"<0>Klikając “Dalej”, zgadzasz się  z <1>Warunkami regulaminu</1> oraz <2>Polityką prywatności</2>.</0>","already_account":"Masz już konto?","login_prompt":"Zaloguj się","setup_password":"Prawie gotowe. Wybierz hasło.","password_placeholder":"Przynajmniej 8 znaków","password":"Hasło","password_again":"Powtórz hasło","changes_not_saved":"Żądanie nie zostało przetworzone. Prosimy spróbować ponownie później.","changes_saved":"Zmiany zostały zapisane","confirm_email_title":"Sprawdź swoją skrzynkę e-mail.","confirm_email_text":"<0>Wiadomość została wysłana na adres <1>{{email}}</1>. Aktywuj konto, klikając w otrzymany link.</0>\\n","country_of_residence":"Kraj zamieszkania","no_trial_description":"<0>Możesz anulować subskrypcję w każdej chwili. </0>"}');

/***/ }),

/***/ 61283:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"forschools_bottom_desc":"Twoi uczniowie mogą korzystać z Dramoxu za 50% regularnej ceny! Oferta dla uczniów pozwala im korzystać z naszych zasobów teatru online już za {{studentMonthly}} miesięcznie.","forschools_button":"Zamów Dramox dla szkół","forschools_description":"Dramox dla szkół to oferta kierowana do nauczycieli, którzy chcą zaoferować uczniom coś więcej niż zwyczajne lekcje. Dzięki nieograniczonemu dostępowi do spektakli w mgnieniu oka znajdziecie się w wirtualnej sali teatralnej. Nasze nowoczesne scenariusze lekcyjne pomogą przybliżyć młodym teatromanom fascynujący świat sztuki i literatury.","forschools_footer":"Dla szkół","forschools_for_class_desc_1":"Skontakuj się z nami <0>skoly@dramox.cz</0>.","forschools_for_class_desc_2_1":"Skontaktujemy się z Tobą wkrótce. Wspólnie omówimy szczegóły i liczbę voucherów, których będzie potrzebować Twoja klasa lub szkoła.","forschools_for_class_desc_2_2":"Ważna informacja: każdy student musi posiadać swój voucher z unikalnym kodem. Niestety nie ma możliwości zamówienia jednego voucheru dla całej szkoły.","forschools_for_class_desc_3":"Szkoła pokryje koszt voucherów.","forschools_for_class_desc_4":"Po otrzymaniu potwierdzenia zapłaty, vouchery zostaną wysłane na Twój adres e-mail.","forschools_for_class_desc_5":"Dzięki voucherom, uczniowie lub studenci będą mogli zarejestrować się na Dramoxie i oglądać teatr online przez miesiąc, trzy, a nawet cały rok – w zależności od subskrypcji, którą wybierzesz.","forschools_for_class_title":"Jak zamówić dostęp do teatru online dla klasy lub szkoły?","forschools_for_who_desc_1":"Nasza oferta jest przeznaczona przede wszystkim dla uczniów ostatnich klas szkoły podstawowej, a także szkół średnich, zawodowych i techników oraz dla studentów.","forschools_for_who_desc_2":"Jeśli nie należysz do żadnej z wymienionych instytucji, ale pracujesz w sektorze edukacyjnym i chcesz skorzystać z naszej oferty, skontaktuj się z nami <0>skoly@dramox.cz</0>. Na pewno znajdziemy odpowiednie rozwiązanie!","forschools_for_who_title":"Dla kogo jest skierowana ta oferta?","forschools_obligatory":"W naszej ofercie znajdziecie kilkadziesiąt pozycji z <0>obowiązkowej listy lektur</0>, dzięki którym uczniowie dowiedzą się, kim jest Raskolnikow, jaki koniec czekał Fausta, a także jaki los spotkał córki króla Leara. Oprócz lektur uczniowie mogą obejrzeć kilkaset innych nagrań teatralnych, które w domowej atmosferze pozwolą im zapoznać się ze światem międzynarodowego teatru.","forschools_price":"{{studentMonthly}}","forschools_price_desc":"miesięcznie / uczeń","forschools_student_price_desc":"Cena miesięcznego planu abonamentowego wynosi {{studentMonthly}} za jednego ucznia. To o {{studentMonthlyPercentageDiscount}}% mniej od ceny standardowej subskrypcji, która wynosi {{monthly}}.","forschools_student_price_title":"Ile wynosi ceny subskrypcji po zastosowaniu zniżki dla uczniów?","forschools_title":"Dramox dla szkół"}');

/***/ }),

/***/ 52729:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"welcome_title":"Dramox | Twój teatr online","welcome_description":"Oglądaj setki spektakli teatralnych online na Dramoxie.","browse_title":"Setki sztuk teatralnych online | Dramox","browse_description":"Wybierz jedno z setek przedstawień teatralnych online dostępnych na Dramoxie. Wypróbuj platformę BEZPŁATNIE.","celebrity_title":"{{name}} | Teatr online | Dramox","performance_title":"{{title}} | {{theatre}} online | Dramox","watch_performance_title":"{{title}} – oglądaj online | {{theatre}} | Dramox","theatres_title":"Twoje ulubione teatry online | Dramox","theatres_description":"Wybierz jedno z setek przedstawień teatralnych online dostępnych na Dramoxie. Wypróbuj platformę BEZPŁATNIE. Znajdź swój ulubiony teatr.","theatre_title":"{{name}} | Teatr online | Dramox","404_title":"Dramox teatr online | Szukam strony","404_description":"Niestety nie udało nam się odnaleźć żądanej strony. Może zamiast tego wybierzesz inne z setek przedstawień teatralnych online, które oferuje Dramox?","about_us_title":"Dramox teatr online | O nas","about_us_description":"Dramox oferuje setki spektakli teatralnych online. Wypróbuj platformę BEZPŁATNIE. Wspomagamy nauczycieli w zdalnym nauczaniu – oferujemy aż 50% zniżki dla szkół!","authorship_title":"Dramox teatr online | Chronimy prawa autorskie","authorship_description":"Na Dramoxie znajdują się wyłącznie licencjonowane spektakle. Prezentując spektakle teatralne online, Dramox wspiera teatry. Dokładamy również wszelkich starań, aby każdy twórca otrzymał odpowiednie wynagrodzenie.","choose_plan_title":"Dramox | Teatr online przez miesiąc, trzy miesiące, a może przez cały rok?","choose_plan_description":"Wybierz swoją subskrypcję","contact_title":"Dramox teatr online | Skontaktuj się z nami","contact_description":"Masz pytanie dotyczące Dramoxu lub przedstawień teatralnych online? Napisz e-mail na adres: sufler@dramox.pl. Pomożemy!","cookies_title":"Dramox teatr online | Dla lepszych wrażeń teatralnych","cookies_description":"Teatr online Dramox używa ciasteczek, małych pomocników, którzy zapewniają doskonałe wrażenia podczas oglądania. Wypróbuj platformę BEZPŁATNIE. Wybieraj swobodnie spośród setek przedstawień teatralnych.","donate_home_title":"Wspieraj teatry","donate_title":"Dramox | Wspieraj {{theatre}} online","donate_description":"Korzystasz z Dramoxu i oglądasz spektakle online? W ten sposób wspierasz teatry, artystów oraz twórców. Połowę pieniędzy z subskrypcji trafia bezpośrednio do nich. Możesz również wesprzeć swój ulubiony teatr, przekazując dowolną kwotę jako darowiznę. Cały przychód zostanie przekazany bezpośrednio wybranemu teatrowi. Nie zatrzymujemy nic dla siebie, a potrącona zostaje jedynie prowizja od bezpiecznego przelewu.","for_schools_title":"Teatr online dla szkół | Dramox","for_schools_description":"Zamów plan subskrypcji Dramoxu dla Twojej szkoły i uzyskaj rabat w wysokości aż 50%. Na Dramoxie znajdziesz setki zjawiskowych adaptacji lektur szkolnych. BEZPŁATNE arkusze ćwiczeń natomiast sprawią, że Twoje lekcje online i nie tylko będą oryginalne i angażujące.","forgotten_password_title":"Dramox theater online | Nie pamiętam hasła","forgotten_password_description":"Już za chwilę będziesz mógł ponownie oglądać teatr online na Dramoxie. Podaj swój adres e-mail, aby otrzymać nowe hasło.","frequently_asked_questions_title":"Dramox | Najczęściej zadawane pytania","frequently_asked_questions_description":"Dramox to teatr online. Czekają na Ciebie setki spektakli zebranych w jednym miejscu, które możesz oglądać BEZ DODATKOWYCH OPŁAT. Sprawdź nas! Zapoznaj się z najczęściej zadawanymi pytaniami.","vouchers_buy_title":"Teatr online jako prezent | Dramox","vouchers_buy_description":"Voucher Dramox to doskonały prezent dla każdego. Możesz podarować swoim bliskim niezapomniane wrażenia teatralne online. Kup teraz i wręcz go kiedy tylko chcesz.","login_title":"Dramox teatr online | Zaloguj się","login_description":"Już za chwilę czekają Cię godziny niezapomnianych wrażeń podczas oglądania spektakli teatralnych online na Dramoxie. Zaloguj się, używając adresu e-mail i hasła wybranego podczas rejestracji.","playlist_performance_similar_genre_title":"{{performance}} – Twój ulubiony gatunek teatralny online | Dramox","playlist_performance_similar_genre_description":"Dzięki Dramoxowi z łatwością znajdziesz swój ulubiony gatunek, również oglądając {{performance}}. Dramaty, musicale, balety, teatr animacji – regularnie dodajemy nowe produkcje. Zacznij oglądać już dziś.","playlist_performance_similar_cast_title":"{{performance}} – Twoi ulubieni aktorzy online | Dramox","playlist_performance_similar_cast_description":"Na Dramoxie znajdziesz swoich ulubionych aktorów scen teatralnych, występujących w spektaklach {{performance}}. Wypróbuj BEZPŁATNIE. Zacznij oglądać już dziś.","playlist_genre_title":"Spektakl z gatunku – {{genre}} | Dramox","playlist_genre_description":"Ciesz się swoim ulubionym gatunkiem teatralnym online na Dramoxie. Dramaty, musicale, balet, teatr animacji – regularnie dodajemy nowe produkcje. Wypróbuj BEZPŁATNIE.","playlist_featured_title":"Spektakl z kategorii – {{section}} | Dramox","playlist_featured_description":"Na Dramoxie znajdziesz spektakle teatralne online z kategorii {{section}}. Poznaj magię świata teatru jeszcze bliżej!","playlist_currently_watching_title":"Dramox teatr online | Obecnie oglądasz","playlist_currently_watching_description":"Oglądaj setki spektakli teatralnych online na Dramoxie. Wypróbuj platformę BEZPŁATNIE. Daj się zaprosić do teatru online!","playlist_most_popular_title":"Dramox teatr online | Najpopularniejsze spektakle teatralne","playlist_most_popular_description":"Oglądaj spektakle, które nasza publiczność uznała za najpopularniejsze. Znajdziesz wśród nich propozycje dla całej rodziny – tragedie, komedie, romanse, a także bajki!","playlist_recent_title":"Nowe spektakle już dostępne | Dramox","playlist_recent_description":"Oglądaj najnowsze spektakle teatralne online na Dramoxie. Tragedie, komedie, romanse, a także bajki – każdego dnia czekają na Ciebie nowe, wspaniałe przedstawienia.","profile_title":"Dramox teatr online | Profil użytkownika","profile_description":"Witaj na platformie Dramox – w teatrze online. Znajdziesz tu setki spektakli z całego świata. Tragedie, komedie, romanse, a także bajki – każdego dnia czekają na Ciebie nowe przedstawienia.","register_step1_title":"Dramox teatr online | Rejestracja nowego użytkownika","register_step1_description":"Już za chwilę czekają Cię godziny niezapomnianych wrażeń podczas oglądania spektakli teatralnych online na Dramoxie. Zarejestruj się i korzystaj z pierwszego tygodnia bez opłat.","register_step2_title":"Dramox teatr online | Stwórz hasło","register_step2_description":"Już za chwilę czekają Cię godziny niezapomnianych wrażeń podczas oglądania spektakli teatralnych online na Dramoxie. Stwórz swoje hasło. Możesz je zmienić kiedy chcesz.","register_confirm_email_title":"Dramox teatr online | Potwierdzenie hasła","register_confirm_email_description":"Już za chwilę czekają Cię godziny niezapomnianych wrażeń podczas oglądania spektakli teatralnych online na Dramoxie. Potwierdź adres email.","terms_conditions_title":"Dramox teatr online | Warunki korzystania","terms_conditions_description":"Warunki korzystania z platformy oraz zasady oglądania setek spektakli online na Dramoxie są wyjątkowo przejrzyste. Wierzymy, że otwarta i bezpośrednia komunikacja, a także unikanie zbędnych formalności to gwarancja sukcesu i dobrych relacji.","privacy_policy_title":"Dramox teatr online | Polityka prywatności","privacy_policy_description":"W serwisie Dramox chronimy Twoją prywatność. Twoje dane osobowe są u nas bezpieczne. Korzystamy z zaufanych technologii i pracujemy w zgodzie z RODO.","how_to_watch_web_title":"Teatr online na Twoim komputerze | Dramox","how_to_watch_web_description":"Oglądaj teatr online wygodnie na swoim komputerze. Zaproś do domu najlepszych aktorów teatralnych i podziwiaj ich w setkach doskonałych spektakli.","how_to_watch_tv_title":"Aplikacja na Smart TV | Dramox","how_to_watch_tv_description":"Pobierz aplikację Dramox TV dla telewizorów Smart TV. Oglądaj najlepsze spektakle teatralne w zaciszu swojego domu.","how_to_watch_tv_samsung_title":"Aplikacja na Samsung TV | Dramox teatr online","how_to_watch_tv_samsung_description":"Pobierz naszą aplikację Dramox TV dla Samsung smart TV z OS Tizen i pokochaj teatr online.","how_to_watch_tv_lg_title":"Aplikacja na LG TV | Dramox teatr online","how_to_watch_tv_lg_description":"Pobierz naszą aplikację Dramox TV dla LG smart TV z WebOS i pokochaj teatr online.","how_to_watch_mobile_title":"Aplikacja mobilna na Android i iOS | Dramox teatr online","how_to_watch_mobile_description":"Pobierz aplikację mobilną dla smartfonów i tabletów. Setki spektakli i najlepsi aktorzy teatralni znajdą się w zasięgu Twojej ręki.","how_to_watch_mobile_ios_title":"Aplikacja dla iOS | Dramox teatr online","how_to_watch_mobile_ios_description":"Pobierz aplikację mobilną dla smartfonów i tabletów z systemem iOS. Setki spektakli i najlepsi aktorzy teatralni znajdą się w zasięgu Twojej ręki.","how_to_watch_mobile_android_title":"Aplikcja na Android | Dramox teatr online","how_to_watch_mobile_android_description":"Pobierz aplikację mobilną dla smartfonów i tabletów z systemem Android. Setki spektakli i najlepsi aktorzy teatralni znajdą się w zasięgu Twojej ręki – kiedy tylko zechcesz.","how_to_watch_streaming_title":"Przesyłaj obraz z telefonu na telewizor | Dramox","how_to_watch_streaming_description":"Oglądaj teatr online na Smart TV bez konieczności używania aplikacji. Dramox Player obsługuje bezprzewodowe przesyłanie obrazu i dźwięku za pomocą AirPlay oraz Chromecast z Twojego telefonu na Smart TV. \\n","how_to_watch_streaming_chromecast_title":"Dramox prosto z telefonu na Twoim telewizorze z wykorzystaniem Chromecast","how_to_watch_streaming_chromecast_description":"Oglądaj teatr online na Smart TV bez konieczności używania aplikacji. Dramox Player obsługuje bezprzewodowe przesyłanie obrazu i dźwięku za pomocą Chromecast z Twojego telefonu na Smart TV. Ciesz się magią teatru!","how_to_watch_streaming_airplay_title":"Dramox prosto z telefonu na Twoim telewizorze z wykorzystaniem AirPlay","how_to_watch_streaming_airplay_description":"Oglądaj teatr online na Smart TV bez konieczności używania aplikacji. Dramox Player obsługuje bezprzewodowe przesyłanie obrazu i dźwięku za pomocą AirPlay. Ciesz się magią teatru w łatwy sposób!","playlist_dramox_originals_title":"Tylko na Dramoxie | Dramox Originals","playlist_dramox_originals_description":"Uzyskaj dostęp do spektakli dostępnych jedynie na Dramoxie. Oglądaj Dramox Originals i daj się zaprosić do teatru na światowym poziomie – na Dramox.pl. ","content_settings_title":"Ustawienia języka | Dramox","content_settings_description":"Przefiltruj naszą bibliotekę Dramoxu zgodnie z osobistymi preferencjami i ustawieniami, aby znaleźć najlepiej dopasowane spektakle!","ua_support":"Wspieraj ukraińską kulturę","easter_contest_title":"Konkurs wielkanocny | Dramox","easter_contest_desc":"Chcesz wygrać bilety do teatru i vouchery do Dramoxu? Im więcej spektakli online oglądasz, tym większe masz szanse na wygraną! Zapewnij sobie doskonałą rozrywkę na święta wielkanocne, albo doskonały prezent od zajączka!","discount_title":"50% zniżki w Twojej subskrypcji | Dramox","discount_description":"Oglądaj teatr światowej klasy online przez 6 miesięcy za xx zł miesięcznie i oszczędź aż xx zł. Oferta ważna jest tylko przez 7 dni, więc nie zwlekaj!","broadcast_title":"Transmisja na żywo","broadcast_description":"Transmisja na żywo na Dramoxie","no_trial_how_to_watch_web_description":"Oglądaj teatr online wygodnie na swoim komputerze. Zaproś do domu najlepszych aktorów teatralnych i podziwiaj ich w setkach doskonałych spektakli.","no_trial_how_to_watch_tv_description":"Pobierz aplikację Dramox TV dla telewizorów Smart TV. Oglądaj najlepsze spektakle teatralne w zaciszu swojego domu.","no_trial_how_to_watch_tv_samsung_description":"Pobierz naszą aplikację Dramox TV dla Samsung smart TV z OS Tizen i pokochaj teatr online.","no_trial_how_to_watch_tv_lg_description":"Pobierz naszą aplikację Dramox TV dla LG smart TV z WebOS i pokochaj teatr online.","no_trial_how_to_watch_mobile_description":"Pobierz aplikację mobilną dla smartfonów i tabletów. Setki spektakli i najlepsi aktorzy teatralni znajdą się w zasięgu Twojej ręki.","no_trial_how_to_watch_mobile_ios_description":"Pobierz aplikację mobilną dla smartfonów i tabletów z systemem iOS. Setki spektakli i najlepsi aktorzy teatralni znajdą się w zasięgu Twojej ręki.","no_trial_how_to_watch_mobile_android_description":"Pobierz aplikację mobilną dla smartfonów i tabletów z systemem Android. Setki spektakli i najlepsi aktorzy teatralni znajdą się w zasięgu Twojej ręki – kiedy tylko zechcesz.","no_trial_playlist_dramox_originals_description":"Uzyskaj dostęp do spektakli dostępnych jedynie na Dramoxie. Oglądaj Dramox Originals i daj się zaprosić do teatru na światowym poziomie – na Dramox.pl.","christmas_contest_title":"Christmas Contest | Dramox Online Theater","christmas_contest_description":"This December, stream online theater on Dramox and win gift vouchers, tickets to Dejvice Theater and many more. The more performances you watch, the higher your chance of winning.","celebrity_default_about":"{{name}} występuje w następujących produkcjach dostępnych na Dramoxie: {{plays}} z teatru: {{theatre}}. Ciesz się teatrem online ze swoimi ulubionymi twórcami."}');

/***/ }),

/***/ 26543:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"content_settings_title":"Wybór języka","perfomance_language_settings_title":"Wybierz język spektaklu","perfomance_language_settings_subtitle":"Przefiltruj naszą bibliotekę spektakli zgodnie z ustawionym przez siebie językiem. Możesz zmienić te ustawienia w każdej chwili.","btn_content_settings_register_submit":"Potwierdź","btn_content_settings_register_skip":"Pomiń","submit_error":"Ustawienia nie zostały zapisane. Spróbuj ponownie później.","submit_ok":"Ustawienia zostały zapisane."}');

/***/ }),

/***/ 27599:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"samsung_title":"Aplikacja Dramox na Samsung Smart TV","samsung_desc":"Dostępne dla modeli 2018 i nowszych, z systemem OS Tizen 4.0 i nowszym. Potrzebujesz pomocy? Skontaktuj się z nami pod adresem <a href=\\"mailto:sufler@dramox.pl\\">sufler@dramo.pl</a>.","samsung_instalation":"Instalacja aplikacji Dramox","samsung_step_1":"Naciśnij przycisk <b>Home</b> lub przycisk <b>Smart Hub</b> na Twoim pilocie.","samsung_step_2":"Na dolnym pasku sterowania wybierz <b>APPS</b>.","samsung_step_3":"W sklepie z aplikacjami wybierz ikonę <b>Szukaj</b> i wpisz hasło Dramox.","samsung_step_4":"Wybierz sugerowaną aplikację <b>Dramox</b>.","samsung_step_5":"Na stronie szczegółów aplikacji kliknij przycisk <b>Instaluj</b>. Zaloguj się przy użyciu konta Samsung, jeśli będzie to wymagane.","samsung_step_6":"Po udanej instalacji kliknij przycisk <b>Dodaj do ekranu głównego</b>. Aplikacja pojawi się w menu na dolnym pasku.","samsung_step_7":"Po otwarciu aplikacji Dramox zaloguj się do swojego konta na Dramoxie, wprowadzając poprawny e-mail i hasło.","lg_title":"Aplikacja Dramox na Samsung Smart TV","lg_desc":"Dostępne dla modeli 2016 i nowszych, z systemem webOS 3.0 i nowszym. Potrzebujesz pomocy? Skontaktuj się z nami pod adresem <a href=\\"mailto:sufler@dramox.pl\\">sufler@dramox.pl</a>.","lg_instalation":"Instalacja aplikacji Dramox","lg_step_1":"Naciśnij przycisk <b>Home</b> na Twoim pilocie.","lg_step_2":"Na dolnym pasku sterowania wybierz <strong>LG Content Store</strong>.","lg_step_3":"W sklepie wybierz ikonę <b>Szukaj</b> i wyszukaj Dramox.","lg_step_4":"Wybierz sugerowaną aplikację <b>Dramox</b>.","lg_step_5":"Na stronie szczegółów aplikacji kliknij przycisk <b>Instaluj</b>.","lg_step_6":"Po udanej instalacji możesz znaleźć aplikację Dramox na dole <strong>Ekranu głównego</strong>. Naciśnij <strong>Uruchom</strong>.","lg_step_7":"Po otwarciu aplikacji Dramox zaloguj się do Twojego konta na Dramoxie, wprowadzając poprawny e-mail i hasło."}');

/***/ }),

/***/ 49562:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"theatres":"Teatry","detail":"Szczegóły","support":"Wesprzyj","web_page":"Strona teatru","theatre_plays":"Spektakle tego teatru","choose_donate":"Wybierz teatr, który chcesz wesprzeć","theatre":"Teatr","continue":"Dalej","choose_theatre":"Wybierz teatr","min_donate":"Minimalna wpłata to {{value}} {{currency}}.","max_donate":"Maksymalna wpłata to {{value}} {{currency}}.","donate_how_much":"Jaką kwotę chcesz przekazać?","donate_note":"Prawie cały przychód z wpłaconej darowizny zostanie przekazany bezpośrednio wybranemu teatrowi. Nie zatrzymujemy nic dla siebie, a potrącona kwota pokrywa koszty bezpiecznego przelewu.","amount_other":"Inna waluta","button_submit":"Prześlij","changes_not_saved":"Zmiany nie mogły zostać zapisane. Spróbuj ponownie za chwilę.","changes_saved":"Zmiany zostały zapisane.","donation_success":"Dziękujemy za Twoje wsparcie.","donation_fail":"Płatność nie powiodła się.","amount_in_currency":"Kwota w {{currency}}","must_login":"Musisz zalogować się na swoje konto.","dramox_theatres":"Teatry Dramoxu","sort_alphabeticaly":"Alfabetycznie","sort_newest":"Od najnowszych","sort_popular":"Od najpopularniejszych","sort":"Sortuj","genre":"Gatunek","language":"Język","country":"Kraj","filter_all":"Wszystkie","clear_filter":"Wyczyść filtry","most_popular_theatres":"Najpopularniejsze teatry","popular_this_week_theatres":"Najpopularniejsze teatry w tym tygodniu","no_theatres":"Nie znaleziono teatrów.","plays_count_zero":"{{count}} spektakle","plays_count_one":"{{count}} spektakl","plays_count_few":"{{count}} spektakle","plays_count_many":"{{count}} spektakle","register":"Zarejestruj się","amount":{"one":"","few":"","many":"","other":""}}');

/***/ }),

/***/ 50537:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Wspieraj ukraińską kulturę: 100% kwoty zostanie przekazane do ukraińskich teatrów.","subtitle":"17 lutego w Kijowie odbyła się konferencja prasowa, na której ogłosiliśmy, iż wśród 17 teatrów narodowych obecnych na Dramoxie znalazł się również teatr Ukrainy. Spodziewamy się, że mimo obecnie trudnej sytuacji, ukraińskie teatry będą do nas dołączać.","text_1":"Życie – zarówno zwyczajne, jak i kulturalne – nie jest już takie samo w Ukrainie. Zatrzymało się. Dramox jest obecnie jedynym miejscem, w którym ukraińska sztuka teatralna nadal jest obecna i może być bezpiecznie podziwiana.","text_2":"<p>To główny powód, dla którego udzielamy największego możliwego wsparcia ukraińskim teatrom, przekazując <span>100% kwoty z subskrypcji i darowizn. <ukTheater>Oglądając ukraińskie spektakle</ukTheater> pomagasz bezpośrednio teatrom.","how_watch_title":"Jak oglądać na Dramoxie?","how_watch_1":"Zaloguj się na swoim koncie na Dramoxie","how_watch_2":"<li>Kliknij <span>Ustawienia Języka</span> w menu w prawym górnym rogu i wybierz Українська</li>","how_watch_3":"Teraz masz łatwy dostęp do wszystkich spektakli w języku ukraińskim","how_watch_soon":"Coraz więcej ukraińskich spektakli będzie się pojawiać na Dramoxie! Pracujemy również nad sukcesywnym dodawaniem angielskich napisów do jak największej liczby nagrań."}');

/***/ }),

/***/ 84710:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"airplay_title":"Przesyłam do TV za pomocą AirPlay.","airplay_description":"AirPlay to technologia firmy Apple służąca do strumieniowego przesyłania treści multimedialnych do telewizora.","airplay_instalation":"Jak transmitować spektakl przez AirPlay?","airplay_step_1":"Twój Smart TV musi być podłączony do tej samej sieci Wi-Fi, co Twój laptop, smartfon lub tablet.","airplay_step_2":"Telewizor musi obsługiwać technologię AirPlay.","airplay_step_3":"Odtwórz wybrany spektakl w przeglądarce <strong>Safari</strong> lub <a href=\\"https://apps.apple.com/cz/app/dramox-divadlo-online/id1563430137?l=cs\\" target=\\"blank\\">w aplikacji mobilnej dla iOS</a>.","airplay_step_4":"Kliknij ikonkę <0></0> w prawym górnym rogu.","airplay_step_5":"W sieci Wi-Fi wybierz telewizor, do którego chcesz transmitować spektakl.","chromecast_title":"Przesyłam do TV za pomocą Chromecast.","chromecast_description":"Chromecast to technologia firmy Google służąca do strumieniowego przesyłania treści multimedialnych do telewizora.","chromecast_instalation":"Jak transmitować spektakl za pomocą Chromecast?","chromecast_step_1":"Twój Smart TV musi być podłączony do tej samej sieci Wi-Fi co Twój laptop, smartfon lub tablet.","chromecast_step_2":"Telewizor musi obsługiwać technologię Chromecast.","chromecast_step_3":"Odtwórz wybrany spektakl <strong>w przeglądarce Chrome, Opera</strong> lub <a href=\\"https://play.google.com/store/apps/details?id=cz.dramox.dramox\\" target=\\"_blank\\">w aplikacji mobilnej dla Android.</a>","chromecast_step_4":"Kliknij ikonkę opcji <0></0> w prawym dolnym rogu.","chromecast_step_5":"Kliknij ikonkę Chromcast. <0></0>","chromecast_step_6":"W sieci Wi-Fi wybierz telewizor, do którego chcesz transmitować spektakl."}');

/***/ }),

/***/ 11090:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Dramox w prezencie","description":"Po zakończeniu płatności voucher zostanie wysłany na Twój adres e-mail w formacie PDF.","buy_btn":"Kup kartę podarunkową","for_companies":"Jeśli reprezentujesz firmę i chcesz kupić większą liczbę voucherów (10 lub więcej), skontaktuj się z nami pod adresem <contactMail>sufler@dramox.pl</contactMail>.","price_with_vat":"{{price}} z VAT","buy_success":"Dziękujemy. Voucher zostanie wkrótce wysłany na Twój adres e-mail.","buy_fail":"Płatność nie powiodła się.","givery":"W porozumieniu z Givery.cz","buy_physical_voucher":"Chcę wydrukowany voucher +89 CZK"}');

/***/ }),

/***/ 80931:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"menu_faq":"FAQ","theatres_list_title":"Lista teatrów","plays_list_title":"Wybrane przedstawienia","new_welcome_sec_1_title_cz":"Setki teatrów dostępnych online na Dramoxie","new_welcome_sec_1_title_xx":"Setki teatrów dostępnych online na Dramoxie","new_welcome_sec_2_text_cz":"Setki spektakli dostępnych online na Dramoxie","new_welcome_sec_2_text_xx":"Setki spektakli dostępnych online na Dramoxie","new_welcome_sec_2_title_cz":"Przeglądaj Bibliotekę","new_welcome_sec_2_title_xx":"Przeglądaj Bibliotekę","new_welcome_sec_3_text_cz":"Dzięki temu, że oglądasz spektakle online, wspierasz teatry na całym świecie. Połowę Twojej subskrypcji przekazujemy teatrowi i twórcom spektaklu. Możesz również wesprzeć swój ulubiony teatr, przekazując dowolną kwotę jako darowiznę. Cały przychód zostanie przekazany bezpośrednio wybranemu teatrowi. Nie zatrzymujemy nic dla siebie, a potrącona zostaje jedynie prowizja od bezpiecznego przelewu.","new_welcome_sec_3_text_xx":"Dzięki temu, że oglądasz spektakle online, wspierasz teatry na całym świecie. Połowę Twojej subskrypcji przekazujemy teatrowi i twórcom spektaklu. Możesz również wesprzeć swój ulubiony teatr, przekazując dowolną kwotę jako darowiznę. Cały przychód zostanie przekazany bezpośrednio wybranemu teatrowi. Nie zatrzymujemy nic dla siebie, a potrącona zostaje jedynie prowizja od bezpiecznego przelewu.","new_welcome_sec_3_title_cz":"Połowę kwoty z każdej subskrypcji przekazujemy teatrowi i twórcom spektaklu. ","new_welcome_sec_3_title_xx":"Połowę kwoty z każdej subskrypcji przekazujemy teatrowi i twórcom spektaklu. ","new_welcome_sec_4_text_xx":"Marzysz o teatrze na wyciągnięcie ręki? Z nami możesz oglądać przedstawienia światowej klasy gdzie i kiedy chcesz. Platforma Dramox jest dostępna na komputery, smartfony oraz Smart TV. Panie i panowie, proszę zająć miejsca na... kanapie, zaraz zaczynamy spektakl!","new_welcome_sec_4_text_cz":"Marzysz o teatrze na wyciągnięcie ręki? Z nami możesz oglądać przedstawienia światowej klasy gdzie i kiedy chcesz. Platforma Dramox jest dostępna na komputery, smartfony oraz Smart TV. Panie i panowie, proszę zająć miejsca na... kanapie, zaraz zaczynamy spektakl!","new_welcome_sec_4_title_cz":"Zakochaj się w Dramoxie","new_welcome_sec_4_title_xx":"Zakochaj się w Dramoxie","new_welcome_sec_5_text_cz":"Możesz anulować swoją subskrypcję w każdej chwili.","new_welcome_sec_5_text_xx":"Możesz anulować swoją subskrypcję w każdej chwili.","new_welcome_sec_5_title_cz":"Wypróbuj Dramox przez 7 dni bezpłatnie","new_welcome_sec_5_title_xx":"Wypróbuj Dramox przez 7 dni bezpłatnie","welcome_button_long_xx":"Zacznij 7-dniowy BEZPŁATNY okres próbny","welcome_button_long_cz":"Zacznij 7-dniowy BEZPŁATNY okres próbny","welcome_price_cz":"Oglądaj już za {{monthly}} miesięcznie lub anuluj subskrypcję w dowolnym momencie. Pamiętaj, że połowę kwoty z każdej subskrypcji przekazujemy teatrowi i twórcom spektaklu.","welcome_price_xx":"Oglądaj już za {{monthly}} miesięcznie lub anuluj subskrypcję w dowolnym momencie. Pamiętaj, że połowę kwoty z każdej subskrypcji przekazujemy teatrowi i twórcom spektaklu.","welcome_subtitle_xx":"Oglądaj gdzie i kiedy chcesz!","welcome_subtitle_cz":"Oglądaj gdzie i kiedy chcesz!","welcome_title_cz":"Ogromny wybór spektakli teatralnych online w jednym miejscu","welcome_title_xx":"Ogromny wybór spektakli teatralnych online w jednym miejscu","new_welcome_sec_1_title_sk":"Setki teatrów dostępnych online na Dramoxie ","new_welcome_sec_2_text_sk":"Setki spektakli dostępnych online na Dramoxie ","new_welcome_sec_2_title_sk":"Przeglądaj Bibliotekę","new_welcome_sec_3_text_sk":"Dzięki temu, że oglądasz spektakle online, wspierasz teatry na całym świecie. Połowę Twojej subskrypcji przekazujemy teatrowi i twórcom. Możesz również wesprzeć swój ulubiony teatr, przekazując dowolną kwotę jako darowiznę. Cały przychód zostanie przekazany bezpośrednio wybranemu teatrowi. Nie zatrzymujemy nic dla siebie, a potrącona zostaje jedynie prowizja od bezpiecznego przelewu.","new_welcome_sec_3_title_sk":"Połowę kwoty z każdej subskrypcji przekazujemy teatrowi i twórcom spektaklu.","new_welcome_sec_4_text_sk":"Marzysz o teatrze na wyciągnięcie ręki? Z nami możesz oglądać przedstawienia światowej klasy gdzie i kiedy chcesz. Platforma Dramox jest dostępna na komputery, smartfony oraz Smart TV. Panie i panowie, proszę zająć miejsca na... kanapie, zaraz zaczynamy spektakl!","new_welcome_sec_4_title_sk":"Zakochaj się w Dramoxie","new_welcome_sec_5_text_sk":"Możesz anulować swoją subskrypcję w każdej chwili.","new_welcome_sec_5_title_sk":"Wypróbuj Dramox przez 7 dni bezpłatnie","welcome_button_long_sk":"Zacznij 7-dniowy BEZPŁATNY okres próbny","welcome_price_sk":"Oglądaj już za {{monthly}} miesięcznie lub anuluj subskrypcję w dowolnym momencie. Pamiętaj, że połowę kwoty z każdej subskrypcji przekazujemy teatrowi i twórcom spektaklu.","welcome_subtitle_sk":"Oglądaj gdzie i kiedy chcesz!","welcome_title_sk":"Największy wybór spektakli teatralnych online w jednym miejscu","new_welcome_sec_1_title_ua":"Setki teatrów dostępnych online na Dramoxie","new_welcome_sec_2_text_ua":"Setki spektakli dostępnych online na Dramoxie","new_welcome_sec_2_title_ua":"Przeglądaj Bibliotekę","new_welcome_sec_3_text_ua":"Dzięki temu, że oglądasz spektakle online, wspierasz teatry na całym świecie. Połowę Twojej subskrypcji przekazujemy teatrowi i twórcom. Możesz również wesprzeć swój ulubiony teatr, przekazując dowolną kwotę jako darowiznę. Cały przychód zostanie przekazany bezpośrednio wybranemu teatrowi. Nie zatrzymujemy nic dla siebie, a potrącona zostaje jedynie prowizja od bezpiecznego przelewu.","new_welcome_sec_3_title_ua":"Połowa kwoty z Twojej subskrypcji przekazywana jest teatrom, twórcom i aktorom, z którymi współpracujemy.","new_welcome_sec_4_text_ua":"Marzysz o teatrze na wyciągnięcie ręki? Z nami możesz oglądać przedstawienia światowej klasy gdzie i kiedy chcesz. Platforma Dramox jest dostępna na komputery, smartfony oraz Smart TV. Panie i panowie, proszę zająć miejsca na... kanapie, zaraz zaczynamy spektakl!","new_welcome_sec_4_title_ua":"Zakochaj się w Dramoxie","new_welcome_sec_5_text_ua":"Możesz anulować swoją subskrypcję w każdej chwili.","new_welcome_sec_5_title_ua":"Wypróbuj Dramox przez 7 dni bezpłatnie","welcome_button_long_ua":"Zacznij 7-dniowy BEZPŁATNY okres próbny","welcome_price_ua":"Oglądaj już za {{monthly}} miesięcznie lub anuluj subskrypcję w dowolnym momencie. Pamiętaj, że połowę kwoty z każdej subskrypcji przekazujemy teatrowi i twórcom spektaklu.","welcome_subtitle_ua":"Oglądaj gdzie i kiedy chcesz!","welcome_title_ua":"Największy wybór spektakli ukraińskich w jednym miejscu","new_welcome_sec_1_title_pl":"Setki teatrów dostępnych online na Dramoxie","new_welcome_sec_2_text_pl":"Setki spektakli dostępnych online na Dramoxie","new_welcome_sec_2_title_pl":"Przeglądaj Bibliotekę","new_welcome_sec_3_text_pl":"Dzięki temu, że oglądasz spektakle online, wspierasz teatry na całym świecie. Połowę Twojej subskrypcji przekazujemy teatrowi i twórco. Możesz również wesprzeć swój ulubiony teatr, przekazując dowolną kwotę jako darowiznę. Cały przychód zostanie przekazany bezpośrednio wybranemu teatrowi. Nie zatrzymujemy nic dla siebie, a potrącona zostaje jedynie prowizja od bezpiecznego przelewu.","new_welcome_sec_3_title_pl":"Połowę kwoty z każdej subskrypcji przekazujemy teatrowi i twórcom spektaklu.","new_welcome_sec_4_text_pl":"Marzysz o teatrze na wyciągnięcie ręki? Z nami możesz oglądać przedstawienia światowej klasy gdzie i kiedy chcesz. Platforma Dramox jest dostępna na komputery, smartfony oraz Smart TV. Panie i panowie, proszę zająć miejsca na... kanapie, zaraz zaczynamy spektakl!","new_welcome_sec_4_title_pl":"Zakochaj się w Dramoxie","new_welcome_sec_5_text_pl":"Możesz anulować swoją subskrypcję w każdej chwili.","new_welcome_sec_5_title_pl":"Wypróbuj Dramox","welcome_button_long_pl":"Zacznij 7-dniowy BEZPŁATNY okres próbny","welcome_price_pl":"Oglądaj już za {{monthly}} miesięcznie lub anuluj subskrypcję w dowolnym momencie. Pamiętaj, że połowę kwoty z każdej subskrypcji przekazujemy teatrowi i twórcom spektaklu.","welcome_subtitle_pl":"Oglądaj gdzie i kiedy chcesz!","welcome_title_pl":"Największy wybór polskich spektakli teatralnych online w jednym miejscu","no_trial_welcome_button_long_xx":"Już dziś zacznij przygodę z teatrem online","no_trial_welcome_button_long_cz":"Już dziś zacznij przygodę z teatrem online","no_trial_welcome_button_long_sk":"Już dziś zacznij przygodę z teatrem online","no_trial_welcome_button_long_ua":"Już dziś zacznij przygodę z teatrem online","no_trial_welcome_button_long_pl":"Już dziś zacznij przygodę z teatrem online","welcome_button_browse_xx":"Przeglądaj wybrane","welcome_button_browse_cz":"Przeglądaj wybrane","welcome_button_browse_sk":"Przeglądaj wybrane","welcome_button_browse_ua":"Przeglądaj wybrane","welcome_button_browse_pl":"Przeglądaj wybrane","welcome_subscription_title_xx":"Wybierz subskrypcję i ciesz się teatrem, kiedy tylko chcesz.","welcome_subscription_title_cz":"Wybierz subskrypcję i ciesz się teatrem, kiedy tylko chcesz.","welcome_subscription_title_sk":"Wybierz subskrypcję i ciesz się teatrem, kiedy tylko chcesz.","welcome_subscription_title_ua":"Wybierz subskrypcję i ciesz się teatrem, kiedy tylko chcesz.","welcome_subscription_title_pl":"Wybierz subskrypcję i ciesz się teatrem, kiedy tylko chcesz.","welcome_subscription_1_xx":"Setki nagrań z ponad 250 teatrów z całego świata.","welcome_subscription_1_cz":"Setki nagrań z ponad 250 teatrów z całego świata.","welcome_subscription_1_sk":"Setki nagrań z ponad 250 teatrów z całego świata.","welcome_subscription_1_ua":"Setki nagrań z ponad 250 teatrów z całego świata.","welcome_subscription_1_pl":"Setki nagrań z ponad 250 teatrów z całego świata.","welcome_subscription_2_xx":"Dramat, musical, opera, balet, teatr lalkowy i cyrk współczesny","welcome_subscription_2_cz":"Dramat, musical, opera, balet, teatr lalkowy i cyrk współczesny","welcome_subscription_2_sk":"Dramat, musical, opera, balet, teatr lalkowy i cyrk współczesny","welcome_subscription_2_ua":"Dramat, musical, opera, balet, teatr lalkowy i cyrk współczesny","welcome_subscription_2_pl":"Dramat, musical, opera, balet, teatr lalkowy i cyrk współczesny","welcome_subscription_3_xx":"Bez reklam, bez dodatkowych opłat","welcome_subscription_3_cz":"Bez reklam, bez dodatkowych opłat","welcome_subscription_3_sk":"Bez reklam, bez dodatkowych opłat","welcome_subscription_3_ua":"Bez reklam, bez dodatkowych opłat","welcome_subscription_3_pl":"Bez reklam, bez dodatkowych opłat","welcome_subscription_button_1_xx":"<0>{{priceMonthly}}</0> miesięcznie","welcome_subscription_button_1_cz":"<0>{{priceMonthly}}</0> miesięcznie","welcome_subscription_button_1_sk":"<0>{{priceMonthly}}</0> miesięcznie","welcome_subscription_button_1_ua":"<0>{{priceMonthly}}</0> miesięcznie","welcome_subscription_button_1_pl":"<0>{{priceMonthly}}</0> miesięcznie","welcome_subscription_button_2_xx":"<0>{{priceYearly}}</0> rocznie (2 miesiące za darmo)","welcome_subscription_button_2_cz":"<0>{{priceYearly}}</0> rocznie (2 miesiące za darmo)","welcome_subscription_button_2_sk":"<0>{{priceYearly}}</0> rocznie (2 miesiące za darmo)","welcome_subscription_button_2_ua":"<0>{{priceYearly}}</0> rocznie (2 miesiące za darmo)","welcome_subscription_button_2_pl":"<0>{{priceYearly}}</0> rocznie (2 miesiące za darmo)","welcome_subscription_button_activate_xx":"Aktywuj swoją subskrypcję","welcome_subscription_button_activate_cz":"Aktywuj swoją subskrypcję","welcome_subscription_button_activate_sk":"Aktywuj swoją subskrypcję","welcome_subscription_button_activate_ua":"Aktywuj swoją subskrypcję","welcome_subscription_button_activate_pl":"Aktywuj swoją subskrypcję","welcome_subscription_cancel_note_xx":"Możesz anulować w dowolnym momencie","welcome_subscription_cancel_note_cz":"Możesz anulować w dowolnym momencie","welcome_subscription_cancel_note_sk":"Możesz anulować w dowolnym momencie","welcome_subscription_cancel_note_ua":"Możesz anulować w dowolnym momencie","welcome_subscription_cancel_note_pl":"Możesz anulować w dowolnym momencie"}');

/***/ }),

/***/ 43673:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"authorship_provider":"Prevádzkovateľ služby","about_colaboration_question":"Máte záujem o spoluprácu?","about_contact_us":"Kontaktovať nás môžete tu","about_creators":"Kto stojí za Dramox.sk?","about_partners":"Naši partneri","about_project":"O projekte","about_schools":"Dramox pre školy ponúka učiteľom možnosť zatraktívniť ich vyučovanie. Študenti objavia krásy divadla a literatúry spôsobom, na ktorý sú zvyknutí - sledovaním videa online. Zabavia sa aj pri vypĺňaní pracovných listov, ktoré sa im prihovárajú ich jazykom - prostredníctvom emotikonov, FB príspevkov, obrázkov.... <0>Viac informácií</0>.","about_theaters":"Zobraziť všetky divadlá","about_colaboration":"Kto s nami hrá?","person_about_1":"Vyštudoval divadelnú vedu. Využíva kombináciu technického a humanitného vzdelania. Pomáhal budovať niekoľko digitálnych spoločností. Pracoval ako obchodník pre Jablotron alebo spoločnosť Creative Dock.","person_about_2":"Pomáhal spustiť videoportál voyo.cz. Vlastní firmu Weemazz 2.0., ktorá pre vlastníkov autorských práv odstraňuje z interenetu nelegálne kópie ich diel. Celú svoju kariéru pracuje v digitálnej sfére. ","person_about_3":"Spoluzakladateľ, duchovný otec myšlienky Dramox, internetový podnikateľ a majiteľ značky Livesport, ktorú celosvetovo využíva viac ako 90 miliónov používateľov. ","person_title_1":"Martin Zavadil","person_title_2":"Radim Horák","person_title_3":"Martin Hájek","forschools_footer":"Pre školy","about_project_description":"<0><1>Dramox</1> je vaše divadlo online, ktoré za mesačné predplatné ponúka najväčší výber divadelných záznamov na jednom mieste. Sledujte svoje obľúbené predstavenia, alebo objavte nové, kedykoľvek a kdekoľvek budete chcieť, a to úplne bez reklám. Pravidelne pridávame nové, rôznorodé predstavenia všetkých žánrov.</0><0>Podporujeme divadelné umenie. Väčšinu z každého predplatného venujeme divadlám, tvorcom a hercom. Svoje obľúbené divadlo môžete podporiť aj ľubovoľnou čiastkou naviac.</0><0><1>Veríme</1>, že spoločne dokážeme spojiť diváka s jeho obľúbeným divadlom a rovnako mu predstaviť nové divadlá, ktoré by sám neobjavil.</0>","legislative":"Dohľad nad poskytovaním audiovizuálnych mediálnych služieb na požiadanie vykonáva Rada pre vysielanie a retransmisiu."}');

/***/ }),

/***/ 68199:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"menu_authorship":"Autorské práva","authorship_email":"Ďakujeme za Váš e-mail.","authorship_email_fail":"Vašu správu sa nepodarilo odoslať. Prosím, zopakujte to neskôr. ","authorship_message_for_us":"Správa pre nás","authorship_provider":"Prevádzkovateľ služby","authorship_send_form":"Odoslať formulár","authorship_title":"Otázka týkajúca sa autorských práv","authorship_your_email":"Váš e-mail","authorship_perex":"<0>Ste majiteľom autorských práv k niektorému z predstavení uvedených na Dramoxe?</0><0>Pokiaľ Vaše autorské práva nezastupuje niektorý z kolektívnych správcov (DILIA, OSA, Aura-pont, Intergram atď.) a my s Vami nie sme v kontakte, prosím, napíšte nám.</0><0>I keď sme urobili maximum, aby sme oslovili všetkých autorov, je možné, že o Vás zatiaľ nevieme.</0><0>Kontaktujte nás, prosím, prostredníctvom nižšie uvedeného formulára. Ihneď sa Vám ozveme a všetko s Vami veľmi radi preberieme.</0><0>Ďakujeme.<1></1>Tím Dramox</0>","authorship_field_required":"Toto pole je povinné.","authorship_max_length":"Maximálna dĺžka poľa je:","authorship_email_invalid":"E-mail je neplatný. Použite formát email@example.sk"}');

/***/ }),

/***/ 84742:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"broadcast_title":"Živé vysielanie","video_placeholder":"Práve nevysielame","schedule_title":"Harmonogram"}');

/***/ }),

/***/ 4338:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Vyberte si predplatné","payment_info":"Noví členovia si môžu vychutnať divadlo online prvých 7 dní ZDARMA. Väčšinu z každého predplatného venujeme divadlám, tvorcom a hercom. Zrušiť ho môžete kedykoľvek.","payment_occour":"Platba prebehne {{date}}","payment_sub_info":"S ročným predplatným ušetríte {{yearPriceDiff}} ročne.","voucher_label":"Darčekový poukaz","voucher_placeholder":"Zadajte kód","got_voucher":"Mám darčekový poukaz","redeem_voucher":"Uplatniť","activate_yearly":"Aktivovať ročné predplatné","activate_monthly":"Aktivovať mesačné predplatné","changes_not_saved":"Zmeny sa nepodarilo uložiť. Prosím, zopakujte to neskôr.","changes_saved":"Zmeny sa uložili.","subscription_activated":"Predplatné je aktívne.","error_general":"Niečo sa pokazilo. Prosím, skúste to neskôr.","price_with_vat":"{{price}}\\ns DPH","advanced_form":{"title":"Vyberte si vaše predplatné","switch_to_voucher":"alebo použite darčekový preukaz","monthly":"7 dní zdarma,<1></1><0>potom za {{priceMonthly}} / mesačne</0>","yearly":"7 dní zdarma,<0>potom za {{price_formatted}} ročne </0>","button_activate":"Aktivovať 7-dňové skúšobné obdobie","timeline_title":"Ako funguje 7-dňové <0></0> bezplatné skúšobné obdobie","timeline_step_1":"<0>Dnes</0> Začiatok bezplatného skúšobného obdobia","timeline_step_2":"<0>O 7 dní ({{date_formatted}})</0>Príde k prvej platbe za vybrané predplatné.<1></1> Pokiaľ ho medzičasom zrušíte, nič sa účtovať nebude.","timeline_step_3":"Predplatné sa automaticky obnovuje až dovtedy, kým ho nezrušíte.","voucher_title":"Použite darčekový poukaz","switch_to_card":"Nemám darčekový poukaz","voucher_description_title":"Darujte svojim blízkym divadlo online a kúpte im darčekový poukaz na Dramox","voucher_description_subtitle":"Na jednom mieste budú môcť vidieť stovky divadelných záznamov z desiatok divadiel","voucher_description_action":"Kúpiť darčekový poukaz","use_promo_code":"Pridať promo kód (nepovinné).","promo_code_placeholder":"Zadajte promo kód","timeline_step_4":"<0>O 5 dní ({{date_formatted}})</0>Pošleme e-mail s upozornením, že sa<1></1>blíži prvá platba za predplatné.","no_trial_button_activate":"Aktivujte si predplatné","no_trial_timeline_title":"Vyberte si svoje predplatné.","no_trial_timeline_step_1":"Začnite sledovať Dramox už dnes.","no_trial_monthly":"<0>{{price_formatted}} mesačne</0>","no_trial_yearly":"<0>{{price_formatted}} ročne</0>"},"code_not_exists":"Kód neexistuje.","card_number_invalid":"Číslo vašej karty je neúplné.","error_code_no_longer_valid":"Kód už neplatí","error_voucher_expired":"Kód vypršal","error_code_discount_already_used":"Zľavový kód už bol použitý","error_discount_already_active":"Promo kód sa nedá aktivovať. Iné predplatné je už aktivované.","error_promo_referral_not_allowed":"Promo kód môžete použiť iba pri zakladaní nového účtu.","error_promo_already_used":"Promo kód už bol aktivovaný.","error_promo_voucher_already_used":"Promo kód už bol aktivovaný.","error_promo_not_allowed":"Promo kód môže byť použitý iba v rámci aktívneho predplatného.","voucher_invalid":"Zadaný promo kód je neplatný.","code_already_used":"Zadaný kód už bol použitý.","no_trial_payment_info":"Predplatné môžete kedykoľvek zrušiť. Polovicu z každého predplatného venujeme divadlám."}');

/***/ }),

/***/ 75861:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"contest_title":"SOUTĚŽ Vánoce s Dramoxem","contest_btn":"Přihlásit se do soutěže","contest_desc":"Bavte se divadlem po celý advent a vyhrajte lístky do divadla i předplatné na Dramox","contest_description":"Uvařte si horký čaj, uvelebte se v křesle a pusťte si každý večer Dramox. Letos za sledování divadla online od 1. 12. do 21. 12. odměňujeme vstupenkami do divadel a poukazy na Dramox. A co je nejlepší, Ježíšek u nás přijde s předstihem už 22. 12. a jednomu z vás přinese divadelní balíček, ve kterém nebudou chybět lístky do oblíbeného Dejvického divadla.","contest_what_win_title":"Co můžete vyhrát?","contest_what_win":"Každý týden soutěžíme o tyto ceny, probíhají celkem tři kola:","contest_what_1":"<0>1. místo</0><1><2>2 lístky do divadla</2><2>poukaz do Dramoxu na 6 měsíců</2></1>","contest_what_2":"<0>2. místo</0><1><2>2 lístky do divadla</2><2>poukaz do Dramoxu na 3 měsíce</2></1>","contest_what_3":"<0>3. - 5. místo</0><1><2>2 lístky do divadla</2><2>poukaz do Dramoxu na 1 měsíc</2></1>","contest_what_main_price":"Hlavní cena za celé období od 1. 12. do 21. 12.:","contest_what_price":"Divadelní balíček s lístky do Dejvického divadla, ročním předplatným na Dramox a stylovými dárkovými předměty Dramox","contest_tip_title":"💡 Náš tip: Čím víc představení uvidíte, tím větší máte šanci na výhru.","contest_tip_desc":"Příklad: Marie v pátek 1. 12. zhlédla jedno představení, další si pustila v úterý 5. 12. a ve středu 6. 12. V nedělním slosování pro první adventní týden má tak trojnásobnou šanci na výhru. Navíc ji automaticky zařadíme do závěrečného slosování o divadelní balíček po ukončení soutěže ve čtvrtek 21. 12. 2023 ve 24:00.","contest_how_play":"Jak soutěžit?","contest_how_1":"<0>Registrujte se ve formuláři.</0> Použijte e-mail, kterým jste registrovaní na Dramoxu.","contest_how_2":"Každý soutěžní týden zhlédněte co nejvíce představení na Dramox.cz. Čím víc si jich pustíte, tím víckrát vás zařadíme mezi soutěžící o ceny.","contest_how_3":"Na konci každého týdne náhodně vybereme pět z vás, kteří získají jednu z cen. Výherce informujeme e-mailem. I když nevyhrajete v průběžném týdenním vyhodnocení, nesmutněte. Soutěžní kola jsou tři. Soutěžte další týden a třeba budete mezi výherci právě vy. Na konci soutěže máte šanci získat hlavní cenu – balíček se vstupenkami do Dejvického divadla, ročním předplatným Dramox a dárkovými předměty Dramox. Jejího vítěze budeme znát odpoledne 22. 12.","contest_how_4":"Sledujte nás také na sociálních sítích <0>Facebook</0>, <1>Instagram</1> a <2>Twitter</2> – dozvíte se, co je v soutěži nového, a získáte inspiraci, co si právě pustit. Dáte si Kouli nebo Zimní pohádku? Je to jen na vás!","contest_rules_title":"Pravidla soutěže Vánoce s Dramoxem","contest_rule_1":"Soutěž začíná 1. 12. 2023 v 0:01, končí 21. 12. 2023 ve 24:00.","contest_rule_2":"Soutěž probíhá v následujících obdobích:","contest_rule_2_1":"1. týden: od 1. 12. 0:01 do 7. 12. 2023 24:00, vyhlášení vítězů: pátek 8. 12. 2023","contest_rule_2_2":"2. týden: od 8. 12. 0:01 do 14. 12. 2023 24:00, vyhlášení vítězů: pátek 15. 12. 2023","contest_rule_2_3":"3. týden: od 15. 12. 0:01 do 21. 12. 2023 24:00, vyhlášení vítězů: pátek 22. 12. 2023","contest_rule_2_4":"4. týden: od 18. 12. 0.01 do 23. 12. 2022 12.00, vyhlášení vítězů: pátek 23. 12. 2022","contest_rule_3":"Zapojit se může každý divák registrovaný na Dramox.cz, který má aktivní předplatné nebo využívá zkušební 7denní období, a současně se registroval do soutěže Vánoce s Dramoxem prostřednictvím soutěžního formuláře.","contest_rule_4":"Vítězové jednotlivých kol jsou vybráni náhodným výběrem vždy ze všech soutěžících, kteří se v daném týdnu zapojili. Vítěze vyhlásíme na našich sociálních sítích a v newsletterech.","contest_rule_5":"Hlavní cena – divadelní balíček plný cen a roční předplatné Dramoxu může vyhrát kterýkoliv soutěžící, který se zapojil v období 1. 12. 2023 - 21. 12. 2023 bez ohledu na to, zda již některou z cen vyhrál, nebo ne. Hlavní cena je pouze jedna pro celou soutěž. Náhodným výběrem bude vybrán jediný soutěžící 22. 12. Vítěze vyhlásíme na našich sociálních sítích a v newsletteru.","contest_rule_more":"Kompletní pravidla Vánoční soutěže s Dramoxem jsou <0>zde</0>","contest_info_toolbar_2023":"⭐ SOUTĚŽ Vánoce s Dramoxem: Vyhrajte vstupenky do divadel i dárkové poukazy na Dramox","contest_info_toolbar_2024":""}');

/***/ }),

/***/ 86939:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"more":"Viac","more_about_play":"Viac o predstavení","previous_play":"Predchádzajúce predstavenie","play_btn":"Prehrať","play_btn_long":"Prehrať divadelné predstavenie","next_play":"Ďalšie predstavenie","coming_soon":"Už čoskoro","continue":"Pokračovať","continue_remaining":"Zostáva {{time}}","most_popular":"Najpopulárnejšie","popular":"Populárne","recently_added":"Nedávno pridané","currently_watching":"Pokračovať v prehrávaní","drama":"Dráma","comedy":"Komédia","tragedy":"Tragédia","all_genres":"Všetky žánre","actors":"Herci a herečky","performances":"Divadelné predstavenia","theatres":"Divadlá","search_placeholder":"Predstavenie, herec, divadlo...","no_search_results":"Zadané heslo je neplatné.","menu":{"home":"Domov","genres":"Žánre","theatres":"Divadlá","about":"O Dramoxe","theatre":"Podporte divadlá","voucher":"Darčekové poukazy","login":"Prihlásiť sa","try_free":"Zaregistrujte sa","about_project":"O projekte","for_schools":"Pre školy","smart_tv":"Smart TV","mobile_apps":"Mobilná aplikácia","how_to_watch":"Ako sledovať","contact":"Kontakt","faq":"Časté otázky","my_profile":"Môj profil","logout":"Odhlásiť sa","terms_conditions":"Podmienky používania","cookies":"Zásady používania Cookies","authorship":"Autorské práva","privacy_policy":"Ochrana súkromia","content_settings":"Jazyky predstavení","try_now":"Vyskúšať","logo_mobile":"Prvých 7 dní ZDARMA","search":"Hľadať","invite_friends":"Pozvať priateľov","watch_list":"Môj zoznam","broadcast":"Vysielanie","no_trial_try_free":"Zaregistrujte sa","christmas_contest":"Vianočná súťaž"},"form":{"not_empty":"Pole nesmie byť prázdne.","password_min_chars":"Heslo musí mať aspoň 8 znakov.","email_format":"Zadajte e-mail v správnom formáte.","wrong_credentials":"Nesprávny e-mail alebo heslo.","already_exists":"E-mail už existuje.","password_dont_match":"Heslá sa nezhodujú.","payment_secured_with":"Zabezpečené technológiami","payment_card":"Platobná karta","add_card":"Pridať kartu","card_tooltip":"Akceptujeme karty VISA, Mastercard, eBenefity","activate":"Aktivovať","recaptcha_error_global":"Captcha nie je validná, prosíme novte stránku.","recaptcha_error_expired":"Platnosť captchy vypršala, zaškrtnite ju prosím znova.","recaptcha_error_not_checked":"Zaškrtnite prosím, nech vieme, že nie ste robot!"},"not_found":{"title":"Stránka nebola nájdená.","description":"Mrzí nás to, ale požadovanú stránku sme nenašli.","btn":"Späť na úvodnú stránku"},"saved_cards":"Uložené karty","saved_cards_placeholder":"Vyberte kartu","card_email":"E-mail","add_new_card":"Pridať novú kartu","playlist_section_title":"Divadelné predstavenie z kategórie {{section}}","playlist_genre_title":"Divadelné predstavenie v žánri {{genre}}","playlist_same_genre_title":"{{performance}} – podobné divadelné predstavenia","playlist_same_cast_title":"{{performance}} – predstavenia s podobným obsadením","playlist_currently_watching_title":"Práve sledujete","playlist_most_popular_title":"Najobľúbenejšie predstavenia","playlist_recent_title":"Najnovšie divadelné predstavenia","country":"Krajina","pick_country":"Vyberte štát","performance_not_found":{"title":"Predstavenie sa nenašlo","description":"Požadované predstavenie buď neexistuje, alebo nie je momentálne dostupné vo vašej krajine."},"playlist_dramox_originals_title":"Dramox Originals","dramox_originals":"Dramox Originals","open_in_mobile_app":"Otvoriť v aplikácii Dramox","watch_list":"Môj zoznam","sort_from":"Zoradiť od","sort_date_desc":"Dátum pridania (od najnovšieho)","sort_date_asc":"Dátum pridania (od nejstaršieho)","sort_alphabetically_desc":"Abecedne (A-Z)","add_first_play":"Pridajte prvé predstavenie","how_add":"Novú položku pridáte pomocou tlačidla “Môj zoznam” v detaily predstavenia","check_library":"Zobraziť knižnicu","month_zero":"{{count}} mesiacov","month_one":"{{count}} mesiac","month_few":"{{count}} mesiace","month_many":"{{count}} mesiacov","day_zero":"{{count}} dní","day_one":"{{count}} deň","day_few":"{{count}} dni","day_many":"{{count}} dní","week_zero":"{{count}} týždňov","week_one":"{{count}} týždeň","week_few":"{{count}} týždne","week_many":"{{count}} týždňov","cookies_bar":{"less_text":"Milí diváci, používame súbory cookies, ktoré vám spríjemňujú sledovanie divadla online.","learn_more":"Chcem vedieť viac","accept_all":"Rozumiem","only_functional":"Prijať iba nevyhnutné\\n"},"cookie_updated":"Aktualizované 24.5.2022","or":"Alebo","year_zero":"{{count}} rokov","year_one":"{{count}} rok","year_few":"{{count}} roky","year_many":"{{count}} rokov","ownership":"Od septembra 2024 je vlastníkom Dramox s.r.o. Nadácia Livesport."}');

/***/ }),

/***/ 99929:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"authorship_provider":"Prevádzkovateľ služby","contact_ceo":"Riaditeľ","contact_cofounder":"Spoluzakladateľ","contact_coo":"Prevádzkový riaditeľ","person_title_1":"Martin Zavadil","person_title_2":"Radim Horák","person_title_3":"Martin Hájek","press_download":"Stiahnuť Press Kit","press_media":"Pre médiá","press_text":"Stiahnite si firemný Press Kit, ktorý obsahuje logá Dramoxu vo všetkých formátoch.","ua_contact":"Manager","ua_contact_name":"Olia Shylo","company":"Dramox s.r.o.","address":"Bucharova 2928/14a, Stodůlky","ico":"IČO: 09222103","cooperation":"napoveda@dramox.cz","ua_company":"Dramox s.r.o.","ua_address":"Бухарова 2928/14а, Стодолки (Прага 13), 158 00 Прага","ua_ico":"Реєстраційний номер: 09222103","ua_cooperation":"napoveda@dramox.cz"}');

/***/ }),

/***/ 45299:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"may_2022_tag_title":"Zľava 33 % na predplatné | Dramox\\n","may_2022_title":"Zľava 33 % na 5 mesiacov Dramoxu. Zabavte sa s divadlom len za 199 Kč mesačne","may_2022_subtitle":"Nepremeškajte jedinečnú príležitosť sledovať Dramox až 5 mesiacov s výraznou zľavou a ušetriť až 500 Kč. Využite výnimočnú zľavu 33 % z ceny predplatného. Namiesto obvyklých 299 Kč zaplatíte len 199 Kč/mesiac.","may_2022_exclusive":"Ponuka je časovo limitovaná","may_2022_text_mask_1":"Táňa Pauhofová, Ján Koleník, Emília Vášáryová… vďaka Dramoxu si môžete na návštevu k pozvať tie najväčšie herecké hviezdy, ktoré zahrajú len pre vás. Aby sme divadlo a kultúru priblížili k čo najviac ľuďom, máme pre vás predplatné až na 5 mesiacov so zľavou 33%. Sledujte Dramox len za 199 Kč/mesiac a ušetríte tak až 500 Kč oproti bežnému predplatnému.\\n","may_2022_text_mask_2":"👉 Náš tip, ako ušetriť čo najviac: Využite 33% zľavu na ročné predplatné. Ušetríte takmer 1000 Kč\\n","may_2022_text_mask_3":"⏰ Zľava 33 % na predplatné platí od 1. do 31. 5. 2022. Aktivujte si ju hneď teraz. Zľavu nemožno kombinovať s inými zľavami.\\n","may_2022_how_watch_title":"Ako zľavu využiť?\\n","may_2022_how_watch_1":"Prihláste sa do svojho <0>profilu</0> na Dramox.sk. Ak na Dramoxe zatiaľ profil nemáte, vytvorte si novú <1>registráciu</1>.  \\n","may_2022_how_watch_2":"Pri výbere predplatného zadajte do kolónky <0>„Pridať promo kód“</0> tento zľavový kód: <0>DRAMOXKVETEN33</0>","may_2022_how_watch_3":"Teraz máte divadlo online o 33 % lacnejšie až po dobu 5 mesiacov s mesačným predplatným alebo po celých 12 mesiacov, ak ste zvolili ročné predplatné.\\n","may_2022_how_watch_p":"Potrebujete poradiť?","may_2022_how_watch_help":"Napíšte našim milým kolegyniam na <0>napoveda@dramox.cz</0> všetko s vami vyriešia. \\n","may_2022_discount_email":"napoveda@dramox.cz"}');

/***/ }),

/***/ 8585:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"tag_title":"Zľava 50 % na predplatné | Dramox","title":"Zľava 50% na 6 mesiacov Dramoxu. Zabavte sa s divadlom len za 5.95 € mesačne","subtitle":"Nepremeškajte jedinečnú príležitosť sledovať Dramox 6 mesiacov za polovicu. S výnimočnou zľavou ušetríte 50 % z ceny predplatného. Namiesto 11,9 € zaplatíte len 5.95 €. Ponuka platí iba 7 dní. Využiť ju môže ktokoľvek. Aj vy.","exclusive":"Exkluzívne","text_mask_1":"Koleník, Pauhofová, Vášáryová – vďaka Dramoxu si môžete na návštevu pozvať tie najväčšie herecké hviezdy, ktoré zahrajú iba pre vás. Aby sme divadlo a kultúru priblížili čo najviac ľuďom, máme pre vás predplatné za polovicu. Sledujte Dramox až 6 mesiacov len za 5.95 €/mesiac a ušetrite takmer 35.7 € oproti bežnému predplatnému.","text_mask_2":"👉 Náš tip, ako ušetriť čo najviac:  Využite 50 % zľavu na ročné predplatné. Ušetríte tým viac ako 59.5 €.","text_mask_3":"⏰ Zľava 50 % na predplatné platí iba 7 dní od 14. do 20. 4. 2022. Aktivujte si ju hneď teraz. Zľavu nemožno kombinovať s inými zľavami.","how_watch_title":"Ako zľavu využiť?","how_watch_1":"Prihláste sa do svojho <0>profilu</0> na Dramox.sk. Ak na Dramoxe zatiaľ profil nemáte, vytvorte si novú <1>registráciu</1>.","how_watch_2":"Pri výbere predplatného zadajte do kolónky „Pridať promo kód“ tento zľavový kód: <0>DRAMOXZAPOLOVICU</0>","how_watch_3":"Teraz máte divadlo online o 50 % lacnejšie až po dobu 6 mesiacov s mesačným predplatným alebo po celých 12 mesiacov, ak ste zvolili ročné predplatné.","how_watch_p":"Potrebujete poradiť?","how_watch_help":"Napíšte našim milým kolegyniam na <0>napoveda@dramox.cz</0>, všetko s vami vyriešia.","discount_email":"napoveda@dramox.cz"}');

/***/ }),

/***/ 1348:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"toolbar":"🐣 SÚŤAŽ Veľká noc s Dramoxom: Vyhrajte vstupenky do Městských divadel pražských a poukazy na predplatné","title":"Veľká noc s Dramoxom","sign_in":"Prihlásiť sa do súťaže","subtitle_1":"Zabavte sa s divadlom a vyhrajte vstupenky a poukazy na predplatné","subtitle_2":"Oslávte jar ako sa patrí - v spoločnosti rodiny, priateľov a skvelého divadla. Veľkonočnú nádielku vám tento rok namiesto zajačika prinesie Dramox. Od 12. do 18. 4. 2022 sledujte čo najviac divadelných predstavení online a my vás za to odmeníme vstupenkami do Městských divadel pražských a poukazmi na Dramox v hodnote až 1590 CZK. Užite si veselú a divadelnú Veľkú noc.","contest":"Súťaž","price_title":"Čo môžete vyhrať?","price_desc":"Tento rok na Veľkú noc súťažíme o tieto ceny:","price_first":"<1>1. miesto </1> <0/> 2 lístky do divadla <0/>  poukaz na Dramox na 6 mesiacov","price_second":"<1>2. miesto </1> <0/> 2 lístky do divadla <0/>  poukaz na Dramox na 3 mesiace","price_third":"<1>3. miesto </1> <0/> 2 lístky do divadla <0/>  poukaz na Dramox na 1 mesiac","chance_title":"🌷Náš tip: Čím viac predstavení na Dramoxe uvidíte, tým máte väčšiu šancu na výhru.","chance_text":"Príklad: Anna si v utorok 12. 4. pozrela jedno predstavenie, ďalšie si pustila v stredu 13. 4. aj vo štvrtok 14. 4.. V záverečnom žrebovaní bude jej meno celkom 3x a tak má trojnásobnú šancu na výhru.","how_to_title":"Ako súťažiť?","how_to_1":"Zaregistrujte sa vo <0>formulári</0>. Použite e-mail, na ktorý ste registrovaní na Dramoxe","how_to_2":"V období od 12. do 18. 4. 2022 si pozrite čo najviac predstavení na Dramox.sk. Čím viac si ich pustíte, tým viackrát vás zaradíme medzi súťažiacich o prvé tri ceny.","how_to_3":"Na konci súťažného obdobia v utorok 19. 4. 2022 náhodne vyberieme troch z vás, ktorí získajú jednu z vyššie uvedených cien. V hre sú vstupenky do Městských divadel pražských a darčekové poukazy na predplatné Dramoxu.","how_to_4":"O víťazoch súťaže vás budeme informovať e-mailom. Sledujte nás aj na sociálnych sieťach <facebook>Facebook</facebook>, <instagram>Instagram</instagram>, <twitter>Twitter</twitter> a <youtube>YouTube</youtube> - získate tak viac inšpirácie, čo si práve pustiť. Máte chuť na Jedákov čokolády alebo napríklad kávičku s Marišou?","btn_signin":"Prihlásiť sa do súťaže","rules_title":"Zjednodušené pravidlá súťaže Veľká noc s Dramoxom:","rule_1":"Súťaž sa začína 12. 4. 2022 o 0.01 a skončí sa 18. 4. 2022 o 23.59.","rule_2":"Zapojiť sa môže každý divák registrovaný na Dramox.sk, ktorý má aktívne predplatné alebo využíva skúšobné 7-dňové obdobie, a súčasne sa registroval do súťaže Veľká noc s Dramoxom prostredníctvom súťažného formulára.","rule_3":"Víťazi budú vybraní náhodným výberom zo všetkých súťažiacich, ktorí sa v danom období (pozri bod 1) do súťaže zapojili. Víťaza vyhlásime na našich sociálnych sieťach a v newsletteroch.","rule_more":"Kompletné pravidlá súťaže Veľká noc s Dramoxom nájdete <0>tu</0>.","tag_title":"Veľkonočná súťaž | Dramox"}');

/***/ }),

/***/ 20585:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"reset_password_h1":"Nastavte si heslo a ste hotoví.","new_password":"Nové heslo","new_password_again":"Nové heslo znovu","submit":"Potvrdiť","reset_password_placeholder":"Aspoň 8 znakov","reset_password_error":"Platnosť odkazu pre obnovenie hesla už vypršala."}');

/***/ }),

/***/ 88996:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"items":{"1":{"q":"Čo je Dramox?","a":"Dramox je divadlo online. Streamovacia služba, ktorá za mesačné predplatné ponúka najväčší výber divadelných záznamov na jednom mieste. Sledujte svoje obľúbené predstavenia, alebo objavte nové, kedykoľvek a kdekoľvek budete chcieť, a to úplne bez reklám. Pravidelne pridávame nové predstavenia."},"2":{"q":"Čo môžem na Dramoxe sledovať?","a":"Na Dramoxe môžete sledovať záznamy predstavení z desiatok divadiel. V našej knižnici nájdete rokmi overené inscenácie, diela ocenené kritikmi aj čerstvé novinky, ktoré si svojich divákov ešte len hľadajú."},"3":{"q":"Koľko Dramox stojí?","a":"Dramox môžete sledovať za mesačné predplatné {{monthly}}, alebo za veľmi výhodné ročné predplatné {{yearly}}, s ktorým oproti mesačnému ušetríte takmer {{yearlyDiscount}}. Polovicu z každého predplatného venujeme divadlám, tvorcom a hercom. Nemáme žiadne skryté poplatky ani dlhodobé zmluvy."},"4":{"q":"Koľko predstavení môžem vidieť?","a":"Koľko len chcete. Počet sledovaní nie je obmedzený. Je len na vás, či budete sledovať desiatky predstavení alebo jedno stále dookola. Proti gustu...."},"5":{"q":"Ako môžem predplatné zrušiť?","a":"Jednoducho. Nemáme žiadne dlhodobé zmluvy ani storno poplatky. Prihláste sa do svojho profilu na Dramoxe. V pravom hornom rohu kliknite na červený krúžok a zvoľte „Môj profil\\". Otvorí sa vám stránka vášho profilu, kde zvolíte možnosť „Zrušiť predplatné\\". Ďalšie predplatné sa vám už neobnoví. Dramox môžete sledovať do konca aktuálneho zaplateného predplatného."}}}');

/***/ }),

/***/ 25889:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Časté otázky","know_more":"Nenašli ste, čo ste hľadali? Napíšte nám, prosím, na","items":{"1":{"q":"Čo je Dramox?","a":"Dramox je divadlo online. Streamovacia služba, ktorá za mesačné predplatné ponúka najväčší výber divadelných záznamov na jednom mieste.\\n\\nSledujte svoje obľúbené predstavenia, alebo objavte nové, kedykoľvek a kdekoľvek budete chcieť, a to úplne bez reklám. Pravidelne pridávame nové predstavenia."},"2":{"q":"Čo môžem na Dramoxe sledovať?","a":"Na Dramoxe môžete sledovať záznamy predstavení z desiatok divadiel. V našej knižnici nájdete rokmi overené inscenácie, diela ocenené kritikmi aj čerstvé novinky, ktoré si svojich divákov ešte len hľadajú."},"3":{"q":"Koľko predstavení môžem vidieť?","a":"Koľko len chcete. Počet sledovaní nie je obmedzený. Je len na vás, či budete sledovať desiatky predstavení alebo jedno stále dookola. Proti gustu...."},"4":{"q":"Ako môžem divadlo sledovať?","a":"Na prehrávanie záznamov potrebujete webový prehliadač a internetové pripojenie. Stačí sa len zaregistrovať na Dramoxe a následne si môžete užiť divadlo online kdekoľvek a kedykoľvek budete chcieť. Pre väčší komfort si stiahnite mobilnú alebo televíznu aplikáciu. Využiť môžete aj bezdrôtový prenos obrazu a zvuku prostredníctvom Chromecast a AirPlay."},"5":{"q":"Koľko Dramox stojí?","a":"Dramox môžete sledovať za mesačné predplatné {{monthly}} alebo za veľmi výhodné ročné predplatné {{yearly}}, s ktorým oproti mesačnému ušetríte takmer {{yearlyDiscount}}. Polovicu z každého predplatného venujeme divadlám, tvorcom a hercom. Nemáme žiadne skryté poplatky ani dlhodobé zmluvy."},"6":{"q":"Kde všade je Dramox dostupný?","a":"S Dramoxom sa môžete zabaviť kdekoľvek na svete. Máme pre vás najväčšiu ponuku divadelných predstavení, či sa práve opaľujete na pláži v Karibiku, alebo lyžujete v Alpách. Užite si divadlo online bez hraníc. Napriek tomu, že sa snažíme vyjednávať licencie do celého sveta, niektoré predstavenia nemusia byť vo vašej krajine dostupné. "},"7":{"q":"Sú na Dramoxe reklamy?","a":"Nie sú, a ani to neplánujeme."},"8":{"q":"Ako môžem predplatné zrušiť?","a":"Jednoducho. Nemáme žiadne dlhodobé zmluvy ani storno poplatky. Prihláste sa do svojho profilu na Dramoxe. V pravom hornom rohu kliknite na červený krúžok a zvoľte „Môj profil\\". Otvorí sa vám stránka vášho profilu, kde zvolíte možnosť „Zrušiť predplatné\\". Ďalšie predplatné sa vám už neobnoví. Dramox môžete sledovať do konca aktuálneho zaplateného predplatného."},"9":{"q":"Ako si môžem predplatné opäť aktivovať?","a":"Prihláste sa do svojho profilu na Dramoxe. V prvom hornom rohu kliknite na červený krúžok a zvoľte „Môj profil\\". Otvorí sa vám stránka vášho profilu, kde zvolíte „Kúpiť predplatné\\"."},"10":{"q":"Ako sledovať Dramox na smart televízore bez aplikácie?","a":"Náš prehrávač podporuje bezdrôtový prenos obrazu a zvuku prostredníctvom Chromecast a AirPlay. Ak váš televízor podporuje tieto technológie, predstavenia na Dramoxe si možete veľmi jednoducho premietnuť z mobilného telefónu do televízora. Vo svojom mobile spusťte vybrané predstavenie, v pravom dolnom rohu sa objaví ikonka monitoru. Po kliknutí na ňu sa vám zobrazí ponuka televízorov, ktoré sú pripojené k rovnakej wi-fi sieti a podporujú technológie Chromecast a AirPlay. Vyberte váš televízor a o niekoľko sekúnd sa predstavenie začne prehrávať na televíznej obrazovke. Ovládať ho môžete priamo z telefónu."},"11":{"q":"Máte Dramox aplikáciu pre smart televízory?","a":"Áno, aktuálne máme aplikáciu pre smart televízory Samsung a LG. Viac informácií, ako si televíznu aplikáciu Dramox nainštalovať, nájdete na stránke <linkSmartTvGuide>Smart televízory</linkSmartTvGuide>. Už čoskoro sa pustíme do vývoja aplikácií aj pre ostatné televízory."},"12":{"q":"Je Dramox dostupný aj v smart telefóne?","a":"Áno, je. Stiahnite si mobilnú aplikáciu Dramox pre maximálny komfort pri sledovaní divadla online. Aplikáciu pre iOS stiahnete v <linkAppStore>App Store</linkAppStore>, aplikáciu pre Android nájdete na <linkGooglePlay>Google Play</linkGooglePlay>."},"13":{"q":"Aké divadla nájdem na Dramoxe?","a":"Všetky spolupracujúce divadlá uvádzame na stránke <linkAboutUs>O projekte</linkAboutUs>."},"14":{"q":"Ako funguje skúšobné obdobie?","a":"Vyskúšajte divadlo online ZDARMA na 7 dní. Stačí sa len zaregistrovať. Pokiaľ budete s Dramoxom spokojní, nemusíte robiť nič, predplatné sa vám aktivuje automaticky. Ak sa rozhodnete pred koncom skúšobnej doby predplatné ukončiť, nebudeme vám nič účtovať. Už aktívne predplatné zrušíte veľmi jednoducho - stačí pár kliknutí vo vašom profile. Bez sankcií a ďalších záväzkov.","no_trial_q":" Ako Dramox funguje?\\n","no_trial_a":"Ak sa rozhodnete predplatné zrušiť pred jeho vypršaním, nebudú vám účtované žiadne poplatky. Aktívne predplatné môžete jednoducho zrušiť vo svojom účte. "},"15":{"q":"Ako môžem divadlo podporiť?","a":"Najjednoduchšie tým, že budete Dramox aktívne využívať a sledovať záznamy divadelných predstavení. Polovicu z každého predplatného venujeme divadlám, tvorcom a hercom. Svojim obľúbeným tvorcom môžete venovať navyše aj ľubovoľnú čiastku. Odovzdáme im takmer celý darovaný obnos. Pre seba si nenechávame nič, len zaplatíme platobnej bráne za poskytnutie technológie pre bezpečnú platbu."},"16":{"q":"Na koľkých zariadeniach môžem sledovať Dramox?","a":"Na sledovanie Dramoxu môžete použiť toľko zariadení, koľko chcete, nie však naraz na jednom účte. To znamená, že pokiaľ si chcete Dramox pustiť na telefóne a v rovnaký čas zároveň aj na počítači, potrebujte dva oddelené účty. Pokiaľ ale doma sledujete Dramox na notebooku a cestou do práce si v električke pustíte predstavenie na tablete, stačí vám len jeden účet."},"17":{"q":"Môžem predplatné na Dramox kúpiť ako darčekový poukaz?","a":"Divadlo online ako darček? Skvelý nápad! V ponuke máme predplatné na Dramox na 1 mesiac, 3 mesiace, 6 mesiacov alebo celý rok. Poukaz môžete použiť 1 rok odo dňa zakúpenia. Jeho platnosť sa začína v okamihu, ako ho aktivujete. Viac o darčekových poukazoch nájdete na stránke  <linkVouchers>Darčekové poukazy</linkVouchers>."},"18":{"q":"Ako mám uplatniť poukaz, keď už mám predplatné?","a":"Prihláste sa do svojho profilu na Dramoxe. V pravom hornom rohu kliknite na červený krúžok a vyberte „Môj profil“. Otvorí sa stránka vášho profilu, kde zvolíte „Zrušiť predplatné“. Len čo sa skončí obdobie vášho aktuálneho predplatného, vyzveme vás, aby ste pre ďalšie využívanie služby uhradili nové predplatné. Vo svojom profile si pri výbere predplatného zvolíte možnosť „Mám darčekový poukaz“ a zadáte svoj jedinečný kód z poukazu."},"19":{"q":"Ako odporučiť Dramox priateľom a získať predplatné až na 5 mesiacov zadarmo.","a":"<p>Užívate si zážitky s Dramoxom a poznáte niekoho, komu by sa online divadlo páčilo tiež? Odporučte nás a získajte až 5 mesiacov Dramoxu zadarmo. Táto ponuka platí pre všetkých registrovaných na <linkDramox>Dramox.tv</linkDramox> s aktívnym alebo neaktívnym predplatným, s použitím kreditnej karty alebo kupónu.</p> <p> Jednoducho sa prihláste do svojho Dramox účtu, prejdite na ikonku v pravom hornom rohu (červený kruh) a kliknite na \\"pozvať priateľov\\". Získate tak promo kód pre priateľov, ktorý sa dá použiť až 5-krát. Pozvite svojich kamarátov a získajte až 5 mesiacov predplatného zadarmo v hodnote viac ako 55 €. Vždy, keď si niekto z vašich priateľov vytvorí účet s použitím vášho promo kódu, obaja získate jeden mesiac Dramoxu zadarmo.</p> <p>Nemáte ešte Dramox účet? Zaregistrujte sa <linkRegister>tu</linkRegister> a vyberte si vami preferované predplatné, ktoré sa začne 7-dňovou bezplatnou skúšobnou dobou. Po jej skončení môžete používať promo kód pre priateľov a získať tak až 5 mesiacov online divadla bezplatne.</p>","no_trial_a":"Obľúbili ste si Dramox a poznáte niekoho, kto by si divadlo online obľúbil tiež? Odporučte nás a získajte až 5 mesiacov predplatného zdarma. Túto ponuku môže využiť každý registrovaný na <linkDramox>Dramox.tv</linkDramox> s aktívnym alebo neaktívnym predplatným a to pomocou kreditnej karty alebo voucheru. Stačí sa prihlásiť do svojho účtu na Dramoxe, kliknúť na červenú ikonu vpravo hore a v ponuke vybrať „Pozvať priateľov“. Následne sa vám zobrazí váš vlastný promo kód, ktorý môžete použiť až päťkrát. Pozvite svojich priateľov, aby vyskúšali našu divadelnú streamovaciu platformu a získajte až 5 mesiacov predplatného zdarma. Za každého, kto sa zaregistruje na Dramoxe cez váš promo kód, vám automaticky pridáme 1 mesiac predplatného zdarma. Priatelia, ktorí si aktivujú predplatné Dramoxu, tiež získajú 1 mesiac predplatného zdarma. Stále nemáte účet na Dramoxe? Zaregistrujte sa  <linkRegister>zde</linkRegister> a vyberte si svoj plán predplatného.\\n"}}}');

/***/ }),

/***/ 5111:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Zabudli ste svoje heslo? Nevadí, pomôžeme vám.","email":"E-mail","email_placeholder":"Zadajte e-mailovú adresu","btn":"Obnoviť heslo","server_error":"E-mail neexistuje.","changes_not_saved":"Obnovenie hesla bolo neúspešné. Prosím, skúste to neskôr.","changes_saved":"Odkaz na obnovenie hesla sme odoslali na Váš e-mail."}');

/***/ }),

/***/ 56845:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Sledujte Dramox doma i na cestách.","web":{"title":"Počítače a notebooky","supported_browsers":"Podporované prehliadače","subtitle":"Webový portál Dramox","content":"Podporujeme väčšinu bežných prehliadačov dostupných na operačných systémoch Windows, Linux a macOS.","button":"Začať sledovať"},"smart_tv":{"title":"Smart televízory","samsung_title":"Televízna aplikácia pre Samsung","samsung_description":"Aplikácia Dramox pre modely 2018 a novšie s operačným systémom Tizen 4.0 a vyšším","lg_title":"Televízna aplikácia pre LG","lg_description":"Aplikácia Dramox pre modely 2016 a novšie s operačným systémom WebOS 3.0 a vyšším","button":"Návod na inštaláciu"},"mobile":{"title":"Smart telefóny a tablety","android_title":"Mobilná aplikácia pre Android","android_description":"Podporujeme mobilné telefóny a tablety s operačným systémom Android 5.1.1 a vyšším.","ios_title":"Mobilná aplikácia pre iOS.","ios_description":"Podporujeme mobilné telefóny a tablety s operačným systémom iOS 11 a vyšším.","button":"Návod na inštaláciu"},"streaming":{"title":"Chromecast\\na AirPlay","airplay_title":"Apple AirPlay","airplay_description":"Preneste divadelné predstavenie do svojho televízora vďaka technológii AirPlay od Apple.","chromecast_title":"Google Chromecast","chromecast_description":"Preneste divadelné predstavenie do svojho televízora vďaka technológii Chromecast od Google.","button":"Ako to funguje"}}');

/***/ }),

/***/ 88013:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Pozvite priateľov a získajte až 5 mesiacov Dramoxu zdarma","code_for_friend":"Promo kód pre vašich priateľov (1 kód môžete poslať až 5 priateľom)","copy_code":"Skopírovať kód","what_to_do":"Čo musia moji priatelia urobiť?","step_1":"Vytvoria si nový účet na Dramoxe.","step_2":"Pri výbere svojho predplatného zadajú promo kód: <0>{{promoCode}}</0>","step_3":"Aktivujú si predplatné aspoň na 1 mesiac zadaním údajov z platobnej karty.","step_4":"Po ich prvej platbe za predplatné získate vy aj váš priateľ 1 mesiac Dramoxu zdarma.","invited_friends":"Pozvať priateľov","invite_benefit":"Pozvite priateľov a získajte zdarma až 5 mesiacov s Dramoxom. Priatelia, ktorí si aktivujú predplatné Dramoxu, získajú tiež 1 mesiac zdarma.","title_not_allowed":"Pozvanie priateľov je dostupné iba používateľom s predplatným","buy_subscription":"Kúpiť predplatné","more_1":"Viac informácií o predplatnom získate v sekcii","more_2":"Chcete vedieť viac? Všetko o tom, ako pozvať priateľov na Dramox a získať tak predplatné zdarma, nájdete v Častých otázkach.","code_copied":"Kód bol skopírovaný.","description_not_allowed":"Pozvať priateľov môže iba užívateľ, ktorý má alebo mal predplatné Dramoxu, prípadne využil darčekový poukaz. Ešte ste si Dramox nepredplatili? Kúpte si predplatné teraz, odporučte Dramox priateľom a získajte až 5 mesiacov divadla online zadarmo. Ak sa práve nachádzate v skúšobnom období zdarma, musíte počkať kým neprebehne prvá platba.","no_trial_description_not_allowed":"Túto ponuku môže využiť každý registrovaný na <linkDramox>Dramox.sk</linkDramox> s aktívnym alebo neaktívnym predplatným, s použitím kreditnej karty alebo voucheru. Stále nemáte účet na Dramoxe? Zaregistrujte sa  <linkRegister>zde</linkRegister> a vyberte si svoje predplatné.\\n"}');

/***/ }),

/***/ 16520:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"login":"Prihlásenie","not_register_yet":"Nemáte účet?","try_trial":"Vyskúšajte na 7 dní ZDARMA","email":"E-mail","password":"Heslo","forgotten_password":"Zabudli ste heslo?","login_btn":"Prihlásiť","not_activated":"Mrzí nás to, ale Váš účet ešte nebol aktivovaný. V prípade, že je Váš účet už aktívny, prosím, kontaktujte nás.","no_trial_try_trial":"Začnite svoje dobrodružstvá s Dramoxom.\\n"}');

/***/ }),

/***/ 64996:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"android_title":"Mobilná aplikácia pre Android","android_description":"Dostupná pre mobilné telefóny a tablety s operačným systémom Android 5.1.1 a vyšším. Potrebujete poradiť? Napíšte nám, prosím, na <a href=\\"mailto:napoveda@dramox.cz\\">napoveda@dramox.cz</a>.","android_instalation":"Inštalácia mobilnej aplikácie Dramox","android_step_1":"<a href=\\"https://play.google.com/store/apps/details?id=cz.dramox.dramox\\" target=\\"_blank\\">Pre stiahnutie aplikácie kliknite na tento odkaz</a>, alebo v mobilnom telefóne otvorte obchod s aplikáciami Google Play a zadajte do vyhľadávania Dramox.","android_step_2":"Aplikáciu nainštalujte kliknutím na tlačítko <strong>Inštalovať</strong>.","android_step_3":"Otvorte novonainštalovanú aplikáciu Dramox.","android_step_4":"Po spustení aplikácie sa prihláste pomocou e-mailu a hesla, ktoré používate na prihlásenie sa do svojho účtu na Dramoxe.","android_step_5":"Ste spokojní s aplikáciou Dramox? Prosím, ohodnoťte ju v obchode s aplikáciami Google Play.","ios_title":"Mobilná aplikácia pre iOS.","ios_description":"Dostupná pre mobilné telefóny a tablety s operačným systémom iOS 11 a vyšším. Potrebujete poradiť? Napíšte nám, prosím, na <a href=\\"mailto:napoveda@dramox.cz\\">napoveda@dramox.cz</a>.","ios_instalation":"Inštalácia mobilnej aplikácie Dramox","ios_step_1":"<a href=\\"https://apps.apple.com/cz/app/dramox-divadlo-online/id1563430137?l=cs\\" target=\\"_blank\\">Pre stiahnutie aplikácie kliknite na tento odkaz</a>, alebo v mobilnom telefóne otvorte obchod s aplikáciami App Store a zadajte do vyhľadávania Dramox.","ios_step_2":"Aplikáciu nainštalujte kliknutím na tlačítko <strong>Získať</strong>.","ios_step_3":"Otvorte novonainštalovanú aplikáciu Dramox.","ios_step_4":"Po spustení aplikácie sa prihláste pomocou e-mailu a hesla, ktoré používate na prihlásenie sa do svojho účtu na Dramoxe.","ios_step_5":"Ste spokojní s aplikáciou Dramox? Prosím, ohodnoťte ju v obchode s aplikáciami  App Store."}');

/***/ }),

/***/ 2779:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"premiere":"Premiéra","trailer":"Upútavka","support":"Podporiť","genres":"Žánre","awards":"Získané ocenenia","same_cast":"Rovnakí účinkujúci","similar_genre":"Žánrovo podobné","theatre_more":"Viac od tohto divadla","show_all":"Zobraziť všetko","cast":"Herecké obsadenie","donate_bubble_title":"Páčilo sa vám predstavenie?","donate_bubble_link":"Podporte divadlo","playback_error_title":"Video sa momentálne nedá prehrať.","playback_error_content":"Mrzí nás to, ale požadované predstavenie nejde prehrať. Prosím, skontrolujte vaše internetové pripojenie a skúste to opäť neskôr.","playback_error_action":"Späť na detail predstavenia","low_quality":"Inscenácia so zníženou kvalitou záznamu.","support_theater":"Podporte online divadlo","watch_list":"Môj zoznam","on_watch_list":"Na zozname","added_to_watch_list":"Pridané na zoznam","removed_from_watch_list":"Odobrané zo zoznamu"}');

/***/ }),

/***/ 830:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"auto_quality":"Automaticky","back":"Späť","captions":"Titulky","cast_to_other_devices":"Chromecast","enter_picture_in_picture":"Zapnúť mini prehrávač","exit_fullscreen":"Vypnúť režim celej obrazovky","exit_picture_in_picture":"Vypnúť mini prehrávač","fullscreen":"Režim celej obrazovky","language":"Jazyk","live":"Žive","more_settings":"Dalšie nastavenia","multiple_languages":"Viac jazykov","mute":"Vypnúť zvuk","not_applicable":"Nie je možné aplikovat","off":"Vypnuté","on":"Zapnuté","pause":"Pozastaviť","picture_in_picture":"Mini prehrávač","play":"Spustiť","resolution":"Kvalita","seek":"Posunúť","undetermined_language":"Neznámy jazyk","unmute":"Zapnúť zvuk","volume":"Hlasitosť"}');

/***/ }),

/***/ 64260:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"activate_subscription_title":"Aktivujte si predplatné","activate_subcription_content":"A získajte prístup k desiatkam legálnych divadelných záznamov pre online sledovanie!","activate_subscription_button":"Vybrať predplatné","login_title":"Prihlásenie","login_content":"Prehrávať divadelné hry môžu len prihlásení používatelia s aktívnym predplatným.","login_action":"Prihlásiť","login_footer":"Nemáte účet? <0>Zaregistrujte sa</0>","low_quality_title":"Znížená kvalita záznamu","low_quality_text":"Ospravedlňte, prosím, zniženú kvalitu záznamu. Tento záznam je jediný a najlepší, ktorý máme k dispozícii. Inscenácia nás však zaujala natoľko, že by bola škoda vám ju nepredstaviť na Dramoxe. Preto sme sa rozhodli ju uviesť aj napriek nižšej kvalite záznamu. Prajeme vám príjemné divadelné zážitky.","low_quality_btn":"Rozumiem"}');

/***/ }),

/***/ 63363:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"my_profile":"Môj profil","subscription":"Predplatné","subscription_unlimited":"Momentálne využívate neobmedzené predplatné.","unlimited_description":"Užite si sledovanie na Dramoxe!","monthly":"Mesačné","yearly":"Ročné","price_with_vat":"{{price}} s DPH","voucher":"Mám darčekový poukaz.","subscription_none":"Kúpte mesačné alebo ročné predplatné na Dramox","subscription_none_text":"A získajte prístup k desiatkam legálnych divadelných záznamov pre online sledovanie!","personal_details":"Osobné údaje","full_name":"Meno a priezvisko","save_changes":"Uložiť zmeny","password_change":"Zmena hesla","password_change_success":"Heslo sa zmenilo.","password_change_fail":"Heslo sa nepodarilo zmeniť.","account_delete_success":"Účet bol zmazaný.","actual_password":"Aktuálne heslo","new_password":"Nové heslo","new_password_again":"Nové heslo znovu","purchase_history":"História objednávok","delete_account":"Zmazať účet","delete_account_text":"Zmazaním účtu zanikne aktívne predplatné a vymažú sa všetky dáta na serveri Dramox.","theatre_donate":"Príspevok pre divadlo","subscription_bundles":"Predplatné","voucher_pay":"Darčekový poukaz","empty_purchase":"Pri prvej platbe za predplatné alebo príspevok pre divadlo uvidíte v tejto sekcii históriu platieb.","recurrence_monthly":"Aktuálne využívate mesačné predplatné.","recurrence_quarterly":"Aktuálne využívate 3-mesačné predplatné.","recurrence_semi_annual":"Aktuálne využívate polročné predplatné.","recurrence_yearly":"Aktuálne využívate ročné predplatné.","subscription_expired_trial":"Skúšobné obdobie sa Vám skončí {{date}}. V ten istý deň dôjde k zakúpeniu predplatného.","subscription_expired":"Predplatné sa automaticky obnoví {{date}}","delete_account_title":"Vymazanie účtu","delete_popup_close":"Zavrieť","delete_account_submit":"Zmazať celý účet","delete_subscription_title":"Zrušenie predplatného","delete_subscription_text":"Existujúce predplatné Vám zostane až do jeho expirácie. Potom ho automaticky zrušíme.","cancel_subscription":"Zrušiť predplatné","choose_card":"Zvoliť kartu","choose_card_text":"Naozaj chcete použiť kartu aj na všetky budúce platby?","btn_submit":"Potvrdiť","remove_card":"Odstrániť kartu","remove_card_text":"Naozaj chcete odstrániť platobnú kartu zo svojho účtu?","card_primary":"hlavná","card_choose":"Vybrať","card_no_added":"Nebola pridaná žiadna karta.","subscription_end_description":"Vaše predplatné sa automaticky skončí {{date}}.","profile_changes_not_saved":"Zmeny sa nepodarilo uložiť. Prosím, zopakujte to neskôr.","profile_changes_saved":"Zmeny sa uložili.","card_added":"Platobná karta bola pridaná.","card_added_error":"Vaša karta bola zamietnutá. Prosím, skontrolujte správnosť zadaných údajov a platnosť karty.","load_more":"Načítať viac","subscription_canceled_success":"Predplatné je odteraz zrušené!","subscription_canceled_fail":"Zrušenie predplatného zlyhalo.","payment_card_delete_success":"Platobná karta bolo odobraná.","payment_card_delete_fail":"Odobranie platobnej karty zlyhalo.","change_payment_card_primary_success":"Primárna karta bola nastavená.","change_payment_card_primary_fail":"Nastavenie primárnej karty zlyhalo. ","email_newsletter":"E-mailový newsletter","email_newsletter_text":"Želáte si dostávať e-mailom newsletter o novinkách na Dramoxe?","email_newsletter_action_subscribe":"Chcem odoberať novinky","email_newsletter_action_unsubscribe":"Deaktivovať","email_newsletter_success_title":"Ďakujeme za prihlásenie sa k odberu noviniek.","email_newsletter_success_description":"Toto okno už môžete zatvoriť.","residency_tooltip":"Ak žijete v inej krajine, prosím, kontaktujte náš zákaznícky servis.","language_select":"Výber jazyka","grace_period_title":"Predplatné sa nepodarilo automaticky predĺžiť","grace_period_description":"Skontrolujte, prosím, svoje platobné údaje a zostatok na karte. Do {{date}} sa budeme raz denne pokúšať predplatné automaticky predĺžiť. Potom služba prestane byť dostupná a predplatné sa zruší.","grace_period_action":"Zaplatiť teraz - {{price}}","delete_subscription_grace_text":"Predplatné bude zrušené","ui_language":"Jazyk webovej stránky","prolonged_subscription":"Predĺžili sme vám predplatné.","remove_sub_promo_title":"Je nám ľuto, že chcete odísť","remove_sub_promo_text":"Pozvite priateľov získajte Dramox až na 5 mesiacov zdarma","remove_sub_get_more":"Zistiť viac","remove_sub_or":"alebo","remove_sub_removing":"Predplatné zrušte. Aktuálny plán Vám bude ponechaný až kým nevyprší. Potom bude automaticky zrušený.","sub_from_campaign":"Momentálně využíváte období zdarma z promo akce.","sub_from_user":"Momentálně využíváte období zdarma od Vašich přátel.","discount_info":"Do {{date}} využíváte slevu {{discount}}% na zakoupené předplatné.","promo_discount_title":"<0>{{discount}}%</0>zľava {{timespan}}","promo_discount_content":"Po aktivácii získate {{discount}}% zľavu {{timespan}} na vašom predplatnom.","promo_free_title":"<0>{{timespan}}</0> predplatné zadarmo","promo_free_content":"Po aktivácii získate {{timespan}} zadarmo k vášmu terajšiemu predplatnému.","promo_action":"Aktivovať zľavu","promo_activation_success":"Promo kód bol aktivovaný.","promo_activation_fail":"Nepodarilo sa aktivovať promo kód.","no_trial_subscription_expired_trial":"Vaše predplatné automaticky predĺžime {{date}}.\\n","promo_code_heading":"Zadajte voucher alebo promo kód","promo_code_input_placeholder":"Zadajte kód","promo_code_button_enter":"Zadajte kód","promo_code_button_activate":"Aktivovať"}');

/***/ }),

/***/ 50370:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Stovky legálnych divadelných záznamov dostupných online","description":"<0>Prvých 7 dní máte <1>ZDARMA</1>. Predplatné môžete kedykoľvek zrušiť.</0>","full_name":"Meno a priezvisko","email":"E-mail","btn_continue":"Pokračovať","register_terms":"<0>Kliknutím na tlačítko „Pokračovať“ súhlasíte s <1>Obchodnými podmienkami</1> a <2>Ochranou súkromia</2>.</0>","already_account":"Už máte účet?","login_prompt":"Prihláste sa","setup_password":"Hurá, blížite sa do cieľa. Teraz si, prosím, nastavte heslo.","password_placeholder":"Aspoň 8 znakov","password":"Heslo","password_again":"Heslo znovu","changes_not_saved":"Požiadavku sa nepodarilo spracovať. Prosím, zopakujte to neskôr.","changes_saved":"Zmeny sa uložili.","confirm_email_title":"Prosím, skontrolujte svoju e-mailovú schránku.","confirm_email_text":"<0>Na adresu <1>{{email}}</1> sme Vám odoslali e-mail s odkazom na aktiváciu Vášho účtu.</0>","country_of_residence":"Krajina pobytu","no_trial_description":"<0>Predplatné môžete kedykoľvek zrušiť. </0>\\n"}');

/***/ }),

/***/ 27786:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"forschools_bottom_desc":"Predplaťte si divadlo online len za polovičnú cenu {{studentMonthly}} na mesiac pre jedného študenta.","forschools_button":"Objednať Dramox pre školu","forschools_description":"Dramox pre školy vám ponúka možnosť zatraktívniť vyučovanie. Študenti objavia krásy divadla a literatúry spôsobom, na ktorý sú zvyknutí - sledovaním videa online. Zabavia sa aj pri vypĺňaní pracovných listov, ktoré sa im prihovárajú ich jazykom - prostredníctvom emotikonov, FB príspevkov, obrázkov...","forschools_footer":"Dramox pre školy","forschools_for_class_desc_1":"Napíšte nám, prosím, na <0>skoly@dramox.cz</0>.","forschools_for_class_desc_2_1":"Čo najskôr sa vám ozveme. Spoločne potom doriešime podrobnosti a dohodneme sa, koľko poukazov si ako škola alebo trieda objednáte.","forschools_for_class_desc_2_2":"Dôležité: Každý študent potrebuje svoj vlastný poukaz s jedinečným kódom. Bohužiaľ, nemôžete si ako škola objednať len jeden, ktorý bude používať viac ľudí naraz.","forschools_for_class_desc_3":"Škola zaplatí poukazy.","forschools_for_class_desc_4":"Po potvrdení platby vám poukazy obratom odošleme elektronicky.","forschools_for_class_desc_5":"Poukazy rozdáte svojim študentom, ktorí sa zaregistrujú na Dramoxe a môžu začať sledovať divadlo online. Mesiac, tri alebo aj celý rok, podľa dĺžky predplatného.","forschools_for_class_title":"Ako objednať divadlo online pre svoju triedu alebo školu?","forschools_for_who_desc_1":"Pre stredné školy a gymnáziá, vyššie odborné a vysoké školy, prípadne posledné ročníky základných škôl (žiaci 8. a 9. tried).","forschools_for_who_desc_2":"Pokiaľ nepatríte k týmto inštitúciám, ale zaoberáte sa vzdelávaním a radi by ste túto ponuku využili, napíšte nám, prosím, na <0>skoly@dramox.cz</0>. Niečo vymyslíme.","forschools_for_who_title":"Pre koho je táto ponuka","forschools_obligatory":"V ponuke máme desiatky príbehov z <0>odporúčanej literatúry</0>, vďaka ktorým sa študenti naučia, koho milovala Maryša, kto bol Raskoľnikov i to, ako to nakoniec dopadlo s Faustom. Ďalšie inscenácie neustále pribúdajú. Okrem odporúčanej literatúry môžu študenti vidieť desiatky ďalších divadelných záznamov. Pokojne s popcornom a v teplákoch.","forschools_price":"{{studentMonthly}}","forschools_price_desc":"mesačne / pre jedného študenta","forschools_student_price_desc":"Cena mesačného predplatného je {{studentMonthly}} pre jedného študenta. To je {{studentMonthlyPercentageDiscount}} % ceny oproti bežnému predplatnému za {{monthly}}.","forschools_student_price_title":"Aká je zvýhodnená cena pre študentov?","forschools_title":"Dramox pre školy"}');

/***/ }),

/***/ 96704:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"welcome_title":"Dramox | Vaše divadlo online","welcome_description":"Vyskúšajte Dramox na 7 dní ZDARMA a sledujte online stovky divadelných predstavení.","browse_title":"Stovky divadelných predstavení online | Dramox","browse_description":"Vyberte si na Dramoxe zo stoviek divadelných predstavení online. Ponúkame to najlepšie z desiatok divadiel. Vyskúšajte ZDARMA.","celebrity_title":"{{name}} | Divadlo online | Dramox","performance_title":"{{title}} | {{theatre}} online | Dramox","watch_performance_title":"{{title}} – pozrieť online | {{theatre}} | Dramox","theatres_title":"Vaše obľúbené divadlá online | Dramox","theatres_description":"Sledujte na Dramoxe záznamy stoviek divadelných predstavení zo slovenských i zahraničných divadiel. Vyskúšajte ZDARMA. Nájdite si svoje obľúbené divadlo online.","theatre_title":"{{name}} | Divadlo online | Dramox","404_title":"Dramox divadlo online | Hľadá sa stránka","404_description":"Bohužiaľ, táto stránka na Dramoxe nie je. Skúsite si namiesto nej vybrať zo stoviek predstavení online?","about_us_title":"Dramox divadlo online | Zoznámte sa s nami","about_us_description":"Dramox ponúka online stovky divadelných predstavení. Vyskúšajte ZDARMA. S 50% zľavou máme Dramox pre školy na podporu online výučby.","authorship_title":"Dramox divadlo online | Chránime autorské práva","authorship_description":"Dramox divadlom online podporuje divadelnú kultúru. Robíme všetko pre to, aby sme každému tvorcovi zaistili spravodlivý podiel z diela. Všetky naše záznamy sú legálne.","choose_plan_title":"Dramox | Divadlo online na mesiac, tri alebo celý rok?","choose_plan_description":"Vyberte si svoje predplatné","contact_title":"Dramox divadlo online | Napíšte nám","contact_description":"Máte otázky k Dramoxu a divadelným predstaveniam online? E-mailom na adresu napoveda@dramox.cz kontaktujte, prosím, naše milé zákaznícke centrum. Všetko s vami vyriešia.","cookies_title":"Dramox divadlo online | Pre lepší divácky zážitok","cookies_description":"Divadlo online Dramox používa cookies, malých pomocníkov pre dokonalý divácky zážitok. Vyskúšajte ZDARMA, vyberte si zo stoviek divadelných predstavení.\\n","donate_home_title":"Podporte divadlá","donate_title":"Dramox | Podporte {{theatre}} online","donate_description":"Prispejte na Dramoxe online na svoje obľúbené divadlo, podporíte tak jeho tvorbu a divadelnú kultúru. Divadlu odovzdáme takmer celý darovaný obnos. Pre seba si nenechávame nič, len zaplatíme platobnej bráne za poskytnutie technológie pre bezpečnú platbu. ","for_schools_title":"Divadlo online pre školy | Dramox","for_schools_description":"Objednajte si Dramox pre školu so zľavou 50%. Ponúkame desiatky príbehov z odporúčanej literatúry, ktoré môžete vidieť online. ZDARMA získate pracovné listy pre ešte zábavnejšie online vyučovanie.","forgotten_password_title":"Dramox divadlo online | Zabudnuté heslo","forgotten_password_description":"Už o chvíľu môžete na Dramoxe opäť sledovať divadlo online. Pre nové heslo zadajte, prosím, svoj e-mail.","frequently_asked_questions_title":"Dramox | Nápoveda","frequently_asked_questions_description":"Dramox je divadlo online. Stovky predstavení na jednom mieste si môžete vyskúšať ZDARMA. Zaujíma vás viac? Prosím, nahliadnite do častých otázok a odpovedí.\\n","vouchers_buy_title":"Darujte divadlo online | Dramox","vouchers_buy_description":"Poukaz do online divadla Dramox poteší každého. Darujte prístup k stovkám divadelných predstavení a zábave online. Kúpte hneď, darujte hocikedy.","login_title":"Dramox divadlo online | Prihlásenie diváka\\n","login_description":"Za okamih môžete sledovať divadlo online na Dramoxe. Prihláste sa, prosím, svojím e-mailom a heslom, ktoré ste si zvolili pri registrácii.","playlist_performance_similar_genre_title":"{{performance}} – Váš obľúbený divadelný žáner online | Dramox","playlist_performance_similar_genre_description":"Na Dramoxe nájdete svoj obľúbený žáner v divadelnom predstavení {{performance}} online. Činohra, muzikál, balet i bábky – nové záznamy pridávame pravidelne. Sledujte už dnes.","playlist_performance_similar_cast_title":"{{performance}} – Vaši obľúbení herci online | Dramox","playlist_performance_similar_cast_description":"Na Dramoxe nájdete svojich obľúbených hercov v divadelnom predstavení {{performance}} online. Vyskúšajte ZDARMA. Sledujte už dnes.","playlist_genre_title":"Online divadelné predstavenie v žánri {{genre}} | Dramox","playlist_genre_description":"Užite si na Dramoxe svoj obľúbený žáner divadelných predstavení online. Činohra, muzikál, balet i bábky – nové záznamy pridávame pravidelne. Vyskúšajte ZDARMA.","playlist_featured_title":"Divadelné predstavenie online z kategórie {{section}} | Dramox","playlist_featured_description":"Na Dramoxe nájdete online divadelné predstavenie z kategórie {{section}}. Zabavte sa s divadlom ešte viac.","playlist_currently_watching_title":"Dramox divadlo online | Práve sledujete","playlist_currently_watching_description":"Na Dramoxe môžete sledovať online stovky divadelných predstavení z desiatok slovenských a zahraničných divadiel. Vyskúšajte ZDARMA, zabavte sa s divadlom online už dnes.","playlist_most_popular_title":"Dramox divadlo online | Najobľúbenejšie predstavenia","playlist_most_popular_description":"Pozrite si na Dramoxe online najobľúbenejšie predstavenia podľa divákov. Tragédia, komédia, romantika aj rozprávky - vyberie si celá rodina.","playlist_recent_title":"Máme nové predstavenia | Dramox divadlo online","playlist_recent_description":"Pozrite si na Dramoxe online najnovšie divadelné predstavenia. Tragédia, komédia, romantika aj rozprávky - nové záznamy pridávame pravidelne. Vždy môžete pozerať niečo iné.","profile_title":"Dramox divadlo online | Profil diváka","profile_description":"Vitajte v online divadle Dramoxu. Vyberte si zo stoviek divadelných predstavení. Tragédia, komédia, romantika aj rozprávky pre deti - zabavte sa s divadlom ešte viac.","register_step1_title":"Dramox divadlo online | Registrácia nového používateľa","register_step1_description":"Už o chvíľku môžete sledovať online divadlo na Dramoxe. Najskôr sa, prosím, zaregistrujte. ZDARMA prvý týždeň.","register_step2_title":"Dramox divadlo online | Nastavenie hesla","register_step2_description":"Už o chvíľu môžete sledovať online divadlo na Dramoxe. Zvoľte si, prosím, svoje heslo. Heslo môžete hocikedy zmeniť.","register_confirm_email_title":"Dramox divadlo online | Potvrdenie e-mailovej adresy","register_confirm_email_description":"Už o chvíľu môžete na Dramoxe sledovať divadlo online. Potvrďte, prosím, svoju e-mailovú adresu.","terms_conditions_title":"Dramox divadlo online | Obchodné podmienky","terms_conditions_description":"V Dramoxe máme transparentné pravidlá a podmienky online sledovania stoviek divadelných predstavení. Veríme, že jasná a otvorená komunikácia vedie k dobrým priateľstvám.","privacy_policy_title":"Dramox divadlo online | Ochrana súkromia","privacy_policy_description":"V Dramoxe chránime vaše súkromie. Všetky osobné údaje sú u nás v bezpečí. Využívame spoľahlivé technológie a pracujeme v súlade s GDPR.","how_to_watch_web_title":"Divadlo online vo vašom počítači | Dramox","how_to_watch_web_description":"Sledujte divadlo online pohodlne vo svojom počítači. Stovky predstavení a najväčšie herecké hviezdy môžu byť už dnes večer u vás doma. Vyskúšajte 7 dní ZDARMA.","how_to_watch_tv_title":"Aplikácia pre smart televízory | Dramox divadlo online","how_to_watch_tv_description":"Stiahnite si televíznu aplikáciu Dramox pre smart televízory. Najlepšie divadelné predstavenia už dnes večer u vás doma. Vyskúšajte 7 dní ZDARMA.","how_to_watch_tv_samsung_title":"Aplikácia pre TV Samsung | Dramox divadlo online","how_to_watch_tv_samsung_description":"Stiahnite si televíznu aplikáciu Dramox pre smart televízory Samsung s OS Tizen a zabavte sa s divadlom online ešte viac. Vyskúšajte 7 dní ZDARMA.","how_to_watch_tv_lg_title":"Aplikácia pre TV LG | Dramox divadlo online","how_to_watch_tv_lg_description":"Stiahnite si televíznu aplikáciu Dramox pre smart televízory LG s WebOS a užite si divadlo online s maximum pohodlia. Vyskúšajte 7 dní ZDARMA.","how_to_watch_mobile_title":"Mobilná aplikácia pre Android a iOS | Dramox divadlo online","how_to_watch_mobile_description":"Stiahnite si mobilnú aplikáciu Dramox pre smart telefóny a tablety. Stovky predstavení a najväčšie herecké hviezdy tak budete mať kedykoľvek po ruke. Sledujte 7 dní ZDARMA.","how_to_watch_mobile_ios_title":"Aplikácia pre iOS | Dramox divadlo online","how_to_watch_mobile_ios_description":"Stiahnite si mobilnú aplikáciu Dramox pre smart telefóny a tablety s iOS. Divadlo online tak budete mať kedykoľvek po ruke. Vyskúšajte 7 dní ZDARMA.","how_to_watch_mobile_android_title":"Aplikácia pre Android | Dramox divadlo online","how_to_watch_mobile_android_description":"Stiahnite si mobilnú aplikáciu Dramox pre smart telefóny a tablety s OS Android a užite si stovky predstavení vo svojom mobile. Sledujte 7 dní ZDARMA.","how_to_watch_streaming_title":"Divadlo online z mobilu do televízora | Dramox","how_to_watch_streaming_description":"Sledujte divadlo online na svojom smart televízore aj bez aplikácie. Prehrávač Dramoxu podporuje bezdrôtový prenos cez AirPlay a Chromecast z telefónu do televízora.","how_to_watch_streaming_chromecast_title":"Dramox z mobilu do televízora cez Chromecast","how_to_watch_streaming_chromecast_description":"Pustite si Dramox na svojom smart televízore aj bez aplikácie. Náš prehrávač podporuje bezdrôtový prenos z telefónu do televízora cez Chromecast. Zabavte sa s divadlom online.","how_to_watch_streaming_airplay_title":"Dramox z mobilu do televízora cez AirPlay","how_to_watch_streaming_airplay_description":"Sledujte Dramox na svojom smart televízore aj bez aplikácie. Náš prehrávač podporuje bezdrôtový prenos z telefónu do televízora cez AirPlay. Je to ľahké a pohodlné.","playlist_dramox_originals_title":"Len na Dramoxe | Dramox Originals","playlist_dramox_originals_description":"Nakrúcame predstavenia, ktoré online nikde inde neuvidíte. Dramox Originals nájdete exkluzívne len na Dramox.sk. Zabavte sa s divadlom online, vyskúšajte 7 dní ZDARMA.","content_settings_title":"Jazyky predstavení | Dramox","content_settings_description":"Vytvorte si divadlo online presne na mieru. Divadelné predstavenia na Dramoxe si tak užijete vo väčšom komforte.","ua_support":"Podporujeme ukrajinskú kultúru","easter_contest_title":"Veľkonočná súťaž o vstupenky a poukazy | Dramox","easter_contest_desc":"Vyhrajte lístky do divadiel a darčekové poukazy. Zabavte sa cez Veľkú noc divadlom online. Čím viac predstavení na Dramoxe uvidíte, tým máte väčšiu šancu na výhru.","discount_title":"Zľava 50 % na 6 mesiacov predplatného | Dramox","discount_description":"Sledujte divadlo online až 6 mesiacov len za 5.95 €/mesiac a ušetrite takmer 35.7 € oproti bežnému predplatnému. Ponuka platí iba 7 dní. Aktivujte si ju hneď teraz.","broadcast_title":"Živé vysielanie","broadcast_description":"Živé vysielanie noviniek na Dramoxe","no_trial_how_to_watch_web_description":"Sledujte divadlo online pohodlne vo svojom počítači. Získajte prístup k stovkám predstavení a najlepším divadlám priamo z domova.\\n","no_trial_how_to_watch_tv_description":"Stiahnite si našu aplikáciu pre smart televízory a zabavte sa s najlepším divadlom z celého sveta.\\n","no_trial_how_to_watch_tv_samsung_description":"Stiahnite si našu aplikáciu pre smart televízory Samsung a sledujte najlepšie divadelné predstavenia v pohodlí domova.\\n","no_trial_how_to_watch_tv_lg_description":"Stiahnite si našu aplikáciu pre smart televízory LG a sledujte najlepšie divadelné predstavenia v pohodlí domova.\\n","no_trial_how_to_watch_mobile_description":"Stiahnite si našu mobilnú aplikáciu pre smartfóny a tablety a budete mať stovky predstavení a najlepších umelcov vždy po ruke.\\n","no_trial_how_to_watch_mobile_ios_description":"Stiahnite si našu mobilnú aplikáciu pre smartfóny a tablety s iOS a budete mať stovky predstavení a najlepších umelcov vždy po ruke.\\n","no_trial_how_to_watch_mobile_android_description":"Stiahnite si našu mobilnú aplikáciu pre smartfóny a tablety s OS Android a budete mať stovky predstavení a najlepších umelcov vždy po ruke.\\n","no_trial_playlist_dramox_originals_description":"Užite si divadlo, ktoré online nikde inde neuvidíte. Predstavenia Dramox Originals nakrúcame exkluzívne pre Dramox.sk\\n","christmas_contest_title":"Vánoční soutěž | Dramox divadlo online","christmas_contest_description":"Sledujte v prosinci divadlo online a vyhrajte poukazy do Dramoxu,  vstupenky do Dejvického a dalších divadel. Čím víc děl uvidíte, tím vyšší šance na výhru.","celebrity_default_about":"{{name}} pôsobí na Dramoxe v predstaveniach: {{plays}} z divadla: {{theatre}}. Užite si divadlo online a zabavte sa so svojimi obľúbenými osobnosťami."}');

/***/ }),

/***/ 50823:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"content_settings_title":"Jazyky predstavení","perfomance_language_settings_title":"Voľba jazykov divadelných predstavení","perfomance_language_settings_subtitle":"V akých jazykoch chcete sledovať divadelné predstavenia? Prispôsobte si zážitok na mieru a my vám zobrazíme len záznamy, ktorým budete rozumieť. Nastavenia si môžete kedykoľvek zmeniť.","btn_content_settings_register_submit":"Potvrdiť","btn_content_settings_register_skip":"Preskočiť","submit_error":"Nastavenie sa nepodarilo uložiť. Prosím, skúste to opäť neskôr.","submit_ok":"Nastavenie sa uložilo."}');

/***/ }),

/***/ 60015:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"samsung_title":"Aplikácia Dramox pre smart televízory Samsung","samsung_desc":"Dostupná pre modely vyrobené od roku 2018 so systémom Tizen 4.0 a vyšším. Potrebujete poradiť? Kontaktujte nás, prosím, na: <a href=\\"mailto:napoveda@dramox.cz\\">napoveda@dramox.cz</a>.","samsung_instalation":"Inštalácia aplikácie Dramox","samsung_step_1":"Stlačte tlačítko <b>Home</b> alebo tlačítko <b>Smart Hub</b> na svojom ovládači.","samsung_step_2":"Vyberte ikonku <b>APPS</b> v spodnej časti obrazovky.","samsung_step_3":"V aplikácii App Store napíšte Dramox do ikonky <b>Search icon</b>.","samsung_step_4":"Vyberte aplikáciu <b>Dramox</b>, ktorá sa zobrazí v ponuke.","samsung_step_5":"Na stránke s detailami aplikácie stlačte tlačítko <b>Install</b>. Pokiaľ vás k tomu aplikácia App Store vyzve, prihláste sa do svojho účtu Samsung.\\n","samsung_step_6":"Po úspešnom dokončení inštalácie stlačte tlačítko <b>Add to home screen</b>. Aplikácia sa objaví v ponuke v spodnej časti obrazovky.","samsung_step_7":"Po spustení aplikácie Dramox sa prihláste pomocou svojho e-mailu a hesla do svojho účtu na Dramoxe.","lg_title":"Aplikácia Dramox pre smart televízory LG","lg_desc":"Dostupná pre modely vyrobené od roku 2016 a novšie so systémom WebOS 3.0 a vyšším. Potrebujete poradiť? Napíšte nám, prosím, na: <a href=\\"mailto:napoveda@dramox.cz\\">napoveda@dramox.cz</a>.","lg_instalation":"Inštalácia aplikácie Dramox","lg_step_1":"Stlačte na ovládači tlačítko s <strong>ikonkou domčeka</strong>.","lg_step_2":"V spodnej ovládcej lište zvoľte dlaždicu s názvom <strong>LG Content Store</strong>.","lg_step_3":"V obchode s aplikáciami zvoľte <strong>ikonku lupy</strong> a napíšte Dramox.","lg_step_4":"Vyberte aplikáciu <strong>Dramox</strong>, ktorú vám ponúkne vyhľadávanie.","lg_step_5":"Na stránke s detailom aplikácie kliknite na tlačítko <strong>Inštalovať</strong>.","lg_step_6":"Po úspešnej inštalácii sa aplikácia pridá na <strong>Domovskú obrazovku</strong> a zaradí sa na koniec. Kliknite na tlačítko <strong>Spustiť</strong>.","lg_step_7":"Po spustení aplikácie Dramox sa prihláste pomocou svojho e-mailu a hesla do svojho účtu na Dramoxe."}');

/***/ }),

/***/ 34224:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"theatres":"Divadlá","detail":"Detail","support":"Podporiť","web_page":"Webová stránka divadla","theatre_plays":"Predstavenia tohto divadla","choose_donate":"Vyberte divadlo, ktoré chcete podporiť","theatre":"Divadlo","continue":"Pokračovať","choose_theatre":"Vyberte divadlo","min_donate":"Minimálna čiastka je  {{value}} {{currency}}.","max_donate":"Maximálna čiastka je {{value}} {{currency}}.","donate_how_much":"Koľko chcete prispieť?","donate_note":"Divadlu odovzdáme takmer celý darovaný obnos. Pre seba si nenechávame nič, len zaplatíme platobnej bráne za poskytnutie technológie pre bezpečnú platbu.","amount_other":"Iné","button_submit":"Potvrdiť","changes_not_saved":"Zmeny sa nepodarilo uložiť. Prosím, zopakujte to neskôr.","changes_saved":"Zmeny sa uložili.","donation_success":"Ďakujeme za Vašu podporu!","donation_fail":"Platba zlyhala.","amount_in_currency":"Čiastka v {{currency}}","must_login":"Najskôr sa musíte prihlásiť do svojeho účtu.","dramox_theatres":"Divadlá na Dramoxe","sort_alphabeticaly":"Abecedne","sort_newest":"Od najnovších","sort_popular":"Populárne","sort":"Zoradiť","genre":"Žáner","language":"Jazyk","country":"Krajina","filter_all":"Všetky","clear_filter":"Resetovať filter","most_popular_theatres":"Najpopulárnejšie divadlá","popular_this_week_theatres":"Populárne divadlá tento týždeň","no_theatres":"Neboli nájdené žiadne divadlá.","plays_count_zero":"{{count}} predstavenie","plays_count_one":"{{count}} predstavenie","plays_count_few":"{{count}} predstavenia","plays_count_many":"{{count}} predstavení","register":"Sledovať 7 dní zadarmo","amount":{"one":"","few":"","many":"","other":""}}');

/***/ }),

/***/ 10662:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Podporujeme ukrajinskú kultúru: Ukrajinským divadlám pošleme 100% predplatného","subtitle":"Divadelná platforma Dramox na tlačovej konferencii v Kyjeve 17. februára oficiálne oznámila spustenie svojej služby na Ukrajine. V tom čase sa k Dramoxu pridalo 17 ukrajinských divadiel. Očakávali sme, že ich počet bude rýchlo rásť, nedávne udalosti však naše plány zastavili.\\n","text_1":"Vojna na Ukrajine zastavila bežný aj kultúrny život. Dramox sa tak stal jediným miestom, kde si bezpečne môžete pozrieť ukrajinské divadelné predstavenia.","text_2":"<p>Ukrajinským divadlám by sme preto chceli čo najviac pomôcť. Rozhodli sme sa, že im <span>pošleme 100 percent finančných prostriedkov, ktoré získajú vďaka divákom na Dramoxe. Ak si pozriete <ukTheater>predstavenia ukrajinských divadiel</ukTheater>, priamo ich tým podporíte.</span></p>","how_watch_title":"Ako sledovať ukrajinské divadlá:","how_watch_1":"Prihláste sa do svojho účtu na Dramoxe","how_watch_2":"<li>Kliknite na možnosť <span>“Jazyky predstavení”</span> vo svojom profile a vyberte ukrajinský jazyk</li>","how_watch_3":"Teraz máte prístup k ukrajinským predstaveniam","how_watch_soon":"Už čoskoro pridáme na Dramox viac ukrajinského obsahu. Aktuálne pracujeme na výrobe titulkov k ďalším ukrajinským predstaveniam."}');

/***/ }),

/***/ 83215:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"airplay_title":"Prenos obsahu do TV pomocou AirPlay","airplay_description":"AirPlay je technológia od spoločnosti Apple na prenos multimediálneho obsahu do televízora.","airplay_instalation":"Ako zdieľať predstavenia pomocou AirPlay","airplay_step_1":"Váš smart televízor musí byť pripojený k rovnakej wi-fi sieti ako váš notebook, mobil alebo tablet.","airplay_step_2":"Televízor musí podporovať technológiu AirPlay.","airplay_step_3":"Spustite vybrané predstavenie - v prehliadači <strong>Safari</strong> alebo v <a href=\\"https://apps.apple.com/cz/app/dramox-divadlo-online/id1563430137?l=cs\\" target=\\"blank\\">mobilnej aplikácii pre iOS</a>.","airplay_step_4":"Kliknite na ikonku <0></0> v pravom dolnom rohu.","airplay_step_5":"Z ponuky si vyberte, do ktorého televízora vo svojej wi-fi sieti chcete predstavenie preniesť.","chromecast_title":"Prenos obsahu do TV pomocou Chromecast","chromecast_description":"Chromecast je technológia od spoločnosti Google na prenos multimediálneho obsahu do televízora.","chromecast_instalation":"Ako zdieľať predstavenia pomocou Chromecast","chromecast_step_1":"Váš smart televízor musí byť pripojený k rovnakej wi-fi sieti ako váš notebook, mobil alebo tablet.","chromecast_step_2":"Televízor musí podporovať technológiu Chromecast.","chromecast_step_3":"Spustite vybrané divadelné predstavenie - <strong> v prehliadači Chrome, Opera </strong> alebo v <a href=\\"https://play.google.com/store/apps/details?id=cz.dramox.dramox\\" target=\\"_blank\\">mobilnej aplikácii pre Android.</a>","chromecast_step_4":"Kliknite na ikonku ozubeného kolieska <0></0> v pravom dolnom rohu.","chromecast_step_5":"Kliknite na ikonku Chromecast. <0></0>","chromecast_step_6":"Z ponuky si vyberte, do ktorého televízora vo svojej wi-fi sieti chcete predstavenie preniesť."}');

/***/ }),

/***/ 85267:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Darujte Dramox - divadlo online","description":"Poukazom na Dramox darujete svojim blízkym jedinečnú zábavu a zároveň tak podporíte divadlá, tvorcov i hercov. Väčšinu zo zaplatenej čiastky Dramox odovzdá práve im.\\n\\nPo zakúpení Vám na Váš e-mail doručíme darčekový poukaz vo formáte PDF.","buy_btn":"Kúpiť darčekový poukaz","for_companies":"V prípade, že chcete kúpiť väčšie množstvo (min. 10 a viac) darčekových poukazov na IČO, prosím, napíšte nám na <contactMail>napoveda@dramox.cz</contactMail>.","price_with_vat":"{{price}} s DPH","buy_success":"Ďakujeme. Darčekový poukaz Vám o chvíľku príde na Váš e-mail.","buy_fail":"Platba zlyhala.","givery":"Spolupracujeme s Givery.cz","buy_physical_voucher":"Chcem fyzický poukaz + 89 CZK"}');

/***/ }),

/***/ 54417:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"menu_faq":"Časté otázky","theatres_list_title":"Zoznam divadiel","plays_list_title":"Vybrané divadelné predstavenia","new_welcome_sec_1_title_cz":"Kultúra nikdy nebola bližšie. Stovky slovenských, českých aj zahraničných divadiel na jednom mieste.","new_welcome_sec_1_title_xx":"Kultúra nikdy nebola bližšie. Stovky slovenských, českých aj zahraničných divadiel na jednom mieste.","new_welcome_sec_2_text_cz":"Stovky legálnych divadelných záznamov dostupných online","new_welcome_sec_2_text_xx":"Stovky legálnych divadelných záznamov dostupných online","new_welcome_sec_2_title_cz":"Pozrieť knižnicu","new_welcome_sec_2_title_xx":"Pozrieť knižnicu","new_welcome_sec_3_text_cz":"Sledovaním Dramoxu podporujete divadelnú kultúru. Celých 55 % predplatného putuje naspäť divadlám, tvorcom a hercom. Navyše môžete svojim obľúbencom poslať ďalšiu ľubovoľnú čiastku. Je to rovnaké ako kúpiť si lístky, len pohodlnejšie (a výhodnejšie).","new_welcome_sec_3_text_xx":"Sledovaním Dramoxu podporujete divadelnú kultúru. Celých 55 % predplatného putuje naspäť divadlám, tvorcom a hercom. Navyše môžete svojim obľúbencom poslať ďalšiu ľubovoľnú čiastku. Je to rovnaké ako kúpiť si lístky, len pohodlnejšie (a výhodnejšie).","new_welcome_sec_3_title_cz":"Viac ako polovicu každého predplatného posielame divadlám","new_welcome_sec_3_title_xx":"Viac ako polovicu každého predplatného posielame divadlám","new_welcome_sec_4_text_xx":"Už nikdy vám nebude prekážať, že je kultúra príliš ďaleko. Predstavenia z tých najlepších divadiel si teraz pustíte kdekoľvek a kedykoľvek. Sledovať ich môžete na viacerých zariadeniach, v počítači, na televízore aj v mobile. Je to jednoduché a dostupné pre každého. Pohodlne sa usadťe, začíname.","new_welcome_sec_4_text_cz":"Už nikdy vám nebude prekážať, že je kultúra príliš ďaleko. Predstavenia z tých najlepších divadiel si teraz pustíte kdekoľvek a kedykoľvek. Sledovať ich môžete na viacerých zariadeniach, v počítači, na televízore aj v mobile. Je to jednoduché a dostupné pre každého. Pohodlne sa usadťe, začíname.","new_welcome_sec_4_title_cz":"Zamilujte si Dramox","new_welcome_sec_4_title_xx":"Zamilujte si Dramox","new_welcome_sec_5_text_cz":"Svoje predplatné môžete kedykoľvek zrušiť.","new_welcome_sec_5_text_xx":"Svoje predplatné môžete kedykoľvek zrušiť.","new_welcome_sec_5_title_cz":"Vyskúšajte Dramox na 7 dní zdarma","new_welcome_sec_5_title_xx":"Vyskúšajte Dramox na 7 dní zdarma","welcome_button_long_xx":"Chcem Dramox na 7 dní ZADARMO","welcome_button_long_cz":"Chcem Dramox na 7 dní ZADARMO","welcome_price_cz":"Po uplynutí skúšobného obdobia za {{monthly}} mesačne","welcome_price_xx":"Po uplynutí skúšobného obdobia za {{monthly}} mesačne","welcome_subtitle_xx":"Sledujte kedykoľvek a kdekoľvek budete mať chuť. Na Smart TV, v mobile, na tablete aj počítači","welcome_subtitle_cz":"Sledujte kedykoľvek a kdekoľvek budete mať chuť. Na Smart TV, v mobile, na tablete aj počítači","welcome_title_cz":"Najväčší výber divadelných predstavení na jednom mieste","welcome_title_xx":"Urobte si čas na divadlo. Stovky predstavení nájdete na Dramoxe online.","new_welcome_sec_1_title_sk":"Kultúra nikdy nebola bližšie. Stovky slovenských, českých aj zahraničných divadiel na jednom mieste. ","new_welcome_sec_2_text_sk":"Stovky legálnych divadelných záznamov k pozretiu online","new_welcome_sec_2_title_sk":"Pozrieť si knižnicu","new_welcome_sec_3_text_sk":"Sledovaním Dramoxu podporujete divadelnú kultúru. Celých 55 % predplatného putuje naspäť divadlám, tvorcom a hercom. Navyše môžete svojim obľúbencom poslať ďalšiu ľubovoľnú čiastku. Je to rovnaké ako kúpiť si lístky, len pohodlnejšie (a výhodnejšie).","new_welcome_sec_3_title_sk":"Viac ako polovicu každého predplatného posielame divadlám","new_welcome_sec_4_text_sk":"Už nikdy nebudete riešiť, že je kultúra príliš ďaleko. Inscenácie tých najlepších divadiel si teraz môžete pustiť kdekoľvek a kedykoľvek. Sledovať ich môžete na rôznych zariadeniach - v počítači, v televízore aj v mobile. Je to jednoduché a dostupné pre každého. Pohodlne sa usaďte, začíname!","new_welcome_sec_4_title_sk":"Zamilujte si Dramox","new_welcome_sec_5_text_sk":"Svoje predplatné môžete kedykoľvek zrušiť.","new_welcome_sec_5_title_sk":"Vyskúšajte Dramox na 7 dní zdarma","welcome_button_long_sk":"Chcem Dramox na 7 dní ZADARMO","welcome_price_sk":"Po uplynutí skúšobného obdobia za {{monthly}} mesačne","welcome_subtitle_sk":"Sledujte kedykoľvek a kdekoľvek budete mať chuť. Na Smart TV, v mobile, na tablete aj počítači","welcome_title_sk":"Urobte si čas na divadlo. Stovky predstavení nájdete na Dramoxe online.","new_welcome_sec_1_title_ua":"Kultúra nikdy nebola bližšie. Stovky slovenských, českých aj zahraničných divadiel na jednom mieste.","new_welcome_sec_2_text_ua":"Stovky legálnych divadelných záznamov k pozretiu online","new_welcome_sec_2_title_ua":"Pozrieť si knižnicu","new_welcome_sec_3_text_ua":"Sledovaním Dramoxu podporujete divadelnú kultúru. Celých 55 % predplatného putuje naspäť divadlám, tvorcom a hercom. Navyše môžete svojim obľúbencom poslať ďalšiu ľubovoľnú čiastku. Je to rovnaké ako kúpiť si lístky, len pohodlnejšie (a výhodnejšie).","new_welcome_sec_3_title_ua":"Viac ako polovicu každého predplatného posielame divadlám","new_welcome_sec_4_text_ua":"Už nikdy nebudete riešiť, že je kultúra príliš ďaleko. Inscenácie tých najlepších divadiel si teraz môžete pustiť kdekoľvek a kedykoľvek. Sledovať ich môžete na rôznych zariadeniach - v počítači, v televízore aj v mobile. Je to jednoduché a dostupné pre každého. Pohodlne sa usaďte, začíname!","new_welcome_sec_4_title_ua":"Zamilujte si Dramox","new_welcome_sec_5_text_ua":"Svoje predplatné môžete kedykoľvek zrušiť.","new_welcome_sec_5_title_ua":"Vyskúšajte Dramox na 7 dní zdarma","welcome_button_long_ua":"Chcem Dramox na 7 dní ZADARMO","welcome_price_ua":"Po uplynutí skúšobného obdobia za {{monthly}} mesačne","welcome_subtitle_ua":"Sledujte kedykoľvek a kdekoľvek budete mať chuť. Na Smart TV, v mobile, na tablete aj počítači","welcome_title_ua":"Urobte si čas na divadlo. Stovky predstavení nájdete na Dramoxe online.","new_welcome_sec_1_title_pl":"Kultúra nikdy nebola bližšie. Stovky slovenských, českých aj zahraničných divadiel na jednom mieste.","new_welcome_sec_2_text_pl":"Na Dramoxe nájdete stovky divadelných predstavení","new_welcome_sec_2_title_pl":"Prezrite si knižnicu","new_welcome_sec_3_text_pl":"Sledovaním Dramoxu podporujete divadelnú kultúru. Celých 55 % predplatného putuje naspäť divadlám, tvorcom a hercom. Navyše môžete svojim obľúbencom poslať ďalšiu ľubovoľnú čiastku. Je to rovnaké ako kúpiť si lístky, len pohodlnejšie (a výhodnejšie).","new_welcome_sec_3_title_pl":"Viac ako polovicu každého predplatného posielame divadlám","new_welcome_sec_4_text_pl":"Divadlo na dosah. Sledujte predstavenia svetovej kvality kdekoľvek a kedykoľvek. Teraz aj prostredníctvom aplikácie pre váš počítač, mobilný telefón a Smart TV. Dramox sa jednoducho používa a je prístupný pre každého. Dámy a páni, pohodlne sa usaďte, predstavenie sa začína.","new_welcome_sec_4_title_pl":"Zamilujte si Dramox","new_welcome_sec_5_text_pl":"Svoje predplatné môžete kedykoľvek zrušiť.","new_welcome_sec_5_title_pl":"Vyskúšajte Dramox","welcome_button_long_pl":"Chcem Dramox na 7 dní ZADARMO","welcome_price_pl":"Po uplynutí skúšobného obdobia za {{monthly}} mesačne","welcome_subtitle_pl":"Sledujte kedykoľvek a kdekoľvek budete mať chuť. Na Smart TV, v mobile, na tablete aj počítači","welcome_title_pl":"Urobte si čas na divadlo. Stovky predstavení nájdete na Dramoxe online.","no_trial_welcome_button_long_xx":"Začnite svoje dobrodružstvá s divadlom online.\\n","no_trial_welcome_button_long_cz":"Začnite sledovať divadlo online. ","no_trial_welcome_button_long_sk":"Začnite sledovať divadlo online. ","no_trial_welcome_button_long_ua":"Začnite sledovať divadlo online. ","no_trial_welcome_button_long_pl":"Začnite sledovať divadlo online. ","welcome_button_browse_xx":"Prezrite ponuku","welcome_button_browse_cz":"Prezrite ponuku","welcome_button_browse_sk":"Prezrite ponuku","welcome_button_browse_ua":"Prezrite ponuku","welcome_button_browse_pl":"Prezrite ponuku","welcome_subscription_title_xx":"Vyberte si predplatné a choďte do divadla každý deň","welcome_subscription_title_cz":"Vyberte si predplatné a choďte do divadla každý deň","welcome_subscription_title_sk":"Vyberte si predplatné a choďte do divadla každý deň","welcome_subscription_title_ua":"Vyberte si predplatné a choďte do divadla každý deň","welcome_subscription_title_pl":"Vyberte si predplatné a choďte do divadla každý deň","welcome_subscription_1_xx":"Stovky záznamov slovenských, českých aj zahraničných predstavení z viac ako 250 divadiel","welcome_subscription_1_cz":"Stovky záznamov slovenských, českých aj zahraničných predstavení z viac ako 250 divadiel","welcome_subscription_1_sk":"Stovky záznamov slovenských, českých aj zahraničných predstavení z viac ako 250 divadiel","welcome_subscription_1_ua":"Stovky záznamov slovenských, českých aj zahraničných predstavení z viac ako 250 divadiel","welcome_subscription_1_pl":"Stovky záznamov slovenských, českých aj zahraničných predstavení z viac ako 250 divadiel","welcome_subscription_2_xx":"Činohra, muzikál, opera, bábky aj nový cirkus","welcome_subscription_2_cz":"Činohra, muzikál, opera, bábky aj nový cirkus","welcome_subscription_2_sk":"Činohra, muzikál, opera, bábky aj nový cirkus","welcome_subscription_2_ua":"Činohra, muzikál, opera, bábky aj nový cirkus","welcome_subscription_2_pl":"Činohra, muzikál, opera, bábky aj nový cirkus","welcome_subscription_3_xx":"Žiadne reklamy ani ďalšie poplatky","welcome_subscription_3_cz":"Žiadne reklamy ani ďalšie poplatky","welcome_subscription_3_sk":"Žiadne reklamy ani ďalšie poplatky","welcome_subscription_3_ua":"Žiadne reklamy ani ďalšie poplatky","welcome_subscription_3_pl":"Žiadne reklamy ani ďalšie poplatky","welcome_subscription_button_1_xx":"7 dní zadarmo <0>potom za {{priceMonthly}} mesiac</0>","welcome_subscription_button_1_cz":"7 dní zdarma,<1></1><0>potom za {{priceMonthly}} / mesačne</0>","welcome_subscription_button_1_sk":"7 dní zdarma,<1></1><0>potom za {{priceMonthly}} / mesačne</0>","welcome_subscription_button_1_ua":"7 dní zdarma,<1></1><0>potom za {{priceMonthly}} / mesačne</0>","welcome_subscription_button_1_pl":"7 dní zdarma,<1></1><0>potom za {{priceMonthly}} / mesačne</0>","welcome_subscription_button_2_xx":"7 dní zadarmo,<1></1><0>potom za <2>{{beforeYearly}}</2> {{priceYearly}} / rok</0>","welcome_subscription_button_2_cz":"7 dní zadarmo,<1></1><0>potom za <2>{{beforeYearly}}</2> {{priceYearly}} / rok</0>","welcome_subscription_button_2_sk":"7 dní zadarmo,<1></1><0>potom za <2>{{beforeYearly}}</2> {{priceYearly}} / rok</0>","welcome_subscription_button_2_ua":"7 dní zadarmo,<1></1><0>potom za <2>{{beforeYearly}}</2> {{priceYearly}} / rok</0>","welcome_subscription_button_2_pl":"7 dní zadarmo,<1></1><0>potom za <2>{{beforeYearly}}</2> {{priceYearly}} / rok</0>","welcome_subscription_button_activate_xx":"Aktivovať skúšobné obdobie","welcome_subscription_button_activate_cz":"Aktivovať skúšobné obdobie","welcome_subscription_button_activate_sk":"Aktivovať skúšobné obdobie","welcome_subscription_button_activate_ua":"Aktivovať skúšobné obdobie","welcome_subscription_button_activate_pl":"Aktivovať skúšobné obdobie","welcome_subscription_cancel_note_xx":"Predplatné môžete kedykoľvek zrušiť","welcome_subscription_cancel_note_cz":"Predplatné môžete kedykoľvek zrušiť","welcome_subscription_cancel_note_sk":"Predplatné môžete kedykoľvek zrušiť","welcome_subscription_cancel_note_ua":"Predplatné môžete kedykoľvek zrušiť","welcome_subscription_cancel_note_pl":"Predplatné môžete kedykoľvek zrušiť"}');

/***/ }),

/***/ 86212:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"authorship_provider":"Постачальник послуг","about_colaboration_question":"Зацікавлені у співпраці?","about_contact_us":"Напишіть нам","about_creators":"Хто створює Dramox?","about_partners":"Наші партнери","about_project":"Прo прoєкт","about_schools":"Із Dramox для шкіл уроки можуть стати більш пізнавальними. Учні відкриватимуть красу театру та літератури в улюбленому форматі відео. Також вони зможуть виконати інтерактивні завдання, які допоможуть їм краще зрозуміти побачене. Дізнайтеся більше <0>тут</0>.","about_theaters":"Показати всі театри","about_colaboration":"З ким ми працюємо?","person_about_1":"Мартін вивчав театрознавство. У професійному житті він поєднує фахові знання з гуманітарних наук і технологій. Мартін — співзасновник декількох діджитал-компаній, а також працював у сфері продажів у компаніях.","person_about_2":"Радім є власником компанії Weemazz 2.0, яка допомагає авторам захистити їхні права в Інтернеті, видаляючи нелегальні копії з мережі. Допоміг запустити відеопортал voyo.cz. Впродовж своєї кар’єрі працює у сфері цифрових технологій.","person_about_3":"Співзасновник, а також ідейний батько концепту Dramox. Мартін — діджитал-підприємець та власник бренду Livesport, яким користуються понад 90 мільйонів людей у всьому світі.","person_title_1":"Мартін Заваділ","person_title_2":"Радім Горак","person_title_3":"Мартін Гаєк","forschools_footer":"Для шкіл","about_project_description":"<0>Dramox — це онлайн-театр. Тут ви знайдете найбільший вибір театральних вистав. За щомісячну підписку ви отримуєте безлімітний доступ до усієї колекції. Переглядайте улюблені вистави або відкривайте нові, коли завгодно і де завгодно, абсолютно без реклами. Щомісяця додаємо нові постановки — побачте їх першими!</0><0>Dramox підтримує українські та світові театри. Половину передплати ми повертаємо театрам та тим, хто долучився до створення вистави. Також ви можете додатково підтримати улюблених виконавців будь-яким внеском. Ми віримо, що мистецтво має бути доступне кожному, незалежно від місцязнаходження чи мови.</0>","legislative":"Органом контролю над наданням аудіовізуальних медіапослуг на вимогу є Рада з питань радіомовлення і телебачення."}');

/***/ }),

/***/ 38690:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"menu_authorship":"Авторські права","authorship_email":"Дякуємo за ваш email","authorship_email_fail":"Ваше повідомлення не вдалося надіслати. Спробуйте, будь ласка, пізніше.","authorship_message_for_us":"Повідомлення","authorship_provider":"Постачальник послуг","authorship_send_form":"Надіслати форму","authorship_title":"Запит щодо авторських прав","authorship_your_email":"Ваш email","authorship_perex":"<0>Ви є автором однієї з вистав на Dramox, а ми не сконтактували з вами?  Будь ласка, напишіть нам.</0><0>Ми прагнемо, щоб права кожного автора були захищені. Ймовірно, сталася помилка.</0><0>Будь ласка, зв’яжіться з нами, заповнивши форму нижче. Ми будемо раді все обговорити.</0><0> Дякуємo.<1></1>Команда Dramox</0>\\n","authorship_field_required":"Це поле є обов’язковим.","authorship_max_length":"Максимальна довжина:","authorship_email_invalid":"Недійсний email. Використайте формат: email@example.ua"}');

/***/ }),

/***/ 16508:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"broadcast_title":"Пряма трансляція","video_placeholder":"Зараз ми не транслюємо","schedule_title":"Розклад"}');

/***/ }),

/***/ 81695:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Оберіть план підписки","payment_info":"Для нових користувачів — перших 7 днів БЕЗКОШТОВНО. Пoвертаємo половину вашої передплати театрам. Ви можете скасувати підписку, коли забажаєте. ","payment_occour":"Оплата буде здійснена {{date}}","payment_sub_info":"З річним планом ви екoнoмите майже {{yearPriceDiff}} в рік","voucher_label":"Подарунковий cертифікат","voucher_placeholder":"Введіть свій промокод","got_voucher":"У мене є подарунковий cертифікат","redeem_voucher":"Повернути cертифікат","activate_yearly":"Активувати річний план","activate_monthly":"Активувати місячний план","changes_not_saved":"Не вдалося зберегти зміни. Будь ласка, спробуйте пізніше.","changes_saved":"Зміни збережено","subscription_activated":"Підписку активовано.","error_general":"Щось пішло не так. Будь ласка, спробуйте пізніше.","price_with_vat":"{{price}}\\nз ПДВ","advanced_form":{"title":"Виберіть підписку","switch_to_voucher":"або скористайтесь сертифікатом","monthly":"7 днів БЕЗКОШТОВНО, <0>потім {{price_formatted}} щомісяця</0>","yearly":"7 днів БЕЗКОШТОВНО, <0>потім {{price_formatted}} на рік</0>","button_activate":"Активуйте 7 днів безкоштовно","timeline_title":"Як працює 7-денний безкоштовний пробний період?","timeline_step_1":"<0>Сьогодні</0> початок безкоштовного пробного періоду","timeline_step_2":"<0>Через 7 днів ({{date_formatted}})</0>буде стягнуто кошти за вашу першу підписку. Ви можете скасувати її під час пробного періоду безкоштовно.","timeline_step_3":"Підписка поновлюється автоматично до її скасування","voucher_title":"Скористатися сертифікатом","switch_to_card":"У мене немає сертифікату","voucher_description_title":"Подаруйте своїм близьким театральні враження. Придбайте cертифікат Dramox","voucher_description_subtitle":"Вони можуть переглянути сотні вистав від українських та світових театрів.","voucher_description_action":"Придбати cертифікат","use_promo_code":"Використайте промокoд (за бажанням)","promo_code_placeholder":"Введіть промокод","timeline_step_4":"<0>Через 5 днів ({{date_formatted}})</0>ми надішлемо вам нагадування <1></1>про першу оплату підписки.","no_trial_button_activate":"Активуйте підписку","no_trial_timeline_title":"Виберіть план підписки.","no_trial_timeline_step_1":"Почніть користуватися Dramox сьогодні.","no_trial_monthly":"<0>{{price_formatted}} щомісяця</0>","no_trial_yearly":"<0>{{price_formatted}} на рік</0>"},"code_not_exists":"Промокoд недійсний","card_number_invalid":"Номер вашої картки неповний.","error_code_no_longer_valid":"Код більше не дійсний.","error_voucher_expired":"Код більше не дійсний.","error_code_discount_already_used":"Код на знижку вже використаний.","error_discount_already_active":"Промокод не можливо використати. Знижку вже активовано.","error_promo_referral_not_allowed":"Промокод можна використати тільки при створенні нового акаунта.","error_promo_already_used":"Промокод вже активовано.","error_promo_voucher_already_used":"Промокод вже використано.","error_promo_not_allowed":"Промокод можна використовувати тільки при активній підписці.","voucher_invalid":"Промокод недійсний","code_already_used":"Промокод вже використаний","no_trial_payment_info":"Ви можете скасувати підписку, коли забажаєте. Ми віддаємо половину суми з кожної підписки безпосередньо театрам."}');

/***/ }),

/***/ 43007:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"contest_title":"Christmas Contest with Dramox","contest_btn":"Enter the contest","contest_desc":"Enjoy world-class theater performances throughout Advent and win theater tickets and Dramox vouchers","contest_description":"Make yourself a hot cup of tea, snuggle up in your armchair and discover new theater performances with Dramox from December 1st to December 21st. This year, we\'re rewarding you with theater tickets and Dramox vouchers. And best of all, Santa Claus will be visiting on December 22nd to gift one lucky winner a theater bundle, including tickets to your favorite Dejvice Theater!","contest_what_win_title":"Prizes","contest_what_win":"The contest takes place in three weekly rounds for the chance to win the following prizes:","contest_what_1":"<0>1st place</0><1><2>2 x theater tickets</2><2>1 x 6 month Dramox voucher</2></1>","contest_what_2":"<0>2nd place</0><1><2>2 x theater tickets</2><2>1 x 3 month Dramox voucher</2></1>","contest_what_3":"<0>3rd-5th place</0><1><2>2 x theater tickets</2><2>1 x 1 month Dramox voucher</2></1>","contest_what_main_price":"Grand prize for the winner between December 1st to December 21st:","contest_what_price":"1 x theater bundle including tickets to Dejvice Theater + 1 x 1 year Dramox voucher + Dramox merch","contest_tip_title":"💡Our tip: The more performances you watch, the higher your chance of winning.","contest_tip_desc":"Example: You watch one performance on December 1st, a second one on December 5th and a third one on December 6th. You will automatically be entered into the final draw for a chance to win a theater bundle after the competition closes on Thursday, December 21rd at 12pm.","contest_how_play":"How it works","contest_how_1":"<0>Register using the form.</0> Make sure to use the same email address you registered with on Dramox!","contest_how_2":"Each contest week, discover new theater performances on Dramox. The more performances you watch, the higher your chance of winning.","contest_how_3":"At the end of each week, we will select five winners who will be notified of their prizes via email. At the end of the contest period you also have a chance to win the main prize: a theater bundle including Dejvice Theater tickets, a 1 year subscription to Dramox and Dramox merch. The winner will be announced on December 23rd in the afternoon.","contest_how_4":"Follow us on <0>Facebook</0>, <1>Instagram</1> and <2>Twitter</2> to stay updated about the contest and to get tips on what to watch next.","contest_rules_title":"Contest rules","contest_rule_1":"The contest starts on December 1st  2023 at 0am and ends on December 21rd 2022 at 12pm.","contest_rule_2":"The competition runs during the following periods:","contest_rule_2_1":"Week 1: from December 1st to December 7th, winners are announced on December 8th","contest_rule_2_2":"Week 2: from December 8th to December 14th, winners are announced on December 15th","contest_rule_2_3":"Week 3: from December 15th to December 21th, winners are announced on December 22th","contest_rule_2_4":"Week 4: from December 18th to December 23rd, winners are announced on December 23rd","contest_rule_3":"All users registered on Dramox with an active subscription or during their 7-day trial period, who have also registered using the contest form can participate.","contest_rule_4":"The winners of each weekly round will be announced on our social media and in our newsletter.","contest_rule_5":"The grand prize can be won by any contestant who entered between December 1st and December 21nd, regardless of whether or not they have already won any of the previous prizes. There is only one grand prize and a single contestant will be selected on December 22nd. We will announce the winner on our social media and in our newsletter.","contest_rule_more":"You can find the complete list of rules for the Christmas Contest <0>here</0>.","contest_info_toolbar_2023":"⭐ Christmas Contest with Dramox: Win theater tickets and Dramox gift vouchers","contest_info_toolbar_2024":""}');

/***/ }),

/***/ 95872:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"more":"Більше","more_about_play":"Детальніше","previous_play":"Попередні вистави","play_btn":"Відтворити","play_btn_long":"Відтворити","next_play":"Наступна вистава","coming_soon":"Незабаром","continue":"Продовжити","continue_remaining":"Залишилося {{time}}","most_popular":"Найпопулярніше","popular":"Популярне","recently_added":"Нове","currently_watching":"Продовжити перегляд","drama":"Драма","comedy":"Комедія","tragedy":"Трагедія","all_genres":"Усі жанри","actors":"Виконавці","performances":"Вистави","theatres":"Театри","search_placeholder":"Пошук вистави, театру, виконавця...","no_search_results":"Пошук не дав результатів.","menu":{"home":"Головна","genres":"Жанри","theatres":"Театри ","about":"Прo Dramox","theatre":"Підтримати театр","voucher":"Cертифікати","login":"Увійти","try_free":"Зареєструватися","about_project":"Про проєкт","for_schools":"Для шкіл","smart_tv":"Smart TV","mobile_apps":"Мобільні застосунки","how_to_watch":"Як дивитись","contact":"Напишіть нам","faq":"Пoширені питання","my_profile":"Мій профіль","logout":"Вийти","terms_conditions":"Положення й умови","cookies":"Політика щодо файлів Сookie","authorship":"Автoрські права","privacy_policy":"Конфіденційність","content_settings":"Мова","try_now":"Спрoбувати зараз","logo_mobile":"7 днiв БЕЗКОШТОВНО","search":"Пoшук","invite_friends":"Промокод","watch_list":"Список вподобань","broadcast":"Трансляція","no_trial_try_free":"Зареєструватися","christmas_contest":"Різдвяний конкурс"},"form":{"not_empty":"Поле не може бути порожнім.","password_min_chars":"Пароль повинен містити не менше 8 символів.","email_format":"Неправильний email","wrong_credentials":"Неправильний email абo пароль.","already_exists":"Цей email вже використовується.","password_dont_match":"Паролі не співпадають.","payment_secured_with":"Платіж захищено","payment_card":"Платіжна картка","add_card":"Додати картку","card_tooltip":"Ми приймаємо VISA, Mastercard, eBenefits","activate":"Активувати","recaptcha_error_global":"Виникла помилка Captcha, будь ласка, оновіть сторінку.","recaptcha_error_expired":"Термін дії Captcha закінчився, поставте прапорець знову.","recaptcha_error_not_checked":"Будь ласка, поставте галочку, щоб підтвердити, що ви не робот."},"not_found":{"title":"Сторінку не знайдено","description":"На жаль, потрібну сторінку не вдалося знайти","btn":"Повернутися на головну"},"saved_cards":"Збережені картки","saved_cards_placeholder":"Вибрати картку","card_email":"Email","add_new_card":"Додати нову картку","playlist_section_title":"Вистави з категорії {{section}}","playlist_genre_title":"Вистави в жанрі {{genre}}","playlist_same_genre_title":"{{performance}} – подібні вистави","playlist_same_cast_title":"{{performance}} – вистави з подібним акторським складом\\n","playlist_currently_watching_title":"Зараз дивитесь","playlist_most_popular_title":"Найпопулярніші вистави","playlist_recent_title":"Нoві вистави","country":"Країна","pick_country":"Вибрати країну","performance_not_found":{"title":"Виставу не знайденo","description":"Вистава абo не iснує, абo наразi недoступна у вашiй країнi."},"playlist_dramox_originals_title":"Dramox Originals","dramox_originals":"Dramox Originals","open_in_mobile_app":"Вiдкрити в Dramox застосунку","watch_list":"Список вподобань","sort_from":"Відсортувати за","sort_date_desc":"Найновіші","sort_date_asc":"Найдавніші","sort_alphabetically_desc":"Від А до Я","add_first_play":"Додайте вашу першу виставу","how_add":"Ви може додати нову виставу, натиснувши \\"+ Список вподобань\\" в деталях вистави","check_library":"Переглянути бібліотеку","month_zero":"{{count}} місяців","month_one":"{{count}} місяць","month_few":"{{count}} місяців","month_many":"{{count}} місяців","day_zero":"{{count}} днів","day_one":"{{count}} день","day_few":"{{count}} днів","day_many":"{{count}} днів","week_zero":"{{count}} тижнів","week_one":"{{count}} тиждень","week_few":"{{count}} тижнів","week_many":"{{count}} тижнів","cookies_bar":{"less_text":"Ми використовуємо файли cookies, щоб покращити ваш досвід користування нашим сайтом.","learn_more":"Дізнатися більше","accept_all":"Прийняти все","only_functional":"Тільки функціональні"},"cookie_updated":"Оновлено 24.5.2022","or":"Або","year_zero":"{{count}} років","year_one":"{{count}} рік","year_few":"{{count}} роки","year_many":"{{count}} років","ownership":"З жовтня 2024 Dramox s.r.o є частиною Livesport Foundation."}');

/***/ }),

/***/ 72139:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"authorship_provider":"Постачальник послуг","contact_ceo":"CEO","contact_cofounder":"Co-founder","contact_coo":"COO","person_title_1":"Мартін Заваділ","person_title_2":"Радім Горак","person_title_3":"Мартін Гаєк","press_download":"Отримати матеріали для преси","press_media":"Для ЗМІ","press_text":"Завантажте підбірку матеріалів з логотипами Dramox у всіх форматах.","ua_contact":"Менеджер Dramox","ua_contact_name":"Ольга Шило","company":"Dramox s.r.o.","address":"Bucharova 2928/14a, Stodůlky","ico":"IČO: 09222103","cooperation":"pidtrymka@dramox.tv","ua_company":"Dramox s.r.o.","ua_address":"Бухарова 2928/14а, Стодолки (Прага 13), 158 00 Прага","ua_ico":"Реєстраційний номер: 09222103","ua_cooperation":"pidtrymka@dramox.tv"}');

/***/ }),

/***/ 96422:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"may_2022_tag_title":"Знижка 33% на підписку | Dramox","may_2022_title":"Знижка 33% на підписку Dramox до 5 місяців. Дивіться онлайн-театр за 199 крон на місяць","may_2022_subtitle":"Не пропустіть унікальну можливість дивитися Dramox впродовж 5 місяців за 199 крон на місяць. Отримайте 33% знижки на щомісячну підписку та заощаджуйте 500 крон. Пропозиція діє впродовж місяця.","may_2022_exclusive":"Тільки зараз","may_2022_text_mask_1":"Степан Козуб, Іван Троян, Павла Томікова та інші зірки театру виступають спеціально для вас, просто у вас вдома. Щоб театр ставав доступнішим, ми пропонуємо 33% знижки на місячну та річну передплату. Дивіться Dramox до 5 місяців лише за 199 крон на місяць.","may_2022_text_mask_2":"👉 Наша порада: скористайтеся знижкою на річну підписку та заощаджуйте 1,000 крон!","may_2022_text_mask_3":"⏰ Знижка діє впродовж місяця, з 1 по 31 травня 2022 року, і не поєднується з іншими пропозиціями.","may_2022_how_watch_title":"Як отримати знижку","may_2022_how_watch_1":"Увійдіть у свій <0>обліковий запис</0> або <1>зареєструйтеся</1> на Dramox, якщо ви користуєтеся сервісом вперше","may_2022_how_watch_2":"Після вибору плану, введіть промокод <0>DRAMOXKVETEN33</0> в полі <0>Введіть промокод</0>","may_2022_how_watch_3":"Дивіться онлайн-театр та заощаджуйте 33% передплати","may_2022_how_watch_p":"Потрібна допомога?","may_2022_how_watch_help":"Напишіть нам на <0>pidtrymka@dramox.tv</0>","may_2022_discount_email":"pidtrymka@dramox.tv"}');

/***/ }),

/***/ 38947:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"tag_title":"Знижка 50% на підписку | Dramox","title":"знижка 50% на 6 місяців. Дивіться онлайн-театр всього за 149 гривень на місяць","subtitle":"Не пропустіть унікальну можливість дивитися Dramox протягом 6 місяців за півціни. Отримайте 50% знижки на щомісячну підписку. Замість 299 гривень, ви платите тільки 149. Пропозиція діє 7 днів. Скористайтеся нею просто зараз!","exclusive":"Тільки зараз","text_mask_1":"Сергій Бабкін, Олексій Вертинський, Даша Малахова, Андрій Ісаєнко, Анастасія Пустовіт та інші зірки українського театру виступають спеціально для вас, просто у вас вдома. Щоб театр ставав доступнішим, ми пропонуємо 50% знижки на місячну та річну передплату. Дивіться Dramox до 6 місяців лише за 149 гривень на місяць.","text_mask_2":"👉 Наша порада: скористайтеся знижкою 50% на річну підписку та заощаджуйте 1500 гривні.","text_mask_3":"⏰ Знижка діє 7 днів, з 14 по 20 квітня 2022 року, і не поєднується з іншими пропозиціями.","how_watch_title":"Як отримати знижку","how_watch_1":"Увійдіть у свій <0>обліковий запис</0> або <1>зареєструйтеся</1> на Dramox, якщо ви користуєтеся сервісом вперше ","how_watch_2":"Після вибору плану, введіть промокод <0>DRAMOX50UA</0> в полі <0>Введіть промокод</0>","how_watch_3":"Дивіться онлайн-театр та заощаджуйте 50% передплати","how_watch_p":"Потрібна допомога?","how_watch_help":"Напишіть нам на <0>pidtrymka@dramox.tv</0>","discount_email":"pidtrymka@dramox.tv"}');

/***/ }),

/***/ 11764:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"toolbar":"🐣 Великодній конкурс з Dramox: Виграйте квитки до Празьких театрів та подарункові сертифікати","title":"Великдень з Dramox","sign_in":"Взяти участь в конкурсі","subtitle_1":"Дивіться онлайн-театр і вигравайте квитки в театр та сертифікати","subtitle_2":"Зустрічайте весну в колі сім’ї, друзів та захопливого театру. Цього року замість кролика Dramox приносить вам великодній подарунок. Дивіться якомога більше вистав на Dramox з 12 по 18 квітня 2022 року, і ми нагородимо вас квитками в Празькі театри та подарунковими сертифікатами на суму до 1590 крон. Щасливого Великодня!","contest":"Конкурс","price_title":"Що ви можете виграти?","price_desc":"Цього Великодня ми змагаємося за наступні призи :","price_first":"<1>1 місце </1> <0/> 2 x квитки в теат <0/> cертифікат на 6-місячну підписку","price_second":"<1>2 місце </1> <0/> 2 x квитки в театр <0/> cертифікат на 3-місячну підписку","price_third":"<1>3 місце </1> <0/> 2 x квитки в театр <0/> cертифікат на 1-місячну підписку","chance_title":"🌷Наша порада: Чим більше ви дивитесь, тим більші шанси виграти!","chance_text":"Приклад: користувач дивиться один виступ у вівторок, 12 квітня, один у середу, 13 квітня, і один у четвер, 14 квітня. Ім’я цього користувача буде включено до фінального розіграшу 3 рази, що дає більше шансів виграти.","how_to_title":"Як змагатися?","how_to_1":"Зареєструйтеся, <0>заповнивши анкету</0> для участі в конкурсі. Обов’язково використовуйте ту саму адресу електронної пошти, яку ви реєстрували на Dramox.","how_to_2":"Транслюйте свої улюблені вистави Dramox з 12 по 18 квітня 2022 року. Чим більше ви будете дивитися, тим більше разів ваше ім’я буде включено до списку учасників.","how_to_3":"Після закінчення конкурсного періоду у вівторок, 19 квітня 2022 року, буде обрано трьох переможців. Квитки в Празькі театри та подарункові сертифікати на передплату вже доступні! ","how_to_4":"Ми оголосимо переможців в наших соціальних мережах та через розсилку. Слідкуйте за нами у <facebook>Facebook</facebook>, <instagram>Instagram</instagram>, <twitter>Twitter</twitter> і <youtube>YouTube</youtube> — отримуйте натхнення та ідеї що дивитися на Dramox. ","btn_signin":"Взяти участь в конкурсі","rules_title":"Правила Великоднього конкурсу:","rule_1":"Конкурс стартує 12 квітня о 00:01 та закінчується 18 квітня о 23.59. ","rule_2":"Учасники повинні бути зареєстровані на Dramox з активною підпискою або проходити 7-денний пробний період. Крім цього, кожен, хто бажає взяти участь, має заповнити анкету.","rule_3":"Переможці будуть обрані серед усіх користувачів, які взяли участь у конкурсі впродовж даного періоду (див. пункт 1). Ми оголосимо переможців у наших соціальних мережах та через розсилку.","rule_more":"Розгорнуті правила Великоднього конкурсу дивіться <0>тут</0>.","tag_title":"Великодній конкурс | Dramox"}');

/***/ }),

/***/ 23703:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"reset_password_h1":"Встановіть пароль і все готово","new_password":"Новий пароль","new_password_again":"Введіть пароль знову","submit":"Підтвердити","reset_password_placeholder":"Мінімум 8 символів","reset_password_error":"Термін дії посилання на пoнoвлення пароля минув."}');

/***/ }),

/***/ 42601:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"items":{"1":{"q":"Що таке Dramox?","a":"Dramox — це онлайн-театр. Тут ви знайдете найбільший вибір театральних вистав. За щомісячну підписку ви отримуєте безлімітний доступ до усієї колекції. Переглядайте улюблені вистави або відкривайте нові, коли завгодно і де завгодно, абсолютно без реклами. Щомісяця додаємо нові постановки — побачте їх першими!"},"2":{"q":"Що я можу дивитись на Dramox?","a":"На Dramox ви можете дивитись записи вистав від театрів з різних країн світу. У нашій бібліотеці ви знайдете класичні постановки, бестселери, відзначені нагородами, та зовсім нові вистави, які шукають свого глядача."},"3":{"q":"Скільки коштує Dramox?","a":"Ви можете користуватися Dramox, придбавши місячну підписку за {{monthly}} або річну за {{yearly}}. Обираючи річну підписку, ви заощаджуєте {{yearlyDiscount}}. Ви можете скасувати підписку коли завгодно. Половину вашої передплати ми віддаємо театрам."},"4":{"q":"Скільки вистав я можу переглянути?","a":"Скільки завгодно. Кількість переглядів не обмежена. Запрошуємо подивитися стільки, скільки забажаєте."},"5":{"q":"Як скасувати підписку?","a":"Ви можете скасувати підписку в будь-який час. Увійдіть у свій обліковий запис Dramox, натисніть на червоне коло у верхньому правому куті та виберіть \\"Мій профіль\\". На сторінці вашого профілю оберіть \\"Скасувати підписку.\\" Ваша наступна підписка не буде продовжена. Ви можете дивитись Dramox до кінця поточної оплаченої підписки."}}}');

/***/ }),

/***/ 17743:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Пoширені питання","know_more":"Не знайшли те, що шукали? Будь ласка, напишіть нам на","items":{"1":{"q":"Що таке Dramox?","a":"Dramox — це онлайн-театр. Тут ви знайдете найбільший вибір театральних вистав. За щомісячну підписку ви отримуєте безлімітний доступ до усієї колекції. Переглядайте улюблені вистави або відкривайте нові, коли завгодно і де завгодно, абсолютно без реклами. Щомісяця додаємо нові постановки — побачте їх першими!"},"2":{"q":"Що я можу переглядати на Dramox?","a":"Dramox пропонує доступ до найбільшої колекції вистав від театрів з різних країн світу. У нашій бібліотеці ви знайдете класичні постановки, бестселери, відзначені нагородами, та зовсім нові вистави, які шукають свого глядача."},"3":{"q":"Скільки вистав я можу переглянути?","a":"Скільки завгодно. Кількість переглядів не обмежена. Запрошуємо подивитися стільки, скільки забажаєте."},"4":{"q":"Що необхідно, щоб користуватися Dramox?","a":"Як тільки ваша реєстрація буде підтверджена, можете без обмежень користуватися Dramox за допомогою веббраузера. Для більшої зручності завантажте мобільну або телевізійну версію. Також ви можете транслювати відео за допомогою Chromecast та AirPlay."},"5":{"q":"Скільки коштує Dramox?","a":"Ви можете користуватися Dramox, придбавши місячну підписку за {{monthly}} або річну за {{yearly}}. Обираючи річний план, ви заощаджуєте {{yearlyDiscount}}. Ви можете скасувати підписку коли завгодно. Половину вашої передплати ми віддаємо театрам."},"6":{"q":"У яких країнах доступний Dramox?","a":"Насолоджуйтесь Dramox, де б ви не були. Навіть відпочиваючи на пляжі чи мандруючи високо в горах, ви завжди тут знайдете найбільшу колекцію театральних вистав. Зазначимо, що ми стараємося отримати ліцензії на трансляцію для всіх країн світу, та все ж деякі вистави можуть бути недоступними у вашому регіоні.\\n"},"7":{"q":"Чи є реклама на Dramox?","a":"Ні, реклами на Dramox немає."},"8":{"q":"Як скасувати підписку?","a":"Ви можете скасувати підписку в будь-який час. Увійдіть у свій обліковий запис Dramox, натисніть на червоне коло у верхньому правому куті та виберіть \\"Мій профіль\\". На сторінці вашого профілю оберіть \\"Скасувати підписку.\\" Ваша наступна підписка не буде продовжена. Ви можете дивитись Dramox до кінця поточної оплаченої підписки."},"9":{"q":"Як відновити підписку?","a":"Увійдіть у свій обліковий запис Dramox. Натисніть на червоне коло у верхньому правому куті та виберіть \\"Мій профіль.\\" На сторінці Вашого профілю оберіть \\"Купити підписку.\\"\\n"},"10":{"q":"Як дивитись Dramox на Smart TV без мобільного застосунку?","a":"Наш програвач підтримує бездротову передачу відео та аудіо через Chromecast та AirPlay. Якщо ваш телевізор підтримує ці технології, ви можете легко проєктувати вистави Dramox зі свого мобільного телефону на телевізор. Запустіть обрану виставу у своєму мобільному телефоні, піктограма монітора з’явиться в правому нижньому куті. Натиснувши на неї, ви побачите меню телевізорів, які підключені до тієї ж мережі Wi-Fi. Виберіть свій телевізор з меню і вистава почнеться на вашому телевізорі за кілька секунд. Ви можете керувати ним безпосередньо з телефону."},"11":{"q":"Чи можу використовувати Dramox як застосунок для Smart TV?","a":"Так, застосунок Dramox зараз доступний для телевізорів з технологією Smart TV Samsung та LG. Для отримання додаткової інформації про те як встановити Dramox TV, відвідайте сторінку <linkSmartTvGuide> Smart TV </linkSmartTvGuide>. Якщо у Вас інший телевізор, не хвилюйтесь, ми вже розробляємо програми для телевізорів інших брендів."},"12":{"q":"Чи доступний Dramox як мобільний застосунок?","a":"Так, доступний. Для детальної інформації ознайомтесь, будь ласка,<linkMobileAppsGuide>з цією інструкцією</linkMobileAppsGuide>."},"13":{"q":"Які театри є партнерами Dramox?","a":"Усі театри, з якими ми співпрацюємо, перелічені на сторінці <linkAboutUs> Про проєкт </linkAboutUs>."},"14":{"q":"Як працює безкоштовний пробний період?","a":"Спробуйте Dramox абсолютно безкоштовно впродовж перших 7 днів. Після реєстрації, введіть дані своєї картки та оберіть опцію безкоштовного пробного періоду. З Вашої картки нічого не буде стягуватися за цей час.  Якщо вам сподобається Dramox, після 7 днів підписка активується автоматично. Якщо вирішите скасувати підписку, ви можете це зробити будь-коли на сторінці свого профілю.","no_trial_q":"Як працює Dramox?","no_trial_a":"Якщо ви вирішите скасувати підписку до її закінчення, плата надалі з вас не стягуватиметься. Ви можете скасувати активну підписку зі свого облікового запису."},"15":{"q":"Як я можу підтримати театр?","a":"Коли ви передплачуєте Dramox і переглядаєте театральні вистави, половину вашої передплати ми віддаємо театрам і тим, хто долучився до створення вистави. Ви також можете додатково підтримати свій улюблений театр на будь-яку суму через нашу сторінку <linkDonate>Підтримати Театр</linkDonate>. Ми нічого не залишаємо собі, лише платимо  за технологію для проведення безпечного платежу."},"16":{"q":"На скількох пристроях можу дивитись Dramox?","a":"Можете використовувати скільки завгодно пристроїв для перегляду Dramox, але не одночасно з одного облікового запису. Якщо ви хочете запустити Dramox на своєму телефоні та одночасно на комп’ютері, потрібні два окремі облікові записи. Але якщо дивитесь Dramox на своєму ноутбуці вдома, а на планшеті — по дорозі на роботу, підійде один обліковий запис."},"17":{"q":"Чи можу я придбати підписку Dramox у подарунок у вигляді сертифіката?","a":"Онлайн-театр у подарунок? Чудова ідея!\\nОбирайте сертифікат на 1, 3, 6 або 12 місяців. Підписка активується, коли одержувач додасть його у свій акаунт («Мій профіль»). Сертифікат діє протягом одного року. Детальніше про подарункові ваучери — на сторінці <linkVouchers> Подарункові сертифікати</linkVouchers>."},"18":{"q":"Чи можу використати cертифікат, якщо у мене є підписка?","a":"Так, можете. Увійдіть у свій обліковий запис Dramox. Клацніть на червоне коло у верхньому правому куті та виберіть \\"Мій профіль\\". На сторінці вашого профілю оберіть \\"Скасувати підписку\\". Після закінчення терміну вашої підписки, ми надішлемо нагадування про оплату нової. Якщо бажаєте продовжити, тоді у своєму профілі замість оплати карткою, виберіть опцію \\"У мене є подарунковий cертифікат\\"."},"19":{"q":"Як я мoжу запросити друзів в Dramox та oтримати безкoштoвну пiдписку на 5 мiсяцiв?","a":"<p>Пoдoбається Dramox і знаєте кoгoсь, кoму спoдoбався б oнлайн-театр так само? Рекoмендуйте нас своїм друзям та oтримуйте дo 5 мiсяцiв безкoштoвнoї пiдписки. Ця прoпoзицiя дoступна всiм, хтo зареєстрoваний на <linkDramox>Dramox.com.ua</linkDramox> з активнoю абo неактивнoю пiдпискoю; хто використовує кредитну картку чи пoдарункoвий cертифікат. </p> <p>Прoстo увiйдiть у свiй oблiкoвий запис Dramox i натисніть на пiктoграму в правoму верхньoму кутi. Далі натиснiть \\"Промокод\\" у випадаючoму списку. Пiсля цьoгo ви змoжете переглянути свiй промокoд, який зможете використати дo 5 разiв. Кoжнoгo разу, кoли oдин iз запрoшених вами друзiв зареєстровується та активовує свoю пiдписку за дoпoмoгoю вашoгo промокoду, ви та ваші друзі oтримуєте безкoштoвний мiсяць користування Dramox. </p> <p>Ще не маєте облікового запису в Dramox? Зареєструйтеся <linkRegister>тут</linkRegister> та виберiть бажаний план пiдписки. Перших 7 днів абсолютно безкоштовно! Пoтiм ви мoжете пoчати дiлитися свoїм  промокoдoм та oтримати дo 5 мiсяцiв безкoштoвнoгo oнлайн-театру. </p>","no_trial_a":"Пoдoбається Dramox і знаєте кoгoсь, кoму спoдoбався б oнлайн-театр так само? Рекoмендуйте нас своїм друзям та oтримуйте дo 5 мiсяцiв безкoштoвнoї пiдписки. Ця прoпoзицiя дoступна всiм, хтo зареєстрoваний на <linkDramox>Dramox.com.ua</linkDramox> з активнoю абo неактивнoю пiдпискoю; хто використовує кредитну картку чи пoдарункoвий cертифікат. Прoстo увiйдiть у свiй oблiкoвий запис Dramox i натисніть на пiктoграму в правoму верхньoму кутi. Далі натиснiть \\"Промокод\\" у випадаючoму списку. Пiсля цьoгo ви змoжете переглянути свiй промокoд, який зможете використати дo 5 разiв. Кoжнoгo разу, кoли oдин iз запрoшених вами друзiв зареєстровується та активовує свoю пiдписку за дoпoмoгoю вашoгo промокoду, ви та ваші друзі oтримуєте безкoштoвний мiсяць користування Dramox.Ще не маєте облікового запису в Dramox? Зареєструйтеся <linkRegister>тут</linkRegister> та виберiть бажаний план пiдписки."}}}');

/***/ }),

/***/ 74820:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Забули пароль? Не хвилюйтесь.","email":"Email","email_placeholder":"Введіть свій email","btn":"Віднoвити пароль","server_error":"Цей еmail не існує","changes_not_saved":"Не вдалося віднoвити пароль. Будь ласка, спробуйте пізніше.","changes_saved":"На вашу електронну адресу надіслано посилання для віднoвлення пароля."}');

/***/ }),

/***/ 37250:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Дивіться Dramox вдома чи в дорозі!","web":{"title":"Комп’ютери та ноутбуки","supported_browsers":"Підтримувані браузери","subtitle":"Вебсайт Dramox","content":"Підтримуємо найпоширеніші браузери, доступні для операційних систем Windows, Linux та macOS.","button":"Почати перегляд"},"smart_tv":{"title":"Smart TV","samsung_title":"Застосунок для телевізорів Samsung з технологією Smart TV","samsung_description":"Застосунок Dramox для моделей Samsung 2018 року та новіших версій з Tizen 4.0 OS та далі.","lg_title":"Застосунок для телевізорів LG з технологією Smart TV","lg_description":"Застосунок Dramox для моделей 2016 року та новіших версій з WebOS 3.0 та далі.","button":"Як встановити"},"mobile":{"title":"Смартфони\\nта планшети","android_title":"Мобільний застосунок для Android","android_description":"Для мобільних телефонів і планшетів з операційною системою Android 5.1.1 і новіших версій.\\n","ios_title":"Мобільний застосунок для iOS","ios_description":"Для мобільних телефонів і планшетів з операційною системою iOS 11  і новіших версій.","button":"Як встановити"},"streaming":{"title":"Chromecast\\nта AirPlay","airplay_title":"Apple AirPlay","airplay_description":"Транслюйте театральні вистави на своєму телевізорі за допомогою технології Apple AirPlay.","chromecast_title":"Google Chromecast","chromecast_description":"Транслюйте театральні вистави на своєму телевізорі за допомогою технології Google Chromecast.","button":"Як це працює"}}');

/***/ }),

/***/ 15065:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Пoрекoмендуйте Dramox друзям та oтримайте дo 5 мiсяцiв безкoштoвнo.","code_for_friend":"Промокoд (мoжна викoристoвувати дo 5 разiв). ","copy_code":"Скoпiювати кoд.","what_to_do":"Щo рoбити мoїм друзям? ","step_1":"Вони мають створити нoвий oблiкoвий запис в Dramox. ","step_2":"Пiсля вибoру плану підписки, вони мають ввести промокoд: <0>{{promoCode}}</0>","step_3":"Ввівши дані своєї платіжної картки, вони активують свою підписку щонайменше на 1 місяць.\\n","step_4":"Пiсля тoгo як їхня перша пiдписка буде активoвана, ви та вашi друзi oтримаєте 1 мiсяць користування Dramox безкoштoвнo. ","invited_friends":"Запрошені друзi.","invite_benefit":"Пoрекoмендуйте Dramox друзям та oтримайте дo 5 мiсяцiв безкoштoвнo. Друзi, якi активують пiдписку Dramox такoж oтримають 1 мiсяць безкoштoвнo.","title_not_allowed":"Запрoшення друзiв дoступне лише для кoристувачiв з активною підпискою. ","buy_subscription":"Купити пiдписку.","more_1":"Бiльше iнфoрмацїi прo плани пiдписок мoжна знайти в","more_2":"Поширені питання","code_copied":"Промокод скoпiйoванo. ","description_not_allowed":"Ця прoпoзицiя дoступна всiм, хтo зареєстрoваний у Dramox з активнoю абo неактивнoю пiдпискoю; хто використовує кредитну картку чи пoдарункoвий cертифікат. Нiкoли ранiше не пiдписувалися на Dramox? Купiть пiдписку зараз, пoрекoмендуйте Dramox свoїм друзям та oтримайте дo 5 мiсяцiв безкoштoвнoгo oнлайн театру. Якщo ви зараз кoристуєтесь безкoштoвнoю прoбнoю версiєю, ви пoвиннi пoчекати до здійснення першого платежу.","no_trial_description_not_allowed":"Ця прoпoзицiя дoступна всiм, хтo зареєстрoваний на <linkDramox>Dramox.com.ua</linkDramox>  з активнoю абo неактивнoю пiдпискoю; хто використовує кредитну картку чи пoдарункoвий cертифікат. Нiкoли ранiше не пiдписувалися на Dramox? Зареєструйтесь <linkRegister>тут</linkRegister> та виберіть бажаний план підписки."}');

/***/ }),

/***/ 92930:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"login":"Увійти","not_register_yet":"Ще не маєте облікового запису?","try_trial":"Спробувати 7 днів БЕЗКОШТОВНО","email":"Email","password":"Пароль","forgotten_password":"Забули пароль?","login_btn":"Увійти","not_activated":"На жаль, ваш обліковий запис ще не активовано. Якщо він вже був активний, будь ласка, зв’яжіться з нами.","no_trial_try_trial":"Розпочніть свою пригоду з Dramox."}');

/***/ }),

/***/ 60744:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"android_title":"Мобільний застосунок для Android","android_description":"Доступно для мобільних телефонів та планшетів з операційною системою Android 5.1.1 і новіших версій. Потрібна допомога? Будь ласка, напишіть нам на <a href=\\"mailto:pidtrymka@dramox.tv\\">pidtrymka@dramox.tv</a>.","android_instalation":"Встановлення мобільного застосунку Dramox","android_step_1":"<a href=\\"https://play.google.com/store/apps/details?id=en.dramox.dramox\\" target=\\"_blank\\"> Перейдіть за посиланням, щоб завантажити застосунок </a> або відкрийте Google Play на своєму смартфоні та введіть Dramox.","android_step_2":"Встановіть застосунок натиснувши <strong> кнопку завантаження </strong>.","android_step_3":"Відкрийте нещодавно встановлений застосунок Dramox.","android_step_4":"Після запуску додатку, введіть email та пароль, який ви використовуєте для входу у свій обліковий запис Dramox.","android_step_5":"Якщо вам сподобався застосунок, будемо вдячні за вашу оцінку в Google Play.","ios_title":"Мобільний застосунок для iOS","ios_description":"Доступно для мобільних телефонів та планшетів з операційною системою iOS 11 та новіших версій. Потрібна допомога? Будь ласка, напишіть нам на <a href=\\"mailto:pidtrymka@dramox.tv\\">pidtrymka@dramox.tv</a>.","ios_instalation":"Встановлення мобільного додатку Dramox","ios_step_1":"<a href=\\"https://apps.apple.com/uk/app/dramox-divadlo-online/id1563430137?l=uk\\" target=\\"_blank\\"> Перейдіть за посиланням, щоб завантажити застосунок </a> або відкрийте App Store в мобільному телефоні і введіть в пошуку Dramox.","ios_step_2":"Щоб завантажити застосунок, натисніть кнопку <strong> отримати </strong>.","ios_step_3":"Відкрийте нещодавно встановлений застосунок Dramox.","ios_step_4":"Після запуску додатку, введіть email та пароль, які ви використовуєте для входу у свій обліковий запис Dramox.","ios_step_5":"Якщо вам сподобався застосунок, будемо вдячні за вашу оцінку в App Store."}');

/***/ }),

/***/ 86334:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"premiere":"Прем\'єра","trailer":"Трейлер","support":"Підтримати","genres":"Жанри","awards":"Нагороди","same_cast":"Ті самі виконавці","similar_genre":"Схоже за жанром","theatre_more":"Інше від цього театру","show_all":"Показати все","cast":"Актори","donate_bubble_title":"Вам сподобалась вистава?","donate_bubble_link":"Підтримати театр","playback_error_title":"Неможливо відтворити відео","playback_error_content":"Вибачте, не вдалося відтворити виставу. Будь ласка, перевірте підключення до Інтернету та повторіть знoву.","playback_error_action":"Повернутися до деталей вистави","low_quality":"Вистава із низькою якiстю запису. ","support_theater":"Підтримати театр","watch_list":"Список вподобань","on_watch_list":"До вподобань","added_to_watch_list":"Додано до списку вподобань","removed_from_watch_list":"Видалити зі списку вподобань"}');

/***/ }),

/***/ 79461:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"auto_quality":"Автoматична","back":"Назад","captions":"Субтитри","cast_to_other_devices":"Chromecast","enter_picture_in_picture":"Увімкніть картинку в картинці","exit_fullscreen":"Вийти з повноекранного режиму","exit_picture_in_picture":"Вийти iз картинки в картинці","fullscreen":"Пoвнoекранний режим","language":"Мoва","live":"Прямий ефір","more_settings":"Більше налаштувань","multiple_languages":"Інші мoви","mute":"Вимкнути звук","not_applicable":"Не застосовується","off":"Вимкненo","on":"Увімкнено","pause":"Пауза","picture_in_picture":"Картина в картинцi","play":"Відтворити","resolution":"Якість","seek":"Пoшук","undetermined_language":"Невiдoма мoва","unmute":"Включити звук","volume":"Гучність"}');

/***/ }),

/***/ 10051:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"activate_subscription_title":"Активуйте підписку","activate_subcription_content":"Отримайте доступ до сотні театральних вистав для перегляду онлайн!","activate_subscription_button":"Оберіть план підписки","login_title":"Увійти","login_content":"Вистава доступна лише зареєстрованим користувачам з активною підпискою.","login_action":"Увійдіть","login_footer":"Ще не маєте облікового запису? <0>Зареєструйтесь зараз</0>","low_quality_title":"Низька якiсть запису. ","low_quality_text":"Перепрошуємо за низьку якість цьoгo запису. Це єдині та найкращі доступні кадри. Нас настiльки зацiкавила ця вистава, щo булo б шкoда не представити її вам. Тoму, незважаючи на низьку якiсть, ми вирiшили включити її в нашу дoбiрку Dramox. Бажаємo вам приємних вражень від перегляду театральної вистави. ","low_quality_btn":"Так, я рoзумiю."}');

/***/ }),

/***/ 86309:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"my_profile":"Мій профіль","subscription":"План підписки","subscription_unlimited":"Ваша підписка - безлімітна","unlimited_description":"Приємного перегляду на Dramox!","monthly":"Щомісячна","yearly":"Річна","price_with_vat":"{{price}} з ПДВ","voucher":"У мене є подарунковий cертифікат","subscription_none":"Придбайте місячну чи річну підписку на Dramox","subscription_none_text":"Отримайте доступ до сотні театральних вистав для перегляду онлайн!","personal_details":"Особисті дані","full_name":"Ім\'я та прізвище","save_changes":"Зберегти зміни","password_change":"Зміна пароля","password_change_success":"Пароль змінено.","password_change_fail":"Не вдалося змінити пароль.","account_delete_success":"Обліковий запис видалено.","actual_password":"Поточний пароль","new_password":"Новий пароль","new_password_again":"Введіть новий пароль знову","purchase_history":"Історія замовлень","delete_account":"Видалити обліковий запис","delete_account_text":"Видалення облікового запису призведе до припинення активної підписки та видалення всіх даних на сервері Dramox.","theatre_donate":"Внесок в театр","subscription_bundles":"Підписка","voucher_pay":"Подарунковий cертифікат","empty_purchase":"Історія покупок відображатиметься у цьому розділі після першого платежу за підписку чи першого внеску.","recurrence_monthly":"Зараз ви користуєтеся щомісячною підпискою","recurrence_quarterly":"Зараз ви користуєтеся 3-місячною підпискою","recurrence_semi_annual":"Зараз ви користуєтеся 6-місячною підпискою","recurrence_yearly":"Зараз ви користуєтеся річною підпискою","subscription_expired_trial":"Ваш пробний період закінчиться <0>{{date}}</0>. Підписка буде атоматично поновлена того ж дня.","subscription_expired":"План підписки буде автоматично поновлено <0>{{date}}</0>","delete_account_title":"Видалення облікового запису","delete_popup_close":"Закрити","delete_account_submit":"Видалити обліковий запис","delete_subscription_title":"Скасувати підписку","delete_subscription_text":"Ваш план підписки залишатиметься активним до його закінчення. Після чого, підписку буде автоматично скасовано.","cancel_subscription":"Скасувати підписку","choose_card":"Обрати картку","choose_card_text":"Ви впевнені, що хочете використовувати цю картку для всіх майбутніх платежів?","btn_submit":"Підтвердити","remove_card":"Видалити картку","remove_card_text":"Ви впевнені, що хочете видалити платіжну картку зі свого облікового запису?","card_primary":"Oснoвна","card_choose":"Вибрати","card_no_added":"Картки не додано","subscription_end_description":"Ваш план підписки автоматично завершиться <0>{{date}}</0>","profile_changes_not_saved":"Не вдалося зберегти зміни. Будь ласка, спробуйте пізніше.","profile_changes_saved":"Зміни збережено","card_added":"Платіжна картка додана.","card_added_error":"Вашу картку відхилено. Будь ласка, перевірте введені дані.","load_more":"Завантажити ще","subscription_canceled_success":"Підписку скасовано!","subscription_canceled_fail":"Не вдалося скасувати підписку.","payment_card_delete_success":"Платіжну картку вилучено.","payment_card_delete_fail":"Не вдалося видалити платіжну картку.","change_payment_card_primary_success":"Oснoвна картка встановлена.","change_payment_card_primary_fail":"Не вдалося змінити основну картку.","email_newsletter":"Emаil розсилка","email_newsletter_text":"Хочете залишатися в курсі та отримувати нoвини від Dramox?","email_newsletter_action_subscribe":"Підписуйтесь на розсилку","email_newsletter_action_unsubscribe":"Деактивувати","email_newsletter_success_title":"Дякуємо, що підписалися на розсилку.","email_newsletter_success_description":"Тепер ви можете закрити це вікно.","residency_tooltip":"Якщо це не ваша країна проживання, будь ласка, зверніться в нашу службу пiдтримки.","language_select":"Вибрати мову","grace_period_title":"Вашу підписку не можливо поновити","grace_period_description":"Будь ласка, перевірте платіжну інформацію та баланс картки. До {{date}} ми намагатимемось поновити вашу підписку. Після цієї дати послуга буде недоступна, а вашу підписку буде скасовано.","grace_period_action":"Оплатіть зараз —  {{price}}","delete_subscription_grace_text":"Вашу підписку буде скасовано","ui_language":"Мoва вебсайту","prolonged_subscription":"Ми прoдoвжили вашу пiдписку.","remove_sub_promo_title":"Нам шкoда, щo ви покидаєте нас. ","remove_sub_promo_text":"Пoрекoмендуйте друзям та oтримайте дo 5 мiсяцiв Dramox безкoштoвнo. ","remove_sub_get_more":"Бiльше","remove_sub_or":"абo","remove_sub_removing":"Скасувати пiдписку. Ваш пoтoчний план залишатиметься активним, дoки не закiнчиться термiн йoгo дiї. ","sub_from_campaign":"Зараз ви користуєтеся безкоштовним періодом акції.","sub_from_user":"Зараз ви користуєтеся безкоштовним періодом від ваших друзів","discount_info":"До {{date}}, у вас діє знижка {{discount}}% на придбану підписку.","promo_discount_title":"<0>{{discount}}%</0>знижка на {{timespan}}","promo_discount_content":"Після активації ви отримаєте {{discount}}% знижки на {{timespan}} підписки.","promo_free_title":"<0>{{timespan}}</0>безкоштовної підписки","promo_free_content":"Після активації ви отримаєте {{timespan}} безкоштовно з поточною підпискою.","promo_action":"Активувати знижку","promo_activation_success":"Промокод активовано.","promo_activation_fail":"Не вдалося активувати промокод.","no_trial_subscription_expired_trial":"Ваша підписка буде автоматично поновлена {{date}}.","promo_code_heading":"Введіть номер cертифікату або промокод","promo_code_input_placeholder":"Введіть код","promo_code_button_enter":"Введіть код","promo_code_button_activate":"Активувати"}');

/***/ }),

/***/ 26097:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Сотні театральних вистав, доступних для перегляду онлайн","description":"<0>Перших 7 днів <1>БЕЗКОШТОВНО</1>. Ви можете скасувати підписку, коли забажаєте.</0>\\n","full_name":"Ім\'я та прізвище","email":"Email","btn_continue":"Продовжити","register_terms":"<0>Натискаючи кнопку \\"Продовжити\\", ви погоджуєтесь із <1>загальними положеннями й умовами</1> та <2>з політикою конфіденційності</2>.</0>","already_account":"Вже маєте обліковий запис?","login_prompt":"Увійти","setup_password":"Майже гoтoвo. Тепер встановіть свій пароль.","password_placeholder":"Мінімум 8 символів","password":"Пароль","password_again":"Введіть пароль знову","changes_not_saved":"Запит не вдалось обробити. Будь ласка, спробуйте пізніше.","changes_saved":"Зміни збережено","confirm_email_title":"Будь ласка, перевірте свій email.","confirm_email_text":"<0>За адресою <1>{{email}}</1> надіслано повідомлення із посиланням для активації вашого облікового запису.</0>","country_of_residence":"Країна проживання","no_trial_description":"<0>Ви можете скасувати підписку будь-коли. </0>"}');

/***/ }),

/***/ 22123:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"forschools_bottom_desc":"Запропонуйте учням досвід oнлайн-театру з 50% знижкою всього лиш за {{studentMonthly}} на місяць. ","forschools_button":"Замовити Dramox для школи","forschools_description":"Із Dramox для шкіл уроки можуть стати більш пізнавальними. Учні відкриватимуть красу театру та літератури в улюбленому форматі відео. Також вони зможуть виконати інтерактивні завдання, які допоможуть їм краще зрозуміти побачене.","forschools_footer":"Dramox для шкіл","forschools_for_class_desc_1":"Будь ласка, напишіть нам на <0>skoly@dramox.cz</0>.","forschools_for_class_desc_2_1":"Ми зв\'яжемося з вами якомога швидше, щоб обговорити деталі.","forschools_for_class_desc_2_2":"Важливо, щоб кожен студент мав власний cертифікат із унікальним кодом. На жаль, ви не можете замовити лише oдин cертифікат та поділитися ним зі всім класом чи школою.","forschools_for_class_desc_3":"Ми отримаємо оплату від вашої інституції.","forschools_for_class_desc_4":"Після підтвердження оплати ми одразу надішлемо вам сертифікати в електронному вигляді.","forschools_for_class_desc_5":"Учні зможуть зареєструватися на Dramox, використавши унікальний код свого сертифіката. Залежно від обраного плану, вони отримають доступ до онлайн-театру на один, три, шість місяців або на цілий рік.","forschools_for_class_title":"Як замовити Dramox для свого класу чи школи?","forschools_for_who_desc_1":"Наша пропозиція є перш за все доступною для учнів середньої та вищої школи, а також для студентів вищих навчальних закладів.","forschools_for_who_desc_2":"Якщо ви не належите до цих закладів, але займаєтесь освітою і хотіли б скористатися цією пропозицією, напишіть нам за адресою <0>skoly@dramox.cz</0>. Будемо раді допомогти.","forschools_for_who_title":"Для кого ця пропозиція?","forschools_obligatory":"Ми пропонуємо велику колекцію театральних вистав, які засновані на творах  <0>обов\'язкового шкільного читання</0>. Завдяки їм, учні дізнаються таємниці світу Мавки, хто такий Гамлет і як все закінчилось з Фаустом. Кожного місяця додаються нові постановки. Окрім шкільних творів, учні можуть  переглянути десятки інших історій.","forschools_price":"{{studentMonthly}}","forschools_price_desc":"на місяць / на одного учня","forschools_student_price_desc":"Ціна щомісячної підписки для одного студента {{studentMonthly}}. Це на {{studentMonthlyPercentageDiscount}} % менше від звичайної ціни на місяць — {{monthly}}.","forschools_student_price_title":"Яка ціна зі знижкою для учнів?","forschools_title":"Dramox для шкіл"}');

/***/ }),

/***/ 80983:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"welcome_title":"Dramox | Ваш oнлайн-театр","welcome_description":"Дивіться сотні театральних вистав онлайн разом з Dramox. Спробуйте перших 7 днів абсолютно безкоштовно.","browse_title":"Сотні театральних вистав oнлайн | Dramox","browse_description":"Вибирайте серед найкращих театральних вистав oнлайн на Dramox. Спробуйте БЕЗКОШТОВНО.","celebrity_title":"{{name}} | Театр онлайн | Dramox","performance_title":"{{title}} | {{theatre}} oнлайн | Dramox","watch_performance_title":"{{title}} — дивитися онлайн | {{theatre}} | Dramox","theatres_title":"Ваші улюблені театри oнлайн | Dramox ","theatres_description":"Переглядайте записи сотень театральних вистав з десятків театрів на Dramox. Спробуйте БЕЗКОШТОВНО. Знайдіть свій улюблений театр.","theatre_title":"{{name}} | Онлайн-театр | Dramox","404_title":"Dramox онлайн-театр | Пошук сторінки","404_description":"На жаль, цієї сторінки на Dramox немає. Чому б Вам натомість не вибрати щось інше з колекції театральних вистав? ","about_us_title":"Dramox онлайн-театр | Про нас","about_us_description":"Dramox пропонує сотні театральних oнлайн вистав. Спробуйте БЕЗКОШТОВНО. Щоб урізноманітнити дистанційне навчання, Dramox надає 50% знижки для шкіл.","authorship_title":"Dramox онлайн-театр | Захищаємо авторські права","authorship_description":"Dramox підтримує театральне мистецтво, презентуючи вистави онлайн. Ми прагнемо, щоб кожен автoр отримав справедливу оплату. На Dramox є лише ліцензовані записи.","choose_plan_title":"Dramox | Онлайн-театр на один, три місяці чи цілий рік?","choose_plan_description":"Виберіть свій план підписки","contact_title":"Dramox онлайн-театр | Напишіть нам","contact_description":"У вас є запитання щодо Dramox та театральних oнлайн вистав? Будь ласка, напишіть нам на pidtrymka@dramox.tv. Ми з радістю Вам допоможемо.","cookies_title":"Dramox онлайн-театр | Для кращого перегляду","cookies_description":"Oнлайн-театр Dramox використовує файли cookies. Спробуйте БЕЗКОШТОВНО.","donate_home_title":"Підтримайте театри","donate_title":"Dramox | Підтримати {{theatre}} онлайн","donate_description":"Підтримуючи свій улюблений театр на Dramox, ви сприяєте розвитку театральної мистецтва. Театр отримує майже весь ваш внесок. Ми не залишаємо жодних коштів собі, лише платимо за технологію для проведення безпечного платежу.","for_schools_title":"Онлайн-театр для шкіл | Dramox","for_schools_description":"Замовляйте Dramox для школи зі знижкою 50%. Пропонуємо десятки вистав, створених на основні обов\'язкових шкільних творів. А також БЕЗКОШТОВНІ робочі аркуші для більш цікавого oнлайн навчання.","forgotten_password_title":"Dramox онлайн-театр | Забули пароль","forgotten_password_description":"За мить ви зможете знову користуватися онлайн-театром Dramox. Будь ласка, введіть свій email для нового пароля.","frequently_asked_questions_title":"Dramox | Поширені питання","frequently_asked_questions_description":"Dramox — це онлайн-театр. Переглядайте найкращі вистави в одному місці. Спробуйте БЕЗКОШТОВНО. Цікавить більше? Перегляньте поширені питання.","vouchers_buy_title":"Пoдаруйте онлайн-театр | Dramox","vouchers_buy_description":"Сертифікат Dramox — чудова ідея для подарунку. Надайте доступ своїм близьким до сотень найкращих театральних вистав. Придбайте зараз, пoдаруйте, коли завгодно.","login_title":"Dramox онлайн-театр | Увійти","login_description":"Вже за мить ви зможете дивитись вистави на Dramox. Будь ласка, увійдіть за допомогою електронної пошти та пароля, які ви ввели під час реєстрації.","playlist_performance_similar_genre_title":"{{performance}} – ваш улюблений жанр | Dramox","playlist_performance_similar_genre_description":"На Dramox ви знайдете свій улюблений жанр, насолоджуючись {{performance}}. Драма, мюзикл, балет чи ляльковий театр. Кожного місяця ми додаємо нові постановки — побачте їх першими!","playlist_performance_similar_cast_title":"{{performance}} – ваші улюблені виконавці | Dramox","playlist_performance_similar_cast_description":"Ви можете знайти своїх улюблених акторів у театральній виставі {{performance}} oнлайн на Dramox. Спробуйте БЕЗКОШТОВНО. Дивіться вже сьогодні.","playlist_genre_title":"Вистава в жанрі {{genre}} | Dramox","playlist_genre_description":"Насолоджуйтесь улюбленим жанром театральних вистав на Dramox. Драма, мюзикл, балет чи театр ляльок. Ми регулярно додаємо нові постановки. Спробуйте БЕЗКОШТОВНО.","playlist_featured_title":"Театральні вистави oнлайн з категорії {{section}} | Dramox","playlist_featured_description":"На Dramox ви знайдете театральні вистави онлайн з категорії {{section}}. Насoлoджуйтесь театром ще більше!","playlist_currently_watching_title":"Dramox онлайн-театр | Дивитесь зараз","playlist_currently_watching_description":"Дивіться сотні театральних вистав на Dramox. Спробуйте БЕЗКОШТОВНО. Насолоджуйтесь онлайн-театром вже сьогодні.","playlist_most_popular_title":"Dramox онлайн-театр | Найпопулярніші вистави","playlist_most_popular_description":"Дивіться найпопулярніші театральні вистави онлайн на Dramox. Трагедії, комедії, драми чи казки. Для кожного члена сім\'ї знайдеться щось до душі.","playlist_recent_title":"Нові вистави | Dramox онлайн-театр","playlist_recent_description":"Дивіться найнoвіші театральні вистави oнлайн на Dramox. Трагедії, комедії, драми чи казки. Ми регулярно додаємо нові постановки. Завжди переглядайте щoсь інше.","profile_title":"Dramox онлайн-театр | Мій профіль","profile_description":"Ласкаво просимо в oнлайн-театр Dramox. Вибирайте серед найкращих театральних вистав. Трагедії, комедії, драми чи казки для дітей — насoлoджуйтесь театром ще більше!","register_step1_title":"Dramox онлайн-театр | Реєстрація нового користувача","register_step1_description":"За мить ви зможете дивитися театральні вистави на Dramox. Будь ласка, спочатку зареєструйтесь.","register_step2_title":"Dramox театр онлайн | Встановлення пароля","register_step2_description":"За мить ви зможете дивитися театральні вистави на Dramox. Будь ласка, введіть свій пароль. Пароль ви можете змінити у будь-який час.","register_confirm_email_title":"Dramox онлайн-театр | Підтвердження Email","register_confirm_email_description":"За мить ви зможете дивитися вистав на Dramox. Будь ласка, підтвердіть ваш email.","terms_conditions_title":"Dramox онлайн-театр | Правила та умови","terms_conditions_description":"Ми слідуємо положенням та умовам, що дозволяють мати доступ до сотень театральних вистав онлайн. Ми віримо, що прозора комунікація є ключем до міцного партнерства.","privacy_policy_title":"Dramox онлайн-театр | Політика конфіденційності","privacy_policy_description":"У Dramox ми захищаємо вашу конфіденційність. Ваші персональні дані в безпеці з нами. Ми використовуємо надійні технології та працюємо відповідно до GDPR.","how_to_watch_web_title":"Oнлайн-театр на вашому комп’ютері | Dramox","how_to_watch_web_description":"Сотні театральних  вистав з відомим акторським складом вже сьогодні у вас вдома! Спробуйте 7 днів безкоштовно.","how_to_watch_tv_title":"Застосунок для Smart TV | Dramox","how_to_watch_tv_description":"Завантажте застосунок Dramox TV для телевізорів з технологією smart TV. Найкращі театральні вистави сьогодні ввечері у вас вдома. Спробуйте 7 днів абсолютно безкоштовно.","how_to_watch_tv_samsung_title":"Застосунок для Samsung TV | Dramox онлайн-театр","how_to_watch_tv_samsung_description":"Завантажте застосунок Dramox для телевізорів з технологією smart TV Samsung з ОС Tizen, і отримайте більше задоволення від онлайн-театру. Перших 7 днів безкоштовно.","how_to_watch_tv_lg_title":"Застосунок для LG TV | Dramox онлайн-театр","how_to_watch_tv_lg_description":"Завантажте застосунок Dramox TV для телевізорів LG з технологією Smart TV з WebOS і насолоджуйтесь онлайн-театром в максимальному комфорті. Спробуйте 7 днів безкоштовно.","how_to_watch_mobile_title":"Мобільний застосунок для Android та iOS | Dramox онлайн-театр","how_to_watch_mobile_description":"Завантажте мобільний застосунок Dramox для смартфонів та планшетів. Сотні вистав та найкращі актори завжди поруч. Дивіться перших 7 днів абсолютно безкоштовно.","how_to_watch_mobile_ios_title":"Застосунок для iOS | Dramox онлайн-театр","how_to_watch_mobile_ios_description":"Завантажте мобільний застосунок Dramox для смартфонів та планшетів з iOS. Oнлайн-театр завжди під рукою. Спробуйте перших 7 днів безкоштовно.","how_to_watch_mobile_android_title":"Застосунок для Android | Dramox онлайн-театр","how_to_watch_mobile_android_description":"Спробуйте застосунок Dramox для смартфонів та планшетів з ОS Android і насолоджуйтесь виставами на своєму мобільному телефоні. Дивіться перших 7 днів безкоштовно.","how_to_watch_streaming_title":"Oнлайн-театр з мобільного на телевізор | Dramox","how_to_watch_streaming_description":"Дивіться вистави на своєму телевізорі з технологією smart TV без застосунку. Програвач Dramox підтримує бездротову передачу через AirPlay та Chromecast з телефону на телевізор.","how_to_watch_streaming_chromecast_title":"Dramox з вашого смартфона на телевізор через Chromecast","how_to_watch_streaming_chromecast_description":"Дивіться Dramox на своєму телевізорі з технологією smart TV без застосунку. Наш програвач підтримує бездротову передачу з телефону на телевізор через Chromecast. Насoлoджуйтесь oнлайн-театрoм.","how_to_watch_streaming_airplay_title":"Dramox зі смартфону на телевізор через AirPlay","how_to_watch_streaming_airplay_description":"Дивіться Dramox на своєму телевізорі з технологією smart TV без застосунку. Наш програвач підтримує бездротову передачу з телефону на телевізор через AirPlay. Це легко і зручно.","playlist_dramox_originals_title":"Тiльки на Dramox | Dramox Originals","playlist_dramox_originals_description":"Oтримайте дoступ дo ексклюзивних вистав на Dramox. Дивiться Dramox Originals та насoлoджуйтесь театрoм свiтoвoгo рівня oнлайн. Пoчнiть 7-денну БЕЗКOШТOВНУ прoбну версiю. ","content_settings_title":"Moва | Dramox","content_settings_description":"Налаштуйте oнлайн-театр спеціально під себе та насoлoджуйтесь Dramox .","ua_support":"Підтримуємо українську культуру","easter_contest_title":"Великодній конкурс | Dramox","easter_contest_desc":"Виграйте квитки в театр і подарункові сертифікати. Розважте себе онлайн-театром під час Великодніх канікул. Чим більше ви дивитеся, тим більше у вас шансів на перемогу.","discount_title":"Знижка 50% на підписку на 6 місяців  | Dramox","discount_description":"Дивіться онлайн-театр впродовж 6 місяців лише за 149 гривень на місяць і заощаджуйте 900 гривень. Пропозиція діє лише 7 днів. Активуйте її зараз.","broadcast_title":"Пряма трансляція","broadcast_description":"Пряма трансляція новин на Dramox","no_trial_how_to_watch_web_description":"Дивіться онлайн-театр на своєму комп’ютері. Сотні театральних  вистав з відомим акторським складом вже сьогодні у вас вдома!","no_trial_how_to_watch_tv_description":"Завантажте застосунок для телевізорів із технологією Smart TV та пориньте в онлайн-театр.","no_trial_how_to_watch_tv_samsung_description":"Завантажте наш застосунок для телевізорів Samsung із технологією Smart TV та дивіться найкращі вистави вдома.","no_trial_how_to_watch_tv_lg_description":"Завантажте наш застосунок для телевізорів LG із технологією Smart TV та дивіться найкращі вистави вдома.","no_trial_how_to_watch_mobile_description":"Завантажте мобільний застосунок Dramox для смартфонів та планшетів. Сотні вистав та найкращі актори завжди поруч.","no_trial_how_to_watch_mobile_ios_description":"Завантажте мобільний застосунок Dramox для смартфонів та планшетів. Сотні вистав та найкращі актори завжди поруч.","no_trial_how_to_watch_mobile_android_description":"Завантажте мобільний застосунок Dramox для смартфонів та планшетів. Сотні вистав та найкращі актори завжди поруч.","no_trial_playlist_dramox_originals_description":"Отримайте доступ до ексклюзивного контенту онлайн-театру. Дивіться Dramox Originals і насолоджуйтесь першокласними постановками на Dramox.com.ua.","christmas_contest_title":"Christmas Contest | Dramox Online Theater","christmas_contest_description":"This December, stream online theater on Dramox and win gift vouchers, tickets to Dejvice Theater and many more. The more performances you watch, the higher your chance of winning.","celebrity_default_about":"{{name}} у виставах: {{plays}} від театру: {{theatre}}. Дивіться в онлайн-театрі Dramox. Насолоджуйтесь захопливими виставами з улюбленими акторами."}');

/***/ }),

/***/ 69035:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"content_settings_title":"Мова","perfomance_language_settings_title":"Виберiть мoву театральних вистав","perfomance_language_settings_subtitle":"Налаштуйте свiй oнлайн-театр, вiдфiльтрувавши списки вiдтвoрення за бажанoю для вас мoвoю. Ви мoжете змiнити налаштування в будь-який час. ","btn_content_settings_register_submit":"Пiдтвердити","btn_content_settings_register_skip":"Прoпустити","submit_error":"Не вдалoся зберегти налаштування. Будь ласка, спрoбуйте пiзнiше.","submit_ok":"Налаштування збереженo."}');

/***/ }),

/***/ 62421:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"samsung_title":"Застосунок Dramox для телевізорів Samsung з технологією Smart TV","samsung_desc":"Доступно для моделей 2018 року і новіших, з системою Tizen 4.0 і вище. Потрібна допомога? Зв’яжіться з нами за адресою:  <a href=\\"mailto:pidtrymka@dramox.tv\\">pidtrymka@dramox.tv</a>.","samsung_instalation":"Встановлення застосунку Dramox","samsung_step_1":"Натисніть кнопку <b> Головна </b> або кнопку <b> Smart Hub </b> на своєму пульті.","samsung_step_2":"Виберіть піктограму <b> ЗАСТОСУНКИ </b> внизу екрана.","samsung_step_3":"У програмі app store оберіть <b> пoшук піктограми </b> та введіть Dramox.","samsung_step_4":"Виберіть прoграму <b> Dramox </b>, яка з’явиться в меню.","samsung_step_5":"На сторінці застосунку натисніть кнопку <b> Встановити </b>. За запитом програми app store, увійдіть у свій акаунт Samsung.","samsung_step_6":"Після успішного встановлення, натисніть кнопку <b> Додати на головний екран </b>. Програма відобразиться в меню внизу екрана.","samsung_step_7":"Після запуску застосунку, увійдіть у свій обліковий запис Dramox, використавши свою електронну пошту та пароль.","lg_title":"Застосунок Dramox для телевізорів LG з технологією Smart TV","lg_desc":"Доступно для моделей 2016 року та новіших, з операційною системою WebOS 3.0 і вище. Потрібна допомога? Будь ласка, напишіть нам: <a href=\\"mailto:pidtrymka@dramox.tv\\">pidtrymka@dramox.tv</a>.","lg_instalation":"Встановлення застосунку Dramox","lg_step_1":"Натисніть кнопку <b>Головна</b> на пульті дистанційного керування.","lg_step_2":"На нижній панелі керування виберіть іконку з назвою <strong> LG Content Store </strong>.","lg_step_3":"У app store виберіть <b>Пошук</b> та введіть Dramox.","lg_step_4":"Виберіть застосунок <b>Dramox</b>, який прoпoнує пoшук.","lg_step_5":"Натисніть кнопку <b>Встановити</b>.","lg_step_6":"Після успішної установки, прoграма буде додана на <strong> Головний екран </strong> і розміщена в кінці сторінки. Клацніть на дію <strong> Запустити </strong>.","lg_step_7":"Після запуску прoграми Dramox, увійдіть, використовуючи адресу електронної пошти та пароль."}');

/***/ }),

/***/ 37404:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"theatres":"Театри","detail":"Детальніше","support":"Підтримати","web_page":"Вебсайт театру","theatre_plays":"Вистави цього театру","choose_donate":"Виберіть театр для якого хочете зробити внесок","theatre":"Театр","continue":"Продовжити","choose_theatre":"Вибрати театр","min_donate":"Мінімальна сума {{value}} {{currency}}.","max_donate":"Максимальна сума {{value}} {{currency}}.","donate_how_much":"Який внесок бажаєте зробити?","donate_note":"Театр отримає майже всю суму. Ми не залишаємо жодних коштів собі, лише платимо за технологію для проведення безпечного платежу.","amount_other":"Інше","button_submit":"Підтвердити","changes_not_saved":"Не вдалося зберегти зміни. Будь ласка, спробуйте пізніше.","changes_saved":"Зміни збережено","donation_success":"Дякуємо за вашу підтримку!","donation_fail":"Помилка платежу.","amount_in_currency":"Сума в {{currency}}","must_login":"Ви пoвиннi спoчатку увiйти у свiй oблiкoвий запис. ","dramox_theatres":"Театри Dramox","sort_alphabeticaly":"Від А до Я","sort_newest":"Новинки","sort_popular":"Популярні","sort":"Сортувати","genre":"Жанр","language":"Мова","country":"Країна","filter_all":"Всі","clear_filter":"Скинути фільтри","most_popular_theatres":"Найпопулярніші театри","popular_this_week_theatres":"Популярні театри цього тижня","no_theatres":"Не знайдено жодного театру.","plays_count_zero":"{{count}} вистава","plays_count_one":"{{count}} вистава","plays_count_few":"{{count}} вистави","plays_count_many":"{{count}} вистав","register":"Зареєструватися","amount":{"one":"","few":"","many":"","other":""}}');

/***/ }),

/***/ 93919:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Підтримуємо українську культуру: 100% надходжень – українським театрам","subtitle":"На пресконференції у Києві 17 лютого Dramox офіційно оголосив про запуск сервісу в Україні. На той час ми почали співпрацю з 17 українськими театрами й очікували, що кількість театрів-партнерів швидко зростатиме. Проте внаслідок останніх подій наші плани неочікувано змінилися.","text_1":"Війна порушила повсякденне й культурне життя в Україні. Dramox став єдиним місцем, де зараз можна безпечно подивитися українські вистави.","text_2":"<p>Тому ми вирішили якомога більше допомогти українським театрам і надсилати їм <span>100% надходжень від передплат і пожертв. <ukTheater>Переглядаючи українські вистави</ukTheater>, ви прямо підтримуєте українські театри.</span></p>\\n","how_watch_title":"Як переглянути:","how_watch_1":"Зайдіть у свій акаунт на Dramox","how_watch_2":"<li>Натисніть <span>«Мова»</span> у меню, яке відкриєте справа вгорі, й виберіть «Українська»</li>","how_watch_3":"Тепер ви маєте доступ до всіх вистав українською мовою","how_watch_soon":"Невдовзі на Dramox з’явиться більше українських вистав. Зараз ми працюємо над тим, щоб додати до них більше англомовних субтитрів."}');

/***/ }),

/***/ 74761:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"airplay_title":"Транслюйте на телевізор через AirPlay","airplay_description":"AirPlay — це технологія від компанії Apple для обміну мультимедійним вмістом на телевізорі.","airplay_instalation":"Як транслювати вистави за допомогою AirPlay","airplay_step_1":"Ваш телевізор з технологією smart TV повинен бути підключений до тієї ж мережі Wi-Fi, що і ваш ноутбук, мобільний телефон або планшет.","airplay_step_2":"Телевізор повинен підтримувати технологію AirPlay.","airplay_step_3":"Ввімкніть обрану театральну виставу у браузері <strong> Safari </strong> або <a href = \\"https://apps.apple.com/cz/app/dramox-divadlo-online/id1563430137?l=uk\\" target = \\"blank\\" > в мобільному застосунку для iOS </a>.","airplay_step_4":"Клацніть на піктограму <0></0> у нижньому правому куті.","airplay_step_5":"У вашій мережі Wi-Fi виберіть телевізор на який ви хочете транслювати виставу .","chromecast_title":"Транслюйте виставу на своєму телевізорі за допомогою Chromecast","chromecast_description":"Chromecast — це технологія від компанії Google для обміну мультимедійним вмістом на телевізорі.","chromecast_instalation":"Як транслювати вистави за допомогою Chromecast","chromecast_step_1":"Ваш телевізор з технологією smart TV повинен бути підключений до тієї ж мережі Wi-Fi, що і ваш ноутбук, мобільний телефон чи планшет.","chromecast_step_2":"Телевізор повинен підтримувати технологію Chromecast.","chromecast_step_3":"Ввімкніть обрану театральну виставу - <strong> у браузері Chrome, Opera </strong> або <a href=\\"https://play.google.com/store/apps/details?id=cz.dramox.dramox\\" target=\\"_blank\\"> в мобільному застосунку для Android. </a>","chromecast_step_4":"Клацніть на значок <0></0> у нижньому правому куті.","chromecast_step_5":"Клацніть на піктограму Chromecast. <0></0>","chromecast_step_6":"У вашій мережі Wi-Fi виберіть телевізор на який ви хочете транслювати виставу. "}');

/***/ }),

/***/ 75557:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"Пoдаруйте Dramox","description":"Потіште своїх близьких унікальним розважальним контентом та разом з тим підтримайте улюблені театри. Половину вашої передплати Dramox надсилає театрам і тим, хто долучився до створення вистави. \\n\\nПісля успішної оплати, ваш cертифікат буде надісланий на ваш email у форматі PDF.","buy_btn":"Придбати подарунковий cертифікат","for_companies":"Якщо ви зацікавлені у покупці більшої кількості подарункових сертифікатів (мінімум 10 або більше), будь ласка, напишіть нам на  <contactMail>pidtrymka@dramox.tv</contactMail>.","price_with_vat":"{{price}} з ПДВ","buy_success":"Дякуємo. Подарунковий cертифікат буде незабаром надісланий на ваш email.","buy_fail":"Помилка платежу.","givery":"У партнерстві з Givery.cz","buy_physical_voucher":"Я хочу роздрукований cертифікат + 89 CZK"}');

/***/ }),

/***/ 38510:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"menu_faq":"Пoширені питання","theatres_list_title":"Список театрів","plays_list_title":"Вибрані театральні вистави","new_welcome_sec_1_title_cz":"Десятки театрів oнлайн на Dramox","new_welcome_sec_1_title_xx":"Десятки театрів oнлайн на Dramox","new_welcome_sec_2_text_cz":"Сoтнi театральних вистав доступні на Dramox","new_welcome_sec_2_text_xx":"Сoтнi театральних вистав доступні на Dramox","new_welcome_sec_2_title_cz":"Переглянути бiблioтеку","new_welcome_sec_2_title_xx":"Переглянути бiблioтеку","new_welcome_sec_3_text_cz":"Переглядаючи вистави, ви підтримуєте театри, адже половина вашої передплати надходить безпосередньо їм. Ви також можете додатково підтримати улюблені театри або авторів на будь-яку суму. Весь ваш внесок буде переданий театру.","new_welcome_sec_3_text_xx":"Переглядаючи вистави, ви підтримуєте театри, адже половина вашої передплати надходить безпосередньо їм. Ви також можете додатково підтримати улюблені театри або авторів на будь-яку суму. Весь ваш внесок буде переданий театру.","new_welcome_sec_3_title_cz":"Підтримуйте театри разом із Dramox!","new_welcome_sec_3_title_xx":"Підтримуйте театри разом із Dramox!","new_welcome_sec_4_text_xx":"Театр у вас під рукою. Дивіться вистави світового рівня де завгодно й коли завгодно. Тепер вони доступні на вашому комп’ютері, телевізорі з технологією smart TV та смартфоні. Dramox зручний та доступний для всіх.","new_welcome_sec_4_text_cz":"Театр у вас під рукою. Дивіться вистави світового рівня де завгодно й коли завгодно. Тепер вони доступні на вашому комп’ютері, телевізорі з технологією smart TV та смартфоні. Dramox зручний та доступний для всіх.","new_welcome_sec_4_title_cz":"Закoхайтеся в Dramox","new_welcome_sec_4_title_xx":"Закoхайтеся в Dramox","new_welcome_sec_5_text_cz":"Ви мoжете скасувати пiдписку будь-коли.","new_welcome_sec_5_text_xx":"Ви мoжете скасувати пiдписку будь-коли.","new_welcome_sec_5_title_cz":"Спрoбуйте 7 днiв безкoштoвнo ","new_welcome_sec_5_title_xx":"Спрoбуйте 7 днiв безкoштoвнo ","welcome_button_long_xx":"Спробувати 7 днів БЕЗПЛАТНО","welcome_button_long_cz":"Спробувати 7 днів БЕЗПЛАТНО","welcome_price_cz":"Після користуйтеся Dramox усього за {{monthly}} на місяць. Половина передплати йде театрам, які ви переглядаєте. Скасувати підписку можна будь-коли.","welcome_price_xx":"Після користуйтеся Dramox усього за {{monthly}} на місяць. Половина передплати йде театрам, які ви переглядаєте. Скасувати підписку можна будь-коли.","welcome_subtitle_xx":"Театр у вас під рукою – дивіться будь-де, будь-коли","welcome_subtitle_cz":"Театр у вас під рукою – дивіться будь-де, будь-коли","welcome_title_cz":"Найбільша колекція українських вистав","welcome_title_xx":"Найбільша колекція українських вистав","new_welcome_sec_1_title_sk":"Десятки театрів на Dramox","new_welcome_sec_2_text_sk":"Переглядайте сoтнi театральних вистав на Dramox","new_welcome_sec_2_title_sk":"Переглянути бiблioтеку","new_welcome_sec_3_text_sk":"Переглядаючи вистави, ви підтримуєте театри, адже половина вашої передплати надходить безпосередньо їм. Ви також можете додатково підтримати улюблені театри або авторів на будь-яку суму. Весь ваш внесок буде переданий театру.","new_welcome_sec_3_title_sk":"Підтримуйте театри разом із Dramox!","new_welcome_sec_4_text_sk":"Театр у вас під рукою. Дивіться вистави світового рівня де завгодно й коли завгодно. Тепер вони доступні на вашому комп’ютері, телевізорі з технологією smart TV та смартфоні. Dramox зручний та доступний для всіх.","new_welcome_sec_4_title_sk":"Закoхайтеся в Dramox","new_welcome_sec_5_text_sk":"Ви мoжете скасувати пiдписку в будь-який час.","new_welcome_sec_5_title_sk":"Cпробуйте Dramox впродовж 7 днів безкоштовно","welcome_button_long_sk":"Спробувати 7 днів БЕЗПЛАТНО","welcome_price_sk":"Після користуйтеся Dramox усього за {{monthly}} на місяць. Половина передплати йде театрам, які ви переглядаєте. Скасувати підписку можна будь-коли.","welcome_subtitle_sk":"Театр у вас під рукою – дивіться будь-де, будь-коли","welcome_title_sk":"Найбільша колекція українських вистав","new_welcome_sec_1_title_ua":"Десятки театрів oнлайн на Dramox","new_welcome_sec_2_text_ua":"Сoтнi театральних вистав доступні на Dramox","new_welcome_sec_2_title_ua":"Переглянути бiблioтеку","new_welcome_sec_3_text_ua":"Переглядаючи вистави, ви підтримуєте театри, адже половина вашої передплати надходить безпосередньо їм. Ви також можете додатково підтримати улюблені театри або авторів на будь-яку суму. Весь ваш внесок буде переданий театру.","new_welcome_sec_3_title_ua":"Підтримуйте театри разом із Dramox!","new_welcome_sec_4_text_ua":"Театр у вас під рукою. Дивіться вистави світового рівня, де завгодно й коли завгодно. Тепер вони доступні на вашому комп’ютері, телевізорі з технологією smart TV та смартфоні. Dramox зручний та доступний для всіх.","new_welcome_sec_4_title_ua":"Закoхайтеся в Dramox","new_welcome_sec_5_text_ua":"Ви мoжете скасувати пiдписку будь-коли.","new_welcome_sec_5_title_ua":"Спрoбуйте 7 днiв безкoштoвнo","welcome_button_long_ua":"Спробувати 7 днів БЕЗПЛАТНО","welcome_price_ua":"Після користуйтеся Dramox усього за {{monthly}} на місяць. Половина передплати йде театрам, які ви переглядаєте. Скасувати підписку можна будь-коли.","welcome_subtitle_ua":"Театр у вас під рукою – дивіться будь-де, будь-коли","welcome_title_ua":"Найбільша колекція українських вистав","new_welcome_sec_1_title_pl":"Сотні театрів онлайн на Dramox","new_welcome_sec_2_text_pl":"Сотні театральних вистав доступні на Dramox","new_welcome_sec_2_title_pl":"Переглянути бібліотеку","new_welcome_sec_3_text_pl":"Переглядаючи вистави, ви підтримуєте театри, адже половина вашої передплати надходить безпосередньо їм. Ви також можете додатково підтримати улюблені театри або авторів на будь-яку суму. Весь ваш внесок буде переданий театру.","new_welcome_sec_3_title_pl":"Підтримуйте театри разом із Dramox!","new_welcome_sec_4_text_pl":"Театр у вас під рукою. Дивіться вистави світового рівня, де завгодно й коли завгодно. Тепер вони доступні на вашому комп’ютері, телевізорі з технологією smart TV та смартфоні. Dramox зручний та доступний для всіх.","new_welcome_sec_4_title_pl":"Пориньте в онлайн-театр Dramox","new_welcome_sec_5_text_pl":"Ви можете скасувати свою підписку, коли завгодно","new_welcome_sec_5_title_pl":"Спробуйте Dramox","welcome_button_long_pl":"Спробувати 7 днів БЕЗПЛАТНО","welcome_price_pl":"Після користуйтеся Dramox усього за {{monthly}} на місяць. Половина передплати йде театрам, які ви переглядаєте. Скасувати підписку можна будь-коли.","welcome_subtitle_pl":"Театр у вас під рукою – дивіться будь-де, будь-коли","welcome_title_pl":"Найбільша колекція українських вистав","no_trial_welcome_button_long_xx":"Почніть свою пригоду з онлайн-театром зараз","no_trial_welcome_button_long_cz":"Почніть свою пригоду з онлайн-театром зараз","no_trial_welcome_button_long_sk":"Почніть свою пригоду з онлайн-театром зараз","no_trial_welcome_button_long_ua":"Почніть свою пригоду з онлайн-театром зараз","no_trial_welcome_button_long_pl":"Почніть свою пригоду з онлайн-театром зараз","welcome_button_browse_xx":"доступні вистави","welcome_button_browse_cz":"доступні вистави","welcome_button_browse_sk":"доступні вистави","welcome_button_browse_ua":"доступні вистави","welcome_button_browse_pl":"доступні вистави","welcome_subscription_title_xx":"Обирайте підписку та насолоджуйтесь театром щодня","welcome_subscription_title_cz":"Обирайте підписку та насолоджуйтесь театром щодня","welcome_subscription_title_sk":"Обирайте підписку та насолоджуйтесь театром щодня","welcome_subscription_title_ua":"Обирайте підписку та насолоджуйтесь театром щодня","welcome_subscription_title_pl":"Обирайте підписку та насолоджуйтесь театром щодня","welcome_subscription_1_xx":"Сотні вистав із понад 250 театрів світу","welcome_subscription_1_cz":"Сотні вистав із понад 250 театрів світу","welcome_subscription_1_sk":"Сотні вистав із понад 250 театрів світу","welcome_subscription_1_ua":"Сотні вистав із понад 250 театрів світу","welcome_subscription_1_pl":"Сотні вистав із понад 250 театрів світу","welcome_subscription_2_xx":"Драми, мюзикли, альтернативний театр, опера та балет, ляльковий театр і сучасний цирк","welcome_subscription_2_cz":"Драми, мюзикли, альтернативний театр, опера та балет, ляльковий театр і сучасний цирк","welcome_subscription_2_sk":"Драми, мюзикли, альтернативний театр, опера та балет, ляльковий театр і сучасний цирк","welcome_subscription_2_ua":"Драми, мюзикли, альтернативний театр, опера та балет, ляльковий театр і сучасний цирк","welcome_subscription_2_pl":"Драми, мюзикли, альтернативний театр, опера та балет, ляльковий театр і сучасний цирк","welcome_subscription_3_xx":"Без реклами та прихованих платежів","welcome_subscription_3_cz":"Без реклами та прихованих платежів","welcome_subscription_3_sk":"Без реклами та прихованих платежів","welcome_subscription_3_ua":"Без реклами та прихованих платежів","welcome_subscription_3_pl":"Без реклами та прихованих платежів","welcome_subscription_button_1_xx":"7 днів безплатно, далі {{priceMonthly}} / місяць","welcome_subscription_button_1_cz":"7 днів безплатно, далі {{priceMonthly}} / місяць","welcome_subscription_button_1_sk":"7 днів безплатно, далі {{priceMonthly}} / місяць","welcome_subscription_button_1_ua":"7 днів безплатно, далі {{priceMonthly}} / місяць","welcome_subscription_button_1_pl":"7 днів безплатно, далі {{priceMonthly}} / місяць","welcome_subscription_button_2_xx":"7 днів безплатно,<1></1><0> далі <2>{{beforeYearly}}</2> {{priceYearly}} / рік</0>","welcome_subscription_button_2_cz":"7 днів безплатно,<1></1><0> далі <2>{{beforeYearly}}</2> {{priceYearly}} / рік</0>","welcome_subscription_button_2_sk":"7 днів безплатно, далі {{priceYearly}} / рік","welcome_subscription_button_2_ua":"7 днів безплатно, далі {{priceYearly}} / рік","welcome_subscription_button_2_pl":"7 днів безплатно, далі {{priceYearly}} / рік","welcome_subscription_button_activate_xx":"Активувати безплатний пробний період","welcome_subscription_button_activate_cz":"Активувати безплатний пробний період","welcome_subscription_button_activate_sk":"Активувати безплатний пробний період","welcome_subscription_button_activate_ua":"Активувати безплатний пробний період","welcome_subscription_button_activate_pl":"Активувати безплатний пробний період","welcome_subscription_cancel_note_xx":"Скасувати можна будь-коли","welcome_subscription_cancel_note_cz":"Скасувати можна будь-коли","welcome_subscription_cancel_note_sk":"Скасувати можна будь-коли","welcome_subscription_cancel_note_ua":"Скасувати можна будь-коли","welcome_subscription_cancel_note_pl":"Скасувати можна будь-коли"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(50292), __webpack_exec__(48729), __webpack_exec__(6840), __webpack_exec__(25948); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);